
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree663"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree663"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bFTps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87fe8139b38d8de8$export$2e2bcd8739ae039; });

var $02MqS = parcelRequire("02MqS");

var $gGGud = parcelRequire("gGGud");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $02MqS.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $gGGud.default);
var $87fe8139b38d8de8$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("02MqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0085c1b99f764d6f$export$2e2bcd8739ae039; });

var $6yC6V = parcelRequire("6yC6V");
/** Detect free variable `self`. */ var $0085c1b99f764d6f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0085c1b99f764d6f$var$root = (0, $6yC6V.default) || $0085c1b99f764d6f$var$freeSelf || Function('return this')();
var $0085c1b99f764d6f$export$2e2bcd8739ae039 = $0085c1b99f764d6f$var$root;

});
parcelRegister("6yC6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c637b1140aa1992$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $4c637b1140aa1992$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $4c637b1140aa1992$export$2e2bcd8739ae039 = $4c637b1140aa1992$var$freeGlobal;

});


parcelRegister("gGGud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c26186814f51cba2$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $c26186814f51cba2$var$stubFalse() {
    return false;
}
var $c26186814f51cba2$export$2e2bcd8739ae039 = $c26186814f51cba2$var$stubFalse;

});


parcelRegister("c3Q8B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7e355641834929$export$2e2bcd8739ae039; });

var $6yC6V = parcelRequire("6yC6V");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $6yC6V.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $8c7e355641834929$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("d8V62", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $99184fdad0874994$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $99184fdad0874994$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $99184fdad0874994$var$__createBinding(exports1, m, p);
};
var $99184fdad0874994$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserMessageWriter = module.exports.BrowserMessageReader = void 0;
module.exports.createMessageConnection = $99184fdad0874994$var$createMessageConnection;

const $99184fdad0874994$var$ril_1 = $99184fdad0874994$var$__importDefault((parcelRequire("A835q")));
// Install the browser runtime abstract.
$99184fdad0874994$var$ril_1.default.install();


$99184fdad0874994$var$__exportStar((parcelRequire("eQdaw")), module.exports);
class $99184fdad0874994$var$BrowserMessageReader extends (parcelRequire("eQdaw")).AbstractMessageReader {
    _onData;
    _messageListener;
    constructor(port){
        super();
        this._onData = new (parcelRequire("eQdaw")).Emitter();
        this._messageListener = (event)=>{
            this._onData.fire(event.data);
        };
        port.addEventListener('error', (event)=>this.fireError(event));
        port.onmessage = this._messageListener;
    }
    listen(callback) {
        return this._onData.event(callback);
    }
}
module.exports.BrowserMessageReader = $99184fdad0874994$var$BrowserMessageReader;
class $99184fdad0874994$var$BrowserMessageWriter extends (parcelRequire("eQdaw")).AbstractMessageWriter {
    port;
    errorCount;
    constructor(port){
        super();
        this.port = port;
        this.errorCount = 0;
        port.addEventListener('error', (event)=>this.fireError(event));
    }
    write(msg) {
        try {
            this.port.postMessage(msg);
            return Promise.resolve();
        } catch (error) {
            this.handleError(error, msg);
            return Promise.reject(error);
        }
    }
    handleError(error, msg) {
        this.errorCount++;
        this.fireError(error, msg, this.errorCount);
    }
    end() {}
}
module.exports.BrowserMessageWriter = $99184fdad0874994$var$BrowserMessageWriter;
function $99184fdad0874994$var$createMessageConnection(reader, writer, logger, options) {
    if (logger === undefined) logger = (parcelRequire("eQdaw")).NullLogger;
    if ((parcelRequire("eQdaw")).ConnectionStrategy.is(options)) options = {
        connectionStrategy: options
    };
    return (0, (parcelRequire("eQdaw")).createMessageConnection)(reader, writer, logger, options);
}

});
parcelRegister("A835q", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PromiseImpl = module.exports.QueueMicrotaskImpl = void 0;

var $eQdaw = parcelRequire("eQdaw");
class $06c99b3a60e41eeb$var$MessageBuffer extends $eQdaw.AbstractMessageBuffer {
    static emptyBuffer = new Uint8Array(0);
    asciiDecoder;
    constructor(encoding = 'utf-8'){
        super(encoding);
        this.asciiDecoder = new TextDecoder('ascii');
    }
    emptyBuffer() {
        return $06c99b3a60e41eeb$var$MessageBuffer.emptyBuffer;
    }
    fromString(value, _encoding) {
        return new TextEncoder().encode(value);
    }
    toString(value, encoding) {
        if (encoding === 'ascii') return this.asciiDecoder.decode(value);
        else return new TextDecoder(encoding).decode(value);
    }
    asNative(buffer, length) {
        if (length === undefined) return buffer;
        else return buffer.slice(0, length);
    }
    allocNative(length) {
        return new Uint8Array(length);
    }
}
class $06c99b3a60e41eeb$var$ReadableStreamWrapper {
    socket;
    _onData;
    _messageListener;
    constructor(socket){
        this.socket = socket;
        this._onData = new $eQdaw.Emitter();
        this._messageListener = (event)=>{
            const blob = event.data;
            blob.arrayBuffer().then((buffer)=>{
                this._onData.fire(new Uint8Array(buffer));
            }, ()=>{
                (0, $eQdaw.RAL)().console.error(`Converting blob to array buffer failed.`);
            });
        };
        this.socket.addEventListener('message', this._messageListener);
    }
    onClose(listener) {
        this.socket.addEventListener('close', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('close', listener));
    }
    onError(listener) {
        this.socket.addEventListener('error', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('error', listener));
    }
    onEnd(listener) {
        this.socket.addEventListener('end', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('end', listener));
    }
    onData(listener) {
        return this._onData.event(listener);
    }
}
class $06c99b3a60e41eeb$var$WritableStreamWrapper {
    socket;
    constructor(socket){
        this.socket = socket;
    }
    onClose(listener) {
        this.socket.addEventListener('close', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('close', listener));
    }
    onError(listener) {
        this.socket.addEventListener('error', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('error', listener));
    }
    onEnd(listener) {
        this.socket.addEventListener('end', listener);
        return $eQdaw.Disposable.create(()=>this.socket.removeEventListener('end', listener));
    }
    write(data, encoding) {
        if (typeof data === 'string') {
            if (encoding !== undefined && encoding !== 'utf-8') throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${encoding}`);
            this.socket.send(data);
        } else if (data.buffer instanceof ArrayBuffer) this.socket.send(data.buffer);
        else // We can't send a shared array buffer directly, so we need to
        // create a copy of it.
        this.socket.send(new Uint8Array(data.buffer).slice().buffer);
        return Promise.resolve();
    }
    end() {
        this.socket.close();
    }
}
class $06c99b3a60e41eeb$var$QueueMicrotaskImpl {
    isDisposed;
    constructor(callback, ...args){
        this.isDisposed = false;
        queueMicrotask(()=>{
            if (!this.isDisposed) callback(...args);
        });
    }
    dispose() {
        this.isDisposed = true;
    }
}
module.exports.QueueMicrotaskImpl = $06c99b3a60e41eeb$var$QueueMicrotaskImpl;
class $06c99b3a60e41eeb$var$PromiseImpl {
    isDisposed;
    constructor(callback, ...args){
        this.isDisposed = false;
        Promise.resolve().then(()=>{
            if (!this.isDisposed) callback(...args);
        }, ()=>{});
    }
    dispose() {
        this.isDisposed = true;
    }
}
module.exports.PromiseImpl = $06c99b3a60e41eeb$var$PromiseImpl;
const $06c99b3a60e41eeb$var$_textEncoder = new TextEncoder();
const $06c99b3a60e41eeb$var$_ril = Object.freeze({
    messageBuffer: Object.freeze({
        create: (encoding)=>new $06c99b3a60e41eeb$var$MessageBuffer(encoding)
    }),
    applicationJson: Object.freeze({
        encoder: Object.freeze({
            name: 'application/json',
            encode: (msg, options)=>{
                if (options.charset !== 'utf-8') throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${options.charset}`);
                return Promise.resolve($06c99b3a60e41eeb$var$_textEncoder.encode(JSON.stringify(msg, undefined, 0)));
            }
        }),
        decoder: Object.freeze({
            name: 'application/json',
            decode: (buffer, options)=>{
                if (!(buffer instanceof Uint8Array)) throw new Error(`In a Browser environments only Uint8Arrays are supported.`);
                return Promise.resolve(JSON.parse(new TextDecoder(options.charset).decode(buffer)));
            }
        })
    }),
    stream: Object.freeze({
        asReadableStream: (socket)=>new $06c99b3a60e41eeb$var$ReadableStreamWrapper(socket),
        asWritableStream: (socket)=>new $06c99b3a60e41eeb$var$WritableStreamWrapper(socket)
    }),
    console: console,
    timer: Object.freeze({
        setTimeout (callback, ms, ...args) {
            const handle = setTimeout(callback, ms, ...args);
            return {
                dispose: ()=>clearTimeout(handle)
            };
        },
        setImmediate (callback, ...args) {
            // Browser don't have setImmediate and setTimeout with 0 delay of 0 can cause problems
            // in webviews and similar environments due to throttling.
            if (typeof globalThis.queueMicrotask === 'function') return new $06c99b3a60e41eeb$var$QueueMicrotaskImpl(callback, ...args);
            else if (Promise !== undefined) return new $06c99b3a60e41eeb$var$PromiseImpl(callback, ...args);
            else {
                const handle = setTimeout(callback, 0, ...args);
                return {
                    dispose: ()=>clearTimeout(handle)
                };
            }
        },
        setInterval (callback, ms, ...args) {
            const handle = setInterval(callback, ms, ...args);
            return {
                dispose: ()=>clearInterval(handle)
            };
        }
    })
});
function $06c99b3a60e41eeb$var$RIL() {
    return $06c99b3a60e41eeb$var$_ril;
}
(function(RIL) {
    function install() {
        $eQdaw.RAL.install($06c99b3a60e41eeb$var$_ril);
    }
    RIL.install = install;
})($06c99b3a60e41eeb$var$RIL || ($06c99b3a60e41eeb$var$RIL = {}));
module.exports.default = $06c99b3a60e41eeb$var$RIL;

});
parcelRegister("eQdaw", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ /// <reference path="../../typings/thenable.d.ts" preserve="true"/>
var $ace0230723f83ca0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProgressType = module.exports.ProgressToken = module.exports.createMessageConnection = module.exports.NullLogger = module.exports.ConnectionOptions = module.exports.ConnectionStrategy = module.exports.AbstractMessageBuffer = module.exports.WriteableStreamMessageWriter = module.exports.AbstractMessageWriter = module.exports.MessageWriter = module.exports.ReadableStreamMessageReader = module.exports.AbstractMessageReader = module.exports.MessageReader = module.exports.SharedArrayReceiverStrategy = module.exports.SharedArraySenderStrategy = module.exports.CancellationToken = module.exports.CancellationTokenSource = module.exports.Emitter = module.exports.Event = module.exports.Disposable = module.exports.LRUCache = module.exports.Touch = module.exports.LinkedMap = module.exports.ParameterStructures = module.exports.NotificationType9 = module.exports.NotificationType8 = module.exports.NotificationType7 = module.exports.NotificationType6 = module.exports.NotificationType5 = module.exports.NotificationType4 = module.exports.NotificationType3 = module.exports.NotificationType2 = module.exports.NotificationType1 = module.exports.NotificationType0 = module.exports.NotificationType = module.exports.ErrorCodes = module.exports.ResponseError = module.exports.RequestType9 = module.exports.RequestType8 = module.exports.RequestType7 = module.exports.RequestType6 = module.exports.RequestType5 = module.exports.RequestType4 = module.exports.RequestType3 = module.exports.RequestType2 = module.exports.RequestType1 = module.exports.RequestType0 = module.exports.RequestType = module.exports.Message = module.exports.RAL = void 0;
module.exports.MessageStrategy = module.exports.CancellationStrategy = module.exports.CancellationSenderStrategy = module.exports.RequestCancellationReceiverStrategy = module.exports.IdCancellationReceiverStrategy = module.exports.CancellationReceiverStrategy = module.exports.ConnectionError = module.exports.ConnectionErrors = module.exports.LogTraceNotification = module.exports.SetTraceNotification = module.exports.TraceFormat = module.exports.TraceValues = module.exports.TraceValue = module.exports.Trace = void 0;

var $bQGIN = parcelRequire("bQGIN");
Object.defineProperty(module.exports, "Message", {
    enumerable: true,
    get: function() {
        return $bQGIN.Message;
    }
});
Object.defineProperty(module.exports, "RequestType", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType;
    }
});
Object.defineProperty(module.exports, "RequestType0", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType0;
    }
});
Object.defineProperty(module.exports, "RequestType1", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType1;
    }
});
Object.defineProperty(module.exports, "RequestType2", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType2;
    }
});
Object.defineProperty(module.exports, "RequestType3", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType3;
    }
});
Object.defineProperty(module.exports, "RequestType4", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType4;
    }
});
Object.defineProperty(module.exports, "RequestType5", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType5;
    }
});
Object.defineProperty(module.exports, "RequestType6", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType6;
    }
});
Object.defineProperty(module.exports, "RequestType7", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType7;
    }
});
Object.defineProperty(module.exports, "RequestType8", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType8;
    }
});
Object.defineProperty(module.exports, "RequestType9", {
    enumerable: true,
    get: function() {
        return $bQGIN.RequestType9;
    }
});
Object.defineProperty(module.exports, "ResponseError", {
    enumerable: true,
    get: function() {
        return $bQGIN.ResponseError;
    }
});
Object.defineProperty(module.exports, "ErrorCodes", {
    enumerable: true,
    get: function() {
        return $bQGIN.ErrorCodes;
    }
});
Object.defineProperty(module.exports, "NotificationType", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType;
    }
});
Object.defineProperty(module.exports, "NotificationType0", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType0;
    }
});
Object.defineProperty(module.exports, "NotificationType1", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType1;
    }
});
Object.defineProperty(module.exports, "NotificationType2", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType2;
    }
});
Object.defineProperty(module.exports, "NotificationType3", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType3;
    }
});
Object.defineProperty(module.exports, "NotificationType4", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType4;
    }
});
Object.defineProperty(module.exports, "NotificationType5", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType5;
    }
});
Object.defineProperty(module.exports, "NotificationType6", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType6;
    }
});
Object.defineProperty(module.exports, "NotificationType7", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType7;
    }
});
Object.defineProperty(module.exports, "NotificationType8", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType8;
    }
});
Object.defineProperty(module.exports, "NotificationType9", {
    enumerable: true,
    get: function() {
        return $bQGIN.NotificationType9;
    }
});
Object.defineProperty(module.exports, "ParameterStructures", {
    enumerable: true,
    get: function() {
        return $bQGIN.ParameterStructures;
    }
});

var $jrRKt = parcelRequire("jrRKt");
Object.defineProperty(module.exports, "LinkedMap", {
    enumerable: true,
    get: function() {
        return $jrRKt.LinkedMap;
    }
});
Object.defineProperty(module.exports, "LRUCache", {
    enumerable: true,
    get: function() {
        return $jrRKt.LRUCache;
    }
});
Object.defineProperty(module.exports, "Touch", {
    enumerable: true,
    get: function() {
        return $jrRKt.Touch;
    }
});

var $kP9zO = parcelRequire("kP9zO");
Object.defineProperty(module.exports, "Disposable", {
    enumerable: true,
    get: function() {
        return $kP9zO.Disposable;
    }
});

var $8Not3 = parcelRequire("8Not3");
Object.defineProperty(module.exports, "Event", {
    enumerable: true,
    get: function() {
        return $8Not3.Event;
    }
});
Object.defineProperty(module.exports, "Emitter", {
    enumerable: true,
    get: function() {
        return $8Not3.Emitter;
    }
});

var $1NuV6 = parcelRequire("1NuV6");
Object.defineProperty(module.exports, "CancellationTokenSource", {
    enumerable: true,
    get: function() {
        return $1NuV6.CancellationTokenSource;
    }
});
Object.defineProperty(module.exports, "CancellationToken", {
    enumerable: true,
    get: function() {
        return $1NuV6.CancellationToken;
    }
});

var $g9ZoK = parcelRequire("g9ZoK");
Object.defineProperty(module.exports, "SharedArraySenderStrategy", {
    enumerable: true,
    get: function() {
        return $g9ZoK.SharedArraySenderStrategy;
    }
});
Object.defineProperty(module.exports, "SharedArrayReceiverStrategy", {
    enumerable: true,
    get: function() {
        return $g9ZoK.SharedArrayReceiverStrategy;
    }
});

var $3c3yY = parcelRequire("3c3yY");
Object.defineProperty(module.exports, "MessageReader", {
    enumerable: true,
    get: function() {
        return $3c3yY.MessageReader;
    }
});
Object.defineProperty(module.exports, "AbstractMessageReader", {
    enumerable: true,
    get: function() {
        return $3c3yY.AbstractMessageReader;
    }
});
Object.defineProperty(module.exports, "ReadableStreamMessageReader", {
    enumerable: true,
    get: function() {
        return $3c3yY.ReadableStreamMessageReader;
    }
});

var $eDSbD = parcelRequire("eDSbD");
Object.defineProperty(module.exports, "MessageWriter", {
    enumerable: true,
    get: function() {
        return $eDSbD.MessageWriter;
    }
});
Object.defineProperty(module.exports, "AbstractMessageWriter", {
    enumerable: true,
    get: function() {
        return $eDSbD.AbstractMessageWriter;
    }
});
Object.defineProperty(module.exports, "WriteableStreamMessageWriter", {
    enumerable: true,
    get: function() {
        return $eDSbD.WriteableStreamMessageWriter;
    }
});

var $8DVyG = parcelRequire("8DVyG");
Object.defineProperty(module.exports, "AbstractMessageBuffer", {
    enumerable: true,
    get: function() {
        return $8DVyG.AbstractMessageBuffer;
    }
});

var $dmaS3 = parcelRequire("dmaS3");
Object.defineProperty(module.exports, "ConnectionStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.ConnectionStrategy;
    }
});
Object.defineProperty(module.exports, "ConnectionOptions", {
    enumerable: true,
    get: function() {
        return $dmaS3.ConnectionOptions;
    }
});
Object.defineProperty(module.exports, "NullLogger", {
    enumerable: true,
    get: function() {
        return $dmaS3.NullLogger;
    }
});
Object.defineProperty(module.exports, "createMessageConnection", {
    enumerable: true,
    get: function() {
        return $dmaS3.createMessageConnection;
    }
});
Object.defineProperty(module.exports, "ProgressToken", {
    enumerable: true,
    get: function() {
        return $dmaS3.ProgressToken;
    }
});
Object.defineProperty(module.exports, "ProgressType", {
    enumerable: true,
    get: function() {
        return $dmaS3.ProgressType;
    }
});
Object.defineProperty(module.exports, "Trace", {
    enumerable: true,
    get: function() {
        return $dmaS3.Trace;
    }
});
Object.defineProperty(module.exports, "TraceValue", {
    enumerable: true,
    get: function() {
        return $dmaS3.TraceValue;
    }
});
Object.defineProperty(module.exports, "TraceFormat", {
    enumerable: true,
    get: function() {
        return $dmaS3.TraceFormat;
    }
});
Object.defineProperty(module.exports, "SetTraceNotification", {
    enumerable: true,
    get: function() {
        return $dmaS3.SetTraceNotification;
    }
});
Object.defineProperty(module.exports, "LogTraceNotification", {
    enumerable: true,
    get: function() {
        return $dmaS3.LogTraceNotification;
    }
});
Object.defineProperty(module.exports, "ConnectionErrors", {
    enumerable: true,
    get: function() {
        return $dmaS3.ConnectionErrors;
    }
});
Object.defineProperty(module.exports, "ConnectionError", {
    enumerable: true,
    get: function() {
        return $dmaS3.ConnectionError;
    }
});
Object.defineProperty(module.exports, "CancellationReceiverStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.CancellationReceiverStrategy;
    }
});
Object.defineProperty(module.exports, "IdCancellationReceiverStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.IdCancellationReceiverStrategy;
    }
});
Object.defineProperty(module.exports, "RequestCancellationReceiverStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.RequestCancellationReceiverStrategy;
    }
});
Object.defineProperty(module.exports, "CancellationSenderStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.CancellationSenderStrategy;
    }
});
Object.defineProperty(module.exports, "CancellationStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.CancellationStrategy;
    }
});
Object.defineProperty(module.exports, "MessageStrategy", {
    enumerable: true,
    get: function() {
        return $dmaS3.MessageStrategy;
    }
});
Object.defineProperty(module.exports, "TraceValues", {
    enumerable: true,
    get: function() {
        return $dmaS3.TraceValues;
    }
});

const $ace0230723f83ca0$var$ral_1 = $ace0230723f83ca0$var$__importDefault((parcelRequire("7UD77")));
module.exports.RAL = $ace0230723f83ca0$var$ral_1.default;

});
parcelRegister("bQGIN", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $8a05b0a7ae718cae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a05b0a7ae718cae$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8a05b0a7ae718cae$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8a05b0a7ae718cae$var$__createBinding(result, mod, k[i]);
        }
        $8a05b0a7ae718cae$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Message = module.exports.NotificationType9 = module.exports.NotificationType8 = module.exports.NotificationType7 = module.exports.NotificationType6 = module.exports.NotificationType5 = module.exports.NotificationType4 = module.exports.NotificationType3 = module.exports.NotificationType2 = module.exports.NotificationType1 = module.exports.NotificationType0 = module.exports.NotificationType = module.exports.RequestType9 = module.exports.RequestType8 = module.exports.RequestType7 = module.exports.RequestType6 = module.exports.RequestType5 = module.exports.RequestType4 = module.exports.RequestType3 = module.exports.RequestType2 = module.exports.RequestType1 = module.exports.RequestType = module.exports.RequestType0 = module.exports.AbstractMessageSignature = module.exports.ParameterStructures = module.exports.ResponseError = module.exports.ErrorCodes = void 0;

const $8a05b0a7ae718cae$var$is = $8a05b0a7ae718cae$var$__importStar((parcelRequire("5BYQO")));
/**
 * Predefined error codes.
 */ var $8a05b0a7ae718cae$var$ErrorCodes;
(function(ErrorCodes) {
    // Defined by JSON RPC
    ErrorCodes.ParseError = -32700;
    ErrorCodes.InvalidRequest = -32600;
    ErrorCodes.MethodNotFound = -32601;
    ErrorCodes.InvalidParams = -32602;
    ErrorCodes.InternalError = -32603;
    /**
     * This is the start range of JSON RPC reserved error codes.
     * It doesn't denote a real error code. No application error codes should
     * be defined between the start and end range. For backwards
     * compatibility the `ServerNotInitialized` and the `UnknownErrorCode`
     * are left in the range.
     *
     * @since 3.16.0
    */ ErrorCodes.jsonrpcReservedErrorRangeStart = -32099;
    /** @deprecated use  jsonrpcReservedErrorRangeStart */ ErrorCodes.serverErrorStart = -32099;
    /**
     * An error occurred when write a message to the transport layer.
     */ ErrorCodes.MessageWriteError = -32099;
    /**
     * An error occurred when reading a message from the transport layer.
     */ ErrorCodes.MessageReadError = -32098;
    /**
     * The connection got disposed or lost and all pending responses got
     * rejected.
     */ ErrorCodes.PendingResponseRejected = -32097;
    /**
     * The connection is inactive and a use of it failed.
     */ ErrorCodes.ConnectionInactive = -32096;
    /**
     * Error code indicating that a server received a notification or
     * request before the server has received the `initialize` request.
     */ ErrorCodes.ServerNotInitialized = -32002;
    ErrorCodes.UnknownErrorCode = -32001;
    /**
     * This is the end range of JSON RPC reserved error codes.
     * It doesn't denote a real error code.
     *
     * @since 3.16.0
    */ ErrorCodes.jsonrpcReservedErrorRangeEnd = -32000;
    /** @deprecated use  jsonrpcReservedErrorRangeEnd */ ErrorCodes.serverErrorEnd = -32000;
})($8a05b0a7ae718cae$var$ErrorCodes || (module.exports.ErrorCodes = $8a05b0a7ae718cae$var$ErrorCodes = {}));
/**
 * An error object return in a response in case a request
 * has failed.
 */ class $8a05b0a7ae718cae$var$ResponseError extends Error {
    code;
    data;
    constructor(code, message, data){
        super(message);
        this.code = $8a05b0a7ae718cae$var$is.number(code) ? code : $8a05b0a7ae718cae$var$ErrorCodes.UnknownErrorCode;
        this.data = data;
        Object.setPrototypeOf(this, $8a05b0a7ae718cae$var$ResponseError.prototype);
    }
    toJson() {
        const result = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) result.data = this.data;
        return result;
    }
}
module.exports.ResponseError = $8a05b0a7ae718cae$var$ResponseError;
class $8a05b0a7ae718cae$var$ParameterStructures {
    kind;
    /**
     * The parameter structure is automatically inferred on the number of parameters
     * and the parameter type in case of a single param.
     */ static auto = new $8a05b0a7ae718cae$var$ParameterStructures('auto');
    /**
     * Forces `byPosition` parameter structure. This is useful if you have a single
     * parameter which has a literal type.
     */ static byPosition = new $8a05b0a7ae718cae$var$ParameterStructures('byPosition');
    /**
     * Forces `byName` parameter structure. This is only useful when having a single
     * parameter. The library will report errors if used with a different number of
     * parameters.
     */ static byName = new $8a05b0a7ae718cae$var$ParameterStructures('byName');
    constructor(kind){
        this.kind = kind;
    }
    static is(value) {
        return value === $8a05b0a7ae718cae$var$ParameterStructures.auto || value === $8a05b0a7ae718cae$var$ParameterStructures.byName || value === $8a05b0a7ae718cae$var$ParameterStructures.byPosition;
    }
    toString() {
        return this.kind;
    }
}
module.exports.ParameterStructures = $8a05b0a7ae718cae$var$ParameterStructures;
/**
 * An abstract implementation of a MessageType.
 */ class $8a05b0a7ae718cae$var$AbstractMessageSignature {
    method;
    numberOfParams;
    constructor(method, numberOfParams){
        this.method = method;
        this.numberOfParams = numberOfParams;
    }
    get parameterStructures() {
        return $8a05b0a7ae718cae$var$ParameterStructures.auto;
    }
}
module.exports.AbstractMessageSignature = $8a05b0a7ae718cae$var$AbstractMessageSignature;
/**
 * Classes to type request response pairs
 */ class $8a05b0a7ae718cae$var$RequestType0 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 0);
    }
}
module.exports.RequestType0 = $8a05b0a7ae718cae$var$RequestType0;
class $8a05b0a7ae718cae$var$RequestType extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    _parameterStructures;
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method, _parameterStructures = $8a05b0a7ae718cae$var$ParameterStructures.auto){
        super(method, 1);
        this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
        return this._parameterStructures;
    }
}
module.exports.RequestType = $8a05b0a7ae718cae$var$RequestType;
class $8a05b0a7ae718cae$var$RequestType1 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    _parameterStructures;
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method, _parameterStructures = $8a05b0a7ae718cae$var$ParameterStructures.auto){
        super(method, 1);
        this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
        return this._parameterStructures;
    }
}
module.exports.RequestType1 = $8a05b0a7ae718cae$var$RequestType1;
class $8a05b0a7ae718cae$var$RequestType2 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 2);
    }
}
module.exports.RequestType2 = $8a05b0a7ae718cae$var$RequestType2;
class $8a05b0a7ae718cae$var$RequestType3 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 3);
    }
}
module.exports.RequestType3 = $8a05b0a7ae718cae$var$RequestType3;
class $8a05b0a7ae718cae$var$RequestType4 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 4);
    }
}
module.exports.RequestType4 = $8a05b0a7ae718cae$var$RequestType4;
class $8a05b0a7ae718cae$var$RequestType5 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 5);
    }
}
module.exports.RequestType5 = $8a05b0a7ae718cae$var$RequestType5;
class $8a05b0a7ae718cae$var$RequestType6 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 6);
    }
}
module.exports.RequestType6 = $8a05b0a7ae718cae$var$RequestType6;
class $8a05b0a7ae718cae$var$RequestType7 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 7);
    }
}
module.exports.RequestType7 = $8a05b0a7ae718cae$var$RequestType7;
class $8a05b0a7ae718cae$var$RequestType8 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 8);
    }
}
module.exports.RequestType8 = $8a05b0a7ae718cae$var$RequestType8;
class $8a05b0a7ae718cae$var$RequestType9 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 9);
    }
}
module.exports.RequestType9 = $8a05b0a7ae718cae$var$RequestType9;
class $8a05b0a7ae718cae$var$NotificationType extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    _parameterStructures;
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method, _parameterStructures = $8a05b0a7ae718cae$var$ParameterStructures.auto){
        super(method, 1);
        this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
        return this._parameterStructures;
    }
}
module.exports.NotificationType = $8a05b0a7ae718cae$var$NotificationType;
class $8a05b0a7ae718cae$var$NotificationType0 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 0);
    }
}
module.exports.NotificationType0 = $8a05b0a7ae718cae$var$NotificationType0;
class $8a05b0a7ae718cae$var$NotificationType1 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    _parameterStructures;
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method, _parameterStructures = $8a05b0a7ae718cae$var$ParameterStructures.auto){
        super(method, 1);
        this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
        return this._parameterStructures;
    }
}
module.exports.NotificationType1 = $8a05b0a7ae718cae$var$NotificationType1;
class $8a05b0a7ae718cae$var$NotificationType2 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 2);
    }
}
module.exports.NotificationType2 = $8a05b0a7ae718cae$var$NotificationType2;
class $8a05b0a7ae718cae$var$NotificationType3 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 3);
    }
}
module.exports.NotificationType3 = $8a05b0a7ae718cae$var$NotificationType3;
class $8a05b0a7ae718cae$var$NotificationType4 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 4);
    }
}
module.exports.NotificationType4 = $8a05b0a7ae718cae$var$NotificationType4;
class $8a05b0a7ae718cae$var$NotificationType5 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 5);
    }
}
module.exports.NotificationType5 = $8a05b0a7ae718cae$var$NotificationType5;
class $8a05b0a7ae718cae$var$NotificationType6 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 6);
    }
}
module.exports.NotificationType6 = $8a05b0a7ae718cae$var$NotificationType6;
class $8a05b0a7ae718cae$var$NotificationType7 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 7);
    }
}
module.exports.NotificationType7 = $8a05b0a7ae718cae$var$NotificationType7;
class $8a05b0a7ae718cae$var$NotificationType8 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 8);
    }
}
module.exports.NotificationType8 = $8a05b0a7ae718cae$var$NotificationType8;
class $8a05b0a7ae718cae$var$NotificationType9 extends $8a05b0a7ae718cae$var$AbstractMessageSignature {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ _;
    constructor(method){
        super(method, 9);
    }
}
module.exports.NotificationType9 = $8a05b0a7ae718cae$var$NotificationType9;
var $8a05b0a7ae718cae$var$Message;
(function(Message) {
    /**
     * Tests if the given message is a request message
     */ function isRequest(message) {
        const candidate = message;
        return candidate && $8a05b0a7ae718cae$var$is.string(candidate.method) && ($8a05b0a7ae718cae$var$is.string(candidate.id) || $8a05b0a7ae718cae$var$is.number(candidate.id));
    }
    Message.isRequest = isRequest;
    /**
     * Tests if the given message is a notification message
     */ function isNotification(message) {
        const candidate = message;
        return candidate && $8a05b0a7ae718cae$var$is.string(candidate.method) && message.id === void 0;
    }
    Message.isNotification = isNotification;
    /**
     * Tests if the given message is a response message
     */ function isResponse(message) {
        const candidate = message;
        return candidate && (candidate.result !== void 0 || !!candidate.error) && ($8a05b0a7ae718cae$var$is.string(candidate.id) || $8a05b0a7ae718cae$var$is.number(candidate.id) || candidate.id === null);
    }
    Message.isResponse = isResponse;
})($8a05b0a7ae718cae$var$Message || (module.exports.Message = $8a05b0a7ae718cae$var$Message = {}));

});
parcelRegister("5BYQO", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolean = $415f9c246583357c$var$boolean;
module.exports.string = $415f9c246583357c$var$string;
module.exports.number = $415f9c246583357c$var$number;
module.exports.error = $415f9c246583357c$var$error;
module.exports.func = $415f9c246583357c$var$func;
module.exports.array = $415f9c246583357c$var$array;
module.exports.stringArray = $415f9c246583357c$var$stringArray;
function $415f9c246583357c$var$boolean(value) {
    return value === true || value === false;
}
function $415f9c246583357c$var$string(value) {
    return typeof value === 'string' || value instanceof String;
}
function $415f9c246583357c$var$number(value) {
    return typeof value === 'number' || value instanceof Number;
}
function $415f9c246583357c$var$error(value) {
    return value instanceof Error;
}
function $415f9c246583357c$var$func(value) {
    return typeof value === 'function';
}
function $415f9c246583357c$var$array(value) {
    return Array.isArray(value);
}
function $415f9c246583357c$var$stringArray(value) {
    return $415f9c246583357c$var$array(value) && value.every((elem)=>$415f9c246583357c$var$string(elem));
}

});


parcelRegister("jrRKt", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LRUCache = module.exports.LinkedMap = module.exports.Touch = void 0;
var $e28a3b4c73c04f0a$var$Touch;
(function(Touch) {
    Touch.None = 0;
    Touch.First = 1;
    Touch.AsOld = Touch.First;
    Touch.Last = 2;
    Touch.AsNew = Touch.Last;
})($e28a3b4c73c04f0a$var$Touch || (module.exports.Touch = $e28a3b4c73c04f0a$var$Touch = {}));
class $e28a3b4c73c04f0a$var$LinkedMap {
    [Symbol.toStringTag] = 'LinkedMap';
    _map;
    _head;
    _tail;
    _size;
    _state;
    constructor(){
        this._map = new Map();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
        this._state = 0;
    }
    clear() {
        this._map.clear();
        this._head = undefined;
        this._tail = undefined;
        this._size = 0;
        this._state++;
    }
    isEmpty() {
        return !this._head && !this._tail;
    }
    get size() {
        return this._size;
    }
    get first() {
        return this._head?.value;
    }
    get last() {
        return this._tail?.value;
    }
    before(key) {
        const item = this._map.get(key);
        return item ? item.previous?.value : undefined;
    }
    after(key) {
        const item = this._map.get(key);
        return item ? item.next?.value : undefined;
    }
    has(key) {
        return this._map.has(key);
    }
    get(key, touch = $e28a3b4c73c04f0a$var$Touch.None) {
        const item = this._map.get(key);
        if (!item) return undefined;
        if (touch !== $e28a3b4c73c04f0a$var$Touch.None) this.touch(item, touch);
        return item.value;
    }
    set(key, value, touch = $e28a3b4c73c04f0a$var$Touch.None) {
        let item = this._map.get(key);
        if (item) {
            item.value = value;
            if (touch !== $e28a3b4c73c04f0a$var$Touch.None) this.touch(item, touch);
        } else {
            item = {
                key: key,
                value: value,
                next: undefined,
                previous: undefined
            };
            switch(touch){
                case $e28a3b4c73c04f0a$var$Touch.None:
                    this.addItemLast(item);
                    break;
                case $e28a3b4c73c04f0a$var$Touch.First:
                    this.addItemFirst(item);
                    break;
                case $e28a3b4c73c04f0a$var$Touch.Last:
                    this.addItemLast(item);
                    break;
                default:
                    this.addItemLast(item);
                    break;
            }
            this._map.set(key, item);
            this._size++;
        }
        return this;
    }
    delete(key) {
        return !!this.remove(key);
    }
    remove(key) {
        const item = this._map.get(key);
        if (!item) return undefined;
        this._map.delete(key);
        this.removeItem(item);
        this._size--;
        return item.value;
    }
    shift() {
        if (!this._head && !this._tail) return undefined;
        if (!this._head || !this._tail) throw new Error('Invalid list');
        const item = this._head;
        this._map.delete(item.key);
        this.removeItem(item);
        this._size--;
        return item.value;
    }
    forEach(callbackfn, thisArg) {
        const state = this._state;
        let current = this._head;
        while(current){
            if (thisArg) callbackfn.bind(thisArg)(current.value, current.key, this);
            else callbackfn(current.value, current.key, this);
            if (this._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
            current = current.next;
        }
    }
    keys() {
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator]: ()=>{
                return iterator;
            },
            next: ()=>{
                if (this._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: current.key,
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    values() {
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator]: ()=>{
                return iterator;
            },
            next: ()=>{
                if (this._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: current.value,
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    entries() {
        const state = this._state;
        let current = this._head;
        const iterator = {
            [Symbol.iterator]: ()=>{
                return iterator;
            },
            next: ()=>{
                if (this._state !== state) throw new Error(`LinkedMap got modified during iteration.`);
                if (current) {
                    const result = {
                        value: [
                            current.key,
                            current.value
                        ],
                        done: false
                    };
                    current = current.next;
                    return result;
                } else return {
                    value: undefined,
                    done: true
                };
            }
        };
        return iterator;
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    trimOld(newSize) {
        if (newSize >= this.size) return;
        if (newSize === 0) {
            this.clear();
            return;
        }
        let current = this._head;
        let currentSize = this.size;
        while(current && currentSize > newSize){
            this._map.delete(current.key);
            current = current.next;
            currentSize--;
        }
        this._head = current;
        this._size = currentSize;
        if (current) current.previous = undefined;
        this._state++;
    }
    addItemFirst(item) {
        // First time Insert
        if (!this._head && !this._tail) this._tail = item;
        else if (!this._head) throw new Error('Invalid list');
        else {
            item.next = this._head;
            this._head.previous = item;
        }
        this._head = item;
        this._state++;
    }
    addItemLast(item) {
        // First time Insert
        if (!this._head && !this._tail) this._head = item;
        else if (!this._tail) throw new Error('Invalid list');
        else {
            item.previous = this._tail;
            this._tail.next = item;
        }
        this._tail = item;
        this._state++;
    }
    removeItem(item) {
        if (item === this._head && item === this._tail) {
            this._head = undefined;
            this._tail = undefined;
        } else if (item === this._head) {
            // This can only happened if size === 1 which is handle
            // by the case above.
            if (!item.next) throw new Error('Invalid list');
            item.next.previous = undefined;
            this._head = item.next;
        } else if (item === this._tail) {
            // This can only happened if size === 1 which is handle
            // by the case above.
            if (!item.previous) throw new Error('Invalid list');
            item.previous.next = undefined;
            this._tail = item.previous;
        } else {
            const next = item.next;
            const previous = item.previous;
            if (!next || !previous) throw new Error('Invalid list');
            next.previous = previous;
            previous.next = next;
        }
        item.next = undefined;
        item.previous = undefined;
        this._state++;
    }
    touch(item, touch) {
        if (!this._head || !this._tail) throw new Error('Invalid list');
        if (touch !== $e28a3b4c73c04f0a$var$Touch.First && touch !== $e28a3b4c73c04f0a$var$Touch.Last) return;
        if (touch === $e28a3b4c73c04f0a$var$Touch.First) {
            if (item === this._head) return;
            const next = item.next;
            const previous = item.previous;
            // Unlink the item
            if (item === this._tail) {
                // previous must be defined since item was not head but is tail
                // So there are more than on item in the map
                previous.next = undefined;
                this._tail = previous;
            } else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            // Insert the node at head
            item.previous = undefined;
            item.next = this._head;
            this._head.previous = item;
            this._head = item;
            this._state++;
        } else if (touch === $e28a3b4c73c04f0a$var$Touch.Last) {
            if (item === this._tail) return;
            const next = item.next;
            const previous = item.previous;
            // Unlink the item.
            if (item === this._head) {
                // next must be defined since item was not tail but is head
                // So there are more than on item in the map
                next.previous = undefined;
                this._head = next;
            } else {
                // Both next and previous are not undefined since item was neither head nor tail.
                next.previous = previous;
                previous.next = next;
            }
            item.next = undefined;
            item.previous = this._tail;
            this._tail.next = item;
            this._tail = item;
            this._state++;
        }
    }
    toJSON() {
        const data = [];
        this.forEach((value, key)=>{
            data.push([
                key,
                value
            ]);
        });
        return data;
    }
    fromJSON(data) {
        this.clear();
        for (const [key, value] of data)this.set(key, value);
    }
}
module.exports.LinkedMap = $e28a3b4c73c04f0a$var$LinkedMap;
class $e28a3b4c73c04f0a$var$LRUCache extends $e28a3b4c73c04f0a$var$LinkedMap {
    _limit;
    _ratio;
    constructor(limit, ratio = 1){
        super();
        this._limit = limit;
        this._ratio = Math.min(Math.max(0, ratio), 1);
    }
    get limit() {
        return this._limit;
    }
    set limit(limit) {
        this._limit = limit;
        this.checkTrim();
    }
    get ratio() {
        return this._ratio;
    }
    set ratio(ratio) {
        this._ratio = Math.min(Math.max(0, ratio), 1);
        this.checkTrim();
    }
    get(key, touch = $e28a3b4c73c04f0a$var$Touch.AsNew) {
        return super.get(key, touch);
    }
    peek(key) {
        return super.get(key, $e28a3b4c73c04f0a$var$Touch.None);
    }
    set(key, value) {
        super.set(key, value, $e28a3b4c73c04f0a$var$Touch.Last);
        this.checkTrim();
        return this;
    }
    checkTrim() {
        if (this.size > this._limit) this.trimOld(Math.round(this._limit * this._ratio));
    }
}
module.exports.LRUCache = $e28a3b4c73c04f0a$var$LRUCache;

});

parcelRegister("kP9zO", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Disposable = void 0;
var $f28fffcd105ffc86$var$Disposable;
(function(Disposable) {
    function create(func) {
        return {
            dispose: func
        };
    }
    Disposable.create = create;
})($f28fffcd105ffc86$var$Disposable || (module.exports.Disposable = $f28fffcd105ffc86$var$Disposable = {}));

});

parcelRegister("8Not3", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $6675e118c2627cc6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Emitter = module.exports.Event = void 0;

const $6675e118c2627cc6$var$ral_1 = $6675e118c2627cc6$var$__importDefault((parcelRequire("7UD77")));
var $6675e118c2627cc6$var$Event;
(function(Event) {
    const _disposable = {
        dispose () {}
    };
    Event.None = function() {
        return _disposable;
    };
})($6675e118c2627cc6$var$Event || (module.exports.Event = $6675e118c2627cc6$var$Event = {}));
class $6675e118c2627cc6$var$CallbackList {
    _callbacks;
    _contexts;
    add(callback, context = null, bucket) {
        if (!this._callbacks) {
            this._callbacks = [];
            this._contexts = [];
        }
        this._callbacks.push(callback);
        this._contexts.push(context);
        if (Array.isArray(bucket)) bucket.push({
            dispose: ()=>this.remove(callback, context)
        });
    }
    remove(callback, context = null) {
        if (!this._callbacks) return;
        let foundCallbackWithDifferentContext = false;
        for(let i = 0, len = this._callbacks.length; i < len; i++)if (this._callbacks[i] === callback) {
            if (this._contexts[i] === context) {
                // callback & context match => remove it
                this._callbacks.splice(i, 1);
                this._contexts.splice(i, 1);
                return;
            } else foundCallbackWithDifferentContext = true;
        }
        if (foundCallbackWithDifferentContext) throw new Error('When adding a listener with a context, you should remove it with the same context');
    }
    invoke(...args) {
        if (!this._callbacks) return [];
        const ret = [], callbacks = this._callbacks.slice(0), contexts = this._contexts.slice(0);
        for(let i = 0, len = callbacks.length; i < len; i++)try {
            ret.push(callbacks[i].apply(contexts[i], args));
        } catch (e) {
            (0, $6675e118c2627cc6$var$ral_1.default)().console.error(e);
        }
        return ret;
    }
    isEmpty() {
        return !this._callbacks || this._callbacks.length === 0;
    }
    dispose() {
        this._callbacks = undefined;
        this._contexts = undefined;
    }
}
class $6675e118c2627cc6$var$Emitter {
    _options;
    static _noop = function() {};
    _event;
    _callbacks;
    constructor(_options){
        this._options = _options;
    }
    /**
     * For the public to allow to subscribe
     * to events from this Emitter
     */ get event() {
        if (!this._event) this._event = (listener, thisArgs, disposables)=>{
            if (!this._callbacks) this._callbacks = new $6675e118c2627cc6$var$CallbackList();
            if (this._options && this._options.onFirstListenerAdd && this._callbacks.isEmpty()) this._options.onFirstListenerAdd(this);
            this._callbacks.add(listener, thisArgs);
            const result = {
                dispose: ()=>{
                    if (!this._callbacks) // disposable is disposed after emitter is disposed.
                    return;
                    this._callbacks.remove(listener, thisArgs);
                    result.dispose = $6675e118c2627cc6$var$Emitter._noop;
                    if (this._options && this._options.onLastListenerRemove && this._callbacks.isEmpty()) this._options.onLastListenerRemove(this);
                }
            };
            if (Array.isArray(disposables)) disposables.push(result);
            return result;
        };
        return this._event;
    }
    /**
     * To be kept private to fire an event to
     * subscribers
     */ fire(event) {
        if (this._callbacks) this._callbacks.invoke.call(this._callbacks, event);
    }
    dispose() {
        if (this._callbacks) {
            this._callbacks.dispose();
            this._callbacks = undefined;
        }
    }
}
module.exports.Emitter = $6675e118c2627cc6$var$Emitter;

});
parcelRegister("7UD77", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $5c2c1a945ab094ce$var$_ral;
function $5c2c1a945ab094ce$var$RAL() {
    if ($5c2c1a945ab094ce$var$_ral === undefined) throw new Error(`No runtime abstraction layer installed`);
    return $5c2c1a945ab094ce$var$_ral;
}
(function(RAL) {
    function install(ral) {
        if (ral === undefined) throw new Error(`No runtime abstraction layer provided`);
        $5c2c1a945ab094ce$var$_ral = ral;
    }
    RAL.install = install;
})($5c2c1a945ab094ce$var$RAL || ($5c2c1a945ab094ce$var$RAL = {}));
module.exports.default = $5c2c1a945ab094ce$var$RAL;

});


parcelRegister("1NuV6", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var $14f25a20defeb70a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14f25a20defeb70a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $14f25a20defeb70a$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $14f25a20defeb70a$var$__createBinding(result, mod, k[i]);
        }
        $14f25a20defeb70a$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $14f25a20defeb70a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancellationTokenSource = module.exports.CancellationToken = void 0;

const $14f25a20defeb70a$var$ral_1 = $14f25a20defeb70a$var$__importDefault((parcelRequire("7UD77")));

const $14f25a20defeb70a$var$Is = $14f25a20defeb70a$var$__importStar((parcelRequire("5BYQO")));

var $8Not3 = parcelRequire("8Not3");
var $14f25a20defeb70a$var$CancellationToken;
(function(CancellationToken) {
    CancellationToken.None = Object.freeze({
        isCancellationRequested: false,
        onCancellationRequested: $8Not3.Event.None
    });
    CancellationToken.Cancelled = Object.freeze({
        isCancellationRequested: true,
        onCancellationRequested: $8Not3.Event.None
    });
    function is(value) {
        const candidate = value;
        return candidate && (candidate === CancellationToken.None || candidate === CancellationToken.Cancelled || $14f25a20defeb70a$var$Is.boolean(candidate.isCancellationRequested) && !!candidate.onCancellationRequested);
    }
    CancellationToken.is = is;
})($14f25a20defeb70a$var$CancellationToken || (module.exports.CancellationToken = $14f25a20defeb70a$var$CancellationToken = {}));
const $14f25a20defeb70a$var$shortcutEvent = Object.freeze(function(callback, context) {
    const handle = (0, $14f25a20defeb70a$var$ral_1.default)().timer.setTimeout(callback.bind(context), 0);
    return {
        dispose () {
            handle.dispose();
        }
    };
});
class $14f25a20defeb70a$var$MutableToken {
    _isCancelled = false;
    _emitter;
    cancel() {
        if (!this._isCancelled) {
            this._isCancelled = true;
            if (this._emitter) {
                this._emitter.fire(undefined);
                this.dispose();
            }
        }
    }
    get isCancellationRequested() {
        return this._isCancelled;
    }
    get onCancellationRequested() {
        if (this._isCancelled) return $14f25a20defeb70a$var$shortcutEvent;
        if (!this._emitter) this._emitter = new $8Not3.Emitter();
        return this._emitter.event;
    }
    dispose() {
        if (this._emitter) {
            this._emitter.dispose();
            this._emitter = undefined;
        }
    }
}
class $14f25a20defeb70a$var$CancellationTokenSource {
    _token;
    get token() {
        if (!this._token) // be lazy and create the token only when
        // actually needed
        this._token = new $14f25a20defeb70a$var$MutableToken();
        return this._token;
    }
    cancel() {
        if (!this._token) // save an object by returning the default
        // cancelled token when cancellation happens
        // before someone asks for the token
        this._token = $14f25a20defeb70a$var$CancellationToken.Cancelled;
        else this._token.cancel();
    }
    dispose() {
        if (!this._token) // ensure to initialize with an empty token if we had none
        this._token = $14f25a20defeb70a$var$CancellationToken.None;
        else if (this._token instanceof $14f25a20defeb70a$var$MutableToken) // actually dispose
        this._token.dispose();
    }
}
module.exports.CancellationTokenSource = $14f25a20defeb70a$var$CancellationTokenSource;

});

parcelRegister("g9ZoK", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SharedArrayReceiverStrategy = module.exports.SharedArraySenderStrategy = void 0;

var $1NuV6 = parcelRequire("1NuV6");
var $bc3d1cff996e0558$var$CancellationState;
(function(CancellationState) {
    CancellationState.Continue = 0;
    CancellationState.Cancelled = 1;
})($bc3d1cff996e0558$var$CancellationState || ($bc3d1cff996e0558$var$CancellationState = {}));
class $bc3d1cff996e0558$var$SharedArraySenderStrategy {
    buffers;
    constructor(){
        this.buffers = new Map();
    }
    enableCancellation(request) {
        if (request.id === null) return;
        const buffer = new SharedArrayBuffer(4);
        const data = new Int32Array(buffer, 0, 1);
        data[0] = $bc3d1cff996e0558$var$CancellationState.Continue;
        this.buffers.set(request.id, buffer);
        request.$cancellationData = buffer;
    }
    async sendCancellation(_conn, id) {
        const buffer = this.buffers.get(id);
        if (buffer === undefined) return;
        const data = new Int32Array(buffer, 0, 1);
        Atomics.store(data, 0, $bc3d1cff996e0558$var$CancellationState.Cancelled);
    }
    cleanup(id) {
        this.buffers.delete(id);
    }
    dispose() {
        this.buffers.clear();
    }
}
module.exports.SharedArraySenderStrategy = $bc3d1cff996e0558$var$SharedArraySenderStrategy;
class $bc3d1cff996e0558$var$SharedArrayBufferCancellationToken {
    data;
    constructor(buffer){
        this.data = new Int32Array(buffer, 0, 1);
    }
    get isCancellationRequested() {
        return Atomics.load(this.data, 0) === $bc3d1cff996e0558$var$CancellationState.Cancelled;
    }
    get onCancellationRequested() {
        throw new Error(`Cancellation over SharedArrayBuffer doesn't support cancellation events`);
    }
}
class $bc3d1cff996e0558$var$SharedArrayBufferCancellationTokenSource {
    token;
    constructor(buffer){
        this.token = new $bc3d1cff996e0558$var$SharedArrayBufferCancellationToken(buffer);
    }
    cancel() {}
    dispose() {}
}
class $bc3d1cff996e0558$var$SharedArrayReceiverStrategy {
    kind = 'request';
    createCancellationTokenSource(request) {
        const buffer = request.$cancellationData;
        if (buffer === undefined) return new $1NuV6.CancellationTokenSource();
        return new $bc3d1cff996e0558$var$SharedArrayBufferCancellationTokenSource(buffer);
    }
}
module.exports.SharedArrayReceiverStrategy = $bc3d1cff996e0558$var$SharedArrayReceiverStrategy;

});

parcelRegister("3c3yY", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $253541a044bdb827$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $253541a044bdb827$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $253541a044bdb827$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $253541a044bdb827$var$__createBinding(result, mod, k[i]);
        }
        $253541a044bdb827$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $253541a044bdb827$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReadableStreamMessageReader = module.exports.AbstractMessageReader = module.exports.MessageReader = void 0;

const $253541a044bdb827$var$ral_1 = $253541a044bdb827$var$__importDefault((parcelRequire("7UD77")));

const $253541a044bdb827$var$Is = $253541a044bdb827$var$__importStar((parcelRequire("5BYQO")));

var $8Not3 = parcelRequire("8Not3");

var $647ZU = parcelRequire("647ZU");
var $253541a044bdb827$var$MessageReader;
(function(MessageReader) {
    function is(value) {
        const candidate = value;
        return candidate && $253541a044bdb827$var$Is.func(candidate.listen) && $253541a044bdb827$var$Is.func(candidate.dispose) && $253541a044bdb827$var$Is.func(candidate.onError) && $253541a044bdb827$var$Is.func(candidate.onClose) && $253541a044bdb827$var$Is.func(candidate.onPartialMessage);
    }
    MessageReader.is = is;
})($253541a044bdb827$var$MessageReader || (module.exports.MessageReader = $253541a044bdb827$var$MessageReader = {}));
class $253541a044bdb827$var$AbstractMessageReader {
    errorEmitter;
    closeEmitter;
    partialMessageEmitter;
    constructor(){
        this.errorEmitter = new $8Not3.Emitter();
        this.closeEmitter = new $8Not3.Emitter();
        this.partialMessageEmitter = new $8Not3.Emitter();
    }
    dispose() {
        this.errorEmitter.dispose();
        this.closeEmitter.dispose();
        this.partialMessageEmitter.dispose();
    }
    get onError() {
        return this.errorEmitter.event;
    }
    fireError(error) {
        this.errorEmitter.fire(this.asError(error));
    }
    get onClose() {
        return this.closeEmitter.event;
    }
    fireClose() {
        this.closeEmitter.fire(undefined);
    }
    get onPartialMessage() {
        return this.partialMessageEmitter.event;
    }
    firePartialMessage(info) {
        this.partialMessageEmitter.fire(info);
    }
    asError(error) {
        if (error instanceof Error) return error;
        else return new Error(`Reader received error. Reason: ${$253541a044bdb827$var$Is.string(error.message) ? error.message : 'unknown'}`);
    }
}
module.exports.AbstractMessageReader = $253541a044bdb827$var$AbstractMessageReader;
var $253541a044bdb827$var$ResolvedMessageReaderOptions;
(function(ResolvedMessageReaderOptions) {
    function fromOptions(options) {
        let charset;
        let result;
        let contentDecoder;
        const contentDecoders = new Map();
        let contentTypeDecoder;
        const contentTypeDecoders = new Map();
        if (options === undefined || typeof options === 'string') charset = options ?? 'utf-8';
        else {
            charset = options.charset ?? 'utf-8';
            if (options.contentDecoder !== undefined) {
                contentDecoder = options.contentDecoder;
                contentDecoders.set(contentDecoder.name, contentDecoder);
            }
            if (options.contentDecoders !== undefined) for (const decoder of options.contentDecoders)contentDecoders.set(decoder.name, decoder);
            if (options.contentTypeDecoder !== undefined) {
                contentTypeDecoder = options.contentTypeDecoder;
                contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
            }
            if (options.contentTypeDecoders !== undefined) for (const decoder of options.contentTypeDecoders)contentTypeDecoders.set(decoder.name, decoder);
        }
        if (contentTypeDecoder === undefined) {
            contentTypeDecoder = (0, $253541a044bdb827$var$ral_1.default)().applicationJson.decoder;
            contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
        }
        return {
            charset: charset,
            contentDecoder: contentDecoder,
            contentDecoders: contentDecoders,
            contentTypeDecoder: contentTypeDecoder,
            contentTypeDecoders: contentTypeDecoders
        };
    }
    ResolvedMessageReaderOptions.fromOptions = fromOptions;
})($253541a044bdb827$var$ResolvedMessageReaderOptions || ($253541a044bdb827$var$ResolvedMessageReaderOptions = {}));
class $253541a044bdb827$var$ReadableStreamMessageReader extends $253541a044bdb827$var$AbstractMessageReader {
    readable;
    options;
    callback;
    nextMessageLength;
    messageToken;
    buffer;
    partialMessageTimer;
    _partialMessageTimeout;
    readSemaphore;
    constructor(readable, options){
        super();
        this.readable = readable;
        this.options = $253541a044bdb827$var$ResolvedMessageReaderOptions.fromOptions(options);
        this.buffer = (0, $253541a044bdb827$var$ral_1.default)().messageBuffer.create(this.options.charset);
        this._partialMessageTimeout = 10000;
        this.nextMessageLength = -1;
        this.messageToken = 0;
        this.readSemaphore = new $647ZU.Semaphore(1);
    }
    set partialMessageTimeout(timeout) {
        this._partialMessageTimeout = timeout;
    }
    get partialMessageTimeout() {
        return this._partialMessageTimeout;
    }
    listen(callback) {
        this.nextMessageLength = -1;
        this.messageToken = 0;
        this.partialMessageTimer = undefined;
        this.callback = callback;
        const result = this.readable.onData((data)=>{
            this.onData(data);
        });
        this.readable.onError((error)=>this.fireError(error));
        this.readable.onClose(()=>this.fireClose());
        return result;
    }
    onData(data) {
        try {
            this.buffer.append(data);
            while(true){
                if (this.nextMessageLength === -1) {
                    const headers = this.buffer.tryReadHeaders(true);
                    if (!headers) return;
                    const contentLength = headers.get('content-length');
                    if (!contentLength) {
                        this.fireError(new Error(`Header must provide a Content-Length property.\n${JSON.stringify(Object.fromEntries(headers))}`));
                        return;
                    }
                    const length = parseInt(contentLength);
                    if (isNaN(length)) {
                        this.fireError(new Error(`Content-Length value must be a number. Got ${contentLength}`));
                        return;
                    }
                    this.nextMessageLength = length;
                }
                const body = this.buffer.tryReadBody(this.nextMessageLength);
                if (body === undefined) {
                    /** We haven't received the full message yet. */ this.setPartialMessageTimer();
                    return;
                }
                this.clearPartialMessageTimer();
                this.nextMessageLength = -1;
                // Make sure that we convert one received message after the
                // other. Otherwise it could happen that a decoding of a second
                // smaller message finished before the decoding of a first larger
                // message and then we would deliver the second message first.
                this.readSemaphore.lock(async ()=>{
                    const bytes = this.options.contentDecoder !== undefined ? await this.options.contentDecoder.decode(body) : body;
                    const message = await this.options.contentTypeDecoder.decode(bytes, this.options);
                    this.callback(message);
                }).catch((error)=>{
                    this.fireError(error);
                });
            }
        } catch (error) {
            this.fireError(error);
        }
    }
    clearPartialMessageTimer() {
        if (this.partialMessageTimer) {
            this.partialMessageTimer.dispose();
            this.partialMessageTimer = undefined;
        }
    }
    setPartialMessageTimer() {
        this.clearPartialMessageTimer();
        if (this._partialMessageTimeout <= 0) return;
        this.partialMessageTimer = (0, $253541a044bdb827$var$ral_1.default)().timer.setTimeout((token, timeout)=>{
            this.partialMessageTimer = undefined;
            if (token === this.messageToken) {
                this.firePartialMessage({
                    messageToken: token,
                    waitingTime: timeout
                });
                this.setPartialMessageTimer();
            }
        }, this._partialMessageTimeout, this.messageToken, this._partialMessageTimeout);
    }
}
module.exports.ReadableStreamMessageReader = $253541a044bdb827$var$ReadableStreamMessageReader;

});
parcelRegister("647ZU", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $46a951ec09f7290d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Semaphore = void 0;

const $46a951ec09f7290d$var$ral_1 = $46a951ec09f7290d$var$__importDefault((parcelRequire("7UD77")));
class $46a951ec09f7290d$var$Semaphore {
    _capacity;
    _active;
    _waiting;
    constructor(capacity = 1){
        if (capacity <= 0) throw new Error('Capacity must be greater than 0');
        this._capacity = capacity;
        this._active = 0;
        this._waiting = [];
    }
    lock(thunk) {
        return new Promise((resolve, reject)=>{
            this._waiting.push({
                thunk: thunk,
                resolve: resolve,
                reject: reject
            });
            this.runNext();
        });
    }
    get active() {
        return this._active;
    }
    runNext() {
        if (this._waiting.length === 0 || this._active === this._capacity) return;
        (0, $46a951ec09f7290d$var$ral_1.default)().timer.setImmediate(()=>this.doRunNext());
    }
    doRunNext() {
        if (this._waiting.length === 0 || this._active === this._capacity) return;
        const next = this._waiting.shift();
        this._active++;
        if (this._active > this._capacity) throw new Error(`Too many thunks active`);
        try {
            const result = next.thunk();
            if (result instanceof Promise) result.then((value)=>{
                this._active--;
                next.resolve(value);
                this.runNext();
            }, (err)=>{
                this._active--;
                next.reject(err);
                this.runNext();
            });
            else {
                this._active--;
                next.resolve(result);
                this.runNext();
            }
        } catch (err) {
            this._active--;
            next.reject(err);
            this.runNext();
        }
    }
}
module.exports.Semaphore = $46a951ec09f7290d$var$Semaphore;

});


parcelRegister("eDSbD", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $aa8ebd860b8263aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aa8ebd860b8263aa$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aa8ebd860b8263aa$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $aa8ebd860b8263aa$var$__createBinding(result, mod, k[i]);
        }
        $aa8ebd860b8263aa$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $aa8ebd860b8263aa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WriteableStreamMessageWriter = module.exports.AbstractMessageWriter = module.exports.MessageWriter = void 0;

const $aa8ebd860b8263aa$var$ral_1 = $aa8ebd860b8263aa$var$__importDefault((parcelRequire("7UD77")));

const $aa8ebd860b8263aa$var$Is = $aa8ebd860b8263aa$var$__importStar((parcelRequire("5BYQO")));

var $647ZU = parcelRequire("647ZU");

var $8Not3 = parcelRequire("8Not3");
const $aa8ebd860b8263aa$var$ContentLength = 'Content-Length: ';
const $aa8ebd860b8263aa$var$CRLF = '\r\n';
var $aa8ebd860b8263aa$var$MessageWriter;
(function(MessageWriter) {
    function is(value) {
        const candidate = value;
        return candidate && $aa8ebd860b8263aa$var$Is.func(candidate.dispose) && $aa8ebd860b8263aa$var$Is.func(candidate.onClose) && $aa8ebd860b8263aa$var$Is.func(candidate.onError) && $aa8ebd860b8263aa$var$Is.func(candidate.write);
    }
    MessageWriter.is = is;
})($aa8ebd860b8263aa$var$MessageWriter || (module.exports.MessageWriter = $aa8ebd860b8263aa$var$MessageWriter = {}));
class $aa8ebd860b8263aa$var$AbstractMessageWriter {
    errorEmitter;
    closeEmitter;
    constructor(){
        this.errorEmitter = new $8Not3.Emitter();
        this.closeEmitter = new $8Not3.Emitter();
    }
    dispose() {
        this.errorEmitter.dispose();
        this.closeEmitter.dispose();
    }
    get onError() {
        return this.errorEmitter.event;
    }
    fireError(error, message, count) {
        this.errorEmitter.fire([
            this.asError(error),
            message,
            count
        ]);
    }
    get onClose() {
        return this.closeEmitter.event;
    }
    fireClose() {
        this.closeEmitter.fire(undefined);
    }
    asError(error) {
        if (error instanceof Error) return error;
        else return new Error(`Writer received error. Reason: ${$aa8ebd860b8263aa$var$Is.string(error.message) ? error.message : 'unknown'}`);
    }
}
module.exports.AbstractMessageWriter = $aa8ebd860b8263aa$var$AbstractMessageWriter;
var $aa8ebd860b8263aa$var$ResolvedMessageWriterOptions;
(function(ResolvedMessageWriterOptions) {
    function fromOptions(options) {
        if (options === undefined || typeof options === 'string') return {
            charset: options ?? 'utf-8',
            contentTypeEncoder: (0, $aa8ebd860b8263aa$var$ral_1.default)().applicationJson.encoder
        };
        else return {
            charset: options.charset ?? 'utf-8',
            contentEncoder: options.contentEncoder,
            contentTypeEncoder: options.contentTypeEncoder ?? (0, $aa8ebd860b8263aa$var$ral_1.default)().applicationJson.encoder
        };
    }
    ResolvedMessageWriterOptions.fromOptions = fromOptions;
})($aa8ebd860b8263aa$var$ResolvedMessageWriterOptions || ($aa8ebd860b8263aa$var$ResolvedMessageWriterOptions = {}));
class $aa8ebd860b8263aa$var$WriteableStreamMessageWriter extends $aa8ebd860b8263aa$var$AbstractMessageWriter {
    writable;
    options;
    errorCount;
    writeSemaphore;
    constructor(writable, options){
        super();
        this.writable = writable;
        this.options = $aa8ebd860b8263aa$var$ResolvedMessageWriterOptions.fromOptions(options);
        this.errorCount = 0;
        this.writeSemaphore = new $647ZU.Semaphore(1);
        this.writable.onError((error)=>this.fireError(error));
        this.writable.onClose(()=>this.fireClose());
    }
    async write(msg) {
        return this.writeSemaphore.lock(async ()=>{
            const payload = this.options.contentTypeEncoder.encode(msg, this.options).then((buffer)=>{
                if (this.options.contentEncoder !== undefined) return this.options.contentEncoder.encode(buffer);
                else return buffer;
            });
            return payload.then((buffer)=>{
                const headers = [];
                headers.push($aa8ebd860b8263aa$var$ContentLength, buffer.byteLength.toString(), $aa8ebd860b8263aa$var$CRLF);
                headers.push($aa8ebd860b8263aa$var$CRLF);
                return this.doWrite(msg, headers, buffer);
            }, (error)=>{
                this.fireError(error);
                throw error;
            });
        });
    }
    async doWrite(msg, headers, data) {
        try {
            await this.writable.write(headers.join(''), 'ascii');
            return this.writable.write(data);
        } catch (error) {
            this.handleError(error, msg);
            return Promise.reject(error);
        }
    }
    handleError(error, msg) {
        this.errorCount++;
        this.fireError(error, msg, this.errorCount);
    }
    end() {
        this.writable.end();
    }
}
module.exports.WriteableStreamMessageWriter = $aa8ebd860b8263aa$var$WriteableStreamMessageWriter;

});

parcelRegister("8DVyG", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractMessageBuffer = void 0;
const $64ae9d237a05be20$var$CR = 13;
const $64ae9d237a05be20$var$LF = 10;
const $64ae9d237a05be20$var$CRLF = '\r\n';
class $64ae9d237a05be20$var$AbstractMessageBuffer {
    _encoding;
    _chunks;
    _totalLength;
    constructor(encoding = 'utf-8'){
        this._encoding = encoding;
        this._chunks = [];
        this._totalLength = 0;
    }
    get encoding() {
        return this._encoding;
    }
    append(chunk) {
        const toAppend = typeof chunk === 'string' ? this.fromString(chunk, this._encoding) : chunk;
        this._chunks.push(toAppend);
        this._totalLength += toAppend.byteLength;
    }
    tryReadHeaders(lowerCaseKeys = false) {
        if (this._chunks.length === 0) return undefined;
        let state = 0;
        let chunkIndex = 0;
        let offset = 0;
        let chunkBytesRead = 0;
        row: while(chunkIndex < this._chunks.length){
            const chunk = this._chunks[chunkIndex];
            offset = 0;
            while(offset < chunk.length){
                const value = chunk[offset];
                switch(value){
                    case $64ae9d237a05be20$var$CR:
                        switch(state){
                            case 0:
                                state = 1;
                                break;
                            case 2:
                                state = 3;
                                break;
                            default:
                                state = 0;
                        }
                        break;
                    case $64ae9d237a05be20$var$LF:
                        switch(state){
                            case 1:
                                state = 2;
                                break;
                            case 3:
                                state = 4;
                                offset++;
                                break row;
                            default:
                                state = 0;
                        }
                        break;
                    default:
                        state = 0;
                }
                offset++;
            }
            chunkBytesRead += chunk.byteLength;
            chunkIndex++;
        }
        if (state !== 4) return undefined;
        // The buffer contains the two CRLF at the end. So we will
        // have two empty lines after the split at the end as well.
        const buffer = this._read(chunkBytesRead + offset);
        const result = new Map();
        const headers = this.toString(buffer, 'ascii').split($64ae9d237a05be20$var$CRLF);
        if (headers.length < 2) return result;
        for(let i = 0; i < headers.length - 2; i++){
            const header = headers[i];
            const index = header.indexOf(':');
            if (index === -1) throw new Error(`Message header must separate key and value using ':'\n${header}`);
            const key = header.substr(0, index);
            const value = header.substr(index + 1).trim();
            result.set(lowerCaseKeys ? key.toLowerCase() : key, value);
        }
        return result;
    }
    tryReadBody(length) {
        if (this._totalLength < length) return undefined;
        return this._read(length);
    }
    get numberOfBytes() {
        return this._totalLength;
    }
    _read(byteCount) {
        if (byteCount === 0) return this.emptyBuffer();
        if (byteCount > this._totalLength) throw new Error(`Cannot read so many bytes!`);
        if (this._chunks[0].byteLength === byteCount) {
            // super fast path, precisely first chunk must be returned
            const chunk = this._chunks[0];
            this._chunks.shift();
            this._totalLength -= byteCount;
            return this.asNative(chunk);
        }
        if (this._chunks[0].byteLength > byteCount) {
            // fast path, the reading is entirely within the first chunk
            const chunk = this._chunks[0];
            const result = this.asNative(chunk, byteCount);
            this._chunks[0] = chunk.slice(byteCount);
            this._totalLength -= byteCount;
            return result;
        }
        const result = this.allocNative(byteCount);
        let resultOffset = 0;
        const chunkIndex = 0;
        while(byteCount > 0){
            const chunk = this._chunks[chunkIndex];
            if (chunk.byteLength > byteCount) {
                // this chunk will survive
                const chunkPart = chunk.slice(0, byteCount);
                result.set(chunkPart, resultOffset);
                resultOffset += byteCount;
                this._chunks[chunkIndex] = chunk.slice(byteCount);
                this._totalLength -= byteCount;
                byteCount -= byteCount;
            } else {
                // this chunk will be entirely read
                result.set(chunk, resultOffset);
                resultOffset += chunk.byteLength;
                this._chunks.shift();
                this._totalLength -= chunk.byteLength;
                byteCount -= chunk.byteLength;
            }
        }
        return result;
    }
}
module.exports.AbstractMessageBuffer = $64ae9d237a05be20$var$AbstractMessageBuffer;

});

parcelRegister("dmaS3", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ /// <reference path="../../typings/thenable.d.ts" preserve="true"/>
var $9b95c32678443a55$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b95c32678443a55$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9b95c32678443a55$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9b95c32678443a55$var$__createBinding(result, mod, k[i]);
        }
        $9b95c32678443a55$var$__setModuleDefault(result, mod);
        return result;
    };
}();
var $9b95c32678443a55$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectionOptions = module.exports.MessageStrategy = module.exports.CancellationStrategy = module.exports.CancellationSenderStrategy = module.exports.CancellationReceiverStrategy = module.exports.RequestCancellationReceiverStrategy = module.exports.IdCancellationReceiverStrategy = module.exports.ConnectionStrategy = module.exports.ConnectionError = module.exports.ConnectionErrors = module.exports.LogTraceNotification = module.exports.SetTraceNotification = module.exports.TraceFormat = module.exports.TraceValues = module.exports.TraceValue = module.exports.Trace = module.exports.NullLogger = module.exports.ProgressType = module.exports.ProgressToken = void 0;
module.exports.createMessageConnection = $9b95c32678443a55$var$createMessageConnection;

const $9b95c32678443a55$var$ral_1 = $9b95c32678443a55$var$__importDefault((parcelRequire("7UD77")));

const $9b95c32678443a55$var$Is = $9b95c32678443a55$var$__importStar((parcelRequire("5BYQO")));

var $bQGIN = parcelRequire("bQGIN");

var $jrRKt = parcelRequire("jrRKt");

var $8Not3 = parcelRequire("8Not3");

var $1NuV6 = parcelRequire("1NuV6");
var $9b95c32678443a55$var$CancelNotification;
(function(CancelNotification) {
    CancelNotification.type = new $bQGIN.NotificationType('$/cancelRequest');
})($9b95c32678443a55$var$CancelNotification || ($9b95c32678443a55$var$CancelNotification = {}));
var $9b95c32678443a55$var$ProgressToken;
(function(ProgressToken) {
    function is(value) {
        return typeof value === 'string' || typeof value === 'number';
    }
    ProgressToken.is = is;
})($9b95c32678443a55$var$ProgressToken || (module.exports.ProgressToken = $9b95c32678443a55$var$ProgressToken = {}));
var $9b95c32678443a55$var$ProgressNotification;
(function(ProgressNotification) {
    ProgressNotification.type = new $bQGIN.NotificationType('$/progress');
})($9b95c32678443a55$var$ProgressNotification || ($9b95c32678443a55$var$ProgressNotification = {}));
class $9b95c32678443a55$var$ProgressType {
    /**
     * Clients must not use these properties. They are here to ensure correct typing.
     * in TypeScript
     */ __;
    _pr;
    constructor(){}
}
module.exports.ProgressType = $9b95c32678443a55$var$ProgressType;
var $9b95c32678443a55$var$StarRequestHandler;
(function(StarRequestHandler) {
    function is(value) {
        return $9b95c32678443a55$var$Is.func(value);
    }
    StarRequestHandler.is = is;
})($9b95c32678443a55$var$StarRequestHandler || ($9b95c32678443a55$var$StarRequestHandler = {}));
module.exports.NullLogger = Object.freeze({
    error: ()=>{},
    warn: ()=>{},
    info: ()=>{},
    log: ()=>{}
});
var $9b95c32678443a55$var$Trace;
(function(Trace) {
    Trace[Trace["Off"] = 0] = "Off";
    Trace[Trace["Messages"] = 1] = "Messages";
    Trace[Trace["Compact"] = 2] = "Compact";
    Trace[Trace["Verbose"] = 3] = "Verbose";
})($9b95c32678443a55$var$Trace || (module.exports.Trace = $9b95c32678443a55$var$Trace = {}));
var $9b95c32678443a55$var$TraceValue;
(function(TraceValue) {
    /**
     * Turn tracing off.
     */ TraceValue.Off = 'off';
    /**
     * Trace messages only.
     */ TraceValue.Messages = 'messages';
    /**
     * Compact message tracing.
     */ TraceValue.Compact = 'compact';
    /**
     * Verbose message tracing.
     */ TraceValue.Verbose = 'verbose';
})($9b95c32678443a55$var$TraceValue || (module.exports.TraceValue = $9b95c32678443a55$var$TraceValue = {}));
/**
 * @deprecated Use TraceValue instead
 */ module.exports.TraceValues = $9b95c32678443a55$var$TraceValue;
(function(Trace) {
    function fromString(value) {
        if (!$9b95c32678443a55$var$Is.string(value)) return Trace.Off;
        value = value.toLowerCase();
        switch(value){
            case 'off':
                return Trace.Off;
            case 'messages':
                return Trace.Messages;
            case 'compact':
                return Trace.Compact;
            case 'verbose':
                return Trace.Verbose;
            default:
                return Trace.Off;
        }
    }
    Trace.fromString = fromString;
    function toString(value) {
        switch(value){
            case Trace.Off:
                return 'off';
            case Trace.Messages:
                return 'messages';
            case Trace.Compact:
                return 'compact';
            case Trace.Verbose:
                return 'verbose';
            default:
                return 'off';
        }
    }
    Trace.toString = toString;
})($9b95c32678443a55$var$Trace || (module.exports.Trace = $9b95c32678443a55$var$Trace = {}));
var $9b95c32678443a55$var$TraceFormat;
(function(TraceFormat) {
    TraceFormat["Text"] = "text";
    TraceFormat["JSON"] = "json";
})($9b95c32678443a55$var$TraceFormat || (module.exports.TraceFormat = $9b95c32678443a55$var$TraceFormat = {}));
(function(TraceFormat) {
    function fromString(value) {
        if (!$9b95c32678443a55$var$Is.string(value)) return TraceFormat.Text;
        value = value.toLowerCase();
        if (value === 'json') return TraceFormat.JSON;
        else return TraceFormat.Text;
    }
    TraceFormat.fromString = fromString;
})($9b95c32678443a55$var$TraceFormat || (module.exports.TraceFormat = $9b95c32678443a55$var$TraceFormat = {}));
var $9b95c32678443a55$var$SetTraceNotification;
(function(SetTraceNotification) {
    SetTraceNotification.type = new $bQGIN.NotificationType('$/setTrace');
})($9b95c32678443a55$var$SetTraceNotification || (module.exports.SetTraceNotification = $9b95c32678443a55$var$SetTraceNotification = {}));
var $9b95c32678443a55$var$LogTraceNotification;
(function(LogTraceNotification) {
    LogTraceNotification.type = new $bQGIN.NotificationType('$/logTrace');
})($9b95c32678443a55$var$LogTraceNotification || (module.exports.LogTraceNotification = $9b95c32678443a55$var$LogTraceNotification = {}));
var $9b95c32678443a55$var$ConnectionErrors;
(function(ConnectionErrors) {
    /**
     * The connection is closed.
     */ ConnectionErrors[ConnectionErrors["Closed"] = 1] = "Closed";
    /**
     * The connection got disposed.
     */ ConnectionErrors[ConnectionErrors["Disposed"] = 2] = "Disposed";
    /**
     * The connection is already in listening mode.
     */ ConnectionErrors[ConnectionErrors["AlreadyListening"] = 3] = "AlreadyListening";
})($9b95c32678443a55$var$ConnectionErrors || (module.exports.ConnectionErrors = $9b95c32678443a55$var$ConnectionErrors = {}));
class $9b95c32678443a55$var$ConnectionError extends Error {
    code;
    constructor(code, message){
        super(message);
        this.code = code;
        Object.setPrototypeOf(this, $9b95c32678443a55$var$ConnectionError.prototype);
    }
}
module.exports.ConnectionError = $9b95c32678443a55$var$ConnectionError;
var $9b95c32678443a55$var$ConnectionStrategy;
(function(ConnectionStrategy) {
    function is(value) {
        const candidate = value;
        return candidate && $9b95c32678443a55$var$Is.func(candidate.cancelUndispatched);
    }
    ConnectionStrategy.is = is;
})($9b95c32678443a55$var$ConnectionStrategy || (module.exports.ConnectionStrategy = $9b95c32678443a55$var$ConnectionStrategy = {}));
var $9b95c32678443a55$var$IdCancellationReceiverStrategy;
(function(IdCancellationReceiverStrategy) {
    function is(value) {
        const candidate = value;
        return candidate && (candidate.kind === undefined || candidate.kind === 'id') && $9b95c32678443a55$var$Is.func(candidate.createCancellationTokenSource) && (candidate.dispose === undefined || $9b95c32678443a55$var$Is.func(candidate.dispose));
    }
    IdCancellationReceiverStrategy.is = is;
})($9b95c32678443a55$var$IdCancellationReceiverStrategy || (module.exports.IdCancellationReceiverStrategy = $9b95c32678443a55$var$IdCancellationReceiverStrategy = {}));
var $9b95c32678443a55$var$RequestCancellationReceiverStrategy;
(function(RequestCancellationReceiverStrategy) {
    function is(value) {
        const candidate = value;
        return candidate && candidate.kind === 'request' && $9b95c32678443a55$var$Is.func(candidate.createCancellationTokenSource) && (candidate.dispose === undefined || $9b95c32678443a55$var$Is.func(candidate.dispose));
    }
    RequestCancellationReceiverStrategy.is = is;
})($9b95c32678443a55$var$RequestCancellationReceiverStrategy || (module.exports.RequestCancellationReceiverStrategy = $9b95c32678443a55$var$RequestCancellationReceiverStrategy = {}));
var $9b95c32678443a55$var$CancellationReceiverStrategy;
(function(CancellationReceiverStrategy) {
    CancellationReceiverStrategy.Message = Object.freeze({
        createCancellationTokenSource (_) {
            return new $1NuV6.CancellationTokenSource();
        }
    });
    function is(value) {
        return $9b95c32678443a55$var$IdCancellationReceiverStrategy.is(value) || $9b95c32678443a55$var$RequestCancellationReceiverStrategy.is(value);
    }
    CancellationReceiverStrategy.is = is;
})($9b95c32678443a55$var$CancellationReceiverStrategy || (module.exports.CancellationReceiverStrategy = $9b95c32678443a55$var$CancellationReceiverStrategy = {}));
var $9b95c32678443a55$var$CancellationSenderStrategy;
(function(CancellationSenderStrategy) {
    CancellationSenderStrategy.Message = Object.freeze({
        sendCancellation (conn, id) {
            return conn.sendNotification($9b95c32678443a55$var$CancelNotification.type, {
                id: id
            });
        },
        cleanup (_) {}
    });
    function is(value) {
        const candidate = value;
        return candidate && $9b95c32678443a55$var$Is.func(candidate.sendCancellation) && $9b95c32678443a55$var$Is.func(candidate.cleanup);
    }
    CancellationSenderStrategy.is = is;
})($9b95c32678443a55$var$CancellationSenderStrategy || (module.exports.CancellationSenderStrategy = $9b95c32678443a55$var$CancellationSenderStrategy = {}));
var $9b95c32678443a55$var$CancellationStrategy;
(function(CancellationStrategy) {
    CancellationStrategy.Message = Object.freeze({
        receiver: $9b95c32678443a55$var$CancellationReceiverStrategy.Message,
        sender: $9b95c32678443a55$var$CancellationSenderStrategy.Message
    });
    function is(value) {
        const candidate = value;
        return candidate && $9b95c32678443a55$var$CancellationReceiverStrategy.is(candidate.receiver) && $9b95c32678443a55$var$CancellationSenderStrategy.is(candidate.sender);
    }
    CancellationStrategy.is = is;
})($9b95c32678443a55$var$CancellationStrategy || (module.exports.CancellationStrategy = $9b95c32678443a55$var$CancellationStrategy = {}));
var $9b95c32678443a55$var$MessageStrategy;
(function(MessageStrategy) {
    function is(value) {
        const candidate = value;
        return candidate && $9b95c32678443a55$var$Is.func(candidate.handleMessage);
    }
    MessageStrategy.is = is;
})($9b95c32678443a55$var$MessageStrategy || (module.exports.MessageStrategy = $9b95c32678443a55$var$MessageStrategy = {}));
var $9b95c32678443a55$var$ConnectionOptions;
(function(ConnectionOptions) {
    function is(value) {
        const candidate = value;
        return candidate && ($9b95c32678443a55$var$CancellationStrategy.is(candidate.cancellationStrategy) || $9b95c32678443a55$var$ConnectionStrategy.is(candidate.connectionStrategy) || $9b95c32678443a55$var$MessageStrategy.is(candidate.messageStrategy) || $9b95c32678443a55$var$Is.number(candidate.maxParallelism));
    }
    ConnectionOptions.is = is;
})($9b95c32678443a55$var$ConnectionOptions || (module.exports.ConnectionOptions = $9b95c32678443a55$var$ConnectionOptions = {}));
var $9b95c32678443a55$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["New"] = 1] = "New";
    ConnectionState[ConnectionState["Listening"] = 2] = "Listening";
    ConnectionState[ConnectionState["Closed"] = 3] = "Closed";
    ConnectionState[ConnectionState["Disposed"] = 4] = "Disposed";
})($9b95c32678443a55$var$ConnectionState || ($9b95c32678443a55$var$ConnectionState = {}));
function $9b95c32678443a55$var$createMessageConnection(messageReader, messageWriter, _logger, options) {
    const logger = _logger !== undefined ? _logger : module.exports.NullLogger;
    let sequenceNumber = 0;
    let notificationSequenceNumber = 0;
    let unknownResponseSequenceNumber = 0;
    const version = '2.0';
    const maxParallelism = options?.maxParallelism ?? -1;
    let inFlight = 0;
    let starRequestHandler = undefined;
    const requestHandlers = new Map();
    let starNotificationHandler = undefined;
    const notificationHandlers = new Map();
    const progressHandlers = new Map();
    let timer;
    let messageQueue = new $jrRKt.LinkedMap();
    let responsePromises = new Map();
    let knownCanceledRequests = new Set();
    let requestTokens = new Map();
    let trace = $9b95c32678443a55$var$Trace.Off;
    let traceFormat = $9b95c32678443a55$var$TraceFormat.Text;
    let tracer;
    let state = $9b95c32678443a55$var$ConnectionState.New;
    const errorEmitter = new $8Not3.Emitter();
    const closeEmitter = new $8Not3.Emitter();
    const unhandledNotificationEmitter = new $8Not3.Emitter();
    const unhandledProgressEmitter = new $8Not3.Emitter();
    const disposeEmitter = new $8Not3.Emitter();
    const cancellationStrategy = options && options.cancellationStrategy ? options.cancellationStrategy : $9b95c32678443a55$var$CancellationStrategy.Message;
    function cancelUndispatched(_message) {
        return undefined;
    }
    function isListening() {
        return state === $9b95c32678443a55$var$ConnectionState.Listening;
    }
    function isClosed() {
        return state === $9b95c32678443a55$var$ConnectionState.Closed;
    }
    function isDisposed() {
        return state === $9b95c32678443a55$var$ConnectionState.Disposed;
    }
    function closeHandler() {
        if (state === $9b95c32678443a55$var$ConnectionState.New || state === $9b95c32678443a55$var$ConnectionState.Listening) {
            state = $9b95c32678443a55$var$ConnectionState.Closed;
            closeEmitter.fire(undefined);
        }
    // If the connection is disposed don't sent close events.
    }
    function readErrorHandler(error) {
        errorEmitter.fire([
            error,
            undefined,
            undefined
        ]);
    }
    function writeErrorHandler(data) {
        errorEmitter.fire(data);
    }
    messageReader.onClose(closeHandler);
    messageReader.onError(readErrorHandler);
    messageWriter.onClose(closeHandler);
    messageWriter.onError(writeErrorHandler);
    function createRequestQueueKey(id) {
        if (id === null) throw new Error(`Can't send requests with id null since the response can't be correlated.`);
        return 'req-' + id.toString();
    }
    function createResponseQueueKey(id) {
        if (id === null) return 'res-unknown-' + (++unknownResponseSequenceNumber).toString();
        else return 'res-' + id.toString();
    }
    function createNotificationQueueKey() {
        return 'not-' + (++notificationSequenceNumber).toString();
    }
    function addMessageToQueue(queue, message) {
        if ($bQGIN.Message.isRequest(message)) queue.set(createRequestQueueKey(message.id), message);
        else if ($bQGIN.Message.isResponse(message)) {
            // If we have unlimited parallelism we queue the response to keep
            // the previous semantics.
            if (maxParallelism === -1) queue.set(createResponseQueueKey(message.id), message);
            else // If we have limited parallelism we resolve responses to avoid
            // dead locks.
            handleResponse(message);
        } else queue.set(createNotificationQueueKey(), message);
    }
    function triggerMessageQueue() {
        if (timer || messageQueue.size === 0) return;
        if (maxParallelism !== -1 && inFlight >= maxParallelism) return;
        timer = (0, $9b95c32678443a55$var$ral_1.default)().timer.setImmediate(async ()=>{
            timer = undefined;
            if (messageQueue.size === 0) return;
            if (maxParallelism !== -1 && inFlight >= maxParallelism) return;
            const message = messageQueue.shift();
            let result;
            try {
                inFlight++;
                const messageStrategy = options?.messageStrategy;
                if ($9b95c32678443a55$var$MessageStrategy.is(messageStrategy)) result = messageStrategy.handleMessage(message, handleMessage);
                else result = handleMessage(message);
            } catch (error) {
                logger.error(`Processing message queue failed: ${error.toString()}`);
            } finally{
                if (result instanceof Promise) result.then(()=>{
                    inFlight--;
                    triggerMessageQueue();
                }).catch((error)=>{
                    logger.error(`Processing message queue failed: ${error.toString()}`);
                });
                else inFlight--;
                triggerMessageQueue();
            }
        });
    }
    async function handleMessage(message) {
        if ($bQGIN.Message.isRequest(message)) return handleRequest(message);
        else if ($bQGIN.Message.isNotification(message)) return handleNotification(message);
        else if ($bQGIN.Message.isResponse(message)) return handleResponse(message);
        else return handleInvalidMessage(message);
    }
    const callback = (message)=>{
        try {
            // We have received a cancellation message. Check if the message is still in the queue
            // and cancel it if allowed to do so.
            if ($bQGIN.Message.isNotification(message) && message.method === $9b95c32678443a55$var$CancelNotification.type.method) {
                const cancelId = message.params.id;
                const key = createRequestQueueKey(cancelId);
                const toCancel = messageQueue.get(key);
                if ($bQGIN.Message.isRequest(toCancel)) {
                    const strategy = options?.connectionStrategy;
                    const response = strategy && strategy.cancelUndispatched ? strategy.cancelUndispatched(toCancel, cancelUndispatched) : cancelUndispatched(toCancel);
                    if (response && (response.error !== undefined || response.result !== undefined)) {
                        messageQueue.delete(key);
                        requestTokens.delete(cancelId);
                        response.id = toCancel.id;
                        traceSendingResponse(response, message.method, Date.now());
                        messageWriter.write(response).catch(()=>logger.error(`Sending response for canceled message failed.`));
                        return;
                    }
                }
                const cancellationToken = requestTokens.get(cancelId);
                // The request is already running. Cancel the token
                if (cancellationToken !== undefined) {
                    cancellationToken.cancel();
                    traceReceivedNotification(message);
                    return;
                } else // Remember the cancel but still queue the message to
                // clean up state in process message.
                knownCanceledRequests.add(cancelId);
            }
            addMessageToQueue(messageQueue, message);
        } finally{
            triggerMessageQueue();
        }
    };
    async function handleRequest(requestMessage) {
        if (isDisposed()) // we return here silently since we fired an event when the
        // connection got disposed.
        return Promise.resolve();
        function reply(resultOrError, method, startTime) {
            const message = {
                jsonrpc: version,
                id: requestMessage.id
            };
            if (resultOrError instanceof $bQGIN.ResponseError) message.error = resultOrError.toJson();
            else message.result = resultOrError === undefined ? null : resultOrError;
            traceSendingResponse(message, method, startTime);
            return messageWriter.write(message);
        }
        function replyError(error, method, startTime) {
            const message = {
                jsonrpc: version,
                id: requestMessage.id,
                error: error.toJson()
            };
            traceSendingResponse(message, method, startTime);
            return messageWriter.write(message);
        }
        traceReceivedRequest(requestMessage);
        const element = requestHandlers.get(requestMessage.method);
        let type;
        let requestHandler;
        if (element) {
            type = element.type;
            requestHandler = element.handler;
        }
        const startTime = Date.now();
        if (requestHandler || starRequestHandler) {
            const tokenKey = requestMessage.id ?? String(Date.now()); //
            const cancellationSource = $9b95c32678443a55$var$IdCancellationReceiverStrategy.is(cancellationStrategy.receiver) ? cancellationStrategy.receiver.createCancellationTokenSource(tokenKey) : cancellationStrategy.receiver.createCancellationTokenSource(requestMessage);
            if (requestMessage.id !== null && knownCanceledRequests.has(requestMessage.id)) cancellationSource.cancel();
            if (requestMessage.id !== null) requestTokens.set(tokenKey, cancellationSource);
            try {
                let handlerResult;
                if (requestHandler) {
                    if (requestMessage.params === undefined) {
                        if (type !== undefined && type.numberOfParams !== 0) return replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines ${type.numberOfParams} params but received none.`), requestMessage.method, startTime);
                        handlerResult = requestHandler(cancellationSource.token);
                    } else if (Array.isArray(requestMessage.params)) {
                        if (type !== undefined && type.parameterStructures === $bQGIN.ParameterStructures.byName) return replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by name but received parameters by position`), requestMessage.method, startTime);
                        handlerResult = requestHandler(...requestMessage.params, cancellationSource.token);
                    } else {
                        if (type !== undefined && type.parameterStructures === $bQGIN.ParameterStructures.byPosition) return replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by position but received parameters by name`), requestMessage.method, startTime);
                        handlerResult = requestHandler(requestMessage.params, cancellationSource.token);
                    }
                } else if (starRequestHandler) handlerResult = starRequestHandler(requestMessage.method, requestMessage.params, cancellationSource.token);
                const resultOrError = await handlerResult;
                await reply(resultOrError, requestMessage.method, startTime);
            } catch (error) {
                if (error instanceof $bQGIN.ResponseError) await reply(error, requestMessage.method, startTime);
                else if (error && $9b95c32678443a55$var$Is.string(error.message)) await replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime);
                else await replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime);
            } finally{
                requestTokens.delete(tokenKey);
            }
        } else await replyError(new $bQGIN.ResponseError($bQGIN.ErrorCodes.MethodNotFound, `Unhandled method ${requestMessage.method}`), requestMessage.method, startTime);
    }
    function handleResponse(responseMessage) {
        if (isDisposed()) // See handle request.
        return;
        if (responseMessage.id === null) {
            if (responseMessage.error) logger.error(`Received response message without id: Error is: \n${JSON.stringify(responseMessage.error, undefined, 4)}`);
            else logger.error(`Received response message without id. No further error information provided.`);
        } else {
            const key = responseMessage.id;
            const responsePromise = responsePromises.get(key);
            traceReceivedResponse(responseMessage, responsePromise);
            if (responsePromise !== undefined) {
                responsePromises.delete(key);
                try {
                    if (responseMessage.error) {
                        const error = responseMessage.error;
                        responsePromise.reject(new $bQGIN.ResponseError(error.code, error.message, error.data));
                    } else if (responseMessage.result !== undefined) responsePromise.resolve(responseMessage.result);
                    else throw new Error('Should never happen.');
                } catch (error) {
                    if (error.message) logger.error(`Response handler '${responsePromise.method}' failed with message: ${error.message}`);
                    else logger.error(`Response handler '${responsePromise.method}' failed unexpectedly.`);
                }
            }
        }
    }
    async function handleNotification(message) {
        if (isDisposed()) // See handle request.
        return;
        let type = undefined;
        let notificationHandler;
        if (message.method === $9b95c32678443a55$var$CancelNotification.type.method) {
            const cancelId = message.params.id;
            knownCanceledRequests.delete(cancelId);
            traceReceivedNotification(message);
            return;
        } else {
            const element = notificationHandlers.get(message.method);
            if (element) {
                notificationHandler = element.handler;
                type = element.type;
            }
        }
        if (notificationHandler || starNotificationHandler) try {
            traceReceivedNotification(message);
            if (notificationHandler) {
                if (message.params === undefined) {
                    if (type !== undefined) {
                        if (type.numberOfParams !== 0 && type.parameterStructures !== $bQGIN.ParameterStructures.byName) logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received none.`);
                    }
                    await notificationHandler();
                } else if (Array.isArray(message.params)) {
                    // There are JSON-RPC libraries that send progress message as positional params although
                    // specified as named. So convert them if this is the case.
                    const params = message.params;
                    if (message.method === $9b95c32678443a55$var$ProgressNotification.type.method && params.length === 2 && $9b95c32678443a55$var$ProgressToken.is(params[0])) await notificationHandler({
                        token: params[0],
                        value: params[1]
                    });
                    else {
                        if (type !== undefined) {
                            if (type.parameterStructures === $bQGIN.ParameterStructures.byName) logger.error(`Notification ${message.method} defines parameters by name but received parameters by position`);
                            if (type.numberOfParams !== message.params.length) logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received ${params.length} arguments`);
                        }
                        await notificationHandler(...params);
                    }
                } else {
                    if (type !== undefined && type.parameterStructures === $bQGIN.ParameterStructures.byPosition) logger.error(`Notification ${message.method} defines parameters by position but received parameters by name`);
                    await notificationHandler(message.params);
                }
            } else if (starNotificationHandler) await starNotificationHandler(message.method, message.params);
        } catch (error) {
            if (error.message) logger.error(`Notification handler '${message.method}' failed with message: ${error.message}`);
            else logger.error(`Notification handler '${message.method}' failed unexpectedly.`);
        }
        else unhandledNotificationEmitter.fire(message);
    }
    function handleInvalidMessage(message) {
        if (!message) {
            logger.error('Received empty message.');
            return;
        }
        logger.error(`Received message which is neither a response nor a notification message:\n${JSON.stringify(message, null, 4)}`);
        // Test whether we find an id to reject the promise
        const responseMessage = message;
        if ($9b95c32678443a55$var$Is.string(responseMessage.id) || $9b95c32678443a55$var$Is.number(responseMessage.id)) {
            const key = responseMessage.id;
            const responseHandler = responsePromises.get(key);
            if (responseHandler) responseHandler.reject(new Error('The received response has neither a result nor an error property.'));
        }
    }
    function stringifyTrace(params) {
        if (params === undefined || params === null) return undefined;
        switch(trace){
            case $9b95c32678443a55$var$Trace.Verbose:
                return JSON.stringify(params, null, 4);
            case $9b95c32678443a55$var$Trace.Compact:
                return JSON.stringify(params);
            default:
                return undefined;
        }
    }
    function traceSendingRequest(message) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if ((trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) && message.params) data = `Params: ${stringifyTrace(message.params)}`;
            tracer.log(`Sending request '${message.method} - (${message.id})'.`, data);
        } else logLSPMessage('send-request', message);
    }
    function traceSendingNotification(message) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if (trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) {
                if (message.params) data = `Params: ${stringifyTrace(message.params)}`;
                else data = 'No parameters provided.';
            }
            tracer.log(`Sending notification '${message.method}'.`, data);
        } else logLSPMessage('send-notification', message);
    }
    function traceSendingResponse(message, method, startTime) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if (trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) {
                if (message.error && message.error.data) data = `Error data: ${stringifyTrace(message.error.data)}`;
                else {
                    if (message.result) data = `Result: ${stringifyTrace(message.result)}`;
                    else if (message.error === undefined) data = 'No result returned.';
                }
            }
            const error = message.error ? ` Request failed: ${message.error.message} (${message.error.code}).` : '';
            tracer.log(`Sending response '${method} - (${message.id})'. Processing request took ${Date.now() - startTime}ms.${error}`, data);
        } else logLSPMessage('send-response', message);
    }
    function traceReceivedRequest(message) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if ((trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) && message.params) data = `Params: ${stringifyTrace(message.params)}`;
            tracer.log(`Received request '${message.method} - (${message.id})'.`, data);
        } else logLSPMessage('receive-request', message);
    }
    function traceReceivedNotification(message) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer || message.method === $9b95c32678443a55$var$LogTraceNotification.type.method) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if (trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) {
                if (message.params) data = `Params: ${stringifyTrace(message.params)}`;
                else data = 'No parameters provided.';
            }
            tracer.log(`Received notification '${message.method}'.`, data);
        } else logLSPMessage('receive-notification', message);
    }
    function traceReceivedResponse(message, responsePromise) {
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        if (traceFormat === $9b95c32678443a55$var$TraceFormat.Text) {
            let data = undefined;
            if (trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact) {
                if (message.error && message.error.data) data = `Error data: ${stringifyTrace(message.error.data)}`;
                else {
                    if (message.result) data = `Result: ${stringifyTrace(message.result)}`;
                    else if (message.error === undefined) data = 'No result returned.';
                }
            }
            if (responsePromise) {
                const error = message.error ? ` Request failed: ${message.error.message} (${message.error.code}).` : '';
                tracer.log(`Received response '${responsePromise.method} - (${message.id})' in ${Date.now() - responsePromise.timerStart}ms.${error}`, data);
            } else tracer.log(`Received response ${message.id} without active response promise.`, data);
        } else logLSPMessage('receive-response', message);
    }
    function logLSPMessage(type, message) {
        if (!tracer || trace === $9b95c32678443a55$var$Trace.Off) return;
        const lspMessage = {
            isLSPMessage: true,
            type: type,
            message: message,
            timestamp: Date.now()
        };
        tracer.log(lspMessage);
    }
    function throwIfClosedOrDisposed() {
        if (isClosed()) throw new $9b95c32678443a55$var$ConnectionError($9b95c32678443a55$var$ConnectionErrors.Closed, 'Connection is closed.');
        if (isDisposed()) throw new $9b95c32678443a55$var$ConnectionError($9b95c32678443a55$var$ConnectionErrors.Disposed, 'Connection is disposed.');
    }
    function throwIfListening() {
        if (isListening()) throw new $9b95c32678443a55$var$ConnectionError($9b95c32678443a55$var$ConnectionErrors.AlreadyListening, 'Connection is already listening');
    }
    function throwIfNotListening() {
        if (!isListening()) throw new Error('Call listen() first.');
    }
    function undefinedToNull(param) {
        if (param === undefined) return null;
        else return param;
    }
    function nullToUndefined(param) {
        if (param === null) return undefined;
        else return param;
    }
    function isNamedParam(param) {
        return param !== undefined && param !== null && !Array.isArray(param) && typeof param === 'object';
    }
    function computeSingleParam(parameterStructures, param) {
        switch(parameterStructures){
            case $bQGIN.ParameterStructures.auto:
                if (isNamedParam(param)) return nullToUndefined(param);
                else return [
                    undefinedToNull(param)
                ];
            case $bQGIN.ParameterStructures.byName:
                if (!isNamedParam(param)) throw new Error(`Received parameters by name but param is not an object literal.`);
                return nullToUndefined(param);
            case $bQGIN.ParameterStructures.byPosition:
                return [
                    undefinedToNull(param)
                ];
            default:
                throw new Error(`Unknown parameter structure ${parameterStructures.toString()}`);
        }
    }
    function computeMessageParams(type, params) {
        let result;
        const numberOfParams = type.numberOfParams;
        switch(numberOfParams){
            case 0:
                result = undefined;
                break;
            case 1:
                result = computeSingleParam(type.parameterStructures, params[0]);
                break;
            default:
                result = [];
                for(let i = 0; i < params.length && i < numberOfParams; i++)result.push(undefinedToNull(params[i]));
                if (params.length < numberOfParams) for(let i = params.length; i < numberOfParams; i++)result.push(null);
                break;
        }
        return result;
    }
    const connection = {
        sendNotification: (type, ...args)=>{
            throwIfClosedOrDisposed();
            let method;
            let messageParams;
            if ($9b95c32678443a55$var$Is.string(type)) {
                method = type;
                const first = args[0];
                let paramStart = 0;
                let parameterStructures = $bQGIN.ParameterStructures.auto;
                if ($bQGIN.ParameterStructures.is(first)) {
                    paramStart = 1;
                    parameterStructures = first;
                }
                const paramEnd = args.length;
                const numberOfParams = paramEnd - paramStart;
                switch(numberOfParams){
                    case 0:
                        messageParams = undefined;
                        break;
                    case 1:
                        messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                        break;
                    default:
                        if (parameterStructures === $bQGIN.ParameterStructures.byName) throw new Error(`Received ${numberOfParams} parameters for 'by Name' notification parameter structure.`);
                        messageParams = args.slice(paramStart, paramEnd).map((value)=>undefinedToNull(value));
                        break;
                }
            } else {
                const params = args;
                method = type.method;
                messageParams = computeMessageParams(type, params);
            }
            const notificationMessage = {
                jsonrpc: version,
                method: method,
                params: messageParams
            };
            traceSendingNotification(notificationMessage);
            return messageWriter.write(notificationMessage).catch((error)=>{
                logger.error(`Sending notification failed.`);
                throw error;
            });
        },
        onNotification: (type, handler)=>{
            throwIfClosedOrDisposed();
            let method;
            if ($9b95c32678443a55$var$Is.func(type)) starNotificationHandler = type;
            else if (handler) {
                if ($9b95c32678443a55$var$Is.string(type)) {
                    method = type;
                    notificationHandlers.set(type, {
                        type: undefined,
                        handler: handler
                    });
                } else {
                    method = type.method;
                    notificationHandlers.set(type.method, {
                        type: type,
                        handler: handler
                    });
                }
            }
            return {
                dispose: ()=>{
                    if (method !== undefined) {
                        if (notificationHandlers.get(method)?.handler === handler) notificationHandlers.delete(method);
                    } else if (starNotificationHandler === type) starNotificationHandler = undefined;
                }
            };
        },
        onProgress: (_type, token, handler)=>{
            if (progressHandlers.has(token)) throw new Error(`Progress handler for token ${token} already registered`);
            progressHandlers.set(token, handler);
            return {
                dispose: ()=>{
                    if (progressHandlers.get(token) === handler) progressHandlers.delete(token);
                }
            };
        },
        sendProgress: (_type, token, value)=>{
            // This should not await but simple return to ensure that we don't have another
            // async scheduling. Otherwise one send could overtake another send.
            return connection.sendNotification($9b95c32678443a55$var$ProgressNotification.type, {
                token: token,
                value: value
            });
        },
        onUnhandledProgress: unhandledProgressEmitter.event,
        sendRequest: (type, ...args)=>{
            throwIfClosedOrDisposed();
            throwIfNotListening();
            function sendCancellation(connection, id) {
                const p = cancellationStrategy.sender.sendCancellation(connection, id);
                if (p === undefined) logger.log(`Received no promise from cancellation strategy when cancelling id ${id}`);
                else p.catch(()=>{
                    logger.log(`Sending cancellation messages for id ${id} failed.`);
                });
            }
            let method;
            let messageParams;
            let token = undefined;
            if ($9b95c32678443a55$var$Is.string(type)) {
                method = type;
                const first = args[0];
                const last = args[args.length - 1];
                let paramStart = 0;
                let parameterStructures = $bQGIN.ParameterStructures.auto;
                if ($bQGIN.ParameterStructures.is(first)) {
                    paramStart = 1;
                    parameterStructures = first;
                }
                let paramEnd = args.length;
                if ($1NuV6.CancellationToken.is(last)) {
                    paramEnd = paramEnd - 1;
                    token = last;
                }
                const numberOfParams = paramEnd - paramStart;
                switch(numberOfParams){
                    case 0:
                        messageParams = undefined;
                        break;
                    case 1:
                        messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                        break;
                    default:
                        if (parameterStructures === $bQGIN.ParameterStructures.byName) throw new Error(`Received ${numberOfParams} parameters for 'by Name' request parameter structure.`);
                        messageParams = args.slice(paramStart, paramEnd).map((value)=>undefinedToNull(value));
                        break;
                }
            } else {
                const params = args;
                method = type.method;
                messageParams = computeMessageParams(type, params);
                const numberOfParams = type.numberOfParams;
                token = $1NuV6.CancellationToken.is(params[numberOfParams]) ? params[numberOfParams] : undefined;
            }
            const id = sequenceNumber++;
            let disposable;
            let tokenWasCancelled = false;
            if (token !== undefined) {
                if (token.isCancellationRequested) tokenWasCancelled = true;
                else disposable = token.onCancellationRequested(()=>{
                    sendCancellation(connection, id);
                });
            }
            const requestMessage = {
                jsonrpc: version,
                id: id,
                method: method,
                params: messageParams
            };
            traceSendingRequest(requestMessage);
            if (typeof cancellationStrategy.sender.enableCancellation === 'function') cancellationStrategy.sender.enableCancellation(requestMessage);
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject)=>{
                const resolveWithCleanup = (r)=>{
                    resolve(r);
                    cancellationStrategy.sender.cleanup(id);
                    disposable?.dispose();
                };
                const rejectWithCleanup = (r)=>{
                    reject(r);
                    cancellationStrategy.sender.cleanup(id);
                    disposable?.dispose();
                };
                const responsePromise = {
                    method: method,
                    timerStart: Date.now(),
                    resolve: resolveWithCleanup,
                    reject: rejectWithCleanup
                };
                try {
                    responsePromises.set(id, responsePromise);
                    await messageWriter.write(requestMessage);
                    if (tokenWasCancelled) sendCancellation(connection, id);
                } catch (error) {
                    // Writing the message failed. So we need to delete it from the response promises and
                    // reject it.
                    responsePromises.delete(id);
                    responsePromise.reject(new $bQGIN.ResponseError($bQGIN.ErrorCodes.MessageWriteError, error.message ? error.message : 'Unknown reason'));
                    logger.error(`Sending request failed.`);
                }
            });
        },
        onRequest: (type, handler)=>{
            throwIfClosedOrDisposed();
            let method = null;
            if ($9b95c32678443a55$var$StarRequestHandler.is(type)) {
                method = undefined;
                starRequestHandler = type;
            } else if ($9b95c32678443a55$var$Is.string(type)) {
                method = null;
                if (handler !== undefined) {
                    method = type;
                    requestHandlers.set(type, {
                        handler: handler,
                        type: undefined
                    });
                }
            } else if (handler !== undefined) {
                method = type.method;
                requestHandlers.set(type.method, {
                    type: type,
                    handler: handler
                });
            }
            return {
                dispose: ()=>{
                    if (method === null) return;
                    if (method !== undefined) {
                        if (requestHandlers.get(method)?.handler === handler) requestHandlers.delete(method);
                    } else if (starRequestHandler === type) starRequestHandler = undefined;
                }
            };
        },
        hasPendingResponse: ()=>{
            return responsePromises.size > 0;
        },
        trace: async (_value, _tracer, sendNotificationOrTraceOptions)=>{
            let _sendNotification = false;
            let _traceFormat = $9b95c32678443a55$var$TraceFormat.Text;
            if (sendNotificationOrTraceOptions !== undefined) {
                if ($9b95c32678443a55$var$Is.boolean(sendNotificationOrTraceOptions)) _sendNotification = sendNotificationOrTraceOptions;
                else {
                    _sendNotification = sendNotificationOrTraceOptions.sendNotification || false;
                    _traceFormat = sendNotificationOrTraceOptions.traceFormat || $9b95c32678443a55$var$TraceFormat.Text;
                }
            }
            trace = _value;
            traceFormat = _traceFormat;
            if (trace === $9b95c32678443a55$var$Trace.Off) tracer = undefined;
            else tracer = _tracer;
            if (_sendNotification && !isClosed() && !isDisposed()) await connection.sendNotification($9b95c32678443a55$var$SetTraceNotification.type, {
                value: $9b95c32678443a55$var$Trace.toString(_value)
            });
        },
        onError: errorEmitter.event,
        onClose: closeEmitter.event,
        onUnhandledNotification: unhandledNotificationEmitter.event,
        onDispose: disposeEmitter.event,
        end: ()=>{
            messageWriter.end();
        },
        dispose: ()=>{
            if (isDisposed()) return;
            state = $9b95c32678443a55$var$ConnectionState.Disposed;
            disposeEmitter.fire(undefined);
            const error = new $bQGIN.ResponseError($bQGIN.ErrorCodes.PendingResponseRejected, 'Pending response rejected since connection got disposed');
            for (const promise of responsePromises.values())promise.reject(error);
            responsePromises = new Map();
            requestTokens = new Map();
            knownCanceledRequests = new Set();
            messageQueue = new $jrRKt.LinkedMap();
            // Test for backwards compatibility
            if ($9b95c32678443a55$var$Is.func(messageWriter.dispose)) messageWriter.dispose();
            if ($9b95c32678443a55$var$Is.func(messageReader.dispose)) messageReader.dispose();
        },
        listen: ()=>{
            throwIfClosedOrDisposed();
            throwIfListening();
            state = $9b95c32678443a55$var$ConnectionState.Listening;
            messageReader.listen(callback);
        },
        inspect: ()=>{
            (0, $9b95c32678443a55$var$ral_1.default)().console.log('inspect');
        }
    };
    connection.onNotification($9b95c32678443a55$var$LogTraceNotification.type, (params)=>{
        if (trace === $9b95c32678443a55$var$Trace.Off || !tracer) return;
        const verbose = trace === $9b95c32678443a55$var$Trace.Verbose || trace === $9b95c32678443a55$var$Trace.Compact;
        tracer.log(params.message, verbose ? params.verbose : undefined);
    });
    connection.onNotification($9b95c32678443a55$var$ProgressNotification.type, async (params)=>{
        const handler = progressHandlers.get(params.token);
        if (handler) await handler(params.value);
        else unhandledProgressEmitter.fire(params);
    });
    return connection;
}

});




parcelRegister("fS1k7", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $b8dcecf6ffeb8c39$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b8dcecf6ffeb8c39$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b8dcecf6ffeb8c39$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LSPErrorCodes = module.exports.createProtocolConnection = void 0;

$b8dcecf6ffeb8c39$var$__exportStar((parcelRequire("d8V62")), module.exports);

$b8dcecf6ffeb8c39$var$__exportStar((parcelRequire("bDmGd")), module.exports);

$b8dcecf6ffeb8c39$var$__exportStar((parcelRequire("3H92V")), module.exports);

$b8dcecf6ffeb8c39$var$__exportStar((parcelRequire("cbAAQ")), module.exports);

var $8dPLY = parcelRequire("8dPLY");
Object.defineProperty(module.exports, "createProtocolConnection", {
    enumerable: true,
    get: function() {
        return $8dPLY.createProtocolConnection;
    }
});
var $b8dcecf6ffeb8c39$var$LSPErrorCodes;
(function(LSPErrorCodes) {
    /**
    * This is the start range of LSP reserved error codes.
    * It doesn't denote a real error code.
    *
    * @since 3.16.0
    */ LSPErrorCodes.lspReservedErrorRangeStart = -32899;
    /**
     * A request failed but it was syntactically correct, e.g the
     * method name was known and the parameters were valid. The error
     * message should contain human readable information about why
     * the request failed.
     *
     * @since 3.17.0
     */ LSPErrorCodes.RequestFailed = -32803;
    /**
     * The server cancelled the request. This error code should
     * only be used for requests that explicitly support being
     * server cancellable.
     *
     * @since 3.17.0
     */ LSPErrorCodes.ServerCancelled = -32802;
    /**
     * The server detected that the content of a document got
     * modified outside normal conditions. A server should
     * NOT send this error code if it detects a content change
     * in it unprocessed messages. The result even computed
     * on an older state might still be useful for the client.
     *
     * If a client decides that a result is not of any use anymore
     * the client should cancel the request.
     */ LSPErrorCodes.ContentModified = -32801;
    /**
     * The client has canceled a request and a server has detected
     * the cancel.
     */ LSPErrorCodes.RequestCancelled = -32800;
    /**
    * This is the end range of LSP reserved error codes.
    * It doesn't denote a real error code.
    *
    * @since 3.16.0
    */ LSPErrorCodes.lspReservedErrorRangeEnd = -32800;
})($b8dcecf6ffeb8c39$var$LSPErrorCodes || (module.exports.LSPErrorCodes = $b8dcecf6ffeb8c39$var$LSPErrorCodes = {}));

});
parcelRegister("bDmGd", function(module, exports) {
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    /* --------------------------------------------------------------------------------------------
     * Copyright (c) Microsoft Corporation. All rights reserved.
     * Licensed under the MIT License. See License.txt in the project root for license information.
     * ------------------------------------------------------------------------------------------ */ 'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TextDocument = exports1.EOL = exports1.WorkspaceFolder = exports1.InlineCompletionContext = exports1.SelectedCompletionInfo = exports1.InlineCompletionTriggerKind = exports1.InlineCompletionList = exports1.InlineCompletionItem = exports1.StringValue = exports1.InlayHint = exports1.InlayHintLabelPart = exports1.InlayHintKind = exports1.InlineValueContext = exports1.InlineValueEvaluatableExpression = exports1.InlineValueVariableLookup = exports1.InlineValueText = exports1.SemanticTokens = exports1.SemanticTokenModifiers = exports1.SemanticTokenTypes = exports1.SelectionRange = exports1.DocumentLink = exports1.FormattingOptions = exports1.CodeLens = exports1.CodeAction = exports1.CodeActionTag = exports1.CodeActionContext = exports1.CodeActionTriggerKind = exports1.CodeActionKind = exports1.DocumentSymbol = exports1.WorkspaceSymbol = exports1.SymbolInformation = exports1.SymbolTag = exports1.SymbolKind = exports1.DocumentHighlight = exports1.DocumentHighlightKind = exports1.SignatureInformation = exports1.ParameterInformation = exports1.Hover = exports1.MarkedString = exports1.CompletionList = exports1.CompletionItem = exports1.CompletionItemLabelDetails = exports1.ApplyKind = exports1.InsertTextMode = exports1.InsertReplaceEdit = exports1.CompletionItemTag = exports1.InsertTextFormat = exports1.CompletionItemKind = exports1.MarkupContent = exports1.MarkupKind = exports1.TextDocumentItem = exports1.LanguageKind = exports1.OptionalVersionedTextDocumentIdentifier = exports1.VersionedTextDocumentIdentifier = exports1.TextDocumentIdentifier = exports1.WorkspaceChange = exports1.SnippetTextEdit = exports1.WorkspaceEdit = exports1.DeleteFile = exports1.RenameFile = exports1.CreateFile = exports1.TextDocumentEdit = exports1.AnnotatedTextEdit = exports1.ChangeAnnotationIdentifier = exports1.ChangeAnnotation = exports1.TextEdit = exports1.Command = exports1.Diagnostic = exports1.CodeDescription = exports1.DiagnosticTag = exports1.DiagnosticSeverity = exports1.DiagnosticRelatedInformation = exports1.FoldingRange = exports1.FoldingRangeKind = exports1.ColorPresentation = exports1.ColorInformation = exports1.Color = exports1.LocationLink = exports1.Location = exports1.Range = exports1.Position = exports1.uinteger = exports1.integer = exports1.URI = exports1.DocumentUri = void 0;
    var DocumentUri;
    (function(DocumentUri) {
        function is(value) {
            return typeof value === 'string';
        }
        DocumentUri.is = is;
    })(DocumentUri || (exports1.DocumentUri = DocumentUri = {}));
    var URI;
    (function(URI) {
        function is(value) {
            return typeof value === 'string';
        }
        URI.is = is;
    })(URI || (exports1.URI = URI = {}));
    var integer;
    (function(integer) {
        integer.MIN_VALUE = -2147483648;
        integer.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === 'number' && integer.MIN_VALUE <= value && value <= integer.MAX_VALUE;
        }
        integer.is = is;
    })(integer || (exports1.integer = integer = {}));
    var uinteger;
    (function(uinteger) {
        uinteger.MIN_VALUE = 0;
        uinteger.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === 'number' && uinteger.MIN_VALUE <= value && value <= uinteger.MAX_VALUE;
        }
        uinteger.is = is;
    })(uinteger || (exports1.uinteger = uinteger = {}));
    /**
     * The Position namespace provides helper functions to work with
     * {@link Position} literals.
     */ var Position;
    (function(Position) {
        /**
         * Creates a new Position literal from the given line and character.
         * @param line The position's line.
         * @param character The position's character.
         */ function create(line, character) {
            if (line === Number.MAX_VALUE) line = uinteger.MAX_VALUE;
            if (character === Number.MAX_VALUE) character = uinteger.MAX_VALUE;
            return {
                line: line,
                character: character
            };
        }
        Position.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Position} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.line) && Is.uinteger(candidate.character);
        }
        Position.is = is;
    })(Position || (exports1.Position = Position = {}));
    /**
     * The Range namespace provides helper functions to work with
     * {@link Range} literals.
     */ var Range;
    (function(Range) {
        function create(one, two, three, four) {
            if (Is.uinteger(one) && Is.uinteger(two) && Is.uinteger(three) && Is.uinteger(four)) return {
                start: Position.create(one, two),
                end: Position.create(three, four)
            };
            else if (Position.is(one) && Position.is(two)) return {
                start: one,
                end: two
            };
            else throw new Error("Range#create called with invalid arguments[".concat(one, ", ").concat(two, ", ").concat(three, ", ").concat(four, "]"));
        }
        Range.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Range} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.start) && Position.is(candidate.end);
        }
        Range.is = is;
    })(Range || (exports1.Range = Range = {}));
    /**
     * The Location namespace provides helper functions to work with
     * {@link Location} literals.
     */ var Location;
    (function(Location) {
        /**
         * Creates a Location literal.
         * @param uri The location's uri.
         * @param range The location's range.
         */ function create(uri, range) {
            return {
                uri: uri,
                range: range
            };
        }
        Location.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Location} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (Is.string(candidate.uri) || Is.undefined(candidate.uri));
        }
        Location.is = is;
    })(Location || (exports1.Location = Location = {}));
    /**
     * The LocationLink namespace provides helper functions to work with
     * {@link LocationLink} literals.
     */ var LocationLink;
    (function(LocationLink) {
        /**
         * Creates a LocationLink literal.
         * @param targetUri The definition's uri.
         * @param targetRange The full range of the definition.
         * @param targetSelectionRange The span of the symbol definition at the target.
         * @param originSelectionRange The span of the symbol being defined in the originating source file.
         */ function create(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
            return {
                targetUri: targetUri,
                targetRange: targetRange,
                targetSelectionRange: targetSelectionRange,
                originSelectionRange: originSelectionRange
            };
        }
        LocationLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link LocationLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.targetRange) && Is.string(candidate.targetUri) && Range.is(candidate.targetSelectionRange) && (Range.is(candidate.originSelectionRange) || Is.undefined(candidate.originSelectionRange));
        }
        LocationLink.is = is;
    })(LocationLink || (exports1.LocationLink = LocationLink = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link Color} literals.
     */ var Color;
    (function(Color) {
        /**
         * Creates a new Color literal.
         */ function create(red, green, blue, alpha) {
            return {
                red: red,
                green: green,
                blue: blue,
                alpha: alpha
            };
        }
        Color.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Color} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.numberRange(candidate.red, 0, 1) && Is.numberRange(candidate.green, 0, 1) && Is.numberRange(candidate.blue, 0, 1) && Is.numberRange(candidate.alpha, 0, 1);
        }
        Color.is = is;
    })(Color || (exports1.Color = Color = {}));
    /**
     * The ColorInformation namespace provides helper functions to work with
     * {@link ColorInformation} literals.
     */ var ColorInformation;
    (function(ColorInformation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(range, color) {
            return {
                range: range,
                color: color
            };
        }
        ColorInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && Color.is(candidate.color);
        }
        ColorInformation.is = is;
    })(ColorInformation || (exports1.ColorInformation = ColorInformation = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link ColorPresentation} literals.
     */ var ColorPresentation;
    (function(ColorPresentation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(label, textEdit, additionalTextEdits) {
            return {
                label: label,
                textEdit: textEdit,
                additionalTextEdits: additionalTextEdits
            };
        }
        ColorPresentation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.undefined(candidate.textEdit) || TextEdit.is(candidate)) && (Is.undefined(candidate.additionalTextEdits) || Is.typedArray(candidate.additionalTextEdits, TextEdit.is));
        }
        ColorPresentation.is = is;
    })(ColorPresentation || (exports1.ColorPresentation = ColorPresentation = {}));
    /**
     * A set of predefined range kinds.
     */ var FoldingRangeKind;
    (function(FoldingRangeKind) {
        /**
         * Folding range for a comment
         */ FoldingRangeKind.Comment = 'comment';
        /**
         * Folding range for an import or include
         */ FoldingRangeKind.Imports = 'imports';
        /**
         * Folding range for a region (e.g. `#region`)
         */ FoldingRangeKind.Region = 'region';
    })(FoldingRangeKind || (exports1.FoldingRangeKind = FoldingRangeKind = {}));
    /**
     * The folding range namespace provides helper functions to work with
     * {@link FoldingRange} literals.
     */ var FoldingRange;
    (function(FoldingRange) {
        /**
         * Creates a new FoldingRange literal.
         */ function create(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
            var result = {
                startLine: startLine,
                endLine: endLine
            };
            if (Is.defined(startCharacter)) result.startCharacter = startCharacter;
            if (Is.defined(endCharacter)) result.endCharacter = endCharacter;
            if (Is.defined(kind)) result.kind = kind;
            if (Is.defined(collapsedText)) result.collapsedText = collapsedText;
            return result;
        }
        FoldingRange.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FoldingRange} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.startLine) && Is.uinteger(candidate.startLine) && (Is.undefined(candidate.startCharacter) || Is.uinteger(candidate.startCharacter)) && (Is.undefined(candidate.endCharacter) || Is.uinteger(candidate.endCharacter)) && (Is.undefined(candidate.kind) || Is.string(candidate.kind));
        }
        FoldingRange.is = is;
    })(FoldingRange || (exports1.FoldingRange = FoldingRange = {}));
    /**
     * The DiagnosticRelatedInformation namespace provides helper functions to work with
     * {@link DiagnosticRelatedInformation} literals.
     */ var DiagnosticRelatedInformation;
    (function(DiagnosticRelatedInformation) {
        /**
         * Creates a new DiagnosticRelatedInformation literal.
         */ function create(location, message) {
            return {
                location: location,
                message: message
            };
        }
        DiagnosticRelatedInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DiagnosticRelatedInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Location.is(candidate.location) && Is.string(candidate.message);
        }
        DiagnosticRelatedInformation.is = is;
    })(DiagnosticRelatedInformation || (exports1.DiagnosticRelatedInformation = DiagnosticRelatedInformation = {}));
    /**
     * The diagnostic's severity.
     */ var DiagnosticSeverity;
    (function(DiagnosticSeverity) {
        /**
         * Reports an error.
         */ DiagnosticSeverity.Error = 1;
        /**
         * Reports a warning.
         */ DiagnosticSeverity.Warning = 2;
        /**
         * Reports an information.
         */ DiagnosticSeverity.Information = 3;
        /**
         * Reports a hint.
         */ DiagnosticSeverity.Hint = 4;
    })(DiagnosticSeverity || (exports1.DiagnosticSeverity = DiagnosticSeverity = {}));
    /**
     * The diagnostic tags.
     *
     * @since 3.15.0
     */ var DiagnosticTag;
    (function(DiagnosticTag) {
        /**
         * Unused or unnecessary code.
         *
         * Clients are allowed to render diagnostics with this tag faded out instead of having
         * an error squiggle.
         */ DiagnosticTag.Unnecessary = 1;
        /**
         * Deprecated or obsolete code.
         *
         * Clients are allowed to rendered diagnostics with this tag strike through.
         */ DiagnosticTag.Deprecated = 2;
    })(DiagnosticTag || (exports1.DiagnosticTag = DiagnosticTag = {}));
    /**
     * The CodeDescription namespace provides functions to deal with descriptions for diagnostic codes.
     *
     * @since 3.16.0
     */ var CodeDescription;
    (function(CodeDescription) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.href);
        }
        CodeDescription.is = is;
    })(CodeDescription || (exports1.CodeDescription = CodeDescription = {}));
    /**
     * The Diagnostic namespace provides helper functions to work with
     * {@link Diagnostic} literals.
     */ var Diagnostic;
    (function(Diagnostic) {
        /**
         * Creates a new Diagnostic literal.
         */ function create(range, message, severity, code, source, relatedInformation) {
            var result = {
                range: range,
                message: message
            };
            if (Is.defined(severity)) result.severity = severity;
            if (Is.defined(code)) result.code = code;
            if (Is.defined(source)) result.source = source;
            if (Is.defined(relatedInformation)) result.relatedInformation = relatedInformation;
            return result;
        }
        Diagnostic.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Diagnostic} interface.
         */ function is(value) {
            var _a;
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.string(candidate.message) || MarkupContent.is(candidate.message)) && (Is.number(candidate.severity) || Is.undefined(candidate.severity)) && (Is.integer(candidate.code) || Is.string(candidate.code) || Is.undefined(candidate.code)) && (Is.undefined(candidate.codeDescription) || Is.string((_a = candidate.codeDescription) === null || _a === void 0 ? void 0 : _a.href)) && (Is.string(candidate.source) || Is.undefined(candidate.source)) && (Is.undefined(candidate.relatedInformation) || Is.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation.is));
        }
        Diagnostic.is = is;
        /**
         * Checks whether the given diagnostic's message conforms to the 3.17.0
         * version of the protocol where the message is a string.
         *
         * @param value the diagnostic
         * @returns true if the diagnostic's message is a string, false otherwise.
         */ function is3_17(value) {
            return Is.string(value.message);
        }
        Diagnostic.is3_17 = is3_17;
        /**
         * Gets the message string of a diagnostic. If the message is already a
         * string, it is returned as is. If the message is a MarkupContent,
         * the value of the MarkupContent is returned. Otherwise an error is thrown.
         *
         * @param diagnostic the diagnostic to get the message string from.
         * @returns the message string of the given diagnostic.
         */ function getMessageString(diagnostic) {
            if (Is.string(diagnostic.message)) return diagnostic.message;
            else if (MarkupContent.is(diagnostic.message)) return diagnostic.message.value;
            else throw new Error("Unknown message type ".concat(typeof diagnostic.message));
        }
        Diagnostic.getMessageString = getMessageString;
    })(Diagnostic || (exports1.Diagnostic = Diagnostic = {}));
    /**
     * The Command namespace provides helper functions to work with
     * {@link Command} literals.
     */ var Command;
    (function(Command) {
        /**
         * Creates a new Command literal.
         */ function create(title, command) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var result = {
                title: title,
                command: command
            };
            if (Is.defined(args) && args.length > 0) result.arguments = args;
            return result;
        }
        Command.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Command} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.title) && (candidate.tooltip === undefined || Is.string(candidate.tooltip)) && Is.string(candidate.command);
        }
        Command.is = is;
    })(Command || (exports1.Command = Command = {}));
    /**
     * The TextEdit namespace provides helper function to create replace,
     * insert and delete edits more easily.
     */ var TextEdit;
    (function(TextEdit) {
        /**
         * Creates a replace text edit.
         * @param range The range of text to be replaced.
         * @param newText The new text.
         */ function replace(range, newText) {
            return {
                range: range,
                newText: newText
            };
        }
        TextEdit.replace = replace;
        /**
         * Creates an insert text edit.
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         */ function insert(position, newText) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText
            };
        }
        TextEdit.insert = insert;
        /**
         * Creates a delete text edit.
         * @param range The range of text to be deleted.
         */ function del(range) {
            return {
                range: range,
                newText: ''
            };
        }
        TextEdit.del = del;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.newText) && Range.is(candidate.range);
        }
        TextEdit.is = is;
    })(TextEdit || (exports1.TextEdit = TextEdit = {}));
    var ChangeAnnotation;
    (function(ChangeAnnotation) {
        function create(label, needsConfirmation, description) {
            var result = {
                label: label
            };
            if (needsConfirmation !== undefined) result.needsConfirmation = needsConfirmation;
            if (description !== undefined) result.description = description;
            return result;
        }
        ChangeAnnotation.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        ChangeAnnotation.is = is;
    })(ChangeAnnotation || (exports1.ChangeAnnotation = ChangeAnnotation = {}));
    var ChangeAnnotationIdentifier;
    (function(ChangeAnnotationIdentifier) {
        function is(value) {
            var candidate = value;
            return Is.string(candidate);
        }
        ChangeAnnotationIdentifier.is = is;
    })(ChangeAnnotationIdentifier || (exports1.ChangeAnnotationIdentifier = ChangeAnnotationIdentifier = {}));
    var AnnotatedTextEdit;
    (function(AnnotatedTextEdit) {
        /**
         * Creates an annotated replace text edit.
         *
         * @param range The range of text to be replaced.
         * @param newText The new text.
         * @param annotation The annotation.
         */ function replace(range, newText, annotation) {
            return {
                range: range,
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.replace = replace;
        /**
         * Creates an annotated insert text edit.
         *
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         * @param annotation The annotation.
         */ function insert(position, newText, annotation) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.insert = insert;
        /**
         * Creates an annotated delete text edit.
         *
         * @param range The range of text to be deleted.
         * @param annotation The annotation.
         */ function del(range, annotation) {
            return {
                range: range,
                newText: '',
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.del = del;
        function is(value) {
            var candidate = value;
            return TextEdit.is(candidate) && (ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        AnnotatedTextEdit.is = is;
    })(AnnotatedTextEdit || (exports1.AnnotatedTextEdit = AnnotatedTextEdit = {}));
    /**
     * The TextDocumentEdit namespace provides helper function to create
     * an edit that manipulates a text document.
     */ var TextDocumentEdit;
    (function(TextDocumentEdit) {
        /**
         * Creates a new `TextDocumentEdit`
         */ function create(textDocument, edits) {
            return {
                textDocument: textDocument,
                edits: edits
            };
        }
        TextDocumentEdit.create = create;
        function is(value) {
            var candidate = value;
            return Is.defined(candidate) && OptionalVersionedTextDocumentIdentifier.is(candidate.textDocument) && Array.isArray(candidate.edits);
        }
        TextDocumentEdit.is = is;
    })(TextDocumentEdit || (exports1.TextDocumentEdit = TextDocumentEdit = {}));
    var CreateFile;
    (function(CreateFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: 'create',
                uri: uri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        CreateFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'create' && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        CreateFile.is = is;
    })(CreateFile || (exports1.CreateFile = CreateFile = {}));
    var RenameFile;
    (function(RenameFile) {
        function create(oldUri, newUri, options, annotation) {
            var result = {
                kind: 'rename',
                oldUri: oldUri,
                newUri: newUri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        RenameFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'rename' && Is.string(candidate.oldUri) && Is.string(candidate.newUri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        RenameFile.is = is;
    })(RenameFile || (exports1.RenameFile = RenameFile = {}));
    var DeleteFile;
    (function(DeleteFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: 'delete',
                uri: uri
            };
            if (options !== undefined && (options.recursive !== undefined || options.ignoreIfNotExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        DeleteFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === 'delete' && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.recursive === undefined || Is.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === undefined || Is.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        DeleteFile.is = is;
    })(DeleteFile || (exports1.DeleteFile = DeleteFile = {}));
    var WorkspaceEdit;
    (function(WorkspaceEdit) {
        function is(value) {
            var candidate = value;
            return candidate && (candidate.changes !== undefined || candidate.documentChanges !== undefined) && (candidate.documentChanges === undefined || candidate.documentChanges.every(function(change) {
                if (Is.string(change.kind)) return CreateFile.is(change) || RenameFile.is(change) || DeleteFile.is(change);
                else return TextDocumentEdit.is(change);
            }));
        }
        WorkspaceEdit.is = is;
    })(WorkspaceEdit || (exports1.WorkspaceEdit = WorkspaceEdit = {}));
    var TextEditChangeImpl = /** @class */ function() {
        function TextEditChangeImpl(edits, changeAnnotations) {
            this.edits = edits;
            this.changeAnnotations = changeAnnotations;
        }
        TextEditChangeImpl.prototype.insert = function(position, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.insert(position, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.insert(position, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.insert(position, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.replace = function(range, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.replace(range, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.replace(range, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.replace(range, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.delete = function(range, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.del(range);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.del(range, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.del(range, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.add = function(edit) {
            this.edits.push(edit);
        };
        TextEditChangeImpl.prototype.all = function() {
            return this.edits;
        };
        TextEditChangeImpl.prototype.clear = function() {
            this.edits.splice(0, this.edits.length);
        };
        TextEditChangeImpl.prototype.assertChangeAnnotations = function(value) {
            if (value === undefined) throw new Error("Text edit change is not configured to manage change annotations.");
        };
        return TextEditChangeImpl;
    }();
    var SnippetTextEdit;
    (function(SnippetTextEdit) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && StringValue.isSnippet(candidate.snippet) && (candidate.annotationId === undefined || ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        SnippetTextEdit.is = is;
    })(SnippetTextEdit || (exports1.SnippetTextEdit = SnippetTextEdit = {}));
    /**
     * A helper class
     */ var ChangeAnnotations = /** @class */ function() {
        function ChangeAnnotations(annotations) {
            this._annotations = annotations === undefined ? Object.create(null) : annotations;
            this._counter = 0;
            this._size = 0;
        }
        ChangeAnnotations.prototype.all = function() {
            return this._annotations;
        };
        Object.defineProperty(ChangeAnnotations.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: false,
            configurable: true
        });
        ChangeAnnotations.prototype.manage = function(idOrAnnotation, annotation) {
            var id;
            if (ChangeAnnotationIdentifier.is(idOrAnnotation)) id = idOrAnnotation;
            else {
                id = this.nextId();
                annotation = idOrAnnotation;
            }
            if (this._annotations[id] !== undefined) throw new Error("Id ".concat(id, " is already in use."));
            if (annotation === undefined) throw new Error("No annotation provided for id ".concat(id));
            this._annotations[id] = annotation;
            this._size++;
            return id;
        };
        ChangeAnnotations.prototype.nextId = function() {
            this._counter++;
            return this._counter.toString();
        };
        return ChangeAnnotations;
    }();
    /**
     * A workspace change helps constructing changes to a workspace.
     */ var WorkspaceChange = /** @class */ function() {
        function WorkspaceChange(workspaceEdit) {
            var _this = this;
            this._textEditChanges = Object.create(null);
            if (workspaceEdit !== undefined) {
                this._workspaceEdit = workspaceEdit;
                if (workspaceEdit.documentChanges) {
                    this._changeAnnotations = new ChangeAnnotations(workspaceEdit.changeAnnotations);
                    workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                    workspaceEdit.documentChanges.forEach(function(change) {
                        if (TextDocumentEdit.is(change)) {
                            var textEditChange = new TextEditChangeImpl(change.edits, _this._changeAnnotations);
                            _this._textEditChanges[change.textDocument.uri] = textEditChange;
                        }
                    });
                } else if (workspaceEdit.changes) Object.keys(workspaceEdit.changes).forEach(function(key) {
                    var textEditChange = new TextEditChangeImpl(workspaceEdit.changes[key]);
                    _this._textEditChanges[key] = textEditChange;
                });
            } else this._workspaceEdit = {};
        }
        Object.defineProperty(WorkspaceChange.prototype, "edit", {
            /**
             * Returns the underlying {@link WorkspaceEdit} literal
             * use to be returned from a workspace edit operation like rename.
             */ get: function() {
                this.initDocumentChanges();
                if (this._changeAnnotations !== undefined) {
                    if (this._changeAnnotations.size === 0) this._workspaceEdit.changeAnnotations = undefined;
                    else this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                }
                return this._workspaceEdit;
            },
            enumerable: false,
            configurable: true
        });
        WorkspaceChange.prototype.getTextEditChange = function(key) {
            if (OptionalVersionedTextDocumentIdentifier.is(key)) {
                this.initDocumentChanges();
                if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
                var textDocument = {
                    uri: key.uri,
                    version: key.version
                };
                var result = this._textEditChanges[textDocument.uri];
                if (!result) {
                    var edits = [];
                    var textDocumentEdit = {
                        textDocument: textDocument,
                        edits: edits
                    };
                    this._workspaceEdit.documentChanges.push(textDocumentEdit);
                    result = new TextEditChangeImpl(edits, this._changeAnnotations);
                    this._textEditChanges[textDocument.uri] = result;
                }
                return result;
            } else {
                this.initChanges();
                if (this._workspaceEdit.changes === undefined) throw new Error('Workspace edit is not configured for normal text edit changes.');
                var result = this._textEditChanges[key];
                if (!result) {
                    var edits = [];
                    this._workspaceEdit.changes[key] = edits;
                    result = new TextEditChangeImpl(edits);
                    this._textEditChanges[key] = result;
                }
                return result;
            }
        };
        WorkspaceChange.prototype.initDocumentChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) {
                this._changeAnnotations = new ChangeAnnotations();
                this._workspaceEdit.documentChanges = [];
                this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
            }
        };
        WorkspaceChange.prototype.initChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) this._workspaceEdit.changes = Object.create(null);
        };
        WorkspaceChange.prototype.createFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = CreateFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = CreateFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.renameFile = function(oldUri, newUri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = RenameFile.create(oldUri, newUri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = RenameFile.create(oldUri, newUri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.deleteFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error('Workspace edit is not configured for document changes.');
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = DeleteFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = DeleteFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        return WorkspaceChange;
    }();
    exports1.WorkspaceChange = WorkspaceChange;
    /**
     * The TextDocumentIdentifier namespace provides helper functions to work with
     * {@link TextDocumentIdentifier} literals.
     */ var TextDocumentIdentifier;
    (function(TextDocumentIdentifier) {
        /**
         * Creates a new TextDocumentIdentifier literal.
         * @param uri The document's uri.
         */ function create(uri) {
            return {
                uri: uri
            };
        }
        TextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri);
        }
        TextDocumentIdentifier.is = is;
    })(TextDocumentIdentifier || (exports1.TextDocumentIdentifier = TextDocumentIdentifier = {}));
    /**
     * The VersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link VersionedTextDocumentIdentifier} literals.
     */ var VersionedTextDocumentIdentifier;
    (function(VersionedTextDocumentIdentifier) {
        /**
         * Creates a new VersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        VersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link VersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.integer(candidate.version);
        }
        VersionedTextDocumentIdentifier.is = is;
    })(VersionedTextDocumentIdentifier || (exports1.VersionedTextDocumentIdentifier = VersionedTextDocumentIdentifier = {}));
    /**
     * The OptionalVersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link OptionalVersionedTextDocumentIdentifier} literals.
     */ var OptionalVersionedTextDocumentIdentifier;
    (function(OptionalVersionedTextDocumentIdentifier) {
        /**
         * Creates a new OptionalVersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        OptionalVersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link OptionalVersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (candidate.version === null || Is.integer(candidate.version));
        }
        OptionalVersionedTextDocumentIdentifier.is = is;
    })(OptionalVersionedTextDocumentIdentifier || (exports1.OptionalVersionedTextDocumentIdentifier = OptionalVersionedTextDocumentIdentifier = {}));
    /**
     * Predefined Language kinds
     * @since 3.18.0
     */ var LanguageKind;
    (function(LanguageKind) {
        LanguageKind.ABAP = 'abap';
        LanguageKind.WindowsBat = 'bat';
        LanguageKind.BibTeX = 'bibtex';
        LanguageKind.Clojure = 'clojure';
        LanguageKind.Coffeescript = 'coffeescript';
        LanguageKind.C = 'c';
        LanguageKind.CPP = 'cpp';
        LanguageKind.CSharp = 'csharp';
        LanguageKind.CSS = 'css';
        /**
         * @since 3.18.0
         */ LanguageKind.D = 'd';
        /**
         * @since 3.18.0
         */ LanguageKind.Delphi = 'pascal';
        LanguageKind.Diff = 'diff';
        LanguageKind.Dart = 'dart';
        LanguageKind.Dockerfile = 'dockerfile';
        LanguageKind.Elixir = 'elixir';
        LanguageKind.Erlang = 'erlang';
        LanguageKind.FSharp = 'fsharp';
        LanguageKind.GitCommit = 'git-commit';
        LanguageKind.GitRebase = 'git-rebase';
        LanguageKind.Go = 'go';
        LanguageKind.Groovy = 'groovy';
        LanguageKind.Handlebars = 'handlebars';
        LanguageKind.Haskell = 'haskell';
        LanguageKind.HTML = 'html';
        LanguageKind.Ini = 'ini';
        LanguageKind.Java = 'java';
        LanguageKind.JavaScript = 'javascript';
        LanguageKind.JavaScriptReact = 'javascriptreact';
        LanguageKind.JSON = 'json';
        LanguageKind.LaTeX = 'latex';
        LanguageKind.Less = 'less';
        LanguageKind.Lua = 'lua';
        LanguageKind.Makefile = 'makefile';
        LanguageKind.Markdown = 'markdown';
        LanguageKind.ObjectiveC = 'objective-c';
        LanguageKind.ObjectiveCPP = 'objective-cpp';
        /**
         * @since 3.18.0
         */ LanguageKind.Pascal = 'pascal';
        LanguageKind.Perl = 'perl';
        LanguageKind.Perl6 = 'perl6';
        LanguageKind.PHP = 'php';
        LanguageKind.Plaintext = 'plaintext';
        LanguageKind.Powershell = 'powershell';
        LanguageKind.Pug = 'jade';
        LanguageKind.Python = 'python';
        LanguageKind.R = 'r';
        LanguageKind.Razor = 'razor';
        LanguageKind.Ruby = 'ruby';
        LanguageKind.Rust = 'rust';
        LanguageKind.SCSS = 'scss';
        LanguageKind.SASS = 'sass';
        LanguageKind.Scala = 'scala';
        LanguageKind.ShaderLab = 'shaderlab';
        LanguageKind.ShellScript = 'shellscript';
        LanguageKind.SQL = 'sql';
        LanguageKind.Swift = 'swift';
        LanguageKind.TypeScript = 'typescript';
        LanguageKind.TypeScriptReact = 'typescriptreact';
        LanguageKind.TeX = 'tex';
        LanguageKind.VisualBasic = 'vb';
        LanguageKind.XML = 'xml';
        LanguageKind.XSL = 'xsl';
        LanguageKind.YAML = 'yaml';
    })(LanguageKind || (exports1.LanguageKind = LanguageKind = {}));
    /**
     * The TextDocumentItem namespace provides helper functions to work with
     * {@link TextDocumentItem} literals.
     */ var TextDocumentItem;
    (function(TextDocumentItem) {
        /**
         * Creates a new TextDocumentItem literal.
         * @param uri The document's uri.
         * @param languageId The document's language identifier.
         * @param version The document's version number.
         * @param text The document's text.
         */ function create(uri, languageId, version, text) {
            return {
                uri: uri,
                languageId: languageId,
                version: version,
                text: text
            };
        }
        TextDocumentItem.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentItem} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.string(candidate.languageId) && Is.integer(candidate.version) && Is.string(candidate.text);
        }
        TextDocumentItem.is = is;
    })(TextDocumentItem || (exports1.TextDocumentItem = TextDocumentItem = {}));
    /**
     * Describes the content type that a client supports in various
     * result literals like `Hover`, `ParameterInfo` or `CompletionItem`.
     *
     * Please note that `MarkupKinds` must not start with a `$`. This kinds
     * are reserved for internal usage.
     */ var MarkupKind;
    (function(MarkupKind) {
        /**
         * Plain text is supported as a content format
         */ MarkupKind.PlainText = 'plaintext';
        /**
         * Markdown is supported as a content format
         */ MarkupKind.Markdown = 'markdown';
        /**
         * Checks whether the given value is a value of the {@link MarkupKind} type.
         */ function is(value) {
            var candidate = value;
            return candidate === MarkupKind.PlainText || candidate === MarkupKind.Markdown;
        }
        MarkupKind.is = is;
    })(MarkupKind || (exports1.MarkupKind = MarkupKind = {}));
    var MarkupContent;
    (function(MarkupContent) {
        /**
         * Checks whether the given value conforms to the {@link MarkupContent} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(value) && MarkupKind.is(candidate.kind) && Is.string(candidate.value);
        }
        MarkupContent.is = is;
    })(MarkupContent || (exports1.MarkupContent = MarkupContent = {}));
    /**
     * The kind of a completion entry.
     */ var CompletionItemKind;
    (function(CompletionItemKind) {
        CompletionItemKind.Text = 1;
        CompletionItemKind.Method = 2;
        CompletionItemKind.Function = 3;
        CompletionItemKind.Constructor = 4;
        CompletionItemKind.Field = 5;
        CompletionItemKind.Variable = 6;
        CompletionItemKind.Class = 7;
        CompletionItemKind.Interface = 8;
        CompletionItemKind.Module = 9;
        CompletionItemKind.Property = 10;
        CompletionItemKind.Unit = 11;
        CompletionItemKind.Value = 12;
        CompletionItemKind.Enum = 13;
        CompletionItemKind.Keyword = 14;
        CompletionItemKind.Snippet = 15;
        CompletionItemKind.Color = 16;
        CompletionItemKind.File = 17;
        CompletionItemKind.Reference = 18;
        CompletionItemKind.Folder = 19;
        CompletionItemKind.EnumMember = 20;
        CompletionItemKind.Constant = 21;
        CompletionItemKind.Struct = 22;
        CompletionItemKind.Event = 23;
        CompletionItemKind.Operator = 24;
        CompletionItemKind.TypeParameter = 25;
    })(CompletionItemKind || (exports1.CompletionItemKind = CompletionItemKind = {}));
    /**
     * Defines whether the insert text in a completion item should be interpreted as
     * plain text or a snippet.
     */ var InsertTextFormat;
    (function(InsertTextFormat) {
        /**
         * The primary text to be inserted is treated as a plain string.
         */ InsertTextFormat.PlainText = 1;
        /**
         * The primary text to be inserted is treated as a snippet.
         *
         * A snippet can define tab stops and placeholders with `$1`, `$2`
         * and `${3:foo}`. `$0` defines the final tab stop, it defaults to
         * the end of the snippet. Placeholders with equal identifiers are linked,
         * that is typing in one will update others too.
         *
         * See also: https://microsoft.github.io/language-server-protocol/specifications/specification-current/#snippet_syntax
         */ InsertTextFormat.Snippet = 2;
    })(InsertTextFormat || (exports1.InsertTextFormat = InsertTextFormat = {}));
    /**
     * Completion item tags are extra annotations that tweak the rendering of a completion
     * item.
     *
     * @since 3.15.0
     */ var CompletionItemTag;
    (function(CompletionItemTag) {
        /**
         * Render a completion as obsolete, usually using a strike-out.
         */ CompletionItemTag.Deprecated = 1;
    })(CompletionItemTag || (exports1.CompletionItemTag = CompletionItemTag = {}));
    /**
     * The InsertReplaceEdit namespace provides functions to deal with insert / replace edits.
     *
     * @since 3.16.0
     */ var InsertReplaceEdit;
    (function(InsertReplaceEdit) {
        /**
         * Creates a new insert / replace edit
         */ function create(newText, insert, replace) {
            return {
                newText: newText,
                insert: insert,
                replace: replace
            };
        }
        InsertReplaceEdit.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InsertReplaceEdit} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.newText) && Range.is(candidate.insert) && Range.is(candidate.replace);
        }
        InsertReplaceEdit.is = is;
    })(InsertReplaceEdit || (exports1.InsertReplaceEdit = InsertReplaceEdit = {}));
    /**
     * How whitespace and indentation is handled during completion
     * item insertion.
     *
     * @since 3.16.0
     */ var InsertTextMode;
    (function(InsertTextMode) {
        /**
         * The insertion or replace strings is taken as it is. If the
         * value is multi line the lines below the cursor will be
         * inserted using the indentation defined in the string value.
         * The client will not apply any kind of adjustments to the
         * string.
         */ InsertTextMode.asIs = 1;
        /**
         * The editor adjusts leading whitespace of new lines so that
         * they match the indentation up to the cursor of the line for
         * which the item is accepted.
         *
         * Consider a line like this: <2tabs><cursor><3tabs>foo. Accepting a
         * multi line completion item is indented using 2 tabs and all
         * following lines inserted will be indented using 2 tabs as well.
         */ InsertTextMode.adjustIndentation = 2;
    })(InsertTextMode || (exports1.InsertTextMode = InsertTextMode = {}));
    /**
     * Defines how values from a set of defaults and an individual item will be
     * merged.
     *
     * @since 3.18.0
     */ var ApplyKind;
    (function(ApplyKind) {
        /**
         * The value from the individual item (if provided and not `null`) will be
         * used instead of the default.
         */ ApplyKind.Replace = 1;
        /**
         * The value from the item will be merged with the default.
         *
         * The specific rules for mergeing values are defined against each field
         * that supports merging.
         */ ApplyKind.Merge = 2;
    })(ApplyKind || (exports1.ApplyKind = ApplyKind = {}));
    var CompletionItemLabelDetails;
    (function(CompletionItemLabelDetails) {
        function is(value) {
            var candidate = value;
            return candidate && (Is.string(candidate.detail) || candidate.detail === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        CompletionItemLabelDetails.is = is;
    })(CompletionItemLabelDetails || (exports1.CompletionItemLabelDetails = CompletionItemLabelDetails = {}));
    /**
     * The CompletionItem namespace provides functions to deal with
     * completion items.
     */ var CompletionItem;
    (function(CompletionItem) {
        /**
         * Create a completion item and seed it with a label.
         * @param label The completion item's label
         */ function create(label) {
            return {
                label: label
            };
        }
        CompletionItem.create = create;
    })(CompletionItem || (exports1.CompletionItem = CompletionItem = {}));
    /**
     * The CompletionList namespace provides functions to deal with
     * completion lists.
     */ var CompletionList;
    (function(CompletionList) {
        /**
         * Creates a new completion list.
         *
         * @param items The completion items.
         * @param isIncomplete The list is not complete.
         */ function create(items, isIncomplete) {
            return {
                items: items ? items : [],
                isIncomplete: !!isIncomplete
            };
        }
        CompletionList.create = create;
    })(CompletionList || (exports1.CompletionList = CompletionList = {}));
    var MarkedString;
    (function(MarkedString) {
        /**
         * Creates a marked string from plain text.
         *
         * @param plainText The plain text.
         */ function fromPlainText(plainText) {
            return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, '\\$&'); // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
        }
        MarkedString.fromPlainText = fromPlainText;
        /**
         * Checks whether the given value conforms to the {@link MarkedString} type.
         */ function is(value) {
            var candidate = value;
            return Is.string(candidate) || Is.objectLiteral(candidate) && Is.string(candidate.language) && Is.string(candidate.value);
        }
        MarkedString.is = is;
    })(MarkedString || (exports1.MarkedString = MarkedString = {}));
    var Hover;
    (function(Hover) {
        /**
         * Checks whether the given value conforms to the {@link Hover} interface.
         */ function is(value) {
            var candidate = value;
            return !!candidate && Is.objectLiteral(candidate) && (MarkupContent.is(candidate.contents) || MarkedString.is(candidate.contents) || Is.typedArray(candidate.contents, MarkedString.is)) && (value.range === undefined || Range.is(value.range));
        }
        Hover.is = is;
    })(Hover || (exports1.Hover = Hover = {}));
    /**
     * The ParameterInformation namespace provides helper functions to work with
     * {@link ParameterInformation} literals.
     */ var ParameterInformation;
    (function(ParameterInformation) {
        /**
         * Creates a new parameter information literal.
         *
         * @param label A label string.
         * @param documentation A doc string.
         */ function create(label, documentation) {
            return documentation ? {
                label: label,
                documentation: documentation
            } : {
                label: label
            };
        }
        ParameterInformation.create = create;
    })(ParameterInformation || (exports1.ParameterInformation = ParameterInformation = {}));
    /**
     * The SignatureInformation namespace provides helper functions to work with
     * {@link SignatureInformation} literals.
     */ var SignatureInformation;
    (function(SignatureInformation) {
        function create(label, documentation) {
            var parameters = [];
            for(var _i = 2; _i < arguments.length; _i++)parameters[_i - 2] = arguments[_i];
            var result = {
                label: label
            };
            if (Is.defined(documentation)) result.documentation = documentation;
            if (Is.defined(parameters)) result.parameters = parameters;
            else result.parameters = [];
            return result;
        }
        SignatureInformation.create = create;
    })(SignatureInformation || (exports1.SignatureInformation = SignatureInformation = {}));
    /**
     * A document highlight kind.
     */ var DocumentHighlightKind;
    (function(DocumentHighlightKind) {
        /**
         * A textual occurrence.
         */ DocumentHighlightKind.Text = 1;
        /**
         * Read-access of a symbol, like reading a variable.
         */ DocumentHighlightKind.Read = 2;
        /**
         * Write-access of a symbol, like writing to a variable.
         */ DocumentHighlightKind.Write = 3;
    })(DocumentHighlightKind || (exports1.DocumentHighlightKind = DocumentHighlightKind = {}));
    /**
     * DocumentHighlight namespace to provide helper functions to work with
     * {@link DocumentHighlight} literals.
     */ var DocumentHighlight;
    (function(DocumentHighlight) {
        /**
         * Create a DocumentHighlight object.
         * @param range The range the highlight applies to.
         * @param kind The highlight kind
         */ function create(range, kind) {
            var result = {
                range: range
            };
            if (Is.number(kind)) result.kind = kind;
            return result;
        }
        DocumentHighlight.create = create;
    })(DocumentHighlight || (exports1.DocumentHighlight = DocumentHighlight = {}));
    /**
     * A symbol kind.
     */ var SymbolKind;
    (function(SymbolKind) {
        SymbolKind.File = 1;
        SymbolKind.Module = 2;
        SymbolKind.Namespace = 3;
        SymbolKind.Package = 4;
        SymbolKind.Class = 5;
        SymbolKind.Method = 6;
        SymbolKind.Property = 7;
        SymbolKind.Field = 8;
        SymbolKind.Constructor = 9;
        SymbolKind.Enum = 10;
        SymbolKind.Interface = 11;
        SymbolKind.Function = 12;
        SymbolKind.Variable = 13;
        SymbolKind.Constant = 14;
        SymbolKind.String = 15;
        SymbolKind.Number = 16;
        SymbolKind.Boolean = 17;
        SymbolKind.Array = 18;
        SymbolKind.Object = 19;
        SymbolKind.Key = 20;
        SymbolKind.Null = 21;
        SymbolKind.EnumMember = 22;
        SymbolKind.Struct = 23;
        SymbolKind.Event = 24;
        SymbolKind.Operator = 25;
        SymbolKind.TypeParameter = 26;
    })(SymbolKind || (exports1.SymbolKind = SymbolKind = {}));
    /**
     * Symbol tags are extra annotations that tweak the rendering of a symbol.
     *
     * @since 3.16
     */ var SymbolTag;
    (function(SymbolTag) {
        /**
         * Render a symbol as obsolete, usually using a strike-out.
         */ SymbolTag.Deprecated = 1;
    })(SymbolTag || (exports1.SymbolTag = SymbolTag = {}));
    var SymbolInformation;
    (function(SymbolInformation) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the location of the symbol.
         * @param uri The resource of the location of symbol.
         * @param containerName The name of the symbol containing the symbol.
         */ function create(name, kind, range, uri, containerName) {
            var result = {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            };
            if (containerName) result.containerName = containerName;
            return result;
        }
        SymbolInformation.create = create;
    })(SymbolInformation || (exports1.SymbolInformation = SymbolInformation = {}));
    var WorkspaceSymbol;
    (function(WorkspaceSymbol) {
        /**
         * Create a new workspace symbol.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param uri The resource of the location of the symbol.
         * @param range An options range of the location.
         * @returns A WorkspaceSymbol.
         */ function create(name, kind, uri, range) {
            return range !== undefined ? {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            } : {
                name: name,
                kind: kind,
                location: {
                    uri: uri
                }
            };
        }
        WorkspaceSymbol.create = create;
    })(WorkspaceSymbol || (exports1.WorkspaceSymbol = WorkspaceSymbol = {}));
    var DocumentSymbol;
    (function(DocumentSymbol) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param detail The detail of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the symbol.
         * @param selectionRange The selectionRange of the symbol.
         * @param children Children of the symbol.
         */ function create(name, detail, kind, range, selectionRange, children) {
            var result = {
                name: name,
                detail: detail,
                kind: kind,
                range: range,
                selectionRange: selectionRange
            };
            if (children !== undefined) result.children = children;
            return result;
        }
        DocumentSymbol.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentSymbol} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.name) && Is.number(candidate.kind) && Range.is(candidate.range) && Range.is(candidate.selectionRange) && (candidate.detail === undefined || Is.string(candidate.detail)) && (candidate.deprecated === undefined || Is.boolean(candidate.deprecated)) && (candidate.children === undefined || Array.isArray(candidate.children)) && (candidate.tags === undefined || Array.isArray(candidate.tags));
        }
        DocumentSymbol.is = is;
    })(DocumentSymbol || (exports1.DocumentSymbol = DocumentSymbol = {}));
    /**
     * A set of predefined code action kinds
     */ var CodeActionKind;
    (function(CodeActionKind) {
        /**
         * Empty kind.
         */ CodeActionKind.Empty = '';
        /**
         * Base kind for quickfix actions: 'quickfix'
         */ CodeActionKind.QuickFix = 'quickfix';
        /**
         * Base kind for refactoring actions: 'refactor'
         */ CodeActionKind.Refactor = 'refactor';
        /**
         * Base kind for refactoring extraction actions: 'refactor.extract'
         *
         * Example extract actions:
         *
         * - Extract method
         * - Extract function
         * - Extract variable
         * - Extract interface from class
         * - ...
         */ CodeActionKind.RefactorExtract = 'refactor.extract';
        /**
         * Base kind for refactoring inline actions: 'refactor.inline'
         *
         * Example inline actions:
         *
         * - Inline function
         * - Inline variable
         * - Inline constant
         * - ...
         */ CodeActionKind.RefactorInline = 'refactor.inline';
        /**
         * Base kind for refactoring move actions: `refactor.move`
         *
         * Example move actions:
         *
         * - Move a function to a new file
         * - Move a property between classes
         * - Move method to base class
         * - ...
         *
         * @since 3.18.0
         */ CodeActionKind.RefactorMove = 'refactor.move';
        /**
         * Base kind for refactoring rewrite actions: 'refactor.rewrite'
         *
         * Example rewrite actions:
         *
         * - Convert JavaScript function to class
         * - Add or remove parameter
         * - Encapsulate field
         * - Make method static
         * - Move method to base class
         * - ...
         */ CodeActionKind.RefactorRewrite = 'refactor.rewrite';
        /**
         * Base kind for source actions: `source`
         *
         * Source code actions apply to the entire file.
         */ CodeActionKind.Source = 'source';
        /**
         * Base kind for an organize imports source action: `source.organizeImports`
         */ CodeActionKind.SourceOrganizeImports = 'source.organizeImports';
        /**
         * Base kind for auto-fix source actions: `source.fixAll`.
         *
         * Fix all actions automatically fix errors that have a clear fix that do not require user input.
         * They should not suppress errors or perform unsafe fixes such as generating new types or classes.
         *
         * @since 3.15.0
         */ CodeActionKind.SourceFixAll = 'source.fixAll';
        /**
         * Base kind for all code actions applying to the entire notebook's scope. CodeActionKinds using
         * this should always begin with `notebook.`
         *
         * @since 3.18.0
         */ CodeActionKind.Notebook = 'notebook';
    })(CodeActionKind || (exports1.CodeActionKind = CodeActionKind = {}));
    /**
     * The reason why code actions were requested.
     *
     * @since 3.17.0
     */ var CodeActionTriggerKind;
    (function(CodeActionTriggerKind) {
        /**
         * Code actions were explicitly requested by the user or by an extension.
         */ CodeActionTriggerKind.Invoked = 1;
        /**
         * Code actions were requested automatically.
         *
         * This typically happens when current selection in a file changes, but can
         * also be triggered when file content changes.
         */ CodeActionTriggerKind.Automatic = 2;
    })(CodeActionTriggerKind || (exports1.CodeActionTriggerKind = CodeActionTriggerKind = {}));
    /**
     * The CodeActionContext namespace provides helper functions to work with
     * {@link CodeActionContext} literals.
     */ var CodeActionContext;
    (function(CodeActionContext) {
        /**
         * Creates a new CodeActionContext literal.
         */ function create(diagnostics, only, triggerKind) {
            var result = {
                diagnostics: diagnostics
            };
            if (only !== undefined && only !== null) result.only = only;
            if (triggerKind !== undefined && triggerKind !== null) result.triggerKind = triggerKind;
            return result;
        }
        CodeActionContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeActionContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.typedArray(candidate.diagnostics, Diagnostic.is) && (candidate.only === undefined || Is.typedArray(candidate.only, Is.string)) && (candidate.triggerKind === undefined || candidate.triggerKind === CodeActionTriggerKind.Invoked || candidate.triggerKind === CodeActionTriggerKind.Automatic);
        }
        CodeActionContext.is = is;
    })(CodeActionContext || (exports1.CodeActionContext = CodeActionContext = {}));
    /**
     * Code action tags are extra annotations that tweak the behavior of a code action.
     *
     * @since 3.18.0
     */ var CodeActionTag;
    (function(CodeActionTag) {
        /**
         * Marks the code action as LLM-generated.
         */ CodeActionTag.LLMGenerated = 1;
        /**
         * Checks whether the given literal conforms to the {@link CodeActionTag} interface.
         */ function is(value) {
            return Is.defined(value) && value === CodeActionTag.LLMGenerated;
        }
        CodeActionTag.is = is;
    })(CodeActionTag || (exports1.CodeActionTag = CodeActionTag = {}));
    var CodeAction;
    (function(CodeAction) {
        function create(title, kindOrCommandOrEdit, kind) {
            var result = {
                title: title
            };
            var checkKind = true;
            if (typeof kindOrCommandOrEdit === 'string') {
                checkKind = false;
                result.kind = kindOrCommandOrEdit;
            } else if (Command.is(kindOrCommandOrEdit)) result.command = kindOrCommandOrEdit;
            else result.edit = kindOrCommandOrEdit;
            if (checkKind && kind !== undefined) result.kind = kind;
            return result;
        }
        CodeAction.create = create;
        function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.title) && (candidate.diagnostics === undefined || Is.typedArray(candidate.diagnostics, Diagnostic.is)) && (candidate.kind === undefined || Is.string(candidate.kind)) && (candidate.edit !== undefined || candidate.command !== undefined) && (candidate.command === undefined || Command.is(candidate.command)) && (candidate.isPreferred === undefined || Is.boolean(candidate.isPreferred)) && (candidate.edit === undefined || WorkspaceEdit.is(candidate.edit)) && (candidate.tags === undefined || Is.typedArray(candidate.tags, CodeActionTag.is));
        }
        CodeAction.is = is;
    })(CodeAction || (exports1.CodeAction = CodeAction = {}));
    /**
     * The CodeLens namespace provides helper functions to work with
     * {@link CodeLens} literals.
     */ var CodeLens;
    (function(CodeLens) {
        /**
         * Creates a new CodeLens literal.
         */ function create(range, data) {
            var result = {
                range: range
            };
            if (Is.defined(data)) result.data = data;
            return result;
        }
        CodeLens.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeLens} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.command) || Command.is(candidate.command));
        }
        CodeLens.is = is;
    })(CodeLens || (exports1.CodeLens = CodeLens = {}));
    /**
     * The FormattingOptions namespace provides helper functions to work with
     * {@link FormattingOptions} literals.
     */ var FormattingOptions;
    (function(FormattingOptions) {
        /**
         * Creates a new FormattingOptions literal.
         */ function create(tabSize, insertSpaces) {
            return {
                tabSize: tabSize,
                insertSpaces: insertSpaces
            };
        }
        FormattingOptions.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FormattingOptions} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.uinteger(candidate.tabSize) && Is.boolean(candidate.insertSpaces);
        }
        FormattingOptions.is = is;
    })(FormattingOptions || (exports1.FormattingOptions = FormattingOptions = {}));
    /**
     * The DocumentLink namespace provides helper functions to work with
     * {@link DocumentLink} literals.
     */ var DocumentLink;
    (function(DocumentLink) {
        /**
         * Creates a new DocumentLink literal.
         */ function create(range, target, data) {
            return {
                range: range,
                target: target,
                data: data
            };
        }
        DocumentLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.target) || Is.string(candidate.target));
        }
        DocumentLink.is = is;
    })(DocumentLink || (exports1.DocumentLink = DocumentLink = {}));
    /**
     * The SelectionRange namespace provides helper function to work with
     * SelectionRange literals.
     */ var SelectionRange;
    (function(SelectionRange) {
        /**
         * Creates a new SelectionRange
         * @param range the range.
         * @param parent an optional parent.
         */ function create(range, parent) {
            return {
                range: range,
                parent: parent
            };
        }
        SelectionRange.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (candidate.parent === undefined || SelectionRange.is(candidate.parent));
        }
        SelectionRange.is = is;
    })(SelectionRange || (exports1.SelectionRange = SelectionRange = {}));
    /**
     * A set of predefined token types. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenTypes;
    (function(SemanticTokenTypes) {
        SemanticTokenTypes["namespace"] = "namespace";
        /**
         * Represents a generic type. Acts as a fallback for types which can't be mapped to
         * a specific type like class or enum.
         */ SemanticTokenTypes["type"] = "type";
        SemanticTokenTypes["class"] = "class";
        SemanticTokenTypes["enum"] = "enum";
        SemanticTokenTypes["interface"] = "interface";
        SemanticTokenTypes["struct"] = "struct";
        SemanticTokenTypes["typeParameter"] = "typeParameter";
        SemanticTokenTypes["parameter"] = "parameter";
        SemanticTokenTypes["variable"] = "variable";
        SemanticTokenTypes["property"] = "property";
        SemanticTokenTypes["enumMember"] = "enumMember";
        SemanticTokenTypes["event"] = "event";
        SemanticTokenTypes["function"] = "function";
        SemanticTokenTypes["method"] = "method";
        SemanticTokenTypes["macro"] = "macro";
        SemanticTokenTypes["keyword"] = "keyword";
        SemanticTokenTypes["modifier"] = "modifier";
        SemanticTokenTypes["comment"] = "comment";
        SemanticTokenTypes["string"] = "string";
        SemanticTokenTypes["number"] = "number";
        SemanticTokenTypes["regexp"] = "regexp";
        SemanticTokenTypes["operator"] = "operator";
        /**
         * @since 3.17.0
         */ SemanticTokenTypes["decorator"] = "decorator";
        /**
         * @since 3.18.0
         */ SemanticTokenTypes["label"] = "label";
    })(SemanticTokenTypes || (exports1.SemanticTokenTypes = SemanticTokenTypes = {}));
    /**
     * A set of predefined token modifiers. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenModifiers;
    (function(SemanticTokenModifiers) {
        SemanticTokenModifiers["declaration"] = "declaration";
        SemanticTokenModifiers["definition"] = "definition";
        SemanticTokenModifiers["readonly"] = "readonly";
        SemanticTokenModifiers["static"] = "static";
        SemanticTokenModifiers["deprecated"] = "deprecated";
        SemanticTokenModifiers["abstract"] = "abstract";
        SemanticTokenModifiers["async"] = "async";
        SemanticTokenModifiers["modification"] = "modification";
        SemanticTokenModifiers["documentation"] = "documentation";
        SemanticTokenModifiers["defaultLibrary"] = "defaultLibrary";
    })(SemanticTokenModifiers || (exports1.SemanticTokenModifiers = SemanticTokenModifiers = {}));
    /**
     * @since 3.16.0
     */ var SemanticTokens;
    (function(SemanticTokens) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.resultId === undefined || typeof candidate.resultId === 'string') && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === 'number');
        }
        SemanticTokens.is = is;
    })(SemanticTokens || (exports1.SemanticTokens = SemanticTokens = {}));
    /**
     * The InlineValueText namespace provides functions to deal with InlineValueTexts.
     *
     * @since 3.17.0
     */ var InlineValueText;
    (function(InlineValueText) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        InlineValueText.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.string(candidate.text);
        }
        InlineValueText.is = is;
    })(InlineValueText || (exports1.InlineValueText = InlineValueText = {}));
    /**
     * The InlineValueVariableLookup namespace provides functions to
     * deal with InlineValueVariableLookups.
     *
     * @since 3.17.0
     */ var InlineValueVariableLookup;
    (function(InlineValueVariableLookup) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, variableName, caseSensitiveLookup) {
            return {
                range: range,
                variableName: variableName,
                caseSensitiveLookup: caseSensitiveLookup
            };
        }
        InlineValueVariableLookup.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.boolean(candidate.caseSensitiveLookup) && (Is.string(candidate.variableName) || candidate.variableName === undefined);
        }
        InlineValueVariableLookup.is = is;
    })(InlineValueVariableLookup || (exports1.InlineValueVariableLookup = InlineValueVariableLookup = {}));
    /**
     * The InlineValueEvaluatableExpression namespace provides functions to deal with InlineValueEvaluatableExpression.
     *
     * @since 3.17.0
     */ var InlineValueEvaluatableExpression;
    (function(InlineValueEvaluatableExpression) {
        /**
         * Creates a new InlineValueEvaluatableExpression literal.
         */ function create(range, expression) {
            return {
                range: range,
                expression: expression
            };
        }
        InlineValueEvaluatableExpression.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && (Is.string(candidate.expression) || candidate.expression === undefined);
        }
        InlineValueEvaluatableExpression.is = is;
    })(InlineValueEvaluatableExpression || (exports1.InlineValueEvaluatableExpression = InlineValueEvaluatableExpression = {}));
    /**
     * The InlineValueContext namespace provides helper functions to work with
     * {@link InlineValueContext} literals.
     *
     * @since 3.17.0
     */ var InlineValueContext;
    (function(InlineValueContext) {
        /**
         * Creates a new InlineValueContext literal.
         */ function create(frameId, stoppedLocation) {
            return {
                frameId: frameId,
                stoppedLocation: stoppedLocation
            };
        }
        InlineValueContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InlineValueContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(value.stoppedLocation);
        }
        InlineValueContext.is = is;
    })(InlineValueContext || (exports1.InlineValueContext = InlineValueContext = {}));
    /**
     * Inlay hint kinds.
     *
     * @since 3.17.0
     */ var InlayHintKind;
    (function(InlayHintKind) {
        /**
         * An inlay hint that for a type annotation.
         */ InlayHintKind.Type = 1;
        /**
         * An inlay hint that is for a parameter.
         */ InlayHintKind.Parameter = 2;
        function is(value) {
            return value === 1 || value === 2;
        }
        InlayHintKind.is = is;
    })(InlayHintKind || (exports1.InlayHintKind = InlayHintKind = {}));
    var InlayHintLabelPart;
    (function(InlayHintLabelPart) {
        function create(value) {
            return {
                value: value
            };
        }
        InlayHintLabelPart.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.location === undefined || Location.is(candidate.location)) && (candidate.command === undefined || Command.is(candidate.command));
        }
        InlayHintLabelPart.is = is;
    })(InlayHintLabelPart || (exports1.InlayHintLabelPart = InlayHintLabelPart = {}));
    var InlayHint;
    (function(InlayHint) {
        function create(position, label, kind) {
            var result = {
                position: position,
                label: label
            };
            if (kind !== undefined) result.kind = kind;
            return result;
        }
        InlayHint.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.position) && (Is.string(candidate.label) || Is.typedArray(candidate.label, InlayHintLabelPart.is)) && (candidate.kind === undefined || InlayHintKind.is(candidate.kind)) && candidate.textEdits === undefined || Is.typedArray(candidate.textEdits, TextEdit.is) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.paddingLeft === undefined || Is.boolean(candidate.paddingLeft)) && (candidate.paddingRight === undefined || Is.boolean(candidate.paddingRight));
        }
        InlayHint.is = is;
    })(InlayHint || (exports1.InlayHint = InlayHint = {}));
    var StringValue;
    (function(StringValue) {
        function createSnippet(value) {
            return {
                kind: 'snippet',
                value: value
            };
        }
        StringValue.createSnippet = createSnippet;
        function isSnippet(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && candidate.kind === 'snippet' && Is.string(candidate.value);
        }
        StringValue.isSnippet = isSnippet;
    })(StringValue || (exports1.StringValue = StringValue = {}));
    var InlineCompletionItem;
    (function(InlineCompletionItem) {
        function create(insertText, filterText, range, command) {
            return {
                insertText: insertText,
                filterText: filterText,
                range: range,
                command: command
            };
        }
        InlineCompletionItem.create = create;
    })(InlineCompletionItem || (exports1.InlineCompletionItem = InlineCompletionItem = {}));
    var InlineCompletionList;
    (function(InlineCompletionList) {
        function create(items) {
            return {
                items: items
            };
        }
        InlineCompletionList.create = create;
    })(InlineCompletionList || (exports1.InlineCompletionList = InlineCompletionList = {}));
    /**
     * Describes how an {@link InlineCompletionItemProvider inline completion provider} was triggered.
     *
     * @since 3.18.0
     */ var InlineCompletionTriggerKind;
    (function(InlineCompletionTriggerKind) {
        /**
         * Completion was triggered explicitly by a user gesture.
         */ InlineCompletionTriggerKind.Invoked = 1;
        /**
         * Completion was triggered automatically while editing.
         */ InlineCompletionTriggerKind.Automatic = 2;
    })(InlineCompletionTriggerKind || (exports1.InlineCompletionTriggerKind = InlineCompletionTriggerKind = {}));
    var SelectedCompletionInfo;
    (function(SelectedCompletionInfo) {
        function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        SelectedCompletionInfo.create = create;
    })(SelectedCompletionInfo || (exports1.SelectedCompletionInfo = SelectedCompletionInfo = {}));
    var InlineCompletionContext;
    (function(InlineCompletionContext) {
        function create(triggerKind, selectedCompletionInfo) {
            return {
                triggerKind: triggerKind,
                selectedCompletionInfo: selectedCompletionInfo
            };
        }
        InlineCompletionContext.create = create;
    })(InlineCompletionContext || (exports1.InlineCompletionContext = InlineCompletionContext = {}));
    var WorkspaceFolder;
    (function(WorkspaceFolder) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && URI.is(candidate.uri) && Is.string(candidate.name);
        }
        WorkspaceFolder.is = is;
    })(WorkspaceFolder || (exports1.WorkspaceFolder = WorkspaceFolder = {}));
    exports1.EOL = [
        '\n',
        '\r\n',
        '\r'
    ];
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var TextDocument;
    (function(TextDocument) {
        /**
         * Creates a new ITextDocument literal from the given uri and content.
         * @param uri The document's uri.
         * @param languageId The document's language Id.
         * @param version The document's version.
         * @param content The document's content.
         */ function create(uri, languageId, version, content) {
            return new FullTextDocument(uri, languageId, version, content);
        }
        TextDocument.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ITextDocument} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (Is.undefined(candidate.languageId) || Is.string(candidate.languageId)) && Is.uinteger(candidate.lineCount) && Is.func(candidate.getText) && Is.func(candidate.positionAt) && Is.func(candidate.offsetAt) ? true : false;
        }
        TextDocument.is = is;
        function applyEdits(document, edits) {
            var text = document.getText();
            var sortedEdits = mergeSort(edits, function(a, b) {
                var diff = a.range.start.line - b.range.start.line;
                if (diff === 0) return a.range.start.character - b.range.start.character;
                return diff;
            });
            var lastModifiedOffset = text.length;
            for(var i = sortedEdits.length - 1; i >= 0; i--){
                var e = sortedEdits[i];
                var startOffset = document.offsetAt(e.range.start);
                var endOffset = document.offsetAt(e.range.end);
                if (endOffset <= lastModifiedOffset) text = text.substring(0, startOffset) + e.newText + text.substring(endOffset, text.length);
                else throw new Error('Overlapping edit');
                lastModifiedOffset = startOffset;
            }
            return text;
        }
        TextDocument.applyEdits = applyEdits;
        function mergeSort(data, compare) {
            if (data.length <= 1) // sorted
            return data;
            var p = data.length / 2 | 0;
            var left = data.slice(0, p);
            var right = data.slice(p);
            mergeSort(left, compare);
            mergeSort(right, compare);
            var leftIdx = 0;
            var rightIdx = 0;
            var i = 0;
            while(leftIdx < left.length && rightIdx < right.length){
                var ret = compare(left[leftIdx], right[rightIdx]);
                if (ret <= 0) // smaller_equal -> take left to preserve order
                data[i++] = left[leftIdx++];
                else // greater -> take right
                data[i++] = right[rightIdx++];
            }
            while(leftIdx < left.length)data[i++] = left[leftIdx++];
            while(rightIdx < right.length)data[i++] = right[rightIdx++];
            return data;
        }
    })(TextDocument || (exports1.TextDocument = TextDocument = {}));
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var FullTextDocument = /** @class */ function() {
        function FullTextDocument(uri, languageId, version, content) {
            this._uri = uri;
            this._languageId = languageId;
            this._version = version;
            this._content = content;
            this._lineOffsets = undefined;
        }
        Object.defineProperty(FullTextDocument.prototype, "uri", {
            get: function() {
                return this._uri;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "languageId", {
            get: function() {
                return this._languageId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "version", {
            get: function() {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.prototype.getText = function(range) {
            if (range) {
                var start = this.offsetAt(range.start);
                var end = this.offsetAt(range.end);
                return this._content.substring(start, end);
            }
            return this._content;
        };
        FullTextDocument.prototype.update = function(event, version) {
            this._content = event.text;
            this._version = version;
            this._lineOffsets = undefined;
        };
        FullTextDocument.prototype.getLineOffsets = function() {
            if (this._lineOffsets === undefined) {
                var lineOffsets = [];
                var text = this._content;
                var isLineStart = true;
                for(var i = 0; i < text.length; i++){
                    if (isLineStart) {
                        lineOffsets.push(i);
                        isLineStart = false;
                    }
                    var ch = text.charAt(i);
                    isLineStart = ch === '\r' || ch === '\n';
                    if (ch === '\r' && i + 1 < text.length && text.charAt(i + 1) === '\n') i++;
                }
                if (isLineStart && text.length > 0) lineOffsets.push(text.length);
                this._lineOffsets = lineOffsets;
            }
            return this._lineOffsets;
        };
        FullTextDocument.prototype.positionAt = function(offset) {
            offset = Math.max(Math.min(offset, this._content.length), 0);
            var lineOffsets = this.getLineOffsets();
            var low = 0, high = lineOffsets.length;
            if (high === 0) return Position.create(0, offset);
            while(low < high){
                var mid = Math.floor((low + high) / 2);
                if (lineOffsets[mid] > offset) high = mid;
                else low = mid + 1;
            }
            // low is the least x for which the line offset is larger than the current offset
            // or array.length if no line offset is larger than the current offset
            var line = low - 1;
            return Position.create(line, offset - lineOffsets[line]);
        };
        FullTextDocument.prototype.offsetAt = function(position) {
            var lineOffsets = this.getLineOffsets();
            if (position.line >= lineOffsets.length) return this._content.length;
            else if (position.line < 0) return 0;
            var lineOffset = lineOffsets[position.line];
            var nextLineOffset = position.line + 1 < lineOffsets.length ? lineOffsets[position.line + 1] : this._content.length;
            return Math.max(Math.min(lineOffset + position.character, nextLineOffset), lineOffset);
        };
        Object.defineProperty(FullTextDocument.prototype, "lineCount", {
            get: function() {
                return this.getLineOffsets().length;
            },
            enumerable: false,
            configurable: true
        });
        return FullTextDocument;
    }();
    var Is;
    (function(Is) {
        var toString = Object.prototype.toString;
        function defined(value) {
            return typeof value !== 'undefined';
        }
        Is.defined = defined;
        function undefined1(value) {
            return typeof value === 'undefined';
        }
        Is.undefined = undefined1;
        function boolean(value) {
            return value === true || value === false;
        }
        Is.boolean = boolean;
        function string(value) {
            return toString.call(value) === '[object String]';
        }
        Is.string = string;
        function number(value) {
            return toString.call(value) === '[object Number]';
        }
        Is.number = number;
        function numberRange(value, min, max) {
            return toString.call(value) === '[object Number]' && min <= value && value <= max;
        }
        Is.numberRange = numberRange;
        function integer(value) {
            return toString.call(value) === '[object Number]' && -2147483648 <= value && value <= 2147483647;
        }
        Is.integer = integer;
        function uinteger(value) {
            return toString.call(value) === '[object Number]' && 0 <= value && value <= 2147483647;
        }
        Is.uinteger = uinteger;
        function func(value) {
            return toString.call(value) === '[object Function]';
        }
        Is.func = func;
        function objectLiteral(value) {
            // Strictly speaking class instances pass this check as well. Since the LSP
            // doesn't use classes we ignore this for now. If we do we need to add something
            // like this: `Object.getPrototypeOf(Object.getPrototypeOf(x)) === null`
            return value !== null && typeof value === 'object';
        }
        Is.objectLiteral = objectLiteral;
        function typedArray(value, check) {
            return Array.isArray(value) && value.every(check);
        }
        Is.typedArray = typedArray;
    })(Is || (Is = {}));
});

});

parcelRegister("3H92V", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CM = module.exports.ProtocolNotificationType = module.exports.ProtocolNotificationType0 = module.exports.ProtocolRequestType = module.exports.ProtocolRequestType0 = module.exports.RegistrationType = module.exports.MessageDirection = void 0;

var $d8V62 = parcelRequire("d8V62");
var $2b0c679ba56e5e65$var$MessageDirection;
(function(MessageDirection) {
    MessageDirection["clientToServer"] = "clientToServer";
    MessageDirection["serverToClient"] = "serverToClient";
    MessageDirection["both"] = "both";
})($2b0c679ba56e5e65$var$MessageDirection || (module.exports.MessageDirection = $2b0c679ba56e5e65$var$MessageDirection = {}));
class $2b0c679ba56e5e65$var$RegistrationType {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ ____;
    method;
    constructor(method){
        this.method = method;
    }
}
module.exports.RegistrationType = $2b0c679ba56e5e65$var$RegistrationType;
class $2b0c679ba56e5e65$var$ProtocolRequestType0 extends $d8V62.RequestType0 {
    /**
     * Clients must not use these properties. They are here to ensure correct typing.
     * in TypeScript
     */ __;
    ___;
    ____;
    _pr;
    constructor(method){
        super(method);
    }
}
module.exports.ProtocolRequestType0 = $2b0c679ba56e5e65$var$ProtocolRequestType0;
class $2b0c679ba56e5e65$var$ProtocolRequestType extends $d8V62.RequestType {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ __;
    ___;
    ____;
    _pr;
    constructor(method){
        super(method, $d8V62.ParameterStructures.byName);
    }
}
module.exports.ProtocolRequestType = $2b0c679ba56e5e65$var$ProtocolRequestType;
class $2b0c679ba56e5e65$var$ProtocolNotificationType0 extends $d8V62.NotificationType0 {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ ___;
    ____;
    constructor(method){
        super(method);
    }
}
module.exports.ProtocolNotificationType0 = $2b0c679ba56e5e65$var$ProtocolNotificationType0;
class $2b0c679ba56e5e65$var$ProtocolNotificationType extends $d8V62.NotificationType {
    /**
     * Clients must not use this property. It is here to ensure correct typing.
     */ ___;
    ____;
    constructor(method){
        super(method, $d8V62.ParameterStructures.byName);
    }
}
module.exports.ProtocolNotificationType = $2b0c679ba56e5e65$var$ProtocolNotificationType;
var $2b0c679ba56e5e65$var$CM;
(function(CM) {
    function create(client, server) {
        return {
            client: client,
            server: server
        };
    }
    CM.create = create;
})($2b0c679ba56e5e65$var$CM || (module.exports.CM = $2b0c679ba56e5e65$var$CM = {}));

});

parcelRegister("cbAAQ", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $8df2e5c85241ab94$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8df2e5c85241ab94$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8df2e5c85241ab94$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8df2e5c85241ab94$var$__createBinding(result, mod, k[i]);
        }
        $8df2e5c85241ab94$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeActionRequest = module.exports.DocumentSymbolRequest = module.exports.DocumentHighlightRequest = module.exports.ReferencesRequest = module.exports.DefinitionRequest = module.exports.SignatureHelpRequest = module.exports.SignatureHelpTriggerKind = module.exports.HoverRequest = module.exports.CompletionResolveRequest = module.exports.CompletionRequest = module.exports.CompletionTriggerKind = module.exports.PublishDiagnosticsNotification = module.exports.WatchKind = module.exports.GlobPattern = module.exports.RelativePattern = module.exports.FileChangeType = module.exports.DidChangeWatchedFilesNotification = module.exports.WillSaveTextDocumentWaitUntilRequest = module.exports.WillSaveTextDocumentNotification = module.exports.TextDocumentSaveReason = module.exports.DidSaveTextDocumentNotification = module.exports.DidCloseTextDocumentNotification = module.exports.DidChangeTextDocumentNotification = module.exports.TextDocumentContentChangeEvent = module.exports.DidOpenTextDocumentNotification = module.exports.TextDocumentSyncKind = module.exports.TelemetryEventNotification = module.exports.LogMessageNotification = module.exports.ShowMessageRequest = module.exports.ShowMessageNotification = module.exports.MessageType = module.exports.DidChangeConfigurationNotification = module.exports.ExitNotification = module.exports.ShutdownRequest = module.exports.InitializedNotification = module.exports.InitializeErrorCodes = module.exports.InitializeRequest = module.exports.WorkDoneProgressOptions = module.exports.TextDocumentRegistrationOptions = module.exports.StaticRegistrationOptions = module.exports.PositionEncodingKind = module.exports.RegularExpressionEngineKind = module.exports.FailureHandlingKind = module.exports.ResourceOperationKind = module.exports.UnregistrationRequest = module.exports.RegistrationRequest = module.exports.DocumentSelector = module.exports.NotebookCellTextDocumentFilter = module.exports.NotebookDocumentFilter = module.exports.TextDocumentFilter = void 0;
module.exports.UniquenessLevel = module.exports.WillDeleteFilesRequest = module.exports.DidDeleteFilesNotification = module.exports.WillRenameFilesRequest = module.exports.DidRenameFilesNotification = module.exports.WillCreateFilesRequest = module.exports.DidCreateFilesNotification = module.exports.FileOperationPatternKind = module.exports.LinkedEditingRangeRequest = module.exports.ShowDocumentRequest = module.exports.SemanticTokensRegistrationType = module.exports.SemanticTokensRefreshRequest = module.exports.SemanticTokensRangeRequest = module.exports.SemanticTokensDeltaRequest = module.exports.SemanticTokensRequest = module.exports.TokenFormat = module.exports.CallHierarchyPrepareRequest = module.exports.CallHierarchyOutgoingCallsRequest = module.exports.CallHierarchyIncomingCallsRequest = module.exports.WorkDoneProgressCancelNotification = module.exports.WorkDoneProgressCreateRequest = module.exports.WorkDoneProgress = module.exports.SelectionRangeRequest = module.exports.DeclarationRequest = module.exports.FoldingRangeRefreshRequest = module.exports.FoldingRangeRequest = module.exports.ColorPresentationRequest = module.exports.DocumentColorRequest = module.exports.ConfigurationRequest = module.exports.DidChangeWorkspaceFoldersNotification = module.exports.WorkspaceFoldersRequest = module.exports.TypeDefinitionRequest = module.exports.ImplementationRequest = module.exports.ApplyWorkspaceEditRequest = module.exports.ExecuteCommandRequest = module.exports.PrepareRenameRequest = module.exports.RenameRequest = module.exports.PrepareSupportDefaultBehavior = module.exports.DocumentOnTypeFormattingRequest = module.exports.DocumentRangesFormattingRequest = module.exports.DocumentRangeFormattingRequest = module.exports.DocumentFormattingRequest = module.exports.DocumentLinkResolveRequest = module.exports.DocumentLinkRequest = module.exports.CodeLensRefreshRequest = module.exports.CodeLensResolveRequest = module.exports.CodeLensRequest = module.exports.WorkspaceSymbolResolveRequest = module.exports.WorkspaceSymbolRequest = module.exports.CodeActionResolveRequest = void 0;
module.exports.TextDocumentContentRefreshRequest = module.exports.TextDocumentContentRequest = module.exports.InlineCompletionRequest = module.exports.DidCloseNotebookDocumentNotification = module.exports.DidSaveNotebookDocumentNotification = module.exports.DidChangeNotebookDocumentNotification = module.exports.NotebookCellArrayChange = module.exports.DidOpenNotebookDocumentNotification = module.exports.NotebookDocumentSyncRegistrationType = module.exports.NotebookDocument = module.exports.NotebookCell = module.exports.ExecutionSummary = module.exports.NotebookCellKind = module.exports.DiagnosticRefreshRequest = module.exports.WorkspaceDiagnosticRequest = module.exports.DocumentDiagnosticRequest = module.exports.DocumentDiagnosticReportKind = module.exports.DiagnosticServerCancellationData = module.exports.InlayHintRefreshRequest = module.exports.InlayHintResolveRequest = module.exports.InlayHintRequest = module.exports.InlineValueRefreshRequest = module.exports.InlineValueRequest = module.exports.TypeHierarchySupertypesRequest = module.exports.TypeHierarchySubtypesRequest = module.exports.TypeHierarchyPrepareRequest = module.exports.MonikerRequest = module.exports.MonikerKind = void 0;

var $3H92V = parcelRequire("3H92V");

var $bDmGd = parcelRequire("bDmGd");

const $8df2e5c85241ab94$var$Is = $8df2e5c85241ab94$var$__importStar((parcelRequire("25XFm")));

var $97KA5 = parcelRequire("97KA5");
Object.defineProperty(module.exports, "ImplementationRequest", {
    enumerable: true,
    get: function() {
        return $97KA5.ImplementationRequest;
    }
});

var $6JJv1 = parcelRequire("6JJv1");
Object.defineProperty(module.exports, "TypeDefinitionRequest", {
    enumerable: true,
    get: function() {
        return $6JJv1.TypeDefinitionRequest;
    }
});

var $sUsTH = parcelRequire("sUsTH");
Object.defineProperty(module.exports, "WorkspaceFoldersRequest", {
    enumerable: true,
    get: function() {
        return $sUsTH.WorkspaceFoldersRequest;
    }
});
Object.defineProperty(module.exports, "DidChangeWorkspaceFoldersNotification", {
    enumerable: true,
    get: function() {
        return $sUsTH.DidChangeWorkspaceFoldersNotification;
    }
});

var $2KSOJ = parcelRequire("2KSOJ");
Object.defineProperty(module.exports, "ConfigurationRequest", {
    enumerable: true,
    get: function() {
        return $2KSOJ.ConfigurationRequest;
    }
});

var $jJgmL = parcelRequire("jJgmL");
Object.defineProperty(module.exports, "DocumentColorRequest", {
    enumerable: true,
    get: function() {
        return $jJgmL.DocumentColorRequest;
    }
});
Object.defineProperty(module.exports, "ColorPresentationRequest", {
    enumerable: true,
    get: function() {
        return $jJgmL.ColorPresentationRequest;
    }
});

var $2SIvv = parcelRequire("2SIvv");
Object.defineProperty(module.exports, "FoldingRangeRequest", {
    enumerable: true,
    get: function() {
        return $2SIvv.FoldingRangeRequest;
    }
});
Object.defineProperty(module.exports, "FoldingRangeRefreshRequest", {
    enumerable: true,
    get: function() {
        return $2SIvv.FoldingRangeRefreshRequest;
    }
});

var $kqiKa = parcelRequire("kqiKa");
Object.defineProperty(module.exports, "DeclarationRequest", {
    enumerable: true,
    get: function() {
        return $kqiKa.DeclarationRequest;
    }
});

var $gyIv8 = parcelRequire("gyIv8");
Object.defineProperty(module.exports, "SelectionRangeRequest", {
    enumerable: true,
    get: function() {
        return $gyIv8.SelectionRangeRequest;
    }
});

var $iWqXu = parcelRequire("iWqXu");
Object.defineProperty(module.exports, "WorkDoneProgress", {
    enumerable: true,
    get: function() {
        return $iWqXu.WorkDoneProgress;
    }
});
Object.defineProperty(module.exports, "WorkDoneProgressCreateRequest", {
    enumerable: true,
    get: function() {
        return $iWqXu.WorkDoneProgressCreateRequest;
    }
});
Object.defineProperty(module.exports, "WorkDoneProgressCancelNotification", {
    enumerable: true,
    get: function() {
        return $iWqXu.WorkDoneProgressCancelNotification;
    }
});

var $1lRx1 = parcelRequire("1lRx1");
Object.defineProperty(module.exports, "CallHierarchyIncomingCallsRequest", {
    enumerable: true,
    get: function() {
        return $1lRx1.CallHierarchyIncomingCallsRequest;
    }
});
Object.defineProperty(module.exports, "CallHierarchyOutgoingCallsRequest", {
    enumerable: true,
    get: function() {
        return $1lRx1.CallHierarchyOutgoingCallsRequest;
    }
});
Object.defineProperty(module.exports, "CallHierarchyPrepareRequest", {
    enumerable: true,
    get: function() {
        return $1lRx1.CallHierarchyPrepareRequest;
    }
});

var $lxKTK = parcelRequire("lxKTK");
Object.defineProperty(module.exports, "TokenFormat", {
    enumerable: true,
    get: function() {
        return $lxKTK.TokenFormat;
    }
});
Object.defineProperty(module.exports, "SemanticTokensRequest", {
    enumerable: true,
    get: function() {
        return $lxKTK.SemanticTokensRequest;
    }
});
Object.defineProperty(module.exports, "SemanticTokensDeltaRequest", {
    enumerable: true,
    get: function() {
        return $lxKTK.SemanticTokensDeltaRequest;
    }
});
Object.defineProperty(module.exports, "SemanticTokensRangeRequest", {
    enumerable: true,
    get: function() {
        return $lxKTK.SemanticTokensRangeRequest;
    }
});
Object.defineProperty(module.exports, "SemanticTokensRefreshRequest", {
    enumerable: true,
    get: function() {
        return $lxKTK.SemanticTokensRefreshRequest;
    }
});
Object.defineProperty(module.exports, "SemanticTokensRegistrationType", {
    enumerable: true,
    get: function() {
        return $lxKTK.SemanticTokensRegistrationType;
    }
});

var $dOzMQ = parcelRequire("dOzMQ");
Object.defineProperty(module.exports, "ShowDocumentRequest", {
    enumerable: true,
    get: function() {
        return $dOzMQ.ShowDocumentRequest;
    }
});

var $lGWTo = parcelRequire("lGWTo");
Object.defineProperty(module.exports, "LinkedEditingRangeRequest", {
    enumerable: true,
    get: function() {
        return $lGWTo.LinkedEditingRangeRequest;
    }
});

var $63R9N = parcelRequire("63R9N");
Object.defineProperty(module.exports, "FileOperationPatternKind", {
    enumerable: true,
    get: function() {
        return $63R9N.FileOperationPatternKind;
    }
});
Object.defineProperty(module.exports, "DidCreateFilesNotification", {
    enumerable: true,
    get: function() {
        return $63R9N.DidCreateFilesNotification;
    }
});
Object.defineProperty(module.exports, "WillCreateFilesRequest", {
    enumerable: true,
    get: function() {
        return $63R9N.WillCreateFilesRequest;
    }
});
Object.defineProperty(module.exports, "DidRenameFilesNotification", {
    enumerable: true,
    get: function() {
        return $63R9N.DidRenameFilesNotification;
    }
});
Object.defineProperty(module.exports, "WillRenameFilesRequest", {
    enumerable: true,
    get: function() {
        return $63R9N.WillRenameFilesRequest;
    }
});
Object.defineProperty(module.exports, "DidDeleteFilesNotification", {
    enumerable: true,
    get: function() {
        return $63R9N.DidDeleteFilesNotification;
    }
});
Object.defineProperty(module.exports, "WillDeleteFilesRequest", {
    enumerable: true,
    get: function() {
        return $63R9N.WillDeleteFilesRequest;
    }
});

var $lC7Bk = parcelRequire("lC7Bk");
Object.defineProperty(module.exports, "UniquenessLevel", {
    enumerable: true,
    get: function() {
        return $lC7Bk.UniquenessLevel;
    }
});
Object.defineProperty(module.exports, "MonikerKind", {
    enumerable: true,
    get: function() {
        return $lC7Bk.MonikerKind;
    }
});
Object.defineProperty(module.exports, "MonikerRequest", {
    enumerable: true,
    get: function() {
        return $lC7Bk.MonikerRequest;
    }
});

var $hVz0q = parcelRequire("hVz0q");
Object.defineProperty(module.exports, "TypeHierarchyPrepareRequest", {
    enumerable: true,
    get: function() {
        return $hVz0q.TypeHierarchyPrepareRequest;
    }
});
Object.defineProperty(module.exports, "TypeHierarchySubtypesRequest", {
    enumerable: true,
    get: function() {
        return $hVz0q.TypeHierarchySubtypesRequest;
    }
});
Object.defineProperty(module.exports, "TypeHierarchySupertypesRequest", {
    enumerable: true,
    get: function() {
        return $hVz0q.TypeHierarchySupertypesRequest;
    }
});

var $l6Gsn = parcelRequire("l6Gsn");
Object.defineProperty(module.exports, "InlineValueRequest", {
    enumerable: true,
    get: function() {
        return $l6Gsn.InlineValueRequest;
    }
});
Object.defineProperty(module.exports, "InlineValueRefreshRequest", {
    enumerable: true,
    get: function() {
        return $l6Gsn.InlineValueRefreshRequest;
    }
});

var $jVKwQ = parcelRequire("jVKwQ");
Object.defineProperty(module.exports, "InlayHintRequest", {
    enumerable: true,
    get: function() {
        return $jVKwQ.InlayHintRequest;
    }
});
Object.defineProperty(module.exports, "InlayHintResolveRequest", {
    enumerable: true,
    get: function() {
        return $jVKwQ.InlayHintResolveRequest;
    }
});
Object.defineProperty(module.exports, "InlayHintRefreshRequest", {
    enumerable: true,
    get: function() {
        return $jVKwQ.InlayHintRefreshRequest;
    }
});

var $byx7q = parcelRequire("byx7q");
Object.defineProperty(module.exports, "DiagnosticServerCancellationData", {
    enumerable: true,
    get: function() {
        return $byx7q.DiagnosticServerCancellationData;
    }
});
Object.defineProperty(module.exports, "DocumentDiagnosticReportKind", {
    enumerable: true,
    get: function() {
        return $byx7q.DocumentDiagnosticReportKind;
    }
});
Object.defineProperty(module.exports, "DocumentDiagnosticRequest", {
    enumerable: true,
    get: function() {
        return $byx7q.DocumentDiagnosticRequest;
    }
});
Object.defineProperty(module.exports, "WorkspaceDiagnosticRequest", {
    enumerable: true,
    get: function() {
        return $byx7q.WorkspaceDiagnosticRequest;
    }
});
Object.defineProperty(module.exports, "DiagnosticRefreshRequest", {
    enumerable: true,
    get: function() {
        return $byx7q.DiagnosticRefreshRequest;
    }
});

var $dt953 = parcelRequire("dt953");
Object.defineProperty(module.exports, "NotebookCellKind", {
    enumerable: true,
    get: function() {
        return $dt953.NotebookCellKind;
    }
});
Object.defineProperty(module.exports, "ExecutionSummary", {
    enumerable: true,
    get: function() {
        return $dt953.ExecutionSummary;
    }
});
Object.defineProperty(module.exports, "NotebookCell", {
    enumerable: true,
    get: function() {
        return $dt953.NotebookCell;
    }
});
Object.defineProperty(module.exports, "NotebookDocument", {
    enumerable: true,
    get: function() {
        return $dt953.NotebookDocument;
    }
});
Object.defineProperty(module.exports, "NotebookDocumentSyncRegistrationType", {
    enumerable: true,
    get: function() {
        return $dt953.NotebookDocumentSyncRegistrationType;
    }
});
Object.defineProperty(module.exports, "DidOpenNotebookDocumentNotification", {
    enumerable: true,
    get: function() {
        return $dt953.DidOpenNotebookDocumentNotification;
    }
});
Object.defineProperty(module.exports, "NotebookCellArrayChange", {
    enumerable: true,
    get: function() {
        return $dt953.NotebookCellArrayChange;
    }
});
Object.defineProperty(module.exports, "DidChangeNotebookDocumentNotification", {
    enumerable: true,
    get: function() {
        return $dt953.DidChangeNotebookDocumentNotification;
    }
});
Object.defineProperty(module.exports, "DidSaveNotebookDocumentNotification", {
    enumerable: true,
    get: function() {
        return $dt953.DidSaveNotebookDocumentNotification;
    }
});
Object.defineProperty(module.exports, "DidCloseNotebookDocumentNotification", {
    enumerable: true,
    get: function() {
        return $dt953.DidCloseNotebookDocumentNotification;
    }
});

var $8PeYO = parcelRequire("8PeYO");
Object.defineProperty(module.exports, "InlineCompletionRequest", {
    enumerable: true,
    get: function() {
        return $8PeYO.InlineCompletionRequest;
    }
});

var $ezXZK = parcelRequire("ezXZK");
Object.defineProperty(module.exports, "TextDocumentContentRequest", {
    enumerable: true,
    get: function() {
        return $ezXZK.TextDocumentContentRequest;
    }
});
Object.defineProperty(module.exports, "TextDocumentContentRefreshRequest", {
    enumerable: true,
    get: function() {
        return $ezXZK.TextDocumentContentRefreshRequest;
    }
});
// @ts-ignore: to avoid inlining LocationLink as dynamic import
let $8df2e5c85241ab94$var$__noDynamicImport;
/**
 * The TextDocumentFilter namespace provides helper functions to work with
 * {@link TextDocumentFilter} literals.
 *
 * @since 3.17.0
 */ var $8df2e5c85241ab94$var$TextDocumentFilter;
(function(TextDocumentFilter) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.string(candidate) || $8df2e5c85241ab94$var$Is.string(candidate.language) || $8df2e5c85241ab94$var$Is.string(candidate.scheme) || $8df2e5c85241ab94$var$GlobPattern.is(candidate.pattern);
    }
    TextDocumentFilter.is = is;
})($8df2e5c85241ab94$var$TextDocumentFilter || (module.exports.TextDocumentFilter = $8df2e5c85241ab94$var$TextDocumentFilter = {}));
/**
 * The NotebookDocumentFilter namespace provides helper functions to work with
 * {@link NotebookDocumentFilter} literals.
 *
 * @since 3.17.0
 */ var $8df2e5c85241ab94$var$NotebookDocumentFilter;
(function(NotebookDocumentFilter) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.objectLiteral(candidate) && ($8df2e5c85241ab94$var$Is.string(candidate.notebookType) || $8df2e5c85241ab94$var$Is.string(candidate.scheme) || $8df2e5c85241ab94$var$Is.string(candidate.pattern));
    }
    NotebookDocumentFilter.is = is;
})($8df2e5c85241ab94$var$NotebookDocumentFilter || (module.exports.NotebookDocumentFilter = $8df2e5c85241ab94$var$NotebookDocumentFilter = {}));
/**
 * The NotebookCellTextDocumentFilter namespace provides helper functions to work with
 * {@link NotebookCellTextDocumentFilter} literals.
 *
 * @since 3.17.0
 */ var $8df2e5c85241ab94$var$NotebookCellTextDocumentFilter;
(function(NotebookCellTextDocumentFilter) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.objectLiteral(candidate) && ($8df2e5c85241ab94$var$Is.string(candidate.notebook) || $8df2e5c85241ab94$var$NotebookDocumentFilter.is(candidate.notebook)) && (candidate.language === undefined || $8df2e5c85241ab94$var$Is.string(candidate.language));
    }
    NotebookCellTextDocumentFilter.is = is;
})($8df2e5c85241ab94$var$NotebookCellTextDocumentFilter || (module.exports.NotebookCellTextDocumentFilter = $8df2e5c85241ab94$var$NotebookCellTextDocumentFilter = {}));
/**
 * The DocumentSelector namespace provides helper functions to work with
 * {@link DocumentSelector}s.
 */ var $8df2e5c85241ab94$var$DocumentSelector;
(function(DocumentSelector) {
    function is(value) {
        if (!Array.isArray(value)) return false;
        for (const elem of value){
            if (!$8df2e5c85241ab94$var$Is.string(elem) && !$8df2e5c85241ab94$var$TextDocumentFilter.is(elem) && !$8df2e5c85241ab94$var$NotebookCellTextDocumentFilter.is(elem)) return false;
        }
        return true;
    }
    DocumentSelector.is = is;
})($8df2e5c85241ab94$var$DocumentSelector || (module.exports.DocumentSelector = $8df2e5c85241ab94$var$DocumentSelector = {}));
/**
 * The `client/registerCapability` request is sent from the server to the client to register a new capability
 * handler on the client side.
 */ var $8df2e5c85241ab94$var$RegistrationRequest;
(function(RegistrationRequest) {
    RegistrationRequest.method = 'client/registerCapability';
    RegistrationRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    RegistrationRequest.type = new $3H92V.ProtocolRequestType(RegistrationRequest.method);
})($8df2e5c85241ab94$var$RegistrationRequest || (module.exports.RegistrationRequest = $8df2e5c85241ab94$var$RegistrationRequest = {}));
/**
 * The `client/unregisterCapability` request is sent from the server to the client to unregister a previously registered capability
 * handler on the client side.
 */ var $8df2e5c85241ab94$var$UnregistrationRequest;
(function(UnregistrationRequest) {
    UnregistrationRequest.method = 'client/unregisterCapability';
    UnregistrationRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    UnregistrationRequest.type = new $3H92V.ProtocolRequestType(UnregistrationRequest.method);
})($8df2e5c85241ab94$var$UnregistrationRequest || (module.exports.UnregistrationRequest = $8df2e5c85241ab94$var$UnregistrationRequest = {}));
var $8df2e5c85241ab94$var$ResourceOperationKind;
(function(ResourceOperationKind) {
    /**
     * Supports creating new files and folders.
     */ ResourceOperationKind.Create = 'create';
    /**
     * Supports renaming existing files and folders.
     */ ResourceOperationKind.Rename = 'rename';
    /**
     * Supports deleting existing files and folders.
     */ ResourceOperationKind.Delete = 'delete';
})($8df2e5c85241ab94$var$ResourceOperationKind || (module.exports.ResourceOperationKind = $8df2e5c85241ab94$var$ResourceOperationKind = {}));
var $8df2e5c85241ab94$var$FailureHandlingKind;
(function(FailureHandlingKind) {
    /**
     * Applying the workspace change is simply aborted if one of the changes provided
     * fails. All operations executed before the failing operation stay executed.
     */ FailureHandlingKind.Abort = 'abort';
    /**
     * All operations are executed transactional. That means they either all
     * succeed or no changes at all are applied to the workspace.
     */ FailureHandlingKind.Transactional = 'transactional';
    /**
     * If the workspace edit contains only textual file changes they are executed transactional.
     * If resource changes (create, rename or delete file) are part of the change the failure
     * handling strategy is abort.
     */ FailureHandlingKind.TextOnlyTransactional = 'textOnlyTransactional';
    /**
     * The client tries to undo the operations already executed. But there is no
     * guarantee that this is succeeding.
     */ FailureHandlingKind.Undo = 'undo';
})($8df2e5c85241ab94$var$FailureHandlingKind || (module.exports.FailureHandlingKind = $8df2e5c85241ab94$var$FailureHandlingKind = {}));
/**
 * Regular Expression Engines
 *
 * @since 3.18.0
 */ var $8df2e5c85241ab94$var$RegularExpressionEngineKind;
(function(RegularExpressionEngineKind) {
    RegularExpressionEngineKind.ES2020 = 'ES2020';
})($8df2e5c85241ab94$var$RegularExpressionEngineKind || (module.exports.RegularExpressionEngineKind = $8df2e5c85241ab94$var$RegularExpressionEngineKind = {}));
/**
 * A set of predefined position encoding kinds.
 *
 * @since 3.17.0
 */ var $8df2e5c85241ab94$var$PositionEncodingKind;
(function(PositionEncodingKind) {
    /**
     * Character offsets count UTF-8 code units (e.g. bytes).
     */ PositionEncodingKind.UTF8 = 'utf-8';
    /**
     * Character offsets count UTF-16 code units.
     *
     * This is the default and must always be supported
     * by servers
     */ PositionEncodingKind.UTF16 = 'utf-16';
    /**
     * Character offsets count UTF-32 code units.
     *
     * Implementation note: these are the same as Unicode codepoints,
     * so this `PositionEncodingKind` may also be used for an
     * encoding-agnostic representation of character offsets.
     */ PositionEncodingKind.UTF32 = 'utf-32';
})($8df2e5c85241ab94$var$PositionEncodingKind || (module.exports.PositionEncodingKind = $8df2e5c85241ab94$var$PositionEncodingKind = {}));
/**
 * The StaticRegistrationOptions namespace provides helper functions to work with
 * {@link StaticRegistrationOptions} literals.
 */ var $8df2e5c85241ab94$var$StaticRegistrationOptions;
(function(StaticRegistrationOptions) {
    function hasId(value) {
        const candidate = value;
        return candidate && $8df2e5c85241ab94$var$Is.string(candidate.id) && candidate.id.length > 0;
    }
    StaticRegistrationOptions.hasId = hasId;
})($8df2e5c85241ab94$var$StaticRegistrationOptions || (module.exports.StaticRegistrationOptions = $8df2e5c85241ab94$var$StaticRegistrationOptions = {}));
/**
 * The TextDocumentRegistrationOptions namespace provides helper functions to work with
 * {@link TextDocumentRegistrationOptions} literals.
 */ var $8df2e5c85241ab94$var$TextDocumentRegistrationOptions;
(function(TextDocumentRegistrationOptions) {
    function is(value) {
        const candidate = value;
        return candidate && (candidate.documentSelector === null || $8df2e5c85241ab94$var$DocumentSelector.is(candidate.documentSelector));
    }
    TextDocumentRegistrationOptions.is = is;
})($8df2e5c85241ab94$var$TextDocumentRegistrationOptions || (module.exports.TextDocumentRegistrationOptions = $8df2e5c85241ab94$var$TextDocumentRegistrationOptions = {}));
/**
 * The WorkDoneProgressOptions namespace provides helper functions to work with
 * {@link WorkDoneProgressOptions} literals.
 */ var $8df2e5c85241ab94$var$WorkDoneProgressOptions;
(function(WorkDoneProgressOptions) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.objectLiteral(candidate) && (candidate.workDoneProgress === undefined || $8df2e5c85241ab94$var$Is.boolean(candidate.workDoneProgress));
    }
    WorkDoneProgressOptions.is = is;
    function hasWorkDoneProgress(value) {
        const candidate = value;
        return candidate && $8df2e5c85241ab94$var$Is.boolean(candidate.workDoneProgress);
    }
    WorkDoneProgressOptions.hasWorkDoneProgress = hasWorkDoneProgress;
})($8df2e5c85241ab94$var$WorkDoneProgressOptions || (module.exports.WorkDoneProgressOptions = $8df2e5c85241ab94$var$WorkDoneProgressOptions = {}));
/**
 * The initialize request is sent from the client to the server.
 * It is sent once as the request after starting up the server.
 * The requests parameter is of type {@link InitializeParams}
 * the response if of type {@link InitializeResult} of a Thenable that
 * resolves to such.
 */ var $8df2e5c85241ab94$var$InitializeRequest;
(function(InitializeRequest) {
    InitializeRequest.method = 'initialize';
    InitializeRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    InitializeRequest.type = new $3H92V.ProtocolRequestType(InitializeRequest.method);
})($8df2e5c85241ab94$var$InitializeRequest || (module.exports.InitializeRequest = $8df2e5c85241ab94$var$InitializeRequest = {}));
/**
 * Known error codes for an `InitializeErrorCodes`;
 */ var $8df2e5c85241ab94$var$InitializeErrorCodes;
(function(InitializeErrorCodes) {
    /**
     * If the protocol version provided by the client can't be handled by the server.
     *
     * @deprecated This initialize error got replaced by client capabilities. There is
     * no version handshake in version 3.0x
     */ InitializeErrorCodes.unknownProtocolVersion = 1;
})($8df2e5c85241ab94$var$InitializeErrorCodes || (module.exports.InitializeErrorCodes = $8df2e5c85241ab94$var$InitializeErrorCodes = {}));
/**
 * The initialized notification is sent from the client to the
 * server after the client is fully initialized and the server
 * is allowed to send requests from the server to the client.
 */ var $8df2e5c85241ab94$var$InitializedNotification;
(function(InitializedNotification) {
    InitializedNotification.method = 'initialized';
    InitializedNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    InitializedNotification.type = new $3H92V.ProtocolNotificationType(InitializedNotification.method);
})($8df2e5c85241ab94$var$InitializedNotification || (module.exports.InitializedNotification = $8df2e5c85241ab94$var$InitializedNotification = {}));
//---- Shutdown Method ----
/**
 * A shutdown request is sent from the client to the server.
 * It is sent once when the client decides to shutdown the
 * server. The only notification that is sent after a shutdown request
 * is the exit event.
 */ var $8df2e5c85241ab94$var$ShutdownRequest;
(function(ShutdownRequest) {
    ShutdownRequest.method = 'shutdown';
    ShutdownRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    ShutdownRequest.type = new $3H92V.ProtocolRequestType0(ShutdownRequest.method);
})($8df2e5c85241ab94$var$ShutdownRequest || (module.exports.ShutdownRequest = $8df2e5c85241ab94$var$ShutdownRequest = {}));
//---- Exit Notification ----
/**
 * The exit event is sent from the client to the server to
 * ask the server to exit its process.
 */ var $8df2e5c85241ab94$var$ExitNotification;
(function(ExitNotification) {
    ExitNotification.method = 'exit';
    ExitNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    ExitNotification.type = new $3H92V.ProtocolNotificationType0(ExitNotification.method);
})($8df2e5c85241ab94$var$ExitNotification || (module.exports.ExitNotification = $8df2e5c85241ab94$var$ExitNotification = {}));
/**
 * The configuration change notification is sent from the client to the server
 * when the client's configuration has changed. The notification contains
 * the changed configuration as defined by the language client.
 */ var $8df2e5c85241ab94$var$DidChangeConfigurationNotification;
(function(DidChangeConfigurationNotification) {
    DidChangeConfigurationNotification.method = 'workspace/didChangeConfiguration';
    DidChangeConfigurationNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidChangeConfigurationNotification.type = new $3H92V.ProtocolNotificationType(DidChangeConfigurationNotification.method);
    DidChangeConfigurationNotification.capabilities = $3H92V.CM.create('workspace.didChangeConfiguration', undefined);
})($8df2e5c85241ab94$var$DidChangeConfigurationNotification || (module.exports.DidChangeConfigurationNotification = $8df2e5c85241ab94$var$DidChangeConfigurationNotification = {}));
//---- Message show and log notifications ----
/**
 * The message type
 */ var $8df2e5c85241ab94$var$MessageType;
(function(MessageType) {
    /**
     * An error message.
     */ MessageType.Error = 1;
    /**
     * A warning message.
     */ MessageType.Warning = 2;
    /**
     * An information message.
     */ MessageType.Info = 3;
    /**
     * A log message.
     */ MessageType.Log = 4;
    /**
     * A debug message.
     *
     * @since 3.18.0
     */ MessageType.Debug = 5;
})($8df2e5c85241ab94$var$MessageType || (module.exports.MessageType = $8df2e5c85241ab94$var$MessageType = {}));
/**
 * The show message notification is sent from a server to a client to ask
 * the client to display a particular message in the user interface.
 */ var $8df2e5c85241ab94$var$ShowMessageNotification;
(function(ShowMessageNotification) {
    ShowMessageNotification.method = 'window/showMessage';
    ShowMessageNotification.messageDirection = $3H92V.MessageDirection.serverToClient;
    ShowMessageNotification.type = new $3H92V.ProtocolNotificationType(ShowMessageNotification.method);
    ShowMessageNotification.capabilities = $3H92V.CM.create('window.showMessage', undefined);
})($8df2e5c85241ab94$var$ShowMessageNotification || (module.exports.ShowMessageNotification = $8df2e5c85241ab94$var$ShowMessageNotification = {}));
/**
 * The show message request is sent from the server to the client to show a message
 * and a set of options actions to the user.
 */ var $8df2e5c85241ab94$var$ShowMessageRequest;
(function(ShowMessageRequest) {
    ShowMessageRequest.method = 'window/showMessageRequest';
    ShowMessageRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    ShowMessageRequest.type = new $3H92V.ProtocolRequestType(ShowMessageRequest.method);
    ShowMessageRequest.capabilities = $3H92V.CM.create('window.showMessage', undefined);
})($8df2e5c85241ab94$var$ShowMessageRequest || (module.exports.ShowMessageRequest = $8df2e5c85241ab94$var$ShowMessageRequest = {}));
/**
 * The log message notification is sent from the server to the client to ask
 * the client to log a particular message.
 */ var $8df2e5c85241ab94$var$LogMessageNotification;
(function(LogMessageNotification) {
    LogMessageNotification.method = 'window/logMessage';
    LogMessageNotification.messageDirection = $3H92V.MessageDirection.serverToClient;
    LogMessageNotification.type = new $3H92V.ProtocolNotificationType(LogMessageNotification.method);
})($8df2e5c85241ab94$var$LogMessageNotification || (module.exports.LogMessageNotification = $8df2e5c85241ab94$var$LogMessageNotification = {}));
//---- Telemetry notification
/**
 * The telemetry event notification is sent from the server to the client to ask
 * the client to log telemetry data.
 */ var $8df2e5c85241ab94$var$TelemetryEventNotification;
(function(TelemetryEventNotification) {
    TelemetryEventNotification.method = 'telemetry/event';
    TelemetryEventNotification.messageDirection = $3H92V.MessageDirection.serverToClient;
    TelemetryEventNotification.type = new $3H92V.ProtocolNotificationType(TelemetryEventNotification.method);
})($8df2e5c85241ab94$var$TelemetryEventNotification || (module.exports.TelemetryEventNotification = $8df2e5c85241ab94$var$TelemetryEventNotification = {}));
/**
 * Defines how the host (editor) should sync
 * document changes to the language server.
 */ var $8df2e5c85241ab94$var$TextDocumentSyncKind;
(function(TextDocumentSyncKind) {
    /**
     * Documents should not be synced at all.
     */ TextDocumentSyncKind.None = 0;
    /**
     * Documents are synced by always sending the full content
     * of the document.
     */ TextDocumentSyncKind.Full = 1;
    /**
     * Documents are synced by sending the full content on open.
     * After that only incremental updates to the document are
     * send.
     */ TextDocumentSyncKind.Incremental = 2;
})($8df2e5c85241ab94$var$TextDocumentSyncKind || (module.exports.TextDocumentSyncKind = $8df2e5c85241ab94$var$TextDocumentSyncKind = {}));
/**
 * The document open notification is sent from the client to the server to signal
 * newly opened text documents. The document's truth is now managed by the client
 * and the server must not try to read the document's truth using the document's
 * uri. Open in this sense means it is managed by the client. It doesn't necessarily
 * mean that its content is presented in an editor. An open notification must not
 * be sent more than once without a corresponding close notification send before.
 * This means open and close notification must be balanced and the max open count
 * is one.
 */ var $8df2e5c85241ab94$var$DidOpenTextDocumentNotification;
(function(DidOpenTextDocumentNotification) {
    DidOpenTextDocumentNotification.method = 'textDocument/didOpen';
    DidOpenTextDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidOpenTextDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidOpenTextDocumentNotification.method);
    DidOpenTextDocumentNotification.capabilities = $3H92V.CM.create('textDocument.synchronization', 'textDocumentSync.openClose');
})($8df2e5c85241ab94$var$DidOpenTextDocumentNotification || (module.exports.DidOpenTextDocumentNotification = $8df2e5c85241ab94$var$DidOpenTextDocumentNotification = {}));
var $8df2e5c85241ab94$var$TextDocumentContentChangeEvent;
(function(TextDocumentContentChangeEvent) {
    /**
     * Checks whether the information describes a delta event.
     */ function isIncremental(event) {
        const candidate = event;
        return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range !== undefined && (candidate.rangeLength === undefined || typeof candidate.rangeLength === 'number');
    }
    TextDocumentContentChangeEvent.isIncremental = isIncremental;
    /**
     * Checks whether the information describes a full replacement event.
     */ function isFull(event) {
        const candidate = event;
        return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range === undefined && candidate.rangeLength === undefined;
    }
    TextDocumentContentChangeEvent.isFull = isFull;
})($8df2e5c85241ab94$var$TextDocumentContentChangeEvent || (module.exports.TextDocumentContentChangeEvent = $8df2e5c85241ab94$var$TextDocumentContentChangeEvent = {}));
/**
 * The document change notification is sent from the client to the server to signal
 * changes to a text document.
 */ var $8df2e5c85241ab94$var$DidChangeTextDocumentNotification;
(function(DidChangeTextDocumentNotification) {
    DidChangeTextDocumentNotification.method = 'textDocument/didChange';
    DidChangeTextDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidChangeTextDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidChangeTextDocumentNotification.method);
    DidChangeTextDocumentNotification.capabilities = $3H92V.CM.create('textDocument.synchronization', 'textDocumentSync');
})($8df2e5c85241ab94$var$DidChangeTextDocumentNotification || (module.exports.DidChangeTextDocumentNotification = $8df2e5c85241ab94$var$DidChangeTextDocumentNotification = {}));
/**
 * The document close notification is sent from the client to the server when
 * the document got closed in the client. The document's truth now exists where
 * the document's uri points to (e.g. if the document's uri is a file uri the
 * truth now exists on disk). As with the open notification the close notification
 * is about managing the document's content. Receiving a close notification
 * doesn't mean that the document was open in an editor before. A close
 * notification requires a previous open notification to be sent.
 */ var $8df2e5c85241ab94$var$DidCloseTextDocumentNotification;
(function(DidCloseTextDocumentNotification) {
    DidCloseTextDocumentNotification.method = 'textDocument/didClose';
    DidCloseTextDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidCloseTextDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidCloseTextDocumentNotification.method);
    DidCloseTextDocumentNotification.capabilities = $3H92V.CM.create('textDocument.synchronization', 'textDocumentSync.openClose');
})($8df2e5c85241ab94$var$DidCloseTextDocumentNotification || (module.exports.DidCloseTextDocumentNotification = $8df2e5c85241ab94$var$DidCloseTextDocumentNotification = {}));
/**
 * The document save notification is sent from the client to the server when
 * the document got saved in the client.
 */ var $8df2e5c85241ab94$var$DidSaveTextDocumentNotification;
(function(DidSaveTextDocumentNotification) {
    DidSaveTextDocumentNotification.method = 'textDocument/didSave';
    DidSaveTextDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidSaveTextDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidSaveTextDocumentNotification.method);
    DidSaveTextDocumentNotification.capabilities = $3H92V.CM.create('textDocument.synchronization.didSave', 'textDocumentSync.save');
})($8df2e5c85241ab94$var$DidSaveTextDocumentNotification || (module.exports.DidSaveTextDocumentNotification = $8df2e5c85241ab94$var$DidSaveTextDocumentNotification = {}));
/**
 * Represents reasons why a text document is saved.
 */ var $8df2e5c85241ab94$var$TextDocumentSaveReason;
(function(TextDocumentSaveReason) {
    /**
     * Manually triggered, e.g. by the user pressing save, by starting debugging,
     * or by an API call.
     */ TextDocumentSaveReason.Manual = 1;
    /**
     * Automatic after a delay.
     */ TextDocumentSaveReason.AfterDelay = 2;
    /**
     * When the editor lost focus.
     */ TextDocumentSaveReason.FocusOut = 3;
})($8df2e5c85241ab94$var$TextDocumentSaveReason || (module.exports.TextDocumentSaveReason = $8df2e5c85241ab94$var$TextDocumentSaveReason = {}));
/**
 * A document will save notification is sent from the client to the server before
 * the document is actually saved.
 */ var $8df2e5c85241ab94$var$WillSaveTextDocumentNotification;
(function(WillSaveTextDocumentNotification) {
    WillSaveTextDocumentNotification.method = 'textDocument/willSave';
    WillSaveTextDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    WillSaveTextDocumentNotification.type = new $3H92V.ProtocolNotificationType(WillSaveTextDocumentNotification.method);
    WillSaveTextDocumentNotification.capabilities = $3H92V.CM.create('textDocument.synchronization.willSave', 'textDocumentSync.willSave');
})($8df2e5c85241ab94$var$WillSaveTextDocumentNotification || (module.exports.WillSaveTextDocumentNotification = $8df2e5c85241ab94$var$WillSaveTextDocumentNotification = {}));
/**
 * A document will save request is sent from the client to the server before
 * the document is actually saved. The request can return an array of TextEdits
 * which will be applied to the text document before it is saved. Please note that
 * clients might drop results if computing the text edits took too long or if a
 * server constantly fails on this request. This is done to keep the save fast and
 * reliable.
 */ var $8df2e5c85241ab94$var$WillSaveTextDocumentWaitUntilRequest;
(function(WillSaveTextDocumentWaitUntilRequest) {
    WillSaveTextDocumentWaitUntilRequest.method = 'textDocument/willSaveWaitUntil';
    WillSaveTextDocumentWaitUntilRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WillSaveTextDocumentWaitUntilRequest.type = new $3H92V.ProtocolRequestType(WillSaveTextDocumentWaitUntilRequest.method);
    WillSaveTextDocumentWaitUntilRequest.capabilities = $3H92V.CM.create('textDocument.synchronization.willSaveWaitUntil', 'textDocumentSync.willSaveWaitUntil');
})($8df2e5c85241ab94$var$WillSaveTextDocumentWaitUntilRequest || (module.exports.WillSaveTextDocumentWaitUntilRequest = $8df2e5c85241ab94$var$WillSaveTextDocumentWaitUntilRequest = {}));
/**
 * The watched files notification is sent from the client to the server when
 * the client detects changes to file watched by the language client.
 */ var $8df2e5c85241ab94$var$DidChangeWatchedFilesNotification;
(function(DidChangeWatchedFilesNotification) {
    DidChangeWatchedFilesNotification.method = 'workspace/didChangeWatchedFiles';
    DidChangeWatchedFilesNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidChangeWatchedFilesNotification.type = new $3H92V.ProtocolNotificationType(DidChangeWatchedFilesNotification.method);
    DidChangeWatchedFilesNotification.capabilities = $3H92V.CM.create('workspace.didChangeWatchedFiles', undefined);
})($8df2e5c85241ab94$var$DidChangeWatchedFilesNotification || (module.exports.DidChangeWatchedFilesNotification = $8df2e5c85241ab94$var$DidChangeWatchedFilesNotification = {}));
/**
 * The file event type
 */ var $8df2e5c85241ab94$var$FileChangeType;
(function(FileChangeType) {
    /**
     * The file got created.
     */ FileChangeType.Created = 1;
    /**
     * The file got changed.
     */ FileChangeType.Changed = 2;
    /**
     * The file got deleted.
     */ FileChangeType.Deleted = 3;
})($8df2e5c85241ab94$var$FileChangeType || (module.exports.FileChangeType = $8df2e5c85241ab94$var$FileChangeType = {}));
var $8df2e5c85241ab94$var$RelativePattern;
(function(RelativePattern) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.objectLiteral(candidate) && ($bDmGd.URI.is(candidate.baseUri) || $bDmGd.WorkspaceFolder.is(candidate.baseUri)) && $8df2e5c85241ab94$var$Is.string(candidate.pattern);
    }
    RelativePattern.is = is;
})($8df2e5c85241ab94$var$RelativePattern || (module.exports.RelativePattern = $8df2e5c85241ab94$var$RelativePattern = {}));
var $8df2e5c85241ab94$var$GlobPattern;
(function(GlobPattern) {
    function is(value) {
        const candidate = value;
        return $8df2e5c85241ab94$var$Is.string(candidate) || $8df2e5c85241ab94$var$RelativePattern.is(candidate);
    }
    GlobPattern.is = is;
})($8df2e5c85241ab94$var$GlobPattern || (module.exports.GlobPattern = $8df2e5c85241ab94$var$GlobPattern = {}));
var $8df2e5c85241ab94$var$WatchKind;
(function(WatchKind) {
    /**
     * Interested in create events.
     */ WatchKind.Create = 1;
    /**
     * Interested in change events
     */ WatchKind.Change = 2;
    /**
     * Interested in delete events
     */ WatchKind.Delete = 4;
})($8df2e5c85241ab94$var$WatchKind || (module.exports.WatchKind = $8df2e5c85241ab94$var$WatchKind = {}));
/**
 * Diagnostics notification are sent from the server to the client to signal
 * results of validation runs.
 */ var $8df2e5c85241ab94$var$PublishDiagnosticsNotification;
(function(PublishDiagnosticsNotification) {
    PublishDiagnosticsNotification.method = 'textDocument/publishDiagnostics';
    PublishDiagnosticsNotification.messageDirection = $3H92V.MessageDirection.serverToClient;
    PublishDiagnosticsNotification.type = new $3H92V.ProtocolNotificationType(PublishDiagnosticsNotification.method);
    PublishDiagnosticsNotification.capabilities = $3H92V.CM.create('textDocument.publishDiagnostics', undefined);
})($8df2e5c85241ab94$var$PublishDiagnosticsNotification || (module.exports.PublishDiagnosticsNotification = $8df2e5c85241ab94$var$PublishDiagnosticsNotification = {}));
/**
 * How a completion was triggered
 */ var $8df2e5c85241ab94$var$CompletionTriggerKind;
(function(CompletionTriggerKind) {
    /**
     * Completion was triggered by typing an identifier (24x7 code
     * complete), manual invocation (e.g Ctrl+Space) or via API.
     */ CompletionTriggerKind.Invoked = 1;
    /**
     * Completion was triggered by a trigger character specified by
     * the `triggerCharacters` properties of the `CompletionRegistrationOptions`.
     */ CompletionTriggerKind.TriggerCharacter = 2;
    /**
     * Completion was re-triggered as current completion list is incomplete
     */ CompletionTriggerKind.TriggerForIncompleteCompletions = 3;
})($8df2e5c85241ab94$var$CompletionTriggerKind || (module.exports.CompletionTriggerKind = $8df2e5c85241ab94$var$CompletionTriggerKind = {}));
/**
 * Request to request completion at a given text document position. The request's
 * parameter is of type {@link TextDocumentPosition} the response
 * is of type {@link CompletionItem CompletionItem[]} or {@link CompletionList}
 * or a Thenable that resolves to such.
 *
 * The request can delay the computation of the {@link CompletionItem.detail `detail`}
 * and {@link CompletionItem.documentation `documentation`} properties to the `completionItem/resolve`
 * request. However, properties that are needed for the initial sorting and filtering, like `sortText`,
 * `filterText`, `insertText`, and `textEdit`, must not be changed during resolve.
 */ var $8df2e5c85241ab94$var$CompletionRequest;
(function(CompletionRequest) {
    CompletionRequest.method = 'textDocument/completion';
    CompletionRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CompletionRequest.type = new $3H92V.ProtocolRequestType(CompletionRequest.method);
    CompletionRequest.capabilities = $3H92V.CM.create('textDocument.completion', 'completionProvider');
})($8df2e5c85241ab94$var$CompletionRequest || (module.exports.CompletionRequest = $8df2e5c85241ab94$var$CompletionRequest = {}));
/**
 * Request to resolve additional information for a given completion item.The request's
 * parameter is of type {@link CompletionItem} the response
 * is of type {@link CompletionItem} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$CompletionResolveRequest;
(function(CompletionResolveRequest) {
    CompletionResolveRequest.method = 'completionItem/resolve';
    CompletionResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CompletionResolveRequest.type = new $3H92V.ProtocolRequestType(CompletionResolveRequest.method);
    CompletionResolveRequest.capabilities = $3H92V.CM.create('textDocument.completion.completionItem.resolveSupport', 'completionProvider.resolveProvider');
})($8df2e5c85241ab94$var$CompletionResolveRequest || (module.exports.CompletionResolveRequest = $8df2e5c85241ab94$var$CompletionResolveRequest = {}));
/**
 * Request to request hover information at a given text document position. The request's
 * parameter is of type {@link TextDocumentPosition} the response is of
 * type {@link Hover} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$HoverRequest;
(function(HoverRequest) {
    HoverRequest.method = 'textDocument/hover';
    HoverRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    HoverRequest.type = new $3H92V.ProtocolRequestType(HoverRequest.method);
    HoverRequest.capabilities = $3H92V.CM.create('textDocument.hover', 'hoverProvider');
})($8df2e5c85241ab94$var$HoverRequest || (module.exports.HoverRequest = $8df2e5c85241ab94$var$HoverRequest = {}));
/**
 * How a signature help was triggered.
 *
 * @since 3.15.0
 */ var $8df2e5c85241ab94$var$SignatureHelpTriggerKind;
(function(SignatureHelpTriggerKind) {
    /**
     * Signature help was invoked manually by the user or by a command.
     */ SignatureHelpTriggerKind.Invoked = 1;
    /**
     * Signature help was triggered by a trigger character.
     */ SignatureHelpTriggerKind.TriggerCharacter = 2;
    /**
     * Signature help was triggered by the cursor moving or by the document content changing.
     */ SignatureHelpTriggerKind.ContentChange = 3;
})($8df2e5c85241ab94$var$SignatureHelpTriggerKind || (module.exports.SignatureHelpTriggerKind = $8df2e5c85241ab94$var$SignatureHelpTriggerKind = {}));
var $8df2e5c85241ab94$var$SignatureHelpRequest;
(function(SignatureHelpRequest) {
    SignatureHelpRequest.method = 'textDocument/signatureHelp';
    SignatureHelpRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    SignatureHelpRequest.type = new $3H92V.ProtocolRequestType(SignatureHelpRequest.method);
    SignatureHelpRequest.capabilities = $3H92V.CM.create('textDocument.signatureHelp', 'signatureHelpProvider');
})($8df2e5c85241ab94$var$SignatureHelpRequest || (module.exports.SignatureHelpRequest = $8df2e5c85241ab94$var$SignatureHelpRequest = {}));
/**
 * A request to resolve the definition location of a symbol at a given text
 * document position. The request's parameter is of type {@link TextDocumentPosition}
 * the response is of either type {@link Definition} or a typed array of
 * {@link DefinitionLink} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$DefinitionRequest;
(function(DefinitionRequest) {
    DefinitionRequest.method = 'textDocument/definition';
    DefinitionRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DefinitionRequest.type = new $3H92V.ProtocolRequestType(DefinitionRequest.method);
    DefinitionRequest.capabilities = $3H92V.CM.create('textDocument.definition', 'definitionProvider');
})($8df2e5c85241ab94$var$DefinitionRequest || (module.exports.DefinitionRequest = $8df2e5c85241ab94$var$DefinitionRequest = {}));
/**
 * A request to resolve project-wide references for the symbol denoted
 * by the given text document position. The request's parameter is of
 * type {@link ReferenceParams} the response is of type
 * {@link Location Location[]} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$ReferencesRequest;
(function(ReferencesRequest) {
    ReferencesRequest.method = 'textDocument/references';
    ReferencesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    ReferencesRequest.type = new $3H92V.ProtocolRequestType(ReferencesRequest.method);
    ReferencesRequest.capabilities = $3H92V.CM.create('textDocument.references', 'referencesProvider');
})($8df2e5c85241ab94$var$ReferencesRequest || (module.exports.ReferencesRequest = $8df2e5c85241ab94$var$ReferencesRequest = {}));
/**
 * Request to resolve a {@link DocumentHighlight} for a given
 * text document position. The request's parameter is of type {@link TextDocumentPosition}
 * the request response is an array of type {@link DocumentHighlight}
 * or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$DocumentHighlightRequest;
(function(DocumentHighlightRequest) {
    DocumentHighlightRequest.method = 'textDocument/documentHighlight';
    DocumentHighlightRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentHighlightRequest.type = new $3H92V.ProtocolRequestType(DocumentHighlightRequest.method);
    DocumentHighlightRequest.capabilities = $3H92V.CM.create('textDocument.documentHighlight', 'documentHighlightProvider');
})($8df2e5c85241ab94$var$DocumentHighlightRequest || (module.exports.DocumentHighlightRequest = $8df2e5c85241ab94$var$DocumentHighlightRequest = {}));
/**
 * A request to list all symbols found in a given text document. The request's
 * parameter is of type {@link TextDocumentIdentifier} the
 * response is of type {@link SymbolInformation SymbolInformation[]} or a Thenable
 * that resolves to such.
 */ var $8df2e5c85241ab94$var$DocumentSymbolRequest;
(function(DocumentSymbolRequest) {
    DocumentSymbolRequest.method = 'textDocument/documentSymbol';
    DocumentSymbolRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentSymbolRequest.type = new $3H92V.ProtocolRequestType(DocumentSymbolRequest.method);
    DocumentSymbolRequest.capabilities = $3H92V.CM.create('textDocument.documentSymbol', 'documentSymbolProvider');
})($8df2e5c85241ab94$var$DocumentSymbolRequest || (module.exports.DocumentSymbolRequest = $8df2e5c85241ab94$var$DocumentSymbolRequest = {}));
/**
 * A request to provide commands for the given text document and range.
 */ var $8df2e5c85241ab94$var$CodeActionRequest;
(function(CodeActionRequest) {
    CodeActionRequest.method = 'textDocument/codeAction';
    CodeActionRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CodeActionRequest.type = new $3H92V.ProtocolRequestType(CodeActionRequest.method);
    CodeActionRequest.capabilities = $3H92V.CM.create('textDocument.codeAction', 'codeActionProvider');
})($8df2e5c85241ab94$var$CodeActionRequest || (module.exports.CodeActionRequest = $8df2e5c85241ab94$var$CodeActionRequest = {}));
/**
 * Request to resolve additional information for a given code action.The request's
 * parameter is of type {@link CodeAction} the response
 * is of type {@link CodeAction} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$CodeActionResolveRequest;
(function(CodeActionResolveRequest) {
    CodeActionResolveRequest.method = 'codeAction/resolve';
    CodeActionResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CodeActionResolveRequest.type = new $3H92V.ProtocolRequestType(CodeActionResolveRequest.method);
    CodeActionResolveRequest.capabilities = $3H92V.CM.create('textDocument.codeAction.resolveSupport', 'codeActionProvider.resolveProvider');
})($8df2e5c85241ab94$var$CodeActionResolveRequest || (module.exports.CodeActionResolveRequest = $8df2e5c85241ab94$var$CodeActionResolveRequest = {}));
/**
 * A request to list project-wide symbols matching the query string given
 * by the {@link WorkspaceSymbolParams}. The response is
 * of type {@link SymbolInformation SymbolInformation[]} or a Thenable that
 * resolves to such.
 *
 * @since 3.17.0 - support for WorkspaceSymbol in the returned data. Clients
 *  need to advertise support for WorkspaceSymbols via the client capability
 *  `workspace.symbol.resolveSupport`.
 *
 */ var $8df2e5c85241ab94$var$WorkspaceSymbolRequest;
(function(WorkspaceSymbolRequest) {
    WorkspaceSymbolRequest.method = 'workspace/symbol';
    WorkspaceSymbolRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WorkspaceSymbolRequest.type = new $3H92V.ProtocolRequestType(WorkspaceSymbolRequest.method);
    WorkspaceSymbolRequest.capabilities = $3H92V.CM.create('workspace.symbol', 'workspaceSymbolProvider');
})($8df2e5c85241ab94$var$WorkspaceSymbolRequest || (module.exports.WorkspaceSymbolRequest = $8df2e5c85241ab94$var$WorkspaceSymbolRequest = {}));
/**
 * A request to resolve the range inside the workspace
 * symbol's location.
 *
 * @since 3.17.0
 */ var $8df2e5c85241ab94$var$WorkspaceSymbolResolveRequest;
(function(WorkspaceSymbolResolveRequest) {
    WorkspaceSymbolResolveRequest.method = 'workspaceSymbol/resolve';
    WorkspaceSymbolResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WorkspaceSymbolResolveRequest.type = new $3H92V.ProtocolRequestType(WorkspaceSymbolResolveRequest.method);
    WorkspaceSymbolResolveRequest.capabilities = $3H92V.CM.create('workspace.symbol.resolveSupport', 'workspaceSymbolProvider.resolveProvider');
})($8df2e5c85241ab94$var$WorkspaceSymbolResolveRequest || (module.exports.WorkspaceSymbolResolveRequest = $8df2e5c85241ab94$var$WorkspaceSymbolResolveRequest = {}));
/**
 * A request to provide code lens for the given text document.
 */ var $8df2e5c85241ab94$var$CodeLensRequest;
(function(CodeLensRequest) {
    CodeLensRequest.method = 'textDocument/codeLens';
    CodeLensRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CodeLensRequest.type = new $3H92V.ProtocolRequestType(CodeLensRequest.method);
    CodeLensRequest.capabilities = $3H92V.CM.create('textDocument.codeLens', 'codeLensProvider');
})($8df2e5c85241ab94$var$CodeLensRequest || (module.exports.CodeLensRequest = $8df2e5c85241ab94$var$CodeLensRequest = {}));
/**
 * A request to resolve a command for a given code lens.
 */ var $8df2e5c85241ab94$var$CodeLensResolveRequest;
(function(CodeLensResolveRequest) {
    CodeLensResolveRequest.method = 'codeLens/resolve';
    CodeLensResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CodeLensResolveRequest.type = new $3H92V.ProtocolRequestType(CodeLensResolveRequest.method);
    CodeLensResolveRequest.capabilities = $3H92V.CM.create('textDocument.codeLens.resolveSupport', 'codeLensProvider.resolveProvider');
})($8df2e5c85241ab94$var$CodeLensResolveRequest || (module.exports.CodeLensResolveRequest = $8df2e5c85241ab94$var$CodeLensResolveRequest = {}));
/**
 * A request to refresh all code actions
 *
 * @since 3.16.0
 */ var $8df2e5c85241ab94$var$CodeLensRefreshRequest;
(function(CodeLensRefreshRequest) {
    CodeLensRefreshRequest.method = `workspace/codeLens/refresh`;
    CodeLensRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    CodeLensRefreshRequest.type = new $3H92V.ProtocolRequestType0(CodeLensRefreshRequest.method);
    CodeLensRefreshRequest.capabilities = $3H92V.CM.create('workspace.codeLens', undefined);
})($8df2e5c85241ab94$var$CodeLensRefreshRequest || (module.exports.CodeLensRefreshRequest = $8df2e5c85241ab94$var$CodeLensRefreshRequest = {}));
/**
 * A request to provide document links
 */ var $8df2e5c85241ab94$var$DocumentLinkRequest;
(function(DocumentLinkRequest) {
    DocumentLinkRequest.method = 'textDocument/documentLink';
    DocumentLinkRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentLinkRequest.type = new $3H92V.ProtocolRequestType(DocumentLinkRequest.method);
    DocumentLinkRequest.capabilities = $3H92V.CM.create('textDocument.documentLink', 'documentLinkProvider');
})($8df2e5c85241ab94$var$DocumentLinkRequest || (module.exports.DocumentLinkRequest = $8df2e5c85241ab94$var$DocumentLinkRequest = {}));
/**
 * Request to resolve additional information for a given document link. The request's
 * parameter is of type {@link DocumentLink} the response
 * is of type {@link DocumentLink} or a Thenable that resolves to such.
 */ var $8df2e5c85241ab94$var$DocumentLinkResolveRequest;
(function(DocumentLinkResolveRequest) {
    DocumentLinkResolveRequest.method = 'documentLink/resolve';
    DocumentLinkResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentLinkResolveRequest.type = new $3H92V.ProtocolRequestType(DocumentLinkResolveRequest.method);
    DocumentLinkResolveRequest.capabilities = $3H92V.CM.create('textDocument.documentLink', 'documentLinkProvider.resolveProvider');
})($8df2e5c85241ab94$var$DocumentLinkResolveRequest || (module.exports.DocumentLinkResolveRequest = $8df2e5c85241ab94$var$DocumentLinkResolveRequest = {}));
/**
 * A request to format a whole document.
 */ var $8df2e5c85241ab94$var$DocumentFormattingRequest;
(function(DocumentFormattingRequest) {
    DocumentFormattingRequest.method = 'textDocument/formatting';
    DocumentFormattingRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentFormattingRequest.type = new $3H92V.ProtocolRequestType(DocumentFormattingRequest.method);
    DocumentFormattingRequest.capabilities = $3H92V.CM.create('textDocument.formatting', 'documentFormattingProvider');
})($8df2e5c85241ab94$var$DocumentFormattingRequest || (module.exports.DocumentFormattingRequest = $8df2e5c85241ab94$var$DocumentFormattingRequest = {}));
/**
 * A request to format a range in a document.
 */ var $8df2e5c85241ab94$var$DocumentRangeFormattingRequest;
(function(DocumentRangeFormattingRequest) {
    DocumentRangeFormattingRequest.method = 'textDocument/rangeFormatting';
    DocumentRangeFormattingRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentRangeFormattingRequest.type = new $3H92V.ProtocolRequestType(DocumentRangeFormattingRequest.method);
    DocumentRangeFormattingRequest.capabilities = $3H92V.CM.create('textDocument.rangeFormatting', 'documentRangeFormattingProvider');
})($8df2e5c85241ab94$var$DocumentRangeFormattingRequest || (module.exports.DocumentRangeFormattingRequest = $8df2e5c85241ab94$var$DocumentRangeFormattingRequest = {}));
/**
 * A request to format ranges in a document.
 *
 * @since 3.18.0
 */ var $8df2e5c85241ab94$var$DocumentRangesFormattingRequest;
(function(DocumentRangesFormattingRequest) {
    DocumentRangesFormattingRequest.method = 'textDocument/rangesFormatting';
    DocumentRangesFormattingRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentRangesFormattingRequest.type = new $3H92V.ProtocolRequestType(DocumentRangesFormattingRequest.method);
    DocumentRangesFormattingRequest.capabilities = $3H92V.CM.create('textDocument.rangeFormatting.rangesSupport', 'documentRangeFormattingProvider.rangesSupport');
})($8df2e5c85241ab94$var$DocumentRangesFormattingRequest || (module.exports.DocumentRangesFormattingRequest = $8df2e5c85241ab94$var$DocumentRangesFormattingRequest = {}));
/**
 * A request to format a document on type.
 */ var $8df2e5c85241ab94$var$DocumentOnTypeFormattingRequest;
(function(DocumentOnTypeFormattingRequest) {
    DocumentOnTypeFormattingRequest.method = 'textDocument/onTypeFormatting';
    DocumentOnTypeFormattingRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentOnTypeFormattingRequest.type = new $3H92V.ProtocolRequestType(DocumentOnTypeFormattingRequest.method);
    DocumentOnTypeFormattingRequest.capabilities = $3H92V.CM.create('textDocument.onTypeFormatting', 'documentOnTypeFormattingProvider');
})($8df2e5c85241ab94$var$DocumentOnTypeFormattingRequest || (module.exports.DocumentOnTypeFormattingRequest = $8df2e5c85241ab94$var$DocumentOnTypeFormattingRequest = {}));
//---- Rename ----------------------------------------------
var $8df2e5c85241ab94$var$PrepareSupportDefaultBehavior;
(function(PrepareSupportDefaultBehavior) {
    /**
     * The client's default behavior is to select the identifier
     * according the to language's syntax rule.
     */ PrepareSupportDefaultBehavior.Identifier = 1;
})($8df2e5c85241ab94$var$PrepareSupportDefaultBehavior || (module.exports.PrepareSupportDefaultBehavior = $8df2e5c85241ab94$var$PrepareSupportDefaultBehavior = {}));
/**
 * A request to rename a symbol.
 */ var $8df2e5c85241ab94$var$RenameRequest;
(function(RenameRequest) {
    RenameRequest.method = 'textDocument/rename';
    RenameRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    RenameRequest.type = new $3H92V.ProtocolRequestType(RenameRequest.method);
    RenameRequest.capabilities = $3H92V.CM.create('textDocument.rename', 'renameProvider');
})($8df2e5c85241ab94$var$RenameRequest || (module.exports.RenameRequest = $8df2e5c85241ab94$var$RenameRequest = {}));
/**
 * A request to test and perform the setup necessary for a rename.
 *
 * @since 3.16 - support for default behavior
 */ var $8df2e5c85241ab94$var$PrepareRenameRequest;
(function(PrepareRenameRequest) {
    PrepareRenameRequest.method = 'textDocument/prepareRename';
    PrepareRenameRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    PrepareRenameRequest.type = new $3H92V.ProtocolRequestType(PrepareRenameRequest.method);
    PrepareRenameRequest.capabilities = $3H92V.CM.create('textDocument.rename.prepareSupport', 'renameProvider.prepareProvider');
})($8df2e5c85241ab94$var$PrepareRenameRequest || (module.exports.PrepareRenameRequest = $8df2e5c85241ab94$var$PrepareRenameRequest = {}));
/**
 * A request send from the client to the server to execute a command. The request might return
 * a workspace edit which the client will apply to the workspace.
 */ var $8df2e5c85241ab94$var$ExecuteCommandRequest;
(function(ExecuteCommandRequest) {
    ExecuteCommandRequest.method = 'workspace/executeCommand';
    ExecuteCommandRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    ExecuteCommandRequest.type = new $3H92V.ProtocolRequestType(ExecuteCommandRequest.method);
    ExecuteCommandRequest.capabilities = $3H92V.CM.create('workspace.executeCommand', 'executeCommandProvider');
})($8df2e5c85241ab94$var$ExecuteCommandRequest || (module.exports.ExecuteCommandRequest = $8df2e5c85241ab94$var$ExecuteCommandRequest = {}));
/**
 * A request sent from the server to the client to modified certain resources.
 */ var $8df2e5c85241ab94$var$ApplyWorkspaceEditRequest;
(function(ApplyWorkspaceEditRequest) {
    ApplyWorkspaceEditRequest.method = 'workspace/applyEdit';
    ApplyWorkspaceEditRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    ApplyWorkspaceEditRequest.type = new $3H92V.ProtocolRequestType('workspace/applyEdit');
    ApplyWorkspaceEditRequest.capabilities = $3H92V.CM.create('workspace.applyEdit', undefined);
})($8df2e5c85241ab94$var$ApplyWorkspaceEditRequest || (module.exports.ApplyWorkspaceEditRequest = $8df2e5c85241ab94$var$ApplyWorkspaceEditRequest = {}));

});
parcelRegister("25XFm", function(module, exports) {
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolean = $186a54d49e3fa9d6$var$boolean;
module.exports.string = $186a54d49e3fa9d6$var$string;
module.exports.number = $186a54d49e3fa9d6$var$number;
module.exports.error = $186a54d49e3fa9d6$var$error;
module.exports.func = $186a54d49e3fa9d6$var$func;
module.exports.array = $186a54d49e3fa9d6$var$array;
module.exports.stringArray = $186a54d49e3fa9d6$var$stringArray;
module.exports.typedArray = $186a54d49e3fa9d6$var$typedArray;
module.exports.objectLiteral = $186a54d49e3fa9d6$var$objectLiteral;
function $186a54d49e3fa9d6$var$boolean(value) {
    return value === true || value === false;
}
function $186a54d49e3fa9d6$var$string(value) {
    return typeof value === 'string' || value instanceof String;
}
function $186a54d49e3fa9d6$var$number(value) {
    return typeof value === 'number' || value instanceof Number;
}
function $186a54d49e3fa9d6$var$error(value) {
    return value instanceof Error;
}
function $186a54d49e3fa9d6$var$func(value) {
    return typeof value === 'function';
}
function $186a54d49e3fa9d6$var$array(value) {
    return Array.isArray(value);
}
function $186a54d49e3fa9d6$var$stringArray(value) {
    return $186a54d49e3fa9d6$var$array(value) && value.every((elem)=>$186a54d49e3fa9d6$var$string(elem));
}
function $186a54d49e3fa9d6$var$typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
}
function $186a54d49e3fa9d6$var$objectLiteral(value) {
    // Strictly speaking class instances pass this check as well. Since the LSP
    // doesn't use classes we ignore this for now. If we do we need to add something
    // like this: `Object.getPrototypeOf(Object.getPrototypeOf(x)) === null`
    return value !== null && typeof value === 'object';
}

});

parcelRegister("97KA5", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImplementationRequest = void 0;

var $3H92V = parcelRequire("3H92V");
// @ts-ignore: to avoid inlining LocationLink as dynamic import
let $6a48e68bc034cd3f$var$__noDynamicImport;
/**
 * A request to resolve the implementation locations of a symbol at a given text
 * document position. The request's parameter is of type {@link TextDocumentPositionParams}
 * the response is of type {@link Definition} or a Thenable that resolves to such.
 */ var $6a48e68bc034cd3f$var$ImplementationRequest;
(function(ImplementationRequest) {
    ImplementationRequest.method = 'textDocument/implementation';
    ImplementationRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    ImplementationRequest.type = new $3H92V.ProtocolRequestType(ImplementationRequest.method);
    ImplementationRequest.capabilities = $3H92V.CM.create('textDocument.implementation', 'implementationProvider');
})($6a48e68bc034cd3f$var$ImplementationRequest || (module.exports.ImplementationRequest = $6a48e68bc034cd3f$var$ImplementationRequest = {}));

});

parcelRegister("6JJv1", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeDefinitionRequest = void 0;

var $3H92V = parcelRequire("3H92V");
// @ts-ignore: to avoid inlining LocationLink as dynamic import
let $4e7a3d49df33c770$var$__noDynamicImport;
/**
 * A request to resolve the type definition locations of a symbol at a given text
 * document position. The request's parameter is of type {@link TextDocumentPositionParams}
 * the response is of type {@link Definition} or a Thenable that resolves to such.
 */ var $4e7a3d49df33c770$var$TypeDefinitionRequest;
(function(TypeDefinitionRequest) {
    TypeDefinitionRequest.method = 'textDocument/typeDefinition';
    TypeDefinitionRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    TypeDefinitionRequest.type = new $3H92V.ProtocolRequestType(TypeDefinitionRequest.method);
    TypeDefinitionRequest.capabilities = $3H92V.CM.create('textDocument.typeDefinition', 'typeDefinitionProvider');
})($4e7a3d49df33c770$var$TypeDefinitionRequest || (module.exports.TypeDefinitionRequest = $4e7a3d49df33c770$var$TypeDefinitionRequest = {}));

});

parcelRegister("sUsTH", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidChangeWorkspaceFoldersNotification = module.exports.WorkspaceFoldersRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * The `workspace/workspaceFolders` is sent from the server to the client to fetch the open workspace folders.
 */ var $056e6a6de4ac1212$var$WorkspaceFoldersRequest;
(function(WorkspaceFoldersRequest) {
    WorkspaceFoldersRequest.method = 'workspace/workspaceFolders';
    WorkspaceFoldersRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    WorkspaceFoldersRequest.type = new $3H92V.ProtocolRequestType0(WorkspaceFoldersRequest.method);
    WorkspaceFoldersRequest.capabilities = $3H92V.CM.create('workspace.workspaceFolders', 'workspace.workspaceFolders');
})($056e6a6de4ac1212$var$WorkspaceFoldersRequest || (module.exports.WorkspaceFoldersRequest = $056e6a6de4ac1212$var$WorkspaceFoldersRequest = {}));
/**
 * The `workspace/didChangeWorkspaceFolders` notification is sent from the client to the server when the workspace
 * folder configuration changes.
 */ var $056e6a6de4ac1212$var$DidChangeWorkspaceFoldersNotification;
(function(DidChangeWorkspaceFoldersNotification) {
    DidChangeWorkspaceFoldersNotification.method = 'workspace/didChangeWorkspaceFolders';
    DidChangeWorkspaceFoldersNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidChangeWorkspaceFoldersNotification.type = new $3H92V.ProtocolNotificationType(DidChangeWorkspaceFoldersNotification.method);
    DidChangeWorkspaceFoldersNotification.capabilities = $3H92V.CM.create(undefined, 'workspace.workspaceFolders.changeNotifications');
})($056e6a6de4ac1212$var$DidChangeWorkspaceFoldersNotification || (module.exports.DidChangeWorkspaceFoldersNotification = $056e6a6de4ac1212$var$DidChangeWorkspaceFoldersNotification = {}));

});

parcelRegister("2KSOJ", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigurationRequest = void 0;

var $3H92V = parcelRequire("3H92V");
//---- Get Configuration request ----
/**
 * The 'workspace/configuration' request is sent from the server to the client to fetch a certain
 * configuration setting.
 *
 * This pull model replaces the old push model were the client signaled configuration change via an
 * event. If the server still needs to react to configuration changes (since the server caches the
 * result of `workspace/configuration` requests) the server should register for an empty configuration
 * change event and empty the cache if such an event is received.
 */ var $201a6633c995ca9e$var$ConfigurationRequest;
(function(ConfigurationRequest) {
    ConfigurationRequest.method = 'workspace/configuration';
    ConfigurationRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    ConfigurationRequest.type = new $3H92V.ProtocolRequestType(ConfigurationRequest.method);
    ConfigurationRequest.capabilities = $3H92V.CM.create('workspace.configuration', undefined);
})($201a6633c995ca9e$var$ConfigurationRequest || (module.exports.ConfigurationRequest = $201a6633c995ca9e$var$ConfigurationRequest = {}));

});

parcelRegister("jJgmL", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorPresentationRequest = module.exports.DocumentColorRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to list all color symbols found in a given text document. The request's
 * parameter is of type {@link DocumentColorParams} the
 * response is of type {@link ColorInformation ColorInformation[]} or a Thenable
 * that resolves to such.
 */ var $e5ceea4b12b475a4$var$DocumentColorRequest;
(function(DocumentColorRequest) {
    DocumentColorRequest.method = 'textDocument/documentColor';
    DocumentColorRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentColorRequest.type = new $3H92V.ProtocolRequestType(DocumentColorRequest.method);
    DocumentColorRequest.capabilities = $3H92V.CM.create('textDocument.colorProvider', 'colorProvider');
})($e5ceea4b12b475a4$var$DocumentColorRequest || (module.exports.DocumentColorRequest = $e5ceea4b12b475a4$var$DocumentColorRequest = {}));
/**
 * A request to list all presentation for a color. The request's
 * parameter is of type {@link ColorPresentationParams} the
 * response is of type {@link ColorPresentation ColorPresentation[]} or a Thenable
 * that resolves to such.
 */ var $e5ceea4b12b475a4$var$ColorPresentationRequest;
(function(ColorPresentationRequest) {
    ColorPresentationRequest.method = 'textDocument/colorPresentation';
    ColorPresentationRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    ColorPresentationRequest.type = new $3H92V.ProtocolRequestType(ColorPresentationRequest.method);
    ColorPresentationRequest.capabilities = $3H92V.CM.create('textDocument.colorProvider', 'colorProvider');
})($e5ceea4b12b475a4$var$ColorPresentationRequest || (module.exports.ColorPresentationRequest = $e5ceea4b12b475a4$var$ColorPresentationRequest = {}));

});

parcelRegister("2SIvv", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FoldingRangeRefreshRequest = module.exports.FoldingRangeRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide folding ranges in a document. The request's
 * parameter is of type {@link FoldingRangeParams}, the
 * response is of type {@link FoldingRangeList} or a Thenable
 * that resolves to such.
 */ var $2193262322e7a781$var$FoldingRangeRequest;
(function(FoldingRangeRequest) {
    FoldingRangeRequest.method = 'textDocument/foldingRange';
    FoldingRangeRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    FoldingRangeRequest.type = new $3H92V.ProtocolRequestType(FoldingRangeRequest.method);
    FoldingRangeRequest.capabilities = $3H92V.CM.create('textDocument.foldingRange', 'foldingRangeProvider');
})($2193262322e7a781$var$FoldingRangeRequest || (module.exports.FoldingRangeRequest = $2193262322e7a781$var$FoldingRangeRequest = {}));
/**
 * A request to refresh the folding ranges in a document.
 *
 * @since 3.18.0
 */ var $2193262322e7a781$var$FoldingRangeRefreshRequest;
(function(FoldingRangeRefreshRequest) {
    FoldingRangeRefreshRequest.method = `workspace/foldingRange/refresh`;
    FoldingRangeRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    FoldingRangeRefreshRequest.type = new $3H92V.ProtocolRequestType0(FoldingRangeRefreshRequest.method);
    FoldingRangeRefreshRequest.capabilities = $3H92V.CM.create('workspace.foldingRange.refreshSupport', undefined);
})($2193262322e7a781$var$FoldingRangeRefreshRequest || (module.exports.FoldingRangeRefreshRequest = $2193262322e7a781$var$FoldingRangeRefreshRequest = {}));

});

parcelRegister("kqiKa", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DeclarationRequest = void 0;

var $3H92V = parcelRequire("3H92V");
// @ts-ignore: to avoid inlining LocationLink as dynamic import
let $ede4c674ced7921d$var$__noDynamicImport;
/**
 * A request to resolve the type definition locations of a symbol at a given text
 * document position. The request's parameter is of type {@link TextDocumentPositionParams}
 * the response is of type {@link Declaration} or a typed array of {@link DeclarationLink}
 * or a Thenable that resolves to such.
 */ var $ede4c674ced7921d$var$DeclarationRequest;
(function(DeclarationRequest) {
    DeclarationRequest.method = 'textDocument/declaration';
    DeclarationRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DeclarationRequest.type = new $3H92V.ProtocolRequestType(DeclarationRequest.method);
    DeclarationRequest.capabilities = $3H92V.CM.create('textDocument.declaration', 'declarationProvider');
})($ede4c674ced7921d$var$DeclarationRequest || (module.exports.DeclarationRequest = $ede4c674ced7921d$var$DeclarationRequest = {}));

});

parcelRegister("gyIv8", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectionRangeRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide selection ranges in a document. The request's
 * parameter is of type {@link SelectionRangeParams}, the
 * response is of type {@link SelectionRange SelectionRange[]} or a Thenable
 * that resolves to such.
 */ var $c0e2574da0bbce20$var$SelectionRangeRequest;
(function(SelectionRangeRequest) {
    SelectionRangeRequest.method = 'textDocument/selectionRange';
    SelectionRangeRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    SelectionRangeRequest.type = new $3H92V.ProtocolRequestType(SelectionRangeRequest.method);
    SelectionRangeRequest.capabilities = $3H92V.CM.create('textDocument.selectionRange', 'selectionRangeProvider');
})($c0e2574da0bbce20$var$SelectionRangeRequest || (module.exports.SelectionRangeRequest = $c0e2574da0bbce20$var$SelectionRangeRequest = {}));

});

parcelRegister("iWqXu", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WorkDoneProgressCancelNotification = module.exports.WorkDoneProgressCreateRequest = module.exports.WorkDoneProgress = void 0;

var $d8V62 = parcelRequire("d8V62");

var $3H92V = parcelRequire("3H92V");
var $dca28e26d70b9514$var$WorkDoneProgress;
(function(WorkDoneProgress) {
    WorkDoneProgress.type = new $d8V62.ProgressType();
    function is(value) {
        return value === WorkDoneProgress.type;
    }
    WorkDoneProgress.is = is;
})($dca28e26d70b9514$var$WorkDoneProgress || (module.exports.WorkDoneProgress = $dca28e26d70b9514$var$WorkDoneProgress = {}));
/**
 * The `window/workDoneProgress/create` request is sent from the server to the client to initiate progress
 * reporting from the server.
 */ var $dca28e26d70b9514$var$WorkDoneProgressCreateRequest;
(function(WorkDoneProgressCreateRequest) {
    WorkDoneProgressCreateRequest.method = 'window/workDoneProgress/create';
    WorkDoneProgressCreateRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    WorkDoneProgressCreateRequest.type = new $3H92V.ProtocolRequestType(WorkDoneProgressCreateRequest.method);
    WorkDoneProgressCreateRequest.capabilities = $3H92V.CM.create('window.workDoneProgress', undefined);
})($dca28e26d70b9514$var$WorkDoneProgressCreateRequest || (module.exports.WorkDoneProgressCreateRequest = $dca28e26d70b9514$var$WorkDoneProgressCreateRequest = {}));
/**
 * The `window/workDoneProgress/cancel` notification is sent from  the client to the server to cancel a progress
 * initiated on the server side.
 */ var $dca28e26d70b9514$var$WorkDoneProgressCancelNotification;
(function(WorkDoneProgressCancelNotification) {
    WorkDoneProgressCancelNotification.method = 'window/workDoneProgress/cancel';
    WorkDoneProgressCancelNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    WorkDoneProgressCancelNotification.type = new $3H92V.ProtocolNotificationType(WorkDoneProgressCancelNotification.method);
})($dca28e26d70b9514$var$WorkDoneProgressCancelNotification || (module.exports.WorkDoneProgressCancelNotification = $dca28e26d70b9514$var$WorkDoneProgressCancelNotification = {}));

});

parcelRegister("1lRx1", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) TypeFox, Microsoft and others. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CallHierarchyOutgoingCallsRequest = module.exports.CallHierarchyIncomingCallsRequest = module.exports.CallHierarchyPrepareRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to result a `CallHierarchyItem` in a document at a given position.
 * Can be used as an input to an incoming or outgoing call hierarchy.
 *
 * @since 3.16.0
 */ var $0fc146e1645eb2ff$var$CallHierarchyPrepareRequest;
(function(CallHierarchyPrepareRequest) {
    CallHierarchyPrepareRequest.method = 'textDocument/prepareCallHierarchy';
    CallHierarchyPrepareRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CallHierarchyPrepareRequest.type = new $3H92V.ProtocolRequestType(CallHierarchyPrepareRequest.method);
    CallHierarchyPrepareRequest.capabilities = $3H92V.CM.create('textDocument.callHierarchy', 'callHierarchyProvider');
})($0fc146e1645eb2ff$var$CallHierarchyPrepareRequest || (module.exports.CallHierarchyPrepareRequest = $0fc146e1645eb2ff$var$CallHierarchyPrepareRequest = {}));
/**
 * A request to resolve the incoming calls for a given `CallHierarchyItem`.
 *
 * @since 3.16.0
 */ var $0fc146e1645eb2ff$var$CallHierarchyIncomingCallsRequest;
(function(CallHierarchyIncomingCallsRequest) {
    CallHierarchyIncomingCallsRequest.method = 'callHierarchy/incomingCalls';
    CallHierarchyIncomingCallsRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CallHierarchyIncomingCallsRequest.type = new $3H92V.ProtocolRequestType(CallHierarchyIncomingCallsRequest.method);
    CallHierarchyIncomingCallsRequest.capabilities = $3H92V.CM.create('textDocument.callHierarchy', 'callHierarchyProvider');
})($0fc146e1645eb2ff$var$CallHierarchyIncomingCallsRequest || (module.exports.CallHierarchyIncomingCallsRequest = $0fc146e1645eb2ff$var$CallHierarchyIncomingCallsRequest = {}));
/**
 * A request to resolve the outgoing calls for a given `CallHierarchyItem`.
 *
 * @since 3.16.0
 */ var $0fc146e1645eb2ff$var$CallHierarchyOutgoingCallsRequest;
(function(CallHierarchyOutgoingCallsRequest) {
    CallHierarchyOutgoingCallsRequest.method = 'callHierarchy/outgoingCalls';
    CallHierarchyOutgoingCallsRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    CallHierarchyOutgoingCallsRequest.type = new $3H92V.ProtocolRequestType(CallHierarchyOutgoingCallsRequest.method);
    CallHierarchyOutgoingCallsRequest.capabilities = $3H92V.CM.create('textDocument.callHierarchy', 'callHierarchyProvider');
})($0fc146e1645eb2ff$var$CallHierarchyOutgoingCallsRequest || (module.exports.CallHierarchyOutgoingCallsRequest = $0fc146e1645eb2ff$var$CallHierarchyOutgoingCallsRequest = {}));

});

parcelRegister("lxKTK", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticTokensRefreshRequest = module.exports.SemanticTokensRangeRequest = module.exports.SemanticTokensDeltaRequest = module.exports.SemanticTokensRequest = module.exports.SemanticTokensRegistrationType = module.exports.TokenFormat = void 0;

var $3H92V = parcelRequire("3H92V");
//------- 'textDocument/semanticTokens' -----
var $faf10f09828c8f3a$var$TokenFormat;
(function(TokenFormat) {
    TokenFormat.Relative = 'relative';
})($faf10f09828c8f3a$var$TokenFormat || (module.exports.TokenFormat = $faf10f09828c8f3a$var$TokenFormat = {}));
var $faf10f09828c8f3a$var$SemanticTokensRegistrationType;
(function(SemanticTokensRegistrationType) {
    SemanticTokensRegistrationType.method = 'textDocument/semanticTokens';
    SemanticTokensRegistrationType.type = new $3H92V.RegistrationType(SemanticTokensRegistrationType.method);
})($faf10f09828c8f3a$var$SemanticTokensRegistrationType || (module.exports.SemanticTokensRegistrationType = $faf10f09828c8f3a$var$SemanticTokensRegistrationType = {}));
/**
 * @since 3.16.0
 */ var $faf10f09828c8f3a$var$SemanticTokensRequest;
(function(SemanticTokensRequest) {
    SemanticTokensRequest.method = 'textDocument/semanticTokens/full';
    SemanticTokensRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    SemanticTokensRequest.type = new $3H92V.ProtocolRequestType(SemanticTokensRequest.method);
    SemanticTokensRequest.registrationMethod = $faf10f09828c8f3a$var$SemanticTokensRegistrationType.method;
    SemanticTokensRequest.capabilities = $3H92V.CM.create('textDocument.semanticTokens', 'semanticTokensProvider');
})($faf10f09828c8f3a$var$SemanticTokensRequest || (module.exports.SemanticTokensRequest = $faf10f09828c8f3a$var$SemanticTokensRequest = {}));
/**
 * @since 3.16.0
 */ var $faf10f09828c8f3a$var$SemanticTokensDeltaRequest;
(function(SemanticTokensDeltaRequest) {
    SemanticTokensDeltaRequest.method = 'textDocument/semanticTokens/full/delta';
    SemanticTokensDeltaRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    SemanticTokensDeltaRequest.type = new $3H92V.ProtocolRequestType(SemanticTokensDeltaRequest.method);
    SemanticTokensDeltaRequest.registrationMethod = $faf10f09828c8f3a$var$SemanticTokensRegistrationType.method;
    SemanticTokensDeltaRequest.capabilities = $3H92V.CM.create('textDocument.semanticTokens.requests.full.delta', 'semanticTokensProvider.full.delta');
})($faf10f09828c8f3a$var$SemanticTokensDeltaRequest || (module.exports.SemanticTokensDeltaRequest = $faf10f09828c8f3a$var$SemanticTokensDeltaRequest = {}));
/**
 * @since 3.16.0
 */ var $faf10f09828c8f3a$var$SemanticTokensRangeRequest;
(function(SemanticTokensRangeRequest) {
    SemanticTokensRangeRequest.method = 'textDocument/semanticTokens/range';
    SemanticTokensRangeRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    SemanticTokensRangeRequest.type = new $3H92V.ProtocolRequestType(SemanticTokensRangeRequest.method);
    SemanticTokensRangeRequest.registrationMethod = $faf10f09828c8f3a$var$SemanticTokensRegistrationType.method;
    SemanticTokensRangeRequest.capabilities = $3H92V.CM.create('textDocument.semanticTokens.requests.range', 'semanticTokensProvider.range');
})($faf10f09828c8f3a$var$SemanticTokensRangeRequest || (module.exports.SemanticTokensRangeRequest = $faf10f09828c8f3a$var$SemanticTokensRangeRequest = {}));
/**
 * @since 3.16.0
 */ var $faf10f09828c8f3a$var$SemanticTokensRefreshRequest;
(function(SemanticTokensRefreshRequest) {
    SemanticTokensRefreshRequest.method = `workspace/semanticTokens/refresh`;
    SemanticTokensRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    SemanticTokensRefreshRequest.type = new $3H92V.ProtocolRequestType0(SemanticTokensRefreshRequest.method);
    SemanticTokensRefreshRequest.capabilities = $3H92V.CM.create('workspace.semanticTokens.refreshSupport', undefined);
})($faf10f09828c8f3a$var$SemanticTokensRefreshRequest || (module.exports.SemanticTokensRefreshRequest = $faf10f09828c8f3a$var$SemanticTokensRefreshRequest = {}));

});

parcelRegister("dOzMQ", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShowDocumentRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to show a document. This request might open an
 * external program depending on the value of the URI to open.
 * For example a request to open `https://code.visualstudio.com/`
 * will very likely open the URI in a WEB browser.
 *
 * @since 3.16.0
*/ var $a0ebb468914df056$var$ShowDocumentRequest;
(function(ShowDocumentRequest) {
    ShowDocumentRequest.method = 'window/showDocument';
    ShowDocumentRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    ShowDocumentRequest.type = new $3H92V.ProtocolRequestType(ShowDocumentRequest.method);
    ShowDocumentRequest.capabilities = $3H92V.CM.create('window.showDocument.support', undefined);
})($a0ebb468914df056$var$ShowDocumentRequest || (module.exports.ShowDocumentRequest = $a0ebb468914df056$var$ShowDocumentRequest = {}));

});

parcelRegister("lGWTo", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkedEditingRangeRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide ranges that can be edited together.
 *
 * @since 3.16.0
 */ var $fcab3403229eb533$var$LinkedEditingRangeRequest;
(function(LinkedEditingRangeRequest) {
    LinkedEditingRangeRequest.method = 'textDocument/linkedEditingRange';
    LinkedEditingRangeRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    LinkedEditingRangeRequest.type = new $3H92V.ProtocolRequestType(LinkedEditingRangeRequest.method);
    LinkedEditingRangeRequest.capabilities = $3H92V.CM.create('textDocument.linkedEditingRange', 'linkedEditingRangeProvider');
})($fcab3403229eb533$var$LinkedEditingRangeRequest || (module.exports.LinkedEditingRangeRequest = $fcab3403229eb533$var$LinkedEditingRangeRequest = {}));

});

parcelRegister("63R9N", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WillDeleteFilesRequest = module.exports.DidDeleteFilesNotification = module.exports.DidRenameFilesNotification = module.exports.WillRenameFilesRequest = module.exports.DidCreateFilesNotification = module.exports.WillCreateFilesRequest = module.exports.FileOperationPatternKind = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A pattern kind describing if a glob pattern matches a file a folder or
 * both.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$FileOperationPatternKind;
(function(FileOperationPatternKind) {
    /**
     * The pattern matches a file only.
     */ FileOperationPatternKind.file = 'file';
    /**
     * The pattern matches a folder only.
     */ FileOperationPatternKind.folder = 'folder';
})($469c41c0edacb550$var$FileOperationPatternKind || (module.exports.FileOperationPatternKind = $469c41c0edacb550$var$FileOperationPatternKind = {}));
/**
 * The will create files request is sent from the client to the server before files are actually
 * created as long as the creation is triggered from within the client.
 *
 * The request can return a `WorkspaceEdit` which will be applied to workspace before the
 * files are created. Hence the `WorkspaceEdit` can not manipulate the content of the file
 * to be created.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$WillCreateFilesRequest;
(function(WillCreateFilesRequest) {
    WillCreateFilesRequest.method = 'workspace/willCreateFiles';
    WillCreateFilesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WillCreateFilesRequest.type = new $3H92V.ProtocolRequestType(WillCreateFilesRequest.method);
    WillCreateFilesRequest.capabilities = $3H92V.CM.create('workspace.fileOperations.willCreate', 'workspace.fileOperations.willCreate');
})($469c41c0edacb550$var$WillCreateFilesRequest || (module.exports.WillCreateFilesRequest = $469c41c0edacb550$var$WillCreateFilesRequest = {}));
/**
 * The did create files notification is sent from the client to the server when
 * files were created from within the client.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$DidCreateFilesNotification;
(function(DidCreateFilesNotification) {
    DidCreateFilesNotification.method = 'workspace/didCreateFiles';
    DidCreateFilesNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidCreateFilesNotification.type = new $3H92V.ProtocolNotificationType(DidCreateFilesNotification.method);
    DidCreateFilesNotification.capabilities = $3H92V.CM.create('workspace.fileOperations.didCreate', 'workspace.fileOperations.didCreate');
})($469c41c0edacb550$var$DidCreateFilesNotification || (module.exports.DidCreateFilesNotification = $469c41c0edacb550$var$DidCreateFilesNotification = {}));
/**
 * The will rename files request is sent from the client to the server before files are actually
 * renamed as long as the rename is triggered from within the client.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$WillRenameFilesRequest;
(function(WillRenameFilesRequest) {
    WillRenameFilesRequest.method = 'workspace/willRenameFiles';
    WillRenameFilesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WillRenameFilesRequest.type = new $3H92V.ProtocolRequestType(WillRenameFilesRequest.method);
    WillRenameFilesRequest.capabilities = $3H92V.CM.create('workspace.fileOperations.willRename', 'workspace.fileOperations.willRename');
})($469c41c0edacb550$var$WillRenameFilesRequest || (module.exports.WillRenameFilesRequest = $469c41c0edacb550$var$WillRenameFilesRequest = {}));
/**
 * The did rename files notification is sent from the client to the server when
 * files were renamed from within the client.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$DidRenameFilesNotification;
(function(DidRenameFilesNotification) {
    DidRenameFilesNotification.method = 'workspace/didRenameFiles';
    DidRenameFilesNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidRenameFilesNotification.type = new $3H92V.ProtocolNotificationType(DidRenameFilesNotification.method);
    DidRenameFilesNotification.capabilities = $3H92V.CM.create('workspace.fileOperations.didRename', 'workspace.fileOperations.didRename');
})($469c41c0edacb550$var$DidRenameFilesNotification || (module.exports.DidRenameFilesNotification = $469c41c0edacb550$var$DidRenameFilesNotification = {}));
/**
 * The will delete files request is sent from the client to the server before files are actually
 * deleted as long as the deletion is triggered from within the client.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$DidDeleteFilesNotification;
(function(DidDeleteFilesNotification) {
    DidDeleteFilesNotification.method = 'workspace/didDeleteFiles';
    DidDeleteFilesNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidDeleteFilesNotification.type = new $3H92V.ProtocolNotificationType(DidDeleteFilesNotification.method);
    DidDeleteFilesNotification.capabilities = $3H92V.CM.create('workspace.fileOperations.didDelete', 'workspace.fileOperations.didDelete');
})($469c41c0edacb550$var$DidDeleteFilesNotification || (module.exports.DidDeleteFilesNotification = $469c41c0edacb550$var$DidDeleteFilesNotification = {}));
/**
 * The did delete files notification is sent from the client to the server when
 * files were deleted from within the client.
 *
 * @since 3.16.0
 */ var $469c41c0edacb550$var$WillDeleteFilesRequest;
(function(WillDeleteFilesRequest) {
    WillDeleteFilesRequest.method = 'workspace/willDeleteFiles';
    WillDeleteFilesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WillDeleteFilesRequest.type = new $3H92V.ProtocolRequestType(WillDeleteFilesRequest.method);
    WillDeleteFilesRequest.capabilities = $3H92V.CM.create('workspace.fileOperations.willDelete', 'workspace.fileOperations.willDelete');
})($469c41c0edacb550$var$WillDeleteFilesRequest || (module.exports.WillDeleteFilesRequest = $469c41c0edacb550$var$WillDeleteFilesRequest = {}));

});

parcelRegister("lC7Bk", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MonikerRequest = module.exports.MonikerKind = module.exports.UniquenessLevel = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * Moniker uniqueness level to define scope of the moniker.
 *
 * @since 3.16.0
 */ var $fbc30b0618139c54$var$UniquenessLevel;
(function(UniquenessLevel) {
    /**
     * The moniker is only unique inside a document
     */ UniquenessLevel.document = 'document';
    /**
     * The moniker is unique inside a project for which a dump got created
     */ UniquenessLevel.project = 'project';
    /**
     * The moniker is unique inside the group to which a project belongs
     */ UniquenessLevel.group = 'group';
    /**
     * The moniker is unique inside the moniker scheme.
     */ UniquenessLevel.scheme = 'scheme';
    /**
     * The moniker is globally unique
     */ UniquenessLevel.global = 'global';
})($fbc30b0618139c54$var$UniquenessLevel || (module.exports.UniquenessLevel = $fbc30b0618139c54$var$UniquenessLevel = {}));
/**
 * The moniker kind.
 *
 * @since 3.16.0
 */ var $fbc30b0618139c54$var$MonikerKind;
(function(MonikerKind) {
    /**
     * The moniker represent a symbol that is imported into a project
     */ MonikerKind.$import = 'import';
    /**
     * The moniker represents a symbol that is exported from a project
     */ MonikerKind.$export = 'export';
    /**
     * The moniker represents a symbol that is local to a project (e.g. a local
     * variable of a function, a class not visible outside the project, ...)
     */ MonikerKind.local = 'local';
})($fbc30b0618139c54$var$MonikerKind || (module.exports.MonikerKind = $fbc30b0618139c54$var$MonikerKind = {}));
/**
 * A request to get the moniker of a symbol at a given text document position.
 * The request parameter is of type {@link TextDocumentPositionParams}.
 * The response is of type {@link Moniker Moniker[]} or `null`.
 */ var $fbc30b0618139c54$var$MonikerRequest;
(function(MonikerRequest) {
    MonikerRequest.method = 'textDocument/moniker';
    MonikerRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    MonikerRequest.type = new $3H92V.ProtocolRequestType(MonikerRequest.method);
    MonikerRequest.capabilities = $3H92V.CM.create('textDocument.moniker', 'monikerProvider');
})($fbc30b0618139c54$var$MonikerRequest || (module.exports.MonikerRequest = $fbc30b0618139c54$var$MonikerRequest = {}));

});

parcelRegister("hVz0q", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) TypeFox, Microsoft and others. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHierarchySubtypesRequest = module.exports.TypeHierarchySupertypesRequest = module.exports.TypeHierarchyPrepareRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to result a `TypeHierarchyItem` in a document at a given position.
 * Can be used as an input to a subtypes or supertypes type hierarchy.
 *
 * @since 3.17.0
 */ var $d0d2e9ff38ace889$var$TypeHierarchyPrepareRequest;
(function(TypeHierarchyPrepareRequest) {
    TypeHierarchyPrepareRequest.method = 'textDocument/prepareTypeHierarchy';
    TypeHierarchyPrepareRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    TypeHierarchyPrepareRequest.type = new $3H92V.ProtocolRequestType(TypeHierarchyPrepareRequest.method);
    TypeHierarchyPrepareRequest.capabilities = $3H92V.CM.create('textDocument.typeHierarchy', 'typeHierarchyProvider');
})($d0d2e9ff38ace889$var$TypeHierarchyPrepareRequest || (module.exports.TypeHierarchyPrepareRequest = $d0d2e9ff38ace889$var$TypeHierarchyPrepareRequest = {}));
/**
 * A request to resolve the supertypes for a given `TypeHierarchyItem`.
 *
 * @since 3.17.0
 */ var $d0d2e9ff38ace889$var$TypeHierarchySupertypesRequest;
(function(TypeHierarchySupertypesRequest) {
    TypeHierarchySupertypesRequest.method = 'typeHierarchy/supertypes';
    TypeHierarchySupertypesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    TypeHierarchySupertypesRequest.type = new $3H92V.ProtocolRequestType(TypeHierarchySupertypesRequest.method);
})($d0d2e9ff38ace889$var$TypeHierarchySupertypesRequest || (module.exports.TypeHierarchySupertypesRequest = $d0d2e9ff38ace889$var$TypeHierarchySupertypesRequest = {}));
/**
 * A request to resolve the subtypes for a given `TypeHierarchyItem`.
 *
 * @since 3.17.0
 */ var $d0d2e9ff38ace889$var$TypeHierarchySubtypesRequest;
(function(TypeHierarchySubtypesRequest) {
    TypeHierarchySubtypesRequest.method = 'typeHierarchy/subtypes';
    TypeHierarchySubtypesRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    TypeHierarchySubtypesRequest.type = new $3H92V.ProtocolRequestType(TypeHierarchySubtypesRequest.method);
})($d0d2e9ff38ace889$var$TypeHierarchySubtypesRequest || (module.exports.TypeHierarchySubtypesRequest = $d0d2e9ff38ace889$var$TypeHierarchySubtypesRequest = {}));

});

parcelRegister("l6Gsn", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InlineValueRefreshRequest = module.exports.InlineValueRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide inline values in a document. The request's parameter is of
 * type {@link InlineValueParams}, the response is of type
 * {@link InlineValue InlineValue[]} or a Thenable that resolves to such.
 *
 * @since 3.17.0
 */ var $f5db178c7c3eb0ec$var$InlineValueRequest;
(function(InlineValueRequest) {
    InlineValueRequest.method = 'textDocument/inlineValue';
    InlineValueRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    InlineValueRequest.type = new $3H92V.ProtocolRequestType(InlineValueRequest.method);
    InlineValueRequest.capabilities = $3H92V.CM.create('textDocument.inlineValue', 'inlineValueProvider');
})($f5db178c7c3eb0ec$var$InlineValueRequest || (module.exports.InlineValueRequest = $f5db178c7c3eb0ec$var$InlineValueRequest = {}));
/**
 * @since 3.17.0
 */ var $f5db178c7c3eb0ec$var$InlineValueRefreshRequest;
(function(InlineValueRefreshRequest) {
    InlineValueRefreshRequest.method = `workspace/inlineValue/refresh`;
    InlineValueRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    InlineValueRefreshRequest.type = new $3H92V.ProtocolRequestType0(InlineValueRefreshRequest.method);
    InlineValueRefreshRequest.capabilities = $3H92V.CM.create('workspace.inlineValue.refreshSupport', undefined);
})($f5db178c7c3eb0ec$var$InlineValueRefreshRequest || (module.exports.InlineValueRefreshRequest = $f5db178c7c3eb0ec$var$InlineValueRefreshRequest = {}));

});

parcelRegister("jVKwQ", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InlayHintRefreshRequest = module.exports.InlayHintResolveRequest = module.exports.InlayHintRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide inlay hints in a document. The request's parameter is of
 * type {@link InlayHintsParams}, the response is of type
 * {@link InlayHint InlayHint[]} or a Thenable that resolves to such.
 *
 * @since 3.17.0
 */ var $e8276ed416baee37$var$InlayHintRequest;
(function(InlayHintRequest) {
    InlayHintRequest.method = 'textDocument/inlayHint';
    InlayHintRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    InlayHintRequest.type = new $3H92V.ProtocolRequestType(InlayHintRequest.method);
    InlayHintRequest.capabilities = $3H92V.CM.create('textDocument.inlayHint', 'inlayHintProvider');
})($e8276ed416baee37$var$InlayHintRequest || (module.exports.InlayHintRequest = $e8276ed416baee37$var$InlayHintRequest = {}));
/**
 * A request to resolve additional properties for an inlay hint.
 * The request's parameter is of type {@link InlayHint}, the response is
 * of type {@link InlayHint} or a Thenable that resolves to such.
 *
 * @since 3.17.0
 */ var $e8276ed416baee37$var$InlayHintResolveRequest;
(function(InlayHintResolveRequest) {
    InlayHintResolveRequest.method = 'inlayHint/resolve';
    InlayHintResolveRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    InlayHintResolveRequest.type = new $3H92V.ProtocolRequestType(InlayHintResolveRequest.method);
    InlayHintResolveRequest.capabilities = $3H92V.CM.create('textDocument.inlayHint.resolveSupport', 'inlayHintProvider.resolveProvider');
})($e8276ed416baee37$var$InlayHintResolveRequest || (module.exports.InlayHintResolveRequest = $e8276ed416baee37$var$InlayHintResolveRequest = {}));
/**
 * @since 3.17.0
 */ var $e8276ed416baee37$var$InlayHintRefreshRequest;
(function(InlayHintRefreshRequest) {
    InlayHintRefreshRequest.method = `workspace/inlayHint/refresh`;
    InlayHintRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    InlayHintRefreshRequest.type = new $3H92V.ProtocolRequestType0(InlayHintRefreshRequest.method);
    InlayHintRefreshRequest.capabilities = $3H92V.CM.create('workspace.inlayHint.refreshSupport', undefined);
})($e8276ed416baee37$var$InlayHintRefreshRequest || (module.exports.InlayHintRefreshRequest = $e8276ed416baee37$var$InlayHintRefreshRequest = {}));

});

parcelRegister("byx7q", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $869c8f65302c3ba1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $869c8f65302c3ba1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $869c8f65302c3ba1$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $869c8f65302c3ba1$var$__createBinding(result, mod, k[i]);
        }
        $869c8f65302c3ba1$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticRefreshRequest = module.exports.WorkspaceDiagnosticRequest = module.exports.DocumentDiagnosticRequest = module.exports.DocumentDiagnosticReportKind = module.exports.DiagnosticServerCancellationData = void 0;

var $d8V62 = parcelRequire("d8V62");

const $869c8f65302c3ba1$var$Is = $869c8f65302c3ba1$var$__importStar((parcelRequire("25XFm")));

var $3H92V = parcelRequire("3H92V");
/**
 * @since 3.17.0
 */ var $869c8f65302c3ba1$var$DiagnosticServerCancellationData;
(function(DiagnosticServerCancellationData) {
    function is(value) {
        const candidate = value;
        return candidate && $869c8f65302c3ba1$var$Is.boolean(candidate.retriggerRequest);
    }
    DiagnosticServerCancellationData.is = is;
})($869c8f65302c3ba1$var$DiagnosticServerCancellationData || (module.exports.DiagnosticServerCancellationData = $869c8f65302c3ba1$var$DiagnosticServerCancellationData = {}));
/**
 * The document diagnostic report kinds.
 *
 * @since 3.17.0
 */ var $869c8f65302c3ba1$var$DocumentDiagnosticReportKind;
(function(DocumentDiagnosticReportKind) {
    /**
     * A diagnostic report with a full
     * set of problems.
     */ DocumentDiagnosticReportKind.Full = 'full';
    /**
     * A report indicating that the last
     * returned report is still accurate.
     */ DocumentDiagnosticReportKind.Unchanged = 'unchanged';
})($869c8f65302c3ba1$var$DocumentDiagnosticReportKind || (module.exports.DocumentDiagnosticReportKind = $869c8f65302c3ba1$var$DocumentDiagnosticReportKind = {}));
/**
 * The document diagnostic request definition.
 *
 *
 * @since 3.17.0
 */ var $869c8f65302c3ba1$var$DocumentDiagnosticRequest;
(function(DocumentDiagnosticRequest) {
    DocumentDiagnosticRequest.method = 'textDocument/diagnostic';
    DocumentDiagnosticRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    DocumentDiagnosticRequest.type = new $3H92V.ProtocolRequestType(DocumentDiagnosticRequest.method);
    DocumentDiagnosticRequest.partialResult = new $d8V62.ProgressType();
    DocumentDiagnosticRequest.capabilities = $3H92V.CM.create('textDocument.diagnostic', 'diagnosticProvider');
})($869c8f65302c3ba1$var$DocumentDiagnosticRequest || (module.exports.DocumentDiagnosticRequest = $869c8f65302c3ba1$var$DocumentDiagnosticRequest = {}));
/**
 * The workspace diagnostic request definition.
 *
 * @since 3.17.0
 */ var $869c8f65302c3ba1$var$WorkspaceDiagnosticRequest;
(function(WorkspaceDiagnosticRequest) {
    WorkspaceDiagnosticRequest.method = 'workspace/diagnostic';
    WorkspaceDiagnosticRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    WorkspaceDiagnosticRequest.type = new $3H92V.ProtocolRequestType(WorkspaceDiagnosticRequest.method);
    WorkspaceDiagnosticRequest.partialResult = new $d8V62.ProgressType();
    WorkspaceDiagnosticRequest.capabilities = $3H92V.CM.create('workspace.diagnostics', 'diagnosticProvider.workspaceDiagnostics');
})($869c8f65302c3ba1$var$WorkspaceDiagnosticRequest || (module.exports.WorkspaceDiagnosticRequest = $869c8f65302c3ba1$var$WorkspaceDiagnosticRequest = {}));
/**
 * The diagnostic refresh request definition.
 *
 * @since 3.17.0
 */ var $869c8f65302c3ba1$var$DiagnosticRefreshRequest;
(function(DiagnosticRefreshRequest) {
    DiagnosticRefreshRequest.method = `workspace/diagnostic/refresh`;
    DiagnosticRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    DiagnosticRefreshRequest.type = new $3H92V.ProtocolRequestType0(DiagnosticRefreshRequest.method);
    DiagnosticRefreshRequest.capabilities = $3H92V.CM.create('workspace.diagnostics.refreshSupport', undefined);
})($869c8f65302c3ba1$var$DiagnosticRefreshRequest || (module.exports.DiagnosticRefreshRequest = $869c8f65302c3ba1$var$DiagnosticRefreshRequest = {}));

});

parcelRegister("dt953", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $9ce507040ec37629$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9ce507040ec37629$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9ce507040ec37629$var$__importStar = module.exports && module.exports.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9ce507040ec37629$var$__createBinding(result, mod, k[i]);
        }
        $9ce507040ec37629$var$__setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DidCloseNotebookDocumentNotification = module.exports.DidSaveNotebookDocumentNotification = module.exports.DidChangeNotebookDocumentNotification = module.exports.NotebookCellArrayChange = module.exports.DidOpenNotebookDocumentNotification = module.exports.NotebookDocumentSyncRegistrationType = module.exports.NotebookDocument = module.exports.NotebookCell = module.exports.ExecutionSummary = module.exports.NotebookCellKind = void 0;

var $bDmGd = parcelRequire("bDmGd");

const $9ce507040ec37629$var$Is = $9ce507040ec37629$var$__importStar((parcelRequire("25XFm")));

var $3H92V = parcelRequire("3H92V");
/**
 * A notebook cell kind.
 *
 * @since 3.17.0
 */ var $9ce507040ec37629$var$NotebookCellKind;
(function(NotebookCellKind) {
    /**
     * A markup-cell is formatted source that is used for display.
     */ NotebookCellKind.Markup = 1;
    /**
     * A code-cell is source code.
     */ NotebookCellKind.Code = 2;
    function is(value) {
        return value === 1 || value === 2;
    }
    NotebookCellKind.is = is;
})($9ce507040ec37629$var$NotebookCellKind || (module.exports.NotebookCellKind = $9ce507040ec37629$var$NotebookCellKind = {}));
var $9ce507040ec37629$var$ExecutionSummary;
(function(ExecutionSummary) {
    function create(executionOrder, success) {
        const result = {
            executionOrder: executionOrder
        };
        if (success === true || success === false) result.success = success;
        return result;
    }
    ExecutionSummary.create = create;
    function is(value) {
        const candidate = value;
        return $9ce507040ec37629$var$Is.objectLiteral(candidate) && $bDmGd.uinteger.is(candidate.executionOrder) && (candidate.success === undefined || $9ce507040ec37629$var$Is.boolean(candidate.success));
    }
    ExecutionSummary.is = is;
    function equals(one, other) {
        if (one === other) return true;
        if (one === null || one === undefined || other === null || other === undefined) return false;
        return one.executionOrder === other.executionOrder && one.success === other.success;
    }
    ExecutionSummary.equals = equals;
})($9ce507040ec37629$var$ExecutionSummary || (module.exports.ExecutionSummary = $9ce507040ec37629$var$ExecutionSummary = {}));
var $9ce507040ec37629$var$NotebookCell;
(function(NotebookCell) {
    function create(kind, document) {
        return {
            kind: kind,
            document: document
        };
    }
    NotebookCell.create = create;
    function is(value) {
        const candidate = value;
        return $9ce507040ec37629$var$Is.objectLiteral(candidate) && $9ce507040ec37629$var$NotebookCellKind.is(candidate.kind) && $bDmGd.DocumentUri.is(candidate.document) && (candidate.metadata === undefined || $9ce507040ec37629$var$Is.objectLiteral(candidate.metadata));
    }
    NotebookCell.is = is;
    function diff(one, two) {
        const result = new Set();
        if (one.document !== two.document) result.add('document');
        if (one.kind !== two.kind) result.add('kind');
        if (one.executionSummary !== two.executionSummary) result.add('executionSummary');
        if ((one.metadata !== undefined || two.metadata !== undefined) && !equalsMetadata(one.metadata, two.metadata)) result.add('metadata');
        if ((one.executionSummary !== undefined || two.executionSummary !== undefined) && !$9ce507040ec37629$var$ExecutionSummary.equals(one.executionSummary, two.executionSummary)) result.add('executionSummary');
        return result;
    }
    NotebookCell.diff = diff;
    function equalsMetadata(one, other) {
        if (one === other) return true;
        if (one === null || one === undefined || other === null || other === undefined) return false;
        if (typeof one !== typeof other) return false;
        if (typeof one !== 'object') return false;
        const oneArray = Array.isArray(one);
        const otherArray = Array.isArray(other);
        if (oneArray !== otherArray) return false;
        if (oneArray && otherArray) {
            if (one.length !== other.length) return false;
            for(let i = 0; i < one.length; i++){
                if (!equalsMetadata(one[i], other[i])) return false;
            }
        }
        if ($9ce507040ec37629$var$Is.objectLiteral(one) && $9ce507040ec37629$var$Is.objectLiteral(other)) {
            const oneKeys = Object.keys(one);
            const otherKeys = Object.keys(other);
            if (oneKeys.length !== otherKeys.length) return false;
            oneKeys.sort();
            otherKeys.sort();
            if (!equalsMetadata(oneKeys, otherKeys)) return false;
            for(let i = 0; i < oneKeys.length; i++){
                const prop = oneKeys[i];
                if (!equalsMetadata(one[prop], other[prop])) return false;
            }
        }
        return true;
    }
})($9ce507040ec37629$var$NotebookCell || (module.exports.NotebookCell = $9ce507040ec37629$var$NotebookCell = {}));
var $9ce507040ec37629$var$NotebookDocument;
(function(NotebookDocument) {
    function create(uri, notebookType, version, cells) {
        return {
            uri: uri,
            notebookType: notebookType,
            version: version,
            cells: cells
        };
    }
    NotebookDocument.create = create;
    function is(value) {
        const candidate = value;
        return $9ce507040ec37629$var$Is.objectLiteral(candidate) && $9ce507040ec37629$var$Is.string(candidate.uri) && $bDmGd.integer.is(candidate.version) && $9ce507040ec37629$var$Is.typedArray(candidate.cells, $9ce507040ec37629$var$NotebookCell.is);
    }
    NotebookDocument.is = is;
})($9ce507040ec37629$var$NotebookDocument || (module.exports.NotebookDocument = $9ce507040ec37629$var$NotebookDocument = {}));
var $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType;
(function(NotebookDocumentSyncRegistrationType) {
    NotebookDocumentSyncRegistrationType.method = 'notebookDocument/sync';
    NotebookDocumentSyncRegistrationType.messageDirection = $3H92V.MessageDirection.clientToServer;
    NotebookDocumentSyncRegistrationType.type = new $3H92V.RegistrationType(NotebookDocumentSyncRegistrationType.method);
})($9ce507040ec37629$var$NotebookDocumentSyncRegistrationType || (module.exports.NotebookDocumentSyncRegistrationType = $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType = {}));
/**
 * A notification sent when a notebook opens.
 *
 * @since 3.17.0
 */ var $9ce507040ec37629$var$DidOpenNotebookDocumentNotification;
(function(DidOpenNotebookDocumentNotification) {
    DidOpenNotebookDocumentNotification.method = 'notebookDocument/didOpen';
    DidOpenNotebookDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidOpenNotebookDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidOpenNotebookDocumentNotification.method);
    DidOpenNotebookDocumentNotification.registrationMethod = $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType.method;
})($9ce507040ec37629$var$DidOpenNotebookDocumentNotification || (module.exports.DidOpenNotebookDocumentNotification = $9ce507040ec37629$var$DidOpenNotebookDocumentNotification = {}));
var $9ce507040ec37629$var$NotebookCellArrayChange;
(function(NotebookCellArrayChange) {
    function is(value) {
        const candidate = value;
        return $9ce507040ec37629$var$Is.objectLiteral(candidate) && $bDmGd.uinteger.is(candidate.start) && $bDmGd.uinteger.is(candidate.deleteCount) && (candidate.cells === undefined || $9ce507040ec37629$var$Is.typedArray(candidate.cells, $9ce507040ec37629$var$NotebookCell.is));
    }
    NotebookCellArrayChange.is = is;
    function create(start, deleteCount, cells) {
        const result = {
            start: start,
            deleteCount: deleteCount
        };
        if (cells !== undefined) result.cells = cells;
        return result;
    }
    NotebookCellArrayChange.create = create;
})($9ce507040ec37629$var$NotebookCellArrayChange || (module.exports.NotebookCellArrayChange = $9ce507040ec37629$var$NotebookCellArrayChange = {}));
var $9ce507040ec37629$var$DidChangeNotebookDocumentNotification;
(function(DidChangeNotebookDocumentNotification) {
    DidChangeNotebookDocumentNotification.method = 'notebookDocument/didChange';
    DidChangeNotebookDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidChangeNotebookDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidChangeNotebookDocumentNotification.method);
    DidChangeNotebookDocumentNotification.registrationMethod = $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType.method;
})($9ce507040ec37629$var$DidChangeNotebookDocumentNotification || (module.exports.DidChangeNotebookDocumentNotification = $9ce507040ec37629$var$DidChangeNotebookDocumentNotification = {}));
/**
 * A notification sent when a notebook document is saved.
 *
 * @since 3.17.0
 */ var $9ce507040ec37629$var$DidSaveNotebookDocumentNotification;
(function(DidSaveNotebookDocumentNotification) {
    DidSaveNotebookDocumentNotification.method = 'notebookDocument/didSave';
    DidSaveNotebookDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidSaveNotebookDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidSaveNotebookDocumentNotification.method);
    DidSaveNotebookDocumentNotification.registrationMethod = $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType.method;
})($9ce507040ec37629$var$DidSaveNotebookDocumentNotification || (module.exports.DidSaveNotebookDocumentNotification = $9ce507040ec37629$var$DidSaveNotebookDocumentNotification = {}));
/**
 * A notification sent when a notebook closes.
 *
 * @since 3.17.0
 */ var $9ce507040ec37629$var$DidCloseNotebookDocumentNotification;
(function(DidCloseNotebookDocumentNotification) {
    DidCloseNotebookDocumentNotification.method = 'notebookDocument/didClose';
    DidCloseNotebookDocumentNotification.messageDirection = $3H92V.MessageDirection.clientToServer;
    DidCloseNotebookDocumentNotification.type = new $3H92V.ProtocolNotificationType(DidCloseNotebookDocumentNotification.method);
    DidCloseNotebookDocumentNotification.registrationMethod = $9ce507040ec37629$var$NotebookDocumentSyncRegistrationType.method;
})($9ce507040ec37629$var$DidCloseNotebookDocumentNotification || (module.exports.DidCloseNotebookDocumentNotification = $9ce507040ec37629$var$DidCloseNotebookDocumentNotification = {}));

});

parcelRegister("8PeYO", function(module, exports) {
"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InlineCompletionRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * A request to provide inline completions in a document. The request's parameter is of
 * type {@link InlineCompletionParams}, the response is of type
 * {@link InlineCompletion InlineCompletion[]} or a Thenable that resolves to such.
 *
 * @since 3.18.0
 */ var $66ceb4db29879e71$var$InlineCompletionRequest;
(function(InlineCompletionRequest) {
    InlineCompletionRequest.method = 'textDocument/inlineCompletion';
    InlineCompletionRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    InlineCompletionRequest.type = new $3H92V.ProtocolRequestType(InlineCompletionRequest.method);
    InlineCompletionRequest.capabilities = $3H92V.CM.create('textDocument.inlineCompletion', 'inlineCompletionProvider');
})($66ceb4db29879e71$var$InlineCompletionRequest || (module.exports.InlineCompletionRequest = $66ceb4db29879e71$var$InlineCompletionRequest = {}));

});

parcelRegister("ezXZK", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextDocumentContentRefreshRequest = module.exports.TextDocumentContentRequest = void 0;

var $3H92V = parcelRequire("3H92V");
/**
 * The `workspace/textDocumentContent` request is sent from the client to the
 * server to request the content of a text document.
 *
 * @since 3.18.0
 */ var $a9d2df54dc1105b3$var$TextDocumentContentRequest;
(function(TextDocumentContentRequest) {
    TextDocumentContentRequest.method = 'workspace/textDocumentContent';
    TextDocumentContentRequest.messageDirection = $3H92V.MessageDirection.clientToServer;
    TextDocumentContentRequest.type = new $3H92V.ProtocolRequestType(TextDocumentContentRequest.method);
    TextDocumentContentRequest.capabilities = $3H92V.CM.create('workspace.textDocumentContent', 'workspace.textDocumentContent');
})($a9d2df54dc1105b3$var$TextDocumentContentRequest || (module.exports.TextDocumentContentRequest = $a9d2df54dc1105b3$var$TextDocumentContentRequest = {}));
/**
 * The `workspace/textDocumentContent` request is sent from the server to the client to refresh
 * the content of a specific text document.
 *
 * @since 3.18.0
 */ var $a9d2df54dc1105b3$var$TextDocumentContentRefreshRequest;
(function(TextDocumentContentRefreshRequest) {
    TextDocumentContentRefreshRequest.method = `workspace/textDocumentContent/refresh`;
    TextDocumentContentRefreshRequest.messageDirection = $3H92V.MessageDirection.serverToClient;
    TextDocumentContentRefreshRequest.type = new $3H92V.ProtocolRequestType(TextDocumentContentRefreshRequest.method);
})($a9d2df54dc1105b3$var$TextDocumentContentRefreshRequest || (module.exports.TextDocumentContentRefreshRequest = $a9d2df54dc1105b3$var$TextDocumentContentRefreshRequest = {}));

});


parcelRegister("8dPLY", function(module, exports) {
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createProtocolConnection = $5fc7b29e9fcca253$var$createProtocolConnection;

var $d8V62 = parcelRequire("d8V62");
function $5fc7b29e9fcca253$var$createProtocolConnection(input, output, logger, options) {
    if ($d8V62.ConnectionStrategy.is(options)) options = {
        connectionStrategy: options
    };
    return (0, $d8V62.createMessageConnection)(input, output, logger, options);
}

});


// web/src/main.ts
// @ts-expect-error
var $ee520df843a253e5$exports = {};
$ee520df843a253e5$exports = ":terminal 開始\n命令\n:comment コメント文\n:call 関数呼び出し\n\t中身\n:if 条件式\n\t真の場合\n:else\n\t偽の場合(:else以下は省略可能)\n:switch 条件\n:case ケース1\n\tケース1の中身\n:case ケース2\n\tケース2の中身\n:case ...\n\tケース文は必要に応じていくつでも追加できます\n:while 繰り返し条件（先判定）\n\t中身\n:dowhile 繰り返し条件（後判定）\n\t中身\n文字列の途中で\\@を使うと@改行されて表示されます\n行末に\\@を置くと@\n次の行と連結して1つの処理になります\n:terminal 終了\n";


var $560653e296c684a1$exports = {};
$560653e296c684a1$exports = JSON.parse("{\"name\":\"padtools_ts\",\"version\":\"0.4.0\",\"type\":\"module\",\"engines\":{\"node\":\">=22\"},\"browserslist\":\"> 0.5%, last 2 versions, not dead\",\"bin\":{\"padtools_ts\":\"dist/cli/cli.js\"},\"files\":[\"dist\",\"dist-web\",\"LICENSE\",\"README.md\"],\"scripts\":{\"build\":\"rimraf dist && tsc\",\"prepublishOnly\":\"npm run build && npm run build:web\",\"format\":\"biome format --write .\",\"start\":\"tsx src/cli/cli.ts\",\"start:api\":\"tsx src/api/server.ts\",\"start:api:bun\":\"bun src/api/server.ts\",\"start:mcp\":\"tsx src/mcp/server.ts\",\"test\":\"jest\",\"test:bun\":\"bun test --exclude tests/web\",\"test:jest:bun\":\"node ./node_modules/jest/bin/jest.js --runInBand\",\"test:web\":\"playwright test\",\"test:web:headed\":\"playwright test --headed\",\"test:cov\":\"jest --coverage\",\"ci\":\"npm run check && npm run build && npm run build:web && npm run test:cov && npm run test:web && npm run convert:web:commands && npm run convert:web:render_options\",\"update-cli-golden-files\":\"tsx tests/cli/E2E/updateGoldenFile.ts\",\"update-spd-golden-files\":\"tsx tests/spd/E2E/updateGoldenFile.ts\",\"update-web-golden-files\":\"tsx tests/web/updateGoldenFile.ts\",\"lint\":\"biome lint .\",\"check\":\"biome check .\",\"check:apply\":\"biome check --write --unsafe .\",\"start:web\":\"parcel web/index.html --dist-dir temp/\",\"build:web\":\"rimraf dist-web && parcel build web/index.html --dist-dir dist-web\",\"build:web:gh-pages\":\"rimraf gh-pages/ && parcel build web/index.html --dist-dir gh-pages/ --public-url /padtools_ts/ && echo > gh-pages/.nojekyll\",\"convert:web:commands\":\"tsx web/utility/convert_commands.ts\",\"convert:web:render_options\":\"tsx web/utility/convert_render_options.ts\",\"deploy\":\"wrangler deploy\",\"dev:worker\":\"wrangler dev\",\"prepare\":\"husky\"},\"keywords\":[\"pad\",\"flowchart\",\"diagram\",\"generator\",\"cli\",\"svg\",\"typescript\",\"PAD\"],\"author\":\"steelpipe\",\"license\":\"MIT\",\"description\":\"Simple tool to write PAD.\",\"dependencies\":{\"@hono/mcp\":\"^0.3.4\",\"@hono/node-server\":\"^2.1.1\",\"@hono/swagger-ui\":\"^0.6.1\",\"@hono/zod-openapi\":\"^1.6.3\",\"@modelcontextprotocol/sdk\":\"^1.32.1\",\"commander\":\"^15.0.0\",\"eastasianwidth\":\"^0.3.0\",\"fastmcp\":\"^4.23.5\",\"glob\":\"^14.0.3\",\"hono\":\"^4.13.14\",\"langium\":\"^4.3.1\",\"sanitize-html\":\"^2.18.1\",\"svgo\":\"^4.1.0\",\"xml-formatter\":\"^3.7.0\",\"zod\":\"^4.6.7\"},\"devDependencies\":{\"@biomejs/biome\":\"^2.6.3\",\"@fullhuman/postcss-purgecss\":\"^8.0.0\",\"@parcel/packager-ts\":\"^2.16.4\",\"@parcel/transformer-inline-string\":\"^2.16.4\",\"@parcel/transformer-typescript-types\":\"^2.16.1\",\"@playwright/test\":\"^1.64.1\",\"@swc/core\":\"^1.16.20\",\"@swc/jest\":\"^0.2.39\",\"@types/jest\":\"^30.0.0\",\"@types/node\":\"^26.6.5\",\"@types/sanitize-html\":\"^2.16.2\",\"baseline-browser-mapping\":\"^2.11.30\",\"buffer\":\"^6.0.3\",\"entities\":\"^8.1.0\",\"husky\":\"^9.1.7\",\"jest\":\"^30.5.2\",\"langium-cli\":\"^4.4.0\",\"parcel\":\"^2.16.4\",\"postcss\":\"^8.5.30\",\"process\":\"^0.11.10\",\"rimraf\":\"^4.1.4\",\"tsx\":\"^4.23.15\",\"typescript\":\"^7.0.2\",\"wrangler\":\"^4.154.0\"},\"alias\":{\"entities/decode\":\"entities/dist/decode.js\",\"langium\":\"langium/lib/index.js\",\"vscode-languageserver-protocol\":\"vscode-languageserver-protocol/lib/browser/main.js\",\"vscode-languageserver-types\":\"vscode-languageserver-types/lib/umd/main.js\",\"vscode-jsonrpc/browser\":\"vscode-jsonrpc/lib/browser/main.js\",\"vscode-jsonrpc\":\"vscode-jsonrpc/lib/browser/main.js\",\"chevrotain\":\"chevrotain/lib/chevrotain.mjs\",\"chevrotain-allstar\":\"chevrotain-allstar/lib/index.js\",\"@chevrotain/regexp-to-ast\":\"@chevrotain/regexp-to-ast/lib/src/api.js\",\"@chevrotain/utils\":\"@chevrotain/utils/lib/src/api.js\",\"@chevrotain/gast\":\"@chevrotain/gast/lib/src/api.js\",\"@chevrotain/types\":\"@chevrotain/types/lib/api.js\",\"@chevrotain/cst-dts-gen\":\"@chevrotain/cst-dts-gen/lib/src/api.js\",\"vscode-uri\":\"vscode-uri/lib/umd/index.js\"},\"overrides\":{\"test-exclude\":\"7.0.1\",\"glob\":\"$glob\"}}");


/**
 * 解析された構造における汎用ノードを表します。
 * いくつかの特定のノードタイプのいずれかになります。
 */ function $a84dc0d9eb6de82c$export$ad632ceaa839ccf(ast, space) {
    if (ast === null) return "null";
    return JSON.stringify(ast, (_key, value)=>{
        if (value instanceof Map) return {
            __type: "Map",
            value: Array.from(value.entries())
        };
        return value;
    }, space);
}
function $a84dc0d9eb6de82c$export$20f9c480f308924b(json) {
    if (json === "null") return null;
    return JSON.parse(json, (_key, value)=>{
        if (value && typeof value === "object" && value.__type === "Map") return new Map(value.value);
        return value;
    });
}
const $a84dc0d9eb6de82c$export$fe6316dd7c7b775d = {
    serializeAST: $a84dc0d9eb6de82c$export$ad632ceaa839ccf,
    deserializeAST: $a84dc0d9eb6de82c$export$20f9c480f308924b
};


/******************************************************************************
 * This file was generated by langium-cli 4.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/ /* eslint-disable */ /******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ function $09c22474b334b427$export$dd586f2688797f92(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.$type === 'string';
}
function $09c22474b334b427$export$fa99cac1c0883c47(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.$refText === 'string' && 'ref' in obj;
}
function $09c22474b334b427$export$c99833078476c909(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.$refText === 'string' && 'items' in obj;
}
function $09c22474b334b427$export$ad0854b800d930a4(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.name === 'string' && typeof obj.type === 'string' && typeof obj.path === 'string';
}
function $09c22474b334b427$export$6693381b2423862d(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.info === 'object' && typeof obj.message === 'string';
}
class $09c22474b334b427$export$78784b6d346bc16d {
    constructor(){
        this.subtypes = {};
        this.allSubtypes = {};
    }
    getAllTypes() {
        return Object.keys(this.types);
    }
    getReferenceType(refInfo) {
        const metaData = this.types[refInfo.container.$type];
        if (!metaData) throw new Error(`Type ${refInfo.container.$type || 'undefined'} not found.`);
        const referenceType = metaData.properties[refInfo.property]?.referenceType;
        if (!referenceType) throw new Error(`Property ${refInfo.property || 'undefined'} of type ${refInfo.container.$type} is not a reference.`);
        return referenceType;
    }
    getTypeMetaData(type) {
        const result = this.types[type];
        if (!result) return {
            name: type,
            properties: {},
            superTypes: []
        };
        return result;
    }
    isInstance(node, type) {
        return $09c22474b334b427$export$dd586f2688797f92(node) && this.isSubtype(node.$type, type);
    }
    isSubtype(subtype, supertype) {
        if (subtype === supertype) return true;
        let nested = this.subtypes[subtype];
        if (!nested) nested = this.subtypes[subtype] = {};
        const existing = nested[supertype];
        if (existing !== undefined) return existing;
        else {
            const metaData = this.types[subtype];
            const result = metaData ? metaData.superTypes.some((s)=>this.isSubtype(s, supertype)) : false;
            nested[supertype] = result;
            return result;
        }
    }
    getAllSubTypes(type) {
        const existing = this.allSubtypes[type];
        if (existing) return existing;
        else {
            const allTypes = this.getAllTypes();
            const types = [];
            for (const possibleSubType of allTypes)if (this.isSubtype(possibleSubType, type)) types.push(possibleSubType);
            this.allSubtypes[type] = types;
            return types;
        }
    }
    /**
     * Check whether a given AST node is missing any non-optional properties.
     * Used to guard against incomplete nodes that deviate from their declared type,
     * particularly when error recovery is in effect.
     */ isComplete(node) {
        const meta = this.getTypeMetaData(node.$type);
        for (const key of Object.keys(meta.properties)){
            const prop = meta.properties[key];
            if (prop.optional) continue;
            const value = node[prop.name];
            if (value === undefined || value === null) return false;
        }
        return true;
    }
}
function $09c22474b334b427$export$e4d2208aa188ebc5(node) {
    return typeof node === 'object' && node !== null && Array.isArray(node.content);
}
function $09c22474b334b427$export$e82a11db49cb0b82(node) {
    return typeof node === 'object' && node !== null && typeof node.tokenType === 'object';
}
function $09c22474b334b427$export$95ae76a9457c0b7d(node) {
    return $09c22474b334b427$export$e4d2208aa188ebc5(node) && typeof node.fullText === 'string';
}


const $9b23bf1934cbb958$export$180a9cbcb16621ba = {
    INDENT: /synthetic:indent/,
    DEDENT: /synthetic:dedent/,
    LINE_COMMENT: /#[^\n\r]*/,
    Content: /[^\t:\n\r](?:[^\n\r]*(?<!\\)@[ \t]*\r?\n[ \t]*|#[^\n\r]*\r?\n[ \t]*)*[^\n\r]*/,
    WS: /[ \t]+/,
    NEWLINE: /\r?\n/
};
function $9b23bf1934cbb958$export$a9a7f57a2c4f210a(item) {
    return typeof item === 'string' && /[^\t:\n\r](?:[^\n\r]*(?<!\\)@[ \t]*\r?\n[ \t]*|#[^\n\r]*\r?\n[ \t]*)*[^\n\r]*/.test(item);
}
const $9b23bf1934cbb958$export$d96a8827a60d6b69 = {
    $type: 'Block',
    statements: 'statements'
};
function $9b23bf1934cbb958$export$de5a9e42c1dff8da(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$d96a8827a60d6b69.$type);
}
const $9b23bf1934cbb958$export$eb33e365f6112854 = {
    $type: 'CallStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$383a1cf0ba5823b2(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$eb33e365f6112854.$type);
}
const $9b23bf1934cbb958$export$52301ef8d97547f1 = {
    $type: 'CaseStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$b0e67572cf2555f7(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$52301ef8d97547f1.$type);
}
const $9b23bf1934cbb958$export$6401305e404f585a = {
    $type: 'CommandStatement'
};
function $9b23bf1934cbb958$export$9b7dc97183f0dd51(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$6401305e404f585a.$type);
}
const $9b23bf1934cbb958$export$3bc2ccfb592cd971 = {
    $type: 'CommentStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$fa509cabd5955637(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$3bc2ccfb592cd971.$type);
}
const $9b23bf1934cbb958$export$473d7ca84c114b4b = {
    $type: 'DoWhileStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$3f395735debea0f3(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$473d7ca84c114b4b.$type);
}
const $9b23bf1934cbb958$export$bf9e95c0b5a6e7f7 = {
    $type: 'ElseStatement',
    block: 'block'
};
function $9b23bf1934cbb958$export$d05303fa73d3cd50(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$bf9e95c0b5a6e7f7.$type);
}
const $9b23bf1934cbb958$export$9017d3771bcf5fda = {
    $type: 'IfStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$5d8d1c90f5b3b487(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$9017d3771bcf5fda.$type);
}
const $9b23bf1934cbb958$export$a1edc412be3e1841 = {
    $type: 'Model',
    statements: 'statements'
};
function $9b23bf1934cbb958$export$6d664b428f87db81(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$a1edc412be3e1841.$type);
}
const $9b23bf1934cbb958$export$17d88cca6034fd69 = {
    $type: 'ProcessStatement',
    block: 'block',
    content: 'content'
};
function $9b23bf1934cbb958$export$2a0f7e1d90aa4674(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$17d88cca6034fd69.$type);
}
const $9b23bf1934cbb958$export$c84356afd4299847 = {
    $type: 'Statement'
};
function $9b23bf1934cbb958$export$78a28e85343c8674(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$c84356afd4299847.$type);
}
const $9b23bf1934cbb958$export$13dbcd95cf5b236b = {
    $type: 'SwitchStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$ec10f450bfbc36e1(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$13dbcd95cf5b236b.$type);
}
const $9b23bf1934cbb958$export$dbf9dc66fc25bafb = {
    $type: 'TerminalStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$985cf53721f25650(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$dbf9dc66fc25bafb.$type);
}
const $9b23bf1934cbb958$export$479b943950dcc4d3 = {
    $type: 'WhileStatement',
    arg: 'arg',
    block: 'block'
};
function $9b23bf1934cbb958$export$c91f7d902b010e81(item) {
    return $9b23bf1934cbb958$export$f49cbeca3e22a85e.isInstance(item, $9b23bf1934cbb958$export$479b943950dcc4d3.$type);
}
class $9b23bf1934cbb958$export$f3faa6c632e65501 extends $09c22474b334b427$export$78784b6d346bc16d {
    types = {
        Block: {
            name: $9b23bf1934cbb958$export$d96a8827a60d6b69.$type,
            properties: {
                statements: {
                    name: $9b23bf1934cbb958$export$d96a8827a60d6b69.statements,
                    defaultValue: []
                }
            },
            superTypes: []
        },
        CallStatement: {
            name: $9b23bf1934cbb958$export$eb33e365f6112854.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$eb33e365f6112854.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$eb33e365f6112854.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        CaseStatement: {
            name: $9b23bf1934cbb958$export$52301ef8d97547f1.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$52301ef8d97547f1.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$52301ef8d97547f1.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        CommandStatement: {
            name: $9b23bf1934cbb958$export$6401305e404f585a.$type,
            properties: {},
            superTypes: [
                $9b23bf1934cbb958$export$c84356afd4299847.$type
            ]
        },
        CommentStatement: {
            name: $9b23bf1934cbb958$export$3bc2ccfb592cd971.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$3bc2ccfb592cd971.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$3bc2ccfb592cd971.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        DoWhileStatement: {
            name: $9b23bf1934cbb958$export$473d7ca84c114b4b.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$473d7ca84c114b4b.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$473d7ca84c114b4b.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        ElseStatement: {
            name: $9b23bf1934cbb958$export$bf9e95c0b5a6e7f7.$type,
            properties: {
                block: {
                    name: $9b23bf1934cbb958$export$bf9e95c0b5a6e7f7.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        IfStatement: {
            name: $9b23bf1934cbb958$export$9017d3771bcf5fda.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$9017d3771bcf5fda.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$9017d3771bcf5fda.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        Model: {
            name: $9b23bf1934cbb958$export$a1edc412be3e1841.$type,
            properties: {
                statements: {
                    name: $9b23bf1934cbb958$export$a1edc412be3e1841.statements,
                    defaultValue: [],
                    optional: true
                }
            },
            superTypes: []
        },
        ProcessStatement: {
            name: $9b23bf1934cbb958$export$17d88cca6034fd69.$type,
            properties: {
                block: {
                    name: $9b23bf1934cbb958$export$17d88cca6034fd69.block,
                    optional: true
                },
                content: {
                    name: $9b23bf1934cbb958$export$17d88cca6034fd69.content
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$c84356afd4299847.$type
            ]
        },
        Statement: {
            name: $9b23bf1934cbb958$export$c84356afd4299847.$type,
            properties: {},
            superTypes: []
        },
        SwitchStatement: {
            name: $9b23bf1934cbb958$export$13dbcd95cf5b236b.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$13dbcd95cf5b236b.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$13dbcd95cf5b236b.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        TerminalStatement: {
            name: $9b23bf1934cbb958$export$dbf9dc66fc25bafb.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$dbf9dc66fc25bafb.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$dbf9dc66fc25bafb.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        },
        WhileStatement: {
            name: $9b23bf1934cbb958$export$479b943950dcc4d3.$type,
            properties: {
                arg: {
                    name: $9b23bf1934cbb958$export$479b943950dcc4d3.arg,
                    optional: true
                },
                block: {
                    name: $9b23bf1934cbb958$export$479b943950dcc4d3.block,
                    optional: true
                }
            },
            superTypes: [
                $9b23bf1934cbb958$export$6401305e404f585a.$type
            ]
        }
    };
}
const $9b23bf1934cbb958$export$f49cbeca3e22a85e = new $9b23bf1934cbb958$export$f3faa6c632e65501();


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
******************************************************************************/ /******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /**
 * The default implementation of `Stream` works with two input functions:
 *  - The first function creates the initial state of an iteration.
 *  - The second function gets the current state as argument and returns an `IteratorResult`.
 */ class $1feb7546a8c17818$export$b9307a13a75072f6 {
    constructor(startFn, nextFn){
        this.startFn = startFn;
        this.nextFn = nextFn;
    }
    iterator() {
        const iterator = {
            state: this.startFn(),
            next: ()=>this.nextFn(iterator.state),
            [Symbol.iterator]: ()=>iterator
        };
        return iterator;
    }
    [Symbol.iterator]() {
        return this.iterator();
    }
    isEmpty() {
        const iterator = this.iterator();
        return Boolean(iterator.next().done);
    }
    count() {
        const iterator = this.iterator();
        let count = 0;
        let next = iterator.next();
        while(!next.done){
            count++;
            next = iterator.next();
        }
        return count;
    }
    toArray() {
        const result = [];
        const iterator = this.iterator();
        let next;
        do {
            next = iterator.next();
            if (next.value !== undefined) result.push(next.value);
        }while (!next.done);
        return result;
    }
    toSet() {
        return new Set(this);
    }
    toMap(keyFn, valueFn) {
        const entryStream = this.map((element)=>[
                keyFn ? keyFn(element) : element,
                valueFn ? valueFn(element) : element
            ]);
        return new Map(entryStream);
    }
    toString() {
        return this.join();
    }
    concat(other) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                first: this.startFn(),
                firstDone: false,
                iterator: other[Symbol.iterator]()
            }), (state)=>{
            let result;
            if (!state.firstDone) {
                do {
                    result = this.nextFn(state.first);
                    if (!result.done) return result;
                }while (!result.done);
                state.firstDone = true;
            }
            do {
                result = state.iterator.next();
                if (!result.done) return result;
            }while (!result.done);
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    join(separator = ',') {
        const iterator = this.iterator();
        let value = '';
        let result;
        let addSeparator = false;
        do {
            result = iterator.next();
            if (!result.done) {
                if (addSeparator) value += separator;
                value += $1feb7546a8c17818$var$toString(result.value);
            }
            addSeparator = true;
        }while (!result.done);
        return value;
    }
    indexOf(searchElement, fromIndex = 0) {
        const iterator = this.iterator();
        let index = 0;
        let next = iterator.next();
        while(!next.done){
            if (index >= fromIndex && next.value === searchElement) return index;
            next = iterator.next();
            index++;
        }
        return -1;
    }
    every(predicate) {
        const iterator = this.iterator();
        let next = iterator.next();
        while(!next.done){
            if (!predicate(next.value)) return false;
            next = iterator.next();
        }
        return true;
    }
    some(predicate) {
        const iterator = this.iterator();
        let next = iterator.next();
        while(!next.done){
            if (predicate(next.value)) return true;
            next = iterator.next();
        }
        return false;
    }
    forEach(callbackfn) {
        const iterator = this.iterator();
        let index = 0;
        let next = iterator.next();
        while(!next.done){
            callbackfn(next.value, index);
            next = iterator.next();
            index++;
        }
    }
    map(callbackfn) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(this.startFn, (state)=>{
            const { done: done, value: value } = this.nextFn(state);
            if (done) return $1feb7546a8c17818$export$fc6411ac32a30069;
            else return {
                done: false,
                value: callbackfn(value)
            };
        });
    }
    filter(predicate) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(this.startFn, (state)=>{
            let result;
            do {
                result = this.nextFn(state);
                if (!result.done && predicate(result.value)) return result;
            }while (!result.done);
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    nonNullable() {
        return this.filter((e)=>e !== undefined && e !== null);
    }
    reduce(callbackfn, initialValue) {
        const iterator = this.iterator();
        let previousValue = initialValue;
        let next = iterator.next();
        while(!next.done){
            if (previousValue === undefined) previousValue = next.value;
            else previousValue = callbackfn(previousValue, next.value);
            next = iterator.next();
        }
        return previousValue;
    }
    reduceRight(callbackfn, initialValue) {
        return this.recursiveReduce(this.iterator(), callbackfn, initialValue);
    }
    recursiveReduce(iterator, callbackfn, initialValue) {
        const next = iterator.next();
        if (next.done) return initialValue;
        const previousValue = this.recursiveReduce(iterator, callbackfn, initialValue);
        if (previousValue === undefined) return next.value;
        return callbackfn(previousValue, next.value);
    }
    find(predicate) {
        const iterator = this.iterator();
        let next = iterator.next();
        while(!next.done){
            if (predicate(next.value)) return next.value;
            next = iterator.next();
        }
        return undefined;
    }
    findIndex(predicate) {
        const iterator = this.iterator();
        let index = 0;
        let next = iterator.next();
        while(!next.done){
            if (predicate(next.value)) return index;
            next = iterator.next();
            index++;
        }
        return -1;
    }
    includes(searchElement) {
        const iterator = this.iterator();
        let next = iterator.next();
        while(!next.done){
            if (next.value === searchElement) return true;
            next = iterator.next();
        }
        return false;
    }
    flatMap(callbackfn) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                this: this.startFn()
            }), (state)=>{
            do {
                if (state.iterator) {
                    const next = state.iterator.next();
                    if (next.done) state.iterator = undefined;
                    else return next;
                }
                const { done: done, value: value } = this.nextFn(state.this);
                if (!done) {
                    const mapped = callbackfn(value);
                    if ($1feb7546a8c17818$var$isIterable(mapped)) state.iterator = mapped[Symbol.iterator]();
                    else return {
                        done: false,
                        value: mapped
                    };
                }
            }while (state.iterator);
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    flat(depth) {
        if (depth === undefined) depth = 1;
        if (depth <= 0) return this;
        const stream = depth > 1 ? this.flat(depth - 1) : this;
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                this: stream.startFn()
            }), (state)=>{
            do {
                if (state.iterator) {
                    const next = state.iterator.next();
                    if (next.done) state.iterator = undefined;
                    else return next;
                }
                const { done: done, value: value } = stream.nextFn(state.this);
                if (!done) {
                    if ($1feb7546a8c17818$var$isIterable(value)) state.iterator = value[Symbol.iterator]();
                    else return {
                        done: false,
                        value: value
                    };
                }
            }while (state.iterator);
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    head() {
        const iterator = this.iterator();
        const result = iterator.next();
        if (result.done) return undefined;
        return result.value;
    }
    tail(skipCount = 1) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>{
            const state = this.startFn();
            for(let i = 0; i < skipCount; i++){
                const next = this.nextFn(state);
                if (next.done) return state;
            }
            return state;
        }, this.nextFn);
    }
    limit(maxSize) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                size: 0,
                state: this.startFn()
            }), (state)=>{
            state.size++;
            if (state.size > maxSize) return $1feb7546a8c17818$export$fc6411ac32a30069;
            return this.nextFn(state.state);
        });
    }
    distinct(by) {
        return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                set: new Set(),
                internalState: this.startFn()
            }), (state)=>{
            let result;
            do {
                result = this.nextFn(state.internalState);
                if (!result.done) {
                    const value = by ? by(result.value) : result.value;
                    if (!state.set.has(value)) {
                        state.set.add(value);
                        return result;
                    }
                }
            }while (!result.done);
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    exclude(other, key) {
        const otherKeySet = new Set();
        for (const item of other){
            const value = key ? key(item) : item;
            otherKeySet.add(value);
        }
        return this.filter((e)=>{
            const ownKey = key ? key(e) : e;
            return !otherKeySet.has(ownKey);
        });
    }
}
function $1feb7546a8c17818$var$toString(item) {
    if (typeof item === 'string') return item;
    if (typeof item === 'undefined') return 'undefined';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof item.toString === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return item.toString();
    return Object.prototype.toString.call(item);
}
function $1feb7546a8c17818$var$isIterable(obj) {
    return !!obj && typeof obj[Symbol.iterator] === 'function';
}
const $1feb7546a8c17818$export$7160cecf0710cccd = new $1feb7546a8c17818$export$b9307a13a75072f6(()=>undefined, ()=>$1feb7546a8c17818$export$fc6411ac32a30069);
const $1feb7546a8c17818$export$fc6411ac32a30069 = Object.freeze({
    done: true,
    value: undefined
});
function $1feb7546a8c17818$export$4938110305e6185f(...collections) {
    if (collections.length === 1) {
        const collection = collections[0];
        if (collection instanceof $1feb7546a8c17818$export$b9307a13a75072f6) return collection;
        if ($1feb7546a8c17818$var$isIterable(collection)) return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>collection[Symbol.iterator](), (iterator)=>iterator.next());
        if (typeof collection.length === 'number') return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
                index: 0
            }), (state)=>{
            if (state.index < collection.length) return {
                done: false,
                value: collection[state.index++]
            };
            else return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    if (collections.length > 1) return new $1feb7546a8c17818$export$b9307a13a75072f6(()=>({
            collIndex: 0,
            arrIndex: 0
        }), (state)=>{
        do {
            if (state.iterator) {
                const next = state.iterator.next();
                if (!next.done) return next;
                state.iterator = undefined;
            }
            if (state.array) {
                if (state.arrIndex < state.array.length) return {
                    done: false,
                    value: state.array[state.arrIndex++]
                };
                state.array = undefined;
                state.arrIndex = 0;
            }
            if (state.collIndex < collections.length) {
                const collection = collections[state.collIndex++];
                if ($1feb7546a8c17818$var$isIterable(collection)) state.iterator = collection[Symbol.iterator]();
                else if (collection && typeof collection.length === 'number') state.array = collection;
            }
        }while (state.iterator || state.array || state.collIndex < collections.length);
        return $1feb7546a8c17818$export$fc6411ac32a30069;
    });
    return $1feb7546a8c17818$export$7160cecf0710cccd;
}
class $1feb7546a8c17818$export$ab7c393f8e95c558 extends $1feb7546a8c17818$export$b9307a13a75072f6 {
    constructor(root, children, options){
        super(()=>({
                iterators: options?.includeRoot ? [
                    [
                        root
                    ][Symbol.iterator]()
                ] : [
                    children(root)[Symbol.iterator]()
                ],
                pruned: false
            }), (state)=>{
            if (state.pruned) {
                state.iterators.pop();
                state.pruned = false;
            }
            while(state.iterators.length > 0){
                const iterator = state.iterators[state.iterators.length - 1];
                const next = iterator.next();
                if (next.done) state.iterators.pop();
                else {
                    state.iterators.push(children(next.value)[Symbol.iterator]());
                    return next;
                }
            }
            return $1feb7546a8c17818$export$fc6411ac32a30069;
        });
    }
    iterator() {
        const iterator = {
            state: this.startFn(),
            next: ()=>this.nextFn(iterator.state),
            prune: ()=>{
                iterator.state.pruned = true;
            },
            [Symbol.iterator]: ()=>iterator
        };
        return iterator;
    }
}
var $1feb7546a8c17818$export$cc9fa7113d70efba;
(function(Reduction) {
    /**
     * Compute the sum of a number stream.
     */ function sum(stream) {
        return stream.reduce((a, b)=>a + b, 0);
    }
    Reduction.sum = sum;
    /**
     * Compute the product of a number stream.
     */ function product(stream) {
        return stream.reduce((a, b)=>a * b, 0);
    }
    Reduction.product = product;
    /**
     * Compute the minimum of a number stream. Returns `undefined` if the stream is empty.
     */ function min(stream) {
        return stream.reduce((a, b)=>Math.min(a, b));
    }
    Reduction.min = min;
    /**
     * Compute the maximum of a number stream. Returns `undefined` if the stream is empty.
     */ function max(stream) {
        return stream.reduce((a, b)=>Math.max(a, b));
    }
    Reduction.max = max;
})($1feb7546a8c17818$export$cc9fa7113d70efba || ($1feb7546a8c17818$export$cc9fa7113d70efba = {}));


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 


function $de130ae470c6cbfb$export$5cc7fb0ff669ce28(node, options = {}) {
    for (const [name, value] of Object.entries(node))if (!name.startsWith('$')) {
        if (Array.isArray(value)) value.forEach((item, index)=>{
            if ((0, $09c22474b334b427$export$dd586f2688797f92)(item)) {
                item.$container = node;
                item.$containerProperty = name;
                item.$containerIndex = index;
                if (options.deep) $de130ae470c6cbfb$export$5cc7fb0ff669ce28(item, options);
            }
        });
        else if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) {
            value.$container = node;
            value.$containerProperty = name;
            if (options.deep) $de130ae470c6cbfb$export$5cc7fb0ff669ce28(value, options);
        }
    }
}
function $de130ae470c6cbfb$export$51e1e993675a3c6a(node, typePredicate) {
    let item = node;
    while(item){
        if (typePredicate(item)) return item;
        item = item.$container;
    }
    return undefined;
}
function $de130ae470c6cbfb$export$91faa7d224bdda6(node, predicate) {
    let item = node;
    while(item){
        if (predicate(item)) return true;
        item = item.$container;
    }
    return false;
}
function $de130ae470c6cbfb$export$f65ca476c09acec0(node) {
    const rootNode = $de130ae470c6cbfb$export$4c67bdbd93d70745(node);
    const result = rootNode.$document;
    if (!result) throw new Error('AST node has no document.');
    return result;
}
function $de130ae470c6cbfb$export$4c67bdbd93d70745(node) {
    while(node.$container)node = node.$container;
    return node;
}
function $de130ae470c6cbfb$export$d2e690f644aa0441(reference) {
    if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(reference)) return reference.ref ? [
        reference.ref
    ] : [];
    else if ((0, $09c22474b334b427$export$c99833078476c909)(reference)) return reference.items.map((item)=>item.ref);
    return [];
}
function $de130ae470c6cbfb$export$99c402bba993fa31(node, options) {
    if (!node) throw new Error('Node must be an AstNode.');
    const range = options?.range;
    return new (0, $1feb7546a8c17818$export$b9307a13a75072f6)(()=>({
            keys: Object.keys(node),
            keyIndex: 0,
            arrayIndex: 0
        }), (state)=>{
        while(state.keyIndex < state.keys.length){
            const property = state.keys[state.keyIndex];
            if (!property.startsWith('$')) {
                const value = node[property];
                if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) {
                    state.keyIndex++;
                    if ($de130ae470c6cbfb$var$isAstNodeInRange(value, range)) return {
                        done: false,
                        value: value
                    };
                } else if (Array.isArray(value)) {
                    while(state.arrayIndex < value.length){
                        const index = state.arrayIndex++;
                        const element = value[index];
                        if ((0, $09c22474b334b427$export$dd586f2688797f92)(element) && $de130ae470c6cbfb$var$isAstNodeInRange(element, range)) return {
                            done: false,
                            value: element
                        };
                    }
                    state.arrayIndex = 0;
                }
            }
            state.keyIndex++;
        }
        return 0, $1feb7546a8c17818$export$fc6411ac32a30069;
    });
}
function $de130ae470c6cbfb$export$b4b3af85716f6615(root, options) {
    if (!root) throw new Error('Root node must be an AstNode.');
    return new (0, $1feb7546a8c17818$export$ab7c393f8e95c558)(root, (node)=>$de130ae470c6cbfb$export$99c402bba993fa31(node, options));
}
function $de130ae470c6cbfb$export$b7350f614170899e(root, options) {
    if (!root) throw new Error('Root node must be an AstNode.');
    else if (options?.range && !$de130ae470c6cbfb$var$isAstNodeInRange(root, options.range)) // Return an empty stream if the root node isn't in range
    return new (0, $1feb7546a8c17818$export$ab7c393f8e95c558)(root, ()=>[]);
    return new (0, $1feb7546a8c17818$export$ab7c393f8e95c558)(root, (node)=>$de130ae470c6cbfb$export$99c402bba993fa31(node, options), {
        includeRoot: true
    });
}
function $de130ae470c6cbfb$var$isAstNodeInRange(astNode, range) {
    if (!range) return true;
    const nodeRange = astNode.$cstNode?.range;
    if (!nodeRange) return false;
    return (0, $f87d6e075cbbfde9$export$ddf89a9c5af38f94)(nodeRange, range);
}
function $de130ae470c6cbfb$export$a724fcaa837c6cb2(node) {
    return new (0, $1feb7546a8c17818$export$b9307a13a75072f6)(()=>({
            keys: Object.keys(node),
            keyIndex: 0,
            arrayIndex: 0
        }), (state)=>{
        while(state.keyIndex < state.keys.length){
            const property = state.keys[state.keyIndex];
            if (!property.startsWith('$')) {
                const value = node[property];
                if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(value) || (0, $09c22474b334b427$export$c99833078476c909)(value)) {
                    state.keyIndex++;
                    return {
                        done: false,
                        value: {
                            reference: value,
                            container: node,
                            property: property
                        }
                    };
                } else if (Array.isArray(value)) {
                    while(state.arrayIndex < value.length){
                        const index = state.arrayIndex++;
                        const element = value[index];
                        if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(element) || (0, $09c22474b334b427$export$c99833078476c909)(element)) return {
                            done: false,
                            value: {
                                reference: element,
                                container: node,
                                property: property,
                                index: index
                            }
                        };
                    }
                    state.arrayIndex = 0;
                }
            }
            state.keyIndex++;
        }
        return 0, $1feb7546a8c17818$export$fc6411ac32a30069;
    });
}
function $de130ae470c6cbfb$export$6d255b1506f7bc8d(reflection, node) {
    const typeMetaData = reflection.getTypeMetaData(node.$type);
    const genericNode = node;
    for (const property of Object.values(typeMetaData.properties))// Only set the value if the property is not already set and if it has a default value
    if (property.defaultValue !== undefined && genericNode[property.name] === undefined) genericNode[property.name] = $de130ae470c6cbfb$var$copyDefaultValue(property.defaultValue);
}
function $de130ae470c6cbfb$var$copyDefaultValue(propertyType) {
    if (Array.isArray(propertyType)) return [
        ...propertyType.map($de130ae470c6cbfb$var$copyDefaultValue)
    ];
    else return propertyType;
}
function $de130ae470c6cbfb$export$8bb021f7af82080e(node, buildReference, trace) {
    const copy = {
        $type: node.$type
    };
    if (trace) {
        trace.set(node, copy);
        trace.set(copy, node);
    }
    for (const [name, value] of Object.entries(node))if (!name.startsWith('$')) {
        if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) copy[name] = $de130ae470c6cbfb$export$8bb021f7af82080e(value, buildReference, trace);
        else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(value)) copy[name] = buildReference(copy, name, value.$refNode, value.$refText, value);
        else if (Array.isArray(value)) {
            const copiedArray = [];
            for (const element of value){
                if ((0, $09c22474b334b427$export$dd586f2688797f92)(element)) copiedArray.push($de130ae470c6cbfb$export$8bb021f7af82080e(element, buildReference, trace));
                else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(element)) copiedArray.push(buildReference(copy, name, element.$refNode, element.$refText, element));
                else copiedArray.push(element);
            }
            copy[name] = copiedArray;
        } else copy[name] = value;
    }
    $de130ae470c6cbfb$export$5cc7fb0ff669ce28(copy, {
        deep: true
    });
    return copy;
}


/******************************************************************************
 * This file was generated by langium-cli 4.4.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/ /* eslint-disable */ 
const $c70992891bcf3a02$export$a3a601ed0a201735 = {
    ID: /\^?[_a-zA-Z][\w_]*/,
    STRING: /"(\\.|[^"\\])*"|'(\\.|[^'\\])*'/,
    NUMBER: /NaN|-?((\d*\.\d+|\d+)([Ee][+-]?\d+)?|Infinity)/,
    RegexLiteral: /\/(?![*+?])(?:[^\r\n\[/\\]|\\.|\[(?:[^\r\n\]\\]|\\.)*\])+\/[a-z]*/,
    WS: /\s+/,
    ML_COMMENT: /\/\*[\s\S]*?\*\//,
    SL_COMMENT: /\/\/[^\n\r]*/
};
const $c70992891bcf3a02$export$d5345f74bf36d494 = {
    $type: 'AbstractElement',
    cardinality: 'cardinality'
};
function $c70992891bcf3a02$export$14d6559204778623(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$d5345f74bf36d494.$type);
}
const $c70992891bcf3a02$export$955d445890e317bf = {
    $type: 'AbstractParserRule'
};
function $c70992891bcf3a02$export$9075dd262e43c30d(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$955d445890e317bf.$type);
}
const $c70992891bcf3a02$export$f5ebc5080f757548 = {
    $type: 'AbstractRule'
};
function $c70992891bcf3a02$export$95a1acf5ef622a1f(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$f5ebc5080f757548.$type);
}
const $c70992891bcf3a02$export$c265dc8338484497 = {
    $type: 'AbstractType'
};
function $c70992891bcf3a02$export$6ea44a810dec4ac5(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$c265dc8338484497.$type);
}
const $c70992891bcf3a02$export$e19cd5f9376f8cee = {
    $type: 'Action',
    cardinality: 'cardinality',
    feature: 'feature',
    inferredType: 'inferredType',
    operator: 'operator',
    type: 'type'
};
function $c70992891bcf3a02$export$b956e38827fca970(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$e19cd5f9376f8cee.$type);
}
const $c70992891bcf3a02$export$83c65964db61e5ec = {
    $type: 'Alternatives',
    cardinality: 'cardinality',
    elements: 'elements'
};
function $c70992891bcf3a02$export$4729babbb377d4fc(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$83c65964db61e5ec.$type);
}
const $c70992891bcf3a02$export$2477073908a0de26 = {
    $type: 'ArrayLiteral',
    elements: 'elements'
};
function $c70992891bcf3a02$export$bc206098df880665(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$2477073908a0de26.$type);
}
const $c70992891bcf3a02$export$49c146ea18b05474 = {
    $type: 'ArrayType',
    elementType: 'elementType'
};
function $c70992891bcf3a02$export$b3f856ebde208b3c(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$49c146ea18b05474.$type);
}
const $c70992891bcf3a02$export$e6b39d88cc0d636 = {
    $type: 'Assignment',
    cardinality: 'cardinality',
    feature: 'feature',
    operator: 'operator',
    predicate: 'predicate',
    terminal: 'terminal'
};
function $c70992891bcf3a02$export$f27c77753b3dbe70(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$e6b39d88cc0d636.$type);
}
const $c70992891bcf3a02$export$875da9705dab30a7 = {
    $type: 'BooleanLiteral',
    true: 'true'
};
function $c70992891bcf3a02$export$9345b34ff3bb44c6(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$875da9705dab30a7.$type);
}
const $c70992891bcf3a02$export$65e81c1884d7435f = {
    $type: 'CharacterRange',
    cardinality: 'cardinality',
    left: 'left',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized',
    right: 'right'
};
function $c70992891bcf3a02$export$8b38dfeb00bc3e81(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$65e81c1884d7435f.$type);
}
const $c70992891bcf3a02$export$fcea0b2db26e6b18 = {
    $type: 'Condition'
};
function $c70992891bcf3a02$export$11cca1f88a6a30c7(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$fcea0b2db26e6b18.$type);
}
const $c70992891bcf3a02$export$3c0fdad2f733b4ca = {
    $type: 'Conjunction',
    left: 'left',
    right: 'right'
};
function $c70992891bcf3a02$export$f9aaf5b44a5e36d0(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$3c0fdad2f733b4ca.$type);
}
const $c70992891bcf3a02$export$77eaf5d0feff3a6 = {
    $type: 'CrossReference',
    cardinality: 'cardinality',
    deprecatedSyntax: 'deprecatedSyntax',
    isMulti: 'isMulti',
    terminal: 'terminal',
    type: 'type'
};
function $c70992891bcf3a02$export$ca91f6306d3bb0f4(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$77eaf5d0feff3a6.$type);
}
const $c70992891bcf3a02$export$e1aa1e7b8f6632ec = {
    $type: 'Disjunction',
    left: 'left',
    right: 'right'
};
function $c70992891bcf3a02$export$f84d3e997ef7e5e8(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$e1aa1e7b8f6632ec.$type);
}
const $c70992891bcf3a02$export$7fb655ff608a7dcb = {
    $type: 'EndOfFile',
    cardinality: 'cardinality'
};
function $c70992891bcf3a02$export$c428a8f05da359d4(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$7fb655ff608a7dcb.$type);
}
const $c70992891bcf3a02$export$553a52f18b21505e = {
    $type: 'Grammar',
    imports: 'imports',
    interfaces: 'interfaces',
    isDeclared: 'isDeclared',
    name: 'name',
    rules: 'rules',
    types: 'types'
};
function $c70992891bcf3a02$export$9416f66eac840e05(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$553a52f18b21505e.$type);
}
const $c70992891bcf3a02$export$f0559fb033a5015d = {
    $type: 'GrammarImport',
    path: 'path'
};
function $c70992891bcf3a02$export$9cb05a333d490579(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$f0559fb033a5015d.$type);
}
const $c70992891bcf3a02$export$eb2fcfdbd7ba97d4 = {
    $type: 'Group',
    cardinality: 'cardinality',
    elements: 'elements',
    guardCondition: 'guardCondition',
    predicate: 'predicate'
};
function $c70992891bcf3a02$export$d7976824e9f55785(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.$type);
}
const $c70992891bcf3a02$export$ff31e17db0f806c1 = {
    $type: 'InferredType',
    name: 'name'
};
function $c70992891bcf3a02$export$bd801a1fe9b55185(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$ff31e17db0f806c1.$type);
}
const $c70992891bcf3a02$export$917914cd02e6f6e7 = {
    $type: 'InfixRule',
    call: 'call',
    dataType: 'dataType',
    inferredType: 'inferredType',
    name: 'name',
    operators: 'operators',
    parameters: 'parameters',
    returnType: 'returnType'
};
function $c70992891bcf3a02$export$ff161511bc809b89(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$917914cd02e6f6e7.$type);
}
const $c70992891bcf3a02$export$ff03b23efe0943ed = {
    $type: 'InfixRuleOperatorList',
    associativity: 'associativity',
    operators: 'operators'
};
function $c70992891bcf3a02$export$f98e6912204a3645(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$ff03b23efe0943ed.$type);
}
const $c70992891bcf3a02$export$5943573deeee282b = {
    $type: 'InfixRuleOperators',
    precedences: 'precedences'
};
function $c70992891bcf3a02$export$7cd327817fd82c09(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$5943573deeee282b.$type);
}
const $c70992891bcf3a02$export$48cefb51a4e315b2 = {
    $type: 'Interface',
    attributes: 'attributes',
    name: 'name',
    superTypes: 'superTypes'
};
function $c70992891bcf3a02$export$e94a97bcd6db8414(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$48cefb51a4e315b2.$type);
}
const $c70992891bcf3a02$export$d1c5cf242bfe5091 = {
    $type: 'Keyword',
    cardinality: 'cardinality',
    predicate: 'predicate',
    value: 'value'
};
function $c70992891bcf3a02$export$384ccb3991bcb643(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$d1c5cf242bfe5091.$type);
}
const $c70992891bcf3a02$export$a10c7031464c657d = {
    $type: 'NamedArgument',
    calledByName: 'calledByName',
    parameter: 'parameter',
    value: 'value'
};
function $c70992891bcf3a02$export$9eac239b024cca3b(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$a10c7031464c657d.$type);
}
const $c70992891bcf3a02$export$6b299db26080cd99 = {
    $type: 'NegatedToken',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized',
    terminal: 'terminal'
};
function $c70992891bcf3a02$export$f4425fdd3f168242(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$6b299db26080cd99.$type);
}
const $c70992891bcf3a02$export$a7c4aaf828ce94d2 = {
    $type: 'Negation',
    value: 'value'
};
function $c70992891bcf3a02$export$fdf5f29387d2e676(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$a7c4aaf828ce94d2.$type);
}
const $c70992891bcf3a02$export$f2ea1d38cedcdcef = {
    $type: 'NumberLiteral',
    value: 'value'
};
function $c70992891bcf3a02$export$eda1492108f728f4(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$f2ea1d38cedcdcef.$type);
}
const $c70992891bcf3a02$export$f817523eebf7ee7f = {
    $type: 'Parameter',
    name: 'name'
};
function $c70992891bcf3a02$export$df165df096763f44(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$f817523eebf7ee7f.$type);
}
const $c70992891bcf3a02$export$6d35a6334b82887f = {
    $type: 'ParameterReference',
    parameter: 'parameter'
};
function $c70992891bcf3a02$export$234e7299f58b20d6(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$6d35a6334b82887f.$type);
}
const $c70992891bcf3a02$export$3af140c868132a9f = {
    $type: 'ParserRule',
    dataType: 'dataType',
    definition: 'definition',
    entry: 'entry',
    fragment: 'fragment',
    inferredType: 'inferredType',
    name: 'name',
    parameters: 'parameters',
    returnType: 'returnType'
};
function $c70992891bcf3a02$export$f9dab8e9825cb550(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$3af140c868132a9f.$type);
}
const $c70992891bcf3a02$export$8868dff548d048cf = {
    $type: 'ReferenceType',
    isMulti: 'isMulti',
    referenceType: 'referenceType'
};
function $c70992891bcf3a02$export$5e9b8dbec8ce4cbb(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$8868dff548d048cf.$type);
}
const $c70992891bcf3a02$export$e63858326ee700b1 = {
    $type: 'RegexToken',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized',
    regex: 'regex'
};
function $c70992891bcf3a02$export$3cb2556e66dd592(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$e63858326ee700b1.$type);
}
const $c70992891bcf3a02$export$87ae1b5af8b88f09 = {
    $type: 'ReturnType',
    name: 'name'
};
function $c70992891bcf3a02$export$5f6f7cc729edd91d(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$87ae1b5af8b88f09.$type);
}
const $c70992891bcf3a02$export$cfcc234657a3a4a4 = {
    $type: 'RuleCall',
    arguments: 'arguments',
    cardinality: 'cardinality',
    predicate: 'predicate',
    rule: 'rule'
};
function $c70992891bcf3a02$export$e937deeadef89848(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$cfcc234657a3a4a4.$type);
}
const $c70992891bcf3a02$export$b4a3ffafb2c1f6b3 = {
    $type: 'SimpleType',
    primitiveType: 'primitiveType',
    stringType: 'stringType',
    typeRef: 'typeRef'
};
function $c70992891bcf3a02$export$957664d9e1a22fd7(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$b4a3ffafb2c1f6b3.$type);
}
const $c70992891bcf3a02$export$3c049037094f4d48 = {
    $type: 'StringLiteral',
    value: 'value'
};
function $c70992891bcf3a02$export$e29dae36795cf20c(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$3c049037094f4d48.$type);
}
const $c70992891bcf3a02$export$36e7bc94c848b444 = {
    $type: 'TerminalAlternatives',
    cardinality: 'cardinality',
    elements: 'elements',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized'
};
function $c70992891bcf3a02$export$ae292517e4fb7e09(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$36e7bc94c848b444.$type);
}
const $c70992891bcf3a02$export$f0cb8b5d530f0407 = {
    $type: 'TerminalElement',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized'
};
function $c70992891bcf3a02$export$a0f7ef019c7d6626(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$f0cb8b5d530f0407.$type);
}
const $c70992891bcf3a02$export$6d9a9915f2abb310 = {
    $type: 'TerminalGroup',
    cardinality: 'cardinality',
    elements: 'elements',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized'
};
function $c70992891bcf3a02$export$95ff26ac47c748f2(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$6d9a9915f2abb310.$type);
}
const $c70992891bcf3a02$export$6d914efa3c62df8e = {
    $type: 'TerminalRule',
    definition: 'definition',
    fragment: 'fragment',
    hidden: 'hidden',
    name: 'name',
    type: 'type'
};
function $c70992891bcf3a02$export$82b19496f708707a(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$6d914efa3c62df8e.$type);
}
const $c70992891bcf3a02$export$18b62ae2ff0a8ed = {
    $type: 'TerminalRuleCall',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized',
    rule: 'rule'
};
function $c70992891bcf3a02$export$c68015e200d3324(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$18b62ae2ff0a8ed.$type);
}
const $c70992891bcf3a02$export$92738401e1603719 = {
    $type: 'Type',
    name: 'name',
    type: 'type'
};
function $c70992891bcf3a02$export$26b9f946b448f23e(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$92738401e1603719.$type);
}
const $c70992891bcf3a02$export$550c7145ebb842d5 = {
    $type: 'TypeAttribute',
    defaultValue: 'defaultValue',
    isOptional: 'isOptional',
    name: 'name',
    type: 'type'
};
function $c70992891bcf3a02$export$2c7bbdb9945609(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$550c7145ebb842d5.$type);
}
const $c70992891bcf3a02$export$456a4cdf65e3b2fa = {
    $type: 'TypeDefinition'
};
function $c70992891bcf3a02$export$65017d5595961941(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type);
}
const $c70992891bcf3a02$export$9b31524cbbc7993 = {
    $type: 'UnionType',
    types: 'types'
};
function $c70992891bcf3a02$export$cca4caab5ef5a545(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$9b31524cbbc7993.$type);
}
const $c70992891bcf3a02$export$6e3a8a6053bf5e7b = {
    $type: 'UnorderedGroup',
    cardinality: 'cardinality',
    elements: 'elements'
};
function $c70992891bcf3a02$export$ced84873394f175(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$6e3a8a6053bf5e7b.$type);
}
const $c70992891bcf3a02$export$a8fef77e9f039e11 = {
    $type: 'UntilToken',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized',
    terminal: 'terminal'
};
function $c70992891bcf3a02$export$16eb3268f2d48(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$a8fef77e9f039e11.$type);
}
const $c70992891bcf3a02$export$4f50667266bb3c04 = {
    $type: 'ValueLiteral'
};
function $c70992891bcf3a02$export$f50afd71fd273c94(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$4f50667266bb3c04.$type);
}
const $c70992891bcf3a02$export$10fd9b2de72cfe8c = {
    $type: 'Wildcard',
    cardinality: 'cardinality',
    lookahead: 'lookahead',
    parenthesized: 'parenthesized'
};
function $c70992891bcf3a02$export$ba42c4680b5f8317(item) {
    return $c70992891bcf3a02$export$f49cbeca3e22a85e.isInstance(item, $c70992891bcf3a02$export$10fd9b2de72cfe8c.$type);
}
class $c70992891bcf3a02$export$3376ecb8b6225174 extends $09c22474b334b427$export$78784b6d346bc16d {
    constructor(){
        super(...arguments);
        this.types = {
            AbstractElement: {
                name: $c70992891bcf3a02$export$d5345f74bf36d494.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$d5345f74bf36d494.cardinality,
                        optional: true
                    }
                },
                superTypes: []
            },
            AbstractParserRule: {
                name: $c70992891bcf3a02$export$955d445890e317bf.$type,
                properties: {},
                superTypes: [
                    $c70992891bcf3a02$export$f5ebc5080f757548.$type,
                    $c70992891bcf3a02$export$c265dc8338484497.$type
                ]
            },
            AbstractRule: {
                name: $c70992891bcf3a02$export$f5ebc5080f757548.$type,
                properties: {},
                superTypes: []
            },
            AbstractType: {
                name: $c70992891bcf3a02$export$c265dc8338484497.$type,
                properties: {},
                superTypes: []
            },
            Action: {
                name: $c70992891bcf3a02$export$e19cd5f9376f8cee.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$e19cd5f9376f8cee.cardinality,
                        optional: true
                    },
                    feature: {
                        name: $c70992891bcf3a02$export$e19cd5f9376f8cee.feature,
                        optional: true
                    },
                    inferredType: {
                        name: $c70992891bcf3a02$export$e19cd5f9376f8cee.inferredType,
                        optional: true
                    },
                    operator: {
                        name: $c70992891bcf3a02$export$e19cd5f9376f8cee.operator,
                        optional: true
                    },
                    type: {
                        name: $c70992891bcf3a02$export$e19cd5f9376f8cee.type,
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            Alternatives: {
                name: $c70992891bcf3a02$export$83c65964db61e5ec.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$83c65964db61e5ec.cardinality,
                        optional: true
                    },
                    elements: {
                        name: $c70992891bcf3a02$export$83c65964db61e5ec.elements,
                        defaultValue: []
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            ArrayLiteral: {
                name: $c70992891bcf3a02$export$2477073908a0de26.$type,
                properties: {
                    elements: {
                        name: $c70992891bcf3a02$export$2477073908a0de26.elements,
                        defaultValue: []
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$4f50667266bb3c04.$type
                ]
            },
            ArrayType: {
                name: $c70992891bcf3a02$export$49c146ea18b05474.$type,
                properties: {
                    elementType: {
                        name: $c70992891bcf3a02$export$49c146ea18b05474.elementType
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type
                ]
            },
            Assignment: {
                name: $c70992891bcf3a02$export$e6b39d88cc0d636.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$e6b39d88cc0d636.cardinality,
                        optional: true
                    },
                    feature: {
                        name: $c70992891bcf3a02$export$e6b39d88cc0d636.feature
                    },
                    operator: {
                        name: $c70992891bcf3a02$export$e6b39d88cc0d636.operator
                    },
                    predicate: {
                        name: $c70992891bcf3a02$export$e6b39d88cc0d636.predicate,
                        optional: true
                    },
                    terminal: {
                        name: $c70992891bcf3a02$export$e6b39d88cc0d636.terminal
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            BooleanLiteral: {
                name: $c70992891bcf3a02$export$875da9705dab30a7.$type,
                properties: {
                    true: {
                        name: $c70992891bcf3a02$export$875da9705dab30a7.true,
                        defaultValue: false
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$fcea0b2db26e6b18.$type,
                    $c70992891bcf3a02$export$4f50667266bb3c04.$type
                ]
            },
            CharacterRange: {
                name: $c70992891bcf3a02$export$65e81c1884d7435f.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$65e81c1884d7435f.cardinality,
                        optional: true
                    },
                    left: {
                        name: $c70992891bcf3a02$export$65e81c1884d7435f.left
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$65e81c1884d7435f.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$65e81c1884d7435f.parenthesized,
                        defaultValue: false,
                        optional: true
                    },
                    right: {
                        name: $c70992891bcf3a02$export$65e81c1884d7435f.right,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            Condition: {
                name: $c70992891bcf3a02$export$fcea0b2db26e6b18.$type,
                properties: {},
                superTypes: []
            },
            Conjunction: {
                name: $c70992891bcf3a02$export$3c0fdad2f733b4ca.$type,
                properties: {
                    left: {
                        name: $c70992891bcf3a02$export$3c0fdad2f733b4ca.left
                    },
                    right: {
                        name: $c70992891bcf3a02$export$3c0fdad2f733b4ca.right
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$fcea0b2db26e6b18.$type
                ]
            },
            CrossReference: {
                name: $c70992891bcf3a02$export$77eaf5d0feff3a6.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$77eaf5d0feff3a6.cardinality,
                        optional: true
                    },
                    deprecatedSyntax: {
                        name: $c70992891bcf3a02$export$77eaf5d0feff3a6.deprecatedSyntax,
                        defaultValue: false
                    },
                    isMulti: {
                        name: $c70992891bcf3a02$export$77eaf5d0feff3a6.isMulti,
                        defaultValue: false
                    },
                    terminal: {
                        name: $c70992891bcf3a02$export$77eaf5d0feff3a6.terminal,
                        optional: true
                    },
                    type: {
                        name: $c70992891bcf3a02$export$77eaf5d0feff3a6.type,
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            Disjunction: {
                name: $c70992891bcf3a02$export$e1aa1e7b8f6632ec.$type,
                properties: {
                    left: {
                        name: $c70992891bcf3a02$export$e1aa1e7b8f6632ec.left
                    },
                    right: {
                        name: $c70992891bcf3a02$export$e1aa1e7b8f6632ec.right
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$fcea0b2db26e6b18.$type
                ]
            },
            EndOfFile: {
                name: $c70992891bcf3a02$export$7fb655ff608a7dcb.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$7fb655ff608a7dcb.cardinality,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            Grammar: {
                name: $c70992891bcf3a02$export$553a52f18b21505e.$type,
                properties: {
                    imports: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.imports,
                        defaultValue: []
                    },
                    interfaces: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.interfaces,
                        defaultValue: []
                    },
                    isDeclared: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.isDeclared,
                        defaultValue: false
                    },
                    name: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.name,
                        optional: true
                    },
                    rules: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.rules,
                        defaultValue: []
                    },
                    types: {
                        name: $c70992891bcf3a02$export$553a52f18b21505e.types,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            GrammarImport: {
                name: $c70992891bcf3a02$export$f0559fb033a5015d.$type,
                properties: {
                    path: {
                        name: $c70992891bcf3a02$export$f0559fb033a5015d.path
                    }
                },
                superTypes: []
            },
            Group: {
                name: $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.cardinality,
                        optional: true
                    },
                    elements: {
                        name: $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.elements,
                        defaultValue: []
                    },
                    guardCondition: {
                        name: $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.guardCondition,
                        optional: true
                    },
                    predicate: {
                        name: $c70992891bcf3a02$export$eb2fcfdbd7ba97d4.predicate,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            InferredType: {
                name: $c70992891bcf3a02$export$ff31e17db0f806c1.$type,
                properties: {
                    name: {
                        name: $c70992891bcf3a02$export$ff31e17db0f806c1.name
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$c265dc8338484497.$type
                ]
            },
            InfixRule: {
                name: $c70992891bcf3a02$export$917914cd02e6f6e7.$type,
                properties: {
                    call: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.call
                    },
                    dataType: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.dataType,
                        optional: true
                    },
                    inferredType: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.inferredType,
                        optional: true
                    },
                    name: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.name
                    },
                    operators: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.operators
                    },
                    parameters: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.parameters,
                        defaultValue: []
                    },
                    returnType: {
                        name: $c70992891bcf3a02$export$917914cd02e6f6e7.returnType,
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$955d445890e317bf.$type
                ]
            },
            InfixRuleOperatorList: {
                name: $c70992891bcf3a02$export$ff03b23efe0943ed.$type,
                properties: {
                    associativity: {
                        name: $c70992891bcf3a02$export$ff03b23efe0943ed.associativity,
                        optional: true
                    },
                    operators: {
                        name: $c70992891bcf3a02$export$ff03b23efe0943ed.operators,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            InfixRuleOperators: {
                name: $c70992891bcf3a02$export$5943573deeee282b.$type,
                properties: {
                    precedences: {
                        name: $c70992891bcf3a02$export$5943573deeee282b.precedences,
                        defaultValue: []
                    }
                },
                superTypes: []
            },
            Interface: {
                name: $c70992891bcf3a02$export$48cefb51a4e315b2.$type,
                properties: {
                    attributes: {
                        name: $c70992891bcf3a02$export$48cefb51a4e315b2.attributes,
                        defaultValue: []
                    },
                    name: {
                        name: $c70992891bcf3a02$export$48cefb51a4e315b2.name
                    },
                    superTypes: {
                        name: $c70992891bcf3a02$export$48cefb51a4e315b2.superTypes,
                        defaultValue: [],
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$c265dc8338484497.$type
                ]
            },
            Keyword: {
                name: $c70992891bcf3a02$export$d1c5cf242bfe5091.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$d1c5cf242bfe5091.cardinality,
                        optional: true
                    },
                    predicate: {
                        name: $c70992891bcf3a02$export$d1c5cf242bfe5091.predicate,
                        optional: true
                    },
                    value: {
                        name: $c70992891bcf3a02$export$d1c5cf242bfe5091.value
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            NamedArgument: {
                name: $c70992891bcf3a02$export$a10c7031464c657d.$type,
                properties: {
                    calledByName: {
                        name: $c70992891bcf3a02$export$a10c7031464c657d.calledByName,
                        defaultValue: false
                    },
                    parameter: {
                        name: $c70992891bcf3a02$export$a10c7031464c657d.parameter,
                        referenceType: $c70992891bcf3a02$export$f817523eebf7ee7f.$type,
                        optional: true
                    },
                    value: {
                        name: $c70992891bcf3a02$export$a10c7031464c657d.value
                    }
                },
                superTypes: []
            },
            NegatedToken: {
                name: $c70992891bcf3a02$export$6b299db26080cd99.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$6b299db26080cd99.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$6b299db26080cd99.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$6b299db26080cd99.parenthesized,
                        defaultValue: false,
                        optional: true
                    },
                    terminal: {
                        name: $c70992891bcf3a02$export$6b299db26080cd99.terminal
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            Negation: {
                name: $c70992891bcf3a02$export$a7c4aaf828ce94d2.$type,
                properties: {
                    value: {
                        name: $c70992891bcf3a02$export$a7c4aaf828ce94d2.value
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$fcea0b2db26e6b18.$type
                ]
            },
            NumberLiteral: {
                name: $c70992891bcf3a02$export$f2ea1d38cedcdcef.$type,
                properties: {
                    value: {
                        name: $c70992891bcf3a02$export$f2ea1d38cedcdcef.value
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$4f50667266bb3c04.$type
                ]
            },
            Parameter: {
                name: $c70992891bcf3a02$export$f817523eebf7ee7f.$type,
                properties: {
                    name: {
                        name: $c70992891bcf3a02$export$f817523eebf7ee7f.name
                    }
                },
                superTypes: []
            },
            ParameterReference: {
                name: $c70992891bcf3a02$export$6d35a6334b82887f.$type,
                properties: {
                    parameter: {
                        name: $c70992891bcf3a02$export$6d35a6334b82887f.parameter,
                        referenceType: $c70992891bcf3a02$export$f817523eebf7ee7f.$type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$fcea0b2db26e6b18.$type
                ]
            },
            ParserRule: {
                name: $c70992891bcf3a02$export$3af140c868132a9f.$type,
                properties: {
                    dataType: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.dataType,
                        optional: true
                    },
                    definition: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.definition
                    },
                    entry: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.entry,
                        defaultValue: false
                    },
                    fragment: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.fragment,
                        defaultValue: false
                    },
                    inferredType: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.inferredType,
                        optional: true
                    },
                    name: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.name
                    },
                    parameters: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.parameters,
                        defaultValue: []
                    },
                    returnType: {
                        name: $c70992891bcf3a02$export$3af140c868132a9f.returnType,
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$955d445890e317bf.$type
                ]
            },
            ReferenceType: {
                name: $c70992891bcf3a02$export$8868dff548d048cf.$type,
                properties: {
                    isMulti: {
                        name: $c70992891bcf3a02$export$8868dff548d048cf.isMulti,
                        defaultValue: false
                    },
                    referenceType: {
                        name: $c70992891bcf3a02$export$8868dff548d048cf.referenceType
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type
                ]
            },
            RegexToken: {
                name: $c70992891bcf3a02$export$e63858326ee700b1.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$e63858326ee700b1.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$e63858326ee700b1.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$e63858326ee700b1.parenthesized,
                        defaultValue: false,
                        optional: true
                    },
                    regex: {
                        name: $c70992891bcf3a02$export$e63858326ee700b1.regex
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            ReturnType: {
                name: $c70992891bcf3a02$export$87ae1b5af8b88f09.$type,
                properties: {
                    name: {
                        name: $c70992891bcf3a02$export$87ae1b5af8b88f09.name
                    }
                },
                superTypes: []
            },
            RuleCall: {
                name: $c70992891bcf3a02$export$cfcc234657a3a4a4.$type,
                properties: {
                    arguments: {
                        name: $c70992891bcf3a02$export$cfcc234657a3a4a4.arguments,
                        defaultValue: []
                    },
                    cardinality: {
                        name: $c70992891bcf3a02$export$cfcc234657a3a4a4.cardinality,
                        optional: true
                    },
                    predicate: {
                        name: $c70992891bcf3a02$export$cfcc234657a3a4a4.predicate,
                        optional: true
                    },
                    rule: {
                        name: $c70992891bcf3a02$export$cfcc234657a3a4a4.rule,
                        referenceType: $c70992891bcf3a02$export$f5ebc5080f757548.$type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            SimpleType: {
                name: $c70992891bcf3a02$export$b4a3ffafb2c1f6b3.$type,
                properties: {
                    primitiveType: {
                        name: $c70992891bcf3a02$export$b4a3ffafb2c1f6b3.primitiveType,
                        optional: true
                    },
                    stringType: {
                        name: $c70992891bcf3a02$export$b4a3ffafb2c1f6b3.stringType,
                        optional: true
                    },
                    typeRef: {
                        name: $c70992891bcf3a02$export$b4a3ffafb2c1f6b3.typeRef,
                        referenceType: $c70992891bcf3a02$export$c265dc8338484497.$type,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type
                ]
            },
            StringLiteral: {
                name: $c70992891bcf3a02$export$3c049037094f4d48.$type,
                properties: {
                    value: {
                        name: $c70992891bcf3a02$export$3c049037094f4d48.value
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$4f50667266bb3c04.$type
                ]
            },
            TerminalAlternatives: {
                name: $c70992891bcf3a02$export$36e7bc94c848b444.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$36e7bc94c848b444.cardinality,
                        optional: true
                    },
                    elements: {
                        name: $c70992891bcf3a02$export$36e7bc94c848b444.elements,
                        defaultValue: []
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$36e7bc94c848b444.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$36e7bc94c848b444.parenthesized,
                        defaultValue: false,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            TerminalElement: {
                name: $c70992891bcf3a02$export$f0cb8b5d530f0407.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$f0cb8b5d530f0407.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$f0cb8b5d530f0407.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$f0cb8b5d530f0407.parenthesized,
                        defaultValue: false,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            TerminalGroup: {
                name: $c70992891bcf3a02$export$6d9a9915f2abb310.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$6d9a9915f2abb310.cardinality,
                        optional: true
                    },
                    elements: {
                        name: $c70992891bcf3a02$export$6d9a9915f2abb310.elements,
                        defaultValue: []
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$6d9a9915f2abb310.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$6d9a9915f2abb310.parenthesized,
                        defaultValue: false,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            TerminalRule: {
                name: $c70992891bcf3a02$export$6d914efa3c62df8e.$type,
                properties: {
                    definition: {
                        name: $c70992891bcf3a02$export$6d914efa3c62df8e.definition
                    },
                    fragment: {
                        name: $c70992891bcf3a02$export$6d914efa3c62df8e.fragment,
                        defaultValue: false
                    },
                    hidden: {
                        name: $c70992891bcf3a02$export$6d914efa3c62df8e.hidden,
                        defaultValue: false
                    },
                    name: {
                        name: $c70992891bcf3a02$export$6d914efa3c62df8e.name
                    },
                    type: {
                        name: $c70992891bcf3a02$export$6d914efa3c62df8e.type,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f5ebc5080f757548.$type
                ]
            },
            TerminalRuleCall: {
                name: $c70992891bcf3a02$export$18b62ae2ff0a8ed.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$18b62ae2ff0a8ed.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$18b62ae2ff0a8ed.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$18b62ae2ff0a8ed.parenthesized,
                        defaultValue: false,
                        optional: true
                    },
                    rule: {
                        name: $c70992891bcf3a02$export$18b62ae2ff0a8ed.rule,
                        referenceType: $c70992891bcf3a02$export$6d914efa3c62df8e.$type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            Type: {
                name: $c70992891bcf3a02$export$92738401e1603719.$type,
                properties: {
                    name: {
                        name: $c70992891bcf3a02$export$92738401e1603719.name
                    },
                    type: {
                        name: $c70992891bcf3a02$export$92738401e1603719.type
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$c265dc8338484497.$type
                ]
            },
            TypeAttribute: {
                name: $c70992891bcf3a02$export$550c7145ebb842d5.$type,
                properties: {
                    defaultValue: {
                        name: $c70992891bcf3a02$export$550c7145ebb842d5.defaultValue,
                        optional: true
                    },
                    isOptional: {
                        name: $c70992891bcf3a02$export$550c7145ebb842d5.isOptional,
                        defaultValue: false
                    },
                    name: {
                        name: $c70992891bcf3a02$export$550c7145ebb842d5.name
                    },
                    type: {
                        name: $c70992891bcf3a02$export$550c7145ebb842d5.type
                    }
                },
                superTypes: []
            },
            TypeDefinition: {
                name: $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type,
                properties: {},
                superTypes: []
            },
            UnionType: {
                name: $c70992891bcf3a02$export$9b31524cbbc7993.$type,
                properties: {
                    types: {
                        name: $c70992891bcf3a02$export$9b31524cbbc7993.types,
                        defaultValue: []
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$456a4cdf65e3b2fa.$type
                ]
            },
            UnorderedGroup: {
                name: $c70992891bcf3a02$export$6e3a8a6053bf5e7b.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$6e3a8a6053bf5e7b.cardinality,
                        optional: true
                    },
                    elements: {
                        name: $c70992891bcf3a02$export$6e3a8a6053bf5e7b.elements,
                        defaultValue: []
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$d5345f74bf36d494.$type
                ]
            },
            UntilToken: {
                name: $c70992891bcf3a02$export$a8fef77e9f039e11.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$a8fef77e9f039e11.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$a8fef77e9f039e11.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$a8fef77e9f039e11.parenthesized,
                        defaultValue: false,
                        optional: true
                    },
                    terminal: {
                        name: $c70992891bcf3a02$export$a8fef77e9f039e11.terminal
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            },
            ValueLiteral: {
                name: $c70992891bcf3a02$export$4f50667266bb3c04.$type,
                properties: {},
                superTypes: []
            },
            Wildcard: {
                name: $c70992891bcf3a02$export$10fd9b2de72cfe8c.$type,
                properties: {
                    cardinality: {
                        name: $c70992891bcf3a02$export$10fd9b2de72cfe8c.cardinality,
                        optional: true
                    },
                    lookahead: {
                        name: $c70992891bcf3a02$export$10fd9b2de72cfe8c.lookahead,
                        optional: true
                    },
                    parenthesized: {
                        name: $c70992891bcf3a02$export$10fd9b2de72cfe8c.parenthesized,
                        defaultValue: false,
                        optional: true
                    }
                },
                superTypes: [
                    $c70992891bcf3a02$export$f0cb8b5d530f0407.$type
                ]
            }
        };
    }
}
const $c70992891bcf3a02$export$f49cbeca3e22a85e = new $c70992891bcf3a02$export$3376ecb8b6225174();


function $f87d6e075cbbfde9$export$f80dde9fefff0897(cstNode) {
    let current = cstNode;
    let found = false;
    while(current){
        const definingRule = (0, $de130ae470c6cbfb$export$51e1e993675a3c6a)(current.grammarSource, (0, $c70992891bcf3a02$export$f9dab8e9825cb550));
        if (definingRule && definingRule.dataType) {
            // Go up the chain. This element might be part of a larger datatype rule
            current = current.container;
            found = true;
        } else if (found) // The last datatype node is the one we are looking for
        return current;
        else // We haven't found any datatype node yet and we've reached a non-datatype rule
        return undefined;
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$e6e798b3ac4e876c(node) {
    return new (0, $1feb7546a8c17818$export$ab7c393f8e95c558)(node, (element)=>{
        if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(element)) return element.content;
        else return [];
    }, {
        includeRoot: true
    });
}
function $f87d6e075cbbfde9$export$dac67dfdd91c93ba(node) {
    return $f87d6e075cbbfde9$export$e6e798b3ac4e876c(node).filter((0, $09c22474b334b427$export$e82a11db49cb0b82));
}
function $f87d6e075cbbfde9$export$da083ea7c8d26f74(child, parent) {
    while(child.container){
        child = child.container;
        if (child === parent) return true;
    }
    return false;
}
function $f87d6e075cbbfde9$export$412827f3965fb32(token) {
    // Chevrotain uses 1-based indices everywhere
    // So we subtract 1 from every value to align with the LSP
    return {
        start: {
            line: token.startLine - 1,
            character: token.startColumn - 1
        },
        end: {
            line: token.endLine - 1,
            character: token.endColumn // endColumn uses the correct index
        }
    };
}
function $f87d6e075cbbfde9$export$b271295f38c7b1c6(token) {
    const { startOffset: startOffset, endOffset: endOffset } = token;
    return typeof startOffset === 'number' && Number.isFinite(startOffset) && startOffset >= 0 && typeof endOffset === 'number' && Number.isFinite(endOffset) && endOffset >= startOffset;
}
function $f87d6e075cbbfde9$export$c9a2c6a6b5629cf4(node) {
    if (!node) return undefined;
    const { offset: offset, end: end, range: range } = node;
    return {
        range: range,
        offset: offset,
        end: end,
        length: end - offset
    };
}
var $f87d6e075cbbfde9$export$42e4226c01e62342;
(function(RangeComparison) {
    RangeComparison[RangeComparison["Before"] = 0] = "Before";
    RangeComparison[RangeComparison["After"] = 1] = "After";
    RangeComparison[RangeComparison["OverlapFront"] = 2] = "OverlapFront";
    RangeComparison[RangeComparison["OverlapBack"] = 3] = "OverlapBack";
    RangeComparison[RangeComparison["Inside"] = 4] = "Inside";
    RangeComparison[RangeComparison["Outside"] = 5] = "Outside";
})($f87d6e075cbbfde9$export$42e4226c01e62342 || ($f87d6e075cbbfde9$export$42e4226c01e62342 = {}));
function $f87d6e075cbbfde9$export$4b8f591ab58dfeaf(range, to) {
    if (range.end.line < to.start.line || range.end.line === to.start.line && range.end.character <= to.start.character) return $f87d6e075cbbfde9$export$42e4226c01e62342.Before;
    else if (range.start.line > to.end.line || range.start.line === to.end.line && range.start.character >= to.end.character) return $f87d6e075cbbfde9$export$42e4226c01e62342.After;
    const startInside = range.start.line > to.start.line || range.start.line === to.start.line && range.start.character >= to.start.character;
    const endInside = range.end.line < to.end.line || range.end.line === to.end.line && range.end.character <= to.end.character;
    if (startInside && endInside) return $f87d6e075cbbfde9$export$42e4226c01e62342.Inside;
    else if (startInside) return $f87d6e075cbbfde9$export$42e4226c01e62342.OverlapBack;
    else if (endInside) return $f87d6e075cbbfde9$export$42e4226c01e62342.OverlapFront;
    else return $f87d6e075cbbfde9$export$42e4226c01e62342.Outside;
}
function $f87d6e075cbbfde9$export$ddf89a9c5af38f94(range, to) {
    const comparison = $f87d6e075cbbfde9$export$4b8f591ab58dfeaf(range, to);
    return comparison > $f87d6e075cbbfde9$export$42e4226c01e62342.After;
}
const $f87d6e075cbbfde9$export$dd0bd96951dcf6e4 = /^[\w\p{L}]$/u;
function $f87d6e075cbbfde9$export$e2b9466aa81142e1(cstNode, offset, nameRegexp = $f87d6e075cbbfde9$export$dd0bd96951dcf6e4) {
    if (cstNode) {
        if (offset > 0) {
            const textAtOffset = offset >= cstNode.offset && offset < cstNode.end ? cstNode.root.fullText.charAt(offset) : '';
            if (!nameRegexp.test(textAtOffset)) offset--;
        }
        return $f87d6e075cbbfde9$export$bbd76ce627a0a247(cstNode, offset);
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$bfcbdf586d163108(cstNode, commentNames) {
    if (cstNode) {
        const previous = $f87d6e075cbbfde9$export$441b3b812f976516(cstNode, true);
        if (previous && $f87d6e075cbbfde9$export$575485136eb1b1f(previous, commentNames)) return previous;
        if ((0, $09c22474b334b427$export$95ae76a9457c0b7d)(cstNode)) {
            // Go from the first non-hidden node through all nodes in reverse order
            // We do this to find the comment node which directly precedes the root node
            const endIndex = cstNode.content.findIndex((e)=>!e.hidden);
            for(let i = endIndex - 1; i >= 0; i--){
                const child = cstNode.content[i];
                if ($f87d6e075cbbfde9$export$575485136eb1b1f(child, commentNames)) return child;
            }
        }
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$575485136eb1b1f(cstNode, commentNames) {
    return (0, $09c22474b334b427$export$e82a11db49cb0b82)(cstNode) && commentNames.includes(cstNode.tokenType.name);
}
function $f87d6e075cbbfde9$export$bbd76ce627a0a247(node, offset) {
    if ((0, $09c22474b334b427$export$e82a11db49cb0b82)(node)) return node;
    else if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(node)) {
        const searchResult = $f87d6e075cbbfde9$var$binarySearch(node, offset, false);
        if (searchResult) return $f87d6e075cbbfde9$export$bbd76ce627a0a247(searchResult, offset);
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$784d0b610d07cd59(node, offset) {
    if ((0, $09c22474b334b427$export$e82a11db49cb0b82)(node)) return node;
    else if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(node)) {
        const searchResult = $f87d6e075cbbfde9$var$binarySearch(node, offset, true);
        if (searchResult) return $f87d6e075cbbfde9$export$784d0b610d07cd59(searchResult, offset);
    }
    return undefined;
}
function $f87d6e075cbbfde9$var$binarySearch(node, offset, closest) {
    let left = 0;
    let right = node.content.length - 1;
    let closestNode = undefined;
    while(left <= right){
        const middle = Math.floor((left + right) / 2);
        const middleNode = node.content[middle];
        if (middleNode.offset <= offset && middleNode.end > offset) // Found an exact match
        return middleNode;
        if (middleNode.end <= offset) {
            // Update the closest node (less than offset) and move to the right half
            closestNode = closest ? middleNode : undefined;
            left = middle + 1;
        } else // Move to the left half
        right = middle - 1;
    }
    return closestNode;
}
function $f87d6e075cbbfde9$export$441b3b812f976516(node, hidden = true) {
    while(node.container){
        const parent = node.container;
        let index = parent.content.indexOf(node);
        while(index > 0){
            index--;
            const previous = parent.content[index];
            if (hidden || !previous.hidden) return previous;
        }
        node = parent;
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$9f79023ffc34e62d(node, hidden = true) {
    while(node.container){
        const parent = node.container;
        let index = parent.content.indexOf(node);
        const last = parent.content.length - 1;
        while(index < last){
            index++;
            const next = parent.content[index];
            if (hidden || !next.hidden) return next;
        }
        node = parent;
    }
    return undefined;
}
function $f87d6e075cbbfde9$export$930ede814e90b993(node) {
    if (node.range.start.character === 0) return node;
    const line = node.range.start.line;
    let last = node;
    let index;
    while(node.container){
        const parent = node.container;
        const selfIndex = index ?? parent.content.indexOf(node);
        if (selfIndex === 0) {
            node = parent;
            index = undefined;
        } else {
            index = selfIndex - 1;
            node = parent.content[index];
        }
        if (node.range.start.line !== line) break;
        last = node;
    }
    return last;
}
function $f87d6e075cbbfde9$export$fea060595b65700f(start, end) {
    const commonParent = $f87d6e075cbbfde9$var$getCommonParent(start, end);
    if (!commonParent) return [];
    return commonParent.parent.content.slice(commonParent.a + 1, commonParent.b);
}
function $f87d6e075cbbfde9$var$getCommonParent(a, b) {
    const aParents = $f87d6e075cbbfde9$var$getParentChain(a);
    const bParents = $f87d6e075cbbfde9$var$getParentChain(b);
    let current;
    for(let i = 0; i < aParents.length && i < bParents.length; i++){
        const aParent = aParents[i];
        const bParent = bParents[i];
        if (aParent.parent === bParent.parent) current = {
            parent: aParent.parent,
            a: aParent.index,
            b: bParent.index
        };
        else break;
    }
    return current;
}
function $f87d6e075cbbfde9$var$getParentChain(node) {
    const chain = [];
    while(node.container){
        const parent = node.container;
        const index = parent.content.indexOf(node);
        chain.push({
            parent: parent,
            index: index
        });
        node = parent;
    }
    return chain.reverse();
}


/******************************************************************************
 * Copyright 2021-2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ class $71d485f045ec2841$export$5495508d5ff9e05 extends Error {
    constructor(node, message){
        const msg = typeof message === 'string' ? message : message();
        super(node ? `${msg} at ${node.range.start.line}:${node.range.start.character}` : msg);
    }
}
function $71d485f045ec2841$export$f2525c1d596f8d46(_, message = 'Error: Got unexpected value.') {
    throw new Error(typeof message === 'string' ? message : message());
}
function $71d485f045ec2841$export$618dcedcacaccadb(condition, message = 'Error: Condition is violated.') {
    if (!condition) throw new Error(typeof message === 'string' ? message : message());
}






/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ function $c18b7c637472d4b7$export$a1edd97dd51cd48d(char) {
    return char.charCodeAt(0);
}
function $c18b7c637472d4b7$export$adbb5500360f75f6(item, set) {
    if (Array.isArray(item)) item.forEach(function(subItem) {
        set.push(subItem);
    });
    else set.push(item);
}
function $c18b7c637472d4b7$export$820a1da46c7a4303(flagObj, flagKey) {
    if (flagObj[flagKey] === true) throw "duplicate flag " + flagKey;
    const x = flagObj[flagKey];
    flagObj[flagKey] = true;
}
function $c18b7c637472d4b7$export$91706c95574f5b3f(obj) {
    // istanbul ignore next
    if (obj === undefined) throw Error("Internal Error - Should never get here!");
    return true;
}
function $c18b7c637472d4b7$export$5c06f5286f92b883() {
    throw Error("Internal Error - Should never get here!");
}
function $c18b7c637472d4b7$export$ea211e0125a20e7d(obj) {
    return obj["type"] === "Character";
}



const $fba3a55139b7b12c$export$7c420e3228a62ead = [];
for(let i = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("0"); i <= (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("9"); i++)$fba3a55139b7b12c$export$7c420e3228a62ead.push(i);
const $fba3a55139b7b12c$export$11954efaace4edcd = [
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("_")
].concat($fba3a55139b7b12c$export$7c420e3228a62ead);
for(let i = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("a"); i <= (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("z"); i++)$fba3a55139b7b12c$export$11954efaace4edcd.push(i);
for(let i = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("A"); i <= (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("Z"); i++)$fba3a55139b7b12c$export$11954efaace4edcd.push(i);
const $fba3a55139b7b12c$export$5d38ee76c8ddd83 = [
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)(" "),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\f"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\n"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\r"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\t"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\v"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\t"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u00a0"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u1680"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2000"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2001"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2002"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2003"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2004"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2005"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2006"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2007"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2008"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2009"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u200a"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2028"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2029"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u202f"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u205f"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u3000"),
    (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\ufeff")
];


// consts and utilities
const $438cb5f1875e7325$var$hexDigitPattern = /[0-9a-fA-F]/;
const $438cb5f1875e7325$var$decimalPattern = /[0-9]/;
const $438cb5f1875e7325$var$decimalPatternNoZero = /[1-9]/;
class $438cb5f1875e7325$export$16ea3460a23e7c94 {
    constructor(){
        this.idx = 0;
        this.input = "";
        this.groupIdx = 0;
    }
    saveState() {
        return {
            idx: this.idx,
            input: this.input,
            groupIdx: this.groupIdx
        };
    }
    restoreState(newState) {
        this.idx = newState.idx;
        this.input = newState.input;
        this.groupIdx = newState.groupIdx;
    }
    pattern(input) {
        // parser state
        this.idx = 0;
        this.input = input;
        this.groupIdx = 0;
        this.consumeChar("/");
        const value = this.disjunction();
        this.consumeChar("/");
        const flags = {
            type: "Flags",
            loc: {
                begin: this.idx,
                end: input.length
            },
            global: false,
            ignoreCase: false,
            multiLine: false,
            unicode: false,
            sticky: false
        };
        while(this.isRegExpFlag())switch(this.popChar()){
            case "g":
                (0, $c18b7c637472d4b7$export$820a1da46c7a4303)(flags, "global");
                break;
            case "i":
                (0, $c18b7c637472d4b7$export$820a1da46c7a4303)(flags, "ignoreCase");
                break;
            case "m":
                (0, $c18b7c637472d4b7$export$820a1da46c7a4303)(flags, "multiLine");
                break;
            case "u":
                (0, $c18b7c637472d4b7$export$820a1da46c7a4303)(flags, "unicode");
                break;
            case "y":
                (0, $c18b7c637472d4b7$export$820a1da46c7a4303)(flags, "sticky");
                break;
        }
        if (this.idx !== this.input.length) throw Error("Redundant input: " + this.input.substring(this.idx));
        return {
            type: "Pattern",
            flags: flags,
            value: value,
            loc: this.loc(0)
        };
    }
    disjunction() {
        const alts = [];
        const begin = this.idx;
        alts.push(this.alternative());
        while(this.peekChar() === "|"){
            this.consumeChar("|");
            alts.push(this.alternative());
        }
        return {
            type: "Disjunction",
            value: alts,
            loc: this.loc(begin)
        };
    }
    alternative() {
        const terms = [];
        const begin = this.idx;
        while(this.isTerm())terms.push(this.term());
        return {
            type: "Alternative",
            value: terms,
            loc: this.loc(begin)
        };
    }
    term() {
        if (this.isAssertion()) return this.assertion();
        else return this.atom();
    }
    assertion() {
        const begin = this.idx;
        switch(this.popChar()){
            case "^":
                return {
                    type: "StartAnchor",
                    loc: this.loc(begin)
                };
            case "$":
                return {
                    type: "EndAnchor",
                    loc: this.loc(begin)
                };
            // '\b' or '\B'
            case "\\":
                switch(this.popChar()){
                    case "b":
                        return {
                            type: "WordBoundary",
                            loc: this.loc(begin)
                        };
                    case "B":
                        return {
                            type: "NonWordBoundary",
                            loc: this.loc(begin)
                        };
                }
                /* c8 ignore next */ throw Error("Invalid Assertion Escape");
            // '(?=' or '(?!'
            case "(":
                this.consumeChar("?");
                let type;
                switch(this.popChar()){
                    case "=":
                        type = "Lookahead";
                        break;
                    case "!":
                        type = "NegativeLookahead";
                        break;
                    case "<":
                        switch(this.popChar()){
                            case "=":
                                type = "Lookbehind";
                                break;
                            case "!":
                                type = "NegativeLookbehind";
                        }
                        break;
                }
                (0, $c18b7c637472d4b7$export$91706c95574f5b3f)(type);
                const disjunction = this.disjunction();
                this.consumeChar(")");
                return {
                    type: type,
                    value: disjunction,
                    loc: this.loc(begin)
                };
        }
        // istanbul ignore next
        return (0, $c18b7c637472d4b7$export$5c06f5286f92b883)();
    }
    quantifier(isBacktracking = false) {
        let range = undefined;
        const begin = this.idx;
        switch(this.popChar()){
            case "*":
                range = {
                    atLeast: 0,
                    atMost: Infinity
                };
                break;
            case "+":
                range = {
                    atLeast: 1,
                    atMost: Infinity
                };
                break;
            case "?":
                range = {
                    atLeast: 0,
                    atMost: 1
                };
                break;
            case "{":
                const atLeast = this.integerIncludingZero();
                switch(this.popChar()){
                    case "}":
                        range = {
                            atLeast: atLeast,
                            atMost: atLeast
                        };
                        break;
                    case ",":
                        let atMost;
                        if (this.isDigit()) {
                            atMost = this.integerIncludingZero();
                            range = {
                                atLeast: atLeast,
                                atMost: atMost
                            };
                        } else range = {
                            atLeast: atLeast,
                            atMost: Infinity
                        };
                        this.consumeChar("}");
                        break;
                }
                // throwing exceptions from "ASSERT_EXISTS" during backtracking
                // causes severe performance degradations
                if (isBacktracking === true && range === undefined) return undefined;
                (0, $c18b7c637472d4b7$export$91706c95574f5b3f)(range);
                break;
        }
        // throwing exceptions from "ASSERT_EXISTS" during backtracking
        // causes severe performance degradations
        if (isBacktracking === true && range === undefined) return undefined;
        // istanbul ignore else
        if ((0, $c18b7c637472d4b7$export$91706c95574f5b3f)(range)) {
            if (this.peekChar(0) === "?") {
                this.consumeChar("?");
                range.greedy = false;
            } else range.greedy = true;
            range.type = "Quantifier";
            range.loc = this.loc(begin);
            return range;
        }
    }
    atom() {
        let atom;
        const begin = this.idx;
        switch(this.peekChar()){
            case ".":
                atom = this.dotAll();
                break;
            case "\\":
                atom = this.atomEscape();
                break;
            case "[":
                atom = this.characterClass();
                break;
            case "(":
                atom = this.group();
                break;
        }
        if (atom === undefined && this.isPatternCharacter()) atom = this.patternCharacter();
        // istanbul ignore else
        if ((0, $c18b7c637472d4b7$export$91706c95574f5b3f)(atom)) {
            atom.loc = this.loc(begin);
            if (this.isQuantifier()) atom.quantifier = this.quantifier();
            return atom;
        }
        // istanbul ignore next
        return (0, $c18b7c637472d4b7$export$5c06f5286f92b883)();
    }
    dotAll() {
        this.consumeChar(".");
        return {
            type: "Set",
            complement: true,
            value: [
                (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\n"),
                (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\r"),
                (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2028"),
                (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u2029")
            ]
        };
    }
    atomEscape() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return this.decimalEscapeAtom();
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    }
    decimalEscapeAtom() {
        const value = this.positiveInteger();
        return {
            type: "GroupBackReference",
            value: value
        };
    }
    characterClassEscape() {
        let set;
        let complement = false;
        switch(this.popChar()){
            case "d":
                set = (0, $fba3a55139b7b12c$export$7c420e3228a62ead);
                break;
            case "D":
                set = (0, $fba3a55139b7b12c$export$7c420e3228a62ead);
                complement = true;
                break;
            case "s":
                set = (0, $fba3a55139b7b12c$export$5d38ee76c8ddd83);
                break;
            case "S":
                set = (0, $fba3a55139b7b12c$export$5d38ee76c8ddd83);
                complement = true;
                break;
            case "w":
                set = (0, $fba3a55139b7b12c$export$11954efaace4edcd);
                break;
            case "W":
                set = (0, $fba3a55139b7b12c$export$11954efaace4edcd);
                complement = true;
                break;
        }
        // istanbul ignore else
        if ((0, $c18b7c637472d4b7$export$91706c95574f5b3f)(set)) return {
            type: "Set",
            value: set,
            complement: complement
        };
        // istanbul ignore next
        return (0, $c18b7c637472d4b7$export$5c06f5286f92b883)();
    }
    controlEscapeAtom() {
        let escapeCode;
        switch(this.popChar()){
            case "f":
                escapeCode = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\f");
                break;
            case "n":
                escapeCode = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\n");
                break;
            case "r":
                escapeCode = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\r");
                break;
            case "t":
                escapeCode = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\t");
                break;
            case "v":
                escapeCode = (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\v");
                break;
        }
        // istanbul ignore else
        if ((0, $c18b7c637472d4b7$export$91706c95574f5b3f)(escapeCode)) return {
            type: "Character",
            value: escapeCode
        };
        // istanbul ignore next
        return (0, $c18b7c637472d4b7$export$5c06f5286f92b883)();
    }
    controlLetterEscapeAtom() {
        this.consumeChar("c");
        const letter = this.popChar();
        if (/[a-zA-Z]/.test(letter) === false) throw Error("Invalid ");
        const letterCode = letter.toUpperCase().charCodeAt(0) - 64;
        return {
            type: "Character",
            value: letterCode
        };
    }
    nulCharacterAtom() {
        // TODO implement '[lookahead ∉ DecimalDigit]'
        // TODO: for the deprecated octal escape sequence
        this.consumeChar("0");
        return {
            type: "Character",
            value: (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\0")
        };
    }
    hexEscapeSequenceAtom() {
        this.consumeChar("x");
        return this.parseHexDigits(2);
    }
    regExpUnicodeEscapeSequenceAtom() {
        this.consumeChar("u");
        return this.parseHexDigits(4);
    }
    identityEscapeAtom() {
        // TODO: implement "SourceCharacter but not UnicodeIDContinue"
        // // http://unicode.org/reports/tr31/#Specific_Character_Adjustments
        const escapedChar = this.popChar();
        return {
            type: "Character",
            value: (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)(escapedChar)
        };
    }
    classPatternCharacterAtom() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case "]":
                throw Error("TBD");
            default:
                const nextChar = this.popChar();
                return {
                    type: "Character",
                    value: (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)(nextChar)
                };
        }
    }
    characterClass() {
        const set = [];
        let complement = false;
        this.consumeChar("[");
        if (this.peekChar(0) === "^") {
            this.consumeChar("^");
            complement = true;
        }
        while(this.isClassAtom()){
            const from = this.classAtom();
            const isFromSingleChar = from.type === "Character";
            if ((0, $c18b7c637472d4b7$export$ea211e0125a20e7d)(from) && this.isRangeDash()) {
                this.consumeChar("-");
                const to = this.classAtom();
                const isToSingleChar = to.type === "Character";
                // a range can only be used when both sides are single characters
                if ((0, $c18b7c637472d4b7$export$ea211e0125a20e7d)(to)) {
                    if (to.value < from.value) throw Error("Range out of order in character class");
                    set.push({
                        from: from.value,
                        to: to.value
                    });
                } else {
                    // literal dash
                    (0, $c18b7c637472d4b7$export$adbb5500360f75f6)(from.value, set);
                    set.push((0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("-"));
                    (0, $c18b7c637472d4b7$export$adbb5500360f75f6)(to.value, set);
                }
            } else (0, $c18b7c637472d4b7$export$adbb5500360f75f6)(from.value, set);
        }
        this.consumeChar("]");
        return {
            type: "Set",
            complement: complement,
            value: set
        };
    }
    classAtom() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "]":
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
                throw Error("TBD");
            case "\\":
                return this.classEscape();
            default:
                return this.classPatternCharacterAtom();
        }
    }
    classEscape() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            // Matches a backspace.
            // (Not to be confused with \b word boundary outside characterClass)
            case "b":
                this.consumeChar("b");
                return {
                    type: "Character",
                    value: (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)("\u0008")
                };
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    }
    group() {
        let capturing = true;
        this.consumeChar("(");
        switch(this.peekChar(0)){
            case "?":
                this.consumeChar("?");
                this.consumeChar(":");
                capturing = false;
                break;
            default:
                this.groupIdx++;
                break;
        }
        const value = this.disjunction();
        this.consumeChar(")");
        const groupAst = {
            type: "Group",
            capturing: capturing,
            value: value
        };
        if (capturing) groupAst["idx"] = this.groupIdx;
        return groupAst;
    }
    positiveInteger() {
        let number = this.popChar();
        // istanbul ignore next - can't ever get here due to previous lookahead checks
        // still implementing this error checking in case this ever changes.
        if ($438cb5f1875e7325$var$decimalPatternNoZero.test(number) === false) throw Error("Expecting a positive integer");
        while($438cb5f1875e7325$var$decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    }
    integerIncludingZero() {
        let number = this.popChar();
        if ($438cb5f1875e7325$var$decimalPattern.test(number) === false) throw Error("Expecting an integer");
        while($438cb5f1875e7325$var$decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    }
    patternCharacter() {
        const nextChar = this.popChar();
        switch(nextChar){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "^":
            // istanbul ignore next
            case "$":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case ".":
            // istanbul ignore next
            case "*":
            // istanbul ignore next
            case "+":
            // istanbul ignore next
            case "?":
            // istanbul ignore next
            case "(":
            // istanbul ignore next
            case ")":
            // istanbul ignore next
            case "[":
            // istanbul ignore next
            case "|":
                // istanbul ignore next
                throw Error("TBD");
            default:
                return {
                    type: "Character",
                    value: (0, $c18b7c637472d4b7$export$a1edd97dd51cd48d)(nextChar)
                };
        }
    }
    isRegExpFlag() {
        switch(this.peekChar(0)){
            case "g":
            case "i":
            case "m":
            case "u":
            case "y":
                return true;
            default:
                return false;
        }
    }
    isRangeDash() {
        return this.peekChar() === "-" && this.isClassAtom(1);
    }
    isDigit() {
        return $438cb5f1875e7325$var$decimalPattern.test(this.peekChar(0));
    }
    isClassAtom(howMuch = 0) {
        switch(this.peekChar(howMuch)){
            case "]":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    }
    isTerm() {
        return this.isAtom() || this.isAssertion();
    }
    isAtom() {
        if (this.isPatternCharacter()) return true;
        switch(this.peekChar(0)){
            case ".":
            case "\\":
            case "[":
            // TODO: isAtom must be called before isAssertion - disambiguate
            case "(":
                return true;
            default:
                return false;
        }
    }
    isAssertion() {
        switch(this.peekChar(0)){
            case "^":
            case "$":
                return true;
            // '\b' or '\B'
            case "\\":
                switch(this.peekChar(1)){
                    case "b":
                    case "B":
                        return true;
                    default:
                        return false;
                }
            // '(?=' or '(?!' or `(?<=` or `(?<!`
            case "(":
                return this.peekChar(1) === "?" && (this.peekChar(2) === "=" || this.peekChar(2) === "!" || this.peekChar(2) === "<" && (this.peekChar(3) === "=" || this.peekChar(3) === "!"));
            default:
                return false;
        }
    }
    isQuantifier() {
        const prevState = this.saveState();
        try {
            return this.quantifier(true) !== undefined;
        } catch (e) {
            return false;
        } finally{
            this.restoreState(prevState);
        }
    }
    isPatternCharacter() {
        switch(this.peekChar()){
            case "^":
            case "$":
            case "\\":
            case ".":
            case "*":
            case "+":
            case "?":
            case "(":
            case ")":
            case "[":
            case "|":
            case "/":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    }
    parseHexDigits(howMany) {
        let hexString = "";
        for(let i = 0; i < howMany; i++){
            const hexChar = this.popChar();
            if ($438cb5f1875e7325$var$hexDigitPattern.test(hexChar) === false) throw Error("Expecting a HexDecimal digits");
            hexString += hexChar;
        }
        const charCode = parseInt(hexString, 16);
        return {
            type: "Character",
            value: charCode
        };
    }
    peekChar(howMuch = 0) {
        return this.input[this.idx + howMuch];
    }
    popChar() {
        const nextChar = this.peekChar(0);
        this.consumeChar(undefined);
        return nextChar;
    }
    consumeChar(char) {
        if (char !== undefined && this.input[this.idx] !== char) throw Error("Expected: '" + char + "' but found: '" + this.input[this.idx] + "' at offset: " + this.idx);
        if (this.idx >= this.input.length) throw Error("Unexpected end of input");
        this.idx++;
    }
    loc(begin) {
        return {
            begin: begin,
            end: this.idx
        };
    }
}


class $13880f94179bb5b4$export$2307b30249d89d9d {
    visitChildren(node) {
        for(const key in node){
            const child = node[key];
            /* istanbul ignore else */ if (node.hasOwnProperty(key)) {
                if (child.type !== undefined) this.visit(child);
                else if (Array.isArray(child)) child.forEach((subChild)=>{
                    this.visit(subChild);
                }, this);
            }
        }
    }
    visit(node) {
        switch(node.type){
            case "Pattern":
                this.visitPattern(node);
                break;
            case "Flags":
                this.visitFlags(node);
                break;
            case "Disjunction":
                this.visitDisjunction(node);
                break;
            case "Alternative":
                this.visitAlternative(node);
                break;
            case "StartAnchor":
                this.visitStartAnchor(node);
                break;
            case "EndAnchor":
                this.visitEndAnchor(node);
                break;
            case "WordBoundary":
                this.visitWordBoundary(node);
                break;
            case "NonWordBoundary":
                this.visitNonWordBoundary(node);
                break;
            case "Lookahead":
                this.visitLookahead(node);
                break;
            case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                break;
            case "Lookbehind":
                this.visitLookbehind(node);
                break;
            case "NegativeLookbehind":
                this.visitNegativeLookbehind(node);
                break;
            case "Character":
                this.visitCharacter(node);
                break;
            case "Set":
                this.visitSet(node);
                break;
            case "Group":
                this.visitGroup(node);
                break;
            case "GroupBackReference":
                this.visitGroupBackReference(node);
                break;
            case "Quantifier":
                this.visitQuantifier(node);
                break;
        }
        this.visitChildren(node);
    }
    visitPattern(node) {}
    visitFlags(node) {}
    visitDisjunction(node) {}
    visitAlternative(node) {}
    // Assertion
    visitStartAnchor(node) {}
    visitEndAnchor(node) {}
    visitWordBoundary(node) {}
    visitNonWordBoundary(node) {}
    visitLookahead(node) {}
    visitNegativeLookahead(node) {}
    visitLookbehind(node) {}
    visitNegativeLookbehind(node) {}
    // atoms
    visitCharacter(node) {}
    visitSet(node) {}
    visitGroup(node) {}
    visitGroupBackReference(node) {}
    visitQuantifier(node) {}
}




const $f53f8e965a7efa80$export$5d8e12a48f5d751a = /\r?\n/gm;
const $f53f8e965a7efa80$var$regexpParser = new (0, $438cb5f1875e7325$export$16ea3460a23e7c94)();
/**
 * This class is in charge of heuristically identifying start/end tokens of terminals.
 *
 * The way this works is by doing the following:
 * 1. Traverse the regular expression in the "start state"
 * 2. Add any encountered sets/single characters to the "start regexp"
 * 3. Once we encounter any variable-length content (i.e. with quantifiers such as +/?/*), we enter the "end state"
 * 4. In the end state, any sets/single characters are added to an "end stack".
 * 5. If we re-encounter any variable-length content we reset the end stack
 * 6. We continue visiting the regex until the end, reseting the end stack and rebuilding it as necessary
 *
 * After traversing a regular expression the `startRegexp/endRegexp` properties allow access to the stored start/end of the terminal
 */ class $f53f8e965a7efa80$var$TerminalRegExpVisitor extends (0, $13880f94179bb5b4$export$2307b30249d89d9d) {
    constructor(){
        super(...arguments);
        this.isStarting = true;
        this.endRegexpStack = [];
        this.multiline = false;
    }
    get endRegex() {
        return this.endRegexpStack.join('');
    }
    reset(regex) {
        this.multiline = false;
        this.regex = regex;
        this.startRegexp = '';
        this.isStarting = true;
        this.endRegexpStack = [];
    }
    visitGroup(node) {
        if (node.quantifier) {
            this.isStarting = false;
            this.endRegexpStack = [];
        }
    }
    visitCharacter(node) {
        const char = String.fromCharCode(node.value);
        if (!this.multiline && char === '\n') this.multiline = true;
        if (node.quantifier) {
            this.isStarting = false;
            this.endRegexpStack = [];
        } else {
            const escapedChar = $f53f8e965a7efa80$export$7c57da42ce8e346f(char);
            this.endRegexpStack.push(escapedChar);
            if (this.isStarting) this.startRegexp += escapedChar;
        }
    }
    visitSet(node) {
        if (!this.multiline) {
            const set = this.regex.substring(node.loc.begin, node.loc.end);
            const regex = new RegExp(set);
            this.multiline = Boolean('\n'.match(regex));
        }
        if (node.quantifier) {
            this.isStarting = false;
            this.endRegexpStack = [];
        } else {
            const set = this.regex.substring(node.loc.begin, node.loc.end);
            this.endRegexpStack.push(set);
            if (this.isStarting) this.startRegexp += set;
        }
    }
    visitChildren(node) {
        if (node.type === 'Group') {
            // Ignore children of groups with quantifier (+/*/?)
            // These groups are unrelated to start/end tokens of terminals
            const group = node;
            if (group.quantifier) return;
        }
        super.visitChildren(node);
    }
}
const $f53f8e965a7efa80$var$visitor = new $f53f8e965a7efa80$var$TerminalRegExpVisitor();
function $f53f8e965a7efa80$export$c6db7247a63dd0ab(regexp) {
    try {
        if (typeof regexp !== 'string') regexp = regexp.source;
        regexp = `/${regexp}/`;
        const pattern = $f53f8e965a7efa80$var$regexpParser.pattern(regexp);
        const parts = [];
        for (const alternative of pattern.value.value){
            $f53f8e965a7efa80$var$visitor.reset(regexp);
            $f53f8e965a7efa80$var$visitor.visit(alternative);
            parts.push({
                start: $f53f8e965a7efa80$var$visitor.startRegexp,
                end: $f53f8e965a7efa80$var$visitor.endRegex
            });
        }
        return parts;
    } catch  {
        return [];
    }
}
function $f53f8e965a7efa80$export$83e351abd4dca46f(regexp) {
    try {
        if (typeof regexp === 'string') regexp = new RegExp(regexp);
        regexp = regexp.toString();
        $f53f8e965a7efa80$var$visitor.reset(regexp);
        // Parsing the pattern might fail (since it's user code)
        $f53f8e965a7efa80$var$visitor.visit($f53f8e965a7efa80$var$regexpParser.pattern(regexp));
        return $f53f8e965a7efa80$var$visitor.multiline;
    } catch  {
        return false;
    }
}
const $f53f8e965a7efa80$export$861b651d7e8949f1 = "\f\n\r	\v \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF".split('');
function $f53f8e965a7efa80$export$a1ed01a3e6d5a08c(value) {
    const regexp = typeof value === 'string' ? new RegExp(value) : value;
    return $f53f8e965a7efa80$export$861b651d7e8949f1.some((ws)=>regexp.test(ws));
}
function $f53f8e965a7efa80$export$7c57da42ce8e346f(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function $f53f8e965a7efa80$export$c5bffdd190c23a11(regex, input) {
    const partial = $f53f8e965a7efa80$export$bbb0a7019bd272b8(regex);
    const match = input.match(partial);
    return !!match && match[0].length > 0;
}
function $f53f8e965a7efa80$export$bbb0a7019bd272b8(regex) {
    if (typeof regex === 'string') regex = new RegExp(regex);
    const re = regex, source = regex.source;
    let i = 0;
    function process() {
        let result = '', tmp;
        function appendRaw(nbChars) {
            result += source.substr(i, nbChars);
            i += nbChars;
        }
        function appendOptional(nbChars) {
            result += '(?:' + source.substr(i, nbChars) + '|$)';
            i += nbChars;
        }
        while(i < source.length)switch(source[i]){
            case '\\':
                switch(source[i + 1]){
                    case 'c':
                        appendOptional(3);
                        break;
                    case 'x':
                        appendOptional(4);
                        break;
                    case 'u':
                        if (re.unicode) {
                            if (source[i + 2] === '{') appendOptional(source.indexOf('}', i) - i + 1);
                            else appendOptional(6);
                        } else appendOptional(2);
                        break;
                    case 'p':
                    case 'P':
                        if (re.unicode) appendOptional(source.indexOf('}', i) - i + 1);
                        else appendOptional(2);
                        break;
                    case 'k':
                        appendOptional(source.indexOf('>', i) - i + 1);
                        break;
                    default:
                        appendOptional(2);
                        break;
                }
                break;
            case '[':
                tmp = /\[(?:\\.|.)*?\]/g;
                tmp.lastIndex = i;
                tmp = tmp.exec(source) || [];
                appendOptional(tmp[0].length);
                break;
            case '|':
            case '^':
            case '$':
            case '*':
            case '+':
            case '?':
                appendRaw(1);
                break;
            case '{':
                tmp = /\{\d+,?\d*\}/g;
                tmp.lastIndex = i;
                tmp = tmp.exec(source);
                if (tmp) appendRaw(tmp[0].length);
                else appendOptional(1);
                break;
            case '(':
                if (source[i + 1] === '?') switch(source[i + 2]){
                    case ':':
                        result += '(?:';
                        i += 3;
                        result += process() + '|$)';
                        break;
                    case '=':
                        result += '(?=';
                        i += 3;
                        result += process() + ')';
                        break;
                    case '!':
                        tmp = i;
                        i += 3;
                        process();
                        result += source.substr(tmp, i - tmp);
                        break;
                    case '<':
                        switch(source[i + 3]){
                            case '=':
                            case '!':
                                tmp = i;
                                i += 4;
                                process();
                                result += source.substr(tmp, i - tmp);
                                break;
                            default:
                                appendRaw(source.indexOf('>', i) - i + 1);
                                result += process() + '|$)';
                                break;
                        }
                        break;
                }
                else {
                    appendRaw(1);
                    result += process() + '|$)';
                }
                break;
            case ')':
                ++i;
                return result;
            default:
                appendOptional(1);
                break;
        }
        return result;
    }
    return new RegExp(process(), regex.flags);
}


function $624e994b941222bd$export$1a19feae7faa0f7e(grammar) {
    return grammar.rules.find((e)=>$c70992891bcf3a02$export$f9dab8e9825cb550(e) && e.entry);
}
function $624e994b941222bd$export$d618825106d5dde2(grammar) {
    return grammar.rules.filter((e)=>$c70992891bcf3a02$export$82b19496f708707a(e) && e.hidden);
}
function $624e994b941222bd$export$fc165bec0f6dde4e(grammar, allTerminals) {
    const ruleNames = new Set();
    const entryRule = $624e994b941222bd$export$1a19feae7faa0f7e(grammar);
    if (!entryRule) return new Set(grammar.rules);
    const topMostRules = [
        entryRule
    ].concat($624e994b941222bd$export$d618825106d5dde2(grammar));
    for (const rule of topMostRules)$624e994b941222bd$var$ruleDfs(rule, ruleNames, allTerminals);
    const rules = new Set();
    for (const rule of grammar.rules)if (ruleNames.has(rule.name) || $c70992891bcf3a02$export$82b19496f708707a(rule) && rule.hidden) rules.add(rule);
    return rules;
}
function $624e994b941222bd$var$ruleDfs(rule, visitedSet, allTerminals) {
    visitedSet.add(rule.name);
    (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(rule).forEach((node)=>{
        if ($c70992891bcf3a02$export$e937deeadef89848(node) || allTerminals && $c70992891bcf3a02$export$c68015e200d3324(node)) {
            const refRule = node.rule.ref;
            if (refRule && !visitedSet.has(refRule.name)) $624e994b941222bd$var$ruleDfs(refRule, visitedSet, allTerminals);
        }
    });
}
function $624e994b941222bd$export$3a9c776bd38505fe(grammar) {
    const result = new Set();
    (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(grammar).forEach((node)=>{
        if ($c70992891bcf3a02$export$ca91f6306d3bb0f4(node)) {
            // the cross-reference refers directly to a parser rule (without "returns", without "infers")
            if ($c70992891bcf3a02$export$f9dab8e9825cb550(node.type.ref)) result.add(node.type.ref);
            // the cross-reference refers to the explicitly inferred type of a parser rule
            if ($c70992891bcf3a02$export$bd801a1fe9b55185(node.type.ref) && $c70992891bcf3a02$export$f9dab8e9825cb550(node.type.ref.$container)) result.add(node.type.ref.$container);
        }
    });
    return result;
}
function $624e994b941222bd$export$9b79b91a8e4df62(crossRef) {
    if (crossRef.terminal) return crossRef.terminal;
    else if (crossRef.type.ref) {
        const nameAssigment = $624e994b941222bd$export$fa6f17e0e38963f1(crossRef.type.ref);
        return nameAssigment?.terminal;
    }
    return undefined;
}
function $624e994b941222bd$export$ec0459fe190b6be2(terminalRule) {
    return terminalRule.hidden && !(0, $f53f8e965a7efa80$export$a1ed01a3e6d5a08c)($624e994b941222bd$export$52fb9fbe017bc3c3(terminalRule));
}
function $624e994b941222bd$export$b6014cab792295bd(node, property) {
    if (!node || !property) return [];
    return $624e994b941222bd$var$findNodesForPropertyInternal(node, property, node.astNode, true);
}
function $624e994b941222bd$export$cb1742ae4f1e059d(node, property, index) {
    if (!node || !property) return undefined;
    const nodes = $624e994b941222bd$var$findNodesForPropertyInternal(node, property, node.astNode, true);
    if (nodes.length === 0) return undefined;
    if (index !== undefined) index = Math.max(0, Math.min(index, nodes.length - 1));
    else index = 0;
    return nodes[index];
}
function $624e994b941222bd$var$findNodesForPropertyInternal(node, property, element, first) {
    if (!first) {
        const nodeFeature = (0, $de130ae470c6cbfb$export$51e1e993675a3c6a)(node.grammarSource, $c70992891bcf3a02$export$f27c77753b3dbe70);
        if (nodeFeature && nodeFeature.feature === property) return [
            node
        ];
    }
    if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(node) && node.astNode === element) return node.content.flatMap((e)=>$624e994b941222bd$var$findNodesForPropertyInternal(e, property, element, false));
    return [];
}
function $624e994b941222bd$export$b3af54a1fe2410fb(node, keyword) {
    if (!node) return [];
    return $624e994b941222bd$export$e9055e4e773a42c5(node, keyword, node?.astNode);
}
function $624e994b941222bd$export$3c69baddbefd5ba4(node, keyword, index) {
    if (!node) return undefined;
    const nodes = $624e994b941222bd$export$e9055e4e773a42c5(node, keyword, node?.astNode);
    if (nodes.length === 0) return undefined;
    if (index !== undefined) index = Math.max(0, Math.min(index, nodes.length - 1));
    else index = 0;
    return nodes[index];
}
function $624e994b941222bd$export$e9055e4e773a42c5(node, keyword, element) {
    if (node.astNode !== element) return [];
    if ($c70992891bcf3a02$export$384ccb3991bcb643(node.grammarSource) && node.grammarSource.value === keyword) return [
        node
    ];
    const treeIterator = (0, $f87d6e075cbbfde9$export$e6e798b3ac4e876c)(node).iterator();
    let result;
    const keywordNodes = [];
    do {
        result = treeIterator.next();
        if (!result.done) {
            const childNode = result.value;
            if (childNode.astNode === element) {
                if ($c70992891bcf3a02$export$384ccb3991bcb643(childNode.grammarSource) && childNode.grammarSource.value === keyword) keywordNodes.push(childNode);
            } else treeIterator.prune();
        }
    }while (!result.done);
    return keywordNodes;
}
function $624e994b941222bd$export$6e669a85c4c7eab7(cstNode) {
    const astNode = cstNode.astNode;
    // Only search until the ast node of the parent cst node is no longer the original ast node
    // This would make us jump to a preceding rule call, which contains only unrelated assignments
    while(astNode === cstNode.container?.astNode){
        const assignment = (0, $de130ae470c6cbfb$export$51e1e993675a3c6a)(cstNode.grammarSource, $c70992891bcf3a02$export$f27c77753b3dbe70);
        if (assignment) return assignment;
        cstNode = cstNode.container;
    }
    return undefined;
}
function $624e994b941222bd$export$fa6f17e0e38963f1(type) {
    let startNode = type;
    if ($c70992891bcf3a02$export$bd801a1fe9b55185(startNode)) {
        // for inferred types, the location to start searching for the name-assignment is different
        if ($c70992891bcf3a02$export$b956e38827fca970(startNode.$container)) // a type which is explicitly inferred by an action: investigate the sibling of the Action node, i.e. start searching at the Action's parent
        startNode = startNode.$container.$container;
        else if ($c70992891bcf3a02$export$9075dd262e43c30d(startNode.$container)) // investigate the parser rule with the explicitly inferred type
        startNode = startNode.$container;
        else (0, $71d485f045ec2841$export$f2525c1d596f8d46)(startNode.$container);
    }
    return $624e994b941222bd$var$findNameAssignmentInternal(type, startNode, new Map());
}
function $624e994b941222bd$var$findNameAssignmentInternal(type, startNode, cache) {
    // the cache is only required to prevent infinite loops
    function go(node, refType) {
        let childAssignment = undefined;
        const parentAssignment = (0, $de130ae470c6cbfb$export$51e1e993675a3c6a)(node, $c70992891bcf3a02$export$f27c77753b3dbe70);
        // No parent assignment implies unassigned rule call
        if (!parentAssignment) childAssignment = $624e994b941222bd$var$findNameAssignmentInternal(refType, refType, cache);
        cache.set(type, childAssignment);
        return childAssignment;
    }
    if (cache.has(type)) return cache.get(type);
    cache.set(type, undefined);
    for (const node of (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(startNode)){
        if ($c70992891bcf3a02$export$f27c77753b3dbe70(node) && node.feature.toLowerCase() === 'name') {
            cache.set(type, node);
            return node;
        } else if ($c70992891bcf3a02$export$e937deeadef89848(node) && $c70992891bcf3a02$export$f9dab8e9825cb550(node.rule.ref)) return go(node, node.rule.ref);
        else if ($c70992891bcf3a02$export$957664d9e1a22fd7(node) && node.typeRef?.ref) return go(node, node.typeRef.ref);
    }
    return undefined;
}
function $624e994b941222bd$export$d16a797d7def12cc(element) {
    const parent = element.$container;
    if ($c70992891bcf3a02$export$d7976824e9f55785(parent)) {
        const elements = parent.elements;
        const index = elements.indexOf(element);
        for(let i = index - 1; i >= 0; i--){
            const item = elements[i];
            if ($c70992891bcf3a02$export$b956e38827fca970(item)) return item;
            else {
                const action = (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(elements[i]).find($c70992891bcf3a02$export$b956e38827fca970);
                if (action) return action;
            }
        }
    }
    if ($c70992891bcf3a02$export$14d6559204778623(parent)) return $624e994b941222bd$export$d16a797d7def12cc(parent);
    else return undefined;
}
function $624e994b941222bd$export$834cdc753f387b02(cardinality, element) {
    return cardinality === '?' || cardinality === '*' || $c70992891bcf3a02$export$d7976824e9f55785(element) && Boolean(element.guardCondition);
}
function $624e994b941222bd$export$fff15dd7e3775884(cardinality) {
    return cardinality === '*' || cardinality === '+';
}
function $624e994b941222bd$export$3ce390905cad9545(operator) {
    return operator === '+=';
}
function $624e994b941222bd$export$345e3e63a0123b21(rule) {
    return $624e994b941222bd$var$isDataTypeRuleInternal(rule, new Set());
}
function $624e994b941222bd$var$isDataTypeRuleInternal(rule, visited) {
    if (visited.has(rule)) return true;
    else visited.add(rule);
    for (const node of (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(rule)){
        if ($c70992891bcf3a02$export$e937deeadef89848(node)) {
            if (!node.rule.ref) // RuleCall to unresolved rule. Don't assume `rule` is a DataType rule.
            return false;
            if ($c70992891bcf3a02$export$f9dab8e9825cb550(node.rule.ref) && !$624e994b941222bd$var$isDataTypeRuleInternal(node.rule.ref, visited)) return false;
            if ($c70992891bcf3a02$export$ff161511bc809b89(node.rule.ref)) return false;
        } else if ($c70992891bcf3a02$export$f27c77753b3dbe70(node)) return false;
        else if ($c70992891bcf3a02$export$b956e38827fca970(node)) return false;
    }
    return Boolean(rule.definition);
}
function $624e994b941222bd$export$9c4589cc5d0efb1f(type) {
    return $624e994b941222bd$var$isDataTypeInternal(type.type, new Set());
}
function $624e994b941222bd$var$isDataTypeInternal(type, visited) {
    if (visited.has(type)) return true;
    else visited.add(type);
    if ($c70992891bcf3a02$export$b3f856ebde208b3c(type)) return false;
    else if ($c70992891bcf3a02$export$5e9b8dbec8ce4cbb(type)) return false;
    else if ($c70992891bcf3a02$export$cca4caab5ef5a545(type)) return type.types.every((e)=>$624e994b941222bd$var$isDataTypeInternal(e, visited));
    else if ($c70992891bcf3a02$export$957664d9e1a22fd7(type)) {
        if (type.primitiveType !== undefined) return true;
        else if (type.stringType !== undefined) return true;
        else if (type.typeRef !== undefined) {
            const ref = type.typeRef.ref;
            if ($c70992891bcf3a02$export$26b9f946b448f23e(ref)) return $624e994b941222bd$var$isDataTypeInternal(ref.type, visited);
            else return false;
        } else return false;
    } else return false;
}
function $624e994b941222bd$export$ebcb533fb2bf9d09(rule) {
    if ($c70992891bcf3a02$export$82b19496f708707a(rule)) return undefined;
    if (rule.inferredType) return rule.inferredType.name;
    else if (rule.dataType) return rule.dataType;
    else if (rule.returnType) {
        const refType = rule.returnType.ref;
        if (refType) return refType.name;
    }
    return undefined;
}
function $624e994b941222bd$export$9bcacca3c0b0cdd9(type) {
    if ($c70992891bcf3a02$export$9075dd262e43c30d(type)) return $c70992891bcf3a02$export$f9dab8e9825cb550(type) && $624e994b941222bd$export$345e3e63a0123b21(type) ? type.name : $624e994b941222bd$export$ebcb533fb2bf9d09(type) ?? type.name;
    else if ($c70992891bcf3a02$export$e94a97bcd6db8414(type) || $c70992891bcf3a02$export$26b9f946b448f23e(type) || $c70992891bcf3a02$export$5f6f7cc729edd91d(type)) return type.name;
    else if ($c70992891bcf3a02$export$b956e38827fca970(type)) {
        const actionType = $624e994b941222bd$export$e303144c5506946a(type);
        if (actionType) return actionType;
    } else if ($c70992891bcf3a02$export$bd801a1fe9b55185(type)) return type.name;
    throw new Error('Cannot get name of Unknown Type');
}
function $624e994b941222bd$export$e303144c5506946a(action) {
    if (action.inferredType) return action.inferredType.name;
    else if (action.type?.ref) return $624e994b941222bd$export$9bcacca3c0b0cdd9(action.type.ref);
    return undefined; // not inferring and not referencing a valid type
}
function $624e994b941222bd$export$996652e9288e7e2d(rule) {
    if ($c70992891bcf3a02$export$82b19496f708707a(rule)) return rule.type?.name ?? 'string';
    else return $c70992891bcf3a02$export$f9dab8e9825cb550(rule) && $624e994b941222bd$export$345e3e63a0123b21(rule) ? rule.name : $624e994b941222bd$export$ebcb533fb2bf9d09(rule) ?? rule.name;
}
function $624e994b941222bd$export$71fe8f5e5e2347dc(rule) {
    if ($c70992891bcf3a02$export$82b19496f708707a(rule)) return rule.type?.name ?? 'string';
    else return $624e994b941222bd$export$ebcb533fb2bf9d09(rule) ?? rule.name;
}
function $624e994b941222bd$export$52fb9fbe017bc3c3(terminalRule) {
    const flags = {
        s: false,
        i: false,
        u: false
    };
    const source = $624e994b941222bd$var$abstractElementToRegex(terminalRule.definition, flags);
    const flagText = Object.entries(flags).filter(([, value])=>value).map(([name])=>name).join('');
    return new RegExp(source, flagText);
}
// Using [\s\S]* allows to match everything, compared to . which doesn't match line terminators
const $624e994b941222bd$var$WILDCARD = /[\s\S]/.source;
function $624e994b941222bd$var$abstractElementToRegex(element, flags) {
    if ($c70992891bcf3a02$export$ae292517e4fb7e09(element)) return $624e994b941222bd$var$terminalAlternativesToRegex(element);
    else if ($c70992891bcf3a02$export$95ff26ac47c748f2(element)) return $624e994b941222bd$var$terminalGroupToRegex(element);
    else if ($c70992891bcf3a02$export$8b38dfeb00bc3e81(element)) return $624e994b941222bd$var$characterRangeToRegex(element);
    else if ($c70992891bcf3a02$export$c68015e200d3324(element)) {
        const rule = element.rule.ref;
        if (!rule) throw new Error('Missing rule reference.');
        return $624e994b941222bd$var$withCardinality($624e994b941222bd$var$abstractElementToRegex(rule.definition), {
            cardinality: element.cardinality,
            lookahead: element.lookahead,
            parenthesized: element.parenthesized
        });
    } else if ($c70992891bcf3a02$export$f4425fdd3f168242(element)) return $624e994b941222bd$var$negateTokenToRegex(element);
    else if ($c70992891bcf3a02$export$16eb3268f2d48(element)) return $624e994b941222bd$var$untilTokenToRegex(element);
    else if ($c70992891bcf3a02$export$3cb2556e66dd592(element)) {
        const lastSlash = element.regex.lastIndexOf('/');
        const source = element.regex.substring(1, lastSlash);
        const regexFlags = element.regex.substring(lastSlash + 1);
        if (flags) {
            flags.i = regexFlags.includes('i');
            flags.s = regexFlags.includes('s');
            flags.u = regexFlags.includes('u');
        }
        return $624e994b941222bd$var$withCardinality(source, {
            cardinality: element.cardinality,
            lookahead: element.lookahead,
            parenthesized: element.parenthesized,
            wrap: false
        });
    } else if ($c70992891bcf3a02$export$ba42c4680b5f8317(element)) return $624e994b941222bd$var$withCardinality($624e994b941222bd$var$WILDCARD, {
        cardinality: element.cardinality,
        lookahead: element.lookahead,
        parenthesized: element.parenthesized
    });
    else throw new Error(`Invalid terminal element: ${element?.$type}, ${element?.$cstNode?.text}`);
}
function $624e994b941222bd$var$terminalAlternativesToRegex(alternatives) {
    return $624e994b941222bd$var$withCardinality(alternatives.elements.map((e)=>$624e994b941222bd$var$abstractElementToRegex(e)).join('|'), {
        cardinality: alternatives.cardinality,
        lookahead: alternatives.lookahead,
        parenthesized: alternatives.parenthesized,
        wrap: false // wrapping is not required for top level alternatives, and nested alternatives are already parenthesized according to the grammar
    });
}
function $624e994b941222bd$var$terminalGroupToRegex(group) {
    return $624e994b941222bd$var$withCardinality(group.elements.map((e)=>$624e994b941222bd$var$abstractElementToRegex(e)).join(''), {
        cardinality: group.cardinality,
        lookahead: group.lookahead,
        parenthesized: group.parenthesized,
        wrap: false // wrapping is not required for top level group, and nested group are already parenthesized according to the grammar
    });
}
function $624e994b941222bd$var$untilTokenToRegex(until) {
    return $624e994b941222bd$var$withCardinality(`${$624e994b941222bd$var$WILDCARD}*?${$624e994b941222bd$var$abstractElementToRegex(until.terminal)}`, {
        cardinality: until.cardinality,
        lookahead: until.lookahead,
        parenthesized: until.parenthesized
    });
}
function $624e994b941222bd$var$negateTokenToRegex(negate) {
    return $624e994b941222bd$var$withCardinality(`(?!${$624e994b941222bd$var$abstractElementToRegex(negate.terminal)})${$624e994b941222bd$var$WILDCARD}*?`, {
        cardinality: negate.cardinality,
        lookahead: negate.lookahead,
        parenthesized: negate.parenthesized
    });
}
function $624e994b941222bd$var$characterRangeToRegex(range) {
    if (range.right) return $624e994b941222bd$var$withCardinality(`[${$624e994b941222bd$var$keywordToRegex(range.left)}-${$624e994b941222bd$var$keywordToRegex(range.right)}]`, {
        cardinality: range.cardinality,
        lookahead: range.lookahead,
        parenthesized: range.parenthesized,
        wrap: false
    });
    return $624e994b941222bd$var$withCardinality($624e994b941222bd$var$keywordToRegex(range.left), {
        cardinality: range.cardinality,
        lookahead: range.lookahead,
        parenthesized: range.parenthesized,
        wrap: false
    });
}
function $624e994b941222bd$var$keywordToRegex(keyword) {
    return (0, $f53f8e965a7efa80$export$7c57da42ce8e346f)(keyword.value);
}
function $624e994b941222bd$var$withCardinality(regex, options) {
    if (options.parenthesized || options.lookahead || options.wrap !== false) {
        const groupConfig = options.lookahead ?? (options.parenthesized ? '' : '?:');
        regex = `(${groupConfig}${regex})`;
    }
    if (options.cardinality) return `${regex}${options.cardinality}`;
    return regex;
}




function $0427dfdfd0423955$export$66eccfaecec6301f(services) {
    const rules = [];
    const grammar = services.Grammar;
    for (const rule of grammar.rules)if ((0, $c70992891bcf3a02$export$82b19496f708707a)(rule) && (0, $624e994b941222bd$export$ec0459fe190b6be2)(rule) && (0, $f53f8e965a7efa80$export$83e351abd4dca46f)((0, $624e994b941222bd$export$52fb9fbe017bc3c3)(rule))) rules.push(rule.name);
    return {
        multilineCommentRules: rules,
        nameRegexp: (0, $f87d6e075cbbfde9$export$dd0bd96951dcf6e4)
    };
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /* eslint-disable @typescript-eslint/no-explicit-any */ 
// lib/src/version.js
var $5d51f81a4b917e73$export$a4ad2735b021c132 = "13.2.0";
// ../utils/lib/src/print.js
function $5d51f81a4b917e73$var$PRINT_ERROR(msg) {
    if (console && console.error) console.error(`Error: ${msg}`);
}
function $5d51f81a4b917e73$var$PRINT_WARNING(msg) {
    if (console && console.warn) console.warn(`Warning: ${msg}`);
}
// ../utils/lib/src/timer.js
function $5d51f81a4b917e73$var$timer(func) {
    const start = /* @__PURE__ */ new Date().getTime();
    const val = func();
    const end = /* @__PURE__ */ new Date().getTime();
    const total = end - start;
    return {
        time: total,
        value: val
    };
}
// ../utils/lib/src/to-fast-properties.js
function $5d51f81a4b917e73$var$toFastProperties(toBecomeFast) {
    function FakeConstructor() {}
    FakeConstructor.prototype = toBecomeFast;
    const fakeInstance = new FakeConstructor();
    function fakeAccess() {
        return typeof fakeInstance.bar;
    }
    fakeAccess();
    fakeAccess();
    return toBecomeFast;
}
// ../gast/lib/src/model.js
function $5d51f81a4b917e73$var$tokenLabel(tokType) {
    if ($5d51f81a4b917e73$var$hasTokenLabel(tokType)) return tokType.LABEL;
    else return tokType.name;
}
function $5d51f81a4b917e73$var$hasTokenLabel(obj) {
    return typeof obj.LABEL === "string" && obj.LABEL !== "";
}
var $5d51f81a4b917e73$var$AbstractProduction = class {
    get definition() {
        return this._definition;
    }
    set definition(value) {
        this._definition = value;
    }
    constructor(_definition){
        this._definition = _definition;
    }
    accept(visitor) {
        visitor.visit(this);
        this.definition.forEach((prod)=>{
            prod.accept(visitor);
        });
    }
};
var $5d51f81a4b917e73$export$ab116ec58638c09 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super([]);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
    set definition(definition) {}
    get definition() {
        if (this.referencedRule !== void 0) return this.referencedRule.definition;
        return [];
    }
    accept(visitor) {
        visitor.visit(this);
    }
};
var $5d51f81a4b917e73$export$f1ff2a90c38ff669 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.orgText = "";
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$4acb47accde578d2 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.ignoreAmbiguities = false;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$36d18380658d5d20 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$d068cf3ccde3d9e8 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$da6c5580175e0214 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$adf7bc0a69b784e9 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$856dea708c981fb8 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    constructor(options){
        super(options.definition);
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$d8895f7a7cf86415 = class extends $5d51f81a4b917e73$var$AbstractProduction {
    get definition() {
        return this._definition;
    }
    set definition(value) {
        this._definition = value;
    }
    constructor(options){
        super(options.definition);
        this.idx = 1;
        this.ignoreAmbiguities = false;
        this.hasPredicates = false;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
};
var $5d51f81a4b917e73$export$8dd80f06eb58bfe1 = class {
    constructor(options){
        this.idx = 1;
        Object.assign(this, $5d51f81a4b917e73$var$pickOnlyDefined(options));
    }
    accept(visitor) {
        visitor.visit(this);
    }
};
function $5d51f81a4b917e73$export$402033653bede0a9(topRules) {
    return topRules.map($5d51f81a4b917e73$export$d5097bfcf032db89);
}
function $5d51f81a4b917e73$export$d5097bfcf032db89(node) {
    function convertDefinition(definition) {
        return definition.map($5d51f81a4b917e73$export$d5097bfcf032db89);
    }
    if (node instanceof $5d51f81a4b917e73$export$ab116ec58638c09) {
        const serializedNonTerminal = {
            type: "NonTerminal",
            name: node.nonTerminalName,
            idx: node.idx
        };
        if (typeof node.label === "string") serializedNonTerminal.label = node.label;
        return serializedNonTerminal;
    } else if (node instanceof $5d51f81a4b917e73$export$4acb47accde578d2) return {
        type: "Alternative",
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$36d18380658d5d20) return {
        type: "Option",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8) return {
        type: "RepetitionMandatory",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$da6c5580175e0214) return {
        type: "RepetitionMandatoryWithSeparator",
        idx: node.idx,
        separator: $5d51f81a4b917e73$export$d5097bfcf032db89(new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
            terminalType: node.separator
        })),
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$856dea708c981fb8) return {
        type: "RepetitionWithSeparator",
        idx: node.idx,
        separator: $5d51f81a4b917e73$export$d5097bfcf032db89(new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
            terminalType: node.separator
        })),
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) return {
        type: "Repetition",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) return {
        type: "Alternation",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
        const serializedTerminal = {
            type: "Terminal",
            name: node.terminalType.name,
            label: $5d51f81a4b917e73$var$tokenLabel(node.terminalType),
            idx: node.idx
        };
        if (typeof node.label === "string") serializedTerminal.terminalLabel = node.label;
        const pattern = node.terminalType.PATTERN;
        if (node.terminalType.PATTERN) serializedTerminal.pattern = pattern instanceof RegExp ? pattern.source : pattern;
        return serializedTerminal;
    } else if (node instanceof $5d51f81a4b917e73$export$f1ff2a90c38ff669) return {
        type: "Rule",
        name: node.name,
        orgText: node.orgText,
        definition: convertDefinition(node.definition)
    };
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$var$pickOnlyDefined(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v])=>v !== void 0));
}
// ../gast/lib/src/visitor.js
var $5d51f81a4b917e73$export$341eb7a348fb5523 = class {
    visit(node) {
        const nodeAny = node;
        switch(nodeAny.constructor){
            case $5d51f81a4b917e73$export$ab116ec58638c09:
                return this.visitNonTerminal(nodeAny);
            case $5d51f81a4b917e73$export$4acb47accde578d2:
                return this.visitAlternative(nodeAny);
            case $5d51f81a4b917e73$export$36d18380658d5d20:
                return this.visitOption(nodeAny);
            case $5d51f81a4b917e73$export$d068cf3ccde3d9e8:
                return this.visitRepetitionMandatory(nodeAny);
            case $5d51f81a4b917e73$export$da6c5580175e0214:
                return this.visitRepetitionMandatoryWithSeparator(nodeAny);
            case $5d51f81a4b917e73$export$856dea708c981fb8:
                return this.visitRepetitionWithSeparator(nodeAny);
            case $5d51f81a4b917e73$export$adf7bc0a69b784e9:
                return this.visitRepetition(nodeAny);
            case $5d51f81a4b917e73$export$d8895f7a7cf86415:
                return this.visitAlternation(nodeAny);
            case $5d51f81a4b917e73$export$8dd80f06eb58bfe1:
                return this.visitTerminal(nodeAny);
            case $5d51f81a4b917e73$export$f1ff2a90c38ff669:
                return this.visitRule(nodeAny);
            /* c8 ignore next 2 */ default:
                throw Error("non exhaustive match");
        }
    }
    /* c8 ignore next */ visitNonTerminal(node) {}
    /* c8 ignore next */ visitAlternative(node) {}
    /* c8 ignore next */ visitOption(node) {}
    /* c8 ignore next */ visitRepetition(node) {}
    /* c8 ignore next */ visitRepetitionMandatory(node) {}
    /* c8 ignore next 3 */ visitRepetitionMandatoryWithSeparator(node) {}
    /* c8 ignore next */ visitRepetitionWithSeparator(node) {}
    /* c8 ignore next */ visitAlternation(node) {}
    /* c8 ignore next */ visitTerminal(node) {}
    /* c8 ignore next */ visitRule(node) {}
};
// ../gast/lib/src/helpers.js
function $5d51f81a4b917e73$var$isSequenceProd(prod) {
    return prod instanceof $5d51f81a4b917e73$export$4acb47accde578d2 || prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20 || prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9 || prod instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8 || prod instanceof $5d51f81a4b917e73$export$da6c5580175e0214 || prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8 || prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1 || prod instanceof $5d51f81a4b917e73$export$f1ff2a90c38ff669;
}
function $5d51f81a4b917e73$var$isOptionalProd(prod, alreadyVisited = []) {
    const isDirectlyOptional = prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20 || prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9 || prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8;
    if (isDirectlyOptional) return true;
    if (prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) return prod.definition.some((subProd)=>{
        return $5d51f81a4b917e73$var$isOptionalProd(subProd, alreadyVisited);
    });
    else if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09 && alreadyVisited.includes(prod)) return false;
    else if (prod instanceof $5d51f81a4b917e73$var$AbstractProduction) {
        if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) alreadyVisited.push(prod);
        return prod.definition.every((subProd)=>{
            return $5d51f81a4b917e73$var$isOptionalProd(subProd, alreadyVisited);
        });
    } else return false;
}
function $5d51f81a4b917e73$var$isBranchingProd(prod) {
    return prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415;
}
function $5d51f81a4b917e73$var$getProductionDslName(prod) {
    if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return "SUBRULE";
    else if (prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20) return "OPTION";
    else if (prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) return "OR";
    else if (prod instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8) return "AT_LEAST_ONE";
    else if (prod instanceof $5d51f81a4b917e73$export$da6c5580175e0214) return "AT_LEAST_ONE_SEP";
    else if (prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8) return "MANY_SEP";
    else if (prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) return "MANY";
    else if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) return "CONSUME";
    else throw Error("non exhaustive match");
}
// lib/src/parse/grammar/rest.js
var $5d51f81a4b917e73$var$RestWalker = class {
    walk(prod, prevRest = []) {
        prod.definition.forEach((subProd, index)=>{
            const currRest = prod.definition.slice(index + 1);
            if (subProd instanceof $5d51f81a4b917e73$export$ab116ec58638c09) this.walkProdRef(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) this.walkTerminal(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$4acb47accde578d2) this.walkFlat(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$36d18380658d5d20) this.walkOption(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8) this.walkAtLeastOne(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$da6c5580175e0214) this.walkAtLeastOneSep(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$856dea708c981fb8) this.walkManySep(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) this.walkMany(subProd, currRest, prevRest);
            else if (subProd instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) this.walkOr(subProd, currRest, prevRest);
            else throw Error("non exhaustive match");
        });
    }
    walkTerminal(terminal, currRest, prevRest) {}
    walkProdRef(refProd, currRest, prevRest) {}
    walkFlat(flatProd, currRest, prevRest) {
        const fullOrRest = currRest.concat(prevRest);
        this.walk(flatProd, fullOrRest);
    }
    walkOption(optionProd, currRest, prevRest) {
        const fullOrRest = currRest.concat(prevRest);
        this.walk(optionProd, fullOrRest);
    }
    walkAtLeastOne(atLeastOneProd, currRest, prevRest) {
        const fullAtLeastOneRest = [
            new $5d51f81a4b917e73$export$36d18380658d5d20({
                definition: atLeastOneProd.definition
            })
        ].concat(currRest, prevRest);
        this.walk(atLeastOneProd, fullAtLeastOneRest);
    }
    walkAtLeastOneSep(atLeastOneSepProd, currRest, prevRest) {
        const fullAtLeastOneSepRest = $5d51f81a4b917e73$var$restForRepetitionWithSeparator(atLeastOneSepProd, currRest, prevRest);
        this.walk(atLeastOneSepProd, fullAtLeastOneSepRest);
    }
    walkMany(manyProd, currRest, prevRest) {
        const fullManyRest = [
            new $5d51f81a4b917e73$export$36d18380658d5d20({
                definition: manyProd.definition
            })
        ].concat(currRest, prevRest);
        this.walk(manyProd, fullManyRest);
    }
    walkManySep(manySepProd, currRest, prevRest) {
        const fullManySepRest = $5d51f81a4b917e73$var$restForRepetitionWithSeparator(manySepProd, currRest, prevRest);
        this.walk(manySepProd, fullManySepRest);
    }
    walkOr(orProd, currRest, prevRest) {
        const fullOrRest = currRest.concat(prevRest);
        orProd.definition.forEach((alt)=>{
            const prodWrapper = new $5d51f81a4b917e73$export$4acb47accde578d2({
                definition: [
                    alt
                ]
            });
            this.walk(prodWrapper, fullOrRest);
        });
    }
};
function $5d51f81a4b917e73$var$restForRepetitionWithSeparator(repSepProd, currRest, prevRest) {
    const repSepRest = [
        new $5d51f81a4b917e73$export$36d18380658d5d20({
            definition: [
                new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
                    terminalType: repSepProd.separator
                })
            ].concat(repSepProd.definition)
        })
    ];
    const fullRepSepRest = repSepRest.concat(currRest, prevRest);
    return fullRepSepRest;
}
// lib/src/parse/grammar/first.js
function $5d51f81a4b917e73$var$first(prod) {
    if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return $5d51f81a4b917e73$var$first(prod.referencedRule);
    else if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) return $5d51f81a4b917e73$var$firstForTerminal(prod);
    else if ($5d51f81a4b917e73$var$isSequenceProd(prod)) return $5d51f81a4b917e73$var$firstForSequence(prod);
    else if ($5d51f81a4b917e73$var$isBranchingProd(prod)) return $5d51f81a4b917e73$var$firstForBranching(prod);
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$var$firstForSequence(prod) {
    let firstSet = [];
    const seq = prod.definition;
    let nextSubProdIdx = 0;
    let hasInnerProdsRemaining = seq.length > nextSubProdIdx;
    let currSubProd;
    let isLastInnerProdOptional = true;
    while(hasInnerProdsRemaining && isLastInnerProdOptional){
        currSubProd = seq[nextSubProdIdx];
        isLastInnerProdOptional = $5d51f81a4b917e73$var$isOptionalProd(currSubProd);
        firstSet = firstSet.concat($5d51f81a4b917e73$var$first(currSubProd));
        nextSubProdIdx = nextSubProdIdx + 1;
        hasInnerProdsRemaining = seq.length > nextSubProdIdx;
    }
    return [
        ...new Set(firstSet)
    ];
}
function $5d51f81a4b917e73$var$firstForBranching(prod) {
    const allAlternativesFirsts = prod.definition.map((innerProd)=>{
        return $5d51f81a4b917e73$var$first(innerProd);
    });
    return [
        ...new Set(allAlternativesFirsts.flat())
    ];
}
function $5d51f81a4b917e73$var$firstForTerminal(terminal) {
    return [
        terminal.terminalType
    ];
}
// lib/src/parse/constants.js
var $5d51f81a4b917e73$var$IN = "_~IN~_";
// lib/src/parse/grammar/follow.js
var $5d51f81a4b917e73$var$ResyncFollowsWalker = class extends $5d51f81a4b917e73$var$RestWalker {
    constructor(topProd){
        super();
        this.topProd = topProd;
        this.follows = {};
    }
    startWalking() {
        this.walk(this.topProd);
        return this.follows;
    }
    walkTerminal(terminal, currRest, prevRest) {}
    walkProdRef(refProd, currRest, prevRest) {
        const followName = $5d51f81a4b917e73$var$buildBetweenProdsFollowPrefix(refProd.referencedRule, refProd.idx) + this.topProd.name;
        const fullRest = currRest.concat(prevRest);
        const restProd = new $5d51f81a4b917e73$export$4acb47accde578d2({
            definition: fullRest
        });
        const t_in_topProd_follows = $5d51f81a4b917e73$var$first(restProd);
        this.follows[followName] = t_in_topProd_follows;
    }
};
function $5d51f81a4b917e73$var$computeAllProdsFollows(topProductions) {
    const reSyncFollows = {};
    topProductions.forEach((topProd)=>{
        const currRefsFollow = new $5d51f81a4b917e73$var$ResyncFollowsWalker(topProd).startWalking();
        Object.assign(reSyncFollows, currRefsFollow);
    });
    return reSyncFollows;
}
function $5d51f81a4b917e73$var$buildBetweenProdsFollowPrefix(inner, occurenceInParent) {
    return inner.name + occurenceInParent + $5d51f81a4b917e73$var$IN;
}
// ../regexp-to-ast/lib/src/utils.js
function $5d51f81a4b917e73$var$cc(char) {
    return char.charCodeAt(0);
}
function $5d51f81a4b917e73$var$insertToSet(item, set) {
    if (Array.isArray(item)) item.forEach(function(subItem) {
        set.push(subItem);
    });
    else set.push(item);
}
function $5d51f81a4b917e73$var$addFlag(flagObj, flagKey) {
    if (flagObj[flagKey] === true) throw "duplicate flag " + flagKey;
    const x = flagObj[flagKey];
    flagObj[flagKey] = true;
}
function $5d51f81a4b917e73$var$ASSERT_EXISTS(obj) {
    if (obj === void 0) throw Error("Internal Error - Should never get here!");
    return true;
}
function $5d51f81a4b917e73$var$ASSERT_NEVER_REACH_HERE() {
    throw Error("Internal Error - Should never get here!");
}
function $5d51f81a4b917e73$var$isCharacter(obj) {
    return obj["type"] === "Character";
}
// ../regexp-to-ast/lib/src/character-classes.js
var $5d51f81a4b917e73$var$digitsCharCodes = [];
for(let i = $5d51f81a4b917e73$var$cc("0"); i <= $5d51f81a4b917e73$var$cc("9"); i++)$5d51f81a4b917e73$var$digitsCharCodes.push(i);
var $5d51f81a4b917e73$var$wordCharCodes = [
    $5d51f81a4b917e73$var$cc("_")
].concat($5d51f81a4b917e73$var$digitsCharCodes);
for(let i = $5d51f81a4b917e73$var$cc("a"); i <= $5d51f81a4b917e73$var$cc("z"); i++)$5d51f81a4b917e73$var$wordCharCodes.push(i);
for(let i = $5d51f81a4b917e73$var$cc("A"); i <= $5d51f81a4b917e73$var$cc("Z"); i++)$5d51f81a4b917e73$var$wordCharCodes.push(i);
var $5d51f81a4b917e73$var$whitespaceCodes = [
    $5d51f81a4b917e73$var$cc(" "),
    $5d51f81a4b917e73$var$cc("\f"),
    $5d51f81a4b917e73$var$cc("\n"),
    $5d51f81a4b917e73$var$cc("\r"),
    $5d51f81a4b917e73$var$cc("	"),
    $5d51f81a4b917e73$var$cc("\v"),
    $5d51f81a4b917e73$var$cc("	"),
    $5d51f81a4b917e73$var$cc("\xA0"),
    $5d51f81a4b917e73$var$cc("\u1680"),
    $5d51f81a4b917e73$var$cc("\u2000"),
    $5d51f81a4b917e73$var$cc("\u2001"),
    $5d51f81a4b917e73$var$cc("\u2002"),
    $5d51f81a4b917e73$var$cc("\u2003"),
    $5d51f81a4b917e73$var$cc("\u2004"),
    $5d51f81a4b917e73$var$cc("\u2005"),
    $5d51f81a4b917e73$var$cc("\u2006"),
    $5d51f81a4b917e73$var$cc("\u2007"),
    $5d51f81a4b917e73$var$cc("\u2008"),
    $5d51f81a4b917e73$var$cc("\u2009"),
    $5d51f81a4b917e73$var$cc("\u200A"),
    $5d51f81a4b917e73$var$cc("\u2028"),
    $5d51f81a4b917e73$var$cc("\u2029"),
    $5d51f81a4b917e73$var$cc("\u202F"),
    $5d51f81a4b917e73$var$cc("\u205F"),
    $5d51f81a4b917e73$var$cc("\u3000"),
    $5d51f81a4b917e73$var$cc("\uFEFF")
];
// ../regexp-to-ast/lib/src/regexp-parser.js
var $5d51f81a4b917e73$var$hexDigitPattern = /[0-9a-fA-F]/;
var $5d51f81a4b917e73$var$decimalPattern = /[0-9]/;
var $5d51f81a4b917e73$var$decimalPatternNoZero = /[1-9]/;
var $5d51f81a4b917e73$var$RegExpParser = class {
    constructor(){
        this.idx = 0;
        this.input = "";
        this.groupIdx = 0;
    }
    saveState() {
        return {
            idx: this.idx,
            input: this.input,
            groupIdx: this.groupIdx
        };
    }
    restoreState(newState) {
        this.idx = newState.idx;
        this.input = newState.input;
        this.groupIdx = newState.groupIdx;
    }
    pattern(input) {
        this.idx = 0;
        this.input = input;
        this.groupIdx = 0;
        this.consumeChar("/");
        const value = this.disjunction();
        this.consumeChar("/");
        const flags = {
            type: "Flags",
            loc: {
                begin: this.idx,
                end: input.length
            },
            global: false,
            ignoreCase: false,
            multiLine: false,
            unicode: false,
            sticky: false
        };
        while(this.isRegExpFlag())switch(this.popChar()){
            case "g":
                $5d51f81a4b917e73$var$addFlag(flags, "global");
                break;
            case "i":
                $5d51f81a4b917e73$var$addFlag(flags, "ignoreCase");
                break;
            case "m":
                $5d51f81a4b917e73$var$addFlag(flags, "multiLine");
                break;
            case "u":
                $5d51f81a4b917e73$var$addFlag(flags, "unicode");
                break;
            case "y":
                $5d51f81a4b917e73$var$addFlag(flags, "sticky");
                break;
        }
        if (this.idx !== this.input.length) throw Error("Redundant input: " + this.input.substring(this.idx));
        return {
            type: "Pattern",
            flags: flags,
            value: value,
            loc: this.loc(0)
        };
    }
    disjunction() {
        const alts = [];
        const begin = this.idx;
        alts.push(this.alternative());
        while(this.peekChar() === "|"){
            this.consumeChar("|");
            alts.push(this.alternative());
        }
        return {
            type: "Disjunction",
            value: alts,
            loc: this.loc(begin)
        };
    }
    alternative() {
        const terms = [];
        const begin = this.idx;
        while(this.isTerm())terms.push(this.term());
        return {
            type: "Alternative",
            value: terms,
            loc: this.loc(begin)
        };
    }
    term() {
        if (this.isAssertion()) return this.assertion();
        else return this.atom();
    }
    assertion() {
        const begin = this.idx;
        switch(this.popChar()){
            case "^":
                return {
                    type: "StartAnchor",
                    loc: this.loc(begin)
                };
            case "$":
                return {
                    type: "EndAnchor",
                    loc: this.loc(begin)
                };
            // '\b' or '\B'
            case "\\":
                switch(this.popChar()){
                    case "b":
                        return {
                            type: "WordBoundary",
                            loc: this.loc(begin)
                        };
                    case "B":
                        return {
                            type: "NonWordBoundary",
                            loc: this.loc(begin)
                        };
                }
                throw Error("Invalid Assertion Escape");
            // '(?=' or '(?!'
            case "(":
                this.consumeChar("?");
                let type;
                switch(this.popChar()){
                    case "=":
                        type = "Lookahead";
                        break;
                    case "!":
                        type = "NegativeLookahead";
                        break;
                    case "<":
                        switch(this.popChar()){
                            case "=":
                                type = "Lookbehind";
                                break;
                            case "!":
                                type = "NegativeLookbehind";
                        }
                        break;
                }
                $5d51f81a4b917e73$var$ASSERT_EXISTS(type);
                const disjunction = this.disjunction();
                this.consumeChar(")");
                return {
                    type: type,
                    value: disjunction,
                    loc: this.loc(begin)
                };
        }
        return $5d51f81a4b917e73$var$ASSERT_NEVER_REACH_HERE();
    }
    quantifier(isBacktracking = false) {
        let range = void 0;
        const begin = this.idx;
        switch(this.popChar()){
            case "*":
                range = {
                    atLeast: 0,
                    atMost: Infinity
                };
                break;
            case "+":
                range = {
                    atLeast: 1,
                    atMost: Infinity
                };
                break;
            case "?":
                range = {
                    atLeast: 0,
                    atMost: 1
                };
                break;
            case "{":
                const atLeast = this.integerIncludingZero();
                switch(this.popChar()){
                    case "}":
                        range = {
                            atLeast: atLeast,
                            atMost: atLeast
                        };
                        break;
                    case ",":
                        let atMost;
                        if (this.isDigit()) {
                            atMost = this.integerIncludingZero();
                            range = {
                                atLeast: atLeast,
                                atMost: atMost
                            };
                        } else range = {
                            atLeast: atLeast,
                            atMost: Infinity
                        };
                        this.consumeChar("}");
                        break;
                }
                if (isBacktracking === true && range === void 0) return void 0;
                $5d51f81a4b917e73$var$ASSERT_EXISTS(range);
                break;
        }
        if (isBacktracking === true && range === void 0) return void 0;
        if ($5d51f81a4b917e73$var$ASSERT_EXISTS(range)) {
            if (this.peekChar(0) === "?") {
                this.consumeChar("?");
                range.greedy = false;
            } else range.greedy = true;
            range.type = "Quantifier";
            range.loc = this.loc(begin);
            return range;
        }
    }
    atom() {
        let atom;
        const begin = this.idx;
        switch(this.peekChar()){
            case ".":
                atom = this.dotAll();
                break;
            case "\\":
                atom = this.atomEscape();
                break;
            case "[":
                atom = this.characterClass();
                break;
            case "(":
                atom = this.group();
                break;
        }
        if (atom === void 0 && this.isPatternCharacter()) atom = this.patternCharacter();
        if ($5d51f81a4b917e73$var$ASSERT_EXISTS(atom)) {
            atom.loc = this.loc(begin);
            if (this.isQuantifier()) atom.quantifier = this.quantifier();
            return atom;
        }
        return $5d51f81a4b917e73$var$ASSERT_NEVER_REACH_HERE();
    }
    dotAll() {
        this.consumeChar(".");
        return {
            type: "Set",
            complement: true,
            value: [
                $5d51f81a4b917e73$var$cc("\n"),
                $5d51f81a4b917e73$var$cc("\r"),
                $5d51f81a4b917e73$var$cc("\u2028"),
                $5d51f81a4b917e73$var$cc("\u2029")
            ]
        };
    }
    atomEscape() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return this.decimalEscapeAtom();
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    }
    decimalEscapeAtom() {
        const value = this.positiveInteger();
        return {
            type: "GroupBackReference",
            value: value
        };
    }
    characterClassEscape() {
        let set;
        let complement = false;
        switch(this.popChar()){
            case "d":
                set = $5d51f81a4b917e73$var$digitsCharCodes;
                break;
            case "D":
                set = $5d51f81a4b917e73$var$digitsCharCodes;
                complement = true;
                break;
            case "s":
                set = $5d51f81a4b917e73$var$whitespaceCodes;
                break;
            case "S":
                set = $5d51f81a4b917e73$var$whitespaceCodes;
                complement = true;
                break;
            case "w":
                set = $5d51f81a4b917e73$var$wordCharCodes;
                break;
            case "W":
                set = $5d51f81a4b917e73$var$wordCharCodes;
                complement = true;
                break;
        }
        if ($5d51f81a4b917e73$var$ASSERT_EXISTS(set)) return {
            type: "Set",
            value: set,
            complement: complement
        };
        return $5d51f81a4b917e73$var$ASSERT_NEVER_REACH_HERE();
    }
    controlEscapeAtom() {
        let escapeCode;
        switch(this.popChar()){
            case "f":
                escapeCode = $5d51f81a4b917e73$var$cc("\f");
                break;
            case "n":
                escapeCode = $5d51f81a4b917e73$var$cc("\n");
                break;
            case "r":
                escapeCode = $5d51f81a4b917e73$var$cc("\r");
                break;
            case "t":
                escapeCode = $5d51f81a4b917e73$var$cc("	");
                break;
            case "v":
                escapeCode = $5d51f81a4b917e73$var$cc("\v");
                break;
        }
        if ($5d51f81a4b917e73$var$ASSERT_EXISTS(escapeCode)) return {
            type: "Character",
            value: escapeCode
        };
        return $5d51f81a4b917e73$var$ASSERT_NEVER_REACH_HERE();
    }
    controlLetterEscapeAtom() {
        this.consumeChar("c");
        const letter = this.popChar();
        if (/[a-zA-Z]/.test(letter) === false) throw Error("Invalid ");
        const letterCode = letter.toUpperCase().charCodeAt(0) - 64;
        return {
            type: "Character",
            value: letterCode
        };
    }
    nulCharacterAtom() {
        this.consumeChar("0");
        return {
            type: "Character",
            value: $5d51f81a4b917e73$var$cc("\0")
        };
    }
    hexEscapeSequenceAtom() {
        this.consumeChar("x");
        return this.parseHexDigits(2);
    }
    regExpUnicodeEscapeSequenceAtom() {
        this.consumeChar("u");
        return this.parseHexDigits(4);
    }
    identityEscapeAtom() {
        const escapedChar = this.popChar();
        return {
            type: "Character",
            value: $5d51f81a4b917e73$var$cc(escapedChar)
        };
    }
    classPatternCharacterAtom() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case "]":
                throw Error("TBD");
            default:
                const nextChar = this.popChar();
                return {
                    type: "Character",
                    value: $5d51f81a4b917e73$var$cc(nextChar)
                };
        }
    }
    characterClass() {
        const set = [];
        let complement = false;
        this.consumeChar("[");
        if (this.peekChar(0) === "^") {
            this.consumeChar("^");
            complement = true;
        }
        while(this.isClassAtom()){
            const from = this.classAtom();
            const isFromSingleChar = from.type === "Character";
            if ($5d51f81a4b917e73$var$isCharacter(from) && this.isRangeDash()) {
                this.consumeChar("-");
                const to = this.classAtom();
                const isToSingleChar = to.type === "Character";
                if ($5d51f81a4b917e73$var$isCharacter(to)) {
                    if (to.value < from.value) throw Error("Range out of order in character class");
                    set.push({
                        from: from.value,
                        to: to.value
                    });
                } else {
                    $5d51f81a4b917e73$var$insertToSet(from.value, set);
                    set.push($5d51f81a4b917e73$var$cc("-"));
                    $5d51f81a4b917e73$var$insertToSet(to.value, set);
                }
            } else $5d51f81a4b917e73$var$insertToSet(from.value, set);
        }
        this.consumeChar("]");
        return {
            type: "Set",
            complement: complement,
            value: set
        };
    }
    classAtom() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "]":
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
                throw Error("TBD");
            case "\\":
                return this.classEscape();
            default:
                return this.classPatternCharacterAtom();
        }
    }
    classEscape() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            // Matches a backspace.
            // (Not to be confused with \b word boundary outside characterClass)
            case "b":
                this.consumeChar("b");
                return {
                    type: "Character",
                    value: $5d51f81a4b917e73$var$cc("\b")
                };
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    }
    group() {
        let capturing = true;
        this.consumeChar("(");
        switch(this.peekChar(0)){
            case "?":
                this.consumeChar("?");
                this.consumeChar(":");
                capturing = false;
                break;
            default:
                this.groupIdx++;
                break;
        }
        const value = this.disjunction();
        this.consumeChar(")");
        const groupAst = {
            type: "Group",
            capturing: capturing,
            value: value
        };
        if (capturing) groupAst["idx"] = this.groupIdx;
        return groupAst;
    }
    positiveInteger() {
        let number = this.popChar();
        if ($5d51f81a4b917e73$var$decimalPatternNoZero.test(number) === false) throw Error("Expecting a positive integer");
        while($5d51f81a4b917e73$var$decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    }
    integerIncludingZero() {
        let number = this.popChar();
        if ($5d51f81a4b917e73$var$decimalPattern.test(number) === false) throw Error("Expecting an integer");
        while($5d51f81a4b917e73$var$decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    }
    patternCharacter() {
        const nextChar = this.popChar();
        switch(nextChar){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "^":
            // istanbul ignore next
            case "$":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case ".":
            // istanbul ignore next
            case "*":
            // istanbul ignore next
            case "+":
            // istanbul ignore next
            case "?":
            // istanbul ignore next
            case "(":
            // istanbul ignore next
            case ")":
            // istanbul ignore next
            case "[":
            // istanbul ignore next
            case "|":
                throw Error("TBD");
            default:
                return {
                    type: "Character",
                    value: $5d51f81a4b917e73$var$cc(nextChar)
                };
        }
    }
    isRegExpFlag() {
        switch(this.peekChar(0)){
            case "g":
            case "i":
            case "m":
            case "u":
            case "y":
                return true;
            default:
                return false;
        }
    }
    isRangeDash() {
        return this.peekChar() === "-" && this.isClassAtom(1);
    }
    isDigit() {
        return $5d51f81a4b917e73$var$decimalPattern.test(this.peekChar(0));
    }
    isClassAtom(howMuch = 0) {
        switch(this.peekChar(howMuch)){
            case "]":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    }
    isTerm() {
        return this.isAtom() || this.isAssertion();
    }
    isAtom() {
        if (this.isPatternCharacter()) return true;
        switch(this.peekChar(0)){
            case ".":
            case "\\":
            // atomEscape
            case "[":
            // characterClass
            // TODO: isAtom must be called before isAssertion - disambiguate
            case "(":
                return true;
            default:
                return false;
        }
    }
    isAssertion() {
        switch(this.peekChar(0)){
            case "^":
            case "$":
                return true;
            // '\b' or '\B'
            case "\\":
                switch(this.peekChar(1)){
                    case "b":
                    case "B":
                        return true;
                    default:
                        return false;
                }
            // '(?=' or '(?!' or `(?<=` or `(?<!`
            case "(":
                return this.peekChar(1) === "?" && (this.peekChar(2) === "=" || this.peekChar(2) === "!" || this.peekChar(2) === "<" && (this.peekChar(3) === "=" || this.peekChar(3) === "!"));
            default:
                return false;
        }
    }
    isQuantifier() {
        const prevState = this.saveState();
        try {
            return this.quantifier(true) !== void 0;
        } catch (e) {
            return false;
        } finally{
            this.restoreState(prevState);
        }
    }
    isPatternCharacter() {
        switch(this.peekChar()){
            case "^":
            case "$":
            case "\\":
            case ".":
            case "*":
            case "+":
            case "?":
            case "(":
            case ")":
            case "[":
            case "|":
            case "/":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    }
    parseHexDigits(howMany) {
        let hexString = "";
        for(let i = 0; i < howMany; i++){
            const hexChar = this.popChar();
            if ($5d51f81a4b917e73$var$hexDigitPattern.test(hexChar) === false) throw Error("Expecting a HexDecimal digits");
            hexString += hexChar;
        }
        const charCode = parseInt(hexString, 16);
        return {
            type: "Character",
            value: charCode
        };
    }
    peekChar(howMuch = 0) {
        return this.input[this.idx + howMuch];
    }
    popChar() {
        const nextChar = this.peekChar(0);
        this.consumeChar(void 0);
        return nextChar;
    }
    consumeChar(char) {
        if (char !== void 0 && this.input[this.idx] !== char) throw Error("Expected: '" + char + "' but found: '" + this.input[this.idx] + "' at offset: " + this.idx);
        if (this.idx >= this.input.length) throw Error("Unexpected end of input");
        this.idx++;
    }
    loc(begin) {
        return {
            begin: begin,
            end: this.idx
        };
    }
};
// ../regexp-to-ast/lib/src/base-regexp-visitor.js
var $5d51f81a4b917e73$var$BaseRegExpVisitor = class {
    visitChildren(node) {
        for(const key in node){
            const child = node[key];
            if (node.hasOwnProperty(key)) {
                if (child.type !== void 0) this.visit(child);
                else if (Array.isArray(child)) child.forEach((subChild)=>{
                    this.visit(subChild);
                }, this);
            }
        }
    }
    visit(node) {
        switch(node.type){
            case "Pattern":
                this.visitPattern(node);
                break;
            case "Flags":
                this.visitFlags(node);
                break;
            case "Disjunction":
                this.visitDisjunction(node);
                break;
            case "Alternative":
                this.visitAlternative(node);
                break;
            case "StartAnchor":
                this.visitStartAnchor(node);
                break;
            case "EndAnchor":
                this.visitEndAnchor(node);
                break;
            case "WordBoundary":
                this.visitWordBoundary(node);
                break;
            case "NonWordBoundary":
                this.visitNonWordBoundary(node);
                break;
            case "Lookahead":
                this.visitLookahead(node);
                break;
            case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                break;
            case "Lookbehind":
                this.visitLookbehind(node);
                break;
            case "NegativeLookbehind":
                this.visitNegativeLookbehind(node);
                break;
            case "Character":
                this.visitCharacter(node);
                break;
            case "Set":
                this.visitSet(node);
                break;
            case "Group":
                this.visitGroup(node);
                break;
            case "GroupBackReference":
                this.visitGroupBackReference(node);
                break;
            case "Quantifier":
                this.visitQuantifier(node);
                break;
        }
        this.visitChildren(node);
    }
    visitPattern(node) {}
    visitFlags(node) {}
    visitDisjunction(node) {}
    visitAlternative(node) {}
    // Assertion
    visitStartAnchor(node) {}
    visitEndAnchor(node) {}
    visitWordBoundary(node) {}
    visitNonWordBoundary(node) {}
    visitLookahead(node) {}
    visitNegativeLookahead(node) {}
    visitLookbehind(node) {}
    visitNegativeLookbehind(node) {}
    // atoms
    visitCharacter(node) {}
    visitSet(node) {}
    visitGroup(node) {}
    visitGroupBackReference(node) {}
    visitQuantifier(node) {}
};
// lib/src/scan/reg_exp_parser.js
var $5d51f81a4b917e73$var$regExpAstCache = {};
var $5d51f81a4b917e73$var$regExpParser = new $5d51f81a4b917e73$var$RegExpParser();
function $5d51f81a4b917e73$var$getRegExpAst(regExp) {
    const regExpStr = regExp.toString();
    if ($5d51f81a4b917e73$var$regExpAstCache.hasOwnProperty(regExpStr)) return $5d51f81a4b917e73$var$regExpAstCache[regExpStr];
    else {
        const regExpAst = $5d51f81a4b917e73$var$regExpParser.pattern(regExpStr);
        $5d51f81a4b917e73$var$regExpAstCache[regExpStr] = regExpAst;
        return regExpAst;
    }
}
function $5d51f81a4b917e73$var$clearRegExpParserCache() {
    $5d51f81a4b917e73$var$regExpAstCache = {};
}
// lib/src/scan/reg_exp.js
var $5d51f81a4b917e73$var$complementErrorMessage = "Complement Sets are not supported for first char optimization";
var $5d51f81a4b917e73$var$failedOptimizationPrefixMsg = 'Unable to use "first char" lexer optimizations:\n';
function $5d51f81a4b917e73$var$getOptimizedStartCodesIndices(regExp, ensureOptimizations = false) {
    try {
        const ast = $5d51f81a4b917e73$var$getRegExpAst(regExp);
        const firstChars = $5d51f81a4b917e73$var$firstCharOptimizedIndices(ast.value, {}, ast.flags.ignoreCase);
        return firstChars;
    } catch (e) {
        if (e.message === $5d51f81a4b917e73$var$complementErrorMessage) {
            if (ensureOptimizations) $5d51f81a4b917e73$var$PRINT_WARNING(`${$5d51f81a4b917e73$var$failedOptimizationPrefixMsg}	Unable to optimize: < ${regExp.toString()} >
	Complement Sets cannot be automatically optimized.
	This will disable the lexer's first char optimizations.
	See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#COMPLEMENT for details.`);
        } else {
            let msgSuffix = "";
            if (ensureOptimizations) msgSuffix = "\n	This will disable the lexer's first char optimizations.\n	See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#REGEXP_PARSING for details.";
            $5d51f81a4b917e73$var$PRINT_ERROR(`${$5d51f81a4b917e73$var$failedOptimizationPrefixMsg}
	Failed parsing: < ${regExp.toString()} >
	Using the @chevrotain/regexp-to-ast library
	Please open an issue at: https://github.com/chevrotain/chevrotain/issues` + msgSuffix);
        }
    }
    return [];
}
function $5d51f81a4b917e73$var$firstCharOptimizedIndices(ast, result, ignoreCase) {
    switch(ast.type){
        case "Disjunction":
            for(let i = 0; i < ast.value.length; i++)$5d51f81a4b917e73$var$firstCharOptimizedIndices(ast.value[i], result, ignoreCase);
            break;
        case "Alternative":
            const terms = ast.value;
            for(let i = 0; i < terms.length; i++){
                const term = terms[i];
                switch(term.type){
                    case "EndAnchor":
                    // A group back reference cannot affect potential starting char.
                    // because if a back reference is the first production than automatically
                    // the group being referenced has had to come BEFORE so its codes have already been added
                    case "GroupBackReference":
                    // assertions do not affect potential starting codes
                    case "Lookahead":
                    case "NegativeLookahead":
                    case "Lookbehind":
                    case "NegativeLookbehind":
                    case "StartAnchor":
                    case "WordBoundary":
                    case "NonWordBoundary":
                        continue;
                }
                const atom = term;
                switch(atom.type){
                    case "Character":
                        $5d51f81a4b917e73$var$addOptimizedIdxToResult(atom.value, result, ignoreCase);
                        break;
                    case "Set":
                        if (atom.complement === true) throw Error($5d51f81a4b917e73$var$complementErrorMessage);
                        atom.value.forEach((code)=>{
                            if (typeof code === "number") $5d51f81a4b917e73$var$addOptimizedIdxToResult(code, result, ignoreCase);
                            else {
                                const range = code;
                                if (ignoreCase === true) for(let rangeCode = range.from; rangeCode <= range.to; rangeCode++)$5d51f81a4b917e73$var$addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                                else {
                                    for(let rangeCode = range.from; rangeCode <= range.to && rangeCode < $5d51f81a4b917e73$var$minOptimizationVal; rangeCode++)$5d51f81a4b917e73$var$addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                                    if (range.to >= $5d51f81a4b917e73$var$minOptimizationVal) {
                                        const minUnOptVal = range.from >= $5d51f81a4b917e73$var$minOptimizationVal ? range.from : $5d51f81a4b917e73$var$minOptimizationVal;
                                        const maxUnOptVal = range.to;
                                        const minOptIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(minUnOptVal);
                                        const maxOptIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(maxUnOptVal);
                                        for(let currOptIdx = minOptIdx; currOptIdx <= maxOptIdx; currOptIdx++)result[currOptIdx] = currOptIdx;
                                    }
                                }
                            }
                        });
                        break;
                    case "Group":
                        $5d51f81a4b917e73$var$firstCharOptimizedIndices(atom.value, result, ignoreCase);
                        break;
                    /* istanbul ignore next */ default:
                        throw Error("Non Exhaustive Match");
                }
                const isOptionalQuantifier = atom.quantifier !== void 0 && atom.quantifier.atLeast === 0;
                if (// A group may be optional due to empty contents /(?:)/
                // or if everything inside it is optional /((a)?)/
                atom.type === "Group" && $5d51f81a4b917e73$var$isWholeOptional(atom) === false || // If this term is not a group it may only be optional if it has an optional quantifier
                atom.type !== "Group" && isOptionalQuantifier === false) break;
            }
            break;
        /* istanbul ignore next */ default:
            throw Error("non exhaustive match!");
    }
    return Object.values(result);
}
function $5d51f81a4b917e73$var$addOptimizedIdxToResult(code, result, ignoreCase) {
    const optimizedCharIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(code);
    result[optimizedCharIdx] = optimizedCharIdx;
    if (ignoreCase === true) $5d51f81a4b917e73$var$handleIgnoreCase(code, result);
}
function $5d51f81a4b917e73$var$handleIgnoreCase(code, result) {
    const char = String.fromCharCode(code);
    const upperChar = char.toUpperCase();
    if (upperChar !== char) {
        const optimizedCharIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(upperChar.charCodeAt(0));
        result[optimizedCharIdx] = optimizedCharIdx;
    } else {
        const lowerChar = char.toLowerCase();
        if (lowerChar !== char) {
            const optimizedCharIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(lowerChar.charCodeAt(0));
            result[optimizedCharIdx] = optimizedCharIdx;
        }
    }
}
function $5d51f81a4b917e73$var$findCode(setNode, targetCharCodes) {
    return setNode.value.find((codeOrRange)=>{
        if (typeof codeOrRange === "number") return targetCharCodes.includes(codeOrRange);
        else {
            const range = codeOrRange;
            return targetCharCodes.find((targetCode)=>range.from <= targetCode && targetCode <= range.to) !== void 0;
        }
    });
}
function $5d51f81a4b917e73$var$isWholeOptional(ast) {
    const quantifier = ast.quantifier;
    if (quantifier && quantifier.atLeast === 0) return true;
    if (!ast.value) return false;
    return Array.isArray(ast.value) ? ast.value.every($5d51f81a4b917e73$var$isWholeOptional) : $5d51f81a4b917e73$var$isWholeOptional(ast.value);
}
var $5d51f81a4b917e73$var$CharCodeFinder = class extends $5d51f81a4b917e73$var$BaseRegExpVisitor {
    constructor(targetCharCodes){
        super();
        this.targetCharCodes = targetCharCodes;
        this.found = false;
    }
    visitChildren(node) {
        if (this.found === true) return;
        switch(node.type){
            case "Lookahead":
                this.visitLookahead(node);
                return;
            case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                return;
            case "Lookbehind":
                this.visitLookbehind(node);
                return;
            case "NegativeLookbehind":
                this.visitNegativeLookbehind(node);
                return;
        }
        super.visitChildren(node);
    }
    visitCharacter(node) {
        if (this.targetCharCodes.includes(node.value)) this.found = true;
    }
    visitSet(node) {
        if (node.complement) {
            if ($5d51f81a4b917e73$var$findCode(node, this.targetCharCodes) === void 0) this.found = true;
        } else if ($5d51f81a4b917e73$var$findCode(node, this.targetCharCodes) !== void 0) this.found = true;
    }
};
function $5d51f81a4b917e73$var$canMatchCharCode(charCodes, pattern) {
    if (pattern instanceof RegExp) {
        const ast = $5d51f81a4b917e73$var$getRegExpAst(pattern);
        const charCodeFinder = new $5d51f81a4b917e73$var$CharCodeFinder(charCodes);
        charCodeFinder.visit(ast);
        return charCodeFinder.found;
    } else {
        for (const char of pattern){
            const charCode = char.charCodeAt(0);
            if (charCodes.includes(charCode)) return true;
        }
        return false;
    }
}
// lib/src/scan/lexer.js
var $5d51f81a4b917e73$var$PATTERN = "PATTERN";
var $5d51f81a4b917e73$var$DEFAULT_MODE = "defaultMode";
var $5d51f81a4b917e73$var$MODES = "modes";
var $5d51f81a4b917e73$var$SINGLE_CHAR_MATCH = 0;
var $5d51f81a4b917e73$var$CUSTOM_MATCH = 1;
var $5d51f81a4b917e73$var$REG_EXP_MATCH = 2;
var $5d51f81a4b917e73$var$ASCII_CLASS_MATCH = 3;
function $5d51f81a4b917e73$var$analyzeTokenTypes(tokenTypes, options) {
    options = Object.assign({
        safeMode: false,
        positionTracking: "full",
        lineTerminatorCharacters: [
            "\r",
            "\n"
        ],
        tracer: (msg, action)=>action()
    }, options);
    const tracer = options.tracer;
    tracer("initCharCodeToOptimizedIndexMap", ()=>{
        $5d51f81a4b917e73$var$initCharCodeToOptimizedIndexMap();
    });
    let onlyRelevantTypes;
    tracer("Reject Lexer.NA", ()=>{
        onlyRelevantTypes = tokenTypes.filter((currType)=>{
            return currType[$5d51f81a4b917e73$var$PATTERN] !== $5d51f81a4b917e73$export$6168dc8908a6c652.NA;
        });
    });
    let hasCustom = false;
    let allTransformedPatterns;
    tracer("Transform Patterns", ()=>{
        hasCustom = false;
        allTransformedPatterns = onlyRelevantTypes.map((currType)=>{
            const currPattern = currType[$5d51f81a4b917e73$var$PATTERN];
            if (currPattern instanceof RegExp) {
                const regExpSource = currPattern.source;
                if (regExpSource.length === 1 && // only these regExp meta characters which can appear in a length one regExp
                regExpSource !== "^" && regExpSource !== "$" && regExpSource !== "." && !currPattern.ignoreCase) return regExpSource;
                else if (regExpSource.length === 2 && regExpSource[0] === "\\" && // not a meta character
                ![
                    "d",
                    "D",
                    "s",
                    "S",
                    "t",
                    "r",
                    "n",
                    "t",
                    "0",
                    "c",
                    "b",
                    "B",
                    "f",
                    "v",
                    "w",
                    "W"
                ].includes(regExpSource[1])) return regExpSource[1];
                else return $5d51f81a4b917e73$var$addStickyFlag(currPattern);
            } else if (typeof currPattern === "function") {
                hasCustom = true;
                return {
                    exec: currPattern
                };
            } else if (typeof currPattern === "object") {
                hasCustom = true;
                return currPattern;
            } else if (typeof currPattern === "string") {
                if (currPattern.length === 1) return currPattern;
                else {
                    const escapedRegExpString = currPattern.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
                    const wrappedRegExp = new RegExp(escapedRegExpString);
                    return $5d51f81a4b917e73$var$addStickyFlag(wrappedRegExp);
                }
            } else throw Error("non exhaustive match");
        });
    });
    let patternIdxToType;
    let patternIdxToGroup;
    let patternIdxToLongerAltIdxArr;
    let patternIdxToPushMode;
    let patternIdxToPopMode;
    tracer("misc mapping", ()=>{
        patternIdxToType = onlyRelevantTypes.map((currType)=>currType.tokenTypeIdx);
        patternIdxToGroup = onlyRelevantTypes.map((clazz)=>{
            const groupName = clazz.GROUP;
            if (groupName === $5d51f81a4b917e73$export$6168dc8908a6c652.SKIPPED) return void 0;
            else if (typeof groupName === "string") return groupName;
            else if (groupName === void 0) return false;
            else throw Error("non exhaustive match");
        });
        patternIdxToLongerAltIdxArr = onlyRelevantTypes.map((clazz)=>{
            const longerAltType = clazz.LONGER_ALT;
            if (longerAltType) {
                const longerAltIdxArr = Array.isArray(longerAltType) ? longerAltType.map((type)=>onlyRelevantTypes.indexOf(type)) : [
                    onlyRelevantTypes.indexOf(longerAltType)
                ];
                return longerAltIdxArr;
            }
        });
        patternIdxToPushMode = onlyRelevantTypes.map((clazz)=>clazz.PUSH_MODE);
        patternIdxToPopMode = onlyRelevantTypes.map((clazz)=>Object.hasOwn(clazz, "POP_MODE"));
    });
    let patternIdxToCanLineTerminator;
    tracer("Line Terminator Handling", ()=>{
        const lineTerminatorCharCodes = $5d51f81a4b917e73$var$getCharCodes(options.lineTerminatorCharacters);
        patternIdxToCanLineTerminator = onlyRelevantTypes.map((tokType)=>false);
        if (options.positionTracking !== "onlyOffset") patternIdxToCanLineTerminator = onlyRelevantTypes.map((tokType)=>{
            if (Object.hasOwn(tokType, "LINE_BREAKS")) return !!tokType.LINE_BREAKS;
            else return $5d51f81a4b917e73$var$checkLineBreaksIssues(tokType, lineTerminatorCharCodes) === false && $5d51f81a4b917e73$var$canMatchCharCode(lineTerminatorCharCodes, tokType.PATTERN);
        });
    });
    let patternIdxToIsCustom;
    let patternIdxToShort;
    let emptyGroups;
    let patternIdxToConfig;
    tracer("Misc Mapping #2", ()=>{
        patternIdxToIsCustom = onlyRelevantTypes.map($5d51f81a4b917e73$var$isCustomPattern);
        patternIdxToShort = allTransformedPatterns.map($5d51f81a4b917e73$var$isShortPattern);
        emptyGroups = onlyRelevantTypes.reduce((acc, clazz)=>{
            const groupName = clazz.GROUP;
            if (typeof groupName === "string" && !(groupName === $5d51f81a4b917e73$export$6168dc8908a6c652.SKIPPED)) acc[groupName] = [];
            return acc;
        }, {});
        patternIdxToConfig = allTransformedPatterns.map((x, idx)=>{
            const asciiClass = patternIdxToGroup[idx] === void 0 && patternIdxToLongerAltIdxArr[idx] === void 0 ? $5d51f81a4b917e73$var$getAsciiClass(onlyRelevantTypes[idx].PATTERN) : void 0;
            return {
                pattern: allTransformedPatterns[idx],
                asciiClass: asciiClass,
                longerAlt: patternIdxToLongerAltIdxArr[idx],
                canLineTerminator: patternIdxToCanLineTerminator[idx],
                matchType: asciiClass !== void 0 ? $5d51f81a4b917e73$var$ASCII_CLASS_MATCH : patternIdxToShort[idx] !== false ? $5d51f81a4b917e73$var$SINGLE_CHAR_MATCH : patternIdxToIsCustom[idx] ? $5d51f81a4b917e73$var$CUSTOM_MATCH : $5d51f81a4b917e73$var$REG_EXP_MATCH,
                short: patternIdxToShort[idx],
                group: patternIdxToGroup[idx],
                push: patternIdxToPushMode[idx],
                pop: patternIdxToPopMode[idx],
                tokenTypeIdx: patternIdxToType[idx],
                tokenType: onlyRelevantTypes[idx]
            };
        });
    });
    let canBeOptimized = true;
    let charCodeToPatternIdxToConfig = [];
    if (!options.safeMode) tracer("First Char Optimization", ()=>{
        charCodeToPatternIdxToConfig = onlyRelevantTypes.reduce((result, currTokType, idx)=>{
            if (typeof currTokType.PATTERN === "string") {
                const charCode = currTokType.PATTERN.charCodeAt(0);
                const optimizedIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(charCode);
                $5d51f81a4b917e73$var$addToMapOfArrays(result, optimizedIdx, patternIdxToConfig[idx]);
            } else if (Array.isArray(currTokType.START_CHARS_HINT)) {
                let lastOptimizedIdx;
                currTokType.START_CHARS_HINT.forEach((charOrInt)=>{
                    const charCode = typeof charOrInt === "string" ? charOrInt.charCodeAt(0) : charOrInt;
                    const currOptimizedIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(charCode);
                    if (lastOptimizedIdx !== currOptimizedIdx) {
                        lastOptimizedIdx = currOptimizedIdx;
                        $5d51f81a4b917e73$var$addToMapOfArrays(result, currOptimizedIdx, patternIdxToConfig[idx]);
                    }
                });
            } else if (currTokType.PATTERN instanceof RegExp) {
                if (currTokType.PATTERN.unicode) {
                    canBeOptimized = false;
                    if (options.ensureOptimizations) $5d51f81a4b917e73$var$PRINT_ERROR(`${$5d51f81a4b917e73$var$failedOptimizationPrefixMsg}	Unable to analyze < ${currTokType.PATTERN.toString()} > pattern.
	The regexp unicode flag is not currently supported by the regexp-to-ast library.
	This will disable the lexer's first char optimizations.
	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#UNICODE_OPTIMIZE`);
                } else {
                    const optimizedCodes = $5d51f81a4b917e73$var$getOptimizedStartCodesIndices(currTokType.PATTERN, options.ensureOptimizations);
                    if (optimizedCodes.length === 0) canBeOptimized = false;
                    optimizedCodes.forEach((code)=>{
                        $5d51f81a4b917e73$var$addToMapOfArrays(result, code, patternIdxToConfig[idx]);
                    });
                }
            } else {
                if (options.ensureOptimizations) $5d51f81a4b917e73$var$PRINT_ERROR(`${$5d51f81a4b917e73$var$failedOptimizationPrefixMsg}	TokenType: <${currTokType.name}> is using a custom token pattern without providing <start_chars_hint> parameter.
	This will disable the lexer's first char optimizations.
	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#CUSTOM_OPTIMIZE`);
                canBeOptimized = false;
            }
            return result;
        }, []);
    });
    return {
        emptyGroups: emptyGroups,
        patternIdxToConfig: patternIdxToConfig,
        charCodeToPatternIdxToConfig: charCodeToPatternIdxToConfig,
        hasCustom: hasCustom,
        canBeOptimized: canBeOptimized
    };
}
function $5d51f81a4b917e73$var$getAsciiClass(pattern) {
    var _a, _b;
    if (!(pattern instanceof RegExp) || pattern.flags !== "") return void 0;
    let ast;
    try {
        ast = $5d51f81a4b917e73$var$getRegExpAst(pattern);
    } catch (_c) {
        return void 0;
    }
    if (ast.value.value.length !== 1 || ast.value.value[0].value.length !== 1) return void 0;
    let atom = ast.value.value[0].value[0];
    let quantifier;
    while(atom.type === "Group"){
        if (atom.capturing || atom.quantifier !== void 0 && quantifier !== void 0 || atom.value.value.length !== 1 || atom.value.value[0].value.length !== 1) return void 0;
        quantifier = (_a = atom.quantifier) !== null && _a !== void 0 ? _a : quantifier;
        atom = atom.value.value[0].value[0];
    }
    if (atom.type !== "Set" || atom.complement || atom.quantifier !== void 0 && quantifier !== void 0) return void 0;
    quantifier = (_b = atom.quantifier) !== null && _b !== void 0 ? _b : quantifier;
    if ((quantifier === null || quantifier === void 0 ? void 0 : quantifier.atLeast) !== 1 || quantifier.atMost !== Infinity || !quantifier.greedy) return void 0;
    const result = new Uint8Array(128);
    for (const item of atom.value){
        const from = typeof item === "number" ? item : item.from;
        const to = typeof item === "number" ? item : item.to;
        if (from < 0 || to >= result.length) return void 0;
        result.fill(1, from, to + 1);
    }
    return result;
}
function $5d51f81a4b917e73$var$validatePatterns(tokenTypes, validModesNames) {
    let errors = [];
    const missingResult = $5d51f81a4b917e73$var$findMissingPatterns(tokenTypes);
    errors = errors.concat(missingResult.errors);
    const invalidResult = $5d51f81a4b917e73$var$findInvalidPatterns(missingResult.valid);
    const validTokenTypes = invalidResult.valid;
    errors = errors.concat(invalidResult.errors);
    errors = errors.concat($5d51f81a4b917e73$var$validateRegExpPattern(validTokenTypes));
    errors = errors.concat($5d51f81a4b917e73$var$findInvalidGroupType(validTokenTypes));
    errors = errors.concat($5d51f81a4b917e73$var$findModesThatDoNotExist(validTokenTypes, validModesNames));
    errors = errors.concat($5d51f81a4b917e73$var$findUnreachablePatterns(validTokenTypes));
    return errors;
}
function $5d51f81a4b917e73$var$validateRegExpPattern(tokenTypes) {
    let errors = [];
    const withRegExpPatterns = tokenTypes.filter((currTokType)=>currTokType[$5d51f81a4b917e73$var$PATTERN] instanceof RegExp);
    errors = errors.concat($5d51f81a4b917e73$var$findEndOfInputAnchor(withRegExpPatterns));
    errors = errors.concat($5d51f81a4b917e73$var$findStartOfInputAnchor(withRegExpPatterns));
    errors = errors.concat($5d51f81a4b917e73$var$findUnsupportedFlags(withRegExpPatterns));
    errors = errors.concat($5d51f81a4b917e73$var$findDuplicatePatterns(withRegExpPatterns));
    errors = errors.concat($5d51f81a4b917e73$var$findEmptyMatchRegExps(withRegExpPatterns));
    return errors;
}
function $5d51f81a4b917e73$var$findMissingPatterns(tokenTypes) {
    const tokenTypesWithMissingPattern = tokenTypes.filter((currType)=>{
        return !Object.hasOwn(currType, $5d51f81a4b917e73$var$PATTERN);
    });
    const errors = tokenTypesWithMissingPattern.map((currType)=>{
        return {
            message: "Token Type: ->" + currType.name + "<- missing static 'PATTERN' property",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.MISSING_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    const valid = tokenTypes.filter((x)=>!tokenTypesWithMissingPattern.includes(x));
    return {
        errors: errors,
        valid: valid
    };
}
function $5d51f81a4b917e73$var$findInvalidPatterns(tokenTypes) {
    const tokenTypesWithInvalidPattern = tokenTypes.filter((currType)=>{
        const pattern = currType[$5d51f81a4b917e73$var$PATTERN];
        return !(pattern instanceof RegExp) && !(typeof pattern === "function") && !Object.hasOwn(pattern, "exec") && !(typeof pattern === "string");
    });
    const errors = tokenTypesWithInvalidPattern.map((currType)=>{
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' can only be a RegExp, a Function matching the {CustomPatternMatcherFunc} type or an Object matching the {ICustomPattern} interface.",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.INVALID_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    const valid = tokenTypes.filter((x)=>!tokenTypesWithInvalidPattern.includes(x));
    return {
        errors: errors,
        valid: valid
    };
}
var $5d51f81a4b917e73$var$end_of_input = /[^\\][$]/;
function $5d51f81a4b917e73$var$findEndOfInputAnchor(tokenTypes) {
    class EndAnchorFinder extends $5d51f81a4b917e73$var$BaseRegExpVisitor {
        constructor(){
            super(...arguments);
            this.found = false;
        }
        visitEndAnchor(node) {
            this.found = true;
        }
    }
    const invalidRegex = tokenTypes.filter((currType)=>{
        const pattern = currType.PATTERN;
        try {
            const regexpAst = $5d51f81a4b917e73$var$getRegExpAst(pattern);
            const endAnchorVisitor = new EndAnchorFinder();
            endAnchorVisitor.visit(regexpAst);
            return endAnchorVisitor.found;
        } catch (e) {
            return $5d51f81a4b917e73$var$end_of_input.test(pattern.source);
        }
    });
    const errors = invalidRegex.map((currType)=>{
        return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain end of input anchor '$'\n	See chevrotain.io/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.EOI_ANCHOR_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findEmptyMatchRegExps(tokenTypes) {
    const matchesEmptyString = tokenTypes.filter((currType)=>{
        const pattern = currType.PATTERN;
        return pattern.test("");
    });
    const errors = matchesEmptyString.map((currType)=>{
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' must not match an empty string",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.EMPTY_MATCH_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
var $5d51f81a4b917e73$var$start_of_input = /[^\\[][\^]|^\^/;
function $5d51f81a4b917e73$var$findStartOfInputAnchor(tokenTypes) {
    class StartAnchorFinder extends $5d51f81a4b917e73$var$BaseRegExpVisitor {
        constructor(){
            super(...arguments);
            this.found = false;
        }
        visitStartAnchor(node) {
            this.found = true;
        }
    }
    const invalidRegex = tokenTypes.filter((currType)=>{
        const pattern = currType.PATTERN;
        try {
            const regexpAst = $5d51f81a4b917e73$var$getRegExpAst(pattern);
            const startAnchorVisitor = new StartAnchorFinder();
            startAnchorVisitor.visit(regexpAst);
            return startAnchorVisitor.found;
        } catch (e) {
            return $5d51f81a4b917e73$var$start_of_input.test(pattern.source);
        }
    });
    const errors = invalidRegex.map((currType)=>{
        return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain start of input anchor '^'\n	See https://chevrotain.io/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.SOI_ANCHOR_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findUnsupportedFlags(tokenTypes) {
    const invalidFlags = tokenTypes.filter((currType)=>{
        const pattern = currType[$5d51f81a4b917e73$var$PATTERN];
        return pattern instanceof RegExp && (pattern.multiline || pattern.global);
    });
    const errors = invalidFlags.map((currType)=>{
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' may NOT contain global('g') or multiline('m')",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.UNSUPPORTED_FLAGS_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findDuplicatePatterns(tokenTypes) {
    const found = [];
    let identicalPatterns = tokenTypes.map((outerType)=>{
        return tokenTypes.reduce((result, innerType)=>{
            if (outerType.PATTERN.source === innerType.PATTERN.source && !found.includes(innerType) && innerType.PATTERN !== $5d51f81a4b917e73$export$6168dc8908a6c652.NA) {
                found.push(innerType);
                result.push(innerType);
                return result;
            }
            return result;
        }, []);
    });
    identicalPatterns = identicalPatterns.filter(Boolean);
    const duplicatePatterns = identicalPatterns.filter((currIdenticalSet)=>{
        return currIdenticalSet.length > 1;
    });
    const errors = duplicatePatterns.map((setOfIdentical)=>{
        const tokenTypeNames = setOfIdentical.map((currType)=>{
            return currType.name;
        });
        const dupPatternSrc = setOfIdentical[0].PATTERN;
        return {
            message: `The same RegExp pattern ->${dupPatternSrc}<-has been used in all of the following Token Types: ${tokenTypeNames.join(", ")} <-`,
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.DUPLICATE_PATTERNS_FOUND,
            tokenTypes: setOfIdentical
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findInvalidGroupType(tokenTypes) {
    const invalidTypes = tokenTypes.filter((clazz)=>{
        if (!Object.hasOwn(clazz, "GROUP")) return false;
        const group = clazz.GROUP;
        return group !== $5d51f81a4b917e73$export$6168dc8908a6c652.SKIPPED && group !== $5d51f81a4b917e73$export$6168dc8908a6c652.NA && !(typeof group === "string");
    });
    const errors = invalidTypes.map((currType)=>{
        return {
            message: "Token Type: ->" + currType.name + "<- static 'GROUP' can only be Lexer.SKIPPED/Lexer.NA/A String",
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.INVALID_GROUP_TYPE_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findModesThatDoNotExist(tokenTypes, validModes) {
    const invalidModes = tokenTypes.filter((clazz)=>{
        return clazz.PUSH_MODE !== void 0 && !validModes.includes(clazz.PUSH_MODE);
    });
    const errors = invalidModes.map((tokType)=>{
        const msg = `Token Type: ->${tokType.name}<- static 'PUSH_MODE' value cannot refer to a Lexer Mode ->${tokType.PUSH_MODE}<-which does not exist`;
        return {
            message: msg,
            type: $5d51f81a4b917e73$export$75fe8082c000e4d9.PUSH_MODE_DOES_NOT_EXIST,
            tokenTypes: [
                tokType
            ]
        };
    });
    return errors;
}
function $5d51f81a4b917e73$var$findUnreachablePatterns(tokenTypes) {
    const errors = [];
    const canBeTested = tokenTypes.reduce((result, tokType, idx)=>{
        const pattern = tokType.PATTERN;
        if (pattern === $5d51f81a4b917e73$export$6168dc8908a6c652.NA) return result;
        if (typeof pattern === "string") result.push({
            str: pattern,
            idx: idx,
            tokenType: tokType
        });
        else if (pattern instanceof RegExp && $5d51f81a4b917e73$var$noMetaChar(pattern)) result.push({
            str: pattern.source,
            idx: idx,
            tokenType: tokType
        });
        return result;
    }, []);
    tokenTypes.forEach((aTokType, aIdx)=>{
        canBeTested.forEach(({ str: bStr, idx: bIdx, tokenType: bTokType })=>{
            if (aIdx < bIdx && $5d51f81a4b917e73$var$tryToMatchStrToPattern(bStr, aTokType.PATTERN)) {
                const msg = `Token: ->${bTokType.name}<- can never be matched.
Because it appears AFTER the Token Type ->${aTokType.name}<-in the lexer's definition.
See https://chevrotain.io/docs/guide/resolving_lexer_errors.html#UNREACHABLE`;
                errors.push({
                    message: msg,
                    type: $5d51f81a4b917e73$export$75fe8082c000e4d9.UNREACHABLE_PATTERN,
                    tokenTypes: [
                        aTokType,
                        bTokType
                    ]
                });
            }
        });
    });
    return errors;
}
function $5d51f81a4b917e73$var$tryToMatchStrToPattern(str, pattern) {
    if (pattern instanceof RegExp) {
        if ($5d51f81a4b917e73$var$usesLookAheadOrBehind(pattern)) return false;
        const regExpArray = pattern.exec(str);
        return regExpArray !== null && regExpArray.index === 0;
    } else if (typeof pattern === "function") return pattern(str, 0, [], {});
    else if (Object.hasOwn(pattern, "exec")) return pattern.exec(str, 0, [], {});
    else if (typeof pattern === "string") return pattern === str;
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$var$noMetaChar(regExp) {
    const metaChars = [
        ".",
        "\\",
        "[",
        "]",
        "|",
        "^",
        "$",
        "(",
        ")",
        "?",
        "*",
        "+",
        "{"
    ];
    return metaChars.find((char)=>regExp.source.indexOf(char) !== -1) === void 0;
}
function $5d51f81a4b917e73$var$usesLookAheadOrBehind(regExp) {
    return /(\(\?=)|(\(\?!)|(\(\?<=)|(\(\?<!)/.test(regExp.source);
}
function $5d51f81a4b917e73$var$addStickyFlag(pattern) {
    const flags = pattern.ignoreCase ? "iy" : "y";
    return new RegExp(`${pattern.source}`, flags);
}
function $5d51f81a4b917e73$var$performRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
    const errors = [];
    if (!Object.hasOwn(lexerDefinition, $5d51f81a4b917e73$var$DEFAULT_MODE)) errors.push({
        message: "A MultiMode Lexer cannot be initialized without a <" + $5d51f81a4b917e73$var$DEFAULT_MODE + "> property in its definition\n",
        type: $5d51f81a4b917e73$export$75fe8082c000e4d9.MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE
    });
    if (!Object.hasOwn(lexerDefinition, $5d51f81a4b917e73$var$MODES)) errors.push({
        message: "A MultiMode Lexer cannot be initialized without a <" + $5d51f81a4b917e73$var$MODES + "> property in its definition\n",
        type: $5d51f81a4b917e73$export$75fe8082c000e4d9.MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY
    });
    if (Object.hasOwn(lexerDefinition, $5d51f81a4b917e73$var$MODES) && Object.hasOwn(lexerDefinition, $5d51f81a4b917e73$var$DEFAULT_MODE) && !Object.hasOwn(lexerDefinition.modes, lexerDefinition.defaultMode)) errors.push({
        message: `A MultiMode Lexer cannot be initialized with a ${$5d51f81a4b917e73$var$DEFAULT_MODE}: <${lexerDefinition.defaultMode}>which does not exist
`,
        type: $5d51f81a4b917e73$export$75fe8082c000e4d9.MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST
    });
    if (Object.hasOwn(lexerDefinition, $5d51f81a4b917e73$var$MODES)) Object.keys(lexerDefinition.modes).forEach((currModeName)=>{
        const currModeValue = lexerDefinition.modes[currModeName];
        currModeValue.forEach((currTokType, currIdx)=>{
            if (currTokType === void 0) errors.push({
                message: `A Lexer cannot be initialized using an undefined Token Type. Mode:<${currModeName}> at index: <${currIdx}>
`,
                type: $5d51f81a4b917e73$export$75fe8082c000e4d9.LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED
            });
            else if (Object.hasOwn(currTokType, "LONGER_ALT")) {
                const longerAlt = Array.isArray(currTokType.LONGER_ALT) ? currTokType.LONGER_ALT : [
                    currTokType.LONGER_ALT
                ];
                longerAlt.forEach((currLongerAlt)=>{
                    if (currLongerAlt !== void 0 && !currModeValue.includes(currLongerAlt)) errors.push({
                        message: `A MultiMode Lexer cannot be initialized with a longer_alt <${currLongerAlt.name}> on token <${currTokType.name}> outside of mode <${currModeName}>
`,
                        type: $5d51f81a4b917e73$export$75fe8082c000e4d9.MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE
                    });
                });
            }
        });
    });
    return errors;
}
function $5d51f81a4b917e73$var$performWarningRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
    const warnings = [];
    let hasAnyLineBreak = false;
    const allTokenTypes = Object.values(lexerDefinition.modes || {}).flat().filter(Boolean);
    const concreteTokenTypes = allTokenTypes.filter((currType)=>currType[$5d51f81a4b917e73$var$PATTERN] !== $5d51f81a4b917e73$export$6168dc8908a6c652.NA);
    const terminatorCharCodes = $5d51f81a4b917e73$var$getCharCodes(lineTerminatorCharacters);
    if (trackLines) concreteTokenTypes.forEach((tokType)=>{
        const currIssue = $5d51f81a4b917e73$var$checkLineBreaksIssues(tokType, terminatorCharCodes);
        if (currIssue !== false) {
            const message = $5d51f81a4b917e73$var$buildLineBreakIssueMessage(tokType, currIssue);
            const warningDescriptor = {
                message: message,
                type: currIssue.issue,
                tokenType: tokType
            };
            warnings.push(warningDescriptor);
        } else {
            if (Object.hasOwn(tokType, "LINE_BREAKS")) {
                if (tokType.LINE_BREAKS === true) hasAnyLineBreak = true;
            } else if ($5d51f81a4b917e73$var$canMatchCharCode(terminatorCharCodes, tokType.PATTERN)) hasAnyLineBreak = true;
        }
    });
    if (trackLines && !hasAnyLineBreak) warnings.push({
        message: "Warning: No LINE_BREAKS Found.\n	This Lexer has been defined to track line and column information,\n	But none of the Token Types can be identified as matching a line terminator.\n	See https://chevrotain.io/docs/guide/resolving_lexer_errors.html#LINE_BREAKS \n	for details.",
        type: $5d51f81a4b917e73$export$75fe8082c000e4d9.NO_LINE_BREAKS_FLAGS
    });
    return warnings;
}
function $5d51f81a4b917e73$var$isCustomPattern(tokenType) {
    const pattern = tokenType.PATTERN;
    if (pattern instanceof RegExp) return false;
    else if (typeof pattern === "function") return true;
    else if (Object.hasOwn(pattern, "exec")) return true;
    else if (typeof pattern === "string") return false;
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$var$isShortPattern(pattern) {
    if (typeof pattern === "string" && pattern.length === 1) return pattern.charCodeAt(0);
    else return false;
}
var $5d51f81a4b917e73$var$LineTerminatorOptimizedTester = {
    // implements /\n|\r\n?/g.test
    test: function(text) {
        const len = text.length;
        for(let i = this.lastIndex; i < len; i++){
            const c = text.charCodeAt(i);
            if (c === 10) {
                this.lastIndex = i + 1;
                return true;
            } else if (c === 13) {
                if (text.charCodeAt(i + 1) === 10) this.lastIndex = i + 2;
                else this.lastIndex = i + 1;
                return true;
            }
        }
        return false;
    },
    lastIndex: 0
};
function $5d51f81a4b917e73$var$checkLineBreaksIssues(tokType, lineTerminatorCharCodes) {
    if (Object.hasOwn(tokType, "LINE_BREAKS")) return false;
    else {
        if (tokType.PATTERN instanceof RegExp) {
            try {
                $5d51f81a4b917e73$var$canMatchCharCode(lineTerminatorCharCodes, tokType.PATTERN);
            } catch (e) {
                return {
                    issue: $5d51f81a4b917e73$export$75fe8082c000e4d9.IDENTIFY_TERMINATOR,
                    errMsg: e.message
                };
            }
            return false;
        } else if (typeof tokType.PATTERN === "string") return false;
        else if ($5d51f81a4b917e73$var$isCustomPattern(tokType)) return {
            issue: $5d51f81a4b917e73$export$75fe8082c000e4d9.CUSTOM_LINE_BREAK
        };
        else throw Error("non exhaustive match");
    }
}
function $5d51f81a4b917e73$var$buildLineBreakIssueMessage(tokType, details) {
    if (details.issue === $5d51f81a4b917e73$export$75fe8082c000e4d9.IDENTIFY_TERMINATOR) return `Warning: unable to identify line terminator usage in pattern.
	The problem is in the <${tokType.name}> Token Type
	 Root cause: ${details.errMsg}.
	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#IDENTIFY_TERMINATOR`;
    else if (details.issue === $5d51f81a4b917e73$export$75fe8082c000e4d9.CUSTOM_LINE_BREAK) return `Warning: A Custom Token Pattern should specify the <line_breaks> option.
	The problem is in the <${tokType.name}> Token Type
	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#CUSTOM_LINE_BREAK`;
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$var$getCharCodes(charsOrCodes) {
    const charCodes = charsOrCodes.map((numOrString)=>{
        if (typeof numOrString === "string") return numOrString.charCodeAt(0);
        else return numOrString;
    });
    return charCodes;
}
function $5d51f81a4b917e73$var$addToMapOfArrays(map, key, value) {
    if (map[key] === void 0) map[key] = [
        value
    ];
    else map[key].push(value);
}
var $5d51f81a4b917e73$var$minOptimizationVal = 256;
var $5d51f81a4b917e73$var$charCodeToOptimizedIdxMap = [];
function $5d51f81a4b917e73$var$charCodeToOptimizedIndex(charCode) {
    return charCode < $5d51f81a4b917e73$var$minOptimizationVal ? charCode : $5d51f81a4b917e73$var$charCodeToOptimizedIdxMap[charCode];
}
function $5d51f81a4b917e73$var$initCharCodeToOptimizedIndexMap() {
    if ($5d51f81a4b917e73$var$charCodeToOptimizedIdxMap.length === 0) {
        $5d51f81a4b917e73$var$charCodeToOptimizedIdxMap = new Array(65536);
        for(let i = 0; i < 65536; i++)$5d51f81a4b917e73$var$charCodeToOptimizedIdxMap[i] = i > 255 ? 255 + ~~(i / 255) : i;
    }
}
// lib/src/scan/tokens.js
function $5d51f81a4b917e73$var$tokenStructuredMatcher(tokInstance, tokConstructor) {
    const instanceType = tokInstance.tokenTypeIdx;
    if (instanceType === tokConstructor.tokenTypeIdx) return true;
    else return tokConstructor.isParent === true && tokConstructor.categoryMatchesMap[instanceType] === true;
}
function $5d51f81a4b917e73$var$tokenStructuredMatcherNoCategories(token, tokType) {
    return token.tokenTypeIdx === tokType.tokenTypeIdx;
}
var $5d51f81a4b917e73$var$tokenShortNameIdx = 1;
var $5d51f81a4b917e73$var$tokenIdxToClass = {};
function $5d51f81a4b917e73$var$augmentTokenTypes(tokenTypes) {
    const tokenTypesAndParents = $5d51f81a4b917e73$var$expandCategories(tokenTypes);
    $5d51f81a4b917e73$var$assignTokenDefaultProps(tokenTypesAndParents);
    $5d51f81a4b917e73$var$assignCategoriesMapProp(tokenTypesAndParents);
    $5d51f81a4b917e73$var$assignCategoriesTokensProp(tokenTypesAndParents);
    tokenTypesAndParents.forEach((tokType)=>{
        tokType.isParent = tokType.categoryMatches.length > 0;
    });
}
function $5d51f81a4b917e73$var$expandCategories(tokenTypes) {
    let result = [
        ...tokenTypes
    ];
    let categories = tokenTypes;
    let searching = true;
    while(searching){
        categories = categories.map((currTokType)=>currTokType.CATEGORIES).flat().filter(Boolean);
        const newCategories = categories.filter((x)=>!result.includes(x));
        result = result.concat(newCategories);
        if (newCategories.length === 0) searching = false;
        else categories = newCategories;
    }
    return result;
}
function $5d51f81a4b917e73$var$assignTokenDefaultProps(tokenTypes) {
    tokenTypes.forEach((currTokType)=>{
        if (!$5d51f81a4b917e73$var$hasShortKeyProperty(currTokType)) {
            $5d51f81a4b917e73$var$tokenIdxToClass[$5d51f81a4b917e73$var$tokenShortNameIdx] = currTokType;
            currTokType.tokenTypeIdx = $5d51f81a4b917e73$var$tokenShortNameIdx++;
        }
        if ($5d51f81a4b917e73$var$hasCategoriesProperty(currTokType) && !Array.isArray(currTokType.CATEGORIES)) currTokType.CATEGORIES = [
            currTokType.CATEGORIES
        ];
        if (!$5d51f81a4b917e73$var$hasCategoriesProperty(currTokType)) currTokType.CATEGORIES = [];
        if (!$5d51f81a4b917e73$var$hasExtendingTokensTypesProperty(currTokType)) currTokType.categoryMatches = [];
        if (!$5d51f81a4b917e73$var$hasExtendingTokensTypesMapProperty(currTokType)) currTokType.categoryMatchesMap = {};
    });
}
function $5d51f81a4b917e73$var$assignCategoriesTokensProp(tokenTypes) {
    tokenTypes.forEach((currTokType)=>{
        currTokType.categoryMatches = [];
        Object.keys(currTokType.categoryMatchesMap).forEach((key)=>{
            currTokType.categoryMatches.push($5d51f81a4b917e73$var$tokenIdxToClass[key].tokenTypeIdx);
        });
    });
}
function $5d51f81a4b917e73$var$assignCategoriesMapProp(tokenTypes) {
    tokenTypes.forEach((currTokType)=>{
        $5d51f81a4b917e73$var$singleAssignCategoriesToksMap([], currTokType);
    });
}
function $5d51f81a4b917e73$var$singleAssignCategoriesToksMap(path, nextNode) {
    path.forEach((pathNode)=>{
        nextNode.categoryMatchesMap[pathNode.tokenTypeIdx] = true;
    });
    nextNode.CATEGORIES.forEach((nextCategory)=>{
        const newPath = path.concat(nextNode);
        if (!newPath.includes(nextCategory)) $5d51f81a4b917e73$var$singleAssignCategoriesToksMap(newPath, nextCategory);
    });
}
function $5d51f81a4b917e73$var$hasShortKeyProperty(tokType) {
    return Object.hasOwn(tokType !== null && tokType !== void 0 ? tokType : {}, "tokenTypeIdx");
}
function $5d51f81a4b917e73$var$hasCategoriesProperty(tokType) {
    return Object.hasOwn(tokType !== null && tokType !== void 0 ? tokType : {}, "CATEGORIES");
}
function $5d51f81a4b917e73$var$hasExtendingTokensTypesProperty(tokType) {
    return Object.hasOwn(tokType !== null && tokType !== void 0 ? tokType : {}, "categoryMatches");
}
function $5d51f81a4b917e73$var$hasExtendingTokensTypesMapProperty(tokType) {
    return Object.hasOwn(tokType !== null && tokType !== void 0 ? tokType : {}, "categoryMatchesMap");
}
function $5d51f81a4b917e73$var$isTokenType(tokType) {
    return Object.hasOwn(tokType !== null && tokType !== void 0 ? tokType : {}, "tokenTypeIdx");
}
// lib/src/scan/lexer_errors_public.js
var $5d51f81a4b917e73$export$cc067353be7648a1 = {
    buildUnableToPopLexerModeMessage (token) {
        return `Unable to pop Lexer Mode after encountering Token ->${token.image}<- The Mode Stack is empty`;
    },
    buildUnexpectedCharactersMessage (fullText, startOffset, length, line, column, mode) {
        return `unexpected character: ->${fullText.charAt(startOffset)}<- at offset: ${startOffset}, skipped ${length} characters.`;
    }
};
// lib/src/scan/lexer_public.js
var $5d51f81a4b917e73$export$75fe8082c000e4d9;
(function(LexerDefinitionErrorType2) {
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["MISSING_PATTERN"] = 0] = "MISSING_PATTERN";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["INVALID_PATTERN"] = 1] = "INVALID_PATTERN";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["EOI_ANCHOR_FOUND"] = 2] = "EOI_ANCHOR_FOUND";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["UNSUPPORTED_FLAGS_FOUND"] = 3] = "UNSUPPORTED_FLAGS_FOUND";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["DUPLICATE_PATTERNS_FOUND"] = 4] = "DUPLICATE_PATTERNS_FOUND";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["INVALID_GROUP_TYPE_FOUND"] = 5] = "INVALID_GROUP_TYPE_FOUND";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["PUSH_MODE_DOES_NOT_EXIST"] = 6] = "PUSH_MODE_DOES_NOT_EXIST";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE"] = 7] = "MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY"] = 8] = "MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST"] = 9] = "MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED"] = 10] = "LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["SOI_ANCHOR_FOUND"] = 11] = "SOI_ANCHOR_FOUND";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["EMPTY_MATCH_PATTERN"] = 12] = "EMPTY_MATCH_PATTERN";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["NO_LINE_BREAKS_FLAGS"] = 13] = "NO_LINE_BREAKS_FLAGS";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["UNREACHABLE_PATTERN"] = 14] = "UNREACHABLE_PATTERN";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["IDENTIFY_TERMINATOR"] = 15] = "IDENTIFY_TERMINATOR";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["CUSTOM_LINE_BREAK"] = 16] = "CUSTOM_LINE_BREAK";
    LexerDefinitionErrorType2[LexerDefinitionErrorType2["MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE"] = 17] = "MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE";
})($5d51f81a4b917e73$export$75fe8082c000e4d9 || ($5d51f81a4b917e73$export$75fe8082c000e4d9 = {}));
var $5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG = {
    deferDefinitionErrorsHandling: false,
    positionTracking: "full",
    lineTerminatorsPattern: /\n|\r\n?/g,
    lineTerminatorCharacters: [
        "\n",
        "\r"
    ],
    ensureOptimizations: false,
    safeMode: false,
    errorMessageProvider: $5d51f81a4b917e73$export$cc067353be7648a1,
    traceInitPerf: false,
    skipValidations: false,
    recoveryEnabled: true
};
Object.freeze($5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG);
var $5d51f81a4b917e73$export$6168dc8908a6c652 = class {
    constructor(lexerDefinition, config = $5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG){
        this.lexerDefinition = lexerDefinition;
        this.lexerDefinitionErrors = [];
        this.lexerDefinitionWarning = [];
        this.patternIdxToConfig = {};
        this.charCodeToPatternIdxToConfig = {};
        this.modes = [];
        this.emptyGroups = {};
        this.cachedGroupKeys = [];
        this.trackStartLines = true;
        this.trackEndLines = true;
        this.hasCustom = false;
        this.canModeBeOptimized = {};
        this.TRACE_INIT = (phaseDesc, phaseImpl)=>{
            if (this.traceInitPerf === true) {
                this.traceInitIndent++;
                const indent = new Array(this.traceInitIndent + 1).join("	");
                if (this.traceInitIndent < this.traceInitMaxIdent) console.log(`${indent}--> <${phaseDesc}>`);
                const { time: time, value: value } = $5d51f81a4b917e73$var$timer(phaseImpl);
                const traceMethod = time > 10 ? console.warn : console.log;
                if (this.traceInitIndent < this.traceInitMaxIdent) traceMethod(`${indent}<-- <${phaseDesc}> time: ${time}ms`);
                this.traceInitIndent--;
                return value;
            } else return phaseImpl();
        };
        if (typeof config === "boolean") throw Error("The second argument to the Lexer constructor is now an ILexerConfig Object.\na boolean 2nd argument is no longer supported");
        this.config = Object.assign({}, $5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG, config);
        const traceInitVal = this.config.traceInitPerf;
        if (traceInitVal === true) {
            this.traceInitMaxIdent = Infinity;
            this.traceInitPerf = true;
        } else if (typeof traceInitVal === "number") {
            this.traceInitMaxIdent = traceInitVal;
            this.traceInitPerf = true;
        }
        this.traceInitIndent = -1;
        this.TRACE_INIT("Lexer Constructor", ()=>{
            let actualDefinition;
            let hasOnlySingleMode = true;
            this.TRACE_INIT("Lexer Config handling", ()=>{
                if (this.config.lineTerminatorsPattern === $5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG.lineTerminatorsPattern) this.config.lineTerminatorsPattern = $5d51f81a4b917e73$var$LineTerminatorOptimizedTester;
                else {
                    if (this.config.lineTerminatorCharacters === $5d51f81a4b917e73$var$DEFAULT_LEXER_CONFIG.lineTerminatorCharacters) throw Error("Error: Missing <lineTerminatorCharacters> property on the Lexer config.\n	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#MISSING_LINE_TERM_CHARS");
                }
                if (config.safeMode && config.ensureOptimizations) throw Error('"safeMode" and "ensureOptimizations" flags are mutually exclusive.');
                this.trackStartLines = /full|onlyStart/i.test(this.config.positionTracking);
                this.trackEndLines = /full/i.test(this.config.positionTracking);
                if (Array.isArray(lexerDefinition)) actualDefinition = {
                    modes: {
                        defaultMode: [
                            ...lexerDefinition
                        ]
                    },
                    defaultMode: $5d51f81a4b917e73$var$DEFAULT_MODE
                };
                else {
                    hasOnlySingleMode = false;
                    actualDefinition = Object.assign({}, lexerDefinition);
                }
            });
            if (this.config.skipValidations === false) {
                this.TRACE_INIT("performRuntimeChecks", ()=>{
                    this.lexerDefinitionErrors = this.lexerDefinitionErrors.concat($5d51f81a4b917e73$var$performRuntimeChecks(actualDefinition, this.trackStartLines, this.config.lineTerminatorCharacters));
                });
                this.TRACE_INIT("performWarningRuntimeChecks", ()=>{
                    this.lexerDefinitionWarning = this.lexerDefinitionWarning.concat($5d51f81a4b917e73$var$performWarningRuntimeChecks(actualDefinition, this.trackStartLines, this.config.lineTerminatorCharacters));
                });
            }
            actualDefinition.modes = actualDefinition.modes ? actualDefinition.modes : {};
            Object.entries(actualDefinition.modes).forEach(([currModeName, currModeValue])=>{
                actualDefinition.modes[currModeName] = currModeValue.filter((currTokType)=>currTokType !== void 0);
            });
            const allModeNames = Object.keys(actualDefinition.modes);
            Object.entries(actualDefinition.modes).forEach(([currModName, currModDef])=>{
                this.TRACE_INIT(`Mode: <${currModName}> processing`, ()=>{
                    this.modes.push(currModName);
                    if (this.config.skipValidations === false) this.TRACE_INIT(`validatePatterns`, ()=>{
                        this.lexerDefinitionErrors = this.lexerDefinitionErrors.concat($5d51f81a4b917e73$var$validatePatterns(currModDef, allModeNames));
                    });
                    if (this.lexerDefinitionErrors.length === 0) {
                        $5d51f81a4b917e73$var$augmentTokenTypes(currModDef);
                        let currAnalyzeResult;
                        this.TRACE_INIT(`analyzeTokenTypes`, ()=>{
                            currAnalyzeResult = $5d51f81a4b917e73$var$analyzeTokenTypes(currModDef, {
                                lineTerminatorCharacters: this.config.lineTerminatorCharacters,
                                positionTracking: config.positionTracking,
                                ensureOptimizations: config.ensureOptimizations,
                                safeMode: config.safeMode,
                                tracer: this.TRACE_INIT
                            });
                        });
                        this.patternIdxToConfig[currModName] = currAnalyzeResult.patternIdxToConfig;
                        this.charCodeToPatternIdxToConfig[currModName] = currAnalyzeResult.charCodeToPatternIdxToConfig;
                        this.emptyGroups = Object.assign({}, this.emptyGroups, currAnalyzeResult.emptyGroups);
                        this.hasCustom = currAnalyzeResult.hasCustom || this.hasCustom;
                        this.canModeBeOptimized[currModName] = currAnalyzeResult.canBeOptimized;
                    }
                });
            });
            this.defaultMode = actualDefinition.defaultMode;
            this.cachedGroupKeys = Object.keys(this.emptyGroups);
            if (this.lexerDefinitionErrors.length > 0 && !this.config.deferDefinitionErrorsHandling) {
                const allErrMessages = this.lexerDefinitionErrors.map((error)=>{
                    return error.message;
                });
                const allErrMessagesString = allErrMessages.join("-----------------------\n");
                throw new Error("Errors detected in definition of Lexer:\n" + allErrMessagesString);
            }
            this.lexerDefinitionWarning.forEach((warningDescriptor)=>{
                $5d51f81a4b917e73$var$PRINT_WARNING(warningDescriptor.message);
            });
            this.TRACE_INIT("Choosing sub-methods implementations", ()=>{
                if (hasOnlySingleMode) this.handleModes = ()=>{};
                if (this.trackStartLines === false) this.computeNewColumn = (x)=>x;
                if (this.trackEndLines === false) this.updateTokenEndLineColumnLocation = ()=>{};
                if (/full/i.test(this.config.positionTracking)) this.createTokenInstance = this.createFullToken;
                else if (/onlyStart/i.test(this.config.positionTracking)) this.createTokenInstance = this.createStartOnlyToken;
                else if (/onlyOffset/i.test(this.config.positionTracking)) this.createTokenInstance = this.createOffsetOnlyToken;
                else throw Error(`Invalid <positionTracking> config option: "${this.config.positionTracking}"`);
                if (this.hasCustom) {
                    this.addToken = this.addTokenUsingPush;
                    this.handlePayload = this.handlePayloadWithCustom;
                } else {
                    this.addToken = this.addTokenUsingMemberAccess;
                    this.handlePayload = this.handlePayloadNoCustom;
                }
            });
            this.TRACE_INIT("Failed Optimization Warnings", ()=>{
                const unOptimizedModes = Object.entries(this.canModeBeOptimized).reduce((cannotBeOptimized, [modeName, canBeOptimized])=>{
                    if (canBeOptimized === false) cannotBeOptimized.push(modeName);
                    return cannotBeOptimized;
                }, []);
                if (config.ensureOptimizations && unOptimizedModes.length > 0) throw Error(`Lexer Modes: < ${unOptimizedModes.join(", ")} > cannot be optimized.
	 Disable the "ensureOptimizations" lexer config flag to silently ignore this and run the lexer in an un-optimized mode.
	 Or inspect the console log for details on how to resolve these issues.`);
            });
            this.TRACE_INIT("clearRegExpParserCache", ()=>{
                $5d51f81a4b917e73$var$clearRegExpParserCache();
            });
            this.TRACE_INIT("toFastProperties", ()=>{
                $5d51f81a4b917e73$var$toFastProperties(this);
            });
        });
    }
    tokenize(text, initialMode = this.defaultMode) {
        if (this.lexerDefinitionErrors.length > 0) {
            const allErrMessages = this.lexerDefinitionErrors.map((error)=>{
                return error.message;
            });
            const allErrMessagesString = allErrMessages.join("-----------------------\n");
            throw new Error("Unable to Tokenize because Errors detected in definition of Lexer:\n" + allErrMessagesString);
        }
        return this.tokenizeInternal(text, initialMode);
    }
    // There is quite a bit of duplication between this and "tokenizeInternalLazy"
    // This is intentional due to performance considerations.
    // this method also used quite a bit of `!` none null assertions because it is too optimized
    // for `tsc` to always understand it is "safe"
    tokenizeInternal(text, initialMode) {
        let i, j, k, matchAltImage, longerAlt, matchedImage, payload, altPayload, imageLength, group, tokType, newToken, errLength, msg, match;
        const orgText = text;
        const orgLength = orgText.length;
        let offset = 0;
        let matchedTokensIndex = 0;
        const guessedNumberOfTokens = this.hasCustom ? 0 : Math.floor(text.length / 10);
        const matchedTokens = new Array(guessedNumberOfTokens);
        const errors = [];
        let line = this.trackStartLines ? 1 : void 0;
        let column = this.trackStartLines ? 1 : void 0;
        const groups = {};
        for(let gi = 0; gi < this.cachedGroupKeys.length; gi++)groups[this.cachedGroupKeys[gi]] = [];
        const trackLines = this.trackStartLines;
        const lineTerminatorPattern = this.config.lineTerminatorsPattern;
        let currModePatternsLength = 0;
        let patternIdxToConfig = [];
        let currCharCodeToPatternIdxToConfig = [];
        const modeStack = [];
        const emptyArray = [];
        Object.freeze(emptyArray);
        let isOptimizedMode = false;
        const pop_mode = (popToken)=>{
            if (modeStack.length === 1 && // if we have both a POP_MODE and a PUSH_MODE this is in-fact a "transition"
            // So no error should occur.
            popToken.tokenType.PUSH_MODE === void 0) {
                const msg2 = this.config.errorMessageProvider.buildUnableToPopLexerModeMessage(popToken);
                errors.push({
                    offset: popToken.startOffset,
                    line: popToken.startLine,
                    column: popToken.startColumn,
                    length: popToken.image.length,
                    message: msg2
                });
            } else {
                modeStack.pop();
                const newMode = modeStack.at(-1);
                patternIdxToConfig = this.patternIdxToConfig[newMode];
                currCharCodeToPatternIdxToConfig = this.charCodeToPatternIdxToConfig[newMode];
                currModePatternsLength = patternIdxToConfig.length;
                const modeCanBeOptimized = this.canModeBeOptimized[newMode] && this.config.safeMode === false;
                if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) isOptimizedMode = true;
                else isOptimizedMode = false;
            }
        };
        function push_mode(newMode) {
            modeStack.push(newMode);
            currCharCodeToPatternIdxToConfig = this.charCodeToPatternIdxToConfig[newMode];
            patternIdxToConfig = this.patternIdxToConfig[newMode];
            currModePatternsLength = patternIdxToConfig.length;
            const modeCanBeOptimized = this.canModeBeOptimized[newMode] && this.config.safeMode === false;
            if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) isOptimizedMode = true;
            else isOptimizedMode = false;
        }
        push_mode.call(this, initialMode);
        let currConfig;
        const recoveryEnabled = this.config.recoveryEnabled;
        while(offset < orgLength){
            matchedImage = null;
            imageLength = -1;
            const nextCharCode = orgText.charCodeAt(offset);
            let chosenPatternIdxToConfig;
            if (isOptimizedMode) {
                const optimizedCharIdx = $5d51f81a4b917e73$var$charCodeToOptimizedIndex(nextCharCode);
                const possiblePatterns = currCharCodeToPatternIdxToConfig[optimizedCharIdx];
                chosenPatternIdxToConfig = possiblePatterns !== void 0 ? possiblePatterns : emptyArray;
            } else chosenPatternIdxToConfig = patternIdxToConfig;
            const chosenPatternsLength = chosenPatternIdxToConfig.length;
            for(i = 0; i < chosenPatternsLength; i++){
                currConfig = chosenPatternIdxToConfig[i];
                const currPattern = currConfig.pattern;
                payload = null;
                switch(currConfig.matchType){
                    case $5d51f81a4b917e73$var$SINGLE_CHAR_MATCH:
                        if (nextCharCode === currConfig.short) {
                            imageLength = 1;
                            matchedImage = currPattern;
                        }
                        break;
                    case $5d51f81a4b917e73$var$CUSTOM_MATCH:
                        match = currPattern.exec(orgText, offset, matchedTokens, groups);
                        if (match !== null) {
                            matchedImage = match[0];
                            imageLength = matchedImage.length;
                            if (match.payload !== void 0) payload = match.payload;
                        } else matchedImage = null;
                        break;
                    case $5d51f81a4b917e73$var$ASCII_CLASS_MATCH:
                        {
                            const asciiClass = currConfig.asciiClass;
                            if (asciiClass[nextCharCode] !== 1) {
                                currPattern.lastIndex = 0;
                                break;
                            }
                            let endOffset = offset + 1;
                            while(asciiClass[orgText.charCodeAt(endOffset)] === 1)endOffset++;
                            imageLength = endOffset - offset;
                            currPattern.lastIndex = endOffset;
                            break;
                        }
                    case $5d51f81a4b917e73$var$REG_EXP_MATCH:
                        currPattern.lastIndex = offset;
                        imageLength = this.matchLength(currPattern, text, offset);
                        break;
                }
                if (imageLength !== -1) {
                    longerAlt = currConfig.longerAlt;
                    if (longerAlt !== void 0) {
                        matchedImage = text.substring(offset, offset + imageLength);
                        const longerAltLength = longerAlt.length;
                        for(k = 0; k < longerAltLength; k++){
                            const longerAltConfig = patternIdxToConfig[longerAlt[k]];
                            const longerAltPattern = longerAltConfig.pattern;
                            altPayload = null;
                            if (longerAltConfig.matchType === $5d51f81a4b917e73$var$CUSTOM_MATCH) {
                                match = longerAltPattern.exec(orgText, offset, matchedTokens, groups);
                                if (match !== null) {
                                    matchAltImage = match[0];
                                    if (match.payload !== void 0) altPayload = match.payload;
                                } else matchAltImage = null;
                            } else {
                                longerAltPattern.lastIndex = offset;
                                matchAltImage = this.match(longerAltPattern, text, offset);
                            }
                            if (matchAltImage && matchAltImage.length > matchedImage.length) {
                                matchedImage = matchAltImage;
                                imageLength = matchAltImage.length;
                                payload = altPayload;
                                currConfig = longerAltConfig;
                                break;
                            }
                        }
                    }
                    break;
                }
            }
            if (imageLength !== -1) {
                group = currConfig.group;
                if (group !== void 0) {
                    matchedImage = matchedImage !== null ? matchedImage : text.substring(offset, offset + imageLength);
                    tokType = currConfig.tokenTypeIdx;
                    newToken = this.createTokenInstance(matchedImage, offset, tokType, currConfig.tokenType, line, column, imageLength);
                    this.handlePayload(newToken, payload);
                    if (group === false) matchedTokensIndex = this.addToken(matchedTokens, matchedTokensIndex, newToken);
                    else groups[group].push(newToken);
                }
                if (trackLines === true && currConfig.canLineTerminator === true) {
                    let numOfLTsInMatch = 0;
                    let foundTerminator;
                    let lastLTEndOffset;
                    lineTerminatorPattern.lastIndex = 0;
                    do {
                        matchedImage = matchedImage !== null ? matchedImage : text.substring(offset, offset + imageLength);
                        foundTerminator = lineTerminatorPattern.test(matchedImage);
                        if (foundTerminator === true) {
                            lastLTEndOffset = lineTerminatorPattern.lastIndex - 1;
                            numOfLTsInMatch++;
                        }
                    }while (foundTerminator === true);
                    if (numOfLTsInMatch !== 0) {
                        line = line + numOfLTsInMatch;
                        column = imageLength - lastLTEndOffset;
                        this.updateTokenEndLineColumnLocation(newToken, group, lastLTEndOffset, numOfLTsInMatch, line, column, imageLength);
                    } else column = this.computeNewColumn(column, imageLength);
                } else column = this.computeNewColumn(column, imageLength);
                offset = offset + imageLength;
                this.handleModes(currConfig, pop_mode, push_mode, newToken);
            } else {
                const errorStartOffset = offset;
                const errorLine = line;
                const errorColumn = column;
                let foundResyncPoint = recoveryEnabled === false;
                while(foundResyncPoint === false && offset < orgLength){
                    offset++;
                    for(j = 0; j < currModePatternsLength; j++){
                        const currConfig2 = patternIdxToConfig[j];
                        const currPattern = currConfig2.pattern;
                        switch(currConfig2.matchType){
                            case $5d51f81a4b917e73$var$SINGLE_CHAR_MATCH:
                                if (orgText.charCodeAt(offset) === currConfig2.short) foundResyncPoint = true;
                                break;
                            case $5d51f81a4b917e73$var$CUSTOM_MATCH:
                                foundResyncPoint = currPattern.exec(orgText, offset, matchedTokens, groups) !== null;
                                break;
                            case $5d51f81a4b917e73$var$ASCII_CLASS_MATCH:
                            case $5d51f81a4b917e73$var$REG_EXP_MATCH:
                                currPattern.lastIndex = offset;
                                foundResyncPoint = currPattern.exec(text) !== null;
                                break;
                        }
                        if (foundResyncPoint === true) break;
                    }
                }
                errLength = offset - errorStartOffset;
                column = this.computeNewColumn(column, errLength);
                msg = this.config.errorMessageProvider.buildUnexpectedCharactersMessage(orgText, errorStartOffset, errLength, errorLine, errorColumn, modeStack.at(-1));
                errors.push({
                    offset: errorStartOffset,
                    line: errorLine,
                    column: errorColumn,
                    length: errLength,
                    message: msg
                });
                if (recoveryEnabled === false) break;
            }
        }
        if (!this.hasCustom) matchedTokens.length = matchedTokensIndex;
        return {
            tokens: matchedTokens,
            groups: groups,
            errors: errors
        };
    }
    handleModes(config, pop_mode, push_mode, newToken) {
        if (config.pop === true) {
            const pushMode = config.push;
            pop_mode(newToken);
            if (pushMode !== void 0) push_mode.call(this, pushMode);
        } else if (config.push !== void 0) push_mode.call(this, config.push);
    }
    // TODO: decrease this under 600 characters? inspect stripping comments option in TSC compiler
    updateTokenEndLineColumnLocation(newToken, group, lastLTIdx, numOfLTsInMatch, line, column, imageLength) {
        let lastCharIsLT, fixForEndingInLT;
        if (group !== void 0) {
            lastCharIsLT = lastLTIdx === imageLength - 1;
            fixForEndingInLT = lastCharIsLT ? -1 : 0;
            if (!(numOfLTsInMatch === 1 && lastCharIsLT === true)) {
                newToken.endLine = line + fixForEndingInLT;
                newToken.endColumn = column - 1 + -fixForEndingInLT;
            }
        }
    }
    computeNewColumn(oldColumn, imageLength) {
        return oldColumn + imageLength;
    }
    createOffsetOnlyToken(image, startOffset, tokenTypeIdx, tokenType) {
        return {
            image: image,
            startOffset: startOffset,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    }
    createStartOnlyToken(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn) {
        return {
            image: image,
            startOffset: startOffset,
            startLine: startLine,
            startColumn: startColumn,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    }
    createFullToken(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn, imageLength) {
        return {
            image: image,
            startOffset: startOffset,
            endOffset: startOffset + imageLength - 1,
            startLine: startLine,
            endLine: startLine,
            startColumn: startColumn,
            endColumn: startColumn + imageLength - 1,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    }
    addTokenUsingPush(tokenVector, index, tokenToAdd) {
        tokenVector.push(tokenToAdd);
        return index;
    }
    addTokenUsingMemberAccess(tokenVector, index, tokenToAdd) {
        tokenVector[index] = tokenToAdd;
        index++;
        return index;
    }
    handlePayloadNoCustom(token, payload) {}
    handlePayloadWithCustom(token, payload) {
        if (payload !== null) token.payload = payload;
    }
    match(pattern, text, offset) {
        const found = pattern.test(text);
        if (found === true) return text.substring(offset, pattern.lastIndex);
        return null;
    }
    matchLength(pattern, text, offset) {
        const found = pattern.test(text);
        if (found === true) return pattern.lastIndex - offset;
        return -1;
    }
};
$5d51f81a4b917e73$export$6168dc8908a6c652.SKIPPED = "This marks a skipped Token pattern, this means each token identified by it will be consumed and then thrown into oblivion, this can be used to for example to completely ignore whitespace.";
$5d51f81a4b917e73$export$6168dc8908a6c652.NA = /NOT_APPLICABLE/;
// lib/src/scan/tokens_public.js
function $5d51f81a4b917e73$export$9e0160de4349ea3f(tokType) {
    if ($5d51f81a4b917e73$var$hasTokenLabel2(tokType)) return tokType.LABEL;
    else return tokType.name;
}
function $5d51f81a4b917e73$export$458bf7b07b21488f(tokType) {
    return tokType.name;
}
function $5d51f81a4b917e73$var$hasTokenLabel2(obj) {
    return typeof obj.LABEL === "string" && obj.LABEL !== "";
}
var $5d51f81a4b917e73$var$PARENT = "parent";
var $5d51f81a4b917e73$var$CATEGORIES = "categories";
var $5d51f81a4b917e73$var$LABEL = "label";
var $5d51f81a4b917e73$var$GROUP = "group";
var $5d51f81a4b917e73$var$PUSH_MODE = "push_mode";
var $5d51f81a4b917e73$var$POP_MODE = "pop_mode";
var $5d51f81a4b917e73$var$LONGER_ALT = "longer_alt";
var $5d51f81a4b917e73$var$LINE_BREAKS = "line_breaks";
var $5d51f81a4b917e73$var$START_CHARS_HINT = "start_chars_hint";
function $5d51f81a4b917e73$export$c255480b061bd6aa(config) {
    return $5d51f81a4b917e73$var$createTokenInternal(config);
}
function $5d51f81a4b917e73$var$createTokenInternal(config) {
    const pattern = config.pattern;
    const tokenType = {};
    tokenType.name = config.name;
    if (pattern !== void 0) tokenType.PATTERN = pattern;
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$PARENT)) throw "The parent property is no longer supported.\nSee: https://github.com/chevrotain/chevrotain/issues/564#issuecomment-349062346 for details.";
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$CATEGORIES)) tokenType.CATEGORIES = config[$5d51f81a4b917e73$var$CATEGORIES];
    $5d51f81a4b917e73$var$augmentTokenTypes([
        tokenType
    ]);
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$LABEL)) tokenType.LABEL = config[$5d51f81a4b917e73$var$LABEL];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$GROUP)) tokenType.GROUP = config[$5d51f81a4b917e73$var$GROUP];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$POP_MODE)) tokenType.POP_MODE = config[$5d51f81a4b917e73$var$POP_MODE];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$PUSH_MODE)) tokenType.PUSH_MODE = config[$5d51f81a4b917e73$var$PUSH_MODE];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$LONGER_ALT)) tokenType.LONGER_ALT = config[$5d51f81a4b917e73$var$LONGER_ALT];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$LINE_BREAKS)) tokenType.LINE_BREAKS = config[$5d51f81a4b917e73$var$LINE_BREAKS];
    if (Object.hasOwn(config, $5d51f81a4b917e73$var$START_CHARS_HINT)) tokenType.START_CHARS_HINT = config[$5d51f81a4b917e73$var$START_CHARS_HINT];
    return tokenType;
}
var $5d51f81a4b917e73$export$c1a09112320b1603 = $5d51f81a4b917e73$export$c255480b061bd6aa({
    name: "EOF",
    pattern: $5d51f81a4b917e73$export$6168dc8908a6c652.NA
});
$5d51f81a4b917e73$var$augmentTokenTypes([
    $5d51f81a4b917e73$export$c1a09112320b1603
]);
function $5d51f81a4b917e73$export$eaddf8d68927eada(tokType, image, startOffset, endOffset, startLine, endLine, startColumn, endColumn) {
    return {
        image: image,
        startOffset: startOffset,
        endOffset: endOffset,
        startLine: startLine,
        endLine: endLine,
        startColumn: startColumn,
        endColumn: endColumn,
        tokenTypeIdx: tokType.tokenTypeIdx,
        tokenType: tokType
    };
}
function $5d51f81a4b917e73$export$4a18d31d63d8e922(token, tokType) {
    return $5d51f81a4b917e73$var$tokenStructuredMatcher(token, tokType);
}
// lib/src/parse/errors_public.js
var $5d51f81a4b917e73$export$d0949d751bf6767 = {
    buildMismatchTokenMessage ({ expected: expected, actual: actual, previous: previous, ruleName: ruleName }) {
        const hasLabel = $5d51f81a4b917e73$var$hasTokenLabel2(expected);
        const expectedMsg = hasLabel ? `--> ${$5d51f81a4b917e73$export$9e0160de4349ea3f(expected)} <--` : `token of type --> ${expected.name} <--`;
        const msg = `Expecting ${expectedMsg} but found --> '${actual.image}' <--`;
        return msg;
    },
    buildNotAllInputParsedMessage ({ firstRedundant: firstRedundant, ruleName: ruleName }) {
        return "Redundant input, expecting EOF but found: " + firstRedundant.image;
    },
    buildNoViableAltMessage ({ expectedPathsPerAlt: expectedPathsPerAlt, actual: actual, previous: previous, customUserDescription: customUserDescription, ruleName: ruleName }) {
        const errPrefix = "Expecting: ";
        const actualText = actual[0].image;
        const errSuffix = "\nbut found: '" + actualText + "'";
        if (customUserDescription) return errPrefix + customUserDescription + errSuffix;
        else {
            const allLookAheadPaths = expectedPathsPerAlt.reduce((result, currAltPaths)=>result.concat(currAltPaths), []);
            const nextValidTokenSequences = allLookAheadPaths.map((currPath)=>`[${currPath.map((currTokenType)=>$5d51f81a4b917e73$export$9e0160de4349ea3f(currTokenType)).join(", ")}]`);
            const nextValidSequenceItems = nextValidTokenSequences.map((itemMsg, idx)=>`  ${idx + 1}. ${itemMsg}`);
            const calculatedDescription = `one of these possible Token sequences:
${nextValidSequenceItems.join("\n")}`;
            return errPrefix + calculatedDescription + errSuffix;
        }
    },
    buildEarlyExitMessage ({ expectedIterationPaths: expectedIterationPaths, actual: actual, customUserDescription: customUserDescription, ruleName: ruleName }) {
        const errPrefix = "Expecting: ";
        const actualText = actual[0].image;
        const errSuffix = "\nbut found: '" + actualText + "'";
        if (customUserDescription) return errPrefix + customUserDescription + errSuffix;
        else {
            const nextValidTokenSequences = expectedIterationPaths.map((currPath)=>`[${currPath.map((currTokenType)=>$5d51f81a4b917e73$export$9e0160de4349ea3f(currTokenType)).join(",")}]`);
            const calculatedDescription = `expecting at least one iteration which starts with one of these possible Token sequences::
  <${nextValidTokenSequences.join(" ,")}>`;
            return errPrefix + calculatedDescription + errSuffix;
        }
    }
};
Object.freeze($5d51f81a4b917e73$export$d0949d751bf6767);
var $5d51f81a4b917e73$var$defaultGrammarResolverErrorProvider = {
    buildRuleNotFoundError (topLevelRule, undefinedRule) {
        const msg = "Invalid grammar, reference to a rule which is not defined: ->" + undefinedRule.nonTerminalName + "<-\ninside top level rule: ->" + topLevelRule.name + "<-";
        return msg;
    }
};
var $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider = {
    buildDuplicateFoundError (topLevelRule, duplicateProds) {
        function getExtraProductionArgument2(prod) {
            if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) return prod.terminalType.name;
            else if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return prod.nonTerminalName;
            else return "";
        }
        const topLevelName = topLevelRule.name;
        const duplicateProd = duplicateProds[0];
        const index = duplicateProd.idx;
        const dslName = $5d51f81a4b917e73$var$getProductionDslName(duplicateProd);
        const extraArgument = getExtraProductionArgument2(duplicateProd);
        const hasExplicitIndex = index > 0;
        let msg = `->${dslName}${hasExplicitIndex ? index : ""}<- ${extraArgument ? `with argument: ->${extraArgument}<-` : ""}
                  appears more than once (${duplicateProds.length} times) in the top level rule: ->${topLevelName}<-.                  
                  For further details see: https://chevrotain.io/docs/FAQ.html#NUMERICAL_SUFFIXES 
                  `;
        msg = msg.replace(/[ \t]+/g, " ");
        msg = msg.replace(/\s\s+/g, "\n");
        return msg;
    },
    buildNamespaceConflictError (rule) {
        const errMsg = `Namespace conflict found in grammar.
The grammar has both a Terminal(Token) and a Non-Terminal(Rule) named: <${rule.name}>.
To resolve this make sure each Terminal and Non-Terminal names are unique
This is easy to accomplish by using the convention that Terminal names start with an uppercase letter
and Non-Terminal names start with a lower case letter.`;
        return errMsg;
    },
    buildAlternationPrefixAmbiguityError (options) {
        const pathMsg = options.prefixPath.map((currTok)=>$5d51f81a4b917e73$export$9e0160de4349ea3f(currTok)).join(", ");
        const occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
        const errMsg = `Ambiguous alternatives: <${options.ambiguityIndices.join(" ,")}> due to common lookahead prefix
in <OR${occurrence}> inside <${options.topLevelRule.name}> Rule,
<${pathMsg}> may appears as a prefix path in all these alternatives.
See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#COMMON_PREFIX
For Further details.`;
        return errMsg;
    },
    buildAlternationAmbiguityError (options) {
        const occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
        const isEmptyPath = options.prefixPath.length === 0;
        let currMessage = `Ambiguous Alternatives Detected: <${options.ambiguityIndices.join(" ,")}> in <OR${occurrence}> inside <${options.topLevelRule.name}> Rule,
`;
        if (isEmptyPath) currMessage += `These alternatives are all empty (match no tokens), making them indistinguishable.
Only the last alternative may be empty.
`;
        else {
            const pathMsg = options.prefixPath.map((currtok)=>$5d51f81a4b917e73$export$9e0160de4349ea3f(currtok)).join(", ");
            currMessage += `<${pathMsg}> may appears as a prefix path in all these alternatives.
`;
        }
        currMessage += `See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#AMBIGUOUS_ALTERNATIVES
For Further details.`;
        return currMessage;
    },
    buildEmptyRepetitionError (options) {
        let dslName = $5d51f81a4b917e73$var$getProductionDslName(options.repetition);
        if (options.repetition.idx !== 0) dslName += options.repetition.idx;
        const errMsg = `The repetition <${dslName}> within Rule <${options.topLevelRule.name}> can never consume any tokens.
This could lead to an infinite loop.`;
        return errMsg;
    },
    // TODO: remove - `errors_public` from nyc.config.js exclude
    //       once this method is fully removed from this file
    buildTokenNameError (options) {
        return "deprecated";
    },
    buildEmptyAlternationError (options) {
        const errMsg = `Ambiguous empty alternative: <${options.emptyChoiceIdx + 1}> in <OR${options.alternation.idx}> inside <${options.topLevelRule.name}> Rule.
Only the last alternative may be an empty alternative.`;
        return errMsg;
    },
    buildTooManyAlternativesError (options) {
        const errMsg = `An Alternation cannot have more than 256 alternatives:
<OR${options.alternation.idx}> inside <${options.topLevelRule.name}> Rule.
 has ${options.alternation.definition.length + 1} alternatives.`;
        return errMsg;
    },
    buildLeftRecursionError (options) {
        const ruleName = options.topLevelRule.name;
        const pathNames = options.leftRecursionPath.map((currRule)=>currRule.name);
        const leftRecursivePath = `${ruleName} --> ${pathNames.concat([
            ruleName
        ]).join(" --> ")}`;
        const errMsg = `Left Recursion found in grammar.
rule: <${ruleName}> can be invoked from itself (directly or indirectly)
without consuming any Tokens. The grammar path that causes this is: 
 ${leftRecursivePath}
 To fix this refactor your grammar to remove the left recursion.
see: https://en.wikipedia.org/wiki/LL_parser#Left_factoring.`;
        return errMsg;
    },
    // TODO: remove - `errors_public` from nyc.config.js exclude
    //       once this method is fully removed from this file
    buildInvalidRuleNameError (options) {
        return "deprecated";
    },
    buildDuplicateRuleNameError (options) {
        let ruleName;
        if (options.topLevelRule instanceof $5d51f81a4b917e73$export$f1ff2a90c38ff669) ruleName = options.topLevelRule.name;
        else ruleName = options.topLevelRule;
        const errMsg = `Duplicate definition, rule: ->${ruleName}<- is already defined in the grammar: ->${options.grammarName}<-`;
        return errMsg;
    }
};
// lib/src/parse/grammar/resolver.js
function $5d51f81a4b917e73$var$resolveGrammar(topLevels, errMsgProvider) {
    const refResolver = new $5d51f81a4b917e73$var$GastRefResolverVisitor(topLevels, errMsgProvider);
    refResolver.resolveRefs();
    return refResolver.errors;
}
var $5d51f81a4b917e73$var$GastRefResolverVisitor = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(nameToTopRule, errMsgProvider){
        super();
        this.nameToTopRule = nameToTopRule;
        this.errMsgProvider = errMsgProvider;
        this.errors = [];
    }
    resolveRefs() {
        Object.values(this.nameToTopRule).forEach((prod)=>{
            this.currTopLevel = prod;
            prod.accept(this);
        });
    }
    visitNonTerminal(node) {
        const ref = this.nameToTopRule[node.nonTerminalName];
        if (!ref) {
            const msg = this.errMsgProvider.buildRuleNotFoundError(this.currTopLevel, node);
            this.errors.push({
                message: msg,
                type: $5d51f81a4b917e73$export$86bd3f602f298cb6.UNRESOLVED_SUBRULE_REF,
                ruleName: this.currTopLevel.name,
                unresolvedRefName: node.nonTerminalName
            });
        } else node.referencedRule = ref;
    }
};
// lib/src/parse/grammar/interpreter.js
var $5d51f81a4b917e73$var$AbstractNextPossibleTokensWalker = class extends $5d51f81a4b917e73$var$RestWalker {
    constructor(topProd, path){
        super();
        this.topProd = topProd;
        this.path = path;
        this.possibleTokTypes = [];
        this.nextProductionName = "";
        this.nextProductionOccurrence = 0;
        this.found = false;
        this.isAtEndOfPath = false;
    }
    startWalking() {
        this.found = false;
        if (this.path.ruleStack[0] !== this.topProd.name) throw Error("The path does not start with the walker's top Rule!");
        this.ruleStack = [
            ...this.path.ruleStack
        ].reverse();
        this.occurrenceStack = [
            ...this.path.occurrenceStack
        ].reverse();
        this.ruleStack.pop();
        this.occurrenceStack.pop();
        this.updateExpectedNext();
        this.walk(this.topProd);
        return this.possibleTokTypes;
    }
    walk(prod, prevRest = []) {
        if (!this.found) super.walk(prod, prevRest);
    }
    walkProdRef(refProd, currRest, prevRest) {
        if (refProd.referencedRule.name === this.nextProductionName && refProd.idx === this.nextProductionOccurrence) {
            const fullRest = currRest.concat(prevRest);
            this.updateExpectedNext();
            this.walk(refProd.referencedRule, fullRest);
        }
    }
    updateExpectedNext() {
        if (this.ruleStack.length === 0) {
            this.nextProductionName = "";
            this.nextProductionOccurrence = 0;
            this.isAtEndOfPath = true;
        } else {
            this.nextProductionName = this.ruleStack.pop();
            this.nextProductionOccurrence = this.occurrenceStack.pop();
        }
    }
};
var $5d51f81a4b917e73$var$NextAfterTokenWalker = class extends $5d51f81a4b917e73$var$AbstractNextPossibleTokensWalker {
    constructor(topProd, path){
        super(topProd, path);
        this.path = path;
        this.nextTerminalName = "";
        this.nextTerminalOccurrence = 0;
        this.nextTerminalName = this.path.lastTok.name;
        this.nextTerminalOccurrence = this.path.lastTokOccurrence;
    }
    walkTerminal(terminal, currRest, prevRest) {
        if (this.isAtEndOfPath && terminal.terminalType.name === this.nextTerminalName && terminal.idx === this.nextTerminalOccurrence && !this.found) {
            const fullRest = currRest.concat(prevRest);
            const restProd = new $5d51f81a4b917e73$export$4acb47accde578d2({
                definition: fullRest
            });
            this.possibleTokTypes = $5d51f81a4b917e73$var$first(restProd);
            this.found = true;
        }
    }
};
var $5d51f81a4b917e73$var$AbstractNextTerminalAfterProductionWalker = class extends $5d51f81a4b917e73$var$RestWalker {
    constructor(topRule, occurrence){
        super();
        this.topRule = topRule;
        this.occurrence = occurrence;
        this.result = {
            token: void 0,
            occurrence: void 0,
            isEndOfRule: void 0
        };
    }
    startWalking() {
        this.walk(this.topRule);
        return this.result;
    }
};
var $5d51f81a4b917e73$var$NextTerminalAfterManyWalker = class extends $5d51f81a4b917e73$var$AbstractNextTerminalAfterProductionWalker {
    walkMany(manyProd, currRest, prevRest) {
        if (manyProd.idx === this.occurrence) {
            const firstAfterMany = currRest.concat(prevRest)[0];
            this.result.isEndOfRule = firstAfterMany === void 0;
            if (firstAfterMany instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
                this.result.token = firstAfterMany.terminalType;
                this.result.occurrence = firstAfterMany.idx;
            }
        } else super.walkMany(manyProd, currRest, prevRest);
    }
};
var $5d51f81a4b917e73$var$NextTerminalAfterManySepWalker = class extends $5d51f81a4b917e73$var$AbstractNextTerminalAfterProductionWalker {
    walkManySep(manySepProd, currRest, prevRest) {
        if (manySepProd.idx === this.occurrence) {
            const firstAfterManySep = currRest.concat(prevRest)[0];
            this.result.isEndOfRule = firstAfterManySep === void 0;
            if (firstAfterManySep instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
                this.result.token = firstAfterManySep.terminalType;
                this.result.occurrence = firstAfterManySep.idx;
            }
        } else super.walkManySep(manySepProd, currRest, prevRest);
    }
};
var $5d51f81a4b917e73$var$NextTerminalAfterAtLeastOneWalker = class extends $5d51f81a4b917e73$var$AbstractNextTerminalAfterProductionWalker {
    walkAtLeastOne(atLeastOneProd, currRest, prevRest) {
        if (atLeastOneProd.idx === this.occurrence) {
            const firstAfterAtLeastOne = currRest.concat(prevRest)[0];
            this.result.isEndOfRule = firstAfterAtLeastOne === void 0;
            if (firstAfterAtLeastOne instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
                this.result.token = firstAfterAtLeastOne.terminalType;
                this.result.occurrence = firstAfterAtLeastOne.idx;
            }
        } else super.walkAtLeastOne(atLeastOneProd, currRest, prevRest);
    }
};
var $5d51f81a4b917e73$var$NextTerminalAfterAtLeastOneSepWalker = class extends $5d51f81a4b917e73$var$AbstractNextTerminalAfterProductionWalker {
    walkAtLeastOneSep(atleastOneSepProd, currRest, prevRest) {
        if (atleastOneSepProd.idx === this.occurrence) {
            const firstAfterfirstAfterAtLeastOneSep = currRest.concat(prevRest)[0];
            this.result.isEndOfRule = firstAfterfirstAfterAtLeastOneSep === void 0;
            if (firstAfterfirstAfterAtLeastOneSep instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
                this.result.token = firstAfterfirstAfterAtLeastOneSep.terminalType;
                this.result.occurrence = firstAfterfirstAfterAtLeastOneSep.idx;
            }
        } else super.walkAtLeastOneSep(atleastOneSepProd, currRest, prevRest);
    }
};
function $5d51f81a4b917e73$var$possiblePathsFrom(targetDef, maxLength, currPath = []) {
    currPath = [
        ...currPath
    ];
    let result = [];
    let i = 0;
    function remainingPathWith(nextDef) {
        return nextDef.concat(targetDef.slice(i + 1));
    }
    function getAlternativesForProd(definition) {
        const alternatives = $5d51f81a4b917e73$var$possiblePathsFrom(remainingPathWith(definition), maxLength, currPath);
        return result.concat(alternatives);
    }
    while(currPath.length < maxLength && i < targetDef.length){
        const prod = targetDef[i];
        if (prod instanceof $5d51f81a4b917e73$export$4acb47accde578d2) return getAlternativesForProd(prod.definition);
        else if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return getAlternativesForProd(prod.definition);
        else if (prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20) result = getAlternativesForProd(prod.definition);
        else if (prod instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8) {
            const newDef = prod.definition.concat([
                new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                    definition: prod.definition
                })
            ]);
            return getAlternativesForProd(newDef);
        } else if (prod instanceof $5d51f81a4b917e73$export$da6c5580175e0214) {
            const newDef = [
                new $5d51f81a4b917e73$export$4acb47accde578d2({
                    definition: prod.definition
                }),
                new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                    definition: [
                        new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
                            terminalType: prod.separator
                        })
                    ].concat(prod.definition)
                })
            ];
            return getAlternativesForProd(newDef);
        } else if (prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8) {
            const newDef = prod.definition.concat([
                new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                    definition: [
                        new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
                            terminalType: prod.separator
                        })
                    ].concat(prod.definition)
                })
            ]);
            result = getAlternativesForProd(newDef);
        } else if (prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) {
            const newDef = prod.definition.concat([
                new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                    definition: prod.definition
                })
            ]);
            result = getAlternativesForProd(newDef);
        } else if (prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) {
            prod.definition.forEach((currAlt)=>{
                if (currAlt.definition.length !== 0) result = getAlternativesForProd(currAlt.definition);
            });
            return result;
        } else if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) currPath.push(prod.terminalType);
        else throw Error("non exhaustive match");
        i++;
    }
    result.push({
        partialPath: currPath,
        suffixDef: targetDef.slice(i)
    });
    return result;
}
function $5d51f81a4b917e73$var$nextPossibleTokensAfter(initialDef, tokenVector, tokMatcher, maxLookAhead) {
    const EXIT_NON_TERMINAL = "EXIT_NONE_TERMINAL";
    const EXIT_NON_TERMINAL_ARR = [
        EXIT_NON_TERMINAL
    ];
    const EXIT_ALTERNATIVE = "EXIT_ALTERNATIVE";
    let foundCompletePath = false;
    const tokenVectorLength = tokenVector.length;
    const minimalAlternativesIndex = tokenVectorLength - maxLookAhead - 1;
    const result = [];
    const possiblePaths = [];
    possiblePaths.push({
        idx: -1,
        def: initialDef,
        ruleStack: [],
        occurrenceStack: []
    });
    while(possiblePaths.length !== 0){
        const currPath = possiblePaths.pop();
        if (currPath === EXIT_ALTERNATIVE) {
            if (foundCompletePath && possiblePaths.at(-1).idx <= minimalAlternativesIndex) possiblePaths.pop();
            continue;
        }
        const currDef = currPath.def;
        const currIdx = currPath.idx;
        const currRuleStack = currPath.ruleStack;
        const currOccurrenceStack = currPath.occurrenceStack;
        if (currDef.length === 0) continue;
        const prod = currDef[0];
        if (prod === EXIT_NON_TERMINAL) {
            const nextPath = {
                idx: currIdx,
                def: currDef.slice(1),
                ruleStack: currRuleStack.slice(0, -1),
                occurrenceStack: currOccurrenceStack.slice(0, -1)
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) {
            if (currIdx < tokenVectorLength - 1) {
                const nextIdx = currIdx + 1;
                const actualToken = tokenVector[nextIdx];
                if (tokMatcher(actualToken, prod.terminalType)) {
                    const nextPath = {
                        idx: nextIdx,
                        def: currDef.slice(1),
                        ruleStack: currRuleStack,
                        occurrenceStack: currOccurrenceStack
                    };
                    possiblePaths.push(nextPath);
                }
            } else if (currIdx === tokenVectorLength - 1) {
                result.push({
                    nextTokenType: prod.terminalType,
                    nextTokenOccurrence: prod.idx,
                    ruleStack: currRuleStack,
                    occurrenceStack: currOccurrenceStack
                });
                foundCompletePath = true;
            } else throw Error("non exhaustive match");
        } else if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) {
            const newRuleStack = [
                ...currRuleStack
            ];
            newRuleStack.push(prod.nonTerminalName);
            const newOccurrenceStack = [
                ...currOccurrenceStack
            ];
            newOccurrenceStack.push(prod.idx);
            const nextPath = {
                idx: currIdx,
                def: prod.definition.concat(EXIT_NON_TERMINAL_ARR, currDef.slice(1)),
                ruleStack: newRuleStack,
                occurrenceStack: newOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20) {
            const nextPathWithout = {
                idx: currIdx,
                def: currDef.slice(1),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            const nextPathWith = {
                idx: currIdx,
                def: prod.definition.concat(currDef.slice(1)),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8) {
            const secondIteration = new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                definition: prod.definition,
                idx: prod.idx
            });
            const nextDef = prod.definition.concat([
                secondIteration
            ], currDef.slice(1));
            const nextPath = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof $5d51f81a4b917e73$export$da6c5580175e0214) {
            const separatorGast = new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
                terminalType: prod.separator
            });
            const secondIteration = new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                definition: [
                    separatorGast
                ].concat(prod.definition),
                idx: prod.idx
            });
            const nextDef = prod.definition.concat([
                secondIteration
            ], currDef.slice(1));
            const nextPath = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8) {
            const nextPathWithout = {
                idx: currIdx,
                def: currDef.slice(1),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            const separatorGast = new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
                terminalType: prod.separator
            });
            const nthRepetition = new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                definition: [
                    separatorGast
                ].concat(prod.definition),
                idx: prod.idx
            });
            const nextDef = prod.definition.concat([
                nthRepetition
            ], currDef.slice(1));
            const nextPathWith = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) {
            const nextPathWithout = {
                idx: currIdx,
                def: currDef.slice(1),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            const nthRepetition = new $5d51f81a4b917e73$export$adf7bc0a69b784e9({
                definition: prod.definition,
                idx: prod.idx
            });
            const nextDef = prod.definition.concat([
                nthRepetition
            ], currDef.slice(1));
            const nextPathWith = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) for(let i = prod.definition.length - 1; i >= 0; i--){
            const currAlt = prod.definition[i];
            const currAltPath = {
                idx: currIdx,
                def: currAlt.definition.concat(currDef.slice(1)),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(currAltPath);
            possiblePaths.push(EXIT_ALTERNATIVE);
        }
        else if (prod instanceof $5d51f81a4b917e73$export$4acb47accde578d2) possiblePaths.push({
            idx: currIdx,
            def: prod.definition.concat(currDef.slice(1)),
            ruleStack: currRuleStack,
            occurrenceStack: currOccurrenceStack
        });
        else if (prod instanceof $5d51f81a4b917e73$export$f1ff2a90c38ff669) possiblePaths.push($5d51f81a4b917e73$var$expandTopLevelRule(prod, currIdx, currRuleStack, currOccurrenceStack));
        else throw Error("non exhaustive match");
    }
    return result;
}
function $5d51f81a4b917e73$var$expandTopLevelRule(topRule, currIdx, currRuleStack, currOccurrenceStack) {
    const newRuleStack = [
        ...currRuleStack
    ];
    newRuleStack.push(topRule.name);
    const newCurrOccurrenceStack = [
        ...currOccurrenceStack
    ];
    newCurrOccurrenceStack.push(1);
    return {
        idx: currIdx,
        def: topRule.definition,
        ruleStack: newRuleStack,
        occurrenceStack: newCurrOccurrenceStack
    };
}
// lib/src/parse/grammar/lookahead.js
var $5d51f81a4b917e73$var$PROD_TYPE;
(function(PROD_TYPE2) {
    PROD_TYPE2[PROD_TYPE2["OPTION"] = 0] = "OPTION";
    PROD_TYPE2[PROD_TYPE2["REPETITION"] = 1] = "REPETITION";
    PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY"] = 2] = "REPETITION_MANDATORY";
    PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY_WITH_SEPARATOR"] = 3] = "REPETITION_MANDATORY_WITH_SEPARATOR";
    PROD_TYPE2[PROD_TYPE2["REPETITION_WITH_SEPARATOR"] = 4] = "REPETITION_WITH_SEPARATOR";
    PROD_TYPE2[PROD_TYPE2["ALTERNATION"] = 5] = "ALTERNATION";
})($5d51f81a4b917e73$var$PROD_TYPE || ($5d51f81a4b917e73$var$PROD_TYPE = {}));
function $5d51f81a4b917e73$var$getProdType(prod) {
    if (prod instanceof $5d51f81a4b917e73$export$36d18380658d5d20 || prod === "Option") return $5d51f81a4b917e73$var$PROD_TYPE.OPTION;
    else if (prod instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9 || prod === "Repetition") return $5d51f81a4b917e73$var$PROD_TYPE.REPETITION;
    else if (prod instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8 || prod === "RepetitionMandatory") return $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY;
    else if (prod instanceof $5d51f81a4b917e73$export$da6c5580175e0214 || prod === "RepetitionMandatoryWithSeparator") return $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR;
    else if (prod instanceof $5d51f81a4b917e73$export$856dea708c981fb8 || prod === "RepetitionWithSeparator") return $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_WITH_SEPARATOR;
    else if (prod instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415 || prod === "Alternation") return $5d51f81a4b917e73$var$PROD_TYPE.ALTERNATION;
    else throw Error("non exhaustive match");
}
function $5d51f81a4b917e73$export$6f325009a545e54b(options) {
    const { occurrence: occurrence, rule: rule, prodType: prodType, maxLookahead: maxLookahead } = options;
    const type = $5d51f81a4b917e73$var$getProdType(prodType);
    if (type === $5d51f81a4b917e73$var$PROD_TYPE.ALTERNATION) return $5d51f81a4b917e73$var$getLookaheadPathsForOr(occurrence, rule, maxLookahead);
    else return $5d51f81a4b917e73$var$getLookaheadPathsForOptionalProd(occurrence, rule, type, maxLookahead);
}
function $5d51f81a4b917e73$var$buildLookaheadFuncForOr(occurrence, ruleGrammar, maxLookahead, hasPredicates, dynamicTokensEnabled, laFuncBuilder) {
    const lookAheadPaths = $5d51f81a4b917e73$var$getLookaheadPathsForOr(occurrence, ruleGrammar, maxLookahead);
    const tokenMatcher2 = $5d51f81a4b917e73$var$areTokenCategoriesNotUsed(lookAheadPaths) ? $5d51f81a4b917e73$var$tokenStructuredMatcherNoCategories : $5d51f81a4b917e73$var$tokenStructuredMatcher;
    return laFuncBuilder(lookAheadPaths, hasPredicates, tokenMatcher2, dynamicTokensEnabled);
}
function $5d51f81a4b917e73$var$buildLookaheadFuncForOptionalProd(occurrence, ruleGrammar, k, dynamicTokensEnabled, prodType, lookaheadBuilder) {
    const lookAheadPaths = $5d51f81a4b917e73$var$getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k);
    const tokenMatcher2 = $5d51f81a4b917e73$var$areTokenCategoriesNotUsed(lookAheadPaths) ? $5d51f81a4b917e73$var$tokenStructuredMatcherNoCategories : $5d51f81a4b917e73$var$tokenStructuredMatcher;
    return lookaheadBuilder(lookAheadPaths[0], tokenMatcher2, dynamicTokensEnabled);
}
function $5d51f81a4b917e73$var$buildAlternativesLookAheadFunc(alts, hasPredicates, tokenMatcher2, dynamicTokensEnabled) {
    const numOfAlts = alts.length;
    const areAllOneTokenLookahead = alts.every((currAlt)=>{
        return currAlt.every((currPath)=>{
            return currPath.length === 1;
        });
    });
    if (hasPredicates) return function(orAlts) {
        const predicates = orAlts.map((currAlt)=>currAlt.GATE);
        for(let t = 0; t < numOfAlts; t++){
            const currAlt = alts[t];
            const currNumOfPaths = currAlt.length;
            const currPredicate = predicates[t];
            if (currPredicate !== void 0 && currPredicate.call(this) === false) continue;
            nextPath: for(let j = 0; j < currNumOfPaths; j++){
                const currPath = currAlt[j];
                const currPathLength = currPath.length;
                for(let i = 0; i < currPathLength; i++){
                    const nextToken = this.LA_FAST(i + 1);
                    if (tokenMatcher2(nextToken, currPath[i]) === false) continue nextPath;
                }
                return t;
            }
        }
        return void 0;
    };
    else if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
        const singleTokenAlts = alts.map((currAlt)=>{
            return currAlt.flat();
        });
        const choiceToAlt = singleTokenAlts.reduce((result, currAlt, idx)=>{
            currAlt.forEach((currTokType)=>{
                if (!(currTokType.tokenTypeIdx in result)) result[currTokType.tokenTypeIdx] = idx;
                currTokType.categoryMatches.forEach((currExtendingType)=>{
                    if (!Object.hasOwn(result, currExtendingType)) result[currExtendingType] = idx;
                });
            });
            return result;
        }, {});
        return function() {
            const nextToken = this.LA_FAST(1);
            return choiceToAlt[nextToken.tokenTypeIdx];
        };
    } else return function() {
        for(let t = 0; t < numOfAlts; t++){
            const currAlt = alts[t];
            const currNumOfPaths = currAlt.length;
            nextPath: for(let j = 0; j < currNumOfPaths; j++){
                const currPath = currAlt[j];
                const currPathLength = currPath.length;
                for(let i = 0; i < currPathLength; i++){
                    const nextToken = this.LA_FAST(i + 1);
                    if (tokenMatcher2(nextToken, currPath[i]) === false) continue nextPath;
                }
                return t;
            }
        }
        return void 0;
    };
}
function $5d51f81a4b917e73$var$buildSingleAlternativeLookaheadFunction(alt, tokenMatcher2, dynamicTokensEnabled) {
    const areAllOneTokenLookahead = alt.every((currPath)=>{
        return currPath.length === 1;
    });
    const numOfPaths = alt.length;
    if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
        const singleTokensTypes = alt.flat();
        if (singleTokensTypes.length === 1 && singleTokensTypes[0].categoryMatches.length === 0) {
            const expectedTokenType = singleTokensTypes[0];
            const expectedTokenUniqueKey = expectedTokenType.tokenTypeIdx;
            return function() {
                return this.LA_FAST(1).tokenTypeIdx === expectedTokenUniqueKey;
            };
        } else {
            const choiceToAlt = singleTokensTypes.reduce((result, currTokType, idx)=>{
                result[currTokType.tokenTypeIdx] = true;
                currTokType.categoryMatches.forEach((currExtendingType)=>{
                    result[currExtendingType] = true;
                });
                return result;
            }, []);
            return function() {
                const nextToken = this.LA_FAST(1);
                return choiceToAlt[nextToken.tokenTypeIdx] === true;
            };
        }
    } else return function() {
        nextPath: for(let j = 0; j < numOfPaths; j++){
            const currPath = alt[j];
            const currPathLength = currPath.length;
            for(let i = 0; i < currPathLength; i++){
                const nextToken = this.LA_FAST(i + 1);
                if (tokenMatcher2(nextToken, currPath[i]) === false) continue nextPath;
            }
            return true;
        }
        return false;
    };
}
var $5d51f81a4b917e73$var$RestDefinitionFinderWalker = class extends $5d51f81a4b917e73$var$RestWalker {
    constructor(topProd, targetOccurrence, targetProdType){
        super();
        this.topProd = topProd;
        this.targetOccurrence = targetOccurrence;
        this.targetProdType = targetProdType;
    }
    startWalking() {
        this.walk(this.topProd);
        return this.restDef;
    }
    checkIsTarget(node, expectedProdType, currRest, prevRest) {
        if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdType) {
            this.restDef = currRest.concat(prevRest);
            return true;
        }
        return false;
    }
    walkOption(optionProd, currRest, prevRest) {
        if (!this.checkIsTarget(optionProd, $5d51f81a4b917e73$var$PROD_TYPE.OPTION, currRest, prevRest)) super.walkOption(optionProd, currRest, prevRest);
    }
    walkAtLeastOne(atLeastOneProd, currRest, prevRest) {
        if (!this.checkIsTarget(atLeastOneProd, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY, currRest, prevRest)) super.walkOption(atLeastOneProd, currRest, prevRest);
    }
    walkAtLeastOneSep(atLeastOneSepProd, currRest, prevRest) {
        if (!this.checkIsTarget(atLeastOneSepProd, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, currRest, prevRest)) super.walkOption(atLeastOneSepProd, currRest, prevRest);
    }
    walkMany(manyProd, currRest, prevRest) {
        if (!this.checkIsTarget(manyProd, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION, currRest, prevRest)) super.walkOption(manyProd, currRest, prevRest);
    }
    walkManySep(manySepProd, currRest, prevRest) {
        if (!this.checkIsTarget(manySepProd, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_WITH_SEPARATOR, currRest, prevRest)) super.walkOption(manySepProd, currRest, prevRest);
    }
};
var $5d51f81a4b917e73$var$InsideDefinitionFinderVisitor = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(targetOccurrence, targetProdType, targetRef){
        super();
        this.targetOccurrence = targetOccurrence;
        this.targetProdType = targetProdType;
        this.targetRef = targetRef;
        this.result = [];
    }
    checkIsTarget(node, expectedProdName) {
        if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdName && (this.targetRef === void 0 || node === this.targetRef)) this.result = node.definition;
    }
    visitOption(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.OPTION);
    }
    visitRepetition(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION);
    }
    visitRepetitionMandatory(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY);
    }
    visitRepetitionMandatoryWithSeparator(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR);
    }
    visitRepetitionWithSeparator(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_WITH_SEPARATOR);
    }
    visitAlternation(node) {
        this.checkIsTarget(node, $5d51f81a4b917e73$var$PROD_TYPE.ALTERNATION);
    }
};
function $5d51f81a4b917e73$var$initializeArrayOfArrays(size) {
    const result = new Array(size);
    for(let i = 0; i < size; i++)result[i] = [];
    return result;
}
function $5d51f81a4b917e73$var$pathToHashKeys(path) {
    let keys = [
        ""
    ];
    for(let i = 0; i < path.length; i++){
        const tokType = path[i];
        const longerKeys = [];
        for(let j = 0; j < keys.length; j++){
            const currShorterKey = keys[j];
            longerKeys.push(currShorterKey + "_" + tokType.tokenTypeIdx);
            for(let t = 0; t < tokType.categoryMatches.length; t++){
                const categoriesKeySuffix = "_" + tokType.categoryMatches[t];
                longerKeys.push(currShorterKey + categoriesKeySuffix);
            }
        }
        keys = longerKeys;
    }
    return keys;
}
function $5d51f81a4b917e73$var$isUniquePrefixHash(altKnownPathsKeys, searchPathKeys, idx) {
    for(let currAltIdx = 0; currAltIdx < altKnownPathsKeys.length; currAltIdx++){
        if (currAltIdx === idx) continue;
        const otherAltKnownPathsKeys = altKnownPathsKeys[currAltIdx];
        for(let searchIdx = 0; searchIdx < searchPathKeys.length; searchIdx++){
            const searchKey = searchPathKeys[searchIdx];
            if (otherAltKnownPathsKeys[searchKey] === true) return false;
        }
    }
    return true;
}
function $5d51f81a4b917e73$var$lookAheadSequenceFromAlternatives(altsDefs, k) {
    const partialAlts = altsDefs.map((currAlt)=>$5d51f81a4b917e73$var$possiblePathsFrom([
            currAlt
        ], 1));
    const finalResult = $5d51f81a4b917e73$var$initializeArrayOfArrays(partialAlts.length);
    const altsHashes = partialAlts.map((currAltPaths)=>{
        const dict = {};
        currAltPaths.forEach((item)=>{
            const keys = $5d51f81a4b917e73$var$pathToHashKeys(item.partialPath);
            keys.forEach((currKey)=>{
                dict[currKey] = true;
            });
        });
        return dict;
    });
    let newData = partialAlts;
    for(let pathLength = 1; pathLength <= k; pathLength++){
        const currDataset = newData;
        newData = $5d51f81a4b917e73$var$initializeArrayOfArrays(currDataset.length);
        for(let altIdx = 0; altIdx < currDataset.length; altIdx++){
            const currAltPathsAndSuffixes = currDataset[altIdx];
            for(let currPathIdx = 0; currPathIdx < currAltPathsAndSuffixes.length; currPathIdx++){
                const currPathPrefix = currAltPathsAndSuffixes[currPathIdx].partialPath;
                const suffixDef = currAltPathsAndSuffixes[currPathIdx].suffixDef;
                const prefixKeys = $5d51f81a4b917e73$var$pathToHashKeys(currPathPrefix);
                const isUnique = $5d51f81a4b917e73$var$isUniquePrefixHash(altsHashes, prefixKeys, altIdx);
                if (isUnique || suffixDef.length === 0 || currPathPrefix.length === k) {
                    const currAltResult = finalResult[altIdx];
                    if ($5d51f81a4b917e73$var$containsPath(currAltResult, currPathPrefix) === false) {
                        currAltResult.push(currPathPrefix);
                        for(let j = 0; j < prefixKeys.length; j++){
                            const currKey = prefixKeys[j];
                            altsHashes[altIdx][currKey] = true;
                        }
                    }
                } else {
                    const newPartialPathsAndSuffixes = $5d51f81a4b917e73$var$possiblePathsFrom(suffixDef, pathLength + 1, currPathPrefix);
                    newData[altIdx] = newData[altIdx].concat(newPartialPathsAndSuffixes);
                    newPartialPathsAndSuffixes.forEach((item)=>{
                        const prefixKeys2 = $5d51f81a4b917e73$var$pathToHashKeys(item.partialPath);
                        prefixKeys2.forEach((key)=>{
                            altsHashes[altIdx][key] = true;
                        });
                    });
                }
            }
        }
    }
    return finalResult;
}
function $5d51f81a4b917e73$var$getLookaheadPathsForOr(occurrence, ruleGrammar, k, orProd) {
    const visitor = new $5d51f81a4b917e73$var$InsideDefinitionFinderVisitor(occurrence, $5d51f81a4b917e73$var$PROD_TYPE.ALTERNATION, orProd);
    ruleGrammar.accept(visitor);
    return $5d51f81a4b917e73$var$lookAheadSequenceFromAlternatives(visitor.result, k);
}
function $5d51f81a4b917e73$var$getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k) {
    const insideDefVisitor = new $5d51f81a4b917e73$var$InsideDefinitionFinderVisitor(occurrence, prodType);
    ruleGrammar.accept(insideDefVisitor);
    const insideDef = insideDefVisitor.result;
    const afterDefWalker = new $5d51f81a4b917e73$var$RestDefinitionFinderWalker(ruleGrammar, occurrence, prodType);
    const afterDef = afterDefWalker.startWalking();
    const insideFlat = new $5d51f81a4b917e73$export$4acb47accde578d2({
        definition: insideDef
    });
    const afterFlat = new $5d51f81a4b917e73$export$4acb47accde578d2({
        definition: afterDef
    });
    return $5d51f81a4b917e73$var$lookAheadSequenceFromAlternatives([
        insideFlat,
        afterFlat
    ], k);
}
function $5d51f81a4b917e73$var$containsPath(alternative, searchPath) {
    compareOtherPath: for(let i = 0; i < alternative.length; i++){
        const otherPath = alternative[i];
        if (otherPath.length !== searchPath.length) continue;
        for(let j = 0; j < otherPath.length; j++){
            const searchTok = searchPath[j];
            const otherTok = otherPath[j];
            const matchingTokens = searchTok === otherTok || otherTok.categoryMatchesMap[searchTok.tokenTypeIdx] !== void 0;
            if (matchingTokens === false) continue compareOtherPath;
        }
        return true;
    }
    return false;
}
function $5d51f81a4b917e73$var$isStrictPrefixOfPath(prefix, other) {
    return prefix.length < other.length && prefix.every((tokType, idx)=>{
        const otherTokType = other[idx];
        return tokType === otherTokType || otherTokType.categoryMatchesMap[tokType.tokenTypeIdx];
    });
}
function $5d51f81a4b917e73$var$areTokenCategoriesNotUsed(lookAheadPaths) {
    return lookAheadPaths.every((singleAltPaths)=>singleAltPaths.every((singlePath)=>singlePath.every((token)=>token.categoryMatches.length === 0)));
}
// lib/src/parse/grammar/checks.js
function $5d51f81a4b917e73$var$validateLookahead(options) {
    const lookaheadValidationErrorMessages = options.lookaheadStrategy.validate({
        rules: options.rules,
        tokenTypes: options.tokenTypes,
        grammarName: options.grammarName
    });
    return lookaheadValidationErrorMessages.map((errorMessage)=>Object.assign({
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.CUSTOM_LOOKAHEAD_VALIDATION
        }, errorMessage));
}
function $5d51f81a4b917e73$var$validateGrammar(topLevels, tokenTypes, errMsgProvider, grammarName) {
    const duplicateErrors = topLevels.flatMap((currTopLevel)=>$5d51f81a4b917e73$var$validateDuplicateProductions(currTopLevel, errMsgProvider));
    const termsNamespaceConflictErrors = $5d51f81a4b917e73$var$checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider);
    const tooManyAltsErrors = topLevels.flatMap((curRule)=>$5d51f81a4b917e73$var$validateTooManyAlts(curRule, errMsgProvider));
    const duplicateRulesError = topLevels.flatMap((curRule)=>$5d51f81a4b917e73$var$validateRuleDoesNotAlreadyExist(curRule, topLevels, grammarName, errMsgProvider));
    return duplicateErrors.concat(termsNamespaceConflictErrors, tooManyAltsErrors, duplicateRulesError);
}
function $5d51f81a4b917e73$var$validateDuplicateProductions(topLevelRule, errMsgProvider) {
    const collectorVisitor2 = new $5d51f81a4b917e73$var$OccurrenceValidationCollector();
    topLevelRule.accept(collectorVisitor2);
    const allRuleProductions = collectorVisitor2.allProductions;
    const productionGroups = Object.groupBy(allRuleProductions, $5d51f81a4b917e73$var$identifyProductionForDuplicates);
    const duplicates = Object.fromEntries(Object.entries(productionGroups).filter(([_k, currGroup])=>currGroup.length > 1));
    const errors = Object.values(duplicates).map((currDuplicates)=>{
        const firstProd = currDuplicates[0];
        const msg = errMsgProvider.buildDuplicateFoundError(topLevelRule, currDuplicates);
        const dslName = $5d51f81a4b917e73$var$getProductionDslName(firstProd);
        const defError = {
            message: msg,
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.DUPLICATE_PRODUCTIONS,
            ruleName: topLevelRule.name,
            dslName: dslName,
            occurrence: firstProd.idx
        };
        const param = $5d51f81a4b917e73$var$getExtraProductionArgument(firstProd);
        if (param) defError.parameter = param;
        return defError;
    });
    return errors;
}
function $5d51f81a4b917e73$var$identifyProductionForDuplicates(prod) {
    return `${$5d51f81a4b917e73$var$getProductionDslName(prod)}_#_${prod.idx}_#_${$5d51f81a4b917e73$var$getExtraProductionArgument(prod)}`;
}
function $5d51f81a4b917e73$var$getExtraProductionArgument(prod) {
    if (prod instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) return prod.terminalType.name;
    else if (prod instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return prod.nonTerminalName;
    else return "";
}
var $5d51f81a4b917e73$var$OccurrenceValidationCollector = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(){
        super(...arguments);
        this.allProductions = [];
    }
    visitNonTerminal(subrule) {
        this.allProductions.push(subrule);
    }
    visitOption(option) {
        this.allProductions.push(option);
    }
    visitRepetitionWithSeparator(manySep) {
        this.allProductions.push(manySep);
    }
    visitRepetitionMandatory(atLeastOne) {
        this.allProductions.push(atLeastOne);
    }
    visitRepetitionMandatoryWithSeparator(atLeastOneSep) {
        this.allProductions.push(atLeastOneSep);
    }
    visitRepetition(many) {
        this.allProductions.push(many);
    }
    visitAlternation(or) {
        this.allProductions.push(or);
    }
    visitTerminal(terminal) {
        this.allProductions.push(terminal);
    }
};
function $5d51f81a4b917e73$var$validateRuleDoesNotAlreadyExist(rule, allRules, className, errMsgProvider) {
    const errors = [];
    const occurrences = allRules.reduce((result, curRule)=>{
        if (curRule.name === rule.name) return result + 1;
        return result;
    }, 0);
    if (occurrences > 1) {
        const errMsg = errMsgProvider.buildDuplicateRuleNameError({
            topLevelRule: rule,
            grammarName: className
        });
        errors.push({
            message: errMsg,
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.DUPLICATE_RULE_NAME,
            ruleName: rule.name
        });
    }
    return errors;
}
function $5d51f81a4b917e73$var$validateRuleIsOverridden(ruleName, definedRulesNames, className) {
    const errors = [];
    let errMsg;
    if (!definedRulesNames.includes(ruleName)) {
        errMsg = `Invalid rule override, rule: ->${ruleName}<- cannot be overridden in the grammar: ->${className}<-as it is not defined in any of the super grammars `;
        errors.push({
            message: errMsg,
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.INVALID_RULE_OVERRIDE,
            ruleName: ruleName
        });
    }
    return errors;
}
function $5d51f81a4b917e73$var$validateNoLeftRecursion(topRule, currRule, errMsgProvider, path = []) {
    const errors = [];
    const nextNonTerminals = $5d51f81a4b917e73$var$getFirstNoneTerminal(currRule.definition);
    if (nextNonTerminals.length === 0) return [];
    else {
        const ruleName = topRule.name;
        const foundLeftRecursion = nextNonTerminals.includes(topRule);
        if (foundLeftRecursion) errors.push({
            message: errMsgProvider.buildLeftRecursionError({
                topLevelRule: topRule,
                leftRecursionPath: path
            }),
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.LEFT_RECURSION,
            ruleName: ruleName
        });
        const excluded = path.concat([
            topRule
        ]);
        const validNextSteps = nextNonTerminals.filter((x)=>!excluded.includes(x));
        const errorsFromNextSteps = validNextSteps.flatMap((currRefRule)=>{
            const newPath = [
                ...path
            ];
            newPath.push(currRefRule);
            return $5d51f81a4b917e73$var$validateNoLeftRecursion(topRule, currRefRule, errMsgProvider, newPath);
        });
        return errors.concat(errorsFromNextSteps);
    }
}
function $5d51f81a4b917e73$var$getFirstNoneTerminal(definition) {
    let result = [];
    if (definition.length === 0) return result;
    const firstProd = definition[0];
    if (firstProd instanceof $5d51f81a4b917e73$export$ab116ec58638c09) result.push(firstProd.referencedRule);
    else if (firstProd instanceof $5d51f81a4b917e73$export$4acb47accde578d2 || firstProd instanceof $5d51f81a4b917e73$export$36d18380658d5d20 || firstProd instanceof $5d51f81a4b917e73$export$d068cf3ccde3d9e8 || firstProd instanceof $5d51f81a4b917e73$export$da6c5580175e0214 || firstProd instanceof $5d51f81a4b917e73$export$856dea708c981fb8 || firstProd instanceof $5d51f81a4b917e73$export$adf7bc0a69b784e9) result = result.concat($5d51f81a4b917e73$var$getFirstNoneTerminal(firstProd.definition));
    else if (firstProd instanceof $5d51f81a4b917e73$export$d8895f7a7cf86415) result = firstProd.definition.map((currSubDef)=>$5d51f81a4b917e73$var$getFirstNoneTerminal(currSubDef.definition)).flat();
    else if (firstProd instanceof $5d51f81a4b917e73$export$8dd80f06eb58bfe1) ;
    else throw Error("non exhaustive match");
    const isFirstOptional = $5d51f81a4b917e73$var$isOptionalProd(firstProd);
    const hasMore = definition.length > 1;
    if (isFirstOptional && hasMore) {
        const rest = definition.slice(1);
        return result.concat($5d51f81a4b917e73$var$getFirstNoneTerminal(rest));
    } else return result;
}
var $5d51f81a4b917e73$var$OrCollector = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(){
        super(...arguments);
        this.alternations = [];
    }
    visitAlternation(node) {
        this.alternations.push(node);
    }
};
function $5d51f81a4b917e73$var$validateEmptyOrAlternative(topLevelRule, errMsgProvider) {
    const orCollector = new $5d51f81a4b917e73$var$OrCollector();
    topLevelRule.accept(orCollector);
    const ors = orCollector.alternations;
    const errors = ors.flatMap((currOr)=>{
        const exceptLast = currOr.definition.slice(0, -1);
        return exceptLast.flatMap((currAlternative, currAltIdx)=>{
            const possibleFirstInAlt = $5d51f81a4b917e73$var$nextPossibleTokensAfter([
                currAlternative
            ], [], $5d51f81a4b917e73$var$tokenStructuredMatcher, 1);
            if (possibleFirstInAlt.length === 0) return [
                {
                    message: errMsgProvider.buildEmptyAlternationError({
                        topLevelRule: topLevelRule,
                        alternation: currOr,
                        emptyChoiceIdx: currAltIdx
                    }),
                    type: $5d51f81a4b917e73$export$86bd3f602f298cb6.NONE_LAST_EMPTY_ALT,
                    ruleName: topLevelRule.name,
                    occurrence: currOr.idx,
                    alternative: currAltIdx + 1
                }
            ];
            else return [];
        });
    });
    return errors;
}
function $5d51f81a4b917e73$var$validateAmbiguousAlternationAlternatives(topLevelRule, globalMaxLookahead, errMsgProvider) {
    const orCollector = new $5d51f81a4b917e73$var$OrCollector();
    topLevelRule.accept(orCollector);
    let ors = orCollector.alternations;
    ors = ors.filter((currOr)=>currOr.ignoreAmbiguities !== true);
    const errors = ors.flatMap((currOr)=>{
        const currOccurrence = currOr.idx;
        const actualMaxLookahead = currOr.maxLookahead || globalMaxLookahead;
        const alternatives = $5d51f81a4b917e73$var$getLookaheadPathsForOr(currOccurrence, topLevelRule, actualMaxLookahead, currOr);
        const altsAmbiguityErrors = $5d51f81a4b917e73$var$checkAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
        const altsPrefixAmbiguityErrors = $5d51f81a4b917e73$var$checkPrefixAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
        return altsAmbiguityErrors.concat(altsPrefixAmbiguityErrors);
    });
    return errors;
}
var $5d51f81a4b917e73$var$RepetitionCollector = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(){
        super(...arguments);
        this.allProductions = [];
    }
    visitRepetitionWithSeparator(manySep) {
        this.allProductions.push(manySep);
    }
    visitRepetitionMandatory(atLeastOne) {
        this.allProductions.push(atLeastOne);
    }
    visitRepetitionMandatoryWithSeparator(atLeastOneSep) {
        this.allProductions.push(atLeastOneSep);
    }
    visitRepetition(many) {
        this.allProductions.push(many);
    }
};
function $5d51f81a4b917e73$var$validateTooManyAlts(topLevelRule, errMsgProvider) {
    const orCollector = new $5d51f81a4b917e73$var$OrCollector();
    topLevelRule.accept(orCollector);
    const ors = orCollector.alternations;
    const errors = ors.flatMap((currOr)=>{
        if (currOr.definition.length > 255) return [
            {
                message: errMsgProvider.buildTooManyAlternativesError({
                    topLevelRule: topLevelRule,
                    alternation: currOr
                }),
                type: $5d51f81a4b917e73$export$86bd3f602f298cb6.TOO_MANY_ALTS,
                ruleName: topLevelRule.name,
                occurrence: currOr.idx
            }
        ];
        else return [];
    });
    return errors;
}
function $5d51f81a4b917e73$var$validateSomeNonEmptyLookaheadPath(topLevelRules, maxLookahead, errMsgProvider) {
    const errors = [];
    topLevelRules.forEach((currTopRule)=>{
        const collectorVisitor2 = new $5d51f81a4b917e73$var$RepetitionCollector();
        currTopRule.accept(collectorVisitor2);
        const allRuleProductions = collectorVisitor2.allProductions;
        allRuleProductions.forEach((currProd)=>{
            const prodType = $5d51f81a4b917e73$var$getProdType(currProd);
            const actualMaxLookahead = currProd.maxLookahead || maxLookahead;
            const currOccurrence = currProd.idx;
            const paths = $5d51f81a4b917e73$var$getLookaheadPathsForOptionalProd(currOccurrence, currTopRule, prodType, actualMaxLookahead);
            const pathsInsideProduction = paths[0];
            if (pathsInsideProduction.flat().length === 0) {
                const errMsg = errMsgProvider.buildEmptyRepetitionError({
                    topLevelRule: currTopRule,
                    repetition: currProd
                });
                errors.push({
                    message: errMsg,
                    type: $5d51f81a4b917e73$export$86bd3f602f298cb6.NO_NON_EMPTY_LOOKAHEAD,
                    ruleName: currTopRule.name
                });
            }
        });
    });
    return errors;
}
function $5d51f81a4b917e73$var$checkAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
    const foundAmbiguousPaths = [];
    const identicalAmbiguities = alternatives.reduce((result, currAlt, currAltIdx)=>{
        if (alternation.definition[currAltIdx].ignoreAmbiguities === true) return result;
        currAlt.forEach((currPath)=>{
            const altsCurrPathAppearsIn = [
                currAltIdx
            ];
            alternatives.forEach((currOtherAlt, currOtherAltIdx)=>{
                if (currAltIdx !== currOtherAltIdx && $5d51f81a4b917e73$var$containsPath(currOtherAlt, currPath) && // ignore (skip) ambiguities with this "other" alternative
                alternation.definition[currOtherAltIdx].ignoreAmbiguities !== true) altsCurrPathAppearsIn.push(currOtherAltIdx);
            });
            if (altsCurrPathAppearsIn.length > 1 && !$5d51f81a4b917e73$var$containsPath(foundAmbiguousPaths, currPath)) {
                foundAmbiguousPaths.push(currPath);
                result.push({
                    alts: altsCurrPathAppearsIn,
                    path: currPath
                });
            }
        });
        return result;
    }, []);
    const currErrors = identicalAmbiguities.map((currAmbDescriptor)=>{
        const ambgIndices = currAmbDescriptor.alts.map((currAltIdx)=>currAltIdx + 1);
        const currMessage = errMsgProvider.buildAlternationAmbiguityError({
            topLevelRule: rule,
            alternation: alternation,
            ambiguityIndices: ambgIndices,
            prefixPath: currAmbDescriptor.path
        });
        return {
            message: currMessage,
            type: $5d51f81a4b917e73$export$86bd3f602f298cb6.AMBIGUOUS_ALTS,
            ruleName: rule.name,
            occurrence: alternation.idx,
            alternatives: currAmbDescriptor.alts
        };
    });
    return currErrors;
}
function $5d51f81a4b917e73$var$checkPrefixAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
    const pathsAndIndices = alternatives.reduce((result, currAlt, idx)=>{
        const currPathsAndIdx = currAlt.map((currPath)=>{
            return {
                idx: idx,
                path: currPath
            };
        });
        return result.concat(currPathsAndIdx);
    }, []);
    const errors = pathsAndIndices.flatMap((currPathAndIdx)=>{
        const alternativeGast = alternation.definition[currPathAndIdx.idx];
        if (alternativeGast.ignoreAmbiguities === true) return [];
        const targetIdx = currPathAndIdx.idx;
        const targetPath = currPathAndIdx.path;
        const prefixAmbiguitiesPathsAndIndices = pathsAndIndices.filter((searchPathAndIdx)=>{
            return(// ignore (skip) ambiguities with this "other" alternative
            alternation.definition[searchPathAndIdx.idx].ignoreAmbiguities !== true && searchPathAndIdx.idx < targetIdx && // checking for strict prefix because identical lookaheads
            // will be be detected using a different validation.
            $5d51f81a4b917e73$var$isStrictPrefixOfPath(searchPathAndIdx.path, targetPath));
        });
        const currPathPrefixErrors = prefixAmbiguitiesPathsAndIndices.map((currAmbPathAndIdx)=>{
            const ambgIndices = [
                currAmbPathAndIdx.idx + 1,
                targetIdx + 1
            ];
            const occurrence = alternation.idx === 0 ? "" : alternation.idx;
            const message = errMsgProvider.buildAlternationPrefixAmbiguityError({
                topLevelRule: rule,
                alternation: alternation,
                ambiguityIndices: ambgIndices,
                prefixPath: currAmbPathAndIdx.path
            });
            return {
                message: message,
                type: $5d51f81a4b917e73$export$86bd3f602f298cb6.AMBIGUOUS_PREFIX_ALTS,
                ruleName: rule.name,
                occurrence: occurrence,
                alternatives: ambgIndices
            };
        });
        return currPathPrefixErrors;
    });
    return errors;
}
function $5d51f81a4b917e73$var$checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider) {
    const errors = [];
    const tokenNames = tokenTypes.map((currToken)=>currToken.name);
    topLevels.forEach((currRule)=>{
        const currRuleName = currRule.name;
        if (tokenNames.includes(currRuleName)) {
            const errMsg = errMsgProvider.buildNamespaceConflictError(currRule);
            errors.push({
                message: errMsg,
                type: $5d51f81a4b917e73$export$86bd3f602f298cb6.CONFLICT_TOKENS_RULES_NAMESPACE,
                ruleName: currRuleName
            });
        }
    });
    return errors;
}
// lib/src/parse/grammar/gast/gast_resolver_public.js
function $5d51f81a4b917e73$var$resolveGrammar2(options) {
    const actualOptions = Object.assign({
        errMsgProvider: $5d51f81a4b917e73$var$defaultGrammarResolverErrorProvider
    }, options);
    const topRulesTable = {};
    options.rules.forEach((rule)=>{
        topRulesTable[rule.name] = rule;
    });
    return $5d51f81a4b917e73$var$resolveGrammar(topRulesTable, actualOptions.errMsgProvider);
}
function $5d51f81a4b917e73$var$validateGrammar2(options) {
    var _a;
    const errMsgProvider = (_a = options.errMsgProvider) !== null && _a !== void 0 ? _a : $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider;
    return $5d51f81a4b917e73$var$validateGrammar(options.rules, options.tokenTypes, errMsgProvider, options.grammarName);
}
// lib/src/parse/exceptions_public.js
var $5d51f81a4b917e73$var$MISMATCHED_TOKEN_EXCEPTION = "MismatchedTokenException";
var $5d51f81a4b917e73$var$NO_VIABLE_ALT_EXCEPTION = "NoViableAltException";
var $5d51f81a4b917e73$var$EARLY_EXIT_EXCEPTION = "EarlyExitException";
var $5d51f81a4b917e73$var$NOT_ALL_INPUT_PARSED_EXCEPTION = "NotAllInputParsedException";
var $5d51f81a4b917e73$var$RECOGNITION_EXCEPTION_NAMES = [
    $5d51f81a4b917e73$var$MISMATCHED_TOKEN_EXCEPTION,
    $5d51f81a4b917e73$var$NO_VIABLE_ALT_EXCEPTION,
    $5d51f81a4b917e73$var$EARLY_EXIT_EXCEPTION,
    $5d51f81a4b917e73$var$NOT_ALL_INPUT_PARSED_EXCEPTION
];
Object.freeze($5d51f81a4b917e73$var$RECOGNITION_EXCEPTION_NAMES);
function $5d51f81a4b917e73$export$93d1e12f7a3ec65(error) {
    return $5d51f81a4b917e73$var$RECOGNITION_EXCEPTION_NAMES.includes(error.name);
}
var $5d51f81a4b917e73$var$RecognitionException = class extends Error {
    constructor(message, token){
        super(message);
        this.token = token;
        this.resyncedTokens = [];
        Object.setPrototypeOf(this, new.target.prototype);
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    }
};
var $5d51f81a4b917e73$export$e052327bfb3cf890 = class extends $5d51f81a4b917e73$var$RecognitionException {
    constructor(message, token, previousToken){
        super(message, token);
        this.previousToken = previousToken;
        this.name = $5d51f81a4b917e73$var$MISMATCHED_TOKEN_EXCEPTION;
    }
};
var $5d51f81a4b917e73$export$24170894ee7a3e61 = class extends $5d51f81a4b917e73$var$RecognitionException {
    constructor(message, token, previousToken){
        super(message, token);
        this.previousToken = previousToken;
        this.name = $5d51f81a4b917e73$var$NO_VIABLE_ALT_EXCEPTION;
    }
};
var $5d51f81a4b917e73$export$3d36978a8da4a7e = class extends $5d51f81a4b917e73$var$RecognitionException {
    constructor(message, token){
        super(message, token);
        this.name = $5d51f81a4b917e73$var$NOT_ALL_INPUT_PARSED_EXCEPTION;
    }
};
var $5d51f81a4b917e73$export$d9af24ca3761c042 = class extends $5d51f81a4b917e73$var$RecognitionException {
    constructor(message, token, previousToken){
        super(message, token);
        this.previousToken = previousToken;
        this.name = $5d51f81a4b917e73$var$EARLY_EXIT_EXCEPTION;
    }
};
// lib/src/parse/parser/traits/recoverable.js
var $5d51f81a4b917e73$var$EOF_FOLLOW_KEY = {};
var $5d51f81a4b917e73$var$IN_RULE_RECOVERY_EXCEPTION = "InRuleRecoveryException";
var $5d51f81a4b917e73$var$InRuleRecoveryException = class extends Error {
    constructor(message){
        super(message);
        this.name = $5d51f81a4b917e73$var$IN_RULE_RECOVERY_EXCEPTION;
    }
};
var $5d51f81a4b917e73$var$Recoverable = class {
    initRecoverable(config) {
        this.firstAfterRepMap = [];
        this.resyncFollows = {};
        this.recoveryEnabled = Object.hasOwn(config, "recoveryEnabled") ? config.recoveryEnabled : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.recoveryEnabled;
        if (this.recoveryEnabled) this.attemptInRepetitionRecovery = $5d51f81a4b917e73$var$attemptInRepetitionRecovery;
    }
    getTokenToInsert(tokType) {
        const tokToInsert = $5d51f81a4b917e73$export$eaddf8d68927eada(tokType, "", -1, -1, -1, -1, -1, -1);
        tokToInsert.isInsertedInRecovery = true;
        return tokToInsert;
    }
    canTokenTypeBeInsertedInRecovery(tokType) {
        return true;
    }
    canTokenTypeBeDeletedInRecovery(tokType) {
        return true;
    }
    tryInRepetitionRecovery(grammarRule, grammarRuleArgs, lookAheadFunc, expectedTokType) {
        const reSyncTokType = this.findReSyncTokenType();
        const savedLexerState = this.exportLexerState();
        const resyncedTokens = [];
        let passedResyncPoint = false;
        const nextTokenWithoutResync = this.LA_FAST(1);
        let currToken = this.LA_FAST(1);
        const generateErrorMessage = ()=>{
            const previousToken = this.LA(0);
            const msg = this.errorMessageProvider.buildMismatchTokenMessage({
                expected: expectedTokType,
                actual: nextTokenWithoutResync,
                previous: previousToken,
                ruleName: this.getCurrRuleFullName()
            });
            const error = new $5d51f81a4b917e73$export$e052327bfb3cf890(msg, nextTokenWithoutResync, this.LA(0));
            error.resyncedTokens = resyncedTokens.slice(0, -1);
            this.SAVE_ERROR(error);
        };
        while(!passedResyncPoint){
            if (this.tokenMatcher(currToken, expectedTokType)) {
                generateErrorMessage();
                return;
            } else if (lookAheadFunc.call(this)) {
                generateErrorMessage();
                grammarRule.apply(this, grammarRuleArgs);
                return;
            } else if (this.tokenMatcher(currToken, reSyncTokType)) passedResyncPoint = true;
            else {
                currToken = this.SKIP_TOKEN();
                this.addToResyncTokens(currToken, resyncedTokens);
            }
        }
        this.importLexerState(savedLexerState);
    }
    shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx, notStuck) {
        if (notStuck === false) return false;
        if (this.tokenMatcher(this.LA_FAST(1), expectTokAfterLastMatch)) return false;
        if (this.isBackTracking()) return false;
        if (this.canPerformInRuleRecovery(expectTokAfterLastMatch, this.getFollowsForInRuleRecovery(expectTokAfterLastMatch, nextTokIdx))) return false;
        return true;
    }
    // TODO: should this be a member method or a utility? it does not have any state or usage of 'this'...
    // TODO: should this be more explicitly part of the public API?
    getNextPossibleTokenTypes(grammarPath) {
        const topRuleName = grammarPath.ruleStack[0];
        const gastProductions = this.getGAstProductions();
        const topProduction = gastProductions[topRuleName];
        const nextPossibleTokenTypes = new $5d51f81a4b917e73$var$NextAfterTokenWalker(topProduction, grammarPath).startWalking();
        return nextPossibleTokenTypes;
    }
    // Error Recovery functionality
    getFollowsForInRuleRecovery(tokType, tokIdxInRule) {
        const grammarPath = this.getCurrentGrammarPath(tokType, tokIdxInRule);
        const follows = this.getNextPossibleTokenTypes(grammarPath);
        return follows;
    }
    tryInRuleRecovery(expectedTokType, follows) {
        if (this.canRecoverWithSingleTokenInsertion(expectedTokType, follows)) {
            const tokToInsert = this.getTokenToInsert(expectedTokType);
            return tokToInsert;
        }
        if (this.canRecoverWithSingleTokenDeletion(expectedTokType)) {
            const nextTok = this.SKIP_TOKEN();
            this.consumeToken();
            return nextTok;
        }
        throw new $5d51f81a4b917e73$var$InRuleRecoveryException("sad sad panda");
    }
    canPerformInRuleRecovery(expectedToken, follows) {
        return this.canRecoverWithSingleTokenInsertion(expectedToken, follows) || this.canRecoverWithSingleTokenDeletion(expectedToken);
    }
    canRecoverWithSingleTokenInsertion(expectedTokType, follows) {
        if (!this.canTokenTypeBeInsertedInRecovery(expectedTokType)) return false;
        if (follows.length === 0) return false;
        const mismatchedTok = this.LA_FAST(1);
        const isMisMatchedTokInFollows = follows.find((possibleFollowsTokType)=>{
            return this.tokenMatcher(mismatchedTok, possibleFollowsTokType);
        }) !== void 0;
        return isMisMatchedTokInFollows;
    }
    canRecoverWithSingleTokenDeletion(expectedTokType) {
        if (!this.canTokenTypeBeDeletedInRecovery(expectedTokType)) return false;
        const isNextTokenWhatIsExpected = this.tokenMatcher(// not using LA_FAST because LA(2) might be un-safe with maxLookahead=1
        // in some edge cases (?)
        this.LA(2), expectedTokType);
        return isNextTokenWhatIsExpected;
    }
    isInCurrentRuleReSyncSet(tokenTypeIdx) {
        const followKey = this.getCurrFollowKey();
        const currentRuleReSyncSet = this.getFollowSetFromFollowKey(followKey);
        return currentRuleReSyncSet.includes(tokenTypeIdx);
    }
    findReSyncTokenType() {
        const allPossibleReSyncTokTypes = this.flattenFollowSet();
        let nextToken = this.LA_FAST(1);
        let k = 2;
        while(true){
            const foundMatch = allPossibleReSyncTokTypes.find((resyncTokType)=>{
                const canMatch = $5d51f81a4b917e73$export$4a18d31d63d8e922(nextToken, resyncTokType);
                return canMatch;
            });
            if (foundMatch !== void 0) return foundMatch;
            nextToken = this.LA(k);
            k++;
        }
    }
    getCurrFollowKey() {
        if (this.RULE_STACK_IDX === 0) return $5d51f81a4b917e73$var$EOF_FOLLOW_KEY;
        const currRuleShortName = this.currRuleShortName;
        const currRuleIdx = this.getLastExplicitRuleOccurrenceIndex();
        const prevRuleShortName = this.getPreviousExplicitRuleShortName();
        return {
            ruleName: this.shortRuleNameToFullName(currRuleShortName),
            idxInCallingRule: currRuleIdx,
            inRule: this.shortRuleNameToFullName(prevRuleShortName)
        };
    }
    buildFullFollowKeyStack() {
        const explicitRuleStack = this.RULE_STACK;
        const explicitOccurrenceStack = this.RULE_OCCURRENCE_STACK;
        const len = this.RULE_STACK_IDX + 1;
        const result = new Array(len);
        for(let idx = 0; idx < len; idx++)if (idx === 0) result[idx] = $5d51f81a4b917e73$var$EOF_FOLLOW_KEY;
        else result[idx] = {
            ruleName: this.shortRuleNameToFullName(explicitRuleStack[idx]),
            idxInCallingRule: explicitOccurrenceStack[idx],
            inRule: this.shortRuleNameToFullName(explicitRuleStack[idx - 1])
        };
        return result;
    }
    flattenFollowSet() {
        const followStack = this.buildFullFollowKeyStack().map((currKey)=>{
            return this.getFollowSetFromFollowKey(currKey);
        });
        return followStack.flat();
    }
    getFollowSetFromFollowKey(followKey) {
        if (followKey === $5d51f81a4b917e73$var$EOF_FOLLOW_KEY) return [
            $5d51f81a4b917e73$export$c1a09112320b1603
        ];
        const followName = followKey.ruleName + followKey.idxInCallingRule + $5d51f81a4b917e73$var$IN + followKey.inRule;
        return this.resyncFollows[followName];
    }
    // It does not make any sense to include a virtual EOF token in the list of resynced tokens
    // as EOF does not really exist and thus does not contain any useful information (line/column numbers)
    addToResyncTokens(token, resyncTokens) {
        if (!this.tokenMatcher(token, $5d51f81a4b917e73$export$c1a09112320b1603)) resyncTokens.push(token);
        return resyncTokens;
    }
    reSyncTo(tokType) {
        const resyncedTokens = [];
        let nextTok = this.LA_FAST(1);
        while(this.tokenMatcher(nextTok, tokType) === false){
            nextTok = this.SKIP_TOKEN();
            this.addToResyncTokens(nextTok, resyncedTokens);
        }
        return resyncedTokens.slice(0, -1);
    }
    attemptInRepetitionRecovery(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {}
    getCurrentGrammarPath(tokType, tokIdxInRule) {
        const pathRuleStack = this.getHumanReadableRuleStack();
        const pathOccurrenceStack = this.RULE_OCCURRENCE_STACK.slice(0, this.RULE_OCCURRENCE_STACK_IDX + 1);
        const grammarPath = {
            ruleStack: pathRuleStack,
            occurrenceStack: pathOccurrenceStack,
            lastTok: tokType,
            lastTokOccurrence: tokIdxInRule
        };
        return grammarPath;
    }
    getHumanReadableRuleStack() {
        const len = this.RULE_STACK_IDX + 1;
        const result = new Array(len);
        for(let i = 0; i < len; i++)result[i] = this.shortRuleNameToFullName(this.RULE_STACK[i]);
        return result;
    }
};
function $5d51f81a4b917e73$var$attemptInRepetitionRecovery(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
    var _a;
    var _b, _c;
    const key = dslMethodIdx | prodOccurrence;
    const ruleCache = (_a = (_b = this.firstAfterRepMap)[_c = this.currRuleShortName]) !== null && _a !== void 0 ? _a : _b[_c] = [];
    let firstAfterRepInfo = ruleCache[key];
    if (firstAfterRepInfo === void 0) {
        const currRuleName = this.getCurrRuleFullName();
        const ruleGrammar = this.getGAstProductions()[currRuleName];
        const walker = new nextToksWalker(ruleGrammar, prodOccurrence);
        firstAfterRepInfo = walker.startWalking();
        ruleCache[key] = firstAfterRepInfo;
    }
    let expectTokAfterLastMatch = firstAfterRepInfo.token;
    let nextTokIdx = firstAfterRepInfo.occurrence;
    const isEndOfRule = firstAfterRepInfo.isEndOfRule;
    if (this.RULE_STACK_IDX === 0 && isEndOfRule && expectTokAfterLastMatch === void 0) {
        expectTokAfterLastMatch = $5d51f81a4b917e73$export$c1a09112320b1603;
        nextTokIdx = 1;
    }
    if (expectTokAfterLastMatch === void 0 || nextTokIdx === void 0) return;
    if (this.shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx, notStuck)) this.tryInRepetitionRecovery(prodFunc, args, lookaheadFunc, expectTokAfterLastMatch);
}
// lib/src/parse/grammar/keys.js
var $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX = 8;
var $5d51f81a4b917e73$var$OR_IDX = 1 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
var $5d51f81a4b917e73$var$OPTION_IDX = 2 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
var $5d51f81a4b917e73$var$MANY_IDX = 3 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
var $5d51f81a4b917e73$var$AT_LEAST_ONE_IDX = 4 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
var $5d51f81a4b917e73$var$MANY_SEP_IDX = 5 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
var $5d51f81a4b917e73$var$AT_LEAST_ONE_SEP_IDX = 6 << $5d51f81a4b917e73$var$BITS_FOR_OCCURRENCE_IDX;
// lib/src/parse/grammar/llk_lookahead.js
var $5d51f81a4b917e73$export$a401661f5bedbeb4 = class {
    constructor(options){
        var _a;
        this.maxLookahead = (_a = options === null || options === void 0 ? void 0 : options.maxLookahead) !== null && _a !== void 0 ? _a : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.maxLookahead;
    }
    validate(options) {
        const leftRecursionErrors = this.validateNoLeftRecursion(options.rules);
        if (leftRecursionErrors.length === 0) {
            const emptyAltErrors = this.validateEmptyOrAlternatives(options.rules);
            const ambiguousAltsErrors = this.validateAmbiguousAlternationAlternatives(options.rules, this.maxLookahead);
            const emptyRepetitionErrors = this.validateSomeNonEmptyLookaheadPath(options.rules, this.maxLookahead);
            const allErrors = [
                ...leftRecursionErrors,
                ...emptyAltErrors,
                ...ambiguousAltsErrors,
                ...emptyRepetitionErrors
            ];
            return allErrors;
        }
        return leftRecursionErrors;
    }
    validateNoLeftRecursion(rules) {
        return rules.flatMap((currTopRule)=>$5d51f81a4b917e73$var$validateNoLeftRecursion(currTopRule, currTopRule, $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider));
    }
    validateEmptyOrAlternatives(rules) {
        return rules.flatMap((currTopRule)=>$5d51f81a4b917e73$var$validateEmptyOrAlternative(currTopRule, $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider));
    }
    validateAmbiguousAlternationAlternatives(rules, maxLookahead) {
        return rules.flatMap((currTopRule)=>$5d51f81a4b917e73$var$validateAmbiguousAlternationAlternatives(currTopRule, maxLookahead, $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider));
    }
    validateSomeNonEmptyLookaheadPath(rules, maxLookahead) {
        return $5d51f81a4b917e73$var$validateSomeNonEmptyLookaheadPath(rules, maxLookahead, $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider);
    }
    buildLookaheadForAlternation(options) {
        return $5d51f81a4b917e73$var$buildLookaheadFuncForOr(options.prodOccurrence, options.rule, options.maxLookahead, options.hasPredicates, options.dynamicTokensEnabled, $5d51f81a4b917e73$var$buildAlternativesLookAheadFunc);
    }
    buildLookaheadForOptional(options) {
        return $5d51f81a4b917e73$var$buildLookaheadFuncForOptionalProd(options.prodOccurrence, options.rule, options.maxLookahead, options.dynamicTokensEnabled, $5d51f81a4b917e73$var$getProdType(options.prodType), $5d51f81a4b917e73$var$buildSingleAlternativeLookaheadFunction);
    }
};
// lib/src/parse/parser/traits/looksahead.js
var $5d51f81a4b917e73$var$LooksAhead = class {
    initLooksAhead(config) {
        this.dynamicTokensEnabled = Object.hasOwn(config, "dynamicTokensEnabled") ? config.dynamicTokensEnabled : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.dynamicTokensEnabled;
        this.maxLookahead = Object.hasOwn(config, "maxLookahead") ? config.maxLookahead : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.maxLookahead;
        this.lookaheadStrategy = Object.hasOwn(config, "lookaheadStrategy") ? config.lookaheadStrategy : new $5d51f81a4b917e73$export$a401661f5bedbeb4({
            maxLookahead: this.maxLookahead
        });
        this.lookAheadFuncsCache = [];
        this.currRuleLookaheadFuncs = [];
    }
    preComputeLookaheadFunctions(rules) {
        rules.forEach((currRule)=>{
            this.TRACE_INIT(`${currRule.name} Rule Lookahead`, ()=>{
                const { alternation: alternation, repetition: repetition, option: option, repetitionMandatory: repetitionMandatory, repetitionMandatoryWithSeparator: repetitionMandatoryWithSeparator, repetitionWithSeparator: repetitionWithSeparator } = $5d51f81a4b917e73$var$collectMethods(currRule);
                alternation.forEach((currProd)=>{
                    const prodIdx = currProd.idx === 0 ? "" : currProd.idx;
                    this.TRACE_INIT(`${$5d51f81a4b917e73$var$getProductionDslName(currProd)}${prodIdx}`, ()=>{
                        const laFunc = this.lookaheadStrategy.buildLookaheadForAlternation({
                            prodOccurrence: currProd.idx,
                            rule: currRule,
                            maxLookahead: currProd.maxLookahead || this.maxLookahead,
                            hasPredicates: currProd.hasPredicates,
                            dynamicTokensEnabled: this.dynamicTokensEnabled
                        });
                        this.setLaFuncCache(this.fullRuleNameToShort[currRule.name], $5d51f81a4b917e73$var$OR_IDX | currProd.idx, laFunc);
                    });
                });
                repetition.forEach((currProd)=>{
                    this.computeLookaheadFunc(currRule, currProd.idx, $5d51f81a4b917e73$var$MANY_IDX, "Repetition", currProd.maxLookahead, $5d51f81a4b917e73$var$getProductionDslName(currProd));
                });
                option.forEach((currProd)=>{
                    this.computeLookaheadFunc(currRule, currProd.idx, $5d51f81a4b917e73$var$OPTION_IDX, "Option", currProd.maxLookahead, $5d51f81a4b917e73$var$getProductionDslName(currProd));
                });
                repetitionMandatory.forEach((currProd)=>{
                    this.computeLookaheadFunc(currRule, currProd.idx, $5d51f81a4b917e73$var$AT_LEAST_ONE_IDX, "RepetitionMandatory", currProd.maxLookahead, $5d51f81a4b917e73$var$getProductionDslName(currProd));
                });
                repetitionMandatoryWithSeparator.forEach((currProd)=>{
                    this.computeLookaheadFunc(currRule, currProd.idx, $5d51f81a4b917e73$var$AT_LEAST_ONE_SEP_IDX, "RepetitionMandatoryWithSeparator", currProd.maxLookahead, $5d51f81a4b917e73$var$getProductionDslName(currProd));
                });
                repetitionWithSeparator.forEach((currProd)=>{
                    this.computeLookaheadFunc(currRule, currProd.idx, $5d51f81a4b917e73$var$MANY_SEP_IDX, "RepetitionWithSeparator", currProd.maxLookahead, $5d51f81a4b917e73$var$getProductionDslName(currProd));
                });
            });
        });
    }
    computeLookaheadFunc(rule, prodOccurrence, prodKey, prodType, prodMaxLookahead, dslMethodName) {
        this.TRACE_INIT(`${dslMethodName}${prodOccurrence === 0 ? "" : prodOccurrence}`, ()=>{
            const laFunc = this.lookaheadStrategy.buildLookaheadForOptional({
                prodOccurrence: prodOccurrence,
                rule: rule,
                maxLookahead: prodMaxLookahead || this.maxLookahead,
                dynamicTokensEnabled: this.dynamicTokensEnabled,
                prodType: prodType
            });
            this.setLaFuncCache(this.fullRuleNameToShort[rule.name], prodKey | prodOccurrence, laFunc);
        });
    }
    setLaFuncCache(ruleIdx, key, value) {
        let ruleLookaheadFuncs = this.lookAheadFuncsCache[ruleIdx];
        if (ruleLookaheadFuncs === void 0) {
            ruleLookaheadFuncs = [];
            this.lookAheadFuncsCache[ruleIdx] = ruleLookaheadFuncs;
        }
        ruleLookaheadFuncs[key] = value;
    }
};
var $5d51f81a4b917e73$var$DslMethodsCollectorVisitor = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    constructor(){
        super(...arguments);
        this.dslMethods = {
            option: [],
            alternation: [],
            repetition: [],
            repetitionWithSeparator: [],
            repetitionMandatory: [],
            repetitionMandatoryWithSeparator: []
        };
    }
    reset() {
        this.dslMethods = {
            option: [],
            alternation: [],
            repetition: [],
            repetitionWithSeparator: [],
            repetitionMandatory: [],
            repetitionMandatoryWithSeparator: []
        };
    }
    visitOption(option) {
        this.dslMethods.option.push(option);
    }
    visitRepetitionWithSeparator(manySep) {
        this.dslMethods.repetitionWithSeparator.push(manySep);
    }
    visitRepetitionMandatory(atLeastOne) {
        this.dslMethods.repetitionMandatory.push(atLeastOne);
    }
    visitRepetitionMandatoryWithSeparator(atLeastOneSep) {
        this.dslMethods.repetitionMandatoryWithSeparator.push(atLeastOneSep);
    }
    visitRepetition(many) {
        this.dslMethods.repetition.push(many);
    }
    visitAlternation(or) {
        this.dslMethods.alternation.push(or);
    }
};
var $5d51f81a4b917e73$var$collectorVisitor = new $5d51f81a4b917e73$var$DslMethodsCollectorVisitor();
function $5d51f81a4b917e73$var$collectMethods(rule) {
    $5d51f81a4b917e73$var$collectorVisitor.reset();
    rule.accept($5d51f81a4b917e73$var$collectorVisitor);
    const dslMethods = $5d51f81a4b917e73$var$collectorVisitor.dslMethods;
    $5d51f81a4b917e73$var$collectorVisitor.reset();
    return dslMethods;
}
// lib/src/parse/cst/cst.js
function $5d51f81a4b917e73$var$setNodeLocationOnlyOffset(currNodeLocation, newLocationInfo) {
    if (currNodeLocation.startOffset === -1) {
        currNodeLocation.startOffset = newLocationInfo.startOffset;
        currNodeLocation.endOffset = newLocationInfo.endOffset;
    } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) currNodeLocation.endOffset = newLocationInfo.endOffset;
}
function $5d51f81a4b917e73$var$setNodeLocationFull(currNodeLocation, newLocationInfo) {
    if (currNodeLocation.startOffset === -1) {
        currNodeLocation.startOffset = newLocationInfo.startOffset;
        currNodeLocation.startColumn = newLocationInfo.startColumn;
        currNodeLocation.startLine = newLocationInfo.startLine;
        currNodeLocation.endOffset = newLocationInfo.endOffset;
        currNodeLocation.endColumn = newLocationInfo.endColumn;
        currNodeLocation.endLine = newLocationInfo.endLine;
    } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
        currNodeLocation.endOffset = newLocationInfo.endOffset;
        currNodeLocation.endColumn = newLocationInfo.endColumn;
        currNodeLocation.endLine = newLocationInfo.endLine;
    }
}
function $5d51f81a4b917e73$var$addTerminalToCst(node, token, tokenTypeName) {
    if (node.children[tokenTypeName] === void 0) node.children[tokenTypeName] = [
        token
    ];
    else node.children[tokenTypeName].push(token);
}
function $5d51f81a4b917e73$var$addNoneTerminalToCst(node, ruleName, ruleResult) {
    if (node.children[ruleName] === void 0) node.children[ruleName] = [
        ruleResult
    ];
    else node.children[ruleName].push(ruleResult);
}
// lib/src/lang/lang_extensions.js
var $5d51f81a4b917e73$var$NAME = "name";
function $5d51f81a4b917e73$var$defineNameProp(obj, nameValue) {
    Object.defineProperty(obj, $5d51f81a4b917e73$var$NAME, {
        enumerable: false,
        configurable: true,
        writable: false,
        value: nameValue
    });
}
// lib/src/parse/cst/cst_visitor.js
function $5d51f81a4b917e73$var$defaultVisit(ctx, param) {
    const childrenNames = Object.keys(ctx);
    const childrenNamesLength = childrenNames.length;
    for(let i = 0; i < childrenNamesLength; i++){
        const currChildName = childrenNames[i];
        const currChildArray = ctx[currChildName];
        const currChildArrayLength = currChildArray.length;
        for(let j = 0; j < currChildArrayLength; j++){
            const currChild = currChildArray[j];
            if (currChild.tokenTypeIdx === void 0) this[currChild.name](currChild.children, param);
        }
    }
}
function $5d51f81a4b917e73$var$createBaseSemanticVisitorConstructor(grammarName, ruleNames) {
    const derivedConstructor = function() {};
    $5d51f81a4b917e73$var$defineNameProp(derivedConstructor, grammarName + "BaseSemantics");
    const semanticProto = {
        visit: function(cstNode, param) {
            if (Array.isArray(cstNode)) cstNode = cstNode[0];
            if (cstNode === void 0) return void 0;
            return this[cstNode.name](cstNode.children, param);
        },
        validateVisitor: function() {
            const semanticDefinitionErrors = $5d51f81a4b917e73$var$validateVisitor(this, ruleNames);
            if (semanticDefinitionErrors.length !== 0) {
                const errorMessages = semanticDefinitionErrors.map((currDefError)=>currDefError.msg);
                throw Error(`Errors Detected in CST Visitor <${this.constructor.name}>:
	${errorMessages.join("\n\n").replace(/\n/g, "\n	")}`);
            }
        }
    };
    derivedConstructor.prototype = semanticProto;
    derivedConstructor.prototype.constructor = derivedConstructor;
    derivedConstructor._RULE_NAMES = ruleNames;
    return derivedConstructor;
}
function $5d51f81a4b917e73$var$createBaseVisitorConstructorWithDefaults(grammarName, ruleNames, baseConstructor) {
    const derivedConstructor = function() {};
    $5d51f81a4b917e73$var$defineNameProp(derivedConstructor, grammarName + "BaseSemanticsWithDefaults");
    const withDefaultsProto = Object.create(baseConstructor.prototype);
    ruleNames.forEach((ruleName)=>{
        withDefaultsProto[ruleName] = $5d51f81a4b917e73$var$defaultVisit;
    });
    derivedConstructor.prototype = withDefaultsProto;
    derivedConstructor.prototype.constructor = derivedConstructor;
    return derivedConstructor;
}
var $5d51f81a4b917e73$var$CstVisitorDefinitionError;
(function(CstVisitorDefinitionError2) {
    CstVisitorDefinitionError2[CstVisitorDefinitionError2["REDUNDANT_METHOD"] = 0] = "REDUNDANT_METHOD";
    CstVisitorDefinitionError2[CstVisitorDefinitionError2["MISSING_METHOD"] = 1] = "MISSING_METHOD";
})($5d51f81a4b917e73$var$CstVisitorDefinitionError || ($5d51f81a4b917e73$var$CstVisitorDefinitionError = {}));
function $5d51f81a4b917e73$var$validateVisitor(visitorInstance, ruleNames) {
    const missingErrors = $5d51f81a4b917e73$var$validateMissingCstMethods(visitorInstance, ruleNames);
    return missingErrors;
}
function $5d51f81a4b917e73$var$validateMissingCstMethods(visitorInstance, ruleNames) {
    const missingRuleNames = ruleNames.filter((currRuleName)=>{
        return typeof visitorInstance[currRuleName] === "function" === false;
    });
    const errors = missingRuleNames.map((currRuleName)=>{
        return {
            msg: `Missing visitor method: <${currRuleName}> on ${visitorInstance.constructor.name} CST Visitor.`,
            type: $5d51f81a4b917e73$var$CstVisitorDefinitionError.MISSING_METHOD,
            methodName: currRuleName
        };
    });
    return errors.filter(Boolean);
}
// lib/src/parse/parser/traits/tree_builder.js
var $5d51f81a4b917e73$var$TreeBuilder = class {
    initTreeBuilder(config) {
        this.CST_STACK = [];
        this.outputCst = config.outputCst;
        this.nodeLocationTracking = Object.hasOwn(config, "nodeLocationTracking") ? config.nodeLocationTracking : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.nodeLocationTracking;
        if (!this.outputCst) {
            this.cstInvocationStateUpdate = ()=>{};
            this.cstFinallyStateUpdate = ()=>{};
            this.cstPostTerminal = ()=>{};
            this.cstPostNonTerminal = ()=>{};
            this.cstPostRule = ()=>{};
        } else {
            if (/full/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                    this.setNodeLocationFromToken = $5d51f81a4b917e73$var$setNodeLocationFull;
                    this.setNodeLocationFromNode = $5d51f81a4b917e73$var$setNodeLocationFull;
                    this.cstPostRule = ()=>{};
                    this.setInitialNodeLocation = this.setInitialNodeLocationFullRecovery;
                } else {
                    this.setNodeLocationFromToken = ()=>{};
                    this.setNodeLocationFromNode = ()=>{};
                    this.cstPostRule = this.cstPostRuleFull;
                    this.setInitialNodeLocation = this.setInitialNodeLocationFullRegular;
                }
            } else if (/onlyOffset/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                    this.setNodeLocationFromToken = $5d51f81a4b917e73$var$setNodeLocationOnlyOffset;
                    this.setNodeLocationFromNode = $5d51f81a4b917e73$var$setNodeLocationOnlyOffset;
                    this.cstPostRule = ()=>{};
                    this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRecovery;
                } else {
                    this.setNodeLocationFromToken = ()=>{};
                    this.setNodeLocationFromNode = ()=>{};
                    this.cstPostRule = this.cstPostRuleOnlyOffset;
                    this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRegular;
                }
            } else if (/none/i.test(this.nodeLocationTracking)) {
                this.setNodeLocationFromToken = ()=>{};
                this.setNodeLocationFromNode = ()=>{};
                this.cstPostRule = ()=>{};
                this.setInitialNodeLocation = ()=>{};
            } else throw Error(`Invalid <nodeLocationTracking> config option: "${config.nodeLocationTracking}"`);
        }
    }
    setInitialNodeLocationOnlyOffsetRecovery(cstNode) {
        cstNode.location = {
            startOffset: -1,
            endOffset: -1
        };
    }
    setInitialNodeLocationOnlyOffsetRegular(cstNode) {
        cstNode.location = {
            // without error recovery the starting Location of a new CstNode is guaranteed
            // To be the next Token's startOffset (for valid inputs).
            // For invalid inputs there won't be any CSTOutput so this potential
            // inaccuracy does not matter
            startOffset: this.LA_FAST(1).startOffset,
            endOffset: -1
        };
    }
    setInitialNodeLocationFullRecovery(cstNode) {
        cstNode.location = {
            startOffset: -1,
            startLine: -1,
            startColumn: -1,
            endOffset: -1,
            endLine: -1,
            endColumn: -1
        };
    }
    /**
       *  @see setInitialNodeLocationOnlyOffsetRegular for explanation why this work
  
       * @param cstNode
       */ setInitialNodeLocationFullRegular(cstNode) {
        const nextToken = this.LA_FAST(1);
        cstNode.location = {
            startOffset: nextToken.startOffset,
            startLine: nextToken.startLine,
            startColumn: nextToken.startColumn,
            endOffset: -1,
            endLine: -1,
            endColumn: -1
        };
    }
    cstInvocationStateUpdate(fullRuleName) {
        const cstNode = {
            name: fullRuleName,
            children: /* @__PURE__ */ Object.create(null)
        };
        this.setInitialNodeLocation(cstNode);
        this.CST_STACK.push(cstNode);
    }
    cstFinallyStateUpdate() {
        this.CST_STACK.pop();
    }
    cstPostRuleFull(ruleCstNode) {
        const prevToken = this.LA(0);
        const loc = ruleCstNode.location;
        if (loc.startOffset !== -1 && loc.startOffset <= prevToken.startOffset === true) {
            loc.endOffset = prevToken.endOffset;
            loc.endLine = prevToken.endLine;
            loc.endColumn = prevToken.endColumn;
        } else {
            loc.startOffset = -1;
            loc.startLine = -1;
            loc.startColumn = -1;
        }
    }
    cstPostRuleOnlyOffset(ruleCstNode) {
        const prevToken = this.LA(0);
        const loc = ruleCstNode.location;
        if (loc.startOffset !== -1 && loc.startOffset <= prevToken.startOffset === true) loc.endOffset = prevToken.endOffset;
        else loc.startOffset = -1;
    }
    cstPostTerminal(key, consumedToken) {
        const rootCst = this.CST_STACK[this.CST_STACK.length - 1];
        $5d51f81a4b917e73$var$addTerminalToCst(rootCst, consumedToken, key);
        this.setNodeLocationFromToken(rootCst.location, consumedToken);
    }
    cstPostNonTerminal(ruleCstResult, ruleName) {
        const preCstNode = this.CST_STACK[this.CST_STACK.length - 1];
        $5d51f81a4b917e73$var$addNoneTerminalToCst(preCstNode, ruleName, ruleCstResult);
        this.setNodeLocationFromNode(preCstNode.location, ruleCstResult.location);
    }
    get currCSTNode() {
        const mixedIn = this;
        return mixedIn.CST_STACK[mixedIn.CST_STACK.length - 1];
    }
    getBaseCstVisitorConstructor() {
        if (this.baseCstVisitorConstructor === void 0) {
            const newBaseCstVisitorConstructor = $5d51f81a4b917e73$var$createBaseSemanticVisitorConstructor(this.className, Object.keys(this.gastProductionsCache));
            this.baseCstVisitorConstructor = newBaseCstVisitorConstructor;
            return newBaseCstVisitorConstructor;
        }
        return this.baseCstVisitorConstructor;
    }
    getBaseCstVisitorConstructorWithDefaults() {
        if (this.baseCstVisitorWithDefaultsConstructor === void 0) {
            const newConstructor = $5d51f81a4b917e73$var$createBaseVisitorConstructorWithDefaults(this.className, Object.keys(this.gastProductionsCache), this.getBaseCstVisitorConstructor());
            this.baseCstVisitorWithDefaultsConstructor = newConstructor;
            return newConstructor;
        }
        return this.baseCstVisitorWithDefaultsConstructor;
    }
    getPreviousExplicitRuleShortName() {
        return this.RULE_STACK[this.RULE_STACK_IDX - 1];
    }
    getLastExplicitRuleOccurrenceIndex() {
        return this.RULE_OCCURRENCE_STACK[this.RULE_OCCURRENCE_STACK_IDX];
    }
};
// lib/src/parse/parser/traits/lexer_adapter.js
var $5d51f81a4b917e73$var$LexerAdapter = class {
    initLexerAdapter() {
        this.tokVector = [];
        this.tokVectorLength = 0;
        this.currIdx = -1;
    }
    set input(newInput) {
        if (this.selfAnalysisDone !== true) throw Error(`Missing <performSelfAnalysis> invocation at the end of the Parser's constructor.`);
        this.reset();
        this.tokVector = newInput;
        this.tokVectorLength = newInput.length;
    }
    get input() {
        return this.tokVector;
    }
    // skips a token and returns the next token
    SKIP_TOKEN() {
        if (this.currIdx <= this.tokVectorLength - 2) {
            this.consumeToken();
            return this.LA_FAST(1);
        } else return $5d51f81a4b917e73$var$END_OF_FILE;
    }
    // Lexer (accessing Token vector) related methods which can be overridden to implement lazy lexers
    // or lexers dependent on parser context.
    // Performance Optimized version of LA without bound checks
    // note that token beyond the end of the token vector EOF Token will still be returned
    // due to using sentinels at the end of the token vector. (for K=max lookahead)
    LA_FAST(howMuch) {
        const soughtIdx = this.currIdx + howMuch;
        return this.tokVector[soughtIdx];
    }
    LA(howMuch) {
        const soughtIdx = this.currIdx + howMuch;
        if (soughtIdx < 0 || this.tokVectorLength <= soughtIdx) return $5d51f81a4b917e73$var$END_OF_FILE;
        else return this.tokVector[soughtIdx];
    }
    consumeToken() {
        this.currIdx++;
    }
    exportLexerState() {
        return this.currIdx;
    }
    importLexerState(newState) {
        this.currIdx = newState;
    }
    resetLexerState() {
        this.currIdx = -1;
    }
    moveToTerminatedState() {
        this.currIdx = this.tokVectorLength - 1;
    }
    getLexerPosition() {
        return this.exportLexerState();
    }
};
// lib/src/parse/parser/traits/recognizer_api.js
var $5d51f81a4b917e73$var$RecognizerApi = class {
    ACTION(impl) {
        return impl.call(this);
    }
    consume(idx, tokType, options) {
        return this.consumeInternal(tokType, idx, options);
    }
    subrule(idx, ruleToCall, options) {
        return this.subruleInternal(ruleToCall, idx, options);
    }
    option(idx, actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, idx);
    }
    or(idx, altsOrOpts) {
        return this.orInternal(altsOrOpts, idx);
    }
    many(idx, actionORMethodDef) {
        return this.manyInternal(idx, actionORMethodDef);
    }
    atLeastOne(idx, actionORMethodDef) {
        return this.atLeastOneInternal(idx, actionORMethodDef);
    }
    CONSUME(tokType, options) {
        return this.consumeInternal(tokType, 0, options);
    }
    CONSUME1(tokType, options) {
        return this.consumeInternal(tokType, 1, options);
    }
    CONSUME2(tokType, options) {
        return this.consumeInternal(tokType, 2, options);
    }
    CONSUME3(tokType, options) {
        return this.consumeInternal(tokType, 3, options);
    }
    CONSUME4(tokType, options) {
        return this.consumeInternal(tokType, 4, options);
    }
    CONSUME5(tokType, options) {
        return this.consumeInternal(tokType, 5, options);
    }
    CONSUME6(tokType, options) {
        return this.consumeInternal(tokType, 6, options);
    }
    CONSUME7(tokType, options) {
        return this.consumeInternal(tokType, 7, options);
    }
    CONSUME8(tokType, options) {
        return this.consumeInternal(tokType, 8, options);
    }
    CONSUME9(tokType, options) {
        return this.consumeInternal(tokType, 9, options);
    }
    SUBRULE(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 0, options);
    }
    SUBRULE1(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 1, options);
    }
    SUBRULE2(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 2, options);
    }
    SUBRULE3(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 3, options);
    }
    SUBRULE4(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 4, options);
    }
    SUBRULE5(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 5, options);
    }
    SUBRULE6(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 6, options);
    }
    SUBRULE7(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 7, options);
    }
    SUBRULE8(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 8, options);
    }
    SUBRULE9(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 9, options);
    }
    OPTION(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 0);
    }
    OPTION1(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 1);
    }
    OPTION2(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 2);
    }
    OPTION3(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 3);
    }
    OPTION4(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 4);
    }
    OPTION5(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 5);
    }
    OPTION6(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 6);
    }
    OPTION7(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 7);
    }
    OPTION8(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 8);
    }
    OPTION9(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 9);
    }
    OR(altsOrOpts) {
        return this.orInternal(altsOrOpts, 0);
    }
    OR1(altsOrOpts) {
        return this.orInternal(altsOrOpts, 1);
    }
    OR2(altsOrOpts) {
        return this.orInternal(altsOrOpts, 2);
    }
    OR3(altsOrOpts) {
        return this.orInternal(altsOrOpts, 3);
    }
    OR4(altsOrOpts) {
        return this.orInternal(altsOrOpts, 4);
    }
    OR5(altsOrOpts) {
        return this.orInternal(altsOrOpts, 5);
    }
    OR6(altsOrOpts) {
        return this.orInternal(altsOrOpts, 6);
    }
    OR7(altsOrOpts) {
        return this.orInternal(altsOrOpts, 7);
    }
    OR8(altsOrOpts) {
        return this.orInternal(altsOrOpts, 8);
    }
    OR9(altsOrOpts) {
        return this.orInternal(altsOrOpts, 9);
    }
    MANY(actionORMethodDef) {
        this.manyInternal(0, actionORMethodDef);
    }
    MANY1(actionORMethodDef) {
        this.manyInternal(1, actionORMethodDef);
    }
    MANY2(actionORMethodDef) {
        this.manyInternal(2, actionORMethodDef);
    }
    MANY3(actionORMethodDef) {
        this.manyInternal(3, actionORMethodDef);
    }
    MANY4(actionORMethodDef) {
        this.manyInternal(4, actionORMethodDef);
    }
    MANY5(actionORMethodDef) {
        this.manyInternal(5, actionORMethodDef);
    }
    MANY6(actionORMethodDef) {
        this.manyInternal(6, actionORMethodDef);
    }
    MANY7(actionORMethodDef) {
        this.manyInternal(7, actionORMethodDef);
    }
    MANY8(actionORMethodDef) {
        this.manyInternal(8, actionORMethodDef);
    }
    MANY9(actionORMethodDef) {
        this.manyInternal(9, actionORMethodDef);
    }
    MANY_SEP(options) {
        this.manySepFirstInternal(0, options);
    }
    MANY_SEP1(options) {
        this.manySepFirstInternal(1, options);
    }
    MANY_SEP2(options) {
        this.manySepFirstInternal(2, options);
    }
    MANY_SEP3(options) {
        this.manySepFirstInternal(3, options);
    }
    MANY_SEP4(options) {
        this.manySepFirstInternal(4, options);
    }
    MANY_SEP5(options) {
        this.manySepFirstInternal(5, options);
    }
    MANY_SEP6(options) {
        this.manySepFirstInternal(6, options);
    }
    MANY_SEP7(options) {
        this.manySepFirstInternal(7, options);
    }
    MANY_SEP8(options) {
        this.manySepFirstInternal(8, options);
    }
    MANY_SEP9(options) {
        this.manySepFirstInternal(9, options);
    }
    AT_LEAST_ONE(actionORMethodDef) {
        this.atLeastOneInternal(0, actionORMethodDef);
    }
    AT_LEAST_ONE1(actionORMethodDef) {
        return this.atLeastOneInternal(1, actionORMethodDef);
    }
    AT_LEAST_ONE2(actionORMethodDef) {
        this.atLeastOneInternal(2, actionORMethodDef);
    }
    AT_LEAST_ONE3(actionORMethodDef) {
        this.atLeastOneInternal(3, actionORMethodDef);
    }
    AT_LEAST_ONE4(actionORMethodDef) {
        this.atLeastOneInternal(4, actionORMethodDef);
    }
    AT_LEAST_ONE5(actionORMethodDef) {
        this.atLeastOneInternal(5, actionORMethodDef);
    }
    AT_LEAST_ONE6(actionORMethodDef) {
        this.atLeastOneInternal(6, actionORMethodDef);
    }
    AT_LEAST_ONE7(actionORMethodDef) {
        this.atLeastOneInternal(7, actionORMethodDef);
    }
    AT_LEAST_ONE8(actionORMethodDef) {
        this.atLeastOneInternal(8, actionORMethodDef);
    }
    AT_LEAST_ONE9(actionORMethodDef) {
        this.atLeastOneInternal(9, actionORMethodDef);
    }
    AT_LEAST_ONE_SEP(options) {
        this.atLeastOneSepFirstInternal(0, options);
    }
    AT_LEAST_ONE_SEP1(options) {
        this.atLeastOneSepFirstInternal(1, options);
    }
    AT_LEAST_ONE_SEP2(options) {
        this.atLeastOneSepFirstInternal(2, options);
    }
    AT_LEAST_ONE_SEP3(options) {
        this.atLeastOneSepFirstInternal(3, options);
    }
    AT_LEAST_ONE_SEP4(options) {
        this.atLeastOneSepFirstInternal(4, options);
    }
    AT_LEAST_ONE_SEP5(options) {
        this.atLeastOneSepFirstInternal(5, options);
    }
    AT_LEAST_ONE_SEP6(options) {
        this.atLeastOneSepFirstInternal(6, options);
    }
    AT_LEAST_ONE_SEP7(options) {
        this.atLeastOneSepFirstInternal(7, options);
    }
    AT_LEAST_ONE_SEP8(options) {
        this.atLeastOneSepFirstInternal(8, options);
    }
    AT_LEAST_ONE_SEP9(options) {
        this.atLeastOneSepFirstInternal(9, options);
    }
    RULE(name, implementation, config = $5d51f81a4b917e73$var$DEFAULT_RULE_CONFIG) {
        if (this.definedRulesNames.includes(name)) {
            const errMsg = $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider.buildDuplicateRuleNameError({
                topLevelRule: name,
                grammarName: this.className
            });
            const error = {
                message: errMsg,
                type: $5d51f81a4b917e73$export$86bd3f602f298cb6.DUPLICATE_RULE_NAME,
                ruleName: name
            };
            this.definitionErrors.push(error);
        }
        this.definedRulesNames.push(name);
        const ruleImplementation = this.defineRule(name, implementation, config);
        this[name] = ruleImplementation;
        return ruleImplementation;
    }
    OVERRIDE_RULE(name, impl, config = $5d51f81a4b917e73$var$DEFAULT_RULE_CONFIG) {
        const ruleErrors = $5d51f81a4b917e73$var$validateRuleIsOverridden(name, this.definedRulesNames, this.className);
        this.definitionErrors = this.definitionErrors.concat(ruleErrors);
        const ruleImplementation = this.defineRule(name, impl, config);
        this[name] = ruleImplementation;
        return ruleImplementation;
    }
    BACKTRACK(grammarRule, args) {
        var _a;
        const ruleToCall = (_a = grammarRule.coreRule) !== null && _a !== void 0 ? _a : grammarRule;
        return function() {
            this.isBackTrackingStack.push(1);
            const orgState = this.saveRecogState();
            try {
                ruleToCall.apply(this, args);
                return true;
            } catch (e) {
                if ($5d51f81a4b917e73$export$93d1e12f7a3ec65(e)) return false;
                else throw e;
            } finally{
                this.reloadRecogState(orgState);
                this.isBackTrackingStack.pop();
            }
        };
    }
    // GAST export APIs
    getGAstProductions() {
        return this.gastProductionsCache;
    }
    getSerializedGastProductions() {
        return $5d51f81a4b917e73$export$402033653bede0a9(Object.values(this.gastProductionsCache));
    }
};
// lib/src/parse/parser/traits/recognizer_engine.js
var $5d51f81a4b917e73$var$RecognizerEngine = class {
    initRecognizerEngine(tokenVocabulary, config) {
        this.className = this.constructor.name;
        this.shortRuleNameToFull = [];
        this.fullRuleNameToShort = {};
        this.ruleShortNameIdx = 0;
        this.tokenMatcher = $5d51f81a4b917e73$var$tokenStructuredMatcherNoCategories;
        this.subruleIdx = 0;
        this.currRuleShortName = -1;
        this.definedRulesNames = [];
        this.tokensMap = {};
        this.isBackTrackingStack = [];
        this.RULE_STACK = [];
        this.RULE_STACK_IDX = -1;
        this.RULE_OCCURRENCE_STACK = [];
        this.RULE_OCCURRENCE_STACK_IDX = -1;
        this.gastProductionsCache = {};
        if (Object.hasOwn(config, "serializedGrammar")) throw Error("The Parser's configuration can no longer contain a <serializedGrammar> property.\n	See: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_6-0-0\n	For Further details.");
        if (Array.isArray(tokenVocabulary)) {
            if (tokenVocabulary.length === 0) throw Error("A Token Vocabulary cannot be empty.\n	Note that the first argument for the parser constructor\n	is no longer a Token vector (since v4.0).");
            if (typeof tokenVocabulary[0].startOffset === "number") throw Error("The Parser constructor no longer accepts a token vector as the first argument.\n	See: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_4-0-0\n	For Further details.");
        }
        if (Array.isArray(tokenVocabulary)) this.tokensMap = tokenVocabulary.reduce((acc, tokType)=>{
            acc[tokType.name] = tokType;
            return acc;
        }, {});
        else if (Object.hasOwn(tokenVocabulary, "modes") && Object.values(tokenVocabulary.modes).flat().every($5d51f81a4b917e73$var$isTokenType)) {
            const allTokenTypes2 = Object.values(tokenVocabulary.modes).flat();
            const uniqueTokens = [
                ...new Set(allTokenTypes2)
            ];
            this.tokensMap = uniqueTokens.reduce((acc, tokType)=>{
                acc[tokType.name] = tokType;
                return acc;
            }, {});
        } else if (typeof tokenVocabulary === "object" && tokenVocabulary !== null) this.tokensMap = Object.assign({}, tokenVocabulary);
        else throw new Error("<tokensDictionary> argument must be An Array of Token constructors, A dictionary of Token constructors or an IMultiModeLexerDefinition");
        this.tokensMap["EOF"] = $5d51f81a4b917e73$export$c1a09112320b1603;
        const allTokenTypes = Object.hasOwn(tokenVocabulary, "modes") ? Object.values(tokenVocabulary.modes).flat() : Object.values(tokenVocabulary);
        const noTokenCategoriesUsed = allTokenTypes.every(// intentional "==" to also cover "undefined"
        (tokenConstructor)=>{
            var _a;
            return ((_a = tokenConstructor.categoryMatches) === null || _a === void 0 ? void 0 : _a.length) == 0;
        });
        this.tokenMatcher = noTokenCategoriesUsed ? $5d51f81a4b917e73$var$tokenStructuredMatcherNoCategories : $5d51f81a4b917e73$var$tokenStructuredMatcher;
        $5d51f81a4b917e73$var$augmentTokenTypes(Object.values(this.tokensMap));
    }
    defineRule(ruleName, impl, config) {
        if (this.selfAnalysisDone) throw Error(`Grammar rule <${ruleName}> may not be defined after the 'performSelfAnalysis' method has been called'
Make sure that all grammar rule definitions are done before 'performSelfAnalysis' is called.`);
        const resyncEnabled = Object.hasOwn(config, "resyncEnabled") ? config.resyncEnabled : $5d51f81a4b917e73$var$DEFAULT_RULE_CONFIG.resyncEnabled;
        const recoveryValueFunc = Object.hasOwn(config, "recoveryValueFunc") ? config.recoveryValueFunc : $5d51f81a4b917e73$var$DEFAULT_RULE_CONFIG.recoveryValueFunc;
        const shortName = this.ruleShortNameIdx++;
        this.shortRuleNameToFull[shortName] = ruleName;
        this.fullRuleNameToShort[ruleName] = shortName;
        let coreRuleFunction;
        if (this.outputCst === true) coreRuleFunction = function invokeRuleWithTry(...args) {
            try {
                this.ruleInvocationStateUpdate(shortName, ruleName, this.subruleIdx);
                impl.apply(this, args);
                const cst = this.CST_STACK[this.CST_STACK.length - 1];
                this.cstPostRule(cst);
                return cst;
            } catch (e) {
                return this.invokeRuleCatch(e, resyncEnabled, recoveryValueFunc);
            } finally{
                this.ruleFinallyStateUpdate();
            }
        };
        else coreRuleFunction = function invokeRuleWithTryCst(...args) {
            try {
                this.ruleInvocationStateUpdate(shortName, ruleName, this.subruleIdx);
                return impl.apply(this, args);
            } catch (e) {
                return this.invokeRuleCatch(e, resyncEnabled, recoveryValueFunc);
            } finally{
                this.ruleFinallyStateUpdate();
            }
        };
        const rootRuleFunction = function rootRule(...args) {
            this.onBeforeParse(ruleName);
            try {
                return coreRuleFunction.apply(this, args);
            } finally{
                this.onAfterParse(ruleName);
            }
        };
        const wrappedGrammarRule = Object.assign(rootRuleFunction, {
            ruleName: ruleName,
            originalGrammarAction: impl,
            coreRule: coreRuleFunction
        });
        return wrappedGrammarRule;
    }
    invokeRuleCatch(e, resyncEnabledConfig, recoveryValueFunc) {
        const isFirstInvokedRule = this.RULE_STACK_IDX === 0;
        const reSyncEnabled = resyncEnabledConfig && !this.isBackTracking() && this.recoveryEnabled;
        if ($5d51f81a4b917e73$export$93d1e12f7a3ec65(e)) {
            const recogError = e;
            if (reSyncEnabled) {
                const reSyncTokType = this.findReSyncTokenType();
                if (this.isInCurrentRuleReSyncSet(reSyncTokType)) {
                    recogError.resyncedTokens = this.reSyncTo(reSyncTokType);
                    if (this.outputCst) {
                        const partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                        partialCstResult.recoveredNode = true;
                        return partialCstResult;
                    } else return recoveryValueFunc(e);
                } else {
                    if (this.outputCst) {
                        const partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                        partialCstResult.recoveredNode = true;
                        recogError.partialCstResult = partialCstResult;
                    }
                    throw recogError;
                }
            } else if (isFirstInvokedRule) {
                this.moveToTerminatedState();
                return recoveryValueFunc(e);
            } else throw recogError;
        } else throw e;
    }
    // Implementation of parsing DSL
    optionInternal(actionORMethodDef, occurrence) {
        const key = $5d51f81a4b917e73$var$OPTION_IDX | occurrence;
        return this.optionInternalLogic(actionORMethodDef, occurrence, key);
    }
    optionInternalLogic(actionORMethodDef, occurrence, key) {
        let lookAheadFunc = this.currRuleLookaheadFuncs[key];
        let action;
        if (typeof actionORMethodDef !== "function") {
            action = actionORMethodDef.DEF;
            const predicate = actionORMethodDef.GATE;
            if (predicate !== void 0) {
                const orgLookaheadFunction = lookAheadFunc;
                lookAheadFunc = ()=>{
                    return predicate.call(this) && orgLookaheadFunction.call(this);
                };
            }
        } else action = actionORMethodDef;
        if (lookAheadFunc.call(this) === true) return action.call(this);
        return void 0;
    }
    atLeastOneInternal(prodOccurrence, actionORMethodDef) {
        const key = $5d51f81a4b917e73$var$AT_LEAST_ONE_IDX | prodOccurrence;
        return this.atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, key);
    }
    atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, key) {
        let lookAheadFunc = this.currRuleLookaheadFuncs[key];
        let action;
        if (typeof actionORMethodDef !== "function") {
            action = actionORMethodDef.DEF;
            const predicate = actionORMethodDef.GATE;
            if (predicate !== void 0) {
                const orgLookaheadFunction = lookAheadFunc;
                lookAheadFunc = ()=>{
                    return predicate.call(this) && orgLookaheadFunction.call(this);
                };
            }
        } else action = actionORMethodDef;
        if (lookAheadFunc.call(this) === true) {
            let notStuck = this.doSingleRepetition(action);
            while(lookAheadFunc.call(this) === true && notStuck === true)notStuck = this.doSingleRepetition(action);
        } else throw this.raiseEarlyExitException(prodOccurrence, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY, actionORMethodDef.ERR_MSG);
        this.attemptInRepetitionRecovery(this.atLeastOneInternal, [
            prodOccurrence,
            actionORMethodDef
        ], lookAheadFunc, $5d51f81a4b917e73$var$AT_LEAST_ONE_IDX, prodOccurrence, $5d51f81a4b917e73$var$NextTerminalAfterAtLeastOneWalker);
    }
    atLeastOneSepFirstInternal(prodOccurrence, options) {
        const key = $5d51f81a4b917e73$var$AT_LEAST_ONE_SEP_IDX | prodOccurrence;
        this.atLeastOneSepFirstInternalLogic(prodOccurrence, options, key);
    }
    atLeastOneSepFirstInternalLogic(prodOccurrence, options, key) {
        const action = options.DEF;
        const separator = options.SEP;
        const firstIterationLookaheadFunc = this.currRuleLookaheadFuncs[key];
        if (firstIterationLookaheadFunc.call(this) === true) {
            action.call(this);
            const separatorLookAheadFunc = ()=>{
                return this.tokenMatcher(this.LA_FAST(1), separator);
            };
            while(this.tokenMatcher(this.LA_FAST(1), separator) === true){
                this.CONSUME(separator);
                action.call(this);
            }
            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                $5d51f81a4b917e73$var$NextTerminalAfterAtLeastOneSepWalker
            ], separatorLookAheadFunc, $5d51f81a4b917e73$var$AT_LEAST_ONE_SEP_IDX, prodOccurrence, $5d51f81a4b917e73$var$NextTerminalAfterAtLeastOneSepWalker);
        } else throw this.raiseEarlyExitException(prodOccurrence, $5d51f81a4b917e73$var$PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, options.ERR_MSG);
    }
    manyInternal(prodOccurrence, actionORMethodDef) {
        const key = $5d51f81a4b917e73$var$MANY_IDX | prodOccurrence;
        return this.manyInternalLogic(prodOccurrence, actionORMethodDef, key);
    }
    manyInternalLogic(prodOccurrence, actionORMethodDef, key) {
        let lookaheadFunction = this.currRuleLookaheadFuncs[key];
        let action;
        if (typeof actionORMethodDef !== "function") {
            action = actionORMethodDef.DEF;
            const predicate = actionORMethodDef.GATE;
            if (predicate !== void 0) {
                const orgLookaheadFunction = lookaheadFunction;
                lookaheadFunction = ()=>{
                    return predicate.call(this) && orgLookaheadFunction.call(this);
                };
            }
        } else action = actionORMethodDef;
        let notStuck = true;
        while(lookaheadFunction.call(this) === true && notStuck === true)notStuck = this.doSingleRepetition(action);
        this.attemptInRepetitionRecovery(this.manyInternal, [
            prodOccurrence,
            actionORMethodDef
        ], lookaheadFunction, $5d51f81a4b917e73$var$MANY_IDX, prodOccurrence, $5d51f81a4b917e73$var$NextTerminalAfterManyWalker, // The notStuck parameter is only relevant when "attemptInRepetitionRecovery"
        // is invoked from manyInternal, in the MANY_SEP case and AT_LEAST_ONE[_SEP]
        // An infinite loop cannot occur as:
        // - Either the lookahead is guaranteed to consume something (Single Token Separator)
        // - AT_LEAST_ONE by definition is guaranteed to consume something (or error out).
        notStuck);
    }
    manySepFirstInternal(prodOccurrence, options) {
        const key = $5d51f81a4b917e73$var$MANY_SEP_IDX | prodOccurrence;
        this.manySepFirstInternalLogic(prodOccurrence, options, key);
    }
    manySepFirstInternalLogic(prodOccurrence, options, key) {
        const action = options.DEF;
        const separator = options.SEP;
        const firstIterationLaFunc = this.currRuleLookaheadFuncs[key];
        if (firstIterationLaFunc.call(this) === true) {
            action.call(this);
            const separatorLookAheadFunc = ()=>{
                return this.tokenMatcher(this.LA_FAST(1), separator);
            };
            while(this.tokenMatcher(this.LA_FAST(1), separator) === true){
                this.CONSUME(separator);
                action.call(this);
            }
            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                $5d51f81a4b917e73$var$NextTerminalAfterManySepWalker
            ], separatorLookAheadFunc, $5d51f81a4b917e73$var$MANY_SEP_IDX, prodOccurrence, $5d51f81a4b917e73$var$NextTerminalAfterManySepWalker);
        }
    }
    repetitionSepSecondInternal(prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker) {
        while(separatorLookAheadFunc()){
            this.CONSUME(separator);
            action.call(this);
        }
        this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
            prodOccurrence,
            separator,
            separatorLookAheadFunc,
            action,
            nextTerminalAfterWalker
        ], separatorLookAheadFunc, $5d51f81a4b917e73$var$AT_LEAST_ONE_SEP_IDX, prodOccurrence, nextTerminalAfterWalker);
    }
    doSingleRepetition(action) {
        const beforeIteration = this.getLexerPosition();
        action.call(this);
        const afterIteration = this.getLexerPosition();
        return afterIteration > beforeIteration;
    }
    orInternal(altsOrOpts, occurrence) {
        const key = $5d51f81a4b917e73$var$OR_IDX | occurrence;
        const alts = Array.isArray(altsOrOpts) ? altsOrOpts : altsOrOpts.DEF;
        const laFunc = this.currRuleLookaheadFuncs[key];
        const altIdxToTake = laFunc.call(this, alts);
        if (altIdxToTake !== void 0) {
            const chosenAlternative = alts[altIdxToTake];
            return chosenAlternative.ALT.call(this);
        }
        this.raiseNoAltException(occurrence, altsOrOpts.ERR_MSG);
    }
    ruleFinallyStateUpdate() {
        this.RULE_STACK_IDX--;
        this.RULE_OCCURRENCE_STACK_IDX--;
        if (this.RULE_STACK_IDX >= 0) {
            this.currRuleShortName = this.RULE_STACK[this.RULE_STACK_IDX];
            this.currRuleLookaheadFuncs = this.lookAheadFuncsCache[this.currRuleShortName];
        }
        this.cstFinallyStateUpdate();
    }
    subruleInternal(ruleToCall, idx, options) {
        let ruleResult;
        try {
            const args = options !== void 0 ? options.ARGS : void 0;
            this.subruleIdx = idx;
            ruleResult = ruleToCall.coreRule.apply(this, args);
            this.cstPostNonTerminal(ruleResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleToCall.ruleName);
            return ruleResult;
        } catch (e) {
            throw this.subruleInternalError(e, options, ruleToCall.ruleName);
        }
    }
    subruleInternalError(e, options, ruleName) {
        if ($5d51f81a4b917e73$export$93d1e12f7a3ec65(e) && e.partialCstResult !== void 0) {
            this.cstPostNonTerminal(e.partialCstResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleName);
            delete e.partialCstResult;
        }
        throw e;
    }
    consumeInternal(tokType, idx, options) {
        let consumedToken;
        try {
            const nextToken = this.LA_FAST(1);
            if (this.tokenMatcher(nextToken, tokType) === true) {
                this.consumeToken();
                consumedToken = nextToken;
            } else this.consumeInternalError(tokType, nextToken, options);
        } catch (eFromConsumption) {
            consumedToken = this.consumeInternalRecovery(tokType, idx, eFromConsumption);
        }
        this.cstPostTerminal(options !== void 0 && options.LABEL !== void 0 ? options.LABEL : tokType.name, consumedToken);
        return consumedToken;
    }
    consumeInternalError(tokType, nextToken, options) {
        let msg;
        const previousToken = this.LA(0);
        if (options !== void 0 && options.ERR_MSG) msg = options.ERR_MSG;
        else msg = this.errorMessageProvider.buildMismatchTokenMessage({
            expected: tokType,
            actual: nextToken,
            previous: previousToken,
            ruleName: this.getCurrRuleFullName()
        });
        throw this.SAVE_ERROR(new $5d51f81a4b917e73$export$e052327bfb3cf890(msg, nextToken, previousToken));
    }
    consumeInternalRecovery(tokType, idx, eFromConsumption) {
        if (this.recoveryEnabled && // TODO: more robust checking of the exception type. Perhaps Typescript extending expressions?
        eFromConsumption.name === "MismatchedTokenException" && !this.isBackTracking()) {
            const follows = this.getFollowsForInRuleRecovery(tokType, idx);
            try {
                return this.tryInRuleRecovery(tokType, follows);
            } catch (eFromInRuleRecovery) {
                if (eFromInRuleRecovery.name === $5d51f81a4b917e73$var$IN_RULE_RECOVERY_EXCEPTION) throw eFromConsumption;
                else throw eFromInRuleRecovery;
            }
        } else throw eFromConsumption;
    }
    saveRecogState() {
        const savedErrors = this.errors;
        const savedRuleStack = this.RULE_STACK.slice(0, this.RULE_STACK_IDX + 1);
        return {
            errors: savedErrors,
            lexerState: this.exportLexerState(),
            RULE_STACK: savedRuleStack,
            CST_STACK: this.CST_STACK
        };
    }
    reloadRecogState(newState) {
        this.errors = newState.errors;
        this.importLexerState(newState.lexerState);
        const saved = newState.RULE_STACK;
        for(let i = 0; i < saved.length; i++)this.RULE_STACK[i] = saved[i];
        this.RULE_STACK_IDX = saved.length - 1;
        if (this.RULE_STACK_IDX >= 0) {
            this.currRuleShortName = this.RULE_STACK[this.RULE_STACK_IDX];
            this.currRuleLookaheadFuncs = this.lookAheadFuncsCache[this.currRuleShortName];
        }
    }
    ruleInvocationStateUpdate(shortName, fullName, idxInCallingRule) {
        this.RULE_OCCURRENCE_STACK[++this.RULE_OCCURRENCE_STACK_IDX] = idxInCallingRule;
        this.RULE_STACK[++this.RULE_STACK_IDX] = shortName;
        this.currRuleShortName = shortName;
        this.currRuleLookaheadFuncs = this.lookAheadFuncsCache[shortName];
        this.cstInvocationStateUpdate(fullName);
    }
    isBackTracking() {
        return this.isBackTrackingStack.length !== 0;
    }
    getCurrRuleFullName() {
        const shortName = this.currRuleShortName;
        return this.shortRuleNameToFull[shortName];
    }
    shortRuleNameToFullName(shortName) {
        return this.shortRuleNameToFull[shortName];
    }
    isAtEndOfInput() {
        return this.tokenMatcher(this.LA(1), $5d51f81a4b917e73$export$c1a09112320b1603);
    }
    reset() {
        this.resetLexerState();
        this.subruleIdx = 0;
        this.currRuleShortName = -1;
        this.currRuleLookaheadFuncs = [];
        this.isBackTrackingStack = [];
        this.errors = [];
        this.RULE_STACK_IDX = -1;
        this.RULE_OCCURRENCE_STACK_IDX = -1;
        this.CST_STACK = [];
    }
    /**
   * Hook called before the root-level parsing rule is invoked.
   * This is only called when a rule is invoked directly by the consumer
   * (e.g., `parser.json()`), not when invoked as a sub-rule via SUBRULE.
   *
   * Override this method to perform actions before parsing begins.
   * The default implementation is a no-op.
   *
   * @param ruleName - The name of the root rule being invoked.
   */ onBeforeParse(ruleName) {
        for(let i = 0; i < this.maxLookahead + 1; i++)this.tokVector.push($5d51f81a4b917e73$var$END_OF_FILE);
    }
    /**
   * Hook called after the root-level parsing rule has completed (or thrown).
   * This is only called when a rule is invoked directly by the consumer
   * (e.g., `parser.json()`), not when invoked as a sub-rule via SUBRULE.
   *
   * This hook is called in a `finally` block, so it executes regardless of
   * whether parsing succeeded or threw an error.
   *
   * Override this method to perform actions after parsing completes.
   * The default implementation is a no-op.
   *
   * @param ruleName - The name of the root rule that was invoked.
   */ onAfterParse(ruleName) {
        if (this.isAtEndOfInput() === false) {
            const firstRedundantTok = this.LA(1);
            const errMsg = this.errorMessageProvider.buildNotAllInputParsedMessage({
                firstRedundant: firstRedundantTok,
                ruleName: this.getCurrRuleFullName()
            });
            this.SAVE_ERROR(new $5d51f81a4b917e73$export$3d36978a8da4a7e(errMsg, firstRedundantTok));
        }
        while(this.tokVector.at(-1) === $5d51f81a4b917e73$var$END_OF_FILE)this.tokVector.pop();
    }
};
// lib/src/parse/parser/traits/error_handler.js
var $5d51f81a4b917e73$var$ErrorHandler = class {
    initErrorHandler(config) {
        this._errors = [];
        this.errorMessageProvider = Object.hasOwn(config, "errorMessageProvider") ? config.errorMessageProvider : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.errorMessageProvider;
    }
    SAVE_ERROR(error) {
        if ($5d51f81a4b917e73$export$93d1e12f7a3ec65(error)) {
            error.context = {
                ruleStack: this.getHumanReadableRuleStack(),
                ruleOccurrenceStack: this.RULE_OCCURRENCE_STACK.slice(0, this.RULE_OCCURRENCE_STACK_IDX + 1)
            };
            this._errors.push(error);
            return error;
        } else throw Error("Trying to save an Error which is not a RecognitionException");
    }
    get errors() {
        return [
            ...this._errors
        ];
    }
    set errors(newErrors) {
        this._errors = newErrors;
    }
    // TODO: consider caching the error message computed information
    raiseEarlyExitException(occurrence, prodType, userDefinedErrMsg) {
        const ruleName = this.getCurrRuleFullName();
        const ruleGrammar = this.getGAstProductions()[ruleName];
        const lookAheadPathsPerAlternative = $5d51f81a4b917e73$var$getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, this.maxLookahead);
        const insideProdPaths = lookAheadPathsPerAlternative[0];
        const actualTokens = [];
        for(let i = 1; i <= this.maxLookahead; i++)actualTokens.push(this.LA(i));
        const msg = this.errorMessageProvider.buildEarlyExitMessage({
            expectedIterationPaths: insideProdPaths,
            actual: actualTokens,
            previous: this.LA(0),
            customUserDescription: userDefinedErrMsg,
            ruleName: ruleName
        });
        throw this.SAVE_ERROR(new $5d51f81a4b917e73$export$d9af24ca3761c042(msg, this.LA(1), this.LA(0)));
    }
    // TODO: consider caching the error message computed information
    raiseNoAltException(occurrence, errMsgTypes) {
        const ruleName = this.getCurrRuleFullName();
        const ruleGrammar = this.getGAstProductions()[ruleName];
        const lookAheadPathsPerAlternative = $5d51f81a4b917e73$var$getLookaheadPathsForOr(occurrence, ruleGrammar, this.maxLookahead);
        const actualTokens = [];
        for(let i = 1; i <= this.maxLookahead; i++)actualTokens.push(this.LA(i));
        const previousToken = this.LA(0);
        const errMsg = this.errorMessageProvider.buildNoViableAltMessage({
            expectedPathsPerAlt: lookAheadPathsPerAlternative,
            actual: actualTokens,
            previous: previousToken,
            customUserDescription: errMsgTypes,
            ruleName: this.getCurrRuleFullName()
        });
        throw this.SAVE_ERROR(new $5d51f81a4b917e73$export$24170894ee7a3e61(errMsg, this.LA(1), previousToken));
    }
};
// lib/src/parse/parser/traits/gast_recorder.js
var $5d51f81a4b917e73$var$RECORDING_NULL_OBJECT = {
    description: "This Object indicates the Parser is during Recording Phase"
};
Object.freeze($5d51f81a4b917e73$var$RECORDING_NULL_OBJECT);
var $5d51f81a4b917e73$var$HANDLE_SEPARATOR = true;
var $5d51f81a4b917e73$var$MAX_METHOD_IDX = 255;
var $5d51f81a4b917e73$var$RFT = $5d51f81a4b917e73$export$c255480b061bd6aa({
    name: "RECORDING_PHASE_TOKEN",
    pattern: $5d51f81a4b917e73$export$6168dc8908a6c652.NA
});
$5d51f81a4b917e73$var$augmentTokenTypes([
    $5d51f81a4b917e73$var$RFT
]);
var $5d51f81a4b917e73$var$RECORDING_PHASE_TOKEN = $5d51f81a4b917e73$export$eaddf8d68927eada($5d51f81a4b917e73$var$RFT, "This IToken indicates the Parser is in Recording Phase\n	See: https://chevrotain.io/docs/guide/internals.html#grammar-recording for details", // Negative positions are less likely to cause errors if the output of LA or CONSUME
// is incorrectly used during the recording phase.
-1, -1, -1, -1, -1, -1);
Object.freeze($5d51f81a4b917e73$var$RECORDING_PHASE_TOKEN);
var $5d51f81a4b917e73$var$RECORDING_PHASE_CSTNODE = {
    name: "This CSTNode indicates the Parser is in Recording Phase\n	See: https://chevrotain.io/docs/guide/internals.html#grammar-recording for details",
    children: {}
};
var $5d51f81a4b917e73$var$GastRecorder = class {
    initGastRecorder(config) {
        this.recordingProdStack = [];
        this.RECORDING_PHASE = false;
    }
    enableRecording() {
        this.RECORDING_PHASE = true;
        this.TRACE_INIT("Enable Recording", ()=>{
            for(let i = 0; i < 10; i++){
                const idx = i > 0 ? i : "";
                this[`CONSUME${idx}`] = function(arg1, arg2) {
                    return this.consumeInternalRecord(arg1, i, arg2);
                };
                this[`SUBRULE${idx}`] = function(arg1, arg2) {
                    return this.subruleInternalRecord(arg1, i, arg2);
                };
                this[`OPTION${idx}`] = function(arg1) {
                    return this.optionInternalRecord(arg1, i);
                };
                this[`OR${idx}`] = function(arg1) {
                    return this.orInternalRecord(arg1, i);
                };
                this[`MANY${idx}`] = function(arg1) {
                    this.manyInternalRecord(i, arg1);
                };
                this[`MANY_SEP${idx}`] = function(arg1) {
                    this.manySepFirstInternalRecord(i, arg1);
                };
                this[`AT_LEAST_ONE${idx}`] = function(arg1) {
                    this.atLeastOneInternalRecord(i, arg1);
                };
                this[`AT_LEAST_ONE_SEP${idx}`] = function(arg1) {
                    this.atLeastOneSepFirstInternalRecord(i, arg1);
                };
            }
            this[`consume`] = function(idx, arg1, arg2) {
                return this.consumeInternalRecord(arg1, idx, arg2);
            };
            this[`subrule`] = function(idx, arg1, arg2) {
                return this.subruleInternalRecord(arg1, idx, arg2);
            };
            this[`option`] = function(idx, arg1) {
                return this.optionInternalRecord(arg1, idx);
            };
            this[`or`] = function(idx, arg1) {
                return this.orInternalRecord(arg1, idx);
            };
            this[`many`] = function(idx, arg1) {
                this.manyInternalRecord(idx, arg1);
            };
            this[`atLeastOne`] = function(idx, arg1) {
                this.atLeastOneInternalRecord(idx, arg1);
            };
            this.ACTION = this.ACTION_RECORD;
            this.BACKTRACK = this.BACKTRACK_RECORD;
            this.LA = this.LA_RECORD;
        });
    }
    disableRecording() {
        this.RECORDING_PHASE = false;
        this.TRACE_INIT("Deleting Recording methods", ()=>{
            const that = this;
            for(let i = 0; i < 10; i++){
                const idx = i > 0 ? i : "";
                delete that[`CONSUME${idx}`];
                delete that[`SUBRULE${idx}`];
                delete that[`OPTION${idx}`];
                delete that[`OR${idx}`];
                delete that[`MANY${idx}`];
                delete that[`MANY_SEP${idx}`];
                delete that[`AT_LEAST_ONE${idx}`];
                delete that[`AT_LEAST_ONE_SEP${idx}`];
            }
            delete that[`consume`];
            delete that[`subrule`];
            delete that[`option`];
            delete that[`or`];
            delete that[`many`];
            delete that[`atLeastOne`];
            delete that.ACTION;
            delete that.BACKTRACK;
            delete that.LA;
        });
    }
    //   Parser methods are called inside an ACTION?
    //   Maybe try/catch/finally on ACTIONS while disabling the recorders state changes?
    // @ts-expect-error -- noop place holder
    ACTION_RECORD(impl) {}
    // Executing backtracking logic will break our recording logic assumptions
    BACKTRACK_RECORD(grammarRule, args) {
        return ()=>true;
    }
    // LA is part of the official API and may be used for custom lookahead logic
    // by end users who may forget to wrap it in ACTION or inside a GATE
    LA_RECORD(howMuch) {
        return $5d51f81a4b917e73$var$END_OF_FILE;
    }
    topLevelRuleRecord(name, def) {
        try {
            const newTopLevelRule = new $5d51f81a4b917e73$export$f1ff2a90c38ff669({
                definition: [],
                name: name
            });
            newTopLevelRule.name = name;
            this.recordingProdStack.push(newTopLevelRule);
            def.call(this);
            this.recordingProdStack.pop();
            return newTopLevelRule;
        } catch (originalError) {
            if (originalError.KNOWN_RECORDER_ERROR !== true) try {
                originalError.message = originalError.message + '\n	 This error was thrown during the "grammar recording phase" For more info see:\n	https://chevrotain.io/docs/guide/internals.html#grammar-recording';
            } catch (mutabilityError) {
                throw originalError;
            }
            throw originalError;
        }
    }
    // Implementation of parsing DSL
    optionInternalRecord(actionORMethodDef, occurrence) {
        return $5d51f81a4b917e73$var$recordProd.call(this, $5d51f81a4b917e73$export$36d18380658d5d20, actionORMethodDef, occurrence);
    }
    atLeastOneInternalRecord(occurrence, actionORMethodDef) {
        $5d51f81a4b917e73$var$recordProd.call(this, $5d51f81a4b917e73$export$d068cf3ccde3d9e8, actionORMethodDef, occurrence);
    }
    atLeastOneSepFirstInternalRecord(occurrence, options) {
        $5d51f81a4b917e73$var$recordProd.call(this, $5d51f81a4b917e73$export$da6c5580175e0214, options, occurrence, $5d51f81a4b917e73$var$HANDLE_SEPARATOR);
    }
    manyInternalRecord(occurrence, actionORMethodDef) {
        $5d51f81a4b917e73$var$recordProd.call(this, $5d51f81a4b917e73$export$adf7bc0a69b784e9, actionORMethodDef, occurrence);
    }
    manySepFirstInternalRecord(occurrence, options) {
        $5d51f81a4b917e73$var$recordProd.call(this, $5d51f81a4b917e73$export$856dea708c981fb8, options, occurrence, $5d51f81a4b917e73$var$HANDLE_SEPARATOR);
    }
    orInternalRecord(altsOrOpts, occurrence) {
        return $5d51f81a4b917e73$var$recordOrProd.call(this, altsOrOpts, occurrence);
    }
    subruleInternalRecord(ruleToCall, occurrence, options) {
        $5d51f81a4b917e73$var$assertMethodIdxIsValid(occurrence);
        if (!ruleToCall || !Object.hasOwn(ruleToCall, "ruleName")) {
            const error = new Error(`<SUBRULE${$5d51f81a4b917e73$var$getIdxSuffix(occurrence)}> argument is invalid expecting a Parser method reference but got: <${JSON.stringify(ruleToCall)}>
 inside top level rule: <${this.recordingProdStack[0].name}>`);
            error.KNOWN_RECORDER_ERROR = true;
            throw error;
        }
        const prevProd = this.recordingProdStack.at(-1);
        const ruleName = ruleToCall.ruleName;
        const newNoneTerminal = new $5d51f81a4b917e73$export$ab116ec58638c09({
            idx: occurrence,
            nonTerminalName: ruleName,
            label: options === null || options === void 0 ? void 0 : options.LABEL,
            // The resolving of the `referencedRule` property will be done once all the Rule's GASTs have been created
            referencedRule: void 0
        });
        prevProd.definition.push(newNoneTerminal);
        return this.outputCst ? $5d51f81a4b917e73$var$RECORDING_PHASE_CSTNODE : $5d51f81a4b917e73$var$RECORDING_NULL_OBJECT;
    }
    consumeInternalRecord(tokType, occurrence, options) {
        $5d51f81a4b917e73$var$assertMethodIdxIsValid(occurrence);
        if (!$5d51f81a4b917e73$var$hasShortKeyProperty(tokType)) {
            const error = new Error(`<CONSUME${$5d51f81a4b917e73$var$getIdxSuffix(occurrence)}> argument is invalid expecting a TokenType reference but got: <${JSON.stringify(tokType)}>
 inside top level rule: <${this.recordingProdStack[0].name}>`);
            error.KNOWN_RECORDER_ERROR = true;
            throw error;
        }
        const prevProd = this.recordingProdStack.at(-1);
        const newNoneTerminal = new $5d51f81a4b917e73$export$8dd80f06eb58bfe1({
            idx: occurrence,
            terminalType: tokType,
            label: options === null || options === void 0 ? void 0 : options.LABEL
        });
        prevProd.definition.push(newNoneTerminal);
        return $5d51f81a4b917e73$var$RECORDING_PHASE_TOKEN;
    }
};
function $5d51f81a4b917e73$var$recordProd(prodConstructor, mainProdArg, occurrence, handleSep = false) {
    $5d51f81a4b917e73$var$assertMethodIdxIsValid(occurrence);
    const prevProd = this.recordingProdStack.at(-1);
    const grammarAction = typeof mainProdArg === "function" ? mainProdArg : mainProdArg.DEF;
    const newProd = new prodConstructor({
        definition: [],
        idx: occurrence
    });
    if (handleSep) newProd.separator = mainProdArg.SEP;
    if (Object.hasOwn(mainProdArg, "MAX_LOOKAHEAD")) newProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
    this.recordingProdStack.push(newProd);
    grammarAction.call(this);
    prevProd.definition.push(newProd);
    this.recordingProdStack.pop();
    return $5d51f81a4b917e73$var$RECORDING_NULL_OBJECT;
}
function $5d51f81a4b917e73$var$recordOrProd(mainProdArg, occurrence) {
    $5d51f81a4b917e73$var$assertMethodIdxIsValid(occurrence);
    const prevProd = this.recordingProdStack.at(-1);
    const hasOptions = Array.isArray(mainProdArg) === false;
    const alts = hasOptions === false ? mainProdArg : mainProdArg.DEF;
    const newOrProd = new $5d51f81a4b917e73$export$d8895f7a7cf86415({
        definition: [],
        idx: occurrence,
        ignoreAmbiguities: hasOptions && mainProdArg.IGNORE_AMBIGUITIES === true
    });
    if (Object.hasOwn(mainProdArg, "MAX_LOOKAHEAD")) newOrProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
    const hasPredicates = alts.some((currAlt)=>typeof currAlt.GATE === "function");
    newOrProd.hasPredicates = hasPredicates;
    prevProd.definition.push(newOrProd);
    alts.forEach((currAlt)=>{
        const currAltFlat = new $5d51f81a4b917e73$export$4acb47accde578d2({
            definition: []
        });
        newOrProd.definition.push(currAltFlat);
        if (Object.hasOwn(currAlt, "IGNORE_AMBIGUITIES")) currAltFlat.ignoreAmbiguities = currAlt.IGNORE_AMBIGUITIES;
        else if (Object.hasOwn(currAlt, "GATE")) currAltFlat.ignoreAmbiguities = true;
        this.recordingProdStack.push(currAltFlat);
        currAlt.ALT.call(this);
        this.recordingProdStack.pop();
    });
    return $5d51f81a4b917e73$var$RECORDING_NULL_OBJECT;
}
function $5d51f81a4b917e73$var$getIdxSuffix(idx) {
    return idx === 0 ? "" : `${idx}`;
}
function $5d51f81a4b917e73$var$assertMethodIdxIsValid(idx) {
    if (idx < 0 || idx > $5d51f81a4b917e73$var$MAX_METHOD_IDX) {
        const error = new Error(// The stack trace will contain all the needed details
        `Invalid DSL Method idx value: <${idx}>
	Idx value must be a none negative value smaller than ${$5d51f81a4b917e73$var$MAX_METHOD_IDX + 1}`);
        error.KNOWN_RECORDER_ERROR = true;
        throw error;
    }
}
// lib/src/parse/parser/traits/perf_tracer.js
var $5d51f81a4b917e73$var$PerformanceTracer = class {
    initPerformanceTracer(config) {
        if (Object.hasOwn(config, "traceInitPerf")) {
            const userTraceInitPerf = config.traceInitPerf;
            const traceIsNumber = typeof userTraceInitPerf === "number";
            this.traceInitMaxIdent = traceIsNumber ? userTraceInitPerf : Infinity;
            this.traceInitPerf = traceIsNumber ? userTraceInitPerf > 0 : userTraceInitPerf;
        } else {
            this.traceInitMaxIdent = 0;
            this.traceInitPerf = $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.traceInitPerf;
        }
        this.traceInitIndent = -1;
    }
    TRACE_INIT(phaseDesc, phaseImpl) {
        if (this.traceInitPerf === true) {
            this.traceInitIndent++;
            const indent = new Array(this.traceInitIndent + 1).join("	");
            if (this.traceInitIndent < this.traceInitMaxIdent) console.log(`${indent}--> <${phaseDesc}>`);
            const { time: time, value: value } = $5d51f81a4b917e73$var$timer(phaseImpl);
            const traceMethod = time > 10 ? console.warn : console.log;
            if (this.traceInitIndent < this.traceInitMaxIdent) traceMethod(`${indent}<-- <${phaseDesc}> time: ${time}ms`);
            this.traceInitIndent--;
            return value;
        } else return phaseImpl();
    }
};
// lib/src/parse/parser/utils/apply_mixins.js
function $5d51f81a4b917e73$var$applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach((baseCtor)=>{
        const baseProto = baseCtor.prototype;
        Object.getOwnPropertyNames(baseProto).forEach((propName)=>{
            if (propName === "constructor") return;
            const basePropDescriptor = Object.getOwnPropertyDescriptor(baseProto, propName);
            if (basePropDescriptor && (basePropDescriptor.get || basePropDescriptor.set)) Object.defineProperty(derivedCtor.prototype, propName, basePropDescriptor);
            else derivedCtor.prototype[propName] = baseCtor.prototype[propName];
        });
    });
}
// lib/src/parse/parser/parser.js
var $5d51f81a4b917e73$var$END_OF_FILE = $5d51f81a4b917e73$export$eaddf8d68927eada($5d51f81a4b917e73$export$c1a09112320b1603, "", -1, -1, -1, -1, -1, -1);
Object.freeze($5d51f81a4b917e73$var$END_OF_FILE);
var $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG = Object.freeze({
    recoveryEnabled: false,
    maxLookahead: 3,
    dynamicTokensEnabled: false,
    outputCst: true,
    errorMessageProvider: $5d51f81a4b917e73$export$d0949d751bf6767,
    nodeLocationTracking: "none",
    traceInitPerf: false,
    skipValidations: false
});
var $5d51f81a4b917e73$var$DEFAULT_RULE_CONFIG = Object.freeze({
    recoveryValueFunc: ()=>void 0,
    resyncEnabled: true
});
var $5d51f81a4b917e73$export$86bd3f602f298cb6;
(function(ParserDefinitionErrorType2) {
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_RULE_NAME"] = 0] = "INVALID_RULE_NAME";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["DUPLICATE_RULE_NAME"] = 1] = "DUPLICATE_RULE_NAME";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_RULE_OVERRIDE"] = 2] = "INVALID_RULE_OVERRIDE";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["DUPLICATE_PRODUCTIONS"] = 3] = "DUPLICATE_PRODUCTIONS";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["UNRESOLVED_SUBRULE_REF"] = 4] = "UNRESOLVED_SUBRULE_REF";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["LEFT_RECURSION"] = 5] = "LEFT_RECURSION";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["NONE_LAST_EMPTY_ALT"] = 6] = "NONE_LAST_EMPTY_ALT";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["AMBIGUOUS_ALTS"] = 7] = "AMBIGUOUS_ALTS";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["CONFLICT_TOKENS_RULES_NAMESPACE"] = 8] = "CONFLICT_TOKENS_RULES_NAMESPACE";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["INVALID_TOKEN_NAME"] = 9] = "INVALID_TOKEN_NAME";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["NO_NON_EMPTY_LOOKAHEAD"] = 10] = "NO_NON_EMPTY_LOOKAHEAD";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["AMBIGUOUS_PREFIX_ALTS"] = 11] = "AMBIGUOUS_PREFIX_ALTS";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["TOO_MANY_ALTS"] = 12] = "TOO_MANY_ALTS";
    ParserDefinitionErrorType2[ParserDefinitionErrorType2["CUSTOM_LOOKAHEAD_VALIDATION"] = 13] = "CUSTOM_LOOKAHEAD_VALIDATION";
})($5d51f81a4b917e73$export$86bd3f602f298cb6 || ($5d51f81a4b917e73$export$86bd3f602f298cb6 = {}));
function $5d51f81a4b917e73$export$ce9c850516ba763e(value) {
    return function() {
        return value;
    };
}
var $5d51f81a4b917e73$var$Parser = class _Parser {
    /**
   *  @deprecated use the **instance** method with the same name instead
   */ static performSelfAnalysis(parserInstance) {
        throw Error("The **static** `performSelfAnalysis` method has been deprecated.	\nUse the **instance** method with the same name instead.");
    }
    performSelfAnalysis() {
        this.TRACE_INIT("performSelfAnalysis", ()=>{
            let defErrorsMsgs;
            this.selfAnalysisDone = true;
            const className = this.className;
            this.TRACE_INIT("toFastProps", ()=>{
                $5d51f81a4b917e73$var$toFastProperties(this);
            });
            this.TRACE_INIT("Grammar Recording", ()=>{
                try {
                    this.enableRecording();
                    this.definedRulesNames.forEach((currRuleName)=>{
                        const wrappedRule = this[currRuleName];
                        const originalGrammarAction = wrappedRule["originalGrammarAction"];
                        let recordedRuleGast;
                        this.TRACE_INIT(`${currRuleName} Rule`, ()=>{
                            recordedRuleGast = this.topLevelRuleRecord(currRuleName, originalGrammarAction);
                        });
                        this.gastProductionsCache[currRuleName] = recordedRuleGast;
                    });
                } finally{
                    this.disableRecording();
                }
            });
            let resolverErrors = [];
            this.TRACE_INIT("Grammar Resolving", ()=>{
                resolverErrors = $5d51f81a4b917e73$var$resolveGrammar2({
                    rules: Object.values(this.gastProductionsCache)
                });
                this.definitionErrors = this.definitionErrors.concat(resolverErrors);
            });
            this.TRACE_INIT("Grammar Validations", ()=>{
                if (resolverErrors.length === 0 && this.skipValidations === false) {
                    const validationErrors = $5d51f81a4b917e73$var$validateGrammar2({
                        rules: Object.values(this.gastProductionsCache),
                        tokenTypes: Object.values(this.tokensMap),
                        errMsgProvider: $5d51f81a4b917e73$var$defaultGrammarValidatorErrorProvider,
                        grammarName: className
                    });
                    const lookaheadValidationErrors = $5d51f81a4b917e73$var$validateLookahead({
                        lookaheadStrategy: this.lookaheadStrategy,
                        rules: Object.values(this.gastProductionsCache),
                        tokenTypes: Object.values(this.tokensMap),
                        grammarName: className
                    });
                    this.definitionErrors = this.definitionErrors.concat(validationErrors, lookaheadValidationErrors);
                }
            });
            if (this.definitionErrors.length === 0) {
                if (this.recoveryEnabled) this.TRACE_INIT("computeAllProdsFollows", ()=>{
                    const allFollows = $5d51f81a4b917e73$var$computeAllProdsFollows(Object.values(this.gastProductionsCache));
                    this.resyncFollows = allFollows;
                });
                this.TRACE_INIT("ComputeLookaheadFunctions", ()=>{
                    var _a, _b;
                    (_b = (_a = this.lookaheadStrategy).initialize) === null || _b === void 0 || _b.call(_a, {
                        rules: Object.values(this.gastProductionsCache)
                    });
                    this.preComputeLookaheadFunctions(Object.values(this.gastProductionsCache));
                });
            }
            if (!_Parser.DEFER_DEFINITION_ERRORS_HANDLING && this.definitionErrors.length !== 0) {
                defErrorsMsgs = this.definitionErrors.map((defError)=>defError.message);
                throw new Error(`Parser Definition Errors detected:
 ${defErrorsMsgs.join("\n-------------------------------\n")}`);
            }
        });
    }
    constructor(tokenVocabulary, config){
        this.definitionErrors = [];
        this.selfAnalysisDone = false;
        const that = this;
        that.initErrorHandler(config);
        that.initLexerAdapter();
        that.initLooksAhead(config);
        that.initRecognizerEngine(tokenVocabulary, config);
        that.initRecoverable(config);
        that.initTreeBuilder(config);
        that.initGastRecorder(config);
        that.initPerformanceTracer(config);
        if (Object.hasOwn(config, "ignoredIssues")) throw new Error("The <ignoredIssues> IParserConfig property has been deprecated.\n	Please use the <IGNORE_AMBIGUITIES> flag on the relevant DSL method instead.\n	See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#IGNORING_AMBIGUITIES\n	For further details.");
        this.skipValidations = Object.hasOwn(config, "skipValidations") ? config.skipValidations : $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG.skipValidations;
    }
};
$5d51f81a4b917e73$var$Parser.DEFER_DEFINITION_ERRORS_HANDLING = false;
$5d51f81a4b917e73$var$applyMixins($5d51f81a4b917e73$var$Parser, [
    $5d51f81a4b917e73$var$Recoverable,
    $5d51f81a4b917e73$var$LooksAhead,
    $5d51f81a4b917e73$var$TreeBuilder,
    $5d51f81a4b917e73$var$LexerAdapter,
    $5d51f81a4b917e73$var$RecognizerEngine,
    $5d51f81a4b917e73$var$RecognizerApi,
    $5d51f81a4b917e73$var$ErrorHandler,
    $5d51f81a4b917e73$var$GastRecorder,
    $5d51f81a4b917e73$var$PerformanceTracer
]);
var $5d51f81a4b917e73$export$3ee4bf74abf432cd = class extends $5d51f81a4b917e73$var$Parser {
    constructor(tokenVocabulary, config = $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG){
        const configClone = Object.assign({}, config);
        configClone.outputCst = true;
        super(tokenVocabulary, configClone);
    }
};
var $5d51f81a4b917e73$export$e1a5f464f819d888 = class extends $5d51f81a4b917e73$var$Parser {
    constructor(tokenVocabulary, config = $5d51f81a4b917e73$var$DEFAULT_PARSER_CONFIG){
        const configClone = Object.assign({}, config);
        configClone.outputCst = false;
        super(tokenVocabulary, configClone);
    }
};
// ../cst-dts-gen/lib/src/model.js
function $5d51f81a4b917e73$var$buildModel(productions) {
    const generator = new $5d51f81a4b917e73$var$CstNodeDefinitionGenerator();
    const allRules = Object.values(productions);
    return allRules.map((rule)=>generator.visitRule(rule));
}
var $5d51f81a4b917e73$var$CstNodeDefinitionGenerator = class extends $5d51f81a4b917e73$export$341eb7a348fb5523 {
    visitRule(node) {
        const rawElements = this.visitEach(node.definition);
        const grouped = Object.groupBy(rawElements, (el)=>el.propertyName);
        const properties = Object.entries(grouped).map(([propertyName, group])=>{
            const allNullable = !group.some((el)=>!el.canBeNull);
            let propertyType = group[0].type;
            if (group.length > 1) propertyType = group.map((g)=>g.type);
            return {
                name: propertyName,
                type: propertyType,
                optional: allNullable
            };
        });
        return {
            name: node.name,
            properties: properties
        };
    }
    visitAlternative(node) {
        return this.visitEachAndOverrideWith(node.definition, {
            canBeNull: true
        });
    }
    visitOption(node) {
        return this.visitEachAndOverrideWith(node.definition, {
            canBeNull: true
        });
    }
    visitRepetition(node) {
        return this.visitEachAndOverrideWith(node.definition, {
            canBeNull: true
        });
    }
    visitRepetitionMandatory(node) {
        return this.visitEach(node.definition);
    }
    visitRepetitionMandatoryWithSeparator(node) {
        return this.visitEach(node.definition).concat({
            propertyName: node.separator.name,
            canBeNull: true,
            type: $5d51f81a4b917e73$var$getType(node.separator)
        });
    }
    visitRepetitionWithSeparator(node) {
        return this.visitEachAndOverrideWith(node.definition, {
            canBeNull: true
        }).concat({
            propertyName: node.separator.name,
            canBeNull: true,
            type: $5d51f81a4b917e73$var$getType(node.separator)
        });
    }
    visitAlternation(node) {
        return this.visitEachAndOverrideWith(node.definition, {
            canBeNull: true
        });
    }
    visitTerminal(node) {
        return [
            {
                propertyName: node.label || node.terminalType.name,
                canBeNull: false,
                type: $5d51f81a4b917e73$var$getType(node)
            }
        ];
    }
    visitNonTerminal(node) {
        return [
            {
                propertyName: node.label || node.nonTerminalName,
                canBeNull: false,
                type: $5d51f81a4b917e73$var$getType(node)
            }
        ];
    }
    visitEachAndOverrideWith(definition, override) {
        return this.visitEach(definition).map((definition2)=>Object.assign(Object.assign({}, definition2), override));
    }
    visitEach(definition) {
        return definition.flatMap((definition2)=>this.visit(definition2));
    }
};
function $5d51f81a4b917e73$var$getType(production) {
    if (production instanceof $5d51f81a4b917e73$export$ab116ec58638c09) return {
        kind: "rule",
        name: production.referencedRule.name
    };
    return {
        kind: "token"
    };
}
// ../cst-dts-gen/lib/src/generate.js
function $5d51f81a4b917e73$var$genDts(model, options) {
    let contentParts = [];
    contentParts = contentParts.concat(`import type { CstNode, ICstVisitor, IToken } from "chevrotain";`);
    contentParts = contentParts.concat(model.flatMap((node)=>$5d51f81a4b917e73$var$genCstNodeTypes(node)));
    if (options.includeVisitorInterface) contentParts = contentParts.concat($5d51f81a4b917e73$var$genVisitor(options.visitorInterfaceName, model));
    return contentParts.join("\n\n") + "\n";
}
function $5d51f81a4b917e73$var$genCstNodeTypes(node) {
    const nodeCstInterface = $5d51f81a4b917e73$var$genNodeInterface(node);
    const nodeChildrenInterface = $5d51f81a4b917e73$var$genNodeChildrenType(node);
    return [
        nodeCstInterface,
        nodeChildrenInterface
    ];
}
function $5d51f81a4b917e73$var$genNodeInterface(node) {
    const nodeInterfaceName = $5d51f81a4b917e73$var$getNodeInterfaceName(node.name);
    const childrenTypeName = $5d51f81a4b917e73$var$getNodeChildrenTypeName(node.name);
    return `export interface ${nodeInterfaceName} extends CstNode {
  name: "${node.name}";
  children: ${childrenTypeName};
}`;
}
function $5d51f81a4b917e73$var$genNodeChildrenType(node) {
    const typeName = $5d51f81a4b917e73$var$getNodeChildrenTypeName(node.name);
    return `export type ${typeName} = {
  ${node.properties.map((property)=>$5d51f81a4b917e73$var$genChildProperty(property)).join("\n  ")}
};`;
}
function $5d51f81a4b917e73$var$genChildProperty(prop) {
    const typeName = $5d51f81a4b917e73$var$buildTypeString(prop.type);
    return `${prop.name}${prop.optional ? "?" : ""}: ${typeName}[];`;
}
function $5d51f81a4b917e73$var$genVisitor(name, nodes) {
    return `export interface ${name}<IN, OUT> extends ICstVisitor<IN, OUT> {
  ${nodes.map((node)=>$5d51f81a4b917e73$var$genVisitorFunction(node)).join("\n  ")}
}`;
}
function $5d51f81a4b917e73$var$genVisitorFunction(node) {
    const childrenTypeName = $5d51f81a4b917e73$var$getNodeChildrenTypeName(node.name);
    return `${node.name}(children: ${childrenTypeName}, param?: IN): OUT;`;
}
function $5d51f81a4b917e73$var$buildTypeString(type) {
    if (Array.isArray(type)) {
        const typeNames = [
            ...new Set(type.map((t)=>$5d51f81a4b917e73$var$getTypeString(t)))
        ];
        const typeString = typeNames.join(" | ");
        return "(" + typeString + ")";
    } else return $5d51f81a4b917e73$var$getTypeString(type);
}
function $5d51f81a4b917e73$var$getTypeString(type) {
    if (type.kind === "token") return "IToken";
    return $5d51f81a4b917e73$var$getNodeInterfaceName(type.name);
}
function $5d51f81a4b917e73$var$getNodeInterfaceName(ruleName) {
    return ruleName.charAt(0).toUpperCase() + ruleName.slice(1) + "CstNode";
}
function $5d51f81a4b917e73$var$getNodeChildrenTypeName(ruleName) {
    return ruleName.charAt(0).toUpperCase() + ruleName.slice(1) + "CstChildren";
}
// ../cst-dts-gen/lib/src/api.js
var $5d51f81a4b917e73$var$defaultOptions = {
    includeVisitorInterface: true,
    visitorInterfaceName: "ICstNodeVisitor"
};
function $5d51f81a4b917e73$export$5738948a585c82cf(productions, options) {
    const effectiveOptions = Object.assign(Object.assign({}, $5d51f81a4b917e73$var$defaultOptions), options);
    const model = $5d51f81a4b917e73$var$buildModel(productions);
    return $5d51f81a4b917e73$var$genDts(model, effectiveOptions);
}
// lib/src/diagrams/render_public.js
function $5d51f81a4b917e73$export$6aabac36f625c484(grammar, { resourceBase: resourceBase = `https://unpkg.com/chevrotain@${$5d51f81a4b917e73$export$a4ad2735b021c132}/diagrams/`, css: css = `https://unpkg.com/chevrotain@${$5d51f81a4b917e73$export$a4ad2735b021c132}/diagrams/diagrams.css` } = {}) {
    const header = `
<!-- This is a generated file -->
<!DOCTYPE html>
<meta charset="utf-8">
<style>
  body {
    background-color: hsl(30, 20%, 95%)
  }
</style>

`;
    const cssHtml = `
<link rel='stylesheet' href='${css}'>
`;
    const scripts = `
<script src='${resourceBase}vendor/railroad-diagrams.js'><\/script>
<script src='${resourceBase}src/diagrams_builder.js'><\/script>
<script src='${resourceBase}src/diagrams_behavior.js'><\/script>
<script src='${resourceBase}src/main.js'><\/script>
`;
    const diagramsDiv = `
<div id="diagrams" align="center"></div>    
`;
    const serializedGrammar = `
<script>
    window.serializedGrammar = ${JSON.stringify(grammar, null, "  ")};
<\/script>
`;
    const initLogic = `
<script>
    var diagramsDiv = document.getElementById("diagrams");
    main.drawDiagramsFromSerializedGrammar(serializedGrammar, diagramsDiv);
<\/script>
`;
    return header + cssHtml + scripts + diagramsDiv + serializedGrammar + initLogic;
}
// lib/src/api.js
function $5d51f81a4b917e73$export$d2adf65b87e47523() {
    console.warn("The clearCache function was 'soft' removed from the Chevrotain API.\n	 It performs no action other than printing this message.\n	 Please avoid using it as it will be completely removed in the future");
}
var $5d51f81a4b917e73$export$7acfa6ed01010e37 = class {
    constructor(){
        throw new Error("The Parser class has been deprecated, use CstParser or EmbeddedActionsParser instead.	\nSee: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_7-0-0");
    }
};
 //# sourceMappingURL=chevrotain.mjs.map


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $55f64dd66ec6f60c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $55f64dd66ec6f60c$export$2e2bcd8739ae039 = $55f64dd66ec6f60c$var$arrayMap;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $28f7b4d4d85db112$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $28f7b4d4d85db112$export$2e2bcd8739ae039 = $28f7b4d4d85db112$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4a9cf7085845d776$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $4a9cf7085845d776$export$2e2bcd8739ae039 = $4a9cf7085845d776$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bbf5eacb8d0670e7$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $4a9cf7085845d776$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $bbf5eacb8d0670e7$export$2e2bcd8739ae039 = $bbf5eacb8d0670e7$var$assocIndexOf;


/** Used for built-in method references. */ var $e1d4940c3af8e700$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e1d4940c3af8e700$var$splice = $e1d4940c3af8e700$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e1d4940c3af8e700$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $bbf5eacb8d0670e7$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e1d4940c3af8e700$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $e1d4940c3af8e700$export$2e2bcd8739ae039 = $e1d4940c3af8e700$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0a0cbf8f1f5a7b5d$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $bbf5eacb8d0670e7$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $0a0cbf8f1f5a7b5d$export$2e2bcd8739ae039 = $0a0cbf8f1f5a7b5d$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1a04045a8d3a37b9$var$listCacheHas(key) {
    return (0, $bbf5eacb8d0670e7$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $1a04045a8d3a37b9$export$2e2bcd8739ae039 = $1a04045a8d3a37b9$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d7f77f1dd2f59053$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $bbf5eacb8d0670e7$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $d7f77f1dd2f59053$export$2e2bcd8739ae039 = $d7f77f1dd2f59053$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e27081b4540d52b2$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$e27081b4540d52b2$var$ListCache.prototype.clear = (0, $28f7b4d4d85db112$export$2e2bcd8739ae039);
$e27081b4540d52b2$var$ListCache.prototype['delete'] = (0, $e1d4940c3af8e700$export$2e2bcd8739ae039);
$e27081b4540d52b2$var$ListCache.prototype.get = (0, $0a0cbf8f1f5a7b5d$export$2e2bcd8739ae039);
$e27081b4540d52b2$var$ListCache.prototype.has = (0, $1a04045a8d3a37b9$export$2e2bcd8739ae039);
$e27081b4540d52b2$var$ListCache.prototype.set = (0, $d7f77f1dd2f59053$export$2e2bcd8739ae039);
var $e27081b4540d52b2$export$2e2bcd8739ae039 = $e27081b4540d52b2$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d0497d89e8f4879d$var$stackClear() {
    this.__data__ = new (0, $e27081b4540d52b2$export$2e2bcd8739ae039);
    this.size = 0;
}
var $d0497d89e8f4879d$export$2e2bcd8739ae039 = $d0497d89e8f4879d$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d3c55e7ba154f8c2$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $d3c55e7ba154f8c2$export$2e2bcd8739ae039 = $d3c55e7ba154f8c2$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ce0031ac9d230aee$var$stackGet(key) {
    return this.__data__.get(key);
}
var $ce0031ac9d230aee$export$2e2bcd8739ae039 = $ce0031ac9d230aee$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0bcfadd96001942b$var$stackHas(key) {
    return this.__data__.has(key);
}
var $0bcfadd96001942b$export$2e2bcd8739ae039 = $0bcfadd96001942b$var$stackHas;




var $02MqS = parcelRequire("02MqS");
/** Built-in value references. */ var $9a7dded94d011067$var$Symbol = (0, $02MqS.default).Symbol;
var $9a7dded94d011067$export$2e2bcd8739ae039 = $9a7dded94d011067$var$Symbol;



/** Used for built-in method references. */ var $3fae9a351860d41f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3fae9a351860d41f$var$hasOwnProperty = $3fae9a351860d41f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fae9a351860d41f$var$nativeObjectToString = $3fae9a351860d41f$var$objectProto.toString;
/** Built-in value references. */ var $3fae9a351860d41f$var$symToStringTag = (0, $9a7dded94d011067$export$2e2bcd8739ae039) ? (0, $9a7dded94d011067$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3fae9a351860d41f$var$getRawTag(value) {
    var isOwn = $3fae9a351860d41f$var$hasOwnProperty.call(value, $3fae9a351860d41f$var$symToStringTag), tag = value[$3fae9a351860d41f$var$symToStringTag];
    try {
        value[$3fae9a351860d41f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3fae9a351860d41f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3fae9a351860d41f$var$symToStringTag] = tag;
        else delete value[$3fae9a351860d41f$var$symToStringTag];
    }
    return result;
}
var $3fae9a351860d41f$export$2e2bcd8739ae039 = $3fae9a351860d41f$var$getRawTag;


/** Used for built-in method references. */ var $85d58776d335b45f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $85d58776d335b45f$var$nativeObjectToString = $85d58776d335b45f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $85d58776d335b45f$var$objectToString(value) {
    return $85d58776d335b45f$var$nativeObjectToString.call(value);
}
var $85d58776d335b45f$export$2e2bcd8739ae039 = $85d58776d335b45f$var$objectToString;


/** `Object#toString` result references. */ var $9e036b5e76200ae5$var$nullTag = '[object Null]', $9e036b5e76200ae5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $9e036b5e76200ae5$var$symToStringTag = (0, $9a7dded94d011067$export$2e2bcd8739ae039) ? (0, $9a7dded94d011067$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9e036b5e76200ae5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9e036b5e76200ae5$var$undefinedTag : $9e036b5e76200ae5$var$nullTag;
    return $9e036b5e76200ae5$var$symToStringTag && $9e036b5e76200ae5$var$symToStringTag in Object(value) ? (0, $3fae9a351860d41f$export$2e2bcd8739ae039)(value) : (0, $85d58776d335b45f$export$2e2bcd8739ae039)(value);
}
var $9e036b5e76200ae5$export$2e2bcd8739ae039 = $9e036b5e76200ae5$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $00b70503e642bfc6$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $00b70503e642bfc6$export$2e2bcd8739ae039 = $00b70503e642bfc6$var$isObject;


/** `Object#toString` result references. */ var $bc2818b501580b3d$var$asyncTag = '[object AsyncFunction]', $bc2818b501580b3d$var$funcTag = '[object Function]', $bc2818b501580b3d$var$genTag = '[object GeneratorFunction]', $bc2818b501580b3d$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $bc2818b501580b3d$var$isFunction(value) {
    if (!(0, $00b70503e642bfc6$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $9e036b5e76200ae5$export$2e2bcd8739ae039)(value);
    return tag == $bc2818b501580b3d$var$funcTag || tag == $bc2818b501580b3d$var$genTag || tag == $bc2818b501580b3d$var$asyncTag || tag == $bc2818b501580b3d$var$proxyTag;
}
var $bc2818b501580b3d$export$2e2bcd8739ae039 = $bc2818b501580b3d$var$isFunction;



var $02MqS = parcelRequire("02MqS");
/** Used to detect overreaching core-js shims. */ var $b5f7a67fde7d4622$var$coreJsData = (0, $02MqS.default)['__core-js_shared__'];
var $b5f7a67fde7d4622$export$2e2bcd8739ae039 = $b5f7a67fde7d4622$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $796e6f11505e6fb4$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $b5f7a67fde7d4622$export$2e2bcd8739ae039) && (0, $b5f7a67fde7d4622$export$2e2bcd8739ae039).keys && (0, $b5f7a67fde7d4622$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $796e6f11505e6fb4$var$isMasked(func) {
    return !!$796e6f11505e6fb4$var$maskSrcKey && $796e6f11505e6fb4$var$maskSrcKey in func;
}
var $796e6f11505e6fb4$export$2e2bcd8739ae039 = $796e6f11505e6fb4$var$isMasked;



/** Used for built-in method references. */ var $e07269fabf384a16$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e07269fabf384a16$var$funcToString = $e07269fabf384a16$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e07269fabf384a16$var$toSource(func) {
    if (func != null) {
        try {
            return $e07269fabf384a16$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $e07269fabf384a16$export$2e2bcd8739ae039 = $e07269fabf384a16$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d2ac8db2cf6c7520$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d2ac8db2cf6c7520$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d2ac8db2cf6c7520$var$funcProto = Function.prototype, $d2ac8db2cf6c7520$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d2ac8db2cf6c7520$var$funcToString = $d2ac8db2cf6c7520$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d2ac8db2cf6c7520$var$hasOwnProperty = $d2ac8db2cf6c7520$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d2ac8db2cf6c7520$var$reIsNative = RegExp('^' + $d2ac8db2cf6c7520$var$funcToString.call($d2ac8db2cf6c7520$var$hasOwnProperty).replace($d2ac8db2cf6c7520$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d2ac8db2cf6c7520$var$baseIsNative(value) {
    if (!(0, $00b70503e642bfc6$export$2e2bcd8739ae039)(value) || (0, $796e6f11505e6fb4$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $bc2818b501580b3d$export$2e2bcd8739ae039)(value) ? $d2ac8db2cf6c7520$var$reIsNative : $d2ac8db2cf6c7520$var$reIsHostCtor;
    return pattern.test((0, $e07269fabf384a16$export$2e2bcd8739ae039)(value));
}
var $d2ac8db2cf6c7520$export$2e2bcd8739ae039 = $d2ac8db2cf6c7520$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $16dca0f4f2dca090$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $16dca0f4f2dca090$export$2e2bcd8739ae039 = $16dca0f4f2dca090$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $51d4dab099bc3121$var$getNative(object, key) {
    var value = (0, $16dca0f4f2dca090$export$2e2bcd8739ae039)(object, key);
    return (0, $d2ac8db2cf6c7520$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $51d4dab099bc3121$export$2e2bcd8739ae039 = $51d4dab099bc3121$var$getNative;



var $02MqS = parcelRequire("02MqS");
/* Built-in method references that are verified to be native. */ var $ae124f9313a0e384$var$Map = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)((0, $02MqS.default), 'Map');
var $ae124f9313a0e384$export$2e2bcd8739ae039 = $ae124f9313a0e384$var$Map;



/* Built-in method references that are verified to be native. */ var $20e005e1aaa6ed49$var$nativeCreate = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)(Object, 'create');
var $20e005e1aaa6ed49$export$2e2bcd8739ae039 = $20e005e1aaa6ed49$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c41606037d7c92d9$var$hashClear() {
    this.__data__ = (0, $20e005e1aaa6ed49$export$2e2bcd8739ae039) ? (0, $20e005e1aaa6ed49$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $c41606037d7c92d9$export$2e2bcd8739ae039 = $c41606037d7c92d9$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $be9da38d7f2f51fb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $be9da38d7f2f51fb$export$2e2bcd8739ae039 = $be9da38d7f2f51fb$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $76c3eccba60a615f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $76c3eccba60a615f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76c3eccba60a615f$var$hasOwnProperty = $76c3eccba60a615f$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $76c3eccba60a615f$var$hashGet(key) {
    var data = this.__data__;
    if (0, $20e005e1aaa6ed49$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $76c3eccba60a615f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $76c3eccba60a615f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $76c3eccba60a615f$export$2e2bcd8739ae039 = $76c3eccba60a615f$var$hashGet;



/** Used for built-in method references. */ var $f2f0989cf3d671b4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2f0989cf3d671b4$var$hasOwnProperty = $f2f0989cf3d671b4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f2f0989cf3d671b4$var$hashHas(key) {
    var data = this.__data__;
    return (0, $20e005e1aaa6ed49$export$2e2bcd8739ae039) ? data[key] !== undefined : $f2f0989cf3d671b4$var$hasOwnProperty.call(data, key);
}
var $f2f0989cf3d671b4$export$2e2bcd8739ae039 = $f2f0989cf3d671b4$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $d66040b6c0cfa9cb$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d66040b6c0cfa9cb$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $20e005e1aaa6ed49$export$2e2bcd8739ae039) && value === undefined ? $d66040b6c0cfa9cb$var$HASH_UNDEFINED : value;
    return this;
}
var $d66040b6c0cfa9cb$export$2e2bcd8739ae039 = $d66040b6c0cfa9cb$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3a914fd05061d4ac$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3a914fd05061d4ac$var$Hash.prototype.clear = (0, $c41606037d7c92d9$export$2e2bcd8739ae039);
$3a914fd05061d4ac$var$Hash.prototype['delete'] = (0, $be9da38d7f2f51fb$export$2e2bcd8739ae039);
$3a914fd05061d4ac$var$Hash.prototype.get = (0, $76c3eccba60a615f$export$2e2bcd8739ae039);
$3a914fd05061d4ac$var$Hash.prototype.has = (0, $f2f0989cf3d671b4$export$2e2bcd8739ae039);
$3a914fd05061d4ac$var$Hash.prototype.set = (0, $d66040b6c0cfa9cb$export$2e2bcd8739ae039);
var $3a914fd05061d4ac$export$2e2bcd8739ae039 = $3a914fd05061d4ac$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3bcace28fb6051f1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $3a914fd05061d4ac$export$2e2bcd8739ae039),
        'map': new ((0, $ae124f9313a0e384$export$2e2bcd8739ae039) || (0, $e27081b4540d52b2$export$2e2bcd8739ae039)),
        'string': new (0, $3a914fd05061d4ac$export$2e2bcd8739ae039)
    };
}
var $3bcace28fb6051f1$export$2e2bcd8739ae039 = $3bcace28fb6051f1$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $27d9bc9f7223f696$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $27d9bc9f7223f696$export$2e2bcd8739ae039 = $27d9bc9f7223f696$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $70999e0ceefdeeba$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $27d9bc9f7223f696$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $70999e0ceefdeeba$export$2e2bcd8739ae039 = $70999e0ceefdeeba$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bfa155c054dbace5$var$mapCacheDelete(key) {
    var result = (0, $70999e0ceefdeeba$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $bfa155c054dbace5$export$2e2bcd8739ae039 = $bfa155c054dbace5$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $311652ed15e27706$var$mapCacheGet(key) {
    return (0, $70999e0ceefdeeba$export$2e2bcd8739ae039)(this, key).get(key);
}
var $311652ed15e27706$export$2e2bcd8739ae039 = $311652ed15e27706$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ee9e8ad114375354$var$mapCacheHas(key) {
    return (0, $70999e0ceefdeeba$export$2e2bcd8739ae039)(this, key).has(key);
}
var $ee9e8ad114375354$export$2e2bcd8739ae039 = $ee9e8ad114375354$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b485f5038c487053$var$mapCacheSet(key, value) {
    var data = (0, $70999e0ceefdeeba$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $b485f5038c487053$export$2e2bcd8739ae039 = $b485f5038c487053$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5b5ab0dcd917cbc1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5b5ab0dcd917cbc1$var$MapCache.prototype.clear = (0, $3bcace28fb6051f1$export$2e2bcd8739ae039);
$5b5ab0dcd917cbc1$var$MapCache.prototype['delete'] = (0, $bfa155c054dbace5$export$2e2bcd8739ae039);
$5b5ab0dcd917cbc1$var$MapCache.prototype.get = (0, $311652ed15e27706$export$2e2bcd8739ae039);
$5b5ab0dcd917cbc1$var$MapCache.prototype.has = (0, $ee9e8ad114375354$export$2e2bcd8739ae039);
$5b5ab0dcd917cbc1$var$MapCache.prototype.set = (0, $b485f5038c487053$export$2e2bcd8739ae039);
var $5b5ab0dcd917cbc1$export$2e2bcd8739ae039 = $5b5ab0dcd917cbc1$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $814b709381d16a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $814b709381d16a90$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $e27081b4540d52b2$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $ae124f9313a0e384$export$2e2bcd8739ae039) || pairs.length < $814b709381d16a90$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5b5ab0dcd917cbc1$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $814b709381d16a90$export$2e2bcd8739ae039 = $814b709381d16a90$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $08a577656cb4caea$var$Stack(entries) {
    var data = this.__data__ = new (0, $e27081b4540d52b2$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$08a577656cb4caea$var$Stack.prototype.clear = (0, $d0497d89e8f4879d$export$2e2bcd8739ae039);
$08a577656cb4caea$var$Stack.prototype['delete'] = (0, $d3c55e7ba154f8c2$export$2e2bcd8739ae039);
$08a577656cb4caea$var$Stack.prototype.get = (0, $ce0031ac9d230aee$export$2e2bcd8739ae039);
$08a577656cb4caea$var$Stack.prototype.has = (0, $0bcfadd96001942b$export$2e2bcd8739ae039);
$08a577656cb4caea$var$Stack.prototype.set = (0, $814b709381d16a90$export$2e2bcd8739ae039);
var $08a577656cb4caea$export$2e2bcd8739ae039 = $08a577656cb4caea$var$Stack;




/** Used to stand-in for `undefined` hash values. */ var $f332d381c7d6f465$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f332d381c7d6f465$var$setCacheAdd(value) {
    this.__data__.set(value, $f332d381c7d6f465$var$HASH_UNDEFINED);
    return this;
}
var $f332d381c7d6f465$export$2e2bcd8739ae039 = $f332d381c7d6f465$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $475966c06de8d428$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $475966c06de8d428$export$2e2bcd8739ae039 = $475966c06de8d428$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5d01a3fbeab19d95$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5b5ab0dcd917cbc1$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5d01a3fbeab19d95$var$SetCache.prototype.add = $5d01a3fbeab19d95$var$SetCache.prototype.push = (0, $f332d381c7d6f465$export$2e2bcd8739ae039);
$5d01a3fbeab19d95$var$SetCache.prototype.has = (0, $475966c06de8d428$export$2e2bcd8739ae039);
var $5d01a3fbeab19d95$export$2e2bcd8739ae039 = $5d01a3fbeab19d95$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2109300f9498553f$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $2109300f9498553f$export$2e2bcd8739ae039 = $2109300f9498553f$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4b08e9ff54f81ac4$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $4b08e9ff54f81ac4$export$2e2bcd8739ae039 = $4b08e9ff54f81ac4$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $a3c08796427138c9$var$COMPARE_PARTIAL_FLAG = 1, $a3c08796427138c9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a3c08796427138c9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a3c08796427138c9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a3c08796427138c9$var$COMPARE_UNORDERED_FLAG ? new (0, $5d01a3fbeab19d95$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $2109300f9498553f$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $4b08e9ff54f81ac4$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $a3c08796427138c9$export$2e2bcd8739ae039 = $a3c08796427138c9$var$equalArrays;




var $02MqS = parcelRequire("02MqS");
/** Built-in value references. */ var $18382377e6e434c8$var$Uint8Array = (0, $02MqS.default).Uint8Array;
var $18382377e6e434c8$export$2e2bcd8739ae039 = $18382377e6e434c8$var$Uint8Array;




/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $3d0ddc8ecf9e3752$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $3d0ddc8ecf9e3752$export$2e2bcd8739ae039 = $3d0ddc8ecf9e3752$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $032c6d7b8d3880ac$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $032c6d7b8d3880ac$export$2e2bcd8739ae039 = $032c6d7b8d3880ac$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $7ef75e32a07edd4d$var$COMPARE_PARTIAL_FLAG = 1, $7ef75e32a07edd4d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $7ef75e32a07edd4d$var$boolTag = '[object Boolean]', $7ef75e32a07edd4d$var$dateTag = '[object Date]', $7ef75e32a07edd4d$var$errorTag = '[object Error]', $7ef75e32a07edd4d$var$mapTag = '[object Map]', $7ef75e32a07edd4d$var$numberTag = '[object Number]', $7ef75e32a07edd4d$var$regexpTag = '[object RegExp]', $7ef75e32a07edd4d$var$setTag = '[object Set]', $7ef75e32a07edd4d$var$stringTag = '[object String]', $7ef75e32a07edd4d$var$symbolTag = '[object Symbol]';
var $7ef75e32a07edd4d$var$arrayBufferTag = '[object ArrayBuffer]', $7ef75e32a07edd4d$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $7ef75e32a07edd4d$var$symbolProto = (0, $9a7dded94d011067$export$2e2bcd8739ae039) ? (0, $9a7dded94d011067$export$2e2bcd8739ae039).prototype : undefined, $7ef75e32a07edd4d$var$symbolValueOf = $7ef75e32a07edd4d$var$symbolProto ? $7ef75e32a07edd4d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7ef75e32a07edd4d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $7ef75e32a07edd4d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $7ef75e32a07edd4d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $18382377e6e434c8$export$2e2bcd8739ae039)(object), new (0, $18382377e6e434c8$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $7ef75e32a07edd4d$var$boolTag:
        case $7ef75e32a07edd4d$var$dateTag:
        case $7ef75e32a07edd4d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $4a9cf7085845d776$export$2e2bcd8739ae039)(+object, +other);
        case $7ef75e32a07edd4d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $7ef75e32a07edd4d$var$regexpTag:
        case $7ef75e32a07edd4d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $7ef75e32a07edd4d$var$mapTag:
            var convert = (0, $3d0ddc8ecf9e3752$export$2e2bcd8739ae039);
        case $7ef75e32a07edd4d$var$setTag:
            var isPartial = bitmask & $7ef75e32a07edd4d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $032c6d7b8d3880ac$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $7ef75e32a07edd4d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $a3c08796427138c9$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $7ef75e32a07edd4d$var$symbolTag:
            if ($7ef75e32a07edd4d$var$symbolValueOf) return $7ef75e32a07edd4d$var$symbolValueOf.call(object) == $7ef75e32a07edd4d$var$symbolValueOf.call(other);
    }
    return false;
}
var $7ef75e32a07edd4d$export$2e2bcd8739ae039 = $7ef75e32a07edd4d$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $e1871f1e848f62ac$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $e1871f1e848f62ac$export$2e2bcd8739ae039 = $e1871f1e848f62ac$var$arrayPush;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $58835d45b1d8c2e6$var$isArray = Array.isArray;
var $58835d45b1d8c2e6$export$2e2bcd8739ae039 = $58835d45b1d8c2e6$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d992a6cdd12bc3ac$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(object) ? result : (0, $e1871f1e848f62ac$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $d992a6cdd12bc3ac$export$2e2bcd8739ae039 = $d992a6cdd12bc3ac$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e55013fa8c4d755a$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $e55013fa8c4d755a$export$2e2bcd8739ae039 = $e55013fa8c4d755a$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $76495c396e27743c$var$stubArray() {
    return [];
}
var $76495c396e27743c$export$2e2bcd8739ae039 = $76495c396e27743c$var$stubArray;


/** Used for built-in method references. */ var $25141c144bc0f93a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $25141c144bc0f93a$var$propertyIsEnumerable = $25141c144bc0f93a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $25141c144bc0f93a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $25141c144bc0f93a$var$getSymbols = !$25141c144bc0f93a$var$nativeGetSymbols ? (0, $76495c396e27743c$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $e55013fa8c4d755a$export$2e2bcd8739ae039)($25141c144bc0f93a$var$nativeGetSymbols(object), function(symbol) {
        return $25141c144bc0f93a$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $25141c144bc0f93a$export$2e2bcd8739ae039 = $25141c144bc0f93a$var$getSymbols;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9dde8ef759fc3592$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $9dde8ef759fc3592$export$2e2bcd8739ae039 = $9dde8ef759fc3592$var$baseTimes;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b7e7d83ad8c2d937$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $b7e7d83ad8c2d937$export$2e2bcd8739ae039 = $b7e7d83ad8c2d937$var$isObjectLike;


/** `Object#toString` result references. */ var $6f998a85a1e418b1$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $6f998a85a1e418b1$var$baseIsArguments(value) {
    return (0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(value) && (0, $9e036b5e76200ae5$export$2e2bcd8739ae039)(value) == $6f998a85a1e418b1$var$argsTag;
}
var $6f998a85a1e418b1$export$2e2bcd8739ae039 = $6f998a85a1e418b1$var$baseIsArguments;



/** Used for built-in method references. */ var $b499c2101bbc7160$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b499c2101bbc7160$var$hasOwnProperty = $b499c2101bbc7160$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $b499c2101bbc7160$var$propertyIsEnumerable = $b499c2101bbc7160$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $b499c2101bbc7160$var$isArguments = (0, $6f998a85a1e418b1$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $6f998a85a1e418b1$export$2e2bcd8739ae039) : function(value) {
    return (0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(value) && $b499c2101bbc7160$var$hasOwnProperty.call(value, 'callee') && !$b499c2101bbc7160$var$propertyIsEnumerable.call(value, 'callee');
};
var $b499c2101bbc7160$export$2e2bcd8739ae039 = $b499c2101bbc7160$var$isArguments;




var $bFTps = parcelRequire("bFTps");
/** Used as references for various `Number` constants. */ var $f5ab26651d36e3a8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $f5ab26651d36e3a8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $f5ab26651d36e3a8$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $f5ab26651d36e3a8$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $f5ab26651d36e3a8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $f5ab26651d36e3a8$export$2e2bcd8739ae039 = $f5ab26651d36e3a8$var$isIndex;



/** Used as references for various `Number` constants. */ var $a14d74e772bd1a3e$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $a14d74e772bd1a3e$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $a14d74e772bd1a3e$var$MAX_SAFE_INTEGER;
}
var $a14d74e772bd1a3e$export$2e2bcd8739ae039 = $a14d74e772bd1a3e$var$isLength;



/** `Object#toString` result references. */ var $80f40b9ad2da5482$var$argsTag = '[object Arguments]', $80f40b9ad2da5482$var$arrayTag = '[object Array]', $80f40b9ad2da5482$var$boolTag = '[object Boolean]', $80f40b9ad2da5482$var$dateTag = '[object Date]', $80f40b9ad2da5482$var$errorTag = '[object Error]', $80f40b9ad2da5482$var$funcTag = '[object Function]', $80f40b9ad2da5482$var$mapTag = '[object Map]', $80f40b9ad2da5482$var$numberTag = '[object Number]', $80f40b9ad2da5482$var$objectTag = '[object Object]', $80f40b9ad2da5482$var$regexpTag = '[object RegExp]', $80f40b9ad2da5482$var$setTag = '[object Set]', $80f40b9ad2da5482$var$stringTag = '[object String]', $80f40b9ad2da5482$var$weakMapTag = '[object WeakMap]';
var $80f40b9ad2da5482$var$arrayBufferTag = '[object ArrayBuffer]', $80f40b9ad2da5482$var$dataViewTag = '[object DataView]', $80f40b9ad2da5482$var$float32Tag = '[object Float32Array]', $80f40b9ad2da5482$var$float64Tag = '[object Float64Array]', $80f40b9ad2da5482$var$int8Tag = '[object Int8Array]', $80f40b9ad2da5482$var$int16Tag = '[object Int16Array]', $80f40b9ad2da5482$var$int32Tag = '[object Int32Array]', $80f40b9ad2da5482$var$uint8Tag = '[object Uint8Array]', $80f40b9ad2da5482$var$uint8ClampedTag = '[object Uint8ClampedArray]', $80f40b9ad2da5482$var$uint16Tag = '[object Uint16Array]', $80f40b9ad2da5482$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $80f40b9ad2da5482$var$typedArrayTags = {};
$80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$float32Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$float64Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$int8Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$int16Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$int32Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$uint8Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$uint8ClampedTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$uint16Tag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$uint32Tag] = true;
$80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$argsTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$arrayTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$arrayBufferTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$boolTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$dataViewTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$dateTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$errorTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$funcTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$mapTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$numberTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$objectTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$regexpTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$setTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$stringTag] = $80f40b9ad2da5482$var$typedArrayTags[$80f40b9ad2da5482$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $80f40b9ad2da5482$var$baseIsTypedArray(value) {
    return (0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(value) && (0, $a14d74e772bd1a3e$export$2e2bcd8739ae039)(value.length) && !!$80f40b9ad2da5482$var$typedArrayTags[(0, $9e036b5e76200ae5$export$2e2bcd8739ae039)(value)];
}
var $80f40b9ad2da5482$export$2e2bcd8739ae039 = $80f40b9ad2da5482$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $f08f62eebe495dc9$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $f08f62eebe495dc9$export$2e2bcd8739ae039 = $f08f62eebe495dc9$var$baseUnary;



var $c3Q8B = parcelRequire("c3Q8B");
/* Node.js helper references. */ var $24f7bb18790a2a3a$var$nodeIsTypedArray = (0, $c3Q8B.default) && (0, $c3Q8B.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $24f7bb18790a2a3a$var$isTypedArray = $24f7bb18790a2a3a$var$nodeIsTypedArray ? (0, $f08f62eebe495dc9$export$2e2bcd8739ae039)($24f7bb18790a2a3a$var$nodeIsTypedArray) : (0, $80f40b9ad2da5482$export$2e2bcd8739ae039);
var $24f7bb18790a2a3a$export$2e2bcd8739ae039 = $24f7bb18790a2a3a$var$isTypedArray;


/** Used for built-in method references. */ var $cb81cddbc4a4fd7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cb81cddbc4a4fd7c$var$hasOwnProperty = $cb81cddbc4a4fd7c$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $cb81cddbc4a4fd7c$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $b499c2101bbc7160$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $bFTps.default)(value), isType = !isArr && !isArg && !isBuff && (0, $24f7bb18790a2a3a$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $9dde8ef759fc3592$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $cb81cddbc4a4fd7c$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $f5ab26651d36e3a8$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $cb81cddbc4a4fd7c$export$2e2bcd8739ae039 = $cb81cddbc4a4fd7c$var$arrayLikeKeys;


/** Used for built-in method references. */ var $919241523bfef5aa$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $919241523bfef5aa$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $919241523bfef5aa$var$objectProto;
    return value === proto;
}
var $919241523bfef5aa$export$2e2bcd8739ae039 = $919241523bfef5aa$var$isPrototype;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $627a760111c7d61a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $627a760111c7d61a$export$2e2bcd8739ae039 = $627a760111c7d61a$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $e65e80f388788bd0$var$nativeKeys = (0, $627a760111c7d61a$export$2e2bcd8739ae039)(Object.keys, Object);
var $e65e80f388788bd0$export$2e2bcd8739ae039 = $e65e80f388788bd0$var$nativeKeys;


/** Used for built-in method references. */ var $bafaa0e689a9dd7d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bafaa0e689a9dd7d$var$hasOwnProperty = $bafaa0e689a9dd7d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bafaa0e689a9dd7d$var$baseKeys(object) {
    if (!(0, $919241523bfef5aa$export$2e2bcd8739ae039)(object)) return (0, $e65e80f388788bd0$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($bafaa0e689a9dd7d$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $bafaa0e689a9dd7d$export$2e2bcd8739ae039 = $bafaa0e689a9dd7d$var$baseKeys;




/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d1a0a4913f704bea$var$isArrayLike(value) {
    return value != null && (0, $a14d74e772bd1a3e$export$2e2bcd8739ae039)(value.length) && !(0, $bc2818b501580b3d$export$2e2bcd8739ae039)(value);
}
var $d1a0a4913f704bea$export$2e2bcd8739ae039 = $d1a0a4913f704bea$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3c516bf80eda0866$var$keys(object) {
    return (0, $d1a0a4913f704bea$export$2e2bcd8739ae039)(object) ? (0, $cb81cddbc4a4fd7c$export$2e2bcd8739ae039)(object) : (0, $bafaa0e689a9dd7d$export$2e2bcd8739ae039)(object);
}
var $3c516bf80eda0866$export$2e2bcd8739ae039 = $3c516bf80eda0866$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6085d09ab40fc339$var$getAllKeys(object) {
    return (0, $d992a6cdd12bc3ac$export$2e2bcd8739ae039)(object, (0, $3c516bf80eda0866$export$2e2bcd8739ae039), (0, $25141c144bc0f93a$export$2e2bcd8739ae039));
}
var $6085d09ab40fc339$export$2e2bcd8739ae039 = $6085d09ab40fc339$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $842f50808f6e57cd$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $842f50808f6e57cd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $842f50808f6e57cd$var$hasOwnProperty = $842f50808f6e57cd$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $842f50808f6e57cd$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $842f50808f6e57cd$var$COMPARE_PARTIAL_FLAG, objProps = (0, $6085d09ab40fc339$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $6085d09ab40fc339$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $842f50808f6e57cd$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $842f50808f6e57cd$export$2e2bcd8739ae039 = $842f50808f6e57cd$var$equalObjects;




var $02MqS = parcelRequire("02MqS");
/* Built-in method references that are verified to be native. */ var $99be65023c1c68b1$var$DataView = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)((0, $02MqS.default), 'DataView');
var $99be65023c1c68b1$export$2e2bcd8739ae039 = $99be65023c1c68b1$var$DataView;





var $02MqS = parcelRequire("02MqS");
/* Built-in method references that are verified to be native. */ var $32a50572254d50fd$var$Promise = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)((0, $02MqS.default), 'Promise');
var $32a50572254d50fd$export$2e2bcd8739ae039 = $32a50572254d50fd$var$Promise;




var $02MqS = parcelRequire("02MqS");
/* Built-in method references that are verified to be native. */ var $6b8e734489284122$var$Set = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)((0, $02MqS.default), 'Set');
var $6b8e734489284122$export$2e2bcd8739ae039 = $6b8e734489284122$var$Set;




var $02MqS = parcelRequire("02MqS");
/* Built-in method references that are verified to be native. */ var $bc168b65c78339d0$var$WeakMap = (0, $51d4dab099bc3121$export$2e2bcd8739ae039)((0, $02MqS.default), 'WeakMap');
var $bc168b65c78339d0$export$2e2bcd8739ae039 = $bc168b65c78339d0$var$WeakMap;




/** `Object#toString` result references. */ var $20ff3b05fef2752c$var$mapTag = '[object Map]', $20ff3b05fef2752c$var$objectTag = '[object Object]', $20ff3b05fef2752c$var$promiseTag = '[object Promise]', $20ff3b05fef2752c$var$setTag = '[object Set]', $20ff3b05fef2752c$var$weakMapTag = '[object WeakMap]';
var $20ff3b05fef2752c$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $20ff3b05fef2752c$var$dataViewCtorString = (0, $e07269fabf384a16$export$2e2bcd8739ae039)((0, $99be65023c1c68b1$export$2e2bcd8739ae039)), $20ff3b05fef2752c$var$mapCtorString = (0, $e07269fabf384a16$export$2e2bcd8739ae039)((0, $ae124f9313a0e384$export$2e2bcd8739ae039)), $20ff3b05fef2752c$var$promiseCtorString = (0, $e07269fabf384a16$export$2e2bcd8739ae039)((0, $32a50572254d50fd$export$2e2bcd8739ae039)), $20ff3b05fef2752c$var$setCtorString = (0, $e07269fabf384a16$export$2e2bcd8739ae039)((0, $6b8e734489284122$export$2e2bcd8739ae039)), $20ff3b05fef2752c$var$weakMapCtorString = (0, $e07269fabf384a16$export$2e2bcd8739ae039)((0, $bc168b65c78339d0$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $20ff3b05fef2752c$var$getTag = (0, $9e036b5e76200ae5$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $99be65023c1c68b1$export$2e2bcd8739ae039) && $20ff3b05fef2752c$var$getTag(new (0, $99be65023c1c68b1$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $20ff3b05fef2752c$var$dataViewTag || (0, $ae124f9313a0e384$export$2e2bcd8739ae039) && $20ff3b05fef2752c$var$getTag(new (0, $ae124f9313a0e384$export$2e2bcd8739ae039)) != $20ff3b05fef2752c$var$mapTag || (0, $32a50572254d50fd$export$2e2bcd8739ae039) && $20ff3b05fef2752c$var$getTag((0, $32a50572254d50fd$export$2e2bcd8739ae039).resolve()) != $20ff3b05fef2752c$var$promiseTag || (0, $6b8e734489284122$export$2e2bcd8739ae039) && $20ff3b05fef2752c$var$getTag(new (0, $6b8e734489284122$export$2e2bcd8739ae039)) != $20ff3b05fef2752c$var$setTag || (0, $bc168b65c78339d0$export$2e2bcd8739ae039) && $20ff3b05fef2752c$var$getTag(new (0, $bc168b65c78339d0$export$2e2bcd8739ae039)) != $20ff3b05fef2752c$var$weakMapTag) $20ff3b05fef2752c$var$getTag = function(value) {
    var result = (0, $9e036b5e76200ae5$export$2e2bcd8739ae039)(value), Ctor = result == $20ff3b05fef2752c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $e07269fabf384a16$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $20ff3b05fef2752c$var$dataViewCtorString:
            return $20ff3b05fef2752c$var$dataViewTag;
        case $20ff3b05fef2752c$var$mapCtorString:
            return $20ff3b05fef2752c$var$mapTag;
        case $20ff3b05fef2752c$var$promiseCtorString:
            return $20ff3b05fef2752c$var$promiseTag;
        case $20ff3b05fef2752c$var$setCtorString:
            return $20ff3b05fef2752c$var$setTag;
        case $20ff3b05fef2752c$var$weakMapCtorString:
            return $20ff3b05fef2752c$var$weakMapTag;
    }
    return result;
};
var $20ff3b05fef2752c$export$2e2bcd8739ae039 = $20ff3b05fef2752c$var$getTag;




var $bFTps = parcelRequire("bFTps");

/** Used to compose bitmasks for value comparisons. */ var $1972a2cbf5aa2f71$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $1972a2cbf5aa2f71$var$argsTag = '[object Arguments]', $1972a2cbf5aa2f71$var$arrayTag = '[object Array]', $1972a2cbf5aa2f71$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1972a2cbf5aa2f71$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1972a2cbf5aa2f71$var$hasOwnProperty = $1972a2cbf5aa2f71$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1972a2cbf5aa2f71$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(object), othIsArr = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $1972a2cbf5aa2f71$var$arrayTag : (0, $20ff3b05fef2752c$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $1972a2cbf5aa2f71$var$arrayTag : (0, $20ff3b05fef2752c$export$2e2bcd8739ae039)(other);
    objTag = objTag == $1972a2cbf5aa2f71$var$argsTag ? $1972a2cbf5aa2f71$var$objectTag : objTag;
    othTag = othTag == $1972a2cbf5aa2f71$var$argsTag ? $1972a2cbf5aa2f71$var$objectTag : othTag;
    var objIsObj = objTag == $1972a2cbf5aa2f71$var$objectTag, othIsObj = othTag == $1972a2cbf5aa2f71$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $bFTps.default)(object)) {
        if (!(0, $bFTps.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $08a577656cb4caea$export$2e2bcd8739ae039));
        return objIsArr || (0, $24f7bb18790a2a3a$export$2e2bcd8739ae039)(object) ? (0, $a3c08796427138c9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $7ef75e32a07edd4d$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $1972a2cbf5aa2f71$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $1972a2cbf5aa2f71$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $1972a2cbf5aa2f71$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $08a577656cb4caea$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $08a577656cb4caea$export$2e2bcd8739ae039));
    return (0, $842f50808f6e57cd$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $1972a2cbf5aa2f71$export$2e2bcd8739ae039 = $1972a2cbf5aa2f71$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $bed122360af9af63$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(value) && !(0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $1972a2cbf5aa2f71$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $bed122360af9af63$var$baseIsEqual, stack);
}
var $bed122360af9af63$export$2e2bcd8739ae039 = $bed122360af9af63$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $b0693dcfdb9d57c7$var$COMPARE_PARTIAL_FLAG = 1, $b0693dcfdb9d57c7$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $b0693dcfdb9d57c7$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $08a577656cb4caea$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $bed122360af9af63$export$2e2bcd8739ae039)(srcValue, objValue, $b0693dcfdb9d57c7$var$COMPARE_PARTIAL_FLAG | $b0693dcfdb9d57c7$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $b0693dcfdb9d57c7$export$2e2bcd8739ae039 = $b0693dcfdb9d57c7$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3234ac073f8a57f5$var$isStrictComparable(value) {
    return value === value && !(0, $00b70503e642bfc6$export$2e2bcd8739ae039)(value);
}
var $3234ac073f8a57f5$export$2e2bcd8739ae039 = $3234ac073f8a57f5$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $8f6cea3ec26f303f$var$getMatchData(object) {
    var result = (0, $3c516bf80eda0866$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $3234ac073f8a57f5$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $8f6cea3ec26f303f$export$2e2bcd8739ae039 = $8f6cea3ec26f303f$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f10747226f8ea51c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $f10747226f8ea51c$export$2e2bcd8739ae039 = $f10747226f8ea51c$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0329fef3252acb38$var$baseMatches(source) {
    var matchData = (0, $8f6cea3ec26f303f$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $f10747226f8ea51c$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $b0693dcfdb9d57c7$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $0329fef3252acb38$export$2e2bcd8739ae039 = $0329fef3252acb38$var$baseMatches;







/** `Object#toString` result references. */ var $049f8cf02b764c8e$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $049f8cf02b764c8e$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $b7e7d83ad8c2d937$export$2e2bcd8739ae039)(value) && (0, $9e036b5e76200ae5$export$2e2bcd8739ae039)(value) == $049f8cf02b764c8e$var$symbolTag;
}
var $049f8cf02b764c8e$export$2e2bcd8739ae039 = $049f8cf02b764c8e$var$isSymbol;


/** Used to match property names within property paths. */ var $81b014a2dc67100c$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $81b014a2dc67100c$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $81b014a2dc67100c$var$isKey(value, object) {
    if ((0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $049f8cf02b764c8e$export$2e2bcd8739ae039)(value)) return true;
    return $81b014a2dc67100c$var$reIsPlainProp.test(value) || !$81b014a2dc67100c$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $81b014a2dc67100c$export$2e2bcd8739ae039 = $81b014a2dc67100c$var$isKey;



/** Error message constants. */ var $747ac2267f913fd5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $747ac2267f913fd5$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($747ac2267f913fd5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($747ac2267f913fd5$var$memoize.Cache || (0, $5b5ab0dcd917cbc1$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$747ac2267f913fd5$var$memoize.Cache = (0, $5b5ab0dcd917cbc1$export$2e2bcd8739ae039);
var $747ac2267f913fd5$export$2e2bcd8739ae039 = $747ac2267f913fd5$var$memoize;


/** Used as the maximum memoize cache size. */ var $b776de8e609f0788$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b776de8e609f0788$var$memoizeCapped(func) {
    var result = (0, $747ac2267f913fd5$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $b776de8e609f0788$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $b776de8e609f0788$export$2e2bcd8739ae039 = $b776de8e609f0788$var$memoizeCapped;


/** Used to match property names within property paths. */ var $bb076047b9defedc$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $bb076047b9defedc$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $bb076047b9defedc$var$stringToPath = (0, $b776de8e609f0788$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($bb076047b9defedc$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($bb076047b9defedc$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $bb076047b9defedc$export$2e2bcd8739ae039 = $bb076047b9defedc$var$stringToPath;






/** Used as references for various `Number` constants. */ var $727dfab898aae6cb$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $727dfab898aae6cb$var$symbolProto = (0, $9a7dded94d011067$export$2e2bcd8739ae039) ? (0, $9a7dded94d011067$export$2e2bcd8739ae039).prototype : undefined, $727dfab898aae6cb$var$symbolToString = $727dfab898aae6cb$var$symbolProto ? $727dfab898aae6cb$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $727dfab898aae6cb$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $55f64dd66ec6f60c$export$2e2bcd8739ae039)(value, $727dfab898aae6cb$var$baseToString) + '';
    if ((0, $049f8cf02b764c8e$export$2e2bcd8739ae039)(value)) return $727dfab898aae6cb$var$symbolToString ? $727dfab898aae6cb$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$727dfab898aae6cb$var$INFINITY ? '-0' : result;
}
var $727dfab898aae6cb$export$2e2bcd8739ae039 = $727dfab898aae6cb$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0217ab286b9ddf4a$var$toString(value) {
    return value == null ? '' : (0, $727dfab898aae6cb$export$2e2bcd8739ae039)(value);
}
var $0217ab286b9ddf4a$export$2e2bcd8739ae039 = $0217ab286b9ddf4a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $32334717a8b7ae05$var$castPath(value, object) {
    if ((0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value)) return value;
    return (0, $81b014a2dc67100c$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $bb076047b9defedc$export$2e2bcd8739ae039)((0, $0217ab286b9ddf4a$export$2e2bcd8739ae039)(value));
}
var $32334717a8b7ae05$export$2e2bcd8739ae039 = $32334717a8b7ae05$var$castPath;



/** Used as references for various `Number` constants. */ var $2b9fade6d919521f$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $2b9fade6d919521f$var$toKey(value) {
    if (typeof value == 'string' || (0, $049f8cf02b764c8e$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$2b9fade6d919521f$var$INFINITY ? '-0' : result;
}
var $2b9fade6d919521f$export$2e2bcd8739ae039 = $2b9fade6d919521f$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ca6dbd0dc0527708$var$baseGet(object, path) {
    path = (0, $32334717a8b7ae05$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $2b9fade6d919521f$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ca6dbd0dc0527708$export$2e2bcd8739ae039 = $ca6dbd0dc0527708$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $650ba0696b9552ee$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $ca6dbd0dc0527708$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $650ba0696b9552ee$export$2e2bcd8739ae039 = $650ba0696b9552ee$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $7406f74bd00a091a$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $7406f74bd00a091a$export$2e2bcd8739ae039 = $7406f74bd00a091a$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $c175e05e0cec4e6c$var$hasPath(object, path, hasFunc) {
    path = (0, $32334717a8b7ae05$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $2b9fade6d919521f$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $a14d74e772bd1a3e$export$2e2bcd8739ae039)(length) && (0, $f5ab26651d36e3a8$export$2e2bcd8739ae039)(key, length) && ((0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(object) || (0, $b499c2101bbc7160$export$2e2bcd8739ae039)(object));
}
var $c175e05e0cec4e6c$export$2e2bcd8739ae039 = $c175e05e0cec4e6c$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $3f91cacaac48e7f9$var$hasIn(object, path) {
    return object != null && (0, $c175e05e0cec4e6c$export$2e2bcd8739ae039)(object, path, (0, $7406f74bd00a091a$export$2e2bcd8739ae039));
}
var $3f91cacaac48e7f9$export$2e2bcd8739ae039 = $3f91cacaac48e7f9$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $01adb3c54dbe1a02$var$COMPARE_PARTIAL_FLAG = 1, $01adb3c54dbe1a02$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $01adb3c54dbe1a02$var$baseMatchesProperty(path, srcValue) {
    if ((0, $81b014a2dc67100c$export$2e2bcd8739ae039)(path) && (0, $3234ac073f8a57f5$export$2e2bcd8739ae039)(srcValue)) return (0, $f10747226f8ea51c$export$2e2bcd8739ae039)((0, $2b9fade6d919521f$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $650ba0696b9552ee$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $3f91cacaac48e7f9$export$2e2bcd8739ae039)(object, path) : (0, $bed122360af9af63$export$2e2bcd8739ae039)(srcValue, objValue, $01adb3c54dbe1a02$var$COMPARE_PARTIAL_FLAG | $01adb3c54dbe1a02$var$COMPARE_UNORDERED_FLAG);
    };
}
var $01adb3c54dbe1a02$export$2e2bcd8739ae039 = $01adb3c54dbe1a02$var$baseMatchesProperty;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0f96e4bcbdf4638f$var$identity(value) {
    return value;
}
var $0f96e4bcbdf4638f$export$2e2bcd8739ae039 = $0f96e4bcbdf4638f$var$identity;



/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $853a772bb65630c1$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $853a772bb65630c1$export$2e2bcd8739ae039 = $853a772bb65630c1$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c5d2070eab4c14d5$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $ca6dbd0dc0527708$export$2e2bcd8739ae039)(object, path);
    };
}
var $c5d2070eab4c14d5$export$2e2bcd8739ae039 = $c5d2070eab4c14d5$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $63da51e4a8d8c391$var$property(path) {
    return (0, $81b014a2dc67100c$export$2e2bcd8739ae039)(path) ? (0, $853a772bb65630c1$export$2e2bcd8739ae039)((0, $2b9fade6d919521f$export$2e2bcd8739ae039)(path)) : (0, $c5d2070eab4c14d5$export$2e2bcd8739ae039)(path);
}
var $63da51e4a8d8c391$export$2e2bcd8739ae039 = $63da51e4a8d8c391$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $b328e8819b7c3787$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $0f96e4bcbdf4638f$export$2e2bcd8739ae039;
    if (typeof value == 'object') return (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value) ? (0, $01adb3c54dbe1a02$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $0329fef3252acb38$export$2e2bcd8739ae039)(value);
    return (0, $63da51e4a8d8c391$export$2e2bcd8739ae039)(value);
}
var $b328e8819b7c3787$export$2e2bcd8739ae039 = $b328e8819b7c3787$var$baseIteratee;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $984b7558381df072$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $984b7558381df072$export$2e2bcd8739ae039 = $984b7558381df072$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a80ffbc4240a6812$var$baseFor = (0, $984b7558381df072$export$2e2bcd8739ae039)();
var $a80ffbc4240a6812$export$2e2bcd8739ae039 = $a80ffbc4240a6812$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $204bf68b17ff031a$var$baseForOwn(object, iteratee) {
    return object && (0, $a80ffbc4240a6812$export$2e2bcd8739ae039)(object, iteratee, (0, $3c516bf80eda0866$export$2e2bcd8739ae039));
}
var $204bf68b17ff031a$export$2e2bcd8739ae039 = $204bf68b17ff031a$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3215c585e8f4cae9$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $d1a0a4913f704bea$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $3215c585e8f4cae9$export$2e2bcd8739ae039 = $3215c585e8f4cae9$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $00b78b51ce550c65$var$baseEach = (0, $3215c585e8f4cae9$export$2e2bcd8739ae039)((0, $204bf68b17ff031a$export$2e2bcd8739ae039));
var $00b78b51ce550c65$export$2e2bcd8739ae039 = $00b78b51ce550c65$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e30579e149f361fd$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $d1a0a4913f704bea$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $00b78b51ce550c65$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $e30579e149f361fd$export$2e2bcd8739ae039 = $e30579e149f361fd$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $ff2d60bc6af6aa19$var$map(collection, iteratee) {
    var func = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(collection) ? (0, $55f64dd66ec6f60c$export$2e2bcd8739ae039) : (0, $e30579e149f361fd$export$2e2bcd8739ae039);
    return func(collection, (0, $b328e8819b7c3787$export$2e2bcd8739ae039)(iteratee, 3));
}
var $ff2d60bc6af6aa19$export$2e2bcd8739ae039 = $ff2d60bc6af6aa19$var$map;




/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1b9ee5d17cb70e84$var$baseFilter(collection, predicate) {
    var result = [];
    (0, $00b78b51ce550c65$export$2e2bcd8739ae039)(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
var $1b9ee5d17cb70e84$export$2e2bcd8739ae039 = $1b9ee5d17cb70e84$var$baseFilter;




/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f6e4b32ee6a9ec18$var$filter(collection, predicate) {
    var func = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(collection) ? (0, $e55013fa8c4d755a$export$2e2bcd8739ae039) : (0, $1b9ee5d17cb70e84$export$2e2bcd8739ae039);
    return func(collection, (0, $b328e8819b7c3787$export$2e2bcd8739ae039)(predicate, 3));
}
var $f6e4b32ee6a9ec18$export$2e2bcd8739ae039 = $f6e4b32ee6a9ec18$var$filter;



function $3e7b82843c6724d4$export$b4b7d75b3b456edc(rule, type, occurrence) {
    return `${rule.name}_${type}_${occurrence}`;
}
const $3e7b82843c6724d4$export$fc8058e10191a97e = 0;
const $3e7b82843c6724d4$export$9315a4ff2444fc69 = 1;
const $3e7b82843c6724d4$export$71cfab281db6e3c7 = 2;
const $3e7b82843c6724d4$export$2cdf328bccc98a6e = 4;
const $3e7b82843c6724d4$export$14bb10e89100d448 = 5;
const $3e7b82843c6724d4$export$b5dda129e6d30636 = 6;
const $3e7b82843c6724d4$export$db5d487b6a59cf5e = 7;
const $3e7b82843c6724d4$export$260b97b251eccfc6 = 8;
const $3e7b82843c6724d4$export$562e5d4bb8c14d6a = 9;
const $3e7b82843c6724d4$export$b3ea1e49985d6b16 = 10;
const $3e7b82843c6724d4$export$79d0fcb83c289f03 = 11;
const $3e7b82843c6724d4$export$2f73ba31c7ae923f = 12;
class $3e7b82843c6724d4$export$7df6c2cdf0ff58ee {
    constructor(target){
        this.target = target;
    }
    isEpsilon() {
        return false;
    }
}
class $3e7b82843c6724d4$export$749c9accb19d603f extends $3e7b82843c6724d4$export$7df6c2cdf0ff58ee {
    constructor(target, tokenType){
        super(target);
        this.tokenType = tokenType;
    }
}
class $3e7b82843c6724d4$export$a59e0290d2db6277 extends $3e7b82843c6724d4$export$7df6c2cdf0ff58ee {
    constructor(target){
        super(target);
    }
    isEpsilon() {
        return true;
    }
}
class $3e7b82843c6724d4$export$5a1cda5a00fd126 extends $3e7b82843c6724d4$export$7df6c2cdf0ff58ee {
    constructor(ruleStart, rule, followState){
        super(ruleStart);
        this.rule = rule;
        this.followState = followState;
    }
    isEpsilon() {
        return true;
    }
}
function $3e7b82843c6724d4$export$b11bf385c5f6743c(rules) {
    const atn = {
        decisionMap: {},
        decisionStates: [],
        ruleToStartState: new Map(),
        ruleToStopState: new Map(),
        states: []
    };
    $3e7b82843c6724d4$var$createRuleStartAndStopATNStates(atn, rules);
    const ruleLength = rules.length;
    for(let i = 0; i < ruleLength; i++){
        const rule = rules[i];
        const ruleBlock = $3e7b82843c6724d4$var$block(atn, rule, rule);
        if (ruleBlock === undefined) continue;
        $3e7b82843c6724d4$var$buildRuleHandle(atn, rule, ruleBlock);
    }
    return atn;
}
function $3e7b82843c6724d4$var$createRuleStartAndStopATNStates(atn, rules) {
    const ruleLength = rules.length;
    for(let i = 0; i < ruleLength; i++){
        const rule = rules[i];
        const start = $3e7b82843c6724d4$var$newState(atn, rule, undefined, {
            type: $3e7b82843c6724d4$export$71cfab281db6e3c7
        });
        const stop = $3e7b82843c6724d4$var$newState(atn, rule, undefined, {
            type: $3e7b82843c6724d4$export$db5d487b6a59cf5e
        });
        start.stop = stop;
        atn.ruleToStartState.set(rule, start);
        atn.ruleToStopState.set(rule, stop);
    }
}
function $3e7b82843c6724d4$var$atom(atn, rule, production) {
    if (production instanceof (0, $5d51f81a4b917e73$export$8dd80f06eb58bfe1)) return $3e7b82843c6724d4$var$tokenRef(atn, rule, production.terminalType, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$ab116ec58638c09)) return $3e7b82843c6724d4$var$ruleRef(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$d8895f7a7cf86415)) return $3e7b82843c6724d4$var$alternation(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$36d18380658d5d20)) return $3e7b82843c6724d4$var$option(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$adf7bc0a69b784e9)) return $3e7b82843c6724d4$var$repetition(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$856dea708c981fb8)) return $3e7b82843c6724d4$var$repetitionSep(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$d068cf3ccde3d9e8)) return $3e7b82843c6724d4$var$repetitionMandatory(atn, rule, production);
    else if (production instanceof (0, $5d51f81a4b917e73$export$da6c5580175e0214)) return $3e7b82843c6724d4$var$repetitionMandatorySep(atn, rule, production);
    else return $3e7b82843c6724d4$var$block(atn, rule, production);
}
function $3e7b82843c6724d4$var$repetition(atn, rule, repetition) {
    const starState = $3e7b82843c6724d4$var$newState(atn, rule, repetition, {
        type: $3e7b82843c6724d4$export$14bb10e89100d448
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, starState);
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, starState, repetition, $3e7b82843c6724d4$var$block(atn, rule, repetition));
    return $3e7b82843c6724d4$var$star(atn, rule, repetition, handle);
}
function $3e7b82843c6724d4$var$repetitionSep(atn, rule, repetition) {
    const starState = $3e7b82843c6724d4$var$newState(atn, rule, repetition, {
        type: $3e7b82843c6724d4$export$14bb10e89100d448
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, starState);
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, starState, repetition, $3e7b82843c6724d4$var$block(atn, rule, repetition));
    const sep = $3e7b82843c6724d4$var$tokenRef(atn, rule, repetition.separator, repetition);
    return $3e7b82843c6724d4$var$star(atn, rule, repetition, handle, sep);
}
function $3e7b82843c6724d4$var$repetitionMandatory(atn, rule, repetition) {
    const plusState = $3e7b82843c6724d4$var$newState(atn, rule, repetition, {
        type: $3e7b82843c6724d4$export$2cdf328bccc98a6e
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, plusState);
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, plusState, repetition, $3e7b82843c6724d4$var$block(atn, rule, repetition));
    return $3e7b82843c6724d4$var$plus(atn, rule, repetition, handle);
}
function $3e7b82843c6724d4$var$repetitionMandatorySep(atn, rule, repetition) {
    const plusState = $3e7b82843c6724d4$var$newState(atn, rule, repetition, {
        type: $3e7b82843c6724d4$export$2cdf328bccc98a6e
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, plusState);
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, plusState, repetition, $3e7b82843c6724d4$var$block(atn, rule, repetition));
    const sep = $3e7b82843c6724d4$var$tokenRef(atn, rule, repetition.separator, repetition);
    return $3e7b82843c6724d4$var$plus(atn, rule, repetition, handle, sep);
}
function $3e7b82843c6724d4$var$alternation(atn, rule, alternation) {
    const start = $3e7b82843c6724d4$var$newState(atn, rule, alternation, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, start);
    const alts = (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(alternation.definition, (e)=>$3e7b82843c6724d4$var$atom(atn, rule, e));
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, start, alternation, ...alts);
    return handle;
}
function $3e7b82843c6724d4$var$option(atn, rule, option) {
    const start = $3e7b82843c6724d4$var$newState(atn, rule, option, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, start);
    const handle = $3e7b82843c6724d4$var$makeAlts(atn, rule, start, option, $3e7b82843c6724d4$var$block(atn, rule, option));
    return $3e7b82843c6724d4$var$optional(atn, rule, option, handle);
}
function $3e7b82843c6724d4$var$block(atn, rule, block) {
    const handles = (0, $f6e4b32ee6a9ec18$export$2e2bcd8739ae039)((0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(block.definition, (e)=>$3e7b82843c6724d4$var$atom(atn, rule, e)), (e)=>e !== undefined);
    if (handles.length === 1) return handles[0];
    else if (handles.length === 0) return undefined;
    else return $3e7b82843c6724d4$var$makeBlock(atn, handles);
}
function $3e7b82843c6724d4$var$plus(atn, rule, plus, handle, sep) {
    const blkStart = handle.left;
    const blkEnd = handle.right;
    const loop = $3e7b82843c6724d4$var$newState(atn, rule, plus, {
        type: $3e7b82843c6724d4$export$79d0fcb83c289f03
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, loop);
    const end = $3e7b82843c6724d4$var$newState(atn, rule, plus, {
        type: $3e7b82843c6724d4$export$2f73ba31c7ae923f
    });
    blkStart.loopback = loop;
    end.loopback = loop;
    atn.decisionMap[$3e7b82843c6724d4$export$b4b7d75b3b456edc(rule, sep ? 'RepetitionMandatoryWithSeparator' : 'RepetitionMandatory', plus.idx)] = loop;
    $3e7b82843c6724d4$var$epsilon(blkEnd, loop); // block can see loop back
    // Depending on whether we have a separator we put the exit transition at index 1 or 0
    // This influences the chosen option in the lookahead DFA
    if (sep === undefined) {
        $3e7b82843c6724d4$var$epsilon(loop, blkStart); // loop back to start
        $3e7b82843c6724d4$var$epsilon(loop, end); // exit
    } else {
        $3e7b82843c6724d4$var$epsilon(loop, end); // exit
        // loop back to start with separator
        $3e7b82843c6724d4$var$epsilon(loop, sep.left);
        $3e7b82843c6724d4$var$epsilon(sep.right, blkStart);
    }
    return {
        left: blkStart,
        right: end
    };
}
function $3e7b82843c6724d4$var$star(atn, rule, star, handle, sep) {
    const start = handle.left;
    const end = handle.right;
    const entry = $3e7b82843c6724d4$var$newState(atn, rule, star, {
        type: $3e7b82843c6724d4$export$b3ea1e49985d6b16
    });
    $3e7b82843c6724d4$var$defineDecisionState(atn, entry);
    const loopEnd = $3e7b82843c6724d4$var$newState(atn, rule, star, {
        type: $3e7b82843c6724d4$export$2f73ba31c7ae923f
    });
    const loop = $3e7b82843c6724d4$var$newState(atn, rule, star, {
        type: $3e7b82843c6724d4$export$562e5d4bb8c14d6a
    });
    entry.loopback = loop;
    loopEnd.loopback = loop;
    $3e7b82843c6724d4$var$epsilon(entry, start); // loop enter edge (alt 2)
    $3e7b82843c6724d4$var$epsilon(entry, loopEnd); // bypass loop edge (alt 1)
    $3e7b82843c6724d4$var$epsilon(end, loop); // block end hits loop back
    if (sep !== undefined) {
        $3e7b82843c6724d4$var$epsilon(loop, loopEnd); // end loop
        // loop back to start of handle using separator
        $3e7b82843c6724d4$var$epsilon(loop, sep.left);
        $3e7b82843c6724d4$var$epsilon(sep.right, start);
    } else $3e7b82843c6724d4$var$epsilon(loop, entry); // loop back to entry/exit decision
    atn.decisionMap[$3e7b82843c6724d4$export$b4b7d75b3b456edc(rule, sep ? 'RepetitionWithSeparator' : 'Repetition', star.idx)] = entry;
    return {
        left: entry,
        right: loopEnd
    };
}
function $3e7b82843c6724d4$var$optional(atn, rule, optional, handle) {
    const start = handle.left;
    const end = handle.right;
    $3e7b82843c6724d4$var$epsilon(start, end);
    atn.decisionMap[$3e7b82843c6724d4$export$b4b7d75b3b456edc(rule, 'Option', optional.idx)] = start;
    return handle;
}
function $3e7b82843c6724d4$var$defineDecisionState(atn, state) {
    atn.decisionStates.push(state);
    state.decision = atn.decisionStates.length - 1;
    return state.decision;
}
function $3e7b82843c6724d4$var$makeAlts(atn, rule, start, production, ...alts) {
    const end = $3e7b82843c6724d4$var$newState(atn, rule, production, {
        type: $3e7b82843c6724d4$export$260b97b251eccfc6,
        start: start
    });
    start.end = end;
    for (const alt of alts)if (alt !== undefined) {
        // hook alts up to decision block
        $3e7b82843c6724d4$var$epsilon(start, alt.left);
        $3e7b82843c6724d4$var$epsilon(alt.right, end);
    } else $3e7b82843c6724d4$var$epsilon(start, end);
    const handle = {
        left: start,
        right: end
    };
    atn.decisionMap[$3e7b82843c6724d4$export$b4b7d75b3b456edc(rule, $3e7b82843c6724d4$var$getProdType(production), production.idx)] = start;
    return handle;
}
function $3e7b82843c6724d4$var$getProdType(production) {
    if (production instanceof (0, $5d51f81a4b917e73$export$d8895f7a7cf86415)) return 'Alternation';
    else if (production instanceof (0, $5d51f81a4b917e73$export$36d18380658d5d20)) return 'Option';
    else if (production instanceof (0, $5d51f81a4b917e73$export$adf7bc0a69b784e9)) return 'Repetition';
    else if (production instanceof (0, $5d51f81a4b917e73$export$856dea708c981fb8)) return 'RepetitionWithSeparator';
    else if (production instanceof (0, $5d51f81a4b917e73$export$d068cf3ccde3d9e8)) return 'RepetitionMandatory';
    else if (production instanceof (0, $5d51f81a4b917e73$export$da6c5580175e0214)) return 'RepetitionMandatoryWithSeparator';
    else throw new Error('Invalid production type encountered');
}
function $3e7b82843c6724d4$var$makeBlock(atn, alts) {
    const altsLength = alts.length;
    for(let i = 0; i < altsLength - 1; i++){
        const handle = alts[i];
        let transition;
        if (handle.left.transitions.length === 1) transition = handle.left.transitions[0];
        const isRuleTransition = transition instanceof $3e7b82843c6724d4$export$5a1cda5a00fd126;
        const ruleTransition = transition;
        const next = alts[i + 1].left;
        if (handle.left.type === $3e7b82843c6724d4$export$9315a4ff2444fc69 && handle.right.type === $3e7b82843c6724d4$export$9315a4ff2444fc69 && transition !== undefined && (isRuleTransition && ruleTransition.followState === handle.right || transition.target === handle.right)) {
            // we can avoid epsilon edge to next element
            if (isRuleTransition) ruleTransition.followState = next;
            else transition.target = next;
            $3e7b82843c6724d4$var$removeState(atn, handle.right); // we skipped over this state
        } else // need epsilon if previous block's right end node is complex
        $3e7b82843c6724d4$var$epsilon(handle.right, next);
    }
    const first = alts[0];
    const last = alts[altsLength - 1];
    return {
        left: first.left,
        right: last.right
    };
}
function $3e7b82843c6724d4$var$tokenRef(atn, rule, tokenType, production) {
    const left = $3e7b82843c6724d4$var$newState(atn, rule, production, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    const right = $3e7b82843c6724d4$var$newState(atn, rule, production, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    $3e7b82843c6724d4$var$addTransition(left, new $3e7b82843c6724d4$export$749c9accb19d603f(right, tokenType));
    return {
        left: left,
        right: right
    };
}
function $3e7b82843c6724d4$var$ruleRef(atn, currentRule, nonTerminal) {
    const rule = nonTerminal.referencedRule;
    const start = atn.ruleToStartState.get(rule);
    const left = $3e7b82843c6724d4$var$newState(atn, currentRule, nonTerminal, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    const right = $3e7b82843c6724d4$var$newState(atn, currentRule, nonTerminal, {
        type: $3e7b82843c6724d4$export$9315a4ff2444fc69
    });
    const call = new $3e7b82843c6724d4$export$5a1cda5a00fd126(start, rule, right);
    $3e7b82843c6724d4$var$addTransition(left, call);
    return {
        left: left,
        right: right
    };
}
function $3e7b82843c6724d4$var$buildRuleHandle(atn, rule, block) {
    const start = atn.ruleToStartState.get(rule);
    $3e7b82843c6724d4$var$epsilon(start, block.left);
    const stop = atn.ruleToStopState.get(rule);
    $3e7b82843c6724d4$var$epsilon(block.right, stop);
    const handle = {
        left: start,
        right: stop
    };
    return handle;
}
function $3e7b82843c6724d4$var$epsilon(a, b) {
    const transition = new $3e7b82843c6724d4$export$a59e0290d2db6277(b);
    $3e7b82843c6724d4$var$addTransition(a, transition);
}
function $3e7b82843c6724d4$var$newState(atn, rule, production, partial) {
    const t = Object.assign({
        atn: atn,
        production: production,
        epsilonOnlyTransitions: false,
        rule: rule,
        transitions: [],
        nextTokenWithinRule: [],
        stateNumber: atn.states.length
    }, partial);
    atn.states.push(t);
    return t;
}
function $3e7b82843c6724d4$var$addTransition(state, transition) {
    // A single ATN state can only contain epsilon transitions or non-epsilon transitions
    // Because they are never mixed, only setting the property for the first transition is fine
    if (state.transitions.length === 0) state.epsilonOnlyTransitions = transition.isEpsilon();
    state.transitions.push(transition);
}
function $3e7b82843c6724d4$var$removeState(atn, state) {
    atn.states.splice(atn.states.indexOf(state), 1);
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
const $2a976e920eae9992$export$49d87936aae2ebd2 = {};
class $2a976e920eae9992$export$3e159d9d82bfca90 {
    constructor(){
        this.map = {};
        this.configs = [];
    }
    get size() {
        return this.configs.length;
    }
    finalize() {
        // Empties the map to free up memory
        this.map = {};
    }
    add(config) {
        const key = $2a976e920eae9992$export$aa8b83e12b1ae083(config);
        // Only add configs which don't exist in our map already
        // While this does not influence the actual algorithm, adding them anyway would massively increase memory consumption
        if (!(key in this.map)) {
            this.map[key] = this.configs.length;
            this.configs.push(config);
        }
    }
    get elements() {
        return this.configs;
    }
    get alts() {
        return (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(this.configs, (e)=>e.alt);
    }
    get key() {
        let value = "";
        for(const k in this.map)value += k + ":";
        return value;
    }
}
function $2a976e920eae9992$export$aa8b83e12b1ae083(config, alt = true) {
    return `${alt ? `a${config.alt}` : ""}s${config.state.stateNumber}:${config.stack.map((e)=>e.stateNumber.toString()).join("_")}`;
}



/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $b01d0d117286688d$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !(0, $049f8cf02b764c8e$export$2e2bcd8739ae039)(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
var $b01d0d117286688d$export$2e2bcd8739ae039 = $b01d0d117286688d$var$baseExtremum;


/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cc26bda4755dc315$var$baseLt(value, other) {
    return value < other;
}
var $cc26bda4755dc315$export$2e2bcd8739ae039 = $cc26bda4755dc315$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $f78fdff2026af505$var$min(array) {
    return array && array.length ? (0, $b01d0d117286688d$export$2e2bcd8739ae039)(array, (0, $0f96e4bcbdf4638f$export$2e2bcd8739ae039), (0, $cc26bda4755dc315$export$2e2bcd8739ae039)) : undefined;
}
var $f78fdff2026af505$export$2e2bcd8739ae039 = $f78fdff2026af505$var$min;






/** Built-in value references. */ var $b48d568ad16a74ed$var$spreadableSymbol = (0, $9a7dded94d011067$export$2e2bcd8739ae039) ? (0, $9a7dded94d011067$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $b48d568ad16a74ed$var$isFlattenable(value) {
    return (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value) || (0, $b499c2101bbc7160$export$2e2bcd8739ae039)(value) || !!($b48d568ad16a74ed$var$spreadableSymbol && value && value[$b48d568ad16a74ed$var$spreadableSymbol]);
}
var $b48d568ad16a74ed$export$2e2bcd8739ae039 = $b48d568ad16a74ed$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b8545adac2029db4$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $b48d568ad16a74ed$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b8545adac2029db4$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $e1871f1e848f62ac$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $b8545adac2029db4$export$2e2bcd8739ae039 = $b8545adac2029db4$var$baseFlatten;



/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $9a6484bdcb1e73a5$var$flatMap(collection, iteratee) {
    return (0, $b8545adac2029db4$export$2e2bcd8739ae039)((0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(collection, iteratee), 1);
}
var $9a6484bdcb1e73a5$export$2e2bcd8739ae039 = $9a6484bdcb1e73a5$var$flatMap;




/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $77f745ec0f94a130$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $77f745ec0f94a130$export$2e2bcd8739ae039 = $77f745ec0f94a130$var$baseFindIndex;


/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $492bbf5389d4e353$var$baseIsNaN(value) {
    return value !== value;
}
var $492bbf5389d4e353$export$2e2bcd8739ae039 = $492bbf5389d4e353$var$baseIsNaN;


/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7542b77c2a930db7$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $7542b77c2a930db7$export$2e2bcd8739ae039 = $7542b77c2a930db7$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3b7083f7d9b428a9$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $7542b77c2a930db7$export$2e2bcd8739ae039)(array, value, fromIndex) : (0, $77f745ec0f94a130$export$2e2bcd8739ae039)(array, (0, $492bbf5389d4e353$export$2e2bcd8739ae039), fromIndex);
}
var $3b7083f7d9b428a9$export$2e2bcd8739ae039 = $3b7083f7d9b428a9$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e6ae12074089703d$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $3b7083f7d9b428a9$export$2e2bcd8739ae039)(array, value, 0) > -1;
}
var $e6ae12074089703d$export$2e2bcd8739ae039 = $e6ae12074089703d$var$arrayIncludes;


/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $fb2e6d432f3915e4$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $fb2e6d432f3915e4$export$2e2bcd8739ae039 = $fb2e6d432f3915e4$var$arrayIncludesWith;




/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $f0e47ec1084b383d$var$noop() {
// No operation performed.
}
var $f0e47ec1084b383d$export$2e2bcd8739ae039 = $f0e47ec1084b383d$var$noop;



/** Used as references for various `Number` constants. */ var $79cc4d03cbea2177$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $79cc4d03cbea2177$var$createSet = !((0, $6b8e734489284122$export$2e2bcd8739ae039) && 1 / (0, $032c6d7b8d3880ac$export$2e2bcd8739ae039)(new (0, $6b8e734489284122$export$2e2bcd8739ae039)([
    ,
    -0
]))[1] == $79cc4d03cbea2177$var$INFINITY) ? (0, $f0e47ec1084b383d$export$2e2bcd8739ae039) : function(values) {
    return new (0, $6b8e734489284122$export$2e2bcd8739ae039)(values);
};
var $79cc4d03cbea2177$export$2e2bcd8739ae039 = $79cc4d03cbea2177$var$createSet;



/** Used as the size to enable large array optimizations. */ var $2a43f7dee29c5336$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $2a43f7dee29c5336$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $e6ae12074089703d$export$2e2bcd8739ae039), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $fb2e6d432f3915e4$export$2e2bcd8739ae039);
    } else if (length >= $2a43f7dee29c5336$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $79cc4d03cbea2177$export$2e2bcd8739ae039)(array);
        if (set) return (0, $032c6d7b8d3880ac$export$2e2bcd8739ae039)(set);
        isCommon = false;
        includes = (0, $4b08e9ff54f81ac4$export$2e2bcd8739ae039);
        seen = new (0, $5d01a3fbeab19d95$export$2e2bcd8739ae039);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $2a43f7dee29c5336$export$2e2bcd8739ae039 = $2a43f7dee29c5336$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $3b7b54f2948a3617$var$uniqBy(array, iteratee) {
    return array && array.length ? (0, $2a43f7dee29c5336$export$2e2bcd8739ae039)(array, (0, $b328e8819b7c3787$export$2e2bcd8739ae039)(iteratee, 2)) : [];
}
var $3b7b54f2948a3617$export$2e2bcd8739ae039 = $3b7b54f2948a3617$var$uniqBy;




/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $6d9807b699274f3b$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $b8545adac2029db4$export$2e2bcd8739ae039)(array, 1) : [];
}
var $6d9807b699274f3b$export$2e2bcd8739ae039 = $6d9807b699274f3b$var$flatten;


/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $37af8ffc509a17ce$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $37af8ffc509a17ce$export$2e2bcd8739ae039 = $37af8ffc509a17ce$var$arrayEach;




/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $5baa0975c2e66e8a$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $0f96e4bcbdf4638f$export$2e2bcd8739ae039);
}
var $5baa0975c2e66e8a$export$2e2bcd8739ae039 = $5baa0975c2e66e8a$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $7f56a0898b2f3740$var$forEach(collection, iteratee) {
    var func = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(collection) ? (0, $37af8ffc509a17ce$export$2e2bcd8739ae039) : (0, $00b78b51ce550c65$export$2e2bcd8739ae039);
    return func(collection, (0, $5baa0975c2e66e8a$export$2e2bcd8739ae039)(iteratee));
}
var $7f56a0898b2f3740$export$2e2bcd8739ae039 = $7f56a0898b2f3740$var$forEach;








var $bFTps = parcelRequire("bFTps");


/** `Object#toString` result references. */ var $98ff1f162dcd0b09$var$mapTag = '[object Map]', $98ff1f162dcd0b09$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $98ff1f162dcd0b09$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $98ff1f162dcd0b09$var$hasOwnProperty = $98ff1f162dcd0b09$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $98ff1f162dcd0b09$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $d1a0a4913f704bea$export$2e2bcd8739ae039)(value) && ((0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, $bFTps.default)(value) || (0, $24f7bb18790a2a3a$export$2e2bcd8739ae039)(value) || (0, $b499c2101bbc7160$export$2e2bcd8739ae039)(value))) return !value.length;
    var tag = (0, $20ff3b05fef2752c$export$2e2bcd8739ae039)(value);
    if (tag == $98ff1f162dcd0b09$var$mapTag || tag == $98ff1f162dcd0b09$var$setTag) return !value.size;
    if ((0, $919241523bfef5aa$export$2e2bcd8739ae039)(value)) return !(0, $bafaa0e689a9dd7d$export$2e2bcd8739ae039)(value).length;
    for(var key in value){
        if ($98ff1f162dcd0b09$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $98ff1f162dcd0b09$export$2e2bcd8739ae039 = $98ff1f162dcd0b09$var$isEmpty;


/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $ecc3cb38ef95a1ba$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $ecc3cb38ef95a1ba$export$2e2bcd8739ae039 = $ecc3cb38ef95a1ba$var$arrayReduce;




/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $f7ee2d12901cd61f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
var $f7ee2d12901cd61f$export$2e2bcd8739ae039 = $f7ee2d12901cd61f$var$baseReduce;



/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $e7fcc7438a197b54$var$reduce(collection, iteratee, accumulator) {
    var func = (0, $58835d45b1d8c2e6$export$2e2bcd8739ae039)(collection) ? (0, $ecc3cb38ef95a1ba$export$2e2bcd8739ae039) : (0, $f7ee2d12901cd61f$export$2e2bcd8739ae039), initAccum = arguments.length < 3;
    return func(collection, (0, $b328e8819b7c3787$export$2e2bcd8739ae039)(iteratee, 4), accumulator, initAccum, (0, $00b78b51ce550c65$export$2e2bcd8739ae039));
}
var $e7fcc7438a197b54$export$2e2bcd8739ae039 = $e7fcc7438a197b54$var$reduce;


function $7b69ac9efffb409f$var$createDFACache(startState, decision) {
    const map = {};
    return (predicateSet)=>{
        const key = predicateSet.toString();
        let existing = map[key];
        if (existing !== undefined) return existing;
        else {
            existing = {
                atnStartState: startState,
                decision: decision,
                states: {}
            };
            map[key] = existing;
            return existing;
        }
    };
}
class $7b69ac9efffb409f$var$PredicateSet {
    constructor(){
        this.predicates = [];
    }
    is(index) {
        return index >= this.predicates.length || this.predicates[index];
    }
    set(index, value) {
        this.predicates[index] = value;
    }
    toString() {
        let value = "";
        const size = this.predicates.length;
        for(let i = 0; i < size; i++)value += this.predicates[i] === true ? "1" : "0";
        return value;
    }
}
const $7b69ac9efffb409f$var$EMPTY_PREDICATES = new $7b69ac9efffb409f$var$PredicateSet();
class $7b69ac9efffb409f$export$b8bdc65cb7fb9724 extends (0, $5d51f81a4b917e73$export$a401661f5bedbeb4) {
    constructor(options){
        var _a, _b;
        super();
        this.logging = (_a = options === null || options === void 0 ? void 0 : options.logging) !== null && _a !== void 0 ? _a : (message)=>console.log(message);
        this.incomplete = (_b = options === null || options === void 0 ? void 0 : options.incomplete) !== null && _b !== void 0 ? _b : false;
    }
    initialize(options) {
        this.atn = (0, $3e7b82843c6724d4$export$b11bf385c5f6743c)(options.rules);
        this.dfas = $7b69ac9efffb409f$var$initATNSimulator(this.atn);
        this.callers = $7b69ac9efffb409f$var$buildCallers(this.atn);
    }
    validateAmbiguousAlternationAlternatives() {
        return [];
    }
    validateEmptyOrAlternatives() {
        return [];
    }
    buildLookaheadForAlternation(options) {
        const { prodOccurrence: prodOccurrence, rule: rule, hasPredicates: hasPredicates, dynamicTokensEnabled: dynamicTokensEnabled } = options;
        const dfas = this.dfas;
        const logging = this.logging;
        const incomplete = this.incomplete;
        const key = (0, $3e7b82843c6724d4$export$b4b7d75b3b456edc)(rule, 'Alternation', prodOccurrence);
        const decisionState = this.atn.decisionMap[key];
        const decisionIndex = decisionState.decision;
        const partialAlts = (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)((0, $5d51f81a4b917e73$export$6f325009a545e54b)({
            maxLookahead: 1,
            occurrence: prodOccurrence,
            prodType: "Alternation",
            rule: rule
        }), (currAlt)=>(0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(currAlt, (path)=>path[0]));
        if ($7b69ac9efffb409f$var$isLL1Sequence(partialAlts, false) && !dynamicTokensEnabled) {
            const choiceToAlt = (0, $e7fcc7438a197b54$export$2e2bcd8739ae039)(partialAlts, (result, currAlt, idx)=>{
                (0, $7f56a0898b2f3740$export$2e2bcd8739ae039)(currAlt, (currTokType)=>{
                    if (currTokType) {
                        result[currTokType.tokenTypeIdx] = idx;
                        (0, $7f56a0898b2f3740$export$2e2bcd8739ae039)(currTokType.categoryMatches, (currExtendingType)=>{
                            result[currExtendingType] = idx;
                        });
                    }
                });
                return result;
            }, {});
            if (hasPredicates) return function(orAlts) {
                var _a;
                const nextToken = this.LA_FAST(1);
                const prediction = choiceToAlt[nextToken.tokenTypeIdx];
                if (orAlts !== undefined && prediction !== undefined) {
                    const gate = (_a = orAlts[prediction]) === null || _a === void 0 ? void 0 : _a.GATE;
                    if (gate !== undefined && gate.call(this) === false) return undefined;
                }
                return prediction;
            };
            else return function() {
                const nextToken = this.LA_FAST(1);
                return choiceToAlt[nextToken.tokenTypeIdx];
            };
        } else if (hasPredicates) return function(orAlts) {
            const predicates = new $7b69ac9efffb409f$var$PredicateSet();
            const length = orAlts === undefined ? 0 : orAlts.length;
            for(let i = 0; i < length; i++){
                const gate = orAlts === null || orAlts === void 0 ? void 0 : orAlts[i].GATE;
                predicates.set(i, gate === undefined || gate.call(this));
            }
            const result = $7b69ac9efffb409f$var$adaptivePredict.call(this, dfas, decisionIndex, predicates, logging, incomplete);
            return typeof result === 'number' ? result : undefined;
        };
        else return function() {
            const result = $7b69ac9efffb409f$var$adaptivePredict.call(this, dfas, decisionIndex, $7b69ac9efffb409f$var$EMPTY_PREDICATES, logging, incomplete);
            return typeof result === 'number' ? result : undefined;
        };
    }
    buildLookaheadForOptional(options) {
        const { prodOccurrence: prodOccurrence, rule: rule, prodType: prodType, dynamicTokensEnabled: dynamicTokensEnabled } = options;
        const dfas = this.dfas;
        const logging = this.logging;
        const incomplete = this.incomplete;
        const callers = this.callers;
        const key = (0, $3e7b82843c6724d4$export$b4b7d75b3b456edc)(rule, prodType, prodOccurrence);
        const decisionState = this.atn.decisionMap[key];
        const decisionIndex = decisionState.decision;
        const alts = (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)((0, $5d51f81a4b917e73$export$6f325009a545e54b)({
            maxLookahead: 1,
            occurrence: prodOccurrence,
            prodType: prodType,
            rule: rule
        }), (e)=>{
            return (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(e, (g)=>g[0]);
        });
        if ($7b69ac9efffb409f$var$isLL1Sequence(alts) && alts[0][0] && !dynamicTokensEnabled && !$7b69ac9efffb409f$var$optionalHasFollowConflict(decisionState, prodType, callers)) {
            const alt = alts[0];
            const singleTokensTypes = (0, $6d9807b699274f3b$export$2e2bcd8739ae039)(alt);
            if (singleTokensTypes.length === 1 && (0, $98ff1f162dcd0b09$export$2e2bcd8739ae039)(singleTokensTypes[0].categoryMatches)) {
                const expectedTokenType = singleTokensTypes[0];
                const expectedTokenUniqueKey = expectedTokenType.tokenTypeIdx;
                return function() {
                    return this.LA_FAST(1).tokenTypeIdx === expectedTokenUniqueKey;
                };
            } else {
                const choiceToAlt = (0, $e7fcc7438a197b54$export$2e2bcd8739ae039)(singleTokensTypes, (result, currTokType)=>{
                    if (currTokType !== undefined) {
                        result[currTokType.tokenTypeIdx] = true;
                        (0, $7f56a0898b2f3740$export$2e2bcd8739ae039)(currTokType.categoryMatches, (currExtendingType)=>{
                            result[currExtendingType] = true;
                        });
                    }
                    return result;
                }, {});
                return function() {
                    const nextToken = this.LA_FAST(1);
                    return choiceToAlt[nextToken.tokenTypeIdx] === true;
                };
            }
        }
        return function() {
            const result = $7b69ac9efffb409f$var$adaptivePredict.call(this, dfas, decisionIndex, $7b69ac9efffb409f$var$EMPTY_PREDICATES, logging, incomplete);
            return typeof result === "object" ? false : result === 0;
        };
    }
}
function $7b69ac9efffb409f$var$isLL1Sequence(sequences, allowEmpty = true) {
    const fullSet = new Set();
    for (const alt of sequences){
        const altSet = new Set();
        for (const tokType of alt){
            if (tokType === undefined) {
                if (allowEmpty) break;
                else return false;
            }
            const indices = [
                tokType.tokenTypeIdx
            ].concat(tokType.categoryMatches);
            for (const index of indices)if (fullSet.has(index)) {
                if (!altSet.has(index)) return false;
            } else {
                fullSet.add(index);
                altSet.add(index);
            }
        }
    }
    return true;
}
// Maps each rule to the follow states of its call sites, so a decision's true
// (cross-rule) FOLLOW set can be computed by continuing into the enclosing context.
function $7b69ac9efffb409f$var$buildCallers(atn) {
    const callers = new Map();
    for (const state of atn.states){
        for (const transition of state.transitions)if (transition instanceof (0, $3e7b82843c6724d4$export$5a1cda5a00fd126)) {
            let followStates = callers.get(transition.rule);
            if (followStates === undefined) {
                followStates = [];
                callers.set(transition.rule, followStates);
            }
            followStates.push(transition.followState);
        }
    }
    return callers;
}
// Collects the set of token type indices reachable first from `start`, following
// epsilon and rule (descend into callee) edges. When `callers` is provided and a
// rule-stop state is reached, the traversal continues into every caller's follow
// state, yielding the cross-rule FOLLOW set (outer context). The shared visited
// set guards against infinite recursion through recursive or transitive follows.
function $7b69ac9efffb409f$var$firstSet(start, callers) {
    const result = new Set();
    const visited = new Set();
    const queue = [
        start
    ];
    while(queue.length > 0){
        const current = queue.shift();
        if (visited.has(current)) continue;
        visited.add(current);
        if (current.type === (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) {
            if (callers !== undefined) {
                const followStates = callers.get(current.rule);
                if (followStates !== undefined) queue.push(...followStates);
            }
            continue;
        }
        for (const transition of current.transitions)if (transition instanceof (0, $3e7b82843c6724d4$export$749c9accb19d603f)) {
            result.add(transition.tokenType.tokenTypeIdx);
            for (const category of transition.tokenType.categoryMatches)result.add(category);
        } else // Epsilon and rule transitions: descend into the target
        queue.push(transition.target);
    }
    return result;
}
// Reports whether an optional/loop guard's local LL(1) decision would be wrong
// once the outer context is taken into account. This happens when the tokens
// that enter (or continue) the production overlap with the tokens that can
// follow it after exiting. A single lookahead token then cannot decide, so the
// decision must fall back to LL(*) adaptive prediction.
function $7b69ac9efffb409f$var$optionalHasFollowConflict(decisionState, prodType, callers) {
    // The mandatory-with-separator loop places its exit edge at index 0 and its
    // continue (via separator) edge at index 1; every other production is reversed.
    const sepPlus = prodType === "RepetitionMandatoryWithSeparator";
    const enterTransition = decisionState.transitions[sepPlus ? 1 : 0];
    const exitTransition = decisionState.transitions[sepPlus ? 0 : 1];
    if (enterTransition === undefined || exitTransition === undefined) return false;
    const enter = $7b69ac9efffb409f$var$firstSet(enterTransition.target);
    const exit = $7b69ac9efffb409f$var$firstSet(exitTransition.target, callers);
    for (const id of enter){
        if (exit.has(id)) return true;
    }
    return false;
}
function $7b69ac9efffb409f$var$initATNSimulator(atn) {
    const decisionLength = atn.decisionStates.length;
    const decisionToDFA = Array(decisionLength);
    for(let i = 0; i < decisionLength; i++)decisionToDFA[i] = $7b69ac9efffb409f$var$createDFACache(atn.decisionStates[i], i);
    return decisionToDFA;
}
function $7b69ac9efffb409f$var$adaptivePredict(dfaCaches, decision, predicateSet, logging, incomplete) {
    const dfa = dfaCaches[decision](predicateSet);
    let start = dfa.start;
    if (start === undefined) {
        const closure = $7b69ac9efffb409f$var$computeStartState(dfa.atnStartState);
        start = $7b69ac9efffb409f$var$addDFAState(dfa, $7b69ac9efffb409f$var$newDFAState(closure));
        dfa.start = start;
    }
    const alt = $7b69ac9efffb409f$var$performLookahead.apply(this, [
        dfa,
        start,
        predicateSet,
        logging,
        incomplete
    ]);
    return alt;
}
function $7b69ac9efffb409f$var$performLookahead(dfa, s0, predicateSet, logging, incomplete) {
    let previousD = s0;
    let i = 1;
    const path = [];
    // Using LA_FAST is fine here
    let t = this.LA_FAST(i++);
    while(true){
        let d = $7b69ac9efffb409f$var$getExistingTargetState(previousD, t);
        if (d === undefined) d = $7b69ac9efffb409f$var$computeLookaheadTarget.apply(this, [
            dfa,
            previousD,
            t,
            i,
            predicateSet,
            logging
        ]);
        if (d === (0, $2a976e920eae9992$export$49d87936aae2ebd2)) return $7b69ac9efffb409f$var$buildAdaptivePredictError(path, previousD, t);
        if (d.isAcceptState === true) {
            if (incomplete === true && (0, $5d51f81a4b917e73$export$4a18d31d63d8e922)(t, (0, $5d51f81a4b917e73$export$c1a09112320b1603))) {
                // We run into this case, when we reached the end of the input, but we are in the middle of evaluating a lookahead sequence
                // The sequence is incomplete, but we can still make an educated guess on which alternative is more likely to be correct
                const bestGuess = $7b69ac9efffb409f$var$getBestGuess(previousD, predicateSet);
                if (bestGuess !== undefined) return bestGuess;
            }
            return d.prediction;
        }
        previousD = d;
        path.push(t);
        // We might be reading out of bounds
        // Therefore, no LA_FAST here
        t = this.LA(i++);
    }
}
function $7b69ac9efffb409f$var$computeLookaheadTarget(dfa, previousD, token, lookahead, predicateSet, logging) {
    const reach = $7b69ac9efffb409f$var$computeReachSet(previousD.configs, token, predicateSet);
    if (reach.size === 0) {
        $7b69ac9efffb409f$var$addDFAEdge(dfa, previousD, token, (0, $2a976e920eae9992$export$49d87936aae2ebd2));
        return 0, $2a976e920eae9992$export$49d87936aae2ebd2;
    }
    let newState = $7b69ac9efffb409f$var$newDFAState(reach);
    const predictedAlt = $7b69ac9efffb409f$var$getUniqueAlt(reach, predicateSet);
    if (predictedAlt !== undefined) {
        newState.isAcceptState = true;
        newState.prediction = predictedAlt;
        newState.configs.uniqueAlt = predictedAlt;
    } else if ($7b69ac9efffb409f$var$hasConflictTerminatingPrediction(reach)) {
        const prediction = (0, $f78fdff2026af505$export$2e2bcd8739ae039)(reach.alts);
        newState.isAcceptState = true;
        newState.prediction = prediction;
        newState.configs.uniqueAlt = prediction;
        $7b69ac9efffb409f$var$reportLookaheadAmbiguity.apply(this, [
            dfa,
            lookahead,
            reach.alts,
            logging
        ]);
    }
    newState = $7b69ac9efffb409f$var$addDFAEdge(dfa, previousD, token, newState);
    return newState;
}
function $7b69ac9efffb409f$var$reportLookaheadAmbiguity(dfa, lookahead, ambiguityIndices, logging) {
    const prefixPath = [];
    for(let i = 1; i <= lookahead; i++)prefixPath.push(this.LA(i).tokenType);
    const atnState = dfa.atnStartState;
    const topLevelRule = atnState.rule;
    const production = atnState.production;
    const message = $7b69ac9efffb409f$var$buildAmbiguityError({
        topLevelRule: topLevelRule,
        ambiguityIndices: ambiguityIndices,
        production: production,
        prefixPath: prefixPath
    });
    logging(message);
}
function $7b69ac9efffb409f$var$buildAmbiguityError(options) {
    const pathMsg = (0, $ff2d60bc6af6aa19$export$2e2bcd8739ae039)(options.prefixPath, (currtok)=>(0, $5d51f81a4b917e73$export$9e0160de4349ea3f)(currtok)).join(", ");
    const occurrence = options.production.idx === 0 ? "" : options.production.idx;
    let currMessage = `Ambiguous Alternatives Detected: <${options.ambiguityIndices.join(", ")}> in <${$7b69ac9efffb409f$var$getProductionDslName(options.production)}${occurrence}>` + ` inside <${options.topLevelRule.name}> Rule,\n` + `<${pathMsg}> may appears as a prefix path in all these alternatives.\n`;
    currMessage = currMessage + `See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#AMBIGUOUS_ALTERNATIVES\n` + `For Further details.`;
    return currMessage;
}
function $7b69ac9efffb409f$var$getProductionDslName(prod) {
    if (prod instanceof (0, $5d51f81a4b917e73$export$ab116ec58638c09)) return "SUBRULE";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$36d18380658d5d20)) return "OPTION";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$d8895f7a7cf86415)) return "OR";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$d068cf3ccde3d9e8)) return "AT_LEAST_ONE";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$da6c5580175e0214)) return "AT_LEAST_ONE_SEP";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$856dea708c981fb8)) return "MANY_SEP";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$adf7bc0a69b784e9)) return "MANY";
    else if (prod instanceof (0, $5d51f81a4b917e73$export$8dd80f06eb58bfe1)) return "CONSUME";
    else throw Error("non exhaustive match");
}
function $7b69ac9efffb409f$var$buildAdaptivePredictError(path, previous, current) {
    const nextTransitions = (0, $9a6484bdcb1e73a5$export$2e2bcd8739ae039)(previous.configs.elements, (e)=>e.state.transitions);
    const nextTokenTypes = (0, $3b7b54f2948a3617$export$2e2bcd8739ae039)(nextTransitions.filter((e)=>e instanceof (0, $3e7b82843c6724d4$export$749c9accb19d603f)).map((e)=>e.tokenType), (e)=>e.tokenTypeIdx);
    return {
        actualToken: current,
        possibleTokenTypes: nextTokenTypes,
        tokenPath: path
    };
}
function $7b69ac9efffb409f$var$getExistingTargetState(state, token) {
    return state.edges[token.tokenTypeIdx];
}
function $7b69ac9efffb409f$var$computeReachSet(configs, token, predicateSet) {
    const intermediate = new (0, $2a976e920eae9992$export$3e159d9d82bfca90)();
    const skippedStopStates = [];
    for (const c of configs.elements){
        if (predicateSet.is(c.alt) === false) continue;
        if (c.state.type === (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) {
            skippedStopStates.push(c);
            continue;
        }
        const transitionLength = c.state.transitions.length;
        for(let i = 0; i < transitionLength; i++){
            const transition = c.state.transitions[i];
            const target = $7b69ac9efffb409f$var$getReachableTarget(transition, token);
            if (target !== undefined) intermediate.add({
                state: target,
                alt: c.alt,
                stack: c.stack
            });
        }
    }
    let reach;
    if (skippedStopStates.length === 0 && intermediate.size === 1) reach = intermediate;
    if (reach === undefined) {
        reach = new (0, $2a976e920eae9992$export$3e159d9d82bfca90)();
        for (const c of intermediate.elements)$7b69ac9efffb409f$var$closure(c, reach);
    }
    if (skippedStopStates.length > 0 && !$7b69ac9efffb409f$var$hasConfigInRuleStopState(reach)) for (const c of skippedStopStates)reach.add(c);
    return reach;
}
function $7b69ac9efffb409f$var$getReachableTarget(transition, token) {
    if (transition instanceof (0, $3e7b82843c6724d4$export$749c9accb19d603f) && (0, $5d51f81a4b917e73$export$4a18d31d63d8e922)(token, transition.tokenType)) return transition.target;
    return undefined;
}
function $7b69ac9efffb409f$var$getUniqueAlt(configs, predicateSet) {
    let alt;
    for (const c of configs.elements)if (predicateSet.is(c.alt) === true) {
        if (alt === undefined) alt = c.alt;
        else if (alt !== c.alt) return undefined;
    }
    return alt;
}
function $7b69ac9efffb409f$var$newDFAState(closure) {
    return {
        configs: closure,
        edges: {},
        isAcceptState: false,
        prediction: -1
    };
}
function $7b69ac9efffb409f$var$addDFAEdge(dfa, from, token, to) {
    to = $7b69ac9efffb409f$var$addDFAState(dfa, to);
    from.edges[token.tokenTypeIdx] = to;
    return to;
}
function $7b69ac9efffb409f$var$addDFAState(dfa, state) {
    if (state === (0, $2a976e920eae9992$export$49d87936aae2ebd2)) return state;
    // Repetitions have the same config set
    // Therefore, storing the key of the config in a map allows us to create a loop in our DFA
    const mapKey = state.configs.key;
    const existing = dfa.states[mapKey];
    if (existing !== undefined) return existing;
    state.configs.finalize();
    dfa.states[mapKey] = state;
    return state;
}
function $7b69ac9efffb409f$var$computeStartState(atnState) {
    const configs = new (0, $2a976e920eae9992$export$3e159d9d82bfca90)();
    const numberOfTransitions = atnState.transitions.length;
    for(let i = 0; i < numberOfTransitions; i++){
        const target = atnState.transitions[i].target;
        const config = {
            state: target,
            alt: i,
            stack: []
        };
        $7b69ac9efffb409f$var$closure(config, configs);
    }
    return configs;
}
function $7b69ac9efffb409f$var$closure(config, configs) {
    const p = config.state;
    if (p.type === (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) {
        if (config.stack.length > 0) {
            const atnStack = [
                ...config.stack
            ];
            const followState = atnStack.pop();
            const followConfig = {
                state: followState,
                alt: config.alt,
                stack: atnStack
            };
            $7b69ac9efffb409f$var$closure(followConfig, configs);
        } else // Dipping into outer context, simply add the config
        // This will stop computation once every config is at the rule stop state
        configs.add(config);
        return;
    }
    if (!p.epsilonOnlyTransitions) configs.add(config);
    const transitionLength = p.transitions.length;
    for(let i = 0; i < transitionLength; i++){
        const transition = p.transitions[i];
        const c = $7b69ac9efffb409f$var$getEpsilonTarget(config, transition);
        if (c !== undefined) $7b69ac9efffb409f$var$closure(c, configs);
    }
}
function $7b69ac9efffb409f$var$getEpsilonTarget(config, transition) {
    if (transition instanceof (0, $3e7b82843c6724d4$export$a59e0290d2db6277)) return {
        state: transition.target,
        alt: config.alt,
        stack: config.stack
    };
    else if (transition instanceof (0, $3e7b82843c6724d4$export$5a1cda5a00fd126)) {
        const stack = [
            ...config.stack,
            transition.followState
        ];
        return {
            state: transition.target,
            alt: config.alt,
            stack: stack
        };
    }
    return undefined;
}
function $7b69ac9efffb409f$var$hasConfigInRuleStopState(configs) {
    for (const c of configs.elements){
        if (c.state.type === (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) return true;
    }
    return false;
}
function $7b69ac9efffb409f$var$allConfigsInRuleStopStates(configs) {
    for (const c of configs.elements){
        if (c.state.type !== (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) return false;
    }
    return true;
}
function $7b69ac9efffb409f$var$hasConflictTerminatingPrediction(configs) {
    if ($7b69ac9efffb409f$var$allConfigsInRuleStopStates(configs)) return true;
    const altSets = $7b69ac9efffb409f$var$getConflictingAltSets(configs.elements);
    const heuristic = $7b69ac9efffb409f$var$hasConflictingAltSet(altSets) && !$7b69ac9efffb409f$var$hasStateAssociatedWithOneAlt(altSets);
    return heuristic;
}
function $7b69ac9efffb409f$var$getConflictingAltSets(configs) {
    const configToAlts = new Map();
    for (const c of configs){
        const key = (0, $2a976e920eae9992$export$aa8b83e12b1ae083)(c, false);
        let alts = configToAlts.get(key);
        if (alts === undefined) {
            alts = {};
            configToAlts.set(key, alts);
        }
        alts[c.alt] = true;
    }
    return configToAlts;
}
function $7b69ac9efffb409f$var$hasConflictingAltSet(altSets) {
    for (const value of Array.from(altSets.values())){
        if (Object.keys(value).length > 1) return true;
    }
    return false;
}
function $7b69ac9efffb409f$var$hasStateAssociatedWithOneAlt(altSets) {
    for (const value of Array.from(altSets.values())){
        if (Object.keys(value).length === 1) return true;
    }
    return false;
}
function $7b69ac9efffb409f$var$getBestGuess(state, predicateSet) {
    let bestAlt = undefined;
    for (const c of state.configs.elements){
        // Ignore invalid and stop states
        if (predicateSet.is(c.alt) === false || c.state.type === (0, $3e7b82843c6724d4$export$db5d487b6a59cf5e)) continue;
        if (bestAlt === undefined) bestAlt = c.alt;
        else if (bestAlt !== c.alt) return undefined;
    }
    return bestAlt;
}








/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /**
 * Incrementally builds the concrete syntax tree (CST) while the parser processes the input.
 *
 * The parser drives the builder with the following protocol: `buildRootNode` starts a new tree,
 * `buildCompositeNode` opens a nested node whenever a parser rule is invoked, `buildLeafNode`
 * adds a node for every consumed token, and `construct` closes the innermost open composite node
 * once its rule implementation has finished. Hidden tokens (e.g. comments and whitespace) are not
 * part of the parser's token stream and are added separately via `addHiddenNodes`.
 */ class $1b748ce23177adfe$export$f81d3ebae79e61c1 {
    constructor(){
        this.nodeStack = [];
    }
    /**
     * The composite node currently being built, i.e. the one to which new child nodes are added:
     * the innermost parser rule invocation that has not been completed with `construct` yet.
     */ get current() {
        return this.nodeStack[this.nodeStack.length - 1] ?? this.rootNode;
    }
    /**
     * Reset the builder and create the root node of a new tree. This must be called once
     * before each parser run; all nodes built afterwards belong to the returned root.
     */ buildRootNode(input) {
        this.rootNode = new $1b748ce23177adfe$export$1e34a4735acab9e2(input);
        this.nodeStack = [
            this.rootNode
        ];
        return this.rootNode;
    }
    /**
     * Create a composite node as a child of the current node and make it the new current node.
     * The parser calls this when a rule is invoked that creates its own AST node; the node
     * remains current until the corresponding `construct` call closes it.
     */ buildCompositeNode(feature) {
        const compositeNode = new $1b748ce23177adfe$export$458d45a1bda00db9();
        compositeNode.grammarSource = feature;
        this.appendChild(this.current, compositeNode);
        this.nodeStack.push(compositeNode);
        return compositeNode;
    }
    /**
     * Create a leaf node for a consumed token and append it to the current composite node.
     * If no grammar element is given, the token is treated as hidden (e.g. a comment).
     */ buildLeafNode(token, feature) {
        const leafNode = this.createLeafNode(token, !feature);
        if (feature) leafNode.grammarSource = feature;
        this.appendChild(this.current, leafNode);
        return leafNode;
    }
    /**
     * Create a detached leaf node from a token, translating Chevrotain's position
     * information to the LSP conventions used by the CST.
     */ createLeafNode(token, hidden) {
        // Chevrotain uses 1-based line/column indices, so we subtract 1 to align with the LSP.
        // The end column needs no adjustment: Chevrotain's inclusive end is the LSP's exclusive end.
        return new $1b748ce23177adfe$export$eefe9a70fe4fb05c(token.startOffset, token.image.length, token.startLine - 1, token.startColumn - 1, token.endLine - 1, token.endColumn, token.tokenType, hidden);
    }
    /**
     * Append a child node to the content of a composite node and set the child's container reference.
     */ appendChild(parent, child) {
        child.container = parent;
        parent.content.push(child);
    }
    /**
     * Append multiple child nodes to the content of a composite node and set their container references.
     */ appendChildren(parent, children) {
        for (const child of children)child.container = parent;
        if (parent.content.length === 0) // Copying into a fresh array yields a backing store with exact capacity,
        // whereas pushing into an empty array over-allocates (see `construct`).
        parent.content = children.slice();
        else parent.content.push(...children);
    }
    /**
     * Insert child nodes at the given index into the content of a composite node and set their container references.
     */ insertChildren(parent, index, children) {
        for (const child of children)child.container = parent;
        parent.content.splice(index, 0, ...children);
    }
    /**
     * Remove a node from the content of its container.
     */ removeNode(node) {
        const parent = node.container;
        if (parent) {
            const index = parent.content.indexOf(node);
            if (index >= 0) parent.content.splice(index, 1);
        }
    }
    /**
     * Insert leaf nodes for hidden tokens (e.g. comments) into the tree. Since hidden tokens are
     * not part of the parser's token stream, the parser calls this separately: once before each
     * consumed token with the hidden tokens preceding it, and once after parsing for the trailing
     * hidden tokens. The nodes are attached where the tree is currently being built, so hidden
     * nodes end up next to the non-hidden token that follows them.
     */ addHiddenNodes(tokens) {
        const nodes = [];
        for (const token of tokens)nodes.push(this.createLeafNode(token, true));
        let current = this.current;
        let added = false;
        // If we are within a composite node, we add the hidden nodes to the content
        if (current.content.length > 0) {
            this.appendChildren(current, nodes);
            return;
        }
        // Otherwise we are at a newly created node
        // Instead of adding the hidden nodes here, we search for the first parent node with content
        while(current.container){
            const index = current.container.content.indexOf(current);
            if (index > 0) {
                // Add the hidden nodes before the current node
                this.insertChildren(current.container, index, nodes);
                added = true;
                break;
            }
            current = current.container;
        }
        // If we arrive at the root node, we add the hidden nodes at the beginning
        // This is the case if the hidden nodes are the first nodes in the tree
        if (!added) this.insertChildren(this.rootNode, 0, nodes);
    }
    /**
     * Close the current composite node and assign it to the given AST node (`item.$cstNode`).
     * The parser calls this when a rule implementation has finished, matching the preceding
     * `buildCompositeNode` (or `buildRootNode`) call; the parent node becomes current again.
     * If the closed node has no content, e.g. due to an unsuccessful optional rule call,
     * it is removed from the tree.
     */ construct(item) {
        const current = this.current;
        item.$cstNode = current;
        const node = this.nodeStack.pop();
        if (node) {
            if (node.content.length === 0) // Empty composite nodes are not valid
            // Simply remove the node from the tree
            this.removeNode(node);
            else // Compact the content array: pushing into an empty array makes V8 allocate a
            // backing store with capacity 16, wasting memory for the many small composite
            // nodes in typical CSTs. Copying yields a backing store with exact capacity.
            node.content = node.content.slice();
        }
    }
}
class $1b748ce23177adfe$export$ed142e17b85cbadc {
    constructor(){
        this.container = undefined;
        this.grammarSource = undefined;
    }
    get root() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let node = this;
        while(node.container)node = node.container;
        return node;
    }
    get text() {
        return this.root.fullText.substring(this.offset, this.end);
    }
}
class $1b748ce23177adfe$export$eefe9a70fe4fb05c extends $1b748ce23177adfe$export$ed142e17b85cbadc {
    get offset() {
        return this._offset;
    }
    get length() {
        return this._length;
    }
    get end() {
        return this._offset + this._length;
    }
    get hidden() {
        return this._hidden;
    }
    get tokenType() {
        return this._tokenType;
    }
    get astNode() {
        const container = this.container;
        if (!container) throw new Error('This node has no associated AST element');
        return container.astNode;
    }
    get range() {
        return {
            start: {
                line: this._startLine,
                character: this._startColumn
            },
            end: {
                line: this._endLine,
                character: this._endColumn
            }
        };
    }
    /**
     * All position values are 0-based and the end position is exclusive,
     * following the LSP convention (see the `Range` type).
     */ constructor(offset, length, startLine, startColumn, endLine, endColumn, tokenType, hidden = false){
        super();
        this._hidden = hidden;
        this._offset = $1b748ce23177adfe$var$toSmi(offset);
        this._length = $1b748ce23177adfe$var$toSmi(length);
        this._startLine = $1b748ce23177adfe$var$toSmi(startLine);
        this._startColumn = $1b748ce23177adfe$var$toSmi(startColumn);
        this._endLine = $1b748ce23177adfe$var$toSmi(endLine);
        this._endColumn = $1b748ce23177adfe$var$toSmi(endColumn);
        this._tokenType = tokenType;
    }
}
/**
 * Normalizes a number so V8 stores it as an inline small integer (Smi field representation).
 * Without this, the CST node fields inherit the boxed heap number ("double") representation
 * of Chevrotain's token position fields, costing 16 extra bytes per number. The conversion
 * is lossless here because offsets and positions are always non-negative integers far below 2^31.
 */ function $1b748ce23177adfe$var$toSmi(value) {
    // eslint-disable-next-line no-bitwise
    return value | 0;
}
class $1b748ce23177adfe$export$458d45a1bda00db9 extends $1b748ce23177adfe$export$ed142e17b85cbadc {
    constructor(){
        super(...arguments);
        /**
         * This array must not be modified directly; use the `CstNodeBuilder` methods instead
         * to ensure that the `container` references of the child nodes are set correctly.
         */ this.content = [];
        /**
         * These fields are assigned lazily, but eagerly initialized with `undefined` so V8 reserves
         * in-object slots for them. Without the initializers, late assignments would go to an
         * out-of-object backing store, costing more memory than the reserved slots and splitting
         * the hidden class of composite nodes (slower property access).
         */ this._astNode = undefined;
        this._rangeCache = undefined;
    }
    get astNode() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let node = this;
        while(node){
            if (node._astNode) return node._astNode;
            node = node.container;
        }
        throw new Error('This node has no associated AST element');
    }
    set astNode(value) {
        this._astNode = value;
    }
    get hidden() {
        return false;
    }
    get offset() {
        return this.firstNonHiddenNode?.offset ?? 0;
    }
    get length() {
        return this.end - this.offset;
    }
    get end() {
        return this.lastNonHiddenNode?.end ?? 0;
    }
    get range() {
        let range = this._rangeCache;
        if (range === undefined) {
            const firstNode = this.firstNonHiddenNode;
            const lastNode = this.lastNonHiddenNode;
            if (firstNode && lastNode) {
                const { range: firstRange } = firstNode;
                const { range: lastRange } = lastNode;
                this._rangeCache = range = {
                    start: firstRange.start,
                    end: lastRange.end.line < firstRange.start.line ? firstRange.start : lastRange.end
                };
            } else return {
                start: {
                    line: 0,
                    character: 0
                },
                end: {
                    line: 0,
                    character: 0
                }
            };
        }
        return range;
    }
    get firstNonHiddenNode() {
        for (const child of this.content){
            if (!child.hidden) return child;
        }
        return this.content[0];
    }
    get lastNonHiddenNode() {
        for(let i = this.content.length - 1; i >= 0; i--){
            const child = this.content[i];
            if (!child.hidden) return child;
        }
        return this.content[this.content.length - 1];
    }
}
class $1b748ce23177adfe$export$1e34a4735acab9e2 extends $1b748ce23177adfe$export$458d45a1bda00db9 {
    get text() {
        return this._text.substring(this.offset, this.end);
    }
    get fullText() {
        return this._text;
    }
    constructor(input){
        super();
        this._text = '';
        this._text = input ?? '';
    }
}


const $494eff091ec87f44$export$feb8f17d631776f6 = Symbol('Datatype');
function $494eff091ec87f44$var$isDataTypeNode(node) {
    return node.$type === $494eff091ec87f44$export$feb8f17d631776f6;
}
const $494eff091ec87f44$var$ruleSuffix = '\u200B';
const $494eff091ec87f44$var$withRuleSuffix = (name)=>name.endsWith($494eff091ec87f44$var$ruleSuffix) ? name : name + $494eff091ec87f44$var$ruleSuffix;
class $494eff091ec87f44$export$256c251ed4645678 {
    constructor(services, incomplete){
        this._unorderedGroups = new Map();
        this.allRules = new Map();
        this.lexer = services.parser.Lexer;
        const tokens = this.lexer.definition;
        const production = services.LanguageMetaData.mode === 'production';
        if (services.shared.profilers.LangiumProfiler?.isActive('parsing')) this.wrapper = new $494eff091ec87f44$var$ProfilerWrapper(tokens, {
            ...services.parser.ParserConfig,
            skipValidations: production,
            errorMessageProvider: services.parser.ParserErrorMessageProvider
        }, incomplete, services.shared.profilers.LangiumProfiler.createTask('parsing', services.LanguageMetaData.languageId));
        else this.wrapper = new $494eff091ec87f44$var$ChevrotainWrapper(tokens, {
            ...services.parser.ParserConfig,
            skipValidations: production,
            errorMessageProvider: services.parser.ParserErrorMessageProvider
        }, incomplete);
    }
    alternatives(idx, choices) {
        this.wrapper.wrapOr(idx, choices);
    }
    optional(idx, callback) {
        this.wrapper.wrapOption(idx, callback);
    }
    many(idx, callback) {
        this.wrapper.wrapMany(idx, callback);
    }
    atLeastOne(idx, callback) {
        this.wrapper.wrapAtLeastOne(idx, callback);
    }
    getRule(name) {
        return this.allRules.get(name);
    }
    isRecording() {
        return this.wrapper.IS_RECORDING;
    }
    get unorderedGroups() {
        return this._unorderedGroups;
    }
    getRuleStack() {
        return this.wrapper.RULE_STACK;
    }
    finalize() {
        this.wrapper.wrapSelfAnalysis();
    }
}
class $494eff091ec87f44$export$f00adfded2d3a900 extends $494eff091ec87f44$export$256c251ed4645678 {
    get current() {
        return this.stack[this.stack.length - 1];
    }
    constructor(services){
        super(services, false);
        this.nodeBuilder = new (0, $1b748ce23177adfe$export$f81d3ebae79e61c1)();
        this.stack = [];
        this.assignmentMap = new Map();
        this.operatorPrecedence = new Map();
        this.linker = services.references.Linker;
        this.converter = services.parser.ValueConverter;
        this.astReflection = services.shared.AstReflection;
    }
    rule(rule, impl) {
        const type = this.computeRuleType(rule);
        let infixName = undefined;
        if ((0, $c70992891bcf3a02$export$ff161511bc809b89)(rule)) {
            infixName = rule.name;
            this.registerPrecedenceMap(rule);
        }
        const ruleMethod = this.wrapper.DEFINE_RULE($494eff091ec87f44$var$withRuleSuffix(rule.name), this.startImplementation(type, infixName, impl).bind(this));
        this.allRules.set(rule.name, ruleMethod);
        if ((0, $c70992891bcf3a02$export$f9dab8e9825cb550)(rule) && rule.entry) this.mainRule = ruleMethod;
        return ruleMethod;
    }
    registerPrecedenceMap(rule) {
        const name = rule.name;
        const map = new Map();
        for(let i = 0; i < rule.operators.precedences.length; i++){
            const precedence = rule.operators.precedences[i];
            for (const keyword of precedence.operators)map.set(keyword.value, {
                precedence: i,
                rightAssoc: precedence.associativity === 'right'
            });
        }
        this.operatorPrecedence.set(name, map);
    }
    computeRuleType(rule) {
        if ((0, $c70992891bcf3a02$export$ff161511bc809b89)(rule)) return (0, $624e994b941222bd$export$9bcacca3c0b0cdd9)(rule);
        else if (rule.fragment) return undefined;
        else if ((0, $624e994b941222bd$export$345e3e63a0123b21)(rule)) return $494eff091ec87f44$export$feb8f17d631776f6;
        else return (0, $624e994b941222bd$export$9bcacca3c0b0cdd9)(rule);
    }
    parse(input, options = {}) {
        this.nodeBuilder.buildRootNode(input);
        const lexerResult = this.lexerResult = this.lexer.tokenize(input);
        this.wrapper.input = lexerResult.tokens;
        const ruleMethod = options.rule ? this.allRules.get(options.rule) : this.mainRule;
        if (!ruleMethod) throw new Error(options.rule ? `No rule found with name '${options.rule}'` : 'No main rule available.');
        const result = this.doParse(ruleMethod);
        this.nodeBuilder.addHiddenNodes(lexerResult.hidden);
        this.unorderedGroups.clear();
        this.lexerResult = undefined;
        (0, $de130ae470c6cbfb$export$5cc7fb0ff669ce28)(result, {
            deep: true
        });
        return {
            value: result,
            lexerErrors: lexerResult.errors,
            lexerReport: lexerResult.report,
            parserErrors: this.wrapper.errors
        };
    }
    doParse(rule) {
        let result = this.wrapper.rule(rule);
        if (this.stack.length > 0) // In case the parser throws on the entry rule, `construct` is not called
        // We need to call it manually here
        result = this.construct();
        // Perform some sanity checking
        if (result === undefined) throw new Error('No result from parser');
        else if (this.stack.length > 0) throw new Error('Parser stack is not empty after parsing');
        this.linkCstNode(result);
        return result;
    }
    /**
     * Assigns the CST-to-AST backlink for the given AST node. The link is stored only on the
     * CST node that is directly associated with an AST node (i.e. its `$cstNode`); all other
     * CST nodes find their AST node by walking up the container hierarchy in the `astNode`
     * getter. This method is called once per AST node as soon as its `$cstNode` is final:
     * for the parse result root here in `doParse`, for all other nodes in `assign`.
     */ linkCstNode(item) {
        if ((0, $09c22474b334b427$export$dd586f2688797f92)(item) && item.$cstNode) item.$cstNode.astNode = item;
    }
    startImplementation($type, infixName, implementation) {
        return (args)=>{
            // Only create a new AST node in case the calling rule is not a fragment rule
            const createNode = !this.isRecording() && $type !== undefined;
            if (createNode) {
                const node = {
                    $type: $type
                };
                this.stack.push(node);
                if ($type === $494eff091ec87f44$export$feb8f17d631776f6) node.value = '';
                else if (infixName !== undefined) node.$infixName = infixName;
            }
            // Execute the actual rule implementation
            // The `implementation` never returns anything and only manipulates the parser state.
            implementation(args);
            // Once the rule implementation is done, we need to construct the AST node
            // If the implementation throws (likely a recognition error), we relay the construction to the `subrule` method
            return createNode ? this.construct() : undefined;
        };
    }
    extractHiddenTokens(token) {
        const hiddenTokens = this.lexerResult.hidden;
        if (!hiddenTokens.length) return [];
        const offset = token.startOffset;
        for(let i = 0; i < hiddenTokens.length; i++){
            const token = hiddenTokens[i];
            if (token.startOffset > offset) return hiddenTokens.splice(0, i);
        }
        return hiddenTokens.splice(0, hiddenTokens.length);
    }
    consume(idx, tokenType, feature) {
        const token = this.wrapper.wrapConsume(idx, tokenType);
        if (!this.isRecording() && this.isValidToken(token)) {
            // Before inserting the current token into the CST, we want add the hidden tokens (i.e. comments)
            // These are located directly before the current token, but are not part of the token stream.
            // Adding the hidden tokens to the CST requires searching through the CST and finding the correct position.
            // Performing this work here is more efficient than doing it later on.
            const hiddenTokens = this.extractHiddenTokens(token);
            this.nodeBuilder.addHiddenNodes(hiddenTokens);
            const leafNode = this.nodeBuilder.buildLeafNode(token, feature);
            const { assignment: assignment, crossRef: crossRef } = this.getAssignment(feature);
            const current = this.current;
            if (assignment) {
                const convertedValue = (0, $c70992891bcf3a02$export$384ccb3991bcb643)(feature) ? token.image : this.converter.convert(token.image, leafNode);
                this.assign(assignment.operator, assignment.feature, convertedValue, leafNode, crossRef);
            } else if ($494eff091ec87f44$var$isDataTypeNode(current)) {
                let text = token.image;
                if (!(0, $c70992891bcf3a02$export$384ccb3991bcb643)(feature)) text = this.converter.convert(text, leafNode).toString();
                current.value += text;
            }
        }
    }
    /**
     * Most consumed parser tokens are valid. However there are two cases in which they are not valid:
     *
     * 1. They were inserted during error recovery by the parser. These tokens don't really exist and should not be further processed
     * 2. They contain invalid token ranges. This might include the special EOF token, or other tokens produced by invalid token builders.
     */ isValidToken(token) {
        return !token.isInsertedInRecovery && (0, $f87d6e075cbbfde9$export$b271295f38c7b1c6)(token);
    }
    subrule(idx, rule, fragment, feature, args) {
        let cstNode;
        if (!this.isRecording() && !fragment) // We only want to create a new CST node if the subrule actually creates a new AST node.
        // In other cases like calls of fragment rules the current CST/AST is populated further.
        // Note that skipping this initialization and leaving cstNode unassigned also skips the subrule assignment later on.
        // This is intended, as fragment rules only enrich the current AST node
        cstNode = this.nodeBuilder.buildCompositeNode(feature);
        let result;
        try {
            result = this.wrapper.wrapSubrule(idx, rule, args);
        } finally{
            if (!this.isRecording()) {
                // Calling `subrule` on chevrotain parsers can result in a recognition error
                // This likely means that we encounter a syntax error in the input.
                // In this case, the result of the subrule is `undefined` and we need to call `construct` manually.
                if (result === undefined && !fragment) result = this.construct();
                // We want to perform the subrule assignment regardless of the recognition error
                // But only if the subrule call actually consumed any tokens
                if (result !== undefined && cstNode && cstNode.length > 0) this.performSubruleAssignment(result, feature, cstNode);
            }
        // We don't have a catch block in here because we want to propagate the recognition error to the caller
        // This results in much better error recovery and error messages from chevrotain
        }
    }
    performSubruleAssignment(result, feature, cstNode) {
        const { assignment: assignment, crossRef: crossRef } = this.getAssignment(feature);
        if (assignment) this.assign(assignment.operator, assignment.feature, result, cstNode, crossRef);
        else if (!assignment) {
            // If we call a subrule without an assignment we either:
            // 1. append the result of the subrule (data type rule)
            // 2. override the current object with the newly parsed object
            // If the current element is an AST node and the result of the subrule
            // is a data type rule, we can safely discard the results.
            const current = this.current;
            if ($494eff091ec87f44$var$isDataTypeNode(current)) current.value += result.toString();
            else if (typeof result === 'object' && result) {
                const object = this.assignWithoutOverride(result, current);
                const newItem = object;
                this.stack.pop();
                this.stack.push(newItem);
            }
        }
    }
    action($type, action) {
        if (!this.isRecording()) {
            let last = this.current;
            if (action.feature && action.operator) {
                last = this.construct();
                this.nodeBuilder.removeNode(last.$cstNode);
                const node = this.nodeBuilder.buildCompositeNode(action);
                this.nodeBuilder.appendChild(node, last.$cstNode);
                const newItem = {
                    $type: $type
                };
                this.stack.push(newItem);
                this.assign(action.operator, action.feature, last, last.$cstNode);
            } else last.$type = $type;
        }
    }
    construct() {
        if (this.isRecording()) return undefined;
        const obj = this.stack.pop();
        this.nodeBuilder.construct(obj);
        if ('$infixName' in obj) return this.constructInfix(obj, this.operatorPrecedence.get(obj.$infixName));
        else if ($494eff091ec87f44$var$isDataTypeNode(obj)) return this.converter.convert(obj.value, obj.$cstNode);
        else (0, $de130ae470c6cbfb$export$6d255b1506f7bc8d)(this.astReflection, obj);
        return obj;
    }
    constructInfix(obj, precedence) {
        const parts = obj.parts;
        if (!Array.isArray(parts) || parts.length === 0) // Likely the result of a syntax error, simply return undefined
        return undefined;
        const operators = obj.operators;
        if (!Array.isArray(operators) || parts.length < 2) // Captured just a single, non-binary expression
        // Simply return the expression as is.
        return parts[0];
        // Find the operator with the lowest precedence (highest value in precedence map)
        let lowestPrecedenceIdx = 0;
        let lowestPrecedenceValue = -1;
        for(let i = 0; i < operators.length; i++){
            const operator = operators[i];
            const opPrecedence = precedence.get(operator) ?? {
                precedence: Infinity,
                rightAssoc: false
            };
            // For equal precedence, use associativity to determine which operator to pick
            if (opPrecedence.precedence > lowestPrecedenceValue) {
                // Always pick operators with lower precedence (higher precedence value)
                lowestPrecedenceValue = opPrecedence.precedence;
                lowestPrecedenceIdx = i;
            } else if (opPrecedence.precedence === lowestPrecedenceValue) // Check associativity when precedence is equal
            {
                if (!opPrecedence.rightAssoc) // For left associative operators (default), pick the leftmost one
                // This means choosing the rightmost equal-precedence operator when working backwards
                lowestPrecedenceIdx = i;
            }
        }
        // Split the expression at the lowest precedence operator
        const leftOperators = operators.slice(0, lowestPrecedenceIdx);
        const rightOperators = operators.slice(lowestPrecedenceIdx + 1);
        const leftParts = parts.slice(0, lowestPrecedenceIdx + 1);
        const rightParts = parts.slice(lowestPrecedenceIdx + 1);
        // Create sub-expressions
        const leftInfix = {
            $infixName: obj.$infixName,
            $type: obj.$type,
            $cstNode: obj.$cstNode,
            parts: leftParts,
            operators: leftOperators
        };
        const rightInfix = {
            $infixName: obj.$infixName,
            $type: obj.$type,
            $cstNode: obj.$cstNode,
            parts: rightParts,
            operators: rightOperators
        };
        // Recursively build the left and right subtrees
        const leftTree = this.constructInfix(leftInfix, precedence);
        const rightTree = this.constructInfix(rightInfix, precedence);
        // Create the final binary expression
        return {
            $type: obj.$type,
            $cstNode: obj.$cstNode,
            left: leftTree,
            operator: operators[lowestPrecedenceIdx],
            right: rightTree
        };
    }
    getAssignment(feature) {
        if (!this.assignmentMap.has(feature)) {
            const assignment = (0, $de130ae470c6cbfb$export$51e1e993675a3c6a)(feature, (0, $c70992891bcf3a02$export$f27c77753b3dbe70));
            this.assignmentMap.set(feature, {
                assignment: assignment,
                crossRef: assignment && (0, $c70992891bcf3a02$export$ca91f6306d3bb0f4)(assignment.terminal) ? assignment.terminal.isMulti ? 'multi' : 'single' : undefined
            });
        }
        return this.assignmentMap.get(feature);
    }
    assign(operator, feature, value, cstNode, crossRef) {
        const obj = this.current;
        let item;
        if (crossRef === 'single' && typeof value === 'string') item = this.linker.buildReference(obj, feature, cstNode, value);
        else if (crossRef === 'multi' && typeof value === 'string') item = this.linker.buildMultiReference(obj, feature, cstNode, value);
        else item = value;
        // The assigned node is fully constructed at this point, so we can link its CST node
        this.linkCstNode(item);
        switch(operator){
            case '=':
                obj[feature] = item;
                break;
            case '?=':
                obj[feature] = true;
                break;
            case '+=':
                if (!Array.isArray(obj[feature])) obj[feature] = [];
                obj[feature].push(item);
        }
    }
    assignWithoutOverride(target, source) {
        for (const [name, existingValue] of Object.entries(source)){
            const newValue = target[name];
            if (newValue === undefined) target[name] = existingValue;
            else if (Array.isArray(newValue) && Array.isArray(existingValue)) {
                existingValue.push(...newValue);
                target[name] = existingValue;
            }
        }
        // The target was parsed from a unassigned subrule
        // After the subrule construction, it received a cst node
        // This CST node will later be overriden by the cst node builder
        target.$cstNode = undefined;
        return target;
    }
    get definitionErrors() {
        return this.wrapper.definitionErrors;
    }
}
class $494eff091ec87f44$export$ce06bf5c52f1a053 {
    buildMismatchTokenMessage(options) {
        return (0, $5d51f81a4b917e73$export$d0949d751bf6767).buildMismatchTokenMessage(options);
    }
    buildNotAllInputParsedMessage(options) {
        return (0, $5d51f81a4b917e73$export$d0949d751bf6767).buildNotAllInputParsedMessage(options);
    }
    buildNoViableAltMessage(options) {
        return (0, $5d51f81a4b917e73$export$d0949d751bf6767).buildNoViableAltMessage(options);
    }
    buildEarlyExitMessage(options) {
        return (0, $5d51f81a4b917e73$export$d0949d751bf6767).buildEarlyExitMessage(options);
    }
}
class $494eff091ec87f44$export$fa69d68414d554e3 extends $494eff091ec87f44$export$ce06bf5c52f1a053 {
    buildMismatchTokenMessage({ expected: expected, actual: actual }) {
        const expectedMsg = expected.LABEL ? '`' + expected.LABEL + '`' : expected.name.endsWith(':KW') ? `keyword '${expected.name.substring(0, expected.name.length - 3)}'` : `token of type '${expected.name}'`;
        return `Expecting ${expectedMsg} but found \`${actual.image}\`.`;
    }
    buildNotAllInputParsedMessage({ firstRedundant: firstRedundant }) {
        return `Expecting end of file but found \`${firstRedundant.image}\`.`;
    }
}
class $494eff091ec87f44$export$9242ffb03db9a9f3 extends $494eff091ec87f44$export$256c251ed4645678 {
    constructor(services){
        super(services, true);
        this.tokens = [];
        this.elementStack = [];
        this.lastElementStack = [];
        this.nextTokenIndex = 0;
        this.stackSize = 0;
    }
    action() {
    // NOOP
    }
    construct() {
        // NOOP
        return undefined;
    }
    parse(input) {
        this.resetState();
        const tokens = this.lexer.tokenize(input, {
            mode: 'partial'
        });
        this.tokens = tokens.tokens;
        this.wrapper.input = [
            ...this.tokens
        ];
        this.mainRule.call(this.wrapper, {});
        this.unorderedGroups.clear();
        return {
            tokens: this.tokens,
            elementStack: [
                ...this.lastElementStack
            ],
            tokenIndex: this.nextTokenIndex
        };
    }
    rule(rule, impl) {
        const ruleMethod = this.wrapper.DEFINE_RULE($494eff091ec87f44$var$withRuleSuffix(rule.name), this.startImplementation(impl).bind(this));
        this.allRules.set(rule.name, ruleMethod);
        if (rule.entry) this.mainRule = ruleMethod;
        return ruleMethod;
    }
    resetState() {
        this.elementStack = [];
        this.lastElementStack = [];
        this.nextTokenIndex = 0;
        this.stackSize = 0;
    }
    startImplementation(implementation) {
        return (args)=>{
            const size = this.keepStackSize();
            try {
                implementation(args);
            } finally{
                this.resetStackSize(size);
            }
        };
    }
    removeUnexpectedElements() {
        this.elementStack.splice(this.stackSize);
    }
    keepStackSize() {
        const size = this.elementStack.length;
        this.stackSize = size;
        return size;
    }
    resetStackSize(size) {
        this.removeUnexpectedElements();
        this.stackSize = size;
    }
    consume(idx, tokenType, feature) {
        this.wrapper.wrapConsume(idx, tokenType);
        if (!this.isRecording()) {
            this.lastElementStack = [
                ...this.elementStack,
                feature
            ];
            this.nextTokenIndex = this.currIdx + 1;
        }
    }
    subrule(idx, rule, fragment, feature, args) {
        this.before(feature);
        this.wrapper.wrapSubrule(idx, rule, args);
        this.after(feature);
    }
    before(element) {
        if (!this.isRecording()) this.elementStack.push(element);
    }
    after(element) {
        if (!this.isRecording()) {
            const index = this.elementStack.lastIndexOf(element);
            if (index >= 0) this.elementStack.splice(index);
        }
    }
    get currIdx() {
        return this.wrapper.currIdx;
    }
}
const $494eff091ec87f44$var$defaultConfig = {
    recoveryEnabled: true,
    nodeLocationTracking: 'full',
    skipValidations: true,
    errorMessageProvider: new $494eff091ec87f44$export$fa69d68414d554e3()
};
/**
 * This class wraps the embedded actions parser of chevrotain and exposes protected methods.
 * This way, we can build the `LangiumParser` as a composition.
 */ class $494eff091ec87f44$var$ChevrotainWrapper extends (0, $5d51f81a4b917e73$export$e1a5f464f819d888) {
    constructor(tokens, config, incomplete){
        const useDefaultLookahead = config && 'maxLookahead' in config;
        super(tokens, {
            ...$494eff091ec87f44$var$defaultConfig,
            lookaheadStrategy: useDefaultLookahead ? new (0, $5d51f81a4b917e73$export$a401661f5bedbeb4)({
                maxLookahead: config.maxLookahead
            }) : new (0, $7b69ac9efffb409f$export$b8bdc65cb7fb9724)({
                // If validations are skipped, don't log the lookahead warnings
                logging: config.skipValidations ? ()=>{} : undefined,
                incomplete: incomplete
            }),
            ...config
        });
    }
    get IS_RECORDING() {
        return this.RECORDING_PHASE;
    }
    DEFINE_RULE(name, impl, config) {
        return this.RULE(name, impl, config);
    }
    wrapSelfAnalysis() {
        this.performSelfAnalysis();
    }
    wrapConsume(idx, tokenType) {
        return this.consume(idx, tokenType, undefined);
    }
    wrapSubrule(idx, rule, args) {
        return this.subrule(idx, rule, {
            ARGS: [
                args
            ]
        });
    }
    wrapOr(idx, choices) {
        this.or(idx, choices);
    }
    wrapOption(idx, callback) {
        this.option(idx, callback);
    }
    wrapMany(idx, callback) {
        this.many(idx, callback);
    }
    wrapAtLeastOne(idx, callback) {
        this.atLeastOne(idx, callback);
    }
    rule(rule) {
        return rule.call(this, {});
    }
}
class $494eff091ec87f44$var$ProfilerWrapper extends $494eff091ec87f44$var$ChevrotainWrapper {
    constructor(tokens, config, incomplete, task){
        super(tokens, config, incomplete);
        this.task = task;
    }
    rule(rule) {
        this.task.start();
        this.task.startSubTask(this.ruleName(rule));
        try {
            return super.rule(rule);
        } finally{
            this.task.stopSubTask(this.ruleName(rule));
            this.task.stop();
        }
    }
    ruleName(rule) {
        return rule.ruleName;
    }
    subrule(idx, ruleToCall, options) {
        this.task.startSubTask(this.ruleName(ruleToCall));
        try {
            return super.subrule(idx, ruleToCall, options);
        } finally{
            this.task.stopSubTask(this.ruleName(ruleToCall));
        }
    }
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 




function $bb67d7cf7c440578$export$88a1156fad04455f(grammar, parser, tokens) {
    const parserContext = {
        parser: parser,
        tokens: tokens,
        ruleNames: new Map()
    };
    $bb67d7cf7c440578$var$buildRules(parserContext, grammar);
    return parser;
}
function $bb67d7cf7c440578$var$buildRules(parserContext, grammar) {
    const reachable = (0, $624e994b941222bd$export$fc165bec0f6dde4e)(grammar, false);
    const parserRules = (0, $1feb7546a8c17818$export$4938110305e6185f)(grammar.rules).filter((0, $c70992891bcf3a02$export$f9dab8e9825cb550)).filter((rule)=>reachable.has(rule));
    for (const rule of parserRules){
        const ctx = {
            ...parserContext,
            consume: 1,
            optional: 1,
            subrule: 1,
            many: 1,
            or: 1
        };
        parserContext.parser.rule(rule, $bb67d7cf7c440578$var$buildElement(ctx, rule.definition));
    }
    const infixRules = (0, $1feb7546a8c17818$export$4938110305e6185f)(grammar.rules).filter((0, $c70992891bcf3a02$export$ff161511bc809b89)).filter((rule)=>reachable.has(rule));
    for (const rule of infixRules)parserContext.parser.rule(rule, $bb67d7cf7c440578$var$buildInfixRule(parserContext, rule));
}
function $bb67d7cf7c440578$var$buildInfixRule(ctx, rule) {
    const expressionRule = rule.call.rule.ref;
    if (!expressionRule) throw new Error('Could not resolve reference to infix operator rule: ' + rule.call.rule.$refText);
    if ((0, $c70992891bcf3a02$export$82b19496f708707a)(expressionRule)) throw new Error('Cannot use terminal rule in infix expression');
    // We need to construct a bunch of synthetic grammar AST nodes here
    // This ensures that the CST and completion engine get populated as expected
    const allKeywords = rule.operators.precedences.flatMap((e)=>e.operators);
    // The outer group represents the first expression call and the whole (optional) loop
    const outerGroup = {
        $type: 'Group',
        elements: []
    };
    const part1Assignment = {
        $container: outerGroup,
        $type: 'Assignment',
        feature: 'parts',
        operator: '+=',
        terminal: rule.call
    };
    // The inner group represents the loop that contains the operator and expression call
    // It can be infinitely repeated
    const innerGroup = {
        $container: outerGroup,
        $type: 'Group',
        elements: [],
        cardinality: '*'
    };
    outerGroup.elements.push(part1Assignment, innerGroup);
    // Store all operator keywords in one alternative/assignment
    const alternatives = {
        $type: 'Alternatives',
        elements: allKeywords
    };
    const operatorAssignment = {
        $container: innerGroup,
        $type: 'Assignment',
        feature: 'operators',
        operator: '+=',
        terminal: alternatives
    };
    // We need a second assignment of the called expression here
    const part2Assignment = {
        ...part1Assignment,
        $container: innerGroup
    };
    innerGroup.elements.push(operatorAssignment, part2Assignment);
    const tokens = allKeywords.map((e)=>ctx.tokens[e.value]);
    const orAlts = tokens.map((token, index)=>({
            ALT: ()=>ctx.parser.consume(index, token, operatorAssignment)
        }));
    let subrule;
    return (args)=>{
        subrule ?? (subrule = $bb67d7cf7c440578$var$getRule(ctx, expressionRule));
        ctx.parser.subrule(0, subrule, false, part1Assignment, args);
        ctx.parser.many(0, {
            DEF: ()=>{
                ctx.parser.alternatives(0, orAlts);
                ctx.parser.subrule(1, subrule, false, part2Assignment, args);
            }
        });
    };
}
function $bb67d7cf7c440578$var$buildElement(ctx, element, ignoreGuard = false) {
    let method;
    if ((0, $c70992891bcf3a02$export$384ccb3991bcb643)(element)) method = $bb67d7cf7c440578$var$buildKeyword(ctx, element);
    else if ((0, $c70992891bcf3a02$export$b956e38827fca970)(element)) method = $bb67d7cf7c440578$var$buildAction(ctx, element);
    else if ((0, $c70992891bcf3a02$export$f27c77753b3dbe70)(element)) method = $bb67d7cf7c440578$var$buildElement(ctx, element.terminal);
    else if ((0, $c70992891bcf3a02$export$ca91f6306d3bb0f4)(element)) method = $bb67d7cf7c440578$var$buildCrossReference(ctx, element);
    else if ((0, $c70992891bcf3a02$export$e937deeadef89848)(element)) method = $bb67d7cf7c440578$var$buildRuleCall(ctx, element);
    else if ((0, $c70992891bcf3a02$export$4729babbb377d4fc)(element)) method = $bb67d7cf7c440578$var$buildAlternatives(ctx, element);
    else if ((0, $c70992891bcf3a02$export$ced84873394f175)(element)) method = $bb67d7cf7c440578$var$buildUnorderedGroup(ctx, element);
    else if ((0, $c70992891bcf3a02$export$d7976824e9f55785)(element)) method = $bb67d7cf7c440578$var$buildGroup(ctx, element);
    else if ((0, $c70992891bcf3a02$export$c428a8f05da359d4)(element)) {
        const idx = ctx.consume++;
        method = ()=>ctx.parser.consume(idx, (0, $5d51f81a4b917e73$export$c1a09112320b1603), element);
    } else throw new (0, $71d485f045ec2841$export$5495508d5ff9e05)(element.$cstNode, `Unexpected element type: ${element.$type}`);
    return $bb67d7cf7c440578$var$wrap(ctx, ignoreGuard ? undefined : $bb67d7cf7c440578$var$getGuardCondition(element), method, element.cardinality);
}
function $bb67d7cf7c440578$var$buildAction(ctx, action) {
    const actionType = (0, $624e994b941222bd$export$9bcacca3c0b0cdd9)(action);
    return ()=>ctx.parser.action(actionType, action);
}
function $bb67d7cf7c440578$var$buildRuleCall(ctx, ruleCall) {
    const rule = ruleCall.rule.ref;
    if ((0, $c70992891bcf3a02$export$9075dd262e43c30d)(rule)) {
        const idx = ctx.subrule++;
        const fragment = (0, $c70992891bcf3a02$export$f9dab8e9825cb550)(rule) && rule.fragment;
        const predicate = ruleCall.arguments.length > 0 ? $bb67d7cf7c440578$var$buildRuleCallPredicate(rule, ruleCall.arguments) : ()=>({});
        let subrule;
        return (args)=>{
            subrule ?? (subrule = $bb67d7cf7c440578$var$getRule(ctx, rule));
            ctx.parser.subrule(idx, subrule, fragment, ruleCall, predicate(args));
        };
    } else if ((0, $c70992891bcf3a02$export$82b19496f708707a)(rule)) {
        const idx = ctx.consume++;
        const method = $bb67d7cf7c440578$var$getToken(ctx, rule.name);
        return ()=>ctx.parser.consume(idx, method, ruleCall);
    } else if (!rule) throw new (0, $71d485f045ec2841$export$5495508d5ff9e05)(ruleCall.$cstNode, `Undefined rule: ${ruleCall.rule.$refText}`);
    else (0, $71d485f045ec2841$export$f2525c1d596f8d46)(rule);
}
function $bb67d7cf7c440578$var$buildRuleCallPredicate(rule, namedArgs) {
    const hasNamedArguments = namedArgs.some((arg)=>arg.calledByName);
    if (hasNamedArguments) {
        const namedPredicates = namedArgs.map((arg)=>({
                parameterName: arg.parameter?.ref?.name,
                predicate: $bb67d7cf7c440578$var$buildPredicate(arg.value)
            }));
        return (args)=>{
            const ruleArgs = {};
            for (const { parameterName: parameterName, predicate: predicate } of namedPredicates)if (parameterName) ruleArgs[parameterName] = predicate(args);
            return ruleArgs;
        };
    } else {
        const predicates = namedArgs.map((arg)=>$bb67d7cf7c440578$var$buildPredicate(arg.value));
        return (args)=>{
            const ruleArgs = {};
            for(let i = 0; i < predicates.length; i++)if (i < rule.parameters.length) {
                const parameterName = rule.parameters[i].name;
                const predicate = predicates[i];
                ruleArgs[parameterName] = predicate(args);
            }
            return ruleArgs;
        };
    }
}
function $bb67d7cf7c440578$var$buildPredicate(condition) {
    if ((0, $c70992891bcf3a02$export$f84d3e997ef7e5e8)(condition)) {
        const left = $bb67d7cf7c440578$var$buildPredicate(condition.left);
        const right = $bb67d7cf7c440578$var$buildPredicate(condition.right);
        return (args)=>left(args) || right(args);
    } else if ((0, $c70992891bcf3a02$export$f9aaf5b44a5e36d0)(condition)) {
        const left = $bb67d7cf7c440578$var$buildPredicate(condition.left);
        const right = $bb67d7cf7c440578$var$buildPredicate(condition.right);
        return (args)=>left(args) && right(args);
    } else if ((0, $c70992891bcf3a02$export$fdf5f29387d2e676)(condition)) {
        const value = $bb67d7cf7c440578$var$buildPredicate(condition.value);
        return (args)=>!value(args);
    } else if ((0, $c70992891bcf3a02$export$234e7299f58b20d6)(condition)) {
        const name = condition.parameter.ref.name;
        return (args)=>args !== undefined && args[name] === true;
    } else if ((0, $c70992891bcf3a02$export$9345b34ff3bb44c6)(condition)) {
        const value = Boolean(condition.true);
        return ()=>value;
    }
    (0, $71d485f045ec2841$export$f2525c1d596f8d46)(condition);
}
function $bb67d7cf7c440578$var$buildAlternatives(ctx, alternatives) {
    if (alternatives.elements.length === 1) return $bb67d7cf7c440578$var$buildElement(ctx, alternatives.elements[0]);
    else {
        const methods = [];
        for (const element of alternatives.elements){
            const predicatedMethod = {
                // Since we handle the guard condition in the alternative already
                // We can ignore the group guard condition inside
                ALT: $bb67d7cf7c440578$var$buildElement(ctx, element, true)
            };
            const guard = $bb67d7cf7c440578$var$getGuardCondition(element);
            if (guard) predicatedMethod.GATE = $bb67d7cf7c440578$var$buildPredicate(guard);
            methods.push(predicatedMethod);
        }
        const idx = ctx.or++;
        return (args)=>ctx.parser.alternatives(idx, methods.map((method)=>{
                const alt = {
                    ALT: ()=>method.ALT(args)
                };
                const gate = method.GATE;
                if (gate) alt.GATE = ()=>gate(args);
                return alt;
            }));
    }
}
function $bb67d7cf7c440578$var$buildUnorderedGroup(ctx, group) {
    if (group.elements.length === 1) return $bb67d7cf7c440578$var$buildElement(ctx, group.elements[0]);
    const methods = [];
    for (const element of group.elements){
        const predicatedMethod = {
            // Since we handle the guard condition in the alternative already
            // We can ignore the group guard condition inside
            ALT: $bb67d7cf7c440578$var$buildElement(ctx, element, true)
        };
        const guard = $bb67d7cf7c440578$var$getGuardCondition(element);
        if (guard) predicatedMethod.GATE = $bb67d7cf7c440578$var$buildPredicate(guard);
        methods.push(predicatedMethod);
    }
    const orIdx = ctx.or++;
    const idFunc = (groupIdx, lParser)=>{
        const stackId = lParser.getRuleStack().join('-');
        return `uGroup_${groupIdx}_${stackId}`;
    };
    const alternatives = (args)=>ctx.parser.alternatives(orIdx, methods.map((method, idx)=>{
            const alt = {
                ALT: ()=>true
            };
            const parser = ctx.parser;
            alt.ALT = ()=>{
                method.ALT(args);
                if (!parser.isRecording()) {
                    const key = idFunc(orIdx, parser);
                    if (!parser.unorderedGroups.get(key)) // init after clear state
                    parser.unorderedGroups.set(key, []);
                    const groupState = parser.unorderedGroups.get(key);
                    if (typeof groupState?.[idx] === 'undefined') // Not accessed yet
                    groupState[idx] = true;
                }
            };
            const gate = method.GATE;
            if (gate) alt.GATE = ()=>gate(args);
            else alt.GATE = ()=>{
                const trackedAlternatives = parser.unorderedGroups.get(idFunc(orIdx, parser));
                const allow = !trackedAlternatives?.[idx];
                return allow;
            };
            return alt;
        }));
    const wrapped = $bb67d7cf7c440578$var$wrap(ctx, $bb67d7cf7c440578$var$getGuardCondition(group), alternatives, '*');
    return (args)=>{
        wrapped(args);
        if (!ctx.parser.isRecording()) ctx.parser.unorderedGroups.delete(idFunc(orIdx, ctx.parser));
    };
}
function $bb67d7cf7c440578$var$buildGroup(ctx, group) {
    const methods = group.elements.map((e)=>$bb67d7cf7c440578$var$buildElement(ctx, e));
    return (args)=>methods.forEach((method)=>method(args));
}
function $bb67d7cf7c440578$var$getGuardCondition(element) {
    if ((0, $c70992891bcf3a02$export$d7976824e9f55785)(element)) return element.guardCondition;
    return undefined;
}
function $bb67d7cf7c440578$var$buildCrossReference(ctx, crossRef, terminal = crossRef.terminal) {
    if (!terminal) {
        if (!crossRef.type.ref) throw new Error('Could not resolve reference to type: ' + crossRef.type.$refText);
        const assignment = (0, $624e994b941222bd$export$fa6f17e0e38963f1)(crossRef.type.ref);
        const assignTerminal = assignment?.terminal;
        if (!assignTerminal) throw new Error('Could not find name assignment for type: ' + (0, $624e994b941222bd$export$9bcacca3c0b0cdd9)(crossRef.type.ref));
        return $bb67d7cf7c440578$var$buildCrossReference(ctx, crossRef, assignTerminal);
    } else if ((0, $c70992891bcf3a02$export$e937deeadef89848)(terminal) && (0, $c70992891bcf3a02$export$f9dab8e9825cb550)(terminal.rule.ref)) {
        // The terminal is a data type rule here. Everything else will result in a validation error.
        const rule = terminal.rule.ref;
        const idx = ctx.subrule++;
        let subrule;
        return (args)=>{
            subrule ?? (subrule = $bb67d7cf7c440578$var$getRule(ctx, rule));
            ctx.parser.subrule(idx, subrule, false, crossRef, args);
        };
    } else if ((0, $c70992891bcf3a02$export$e937deeadef89848)(terminal) && (0, $c70992891bcf3a02$export$82b19496f708707a)(terminal.rule.ref)) {
        const idx = ctx.consume++;
        const terminalRule = $bb67d7cf7c440578$var$getToken(ctx, terminal.rule.ref.name);
        return ()=>ctx.parser.consume(idx, terminalRule, crossRef);
    } else if ((0, $c70992891bcf3a02$export$384ccb3991bcb643)(terminal)) {
        const idx = ctx.consume++;
        const keyword = $bb67d7cf7c440578$var$getToken(ctx, terminal.value);
        return ()=>ctx.parser.consume(idx, keyword, crossRef);
    } else throw new Error('Could not build cross reference parser');
}
function $bb67d7cf7c440578$var$buildKeyword(ctx, keyword) {
    const idx = ctx.consume++;
    const token = ctx.tokens[keyword.value];
    if (!token) throw new Error('Could not find token for keyword: ' + keyword.value);
    return ()=>ctx.parser.consume(idx, token, keyword);
}
function $bb67d7cf7c440578$var$wrap(ctx, guard, method, cardinality) {
    const gate = guard && $bb67d7cf7c440578$var$buildPredicate(guard);
    if (!cardinality) {
        if (gate) {
            const idx = ctx.or++;
            return (args)=>ctx.parser.alternatives(idx, [
                    {
                        ALT: ()=>method(args),
                        GATE: ()=>gate(args)
                    },
                    {
                        ALT: (0, $5d51f81a4b917e73$export$ce9c850516ba763e)(),
                        GATE: ()=>!gate(args)
                    }
                ]);
        } else return method;
    }
    if (cardinality === '*') {
        const idx = ctx.many++;
        return (args)=>ctx.parser.many(idx, {
                DEF: ()=>method(args),
                GATE: gate ? ()=>gate(args) : undefined
            });
    } else if (cardinality === '+') {
        const idx = ctx.many++;
        if (gate) {
            const orIdx = ctx.or++;
            // In the case of a guard condition for the `+` group
            // We combine it with an empty alternative
            // If the condition returns true, it needs to parse at least a single iteration
            // If its false, it is not allowed to parse anything
            return (args)=>ctx.parser.alternatives(orIdx, [
                    {
                        ALT: ()=>ctx.parser.atLeastOne(idx, {
                                DEF: ()=>method(args)
                            }),
                        GATE: ()=>gate(args)
                    },
                    {
                        ALT: (0, $5d51f81a4b917e73$export$ce9c850516ba763e)(),
                        GATE: ()=>!gate(args)
                    }
                ]);
        } else return (args)=>ctx.parser.atLeastOne(idx, {
                DEF: ()=>method(args)
            });
    } else if (cardinality === '?') {
        const idx = ctx.optional++;
        return (args)=>ctx.parser.optional(idx, {
                DEF: ()=>method(args),
                GATE: gate ? ()=>gate(args) : undefined
            });
    } else (0, $71d485f045ec2841$export$f2525c1d596f8d46)(cardinality);
}
function $bb67d7cf7c440578$var$getRule(ctx, element) {
    const name = $bb67d7cf7c440578$var$getRuleName(ctx, element);
    const rule = ctx.parser.getRule(name);
    if (!rule) throw new Error(`Rule "${name}" not found."`);
    return rule;
}
function $bb67d7cf7c440578$var$getRuleName(ctx, element) {
    if ((0, $c70992891bcf3a02$export$9075dd262e43c30d)(element)) return element.name;
    else if (ctx.ruleNames.has(element)) return ctx.ruleNames.get(element);
    else {
        let item = element;
        let parent = item.$container;
        let ruleName = element.$type;
        while(!(0, $c70992891bcf3a02$export$f9dab8e9825cb550)(parent)){
            if ((0, $c70992891bcf3a02$export$d7976824e9f55785)(parent) || (0, $c70992891bcf3a02$export$4729babbb377d4fc)(parent) || (0, $c70992891bcf3a02$export$ced84873394f175)(parent)) {
                const index = parent.elements.indexOf(item);
                ruleName = index.toString() + ':' + ruleName;
            }
            item = parent;
            parent = parent.$container;
        }
        const rule = parent;
        ruleName = rule.name + ':' + ruleName;
        ctx.ruleNames.set(element, ruleName);
        return ruleName;
    }
}
function $bb67d7cf7c440578$var$getToken(ctx, name) {
    const token = ctx.tokens[name];
    if (!token) throw new Error(`Token "${name}" not found."`);
    return token;
}


function $69fd5d94279834e5$export$fb4437d6aec944c8(services) {
    const grammar = services.Grammar;
    const lexer = services.parser.Lexer;
    const parser = new (0, $494eff091ec87f44$export$9242ffb03db9a9f3)(services);
    (0, $bb67d7cf7c440578$export$88a1156fad04455f)(grammar, parser, lexer.definition);
    parser.finalize();
    return parser;
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

function $0c6afc7ef5407be8$export$c34ae3a42210eed7(services) {
    const parser = $0c6afc7ef5407be8$export$5084939260cc4d72(services);
    parser.finalize();
    return parser;
}
function $0c6afc7ef5407be8$export$5084939260cc4d72(services) {
    const grammar = services.Grammar;
    const lexer = services.parser.Lexer;
    const parser = new (0, $494eff091ec87f44$export$f00adfded2d3a900)(services);
    return (0, $bb67d7cf7c440578$export$88a1156fad04455f)(grammar, parser, lexer.definition);
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 





class $e140e1b69a73e38f$export$a4968393d41e1883 {
    constructor(){
        /**
         * The list of diagnostics stored during the lexing process of a single text.
         */ this.diagnostics = [];
    }
    buildTokens(grammar, options) {
        const reachableRules = (0, $1feb7546a8c17818$export$4938110305e6185f)((0, $624e994b941222bd$export$fc165bec0f6dde4e)(grammar, false));
        const terminalTokens = this.buildTerminalTokens(reachableRules);
        const tokens = this.buildKeywordTokens(reachableRules, terminalTokens, options);
        // Add all terminals tokens to the end in the order they were defined
        // Chevrotain documentation recommends to add Whitespace-like tokens at the start
        // However, assuming the lexer is able to optimize the tokens, it should not matter
        tokens.push(...terminalTokens);
        // We don't need to add the EOF token explicitly.
        // It is automatically available at the end of the token stream.
        return tokens;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    flushLexingReport(text) {
        return {
            diagnostics: this.popDiagnostics()
        };
    }
    popDiagnostics() {
        const diagnostics = [
            ...this.diagnostics
        ];
        this.diagnostics = [];
        return diagnostics;
    }
    buildTerminalTokens(rules) {
        return rules.filter((0, $c70992891bcf3a02$export$82b19496f708707a)).filter((e)=>!e.fragment).map((terminal)=>this.buildTerminalToken(terminal)).toArray();
    }
    buildTerminalToken(terminal) {
        const regex = (0, $624e994b941222bd$export$52fb9fbe017bc3c3)(terminal);
        const pattern = this.requiresCustomPattern(regex) ? this.regexPatternFunction(regex) : regex;
        const tokenType = {
            name: terminal.name,
            PATTERN: pattern
        };
        if (typeof pattern === 'function') tokenType.LINE_BREAKS = true;
        if (terminal.hidden) // Only skip tokens that are able to accept whitespace
        tokenType.GROUP = (0, $f53f8e965a7efa80$export$a1ed01a3e6d5a08c)(regex) ? (0, $5d51f81a4b917e73$export$6168dc8908a6c652).SKIPPED : 'hidden';
        return tokenType;
    }
    requiresCustomPattern(regex) {
        if (regex.flags.includes('u') || regex.flags.includes('s')) // Unicode and dotall regexes are not supported by Chevrotain.
        return true;
        else return false;
    }
    regexPatternFunction(regex) {
        const stickyRegex = new RegExp(regex, regex.flags + 'y');
        return (text, offset)=>{
            stickyRegex.lastIndex = offset;
            const execResult = stickyRegex.exec(text);
            return execResult;
        };
    }
    buildKeywordTokens(rules, terminalTokens, options) {
        return rules// We filter by parser rules, since keywords in terminal rules get transformed into regex and are not actual tokens
        .filter((0, $c70992891bcf3a02$export$9075dd262e43c30d)).flatMap((rule)=>(0, $de130ae470c6cbfb$export$b4b3af85716f6615)(rule).filter((0, $c70992891bcf3a02$export$384ccb3991bcb643))).distinct((e)=>e.value).toArray()// Sort keywords by descending length
        .sort((a, b)=>b.value.length - a.value.length).map((keyword)=>this.buildKeywordToken(keyword, terminalTokens, Boolean(options?.caseInsensitive)));
    }
    buildKeywordToken(keyword, terminalTokens, caseInsensitive) {
        const keywordPattern = this.buildKeywordPattern(keyword, caseInsensitive);
        const tokenType = {
            name: keyword.value,
            PATTERN: keywordPattern,
            LONGER_ALT: this.findLongerAlt(keyword, terminalTokens)
        };
        if (typeof keywordPattern === 'function') tokenType.LINE_BREAKS = true;
        return tokenType;
    }
    buildKeywordPattern(keyword, caseInsensitive) {
        return caseInsensitive ? new RegExp((0, $f53f8e965a7efa80$export$7c57da42ce8e346f)(keyword.value), 'i') : keyword.value;
    }
    findLongerAlt(keyword, terminalTokens) {
        return terminalTokens.reduce((longerAlts, token)=>{
            const pattern = token?.PATTERN;
            if (pattern?.source && (0, $f53f8e965a7efa80$export$c5bffdd190c23a11)('^' + pattern.source + '$', keyword.value)) longerAlts.push(token);
            return longerAlts;
        }, []);
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

class $ee0cf949ec60f893$export$f6596dabd45df11d {
    convert(input, cstNode) {
        let feature = cstNode.grammarSource;
        if ((0, $c70992891bcf3a02$export$ca91f6306d3bb0f4)(feature)) feature = (0, $624e994b941222bd$export$9b79b91a8e4df62)(feature);
        if ((0, $c70992891bcf3a02$export$e937deeadef89848)(feature)) {
            const rule = feature.rule.ref;
            if (!rule) throw new Error('This cst node was not parsed by a rule.');
            return this.runConverter(rule, input, cstNode);
        }
        return input;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    runConverter(rule, input, cstNode) {
        switch(rule.name.toUpperCase()){
            case 'INT':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertInt(input);
            case 'STRING':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertString(input);
            case 'ID':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertID(input);
        }
        switch((0, $624e994b941222bd$export$71fe8f5e5e2347dc)(rule)?.toLowerCase()){
            case 'number':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertNumber(input);
            case 'boolean':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertBoolean(input);
            case 'bigint':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertBigint(input);
            case 'date':
                return $ee0cf949ec60f893$export$12e6ba671925ed17.convertDate(input);
            default:
                return input;
        }
    }
}
var $ee0cf949ec60f893$export$12e6ba671925ed17;
(function(ValueConverter) {
    function convertString(input) {
        let result = '';
        for(let i = 1; i < input.length - 1; i++){
            const c = input.charAt(i);
            if (c === '\\') {
                const c1 = input.charAt(++i);
                result += convertEscapeCharacter(c1);
            } else result += c;
        }
        return result;
    }
    ValueConverter.convertString = convertString;
    function convertEscapeCharacter(char) {
        switch(char){
            case 'b':
                return '\b';
            case 'f':
                return '\f';
            case 'n':
                return '\n';
            case 'r':
                return '\r';
            case 't':
                return '\t';
            case 'v':
                return '\v';
            case '0':
                return '\0';
            default:
                return char;
        }
    }
    function convertID(input) {
        if (input.charAt(0) === '^') return input.substring(1);
        else return input;
    }
    ValueConverter.convertID = convertID;
    function convertInt(input) {
        return parseInt(input);
    }
    ValueConverter.convertInt = convertInt;
    function convertBigint(input) {
        return BigInt(input);
    }
    ValueConverter.convertBigint = convertBigint;
    function convertDate(input) {
        return new Date(input);
    }
    ValueConverter.convertDate = convertDate;
    function convertNumber(input) {
        return Number(input);
    }
    ValueConverter.convertNumber = convertNumber;
    function convertBoolean(input) {
        return input.toLowerCase() === 'true';
    }
    ValueConverter.convertBoolean = convertBoolean;
})($ee0cf949ec60f893$export$12e6ba671925ed17 || ($ee0cf949ec60f893$export$12e6ba671925ed17 = {}));


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ var $284dfc6cfc7f5287$exports = {};
"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */ var $284dfc6cfc7f5287$var$__createBinding = $284dfc6cfc7f5287$exports && $284dfc6cfc7f5287$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $284dfc6cfc7f5287$var$__exportStar = $284dfc6cfc7f5287$exports && $284dfc6cfc7f5287$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $284dfc6cfc7f5287$var$__createBinding(exports1, m, p);
};
Object.defineProperty($284dfc6cfc7f5287$exports, "__esModule", {
    value: true
});
$284dfc6cfc7f5287$exports.createProtocolConnection = $284dfc6cfc7f5287$var$createProtocolConnection;


$284dfc6cfc7f5287$var$__exportStar((parcelRequire("d8V62")), $284dfc6cfc7f5287$exports);

$284dfc6cfc7f5287$var$__exportStar((parcelRequire("fS1k7")), $284dfc6cfc7f5287$exports);
function $284dfc6cfc7f5287$var$createProtocolConnection(reader, writer, logger, options) {
    return (0, (parcelRequire("d8V62")).createMessageConnection)(reader, writer, logger, options);
}




/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
function $4fb404a672a62c84$export$e08d67d318085514() {
    return new Promise((resolve)=>{
        // In case we are running in a non-node environment, `setImmediate` isn't available.
        // Using `setTimeout` of the browser API accomplishes the same result.
        if (typeof setImmediate === 'undefined') setTimeout(resolve, 0);
        else setImmediate(resolve);
    });
}
let $4fb404a672a62c84$var$lastTick = 0;
let $4fb404a672a62c84$var$globalInterruptionPeriod = 10;
function $4fb404a672a62c84$export$77c8be3ce67874ab() {
    $4fb404a672a62c84$var$lastTick = performance.now();
    return new (0, $284dfc6cfc7f5287$exports.CancellationTokenSource)();
}
function $4fb404a672a62c84$export$ffcc322e0bbc775d(period) {
    $4fb404a672a62c84$var$globalInterruptionPeriod = period;
}
const $4fb404a672a62c84$export$e8984aef454a5fd3 = Symbol('OperationCancelled');
function $4fb404a672a62c84$export$5b2d4ab85306fab5(err) {
    return err === $4fb404a672a62c84$export$e8984aef454a5fd3;
}
async function $4fb404a672a62c84$export$bdfe86f6b3074c59(token) {
    if (token === (0, $284dfc6cfc7f5287$exports.CancellationToken).None) // Early exit in case cancellation was disabled by the caller
    return;
    const current = performance.now();
    if (current - $4fb404a672a62c84$var$lastTick >= $4fb404a672a62c84$var$globalInterruptionPeriod) {
        $4fb404a672a62c84$var$lastTick = current;
        await $4fb404a672a62c84$export$e08d67d318085514();
        // prevent calling delayNextTick every iteration of loop
        // where delayNextTick takes up the majority or all of the
        // globalInterruptionPeriod itself
        $4fb404a672a62c84$var$lastTick = performance.now();
    }
    if (token.isCancellationRequested) throw $4fb404a672a62c84$export$e8984aef454a5fd3;
}
class $4fb404a672a62c84$export$85f6557964517f1a {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (arg)=>{
                resolve(arg);
                return this;
            };
            this.reject = (err)=>{
                reject(err);
                return this;
            };
        });
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /**
 * Re-export 'TextDocument' from 'vscode-languageserver-textdocument' for convenience,
 *  including both type _and_ symbol (namespace), as we here and there also refer to the symbol,
 *  the overhead is very small, just a few kilobytes.
 * Everything else of that package (at the time contributing) is also defined
 *  in 'vscode-languageserver-protocol' or 'vscode-languageserver-types'.
 */ var $b10a49ae6010afc9$exports = {};
var $b10a49ae6010afc9$var$__spreadArray = $b10a49ae6010afc9$exports && $b10a49ae6010afc9$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
(function(factory) {
    if (typeof $b10a49ae6010afc9$exports === "object") {
        var v = factory(undefined, $b10a49ae6010afc9$exports);
        if (v !== undefined) $b10a49ae6010afc9$exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    /* --------------------------------------------------------------------------------------------
     * Copyright (c) Microsoft Corporation. All rights reserved.
     * Licensed under the MIT License. See License.txt in the project root for license information.
     * ------------------------------------------------------------------------------------------ */ 'use strict';
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TextDocument = void 0;
    var FullTextDocument = /** @class */ function() {
        function FullTextDocument(uri, languageId, version, content) {
            this._uri = uri;
            this._languageId = languageId;
            this._version = version;
            this._content = content;
            this._lineOffsets = undefined;
        }
        Object.defineProperty(FullTextDocument.prototype, "uri", {
            get: function() {
                return this._uri;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "languageId", {
            get: function() {
                return this._languageId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "version", {
            get: function() {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.prototype.getText = function(range) {
            if (range) {
                var start = this.offsetAt(range.start);
                var end = this.offsetAt(range.end);
                return this._content.substring(start, end);
            }
            return this._content;
        };
        FullTextDocument.prototype.update = function(changes, version) {
            for(var _i = 0, changes_1 = changes; _i < changes_1.length; _i++){
                var change = changes_1[_i];
                if (FullTextDocument.isIncremental(change)) {
                    // makes sure start is before end
                    var range = getWellformedRange(change.range);
                    // update content
                    var startOffset = this.offsetAt(range.start);
                    var endOffset = this.offsetAt(range.end);
                    this._content = this._content.substring(0, startOffset) + change.text + this._content.substring(endOffset, this._content.length);
                    // update the offsets
                    var startLine = Math.max(range.start.line, 0);
                    var endLine = Math.max(range.end.line, 0);
                    var lineOffsets = this._lineOffsets;
                    var addedLineOffsets = computeLineOffsets(change.text, false, startOffset);
                    if (endLine - startLine === addedLineOffsets.length) for(var i = 0, len = addedLineOffsets.length; i < len; i++)lineOffsets[i + startLine + 1] = addedLineOffsets[i];
                    else if (addedLineOffsets.length < 10000) lineOffsets.splice.apply(lineOffsets, $b10a49ae6010afc9$var$__spreadArray([
                        startLine + 1,
                        endLine - startLine
                    ], addedLineOffsets, false));
                    else this._lineOffsets = lineOffsets = lineOffsets.slice(0, startLine + 1).concat(addedLineOffsets, lineOffsets.slice(endLine + 1));
                    var diff = change.text.length - (endOffset - startOffset);
                    if (diff !== 0) for(var i = startLine + 1 + addedLineOffsets.length, len = lineOffsets.length; i < len; i++)lineOffsets[i] = lineOffsets[i] + diff;
                } else if (FullTextDocument.isFull(change)) {
                    this._content = change.text;
                    this._lineOffsets = undefined;
                } else throw new Error('Unknown change event received');
            }
            this._version = version;
        };
        FullTextDocument.prototype.getLineOffsets = function() {
            if (this._lineOffsets === undefined) this._lineOffsets = computeLineOffsets(this._content, true);
            return this._lineOffsets;
        };
        FullTextDocument.prototype.positionAt = function(offset) {
            offset = Math.max(Math.min(offset, this._content.length), 0);
            var lineOffsets = this.getLineOffsets();
            var low = 0, high = lineOffsets.length;
            if (high === 0) return {
                line: 0,
                character: offset
            };
            while(low < high){
                var mid = Math.floor((low + high) / 2);
                if (lineOffsets[mid] > offset) high = mid;
                else low = mid + 1;
            }
            // low is the least x for which the line offset is larger than the current offset
            // or array.length if no line offset is larger than the current offset
            var line = low - 1;
            offset = this.ensureBeforeEOL(offset, lineOffsets[line]);
            return {
                line: line,
                character: offset - lineOffsets[line]
            };
        };
        FullTextDocument.prototype.offsetAt = function(position) {
            var lineOffsets = this.getLineOffsets();
            if (position.line >= lineOffsets.length) return this._content.length;
            else if (position.line < 0) return 0;
            var lineOffset = lineOffsets[position.line];
            if (position.character <= 0) return lineOffset;
            var nextLineOffset = position.line + 1 < lineOffsets.length ? lineOffsets[position.line + 1] : this._content.length;
            var offset = Math.min(lineOffset + position.character, nextLineOffset);
            return this.ensureBeforeEOL(offset, lineOffset);
        };
        FullTextDocument.prototype.getLineRange = function(line) {
            var lineOffsets = this.getLineOffsets();
            if (line >= lineOffsets.length) {
                var lastLine = lineOffsets.length - 1;
                return {
                    start: {
                        line: lastLine,
                        character: 0
                    },
                    end: {
                        line: lastLine,
                        character: this._content.length - lineOffsets[lastLine]
                    }
                };
            } else if (line < 0) return {
                start: {
                    line: 0,
                    character: 0
                },
                end: {
                    line: 0,
                    character: 0
                }
            };
            var startOffset = lineOffsets[line];
            var nextLineOffset = line + 1 < lineOffsets.length ? lineOffsets[line + 1] : this._content.length;
            var endOffset = this.ensureBeforeEOL(nextLineOffset, startOffset);
            return {
                start: {
                    line: line,
                    character: 0
                },
                end: {
                    line: line,
                    character: endOffset - startOffset
                }
            };
        };
        FullTextDocument.prototype.getEOLCharacters = function(line) {
            var lineOffsets = this.getLineOffsets();
            if (line >= lineOffsets.length) return '';
            else if (line < 0) return '';
            var nextLineOffset = line + 1 < lineOffsets.length ? lineOffsets[line + 1] : this._content.length;
            var eolOffset = this.ensureBeforeEOL(nextLineOffset, lineOffsets[line]);
            return this._content.substring(eolOffset, nextLineOffset);
        };
        FullTextDocument.prototype.ensureBeforeEOL = function(offset, lineOffset) {
            while(offset > lineOffset && isEOL(this._content.charCodeAt(offset - 1)))offset--;
            return offset;
        };
        Object.defineProperty(FullTextDocument.prototype, "lineCount", {
            get: function() {
                return this.getLineOffsets().length;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.isIncremental = function(event) {
            var candidate = event;
            return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range !== undefined && (candidate.rangeLength === undefined || typeof candidate.rangeLength === 'number');
        };
        FullTextDocument.isFull = function(event) {
            var candidate = event;
            return candidate !== undefined && candidate !== null && typeof candidate.text === 'string' && candidate.range === undefined && candidate.rangeLength === undefined;
        };
        return FullTextDocument;
    }();
    var TextDocument;
    (function(TextDocument) {
        /**
         * Creates a new text document.
         *
         * @param uri The document's uri.
         * @param languageId  The document's language Id.
         * @param version The document's initial version number.
         * @param content The document's content.
         */ function create(uri, languageId, version, content) {
            return new FullTextDocument(uri, languageId, version, content);
        }
        TextDocument.create = create;
        /**
         * Updates a TextDocument by modifying its content.
         *
         * @param document the document to update. Only documents created by TextDocument.create are valid inputs.
         * @param changes the changes to apply to the document.
         * @param version the changes version for the document.
         * @returns The updated TextDocument. Note: That's the same document instance passed in as first parameter.
         *
         */ function update(document, changes, version) {
            if (document instanceof FullTextDocument) {
                document.update(changes, version);
                return document;
            } else throw new Error('TextDocument.update: document must be created by TextDocument.create');
        }
        TextDocument.update = update;
        function applyEdits(document, edits) {
            var text = document.getText();
            var sortedEdits = mergeSort(edits.map(getWellformedEdit), function(a, b) {
                var diff = a.range.start.line - b.range.start.line;
                if (diff === 0) return a.range.start.character - b.range.start.character;
                return diff;
            });
            var lastModifiedOffset = 0;
            var spans = [];
            for(var _i = 0, sortedEdits_1 = sortedEdits; _i < sortedEdits_1.length; _i++){
                var e = sortedEdits_1[_i];
                var startOffset = document.offsetAt(e.range.start);
                if (startOffset < lastModifiedOffset) throw new Error('Overlapping edit');
                else if (startOffset > lastModifiedOffset) spans.push(text.substring(lastModifiedOffset, startOffset));
                if (e.newText.length) spans.push(e.newText);
                lastModifiedOffset = document.offsetAt(e.range.end);
            }
            spans.push(text.substr(lastModifiedOffset));
            return spans.join('');
        }
        TextDocument.applyEdits = applyEdits;
    })(TextDocument || (exports1.TextDocument = TextDocument = {}));
    function mergeSort(data, compare) {
        if (data.length <= 1) // sorted
        return data;
        var p = data.length / 2 | 0;
        var left = data.slice(0, p);
        var right = data.slice(p);
        mergeSort(left, compare);
        mergeSort(right, compare);
        var leftIdx = 0;
        var rightIdx = 0;
        var i = 0;
        while(leftIdx < left.length && rightIdx < right.length){
            var ret = compare(left[leftIdx], right[rightIdx]);
            if (ret <= 0) // smaller_equal -> take left to preserve order
            data[i++] = left[leftIdx++];
            else // greater -> take right
            data[i++] = right[rightIdx++];
        }
        while(leftIdx < left.length)data[i++] = left[leftIdx++];
        while(rightIdx < right.length)data[i++] = right[rightIdx++];
        return data;
    }
    function computeLineOffsets(text, isAtLineStart, textOffset) {
        if (textOffset === void 0) textOffset = 0;
        var result = isAtLineStart ? [
            textOffset
        ] : [];
        for(var i = 0; i < text.length; i++){
            var ch = text.charCodeAt(i);
            if (isEOL(ch)) {
                if (ch === 13 /* CharCode.CarriageReturn */  && i + 1 < text.length && text.charCodeAt(i + 1) === 10 /* CharCode.LineFeed */ ) i++;
                result.push(textOffset + i + 1);
            }
        }
        return result;
    }
    function isEOL(char) {
        return char === 13 /* CharCode.CarriageReturn */  || char === 10 /* CharCode.LineFeed */ ;
    }
    function getWellformedRange(range) {
        var start = range.start;
        var end = range.end;
        if (start.line > end.line || start.line === end.line && start.character > end.character) return {
            start: end,
            end: start
        };
        return range;
    }
    function getWellformedEdit(textEdit) {
        var range = getWellformedRange(textEdit.range);
        if (range !== textEdit.range) return {
            newText: textEdit.newText,
            range: range
        };
        return textEdit;
    }
});





/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ var $3a1a3bfcc859a329$exports = {};
var $dd89472898af0f52$exports = {};
// shim for using process in browser
var $dd89472898af0f52$var$process = $dd89472898af0f52$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $dd89472898af0f52$var$cachedSetTimeout;
var $dd89472898af0f52$var$cachedClearTimeout;
function $dd89472898af0f52$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $dd89472898af0f52$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $dd89472898af0f52$var$cachedSetTimeout = setTimeout;
        else $dd89472898af0f52$var$cachedSetTimeout = $dd89472898af0f52$var$defaultSetTimout;
    } catch (e) {
        $dd89472898af0f52$var$cachedSetTimeout = $dd89472898af0f52$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $dd89472898af0f52$var$cachedClearTimeout = clearTimeout;
        else $dd89472898af0f52$var$cachedClearTimeout = $dd89472898af0f52$var$defaultClearTimeout;
    } catch (e) {
        $dd89472898af0f52$var$cachedClearTimeout = $dd89472898af0f52$var$defaultClearTimeout;
    }
})();
function $dd89472898af0f52$var$runTimeout(fun) {
    if ($dd89472898af0f52$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($dd89472898af0f52$var$cachedSetTimeout === $dd89472898af0f52$var$defaultSetTimout || !$dd89472898af0f52$var$cachedSetTimeout) && setTimeout) {
        $dd89472898af0f52$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd89472898af0f52$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $dd89472898af0f52$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $dd89472898af0f52$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $dd89472898af0f52$var$runClearTimeout(marker) {
    if ($dd89472898af0f52$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($dd89472898af0f52$var$cachedClearTimeout === $dd89472898af0f52$var$defaultClearTimeout || !$dd89472898af0f52$var$cachedClearTimeout) && clearTimeout) {
        $dd89472898af0f52$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $dd89472898af0f52$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $dd89472898af0f52$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $dd89472898af0f52$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $dd89472898af0f52$var$queue = [];
var $dd89472898af0f52$var$draining = false;
var $dd89472898af0f52$var$currentQueue;
var $dd89472898af0f52$var$queueIndex = -1;
function $dd89472898af0f52$var$cleanUpNextTick() {
    if (!$dd89472898af0f52$var$draining || !$dd89472898af0f52$var$currentQueue) return;
    $dd89472898af0f52$var$draining = false;
    if ($dd89472898af0f52$var$currentQueue.length) $dd89472898af0f52$var$queue = $dd89472898af0f52$var$currentQueue.concat($dd89472898af0f52$var$queue);
    else $dd89472898af0f52$var$queueIndex = -1;
    if ($dd89472898af0f52$var$queue.length) $dd89472898af0f52$var$drainQueue();
}
function $dd89472898af0f52$var$drainQueue() {
    if ($dd89472898af0f52$var$draining) return;
    var timeout = $dd89472898af0f52$var$runTimeout($dd89472898af0f52$var$cleanUpNextTick);
    $dd89472898af0f52$var$draining = true;
    var len = $dd89472898af0f52$var$queue.length;
    while(len){
        $dd89472898af0f52$var$currentQueue = $dd89472898af0f52$var$queue;
        $dd89472898af0f52$var$queue = [];
        while(++$dd89472898af0f52$var$queueIndex < len)if ($dd89472898af0f52$var$currentQueue) $dd89472898af0f52$var$currentQueue[$dd89472898af0f52$var$queueIndex].run();
        $dd89472898af0f52$var$queueIndex = -1;
        len = $dd89472898af0f52$var$queue.length;
    }
    $dd89472898af0f52$var$currentQueue = null;
    $dd89472898af0f52$var$draining = false;
    $dd89472898af0f52$var$runClearTimeout(timeout);
}
$dd89472898af0f52$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $dd89472898af0f52$var$queue.push(new $dd89472898af0f52$var$Item(fun, args));
    if ($dd89472898af0f52$var$queue.length === 1 && !$dd89472898af0f52$var$draining) $dd89472898af0f52$var$runTimeout($dd89472898af0f52$var$drainQueue);
};
// v8 likes predictible objects
function $dd89472898af0f52$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$dd89472898af0f52$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$dd89472898af0f52$var$process.title = 'browser';
$dd89472898af0f52$var$process.browser = true;
$dd89472898af0f52$var$process.env = {};
$dd89472898af0f52$var$process.argv = [];
$dd89472898af0f52$var$process.version = ''; // empty string to avoid regexp issues
$dd89472898af0f52$var$process.versions = {};
function $dd89472898af0f52$var$noop() {}
$dd89472898af0f52$var$process.on = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.addListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.once = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.off = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.removeListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.removeAllListeners = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.emit = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.prependListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.prependOnceListener = $dd89472898af0f52$var$noop;
$dd89472898af0f52$var$process.listeners = function(name) {
    return [];
};
$dd89472898af0f52$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$dd89472898af0f52$var$process.cwd = function() {
    return '/';
};
$dd89472898af0f52$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$dd89472898af0f52$var$process.umask = function() {
    return 0;
};


!function(t, e) {
    var r, n;
    $3a1a3bfcc859a329$exports = e();
}($3a1a3bfcc859a329$exports, ()=>(()=>{
        "use strict";
        var t = {
            975: (t)=>{
                function e(t) {
                    if ("string" != typeof t) throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
                }
                function r(t, e) {
                    for(var r, n = "", i = 0, o = -1, s = 0, a = 0; a <= t.length; ++a){
                        if (a < t.length) r = t.charCodeAt(a);
                        else {
                            if (47 === r) break;
                            r = 47;
                        }
                        if (47 === r) {
                            if (o === a - 1 || 1 === s) ;
                            else if (o !== a - 1 && 2 === s) {
                                if (n.length < 2 || 2 !== i || 46 !== n.charCodeAt(n.length - 1) || 46 !== n.charCodeAt(n.length - 2)) {
                                    if (n.length > 2) {
                                        var h = n.lastIndexOf("/");
                                        if (h !== n.length - 1) {
                                            -1 === h ? (n = "", i = 0) : i = (n = n.slice(0, h)).length - 1 - n.lastIndexOf("/"), o = a, s = 0;
                                            continue;
                                        }
                                    } else if (2 === n.length || 1 === n.length) {
                                        n = "", i = 0, o = a, s = 0;
                                        continue;
                                    }
                                }
                                e && (n.length > 0 ? n += "/.." : n = "..", i = 2);
                            } else n.length > 0 ? n += "/" + t.slice(o + 1, a) : n = t.slice(o + 1, a), i = a - o - 1;
                            o = a, s = 0;
                        } else 46 === r && -1 !== s ? ++s : s = -1;
                    }
                    return n;
                }
                var n = {
                    resolve: function() {
                        for(var t, n = "", i = !1, o = arguments.length - 1; o >= -1 && !i; o--){
                            var s;
                            o >= 0 ? s = arguments[o] : (void 0 === t && (t = $dd89472898af0f52$exports.cwd()), s = t), e(s), 0 !== s.length && (n = s + "/" + n, i = 47 === s.charCodeAt(0));
                        }
                        return n = r(n, !i), i ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
                    },
                    normalize: function(t) {
                        if (e(t), 0 === t.length) return ".";
                        var n = 47 === t.charCodeAt(0), i = 47 === t.charCodeAt(t.length - 1);
                        return 0 !== (t = r(t, !n)).length || n || (t = "."), t.length > 0 && i && (t += "/"), n ? "/" + t : t;
                    },
                    isAbsolute: function(t) {
                        return e(t), t.length > 0 && 47 === t.charCodeAt(0);
                    },
                    join: function() {
                        if (0 === arguments.length) return ".";
                        for(var t, r = 0; r < arguments.length; ++r){
                            var i = arguments[r];
                            e(i), i.length > 0 && (void 0 === t ? t = i : t += "/" + i);
                        }
                        return void 0 === t ? "." : n.normalize(t);
                    },
                    relative: function(t, r) {
                        if (e(t), e(r), t === r) return "";
                        if ((t = n.resolve(t)) === (r = n.resolve(r))) return "";
                        for(var i = 1; i < t.length && 47 === t.charCodeAt(i); ++i);
                        for(var o = t.length, s = o - i, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a);
                        for(var h = r.length - a, c = s < h ? s : h, f = -1, u = 0; u <= c; ++u){
                            if (u === c) {
                                if (h > c) {
                                    if (47 === r.charCodeAt(a + u)) return r.slice(a + u + 1);
                                    if (0 === u) return r.slice(a + u);
                                } else s > c && (47 === t.charCodeAt(i + u) ? f = u : 0 === u && (f = 0));
                                break;
                            }
                            var l = t.charCodeAt(i + u);
                            if (l !== r.charCodeAt(a + u)) break;
                            47 === l && (f = u);
                        }
                        var d = "";
                        for(u = i + f + 1; u <= o; ++u)u !== o && 47 !== t.charCodeAt(u) || (0 === d.length ? d += ".." : d += "/..");
                        return d.length > 0 ? d + r.slice(a + f) : (a += f, 47 === r.charCodeAt(a) && ++a, r.slice(a));
                    },
                    _makeLong: function(t) {
                        return t;
                    },
                    dirname: function(t) {
                        if (e(t), 0 === t.length) return ".";
                        for(var r = t.charCodeAt(0), n = 47 === r, i = -1, o = !0, s = t.length - 1; s >= 1; --s)if (47 === (r = t.charCodeAt(s))) {
                            if (!o) {
                                i = s;
                                break;
                            }
                        } else o = !1;
                        return -1 === i ? n ? "/" : "." : n && 1 === i ? "//" : t.slice(0, i);
                    },
                    basename: function(t, r) {
                        if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
                        e(t);
                        var n, i = 0, o = -1, s = !0;
                        if (void 0 !== r && r.length > 0 && r.length <= t.length) {
                            if (r.length === t.length && r === t) return "";
                            var a = r.length - 1, h = -1;
                            for(n = t.length - 1; n >= 0; --n){
                                var c = t.charCodeAt(n);
                                if (47 === c) {
                                    if (!s) {
                                        i = n + 1;
                                        break;
                                    }
                                } else -1 === h && (s = !1, h = n + 1), a >= 0 && (c === r.charCodeAt(a) ? -1 == --a && (o = n) : (a = -1, o = h));
                            }
                            return i === o ? o = h : -1 === o && (o = t.length), t.slice(i, o);
                        }
                        for(n = t.length - 1; n >= 0; --n)if (47 === t.charCodeAt(n)) {
                            if (!s) {
                                i = n + 1;
                                break;
                            }
                        } else -1 === o && (s = !1, o = n + 1);
                        return -1 === o ? "" : t.slice(i, o);
                    },
                    extname: function(t) {
                        e(t);
                        for(var r = -1, n = 0, i = -1, o = !0, s = 0, a = t.length - 1; a >= 0; --a){
                            var h = t.charCodeAt(a);
                            if (47 !== h) -1 === i && (o = !1, i = a + 1), 46 === h ? -1 === r ? r = a : 1 !== s && (s = 1) : -1 !== r && (s = -1);
                            else if (!o) {
                                n = a + 1;
                                break;
                            }
                        }
                        return -1 === r || -1 === i || 0 === s || 1 === s && r === i - 1 && r === n + 1 ? "" : t.slice(r, i);
                    },
                    format: function(t) {
                        if (null === t || "object" != typeof t) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
                        return function(t, e) {
                            var r = e.dir || e.root, n = e.base || (e.name || "") + (e.ext || "");
                            return r ? r === e.root ? r + n : r + "/" + n : n;
                        }(0, t);
                    },
                    parse: function(t) {
                        e(t);
                        var r = {
                            root: "",
                            dir: "",
                            base: "",
                            ext: "",
                            name: ""
                        };
                        if (0 === t.length) return r;
                        var n, i = t.charCodeAt(0), o = 47 === i;
                        o ? (r.root = "/", n = 1) : n = 0;
                        for(var s = -1, a = 0, h = -1, c = !0, f = t.length - 1, u = 0; f >= n; --f)if (47 !== (i = t.charCodeAt(f))) -1 === h && (c = !1, h = f + 1), 46 === i ? -1 === s ? s = f : 1 !== u && (u = 1) : -1 !== s && (u = -1);
                        else if (!c) {
                            a = f + 1;
                            break;
                        }
                        return -1 === s || -1 === h || 0 === u || 1 === u && s === h - 1 && s === a + 1 ? -1 !== h && (r.base = r.name = 0 === a && o ? t.slice(1, h) : t.slice(a, h)) : (0 === a && o ? (r.name = t.slice(1, s), r.base = t.slice(1, h)) : (r.name = t.slice(a, s), r.base = t.slice(a, h)), r.ext = t.slice(s, h)), a > 0 ? r.dir = t.slice(0, a - 1) : o && (r.dir = "/"), r;
                    },
                    sep: "/",
                    delimiter: ":",
                    win32: null,
                    posix: null
                };
                n.posix = n, t.exports = n;
            },
            70: (t, e)=>{
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.isWindows = void 0;
                if ("object" == typeof navigator) {
                    let t = navigator.userAgent;
                    e.isWindows = t.indexOf("Windows") >= 0;
                }
            },
            231: (t, e, r)=>{
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.uriToFsPath = e.URI = void 0;
                const n = r(70), i = /^\w[\w\d+.-]*$/, o = /^\//, s = /^\/\//;
                function a(t, e) {
                    if (!t.scheme && e) throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${t.authority}", path: "${t.path}", query: "${t.query}", fragment: "${t.fragment}"}`);
                    if (t.scheme && !i.test(t.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
                    if (t.path) {
                        if (t.authority) {
                            if (!o.test(t.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
                        } else if (s.test(t.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
                    }
                }
                const h = "", c = "/", f = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
                class u {
                    static isUri(t) {
                        return t instanceof u || !!t && "string" == typeof t.authority && "string" == typeof t.fragment && "string" == typeof t.path && "string" == typeof t.query && "string" == typeof t.scheme && "string" == typeof t.fsPath && "function" == typeof t.with && "function" == typeof t.toString;
                    }
                    scheme;
                    authority;
                    path;
                    query;
                    fragment;
                    constructor(t, e, r, n, i, o = !1){
                        "object" == typeof t ? (this.scheme = t.scheme || h, this.authority = t.authority || h, this.path = t.path || h, this.query = t.query || h, this.fragment = t.fragment || h) : (this.scheme = function(t, e) {
                            return t || e ? t : "file";
                        }(t, o), this.authority = e || h, this.path = function(t, e) {
                            switch(t){
                                case "https":
                                case "http":
                                case "file":
                                    e ? e[0] !== c && (e = c + e) : e = c;
                            }
                            return e;
                        }(this.scheme, r || h), this.query = n || h, this.fragment = i || h, a(this, o));
                    }
                    get fsPath() {
                        return v(this, !1);
                    }
                    with(t) {
                        if (!t) return this;
                        let { scheme: e, authority: r, path: n, query: i, fragment: o } = t;
                        return void 0 === e ? e = this.scheme : null === e && (e = h), void 0 === r ? r = this.authority : null === r && (r = h), void 0 === n ? n = this.path : null === n && (n = h), void 0 === i ? i = this.query : null === i && (i = h), void 0 === o ? o = this.fragment : null === o && (o = h), e === this.scheme && r === this.authority && n === this.path && i === this.query && o === this.fragment ? this : new d(e, r, n, i, o);
                    }
                    static parse(t, e = !1) {
                        const r = f.exec(t);
                        return r ? new d(r[2] || h, w(r[4] || h), w(r[5] || h), w(r[7] || h), w(r[9] || h), e) : new d(h, h, h, h, h);
                    }
                    static file(t) {
                        let e = h;
                        if (n.isWindows && (t = t.replace(/\\/g, c)), t[0] === c && t[1] === c) {
                            const r = t.indexOf(c, 2);
                            -1 === r ? (e = t.substring(2), t = c) : (e = t.substring(2, r), t = t.substring(r) || c);
                        }
                        return new d("file", e, t, h, h);
                    }
                    static from(t) {
                        const e = new d(t.scheme, t.authority, t.path, t.query, t.fragment);
                        return a(e, !0), e;
                    }
                    toString(t = !1) {
                        return y(this, t);
                    }
                    toJSON() {
                        return this;
                    }
                    static revive(t) {
                        if (t) {
                            if (t instanceof u) return t;
                            {
                                const e = new d(t);
                                return e._formatted = t.external, e._fsPath = t._sep === l ? t.fsPath : null, e;
                            }
                        }
                        return t;
                    }
                }
                e.URI = u;
                const l = n.isWindows ? 1 : void 0;
                class d extends u {
                    _formatted = null;
                    _fsPath = null;
                    get fsPath() {
                        return this._fsPath || (this._fsPath = v(this, !1)), this._fsPath;
                    }
                    toString(t = !1) {
                        return t ? y(this, !0) : (this._formatted || (this._formatted = y(this, !1)), this._formatted);
                    }
                    toJSON() {
                        const t = {
                            $mid: 1
                        };
                        return this._fsPath && (t.fsPath = this._fsPath, t._sep = l), this._formatted && (t.external = this._formatted), this.path && (t.path = this.path), this.scheme && (t.scheme = this.scheme), this.authority && (t.authority = this.authority), this.query && (t.query = this.query), this.fragment && (t.fragment = this.fragment), t;
                    }
                }
                const p = {
                    58: "%3A",
                    47: "%2F",
                    63: "%3F",
                    35: "%23",
                    91: "%5B",
                    93: "%5D",
                    64: "%40",
                    33: "%21",
                    36: "%24",
                    38: "%26",
                    39: "%27",
                    40: "%28",
                    41: "%29",
                    42: "%2A",
                    43: "%2B",
                    44: "%2C",
                    59: "%3B",
                    61: "%3D",
                    32: "%20"
                };
                function g(t, e, r) {
                    let n, i = -1;
                    for(let o = 0; o < t.length; o++){
                        const s = t.charCodeAt(o);
                        if (s >= 97 && s <= 122 || s >= 65 && s <= 90 || s >= 48 && s <= 57 || 45 === s || 46 === s || 95 === s || 126 === s || e && 47 === s || r && 91 === s || r && 93 === s || r && 58 === s) -1 !== i && (n += encodeURIComponent(t.substring(i, o)), i = -1), void 0 !== n && (n += t.charAt(o));
                        else {
                            void 0 === n && (n = t.substr(0, o));
                            const e = p[s];
                            void 0 !== e ? (-1 !== i && (n += encodeURIComponent(t.substring(i, o)), i = -1), n += e) : -1 === i && (i = o);
                        }
                    }
                    return -1 !== i && (n += encodeURIComponent(t.substring(i))), void 0 !== n ? n : t;
                }
                function m(t) {
                    let e;
                    for(let r = 0; r < t.length; r++){
                        const n = t.charCodeAt(r);
                        35 === n || 63 === n ? (void 0 === e && (e = t.substr(0, r)), e += p[n]) : void 0 !== e && (e += t[r]);
                    }
                    return void 0 !== e ? e : t;
                }
                function v(t, e) {
                    let r;
                    return r = t.authority && t.path.length > 1 && "file" === t.scheme ? `//${t.authority}${t.path}` : 47 === t.path.charCodeAt(0) && (t.path.charCodeAt(1) >= 65 && t.path.charCodeAt(1) <= 90 || t.path.charCodeAt(1) >= 97 && t.path.charCodeAt(1) <= 122) && 58 === t.path.charCodeAt(2) ? e ? t.path.substr(1) : t.path[1].toLowerCase() + t.path.substr(2) : t.path, n.isWindows && (r = r.replace(/\//g, "\\")), r;
                }
                function y(t, e) {
                    const r = e ? m : g;
                    let n = "", { scheme: i, authority: o, path: s, query: a, fragment: h } = t;
                    if (i && (n += i, n += ":"), (o || "file" === i) && (n += c, n += c), o) {
                        let t = o.indexOf("@");
                        if (-1 !== t) {
                            const e = o.substr(0, t);
                            o = o.substr(t + 1), t = e.lastIndexOf(":"), -1 === t ? n += r(e, !1, !1) : (n += r(e.substr(0, t), !1, !1), n += ":", n += r(e.substr(t + 1), !1, !0)), n += "@";
                        }
                        o = o.toLowerCase(), t = o.lastIndexOf(":"), -1 === t ? n += r(o, !1, !0) : (n += r(o.substr(0, t), !1, !0), n += o.substr(t));
                    }
                    if (s) {
                        if (s.length >= 3 && 47 === s.charCodeAt(0) && 58 === s.charCodeAt(2)) {
                            const t = s.charCodeAt(1);
                            t >= 65 && t <= 90 && (s = `/${String.fromCharCode(t + 32)}:${s.substr(3)}`);
                        } else if (s.length >= 2 && 58 === s.charCodeAt(1)) {
                            const t = s.charCodeAt(0);
                            t >= 65 && t <= 90 && (s = `${String.fromCharCode(t + 32)}:${s.substr(2)}`);
                        }
                        n += r(s, !0, !1);
                    }
                    return a && (n += "?", n += r(a, !1, !1)), h && (n += "#", n += e ? h : g(h, !1, !1)), n;
                }
                function b(t) {
                    try {
                        return decodeURIComponent(t);
                    } catch  {
                        return t.length > 3 ? t.substr(0, 3) + b(t.substr(3)) : t;
                    }
                }
                e.uriToFsPath = v;
                const C = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
                function w(t) {
                    return t.match(C) ? t.replace(C, (t)=>b(t)) : t;
                }
            },
            552: function(t, e, r) {
                var n = this && this.__createBinding || (Object.create ? function(t, e, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(e, r);
                    i && !("get" in i ? !e.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return e[r];
                        }
                    }), Object.defineProperty(t, n, i);
                } : function(t, e, r, n) {
                    void 0 === n && (n = r), t[n] = e[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(t, e) {
                    Object.defineProperty(t, "default", {
                        enumerable: !0,
                        value: e
                    });
                } : function(t, e) {
                    t.default = e;
                }), o = this && this.__importStar || function(t) {
                    if (t && t.__esModule) return t;
                    var e = {};
                    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
                    return i(e, t), e;
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Utils = void 0;
                const s = o(r(975)), a = s.posix || s, h = "/";
                var c;
                !function(t) {
                    t.joinPath = function(t, ...e) {
                        return t.with({
                            path: a.join(t.path, ...e)
                        });
                    }, t.resolvePath = function(t, ...e) {
                        let r = t.path, n = !1;
                        r[0] !== h && (r = h + r, n = !0);
                        let i = a.resolve(r, ...e);
                        return n && i[0] === h && !t.authority && (i = i.substring(1)), t.with({
                            path: i
                        });
                    }, t.dirname = function(t) {
                        if (0 === t.path.length || t.path === h) return t;
                        let e = a.dirname(t.path);
                        return 1 === e.length && 46 === e.charCodeAt(0) && (e = ""), t.with({
                            path: e
                        });
                    }, t.basename = function(t) {
                        return a.basename(t.path);
                    }, t.extname = function(t) {
                        return a.extname(t.path);
                    };
                }(c || (e.Utils = c = {}));
            }
        }, e = {};
        function r(n) {
            var i = e[n];
            if (void 0 !== i) return i.exports;
            var o = e[n] = {
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.exports;
        }
        var n = {};
        return (()=>{
            var t = n;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Utils = t.URI = void 0;
            const e = r(231);
            Object.defineProperty(t, "URI", {
                enumerable: !0,
                get: function() {
                    return e.URI;
                }
            });
            const i = r(552);
            Object.defineProperty(t, "Utils", {
                enumerable: !0,
                get: function() {
                    return i.Utils;
                }
            });
        })(), n;
    })());


var $c3a2ae12d89e8820$export$c96870febfa75a76;
(function(UriUtils) {
    UriUtils.basename = (0, $3a1a3bfcc859a329$exports.Utils).basename;
    UriUtils.dirname = (0, $3a1a3bfcc859a329$exports.Utils).dirname;
    UriUtils.extname = (0, $3a1a3bfcc859a329$exports.Utils).extname;
    UriUtils.joinPath = (0, $3a1a3bfcc859a329$exports.Utils).joinPath;
    UriUtils.resolvePath = (0, $3a1a3bfcc859a329$exports.Utils).resolvePath;
    const isWindows = false;
    function equals(a, b) {
        return a?.toString() === b?.toString();
    }
    UriUtils.equals = equals;
    function relative(from, to) {
        const fromPath = typeof from === 'string' ? (0, $3a1a3bfcc859a329$exports.URI).parse(from).path : from.path;
        const toPath = typeof to === 'string' ? (0, $3a1a3bfcc859a329$exports.URI).parse(to).path : to.path;
        const fromParts = fromPath.split('/').filter((e)=>e.length > 0);
        const toParts = toPath.split('/').filter((e)=>e.length > 0);
        if (isWindows) {
            const upperCaseDriveLetter = /^[A-Z]:$/;
            if (fromParts[0] && upperCaseDriveLetter.test(fromParts[0])) fromParts[0] = fromParts[0].toLowerCase();
            if (toParts[0] && upperCaseDriveLetter.test(toParts[0])) toParts[0] = toParts[0].toLowerCase();
            if (fromParts[0] !== toParts[0]) // in case of different drive letters, we cannot compute a relative path, so...
            return toPath.substring(1); // fall back to full 'to' path, drop the leading '/', keep everything else as is for good comparability
        }
        let i = 0;
        for(; i < fromParts.length; i++){
            if (fromParts[i] !== toParts[i]) break;
        }
        const backPart = '../'.repeat(fromParts.length - i);
        const toPart = toParts.slice(i).join('/');
        return backPart + toPart;
    }
    UriUtils.relative = relative;
    function normalize(uri) {
        return (0, $3a1a3bfcc859a329$exports.URI).parse(uri.toString()).toString();
    }
    UriUtils.normalize = normalize;
    function contains(parent, child) {
        const parentUri = typeof parent === 'string' ? (0, $3a1a3bfcc859a329$exports.URI).parse(parent) : parent;
        const childUri = typeof child === 'string' ? (0, $3a1a3bfcc859a329$exports.URI).parse(child) : child;
        if (parentUri.scheme !== childUri.scheme) return false;
        let parentPath = parentUri.path;
        let childPath = childUri.path;
        // Trim trailing slashes
        if (childPath.charAt(childPath.length - 1) === '/') childPath = childPath.slice(0, -1);
        if (parentPath.charAt(parentPath.length - 1) === '/') parentPath = parentPath.slice(0, -1);
        // If the paths are equal, simply return true
        if (childPath === parentPath) return true;
        // If the child path is shorter than the parent path, it can't be a child
        if (childPath.length < parentPath.length) return false;
        // If the path does not feature a slash after the parent path, it can't be a child
        if (childPath.charAt(parentPath.length) !== '/') return false;
        // Check if the child path starts with the parent path
        return childPath.startsWith(parentPath);
    }
    UriUtils.contains = contains;
})($c3a2ae12d89e8820$export$c96870febfa75a76 || ($c3a2ae12d89e8820$export$c96870febfa75a76 = {}));
class $c3a2ae12d89e8820$export$15c702c6c325293f {
    constructor(){
        this.root = {
            name: '',
            children: new Map()
        };
    }
    normalizeUri(uri) {
        return $c3a2ae12d89e8820$export$c96870febfa75a76.normalize(uri);
    }
    clear() {
        this.root.children.clear();
    }
    insert(uri, element) {
        const node = this.getNode(this.normalizeUri(uri), true);
        node.element = element;
    }
    delete(uri) {
        const nodeToDelete = this.getNode(this.normalizeUri(uri), false);
        if (nodeToDelete?.parent) nodeToDelete.parent.children.delete(nodeToDelete.name);
    }
    has(uri) {
        return this.getNode(this.normalizeUri(uri), false)?.element !== undefined;
    }
    hasNode(uri) {
        return this.getNode(this.normalizeUri(uri), false) !== undefined;
    }
    find(uri) {
        return this.getNode(this.normalizeUri(uri), false)?.element;
    }
    findNode(uri) {
        const uriString = this.normalizeUri(uri);
        const node = this.getNode(uriString, false);
        if (!node) return undefined;
        return {
            name: node.name,
            uri: $c3a2ae12d89e8820$export$c96870febfa75a76.joinPath((0, $3a1a3bfcc859a329$exports.URI).parse(uriString), node.name).toString(),
            element: node.element
        };
    }
    findChildren(uri) {
        const uriString = this.normalizeUri(uri);
        const node = this.getNode(uriString, false);
        if (!node) return [];
        return Array.from(node.children.values()).map((child)=>({
                name: child.name,
                uri: $c3a2ae12d89e8820$export$c96870febfa75a76.joinPath((0, $3a1a3bfcc859a329$exports.URI).parse(uriString), child.name).toString(),
                element: child.element
            }));
    }
    all() {
        return this.collectValues(this.root);
    }
    findAll(prefix) {
        const node = this.getNode(this.normalizeUri(prefix), false);
        if (!node) return [];
        return this.collectValues(node);
    }
    getNode(uri, create) {
        const parts = uri.split('/');
        if (uri.charAt(uri.length - 1) === '/') // Remove the last part if the URI ends with a slash
        parts.pop();
        let current = this.root;
        for (const part of parts){
            let child = current.children.get(part);
            if (!child) {
                if (create) {
                    child = {
                        name: part,
                        children: new Map(),
                        parent: current
                    };
                    current.children.set(part, child);
                } else return undefined;
            }
            current = child;
        }
        return current;
    }
    collectValues(node) {
        const result = [];
        if (node.element) result.push(node.element);
        for (const child of node.children.values())result.push(...this.collectValues(child));
        return result;
    }
}


var $4ec1768ef727cb18$export$4c6f7616f18c0be;
(function(DocumentState) {
    /**
     * The text content has changed and needs to be parsed again. The AST held by this outdated
     * document instance is no longer valid.
     */ DocumentState[DocumentState["Changed"] = 0] = "Changed";
    /**
     * An AST has been created from the text content. The document structure can be traversed,
     * but cross-references cannot be resolved yet. If necessary, the structure can be manipulated
     * at this stage as a preprocessing step.
     */ DocumentState[DocumentState["Parsed"] = 1] = "Parsed";
    /**
     * The `IndexManager` service has processed AST nodes of this document. This means the
     * exported symbols are available in the global scope and can be resolved from other documents.
     */ DocumentState[DocumentState["IndexedContent"] = 2] = "IndexedContent";
    /**
     * The `ScopeComputation` service has processed this document. This means the document's locally accessible
     * symbols are captured in a `DocumentSymbols` table and can be looked up by the `ScopeProvider` service.
     * Once a document has reached this state, you may follow every reference - it will lazily
     * resolve its `ref` property and yield either the target AST node or `undefined` in case
     * the target is not in scope.
     */ DocumentState[DocumentState["ComputedScopes"] = 3] = "ComputedScopes";
    /**
     * The `Linker` service has processed this document. All outgoing references have been
     * resolved or marked as erroneous.
     */ DocumentState[DocumentState["Linked"] = 4] = "Linked";
    /**
     * The `IndexManager` service has processed AST node references of this document. This is
     * necessary to determine which documents are affected by a change in one of the workspace
     * documents.
     */ DocumentState[DocumentState["IndexedReferences"] = 5] = "IndexedReferences";
    /**
     * The `DocumentValidator` service has processed this document. The language server listens
     * to the results of this phase and sends diagnostics to the client.
     */ DocumentState[DocumentState["Validated"] = 6] = "Validated";
})($4ec1768ef727cb18$export$4c6f7616f18c0be || ($4ec1768ef727cb18$export$4c6f7616f18c0be = {}));
class $4ec1768ef727cb18$export$8e75912b72ec32a3 {
    constructor(services){
        this.serviceRegistry = services.ServiceRegistry;
        this.textDocuments = services.workspace.TextDocuments;
        this.fileSystemProvider = services.workspace.FileSystemProvider;
    }
    async fromUri(uri, cancellationToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const content = await this.getInitialText(uri, cancellationToken);
        return this.createAsync(uri, content, cancellationToken);
    }
    async getInitialText(uri, _cancellationToken) {
        return this.fileSystemProvider.readFile(uri);
    }
    fromTextDocument(textDocument, uri, token) {
        uri = uri ?? (0, $3a1a3bfcc859a329$exports.URI).parse(textDocument.uri);
        if ((0, $284dfc6cfc7f5287$exports.CancellationToken).is(token)) return this.createAsync(uri, textDocument, token);
        else return this.create(uri, textDocument, token);
    }
    fromString(text, uri, token) {
        if ((0, $284dfc6cfc7f5287$exports.CancellationToken).is(token)) return this.createAsync(uri, text, token);
        else return this.create(uri, text, token);
    }
    fromModel(model, uri) {
        return this.create(uri, {
            $model: model
        });
    }
    create(uri, content, options) {
        if (typeof content === 'string') {
            const parseResult = this.parse(uri, content, options);
            return this.createLangiumDocument(parseResult, uri, undefined, content);
        } else if ('$model' in content) {
            const parseResult = {
                value: content.$model,
                parserErrors: [],
                lexerErrors: []
            };
            return this.createLangiumDocument(parseResult, uri);
        } else {
            const parseResult = this.parse(uri, content.getText(), options);
            return this.createLangiumDocument(parseResult, uri, content);
        }
    }
    async createAsync(uri, content, cancelToken) {
        if (typeof content === 'string') {
            const parseResult = await this.parseAsync(uri, content, cancelToken);
            return this.createLangiumDocument(parseResult, uri, undefined, content);
        } else {
            const parseResult = await this.parseAsync(uri, content.getText(), cancelToken);
            return this.createLangiumDocument(parseResult, uri, content);
        }
    }
    /**
     * Create a LangiumDocument from a given parse result.
     *
     * A TextDocument is created on demand if it is not provided as argument here. Usually this
     * should not be necessary because the main purpose of the TextDocument is to convert between
     * text ranges and offsets, which is done solely in LSP request handling.
     *
     * With the introduction of {@link update} below this method is supposed to be mainly called
     * during workspace initialization and on addition/recognition of new files, while changes in
     * existing documents are processed via {@link update}.
     */ createLangiumDocument(parseResult, uri, textDocument, text) {
        let document;
        if (textDocument) document = {
            parseResult: parseResult,
            uri: uri,
            state: $4ec1768ef727cb18$export$4c6f7616f18c0be.Parsed,
            references: [],
            textDocument: textDocument
        };
        else {
            const textDocumentGetter = this.createTextDocumentGetter(uri, text);
            document = {
                parseResult: parseResult,
                uri: uri,
                state: $4ec1768ef727cb18$export$4c6f7616f18c0be.Parsed,
                references: [],
                get textDocument () {
                    return textDocumentGetter();
                }
            };
        }
        parseResult.value.$document = document;
        return document;
    }
    async update(document, cancellationToken) {
        // The CST full text property contains the original text that was used to create the AST.
        const oldText = document.parseResult.value.$cstNode?.root.fullText;
        const textDocument = this.textDocuments?.get(document.uri.toString());
        const text = await this.getUpdatedText(document, textDocument, cancellationToken);
        if (textDocument) Object.defineProperty(document, 'textDocument', {
            value: textDocument
        });
        else {
            const textDocumentGetter = this.createTextDocumentGetter(document.uri, text);
            Object.defineProperty(document, 'textDocument', {
                get: textDocumentGetter
            });
        }
        // Some of these documents can be pretty large, so parsing them again can be quite expensive.
        // Therefore, we only parse if the text has actually changed.
        if (oldText !== text) {
            document.parseResult = await this.parseAsync(document.uri, text, cancellationToken);
            document.parseResult.value.$document = document;
        }
        document.state = $4ec1768ef727cb18$export$4c6f7616f18c0be.Parsed;
        return document;
    }
    async getUpdatedText(document, textDocument, _cancellationToken) {
        return textDocument ? textDocument.getText() : await this.fileSystemProvider.readFile(document.uri);
    }
    parse(uri, text, options) {
        const services = this.serviceRegistry.getServices(uri);
        return services.parser.LangiumParser.parse(text, options);
    }
    parseAsync(uri, text, cancellationToken) {
        const services = this.serviceRegistry.getServices(uri);
        return services.parser.AsyncParser.parse(text, cancellationToken);
    }
    createTextDocumentGetter(uri, text) {
        const serviceRegistry = this.serviceRegistry;
        let textDoc = undefined;
        return ()=>{
            return textDoc ?? (textDoc = (0, $b10a49ae6010afc9$exports.TextDocument).create(uri.toString(), serviceRegistry.getServices(uri).LanguageMetaData.languageId, 0, text ?? ''));
        };
    }
}
class $4ec1768ef727cb18$export$33b27a5eb36b3f5e {
    constructor(services){
        this.documentTrie = new (0, $c3a2ae12d89e8820$export$15c702c6c325293f)();
        this.services = services;
        this.langiumDocumentFactory = services.workspace.LangiumDocumentFactory;
        this.documentBuilder = ()=>services.workspace.DocumentBuilder;
    }
    get all() {
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(this.documentTrie.all());
    }
    addDocument(document) {
        const uriString = document.uri.toString();
        if (this.documentTrie.has(uriString)) throw new Error(`A document with the URI '${uriString}' is already present.`);
        this.documentTrie.insert(uriString, document);
    }
    getDocument(uri) {
        const uriString = uri.toString();
        return this.documentTrie.find(uriString);
    }
    getDocuments(folder) {
        const uriString = folder.toString();
        return this.documentTrie.findAll(uriString);
    }
    async getOrCreateDocument(uri, cancellationToken) {
        let document = this.getDocument(uri);
        if (document) return document;
        document = await this.langiumDocumentFactory.fromUri(uri, cancellationToken);
        this.addDocument(document);
        return document;
    }
    createDocument(uri, text, cancellationToken) {
        if (cancellationToken) return this.langiumDocumentFactory.fromString(text, uri, cancellationToken).then((document)=>{
            this.addDocument(document);
            return document;
        });
        else {
            const document = this.langiumDocumentFactory.fromString(text, uri);
            this.addDocument(document);
            return document;
        }
    }
    hasDocument(uri) {
        return this.documentTrie.has(uri.toString());
    }
    /**
     * @deprecated Since 4.2 use `DocumentBuilder.resetToState(DocumentState.Changed)` instead
     * TODO remove this for the next major release
     */ invalidateDocument(uri) {
        const uriString = uri.toString();
        const langiumDoc = this.documentTrie.find(uriString);
        if (langiumDoc) this.documentBuilder().resetToState(langiumDoc, $4ec1768ef727cb18$export$4c6f7616f18c0be.Changed);
        return langiumDoc;
    }
    deleteDocument(uri) {
        const uriString = uri.toString();
        const langiumDoc = this.documentTrie.find(uriString);
        if (langiumDoc) {
            langiumDoc.state = $4ec1768ef727cb18$export$4c6f7616f18c0be.Changed;
            this.documentTrie.delete(uriString);
        }
        return langiumDoc;
    }
    deleteDocuments(folder) {
        const uriString = folder.toString();
        const langiumDocs = this.documentTrie.findAll(uriString);
        for (const langiumDoc of langiumDocs)langiumDoc.state = $4ec1768ef727cb18$export$4c6f7616f18c0be.Changed;
        this.documentTrie.delete(uriString);
        return langiumDocs;
    }
}


const $42c9a3b317638daf$export$91dd235c6a0b346d = Symbol('RefResolving');
class $42c9a3b317638daf$var$DefaultReferenceImpl {
    constructor(resolver, node, property, refNode, refText){
        this.resolver = resolver;
        this.node = node;
        this.property = property;
        this._ref = undefined;
        this.$refNode = refNode;
        this.$refText = refText;
    }
    get ref() {
        return this.resolver.resolveReference(this, this.node, this.property);
    }
    get $nodeDescription() {
        return this._nodeDescription;
    }
    get error() {
        return (0, $09c22474b334b427$export$6693381b2423862d)(this._ref) ? this._ref : undefined;
    }
}
class $42c9a3b317638daf$var$DefaultMultiReferenceImpl {
    constructor(resolver, node, property, refNode, refText){
        this.resolver = resolver;
        this.node = node;
        this.property = property;
        this._items = undefined;
        this.$refNode = refNode;
        this.$refText = refText;
    }
    get items() {
        return this.resolver.resolveMultiReference(this, this.node, this.property);
    }
    get error() {
        return this._linkingError;
    }
}
class $42c9a3b317638daf$export$4467b657ef20e7b9 {
    constructor(services){
        this.reflection = services.shared.AstReflection;
        this.langiumDocuments = ()=>services.shared.workspace.LangiumDocuments;
        this.scopeProvider = services.references.ScopeProvider;
        this.astNodeLocator = services.workspace.AstNodeLocator;
        this.profiler = services.shared.profilers.LangiumProfiler;
        this.languageId = services.LanguageMetaData.languageId;
        this.referenceResolver = {
            resolveReference: this.resolveReference.bind(this),
            resolveMultiReference: this.resolveMultiReference.bind(this)
        };
    }
    async link(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        if (this.profiler?.isActive('linking')) {
            const task = this.profiler.createTask('linking', this.languageId);
            task.start();
            try {
                for (const node of (0, $de130ae470c6cbfb$export$b7350f614170899e)(document.parseResult.value)){
                    await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
                    (0, $de130ae470c6cbfb$export$a724fcaa837c6cb2)(node).forEach((ref)=>{
                        const name = `${node.$type}:${ref.property}`;
                        task.startSubTask(name);
                        try {
                            this.doLink(ref, document);
                        } finally{
                            task.stopSubTask(name);
                        }
                    });
                }
            } finally{
                task.stop();
            }
        } else for (const node of (0, $de130ae470c6cbfb$export$b7350f614170899e)(document.parseResult.value)){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            (0, $de130ae470c6cbfb$export$a724fcaa837c6cb2)(node).forEach((ref)=>this.doLink(ref, document));
        }
    }
    doLink(refInfo, document) {
        const ref = refInfo.reference;
        // The reference may already have been resolved lazily by accessing its `ref` property.
        if ('_ref' in ref && ref._ref === undefined) {
            ref._ref = $42c9a3b317638daf$export$91dd235c6a0b346d;
            try {
                const description = this.getCandidate(refInfo);
                if ((0, $09c22474b334b427$export$6693381b2423862d)(description)) ref._ref = description;
                else {
                    ref._nodeDescription = description;
                    const linkedNode = this.loadAstNode(description);
                    ref._ref = linkedNode ?? this.createLinkingError(refInfo, description);
                }
            } catch (err) {
                console.error(`An error occurred while resolving reference to '${ref.$refText}':`, err);
                const errorMessage = err.message ?? String(err);
                ref._ref = {
                    info: refInfo,
                    message: `An error occurred while resolving reference to '${ref.$refText}': ${errorMessage}`
                };
            }
            document.references.push(ref);
        } else if ('_items' in ref && ref._items === undefined) {
            ref._items = $42c9a3b317638daf$export$91dd235c6a0b346d;
            try {
                const descriptions = this.getCandidates(refInfo);
                const items = [];
                if ((0, $09c22474b334b427$export$6693381b2423862d)(descriptions)) ref._linkingError = descriptions;
                else for (const description of descriptions){
                    const linkedNode = this.loadAstNode(description);
                    if (linkedNode) items.push({
                        ref: linkedNode,
                        $nodeDescription: description
                    });
                }
                ref._items = items;
            } catch (err) {
                ref._linkingError = {
                    info: refInfo,
                    message: `An error occurred while resolving reference to '${ref.$refText}': ${err}`
                };
                ref._items = [];
            }
            document.references.push(ref);
        }
    }
    unlink(document) {
        for (const ref of document.references){
            if ('_ref' in ref) {
                ref._ref = undefined;
                delete ref._nodeDescription;
            } else if ('_items' in ref) {
                ref._items = undefined;
                delete ref._linkingError;
            }
        }
        document.references = [];
    }
    getCandidate(refInfo) {
        const scope = this.scopeProvider.getScope(refInfo);
        const description = scope.getElement(refInfo.reference.$refText);
        return description ?? this.createLinkingError(refInfo);
    }
    getCandidates(refInfo) {
        const scope = this.scopeProvider.getScope(refInfo);
        const descriptions = scope.getElements(refInfo.reference.$refText).distinct((desc)=>`${desc.documentUri}#${desc.path}`).toArray();
        return descriptions.length > 0 ? descriptions : this.createLinkingError(refInfo);
    }
    buildReference(node, property, refNode, refText) {
        // See behavior description in doc of Linker, update that on changes in here.
        return new $42c9a3b317638daf$var$DefaultReferenceImpl(this.referenceResolver, node, property, refNode, refText);
    }
    buildMultiReference(node, property, refNode, refText) {
        // See behavior description in doc of Linker, update that on changes in here.
        return new $42c9a3b317638daf$var$DefaultMultiReferenceImpl(this.referenceResolver, node, property, refNode, refText);
    }
    resolveReference(reference, node, property) {
        if ((0, $09c22474b334b427$export$dd586f2688797f92)(reference._ref)) // Most frequent case: the target is already resolved.
        return reference._ref;
        else if ((0, $09c22474b334b427$export$ad0854b800d930a4)(reference._nodeDescription)) {
            // A candidate has been found before, but it is not loaded yet.
            const linkedNode = this.loadAstNode(reference._nodeDescription);
            reference._ref = linkedNode ?? this.createLinkingError({
                reference: reference,
                container: node,
                property: property
            }, reference._nodeDescription);
        } else if (reference._ref === undefined) {
            // The reference has not been linked yet, so do that now.
            reference._ref = $42c9a3b317638daf$export$91dd235c6a0b346d;
            const document = (0, $de130ae470c6cbfb$export$4c67bdbd93d70745)(node).$document;
            const refData = this.getLinkedNode({
                reference: reference,
                container: node,
                property: property
            });
            if (refData.error && document && document.state < (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).ComputedScopes) // Document scope is not ready, don't set `reference._ref` so linker can retry later.
            return reference._ref = undefined;
            reference._ref = refData.node ?? refData.error;
            reference._nodeDescription = refData.descr;
            document?.references.push(reference);
        } else if (reference._ref === $42c9a3b317638daf$export$91dd235c6a0b346d) this.throwCyclicReferenceError(node, property, reference.$refText);
        return (0, $09c22474b334b427$export$dd586f2688797f92)(reference._ref) ? reference._ref : undefined;
    }
    resolveMultiReference(reference, node, property) {
        if (Array.isArray(reference._items)) return reference._items;
        else if (reference._items === undefined) {
            reference._items = $42c9a3b317638daf$export$91dd235c6a0b346d;
            const document = (0, $de130ae470c6cbfb$export$4c67bdbd93d70745)(node).$document;
            const descriptions = this.getCandidates({
                reference: reference,
                container: node,
                property: property
            });
            const items = [];
            if ((0, $09c22474b334b427$export$6693381b2423862d)(descriptions)) reference._linkingError = descriptions;
            else {
                for (const description of descriptions){
                    const linkedNode = this.loadAstNode(description);
                    if (linkedNode) items.push({
                        ref: linkedNode,
                        $nodeDescription: description
                    });
                }
                if (items.length === 0) reference._linkingError = this.createLinkingError({
                    reference: reference,
                    container: node,
                    property: property
                });
            }
            reference._items = items;
            document?.references.push(reference);
        } else if (reference._items === $42c9a3b317638daf$export$91dd235c6a0b346d) this.throwCyclicReferenceError(node, property, reference.$refText);
        return Array.isArray(reference._items) ? reference._items : [];
    }
    throwCyclicReferenceError(node, property, refText) {
        throw new Error(`Cyclic reference resolution detected: ${this.astNodeLocator.getAstNodePath(node)}/${property} (symbol '${refText}')`);
    }
    getLinkedNode(refInfo) {
        try {
            const description = this.getCandidate(refInfo);
            if ((0, $09c22474b334b427$export$6693381b2423862d)(description)) return {
                error: description
            };
            const linkedNode = this.loadAstNode(description);
            if (linkedNode) return {
                node: linkedNode,
                descr: description
            };
            else return {
                descr: description,
                error: this.createLinkingError(refInfo, description)
            };
        } catch (err) {
            console.error(`An error occurred while resolving reference to '${refInfo.reference.$refText}':`, err);
            const errorMessage = err.message ?? String(err);
            return {
                error: {
                    info: refInfo,
                    message: `An error occurred while resolving reference to '${refInfo.reference.$refText}': ${errorMessage}`
                }
            };
        }
    }
    loadAstNode(nodeDescription) {
        if (nodeDescription.node) return nodeDescription.node;
        const doc = this.langiumDocuments().getDocument(nodeDescription.documentUri);
        if (!doc) return undefined;
        return this.astNodeLocator.getAstNode(doc.parseResult.value, nodeDescription.path);
    }
    createLinkingError(refInfo, targetDescription) {
        // Check whether the document is sufficiently processed by the DocumentBuilder. If not, this is a hint for a bug
        // in the language implementation.
        const document = (0, $de130ae470c6cbfb$export$4c67bdbd93d70745)(refInfo.container).$document;
        if (document && document.state < (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).ComputedScopes) console.warn(`Attempted reference resolution before document reached ComputedScopes state (${document.uri}).`);
        const referenceType = this.reflection.getReferenceType(refInfo);
        return {
            info: refInfo,
            message: `Could not resolve reference to ${referenceType} named '${refInfo.reference.$refText}'.`,
            targetDescription: targetDescription
        };
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
function $8868c78697bc048f$export$745137f0b0c9a0b3(node) {
    return typeof node.name === 'string';
}
class $8868c78697bc048f$export$d89d3fb260d53b12 {
    getName(node) {
        if ($8868c78697bc048f$export$745137f0b0c9a0b3(node)) return node.name;
        return undefined;
    }
    getNameNode(node) {
        return (0, $624e994b941222bd$export$cb1742ae4f1e059d)(node.$cstNode, 'name');
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 






class $a03c43c8ab5ae2e3$export$3be536c561c2c1d7 {
    constructor(services){
        this.nameProvider = services.references.NameProvider;
        this.index = services.shared.workspace.IndexManager;
        this.nodeLocator = services.workspace.AstNodeLocator;
        this.documents = services.shared.workspace.LangiumDocuments;
        this.hasMultiReference = (0, $de130ae470c6cbfb$export$b7350f614170899e)(services.Grammar).some((node)=>(0, $c70992891bcf3a02$export$ca91f6306d3bb0f4)(node) && node.isMulti);
    }
    findDeclarations(sourceCstNode) {
        if (sourceCstNode) {
            const assignment = (0, $624e994b941222bd$export$6e669a85c4c7eab7)(sourceCstNode);
            const nodeElem = sourceCstNode.astNode;
            if (assignment && nodeElem) {
                const reference = nodeElem[assignment.feature];
                if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(reference) || (0, $09c22474b334b427$export$c99833078476c909)(reference)) return (0, $de130ae470c6cbfb$export$d2e690f644aa0441)(reference);
                else if (Array.isArray(reference)) for (const ref of reference){
                    if (((0, $09c22474b334b427$export$fa99cac1c0883c47)(ref) || (0, $09c22474b334b427$export$c99833078476c909)(ref)) && ref.$refNode && ref.$refNode.offset <= sourceCstNode.offset && ref.$refNode.end >= sourceCstNode.end) return (0, $de130ae470c6cbfb$export$d2e690f644aa0441)(ref);
                }
            }
            if (nodeElem) {
                const nameNode = this.nameProvider.getNameNode(nodeElem);
                // Only return the targeted node in case the targeted cst node is the name node or part of it
                if (nameNode && (nameNode === sourceCstNode || (0, $f87d6e075cbbfde9$export$da083ea7c8d26f74)(sourceCstNode, nameNode))) return this.getSelfNodes(nodeElem);
            }
        }
        return [];
    }
    /**
     * Returns all self-references for the specified node.
     * Since the node can be part of a multi-reference, this method returns all nodes that are part of the same multi-reference.
     */ getSelfNodes(node) {
        if (!this.hasMultiReference) return [
            node
        ];
        else {
            // In order to find all nodes that are part of the same multi-reference,
            // we need to find a reference that points to the node.
            // It will also point to the logical siblings of the node.
            const references = this.index.findAllReferences(node, this.nodeLocator.getAstNodePath(node));
            // We can simply use the first reference to find all logical siblings.
            // Looking through all references is not necessary and very inefficient.
            const headNode = this.getNodeFromReferenceDescription(references.head());
            if (headNode) // We need to iterate over all references to find the one that points to the node.
            for (const ref of (0, $de130ae470c6cbfb$export$a724fcaa837c6cb2)(headNode)){
                if ((0, $09c22474b334b427$export$c99833078476c909)(ref.reference) && ref.reference.items.some((item)=>item.ref === node)) // Once we found the reference, simply return all items of the multi-reference.
                return ref.reference.items.map((item)=>item.ref);
            }
            return [
                node
            ];
        }
    }
    getNodeFromReferenceDescription(ref) {
        if (!ref) return undefined;
        const doc = this.documents.getDocument(ref.sourceUri);
        if (doc) return this.nodeLocator.getAstNode(doc.parseResult.value, ref.sourcePath);
        return undefined;
    }
    findDeclarationNodes(sourceCstNode) {
        const astNodes = this.findDeclarations(sourceCstNode);
        const cstNodes = [];
        for (const astNode of astNodes){
            const cstNode = this.nameProvider.getNameNode(astNode) ?? astNode.$cstNode;
            if (cstNode) cstNodes.push(cstNode);
        }
        return cstNodes;
    }
    findReferences(targetNode, options) {
        const refs = [];
        if (options.includeDeclaration) refs.push(...this.getSelfReferences(targetNode));
        let indexReferences = this.index.findAllReferences(targetNode, this.nodeLocator.getAstNodePath(targetNode));
        if (options.documentUri) indexReferences = indexReferences.filter((ref)=>(0, $c3a2ae12d89e8820$export$c96870febfa75a76).equals(ref.sourceUri, options.documentUri));
        refs.push(...indexReferences);
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(refs);
    }
    getSelfReferences(targetNode) {
        const selfNodes = this.getSelfNodes(targetNode);
        const references = [];
        for (const selfNode of selfNodes){
            const nameNode = this.nameProvider.getNameNode(selfNode);
            if (nameNode) {
                const doc = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(selfNode);
                const path = this.nodeLocator.getAstNodePath(selfNode);
                references.push({
                    sourceUri: doc.uri,
                    sourcePath: path,
                    targetUri: doc.uri,
                    targetPath: path,
                    segment: (0, $f87d6e075cbbfde9$export$c9a2c6a6b5629cf4)(nameNode),
                    local: true
                });
            }
        }
        return references;
    }
}


/******************************************************************************
 * Copyright 2021-2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
class $9c40ddedabc72f65$export$c43b025112e292e2 {
    constructor(elements){
        this.map = new Map();
        if (elements) for (const [key, value] of elements)this.add(key, value);
    }
    /**
     * The total number of values in the multimap.
     */ get size() {
        return (0, $1feb7546a8c17818$export$cc9fa7113d70efba).sum((0, $1feb7546a8c17818$export$4938110305e6185f)(this.map.values()).map((a)=>a.length));
    }
    /**
     * Clear all entries in the multimap.
     */ clear() {
        this.map.clear();
    }
    /**
     * Operates differently depending on whether a `value` is given:
     *  * With a value, this method deletes the specific key / value pair from the multimap.
     *  * Without a value, all values associated with the given key are deleted.
     *
     * @returns `true` if a value existed and has been removed, or `false` if the specified
     *     key / value does not exist.
     */ delete(key, value) {
        if (value === undefined) return this.map.delete(key);
        else {
            const values = this.map.get(key);
            if (values) {
                const index = values.indexOf(value);
                if (index >= 0) {
                    if (values.length === 1) this.map.delete(key);
                    else values.splice(index, 1);
                    return true;
                }
            }
            return false;
        }
    }
    /**
     * Returns an array of all values associated with the given key. If no value exists,
     * an empty array is returned.
     *
     * _Note:_ The returned array is assumed not to be modified. Use the `set` method to add a
     * value and `delete` to remove a value from the multimap.
     */ get(key) {
        return this.map.get(key) ?? [];
    }
    /**
     * Returns a stream of all values associated with the given key. If no value exists,
     * {@link EMPTY_STREAM} is returned.
     */ getStream(key) {
        const values = this.map.get(key);
        return values ? (0, $1feb7546a8c17818$export$4938110305e6185f)(values) : (0, $1feb7546a8c17818$export$7160cecf0710cccd);
    }
    /**
     * Operates differently depending on whether a `value` is given:
     *  * With a value, this method returns `true` if the specific key / value pair is present in the multimap.
     *  * Without a value, this method returns `true` if the given key is present in the multimap.
     */ has(key, value) {
        if (value === undefined) return this.map.has(key);
        else {
            const values = this.map.get(key);
            if (values) return values.indexOf(value) >= 0;
            return false;
        }
    }
    /**
     * Add the given key / value pair to the multimap.
     */ add(key, value) {
        if (this.map.has(key)) this.map.get(key).push(value);
        else this.map.set(key, [
            value
        ]);
        return this;
    }
    /**
     * Add the given set of key / value pairs to the multimap.
     */ addAll(key, values) {
        if (this.map.has(key)) this.map.get(key).push(...values);
        else this.map.set(key, Array.from(values));
        return this;
    }
    /**
     * Invokes the given callback function for every key / value pair in the multimap.
     */ forEach(callbackfn) {
        this.map.forEach((array, key)=>array.forEach((value)=>callbackfn(value, key, this)));
    }
    /**
     * Returns an iterator of key, value pairs for every entry in the map.
     */ [Symbol.iterator]() {
        return this.entries().iterator();
    }
    /**
     * Returns a stream of key, value pairs for every entry in the map.
     */ entries() {
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(this.map.entries()).flatMap(([key, array])=>array.map((value)=>[
                    key,
                    value
                ]));
    }
    /**
     * Returns a stream of keys in the map.
     */ keys() {
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(this.map.keys());
    }
    /**
     * Returns a stream of values in the map.
     */ values() {
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(this.map.values()).flat();
    }
    /**
     * Returns a stream of key, value set pairs for every key in the map.
     */ entriesGroupedByKey() {
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(this.map.entries());
    }
}
class $9c40ddedabc72f65$export$f742ea9eee1a8cf2 {
    get size() {
        return this.map.size;
    }
    constructor(elements){
        this.map = new Map();
        this.inverse = new Map();
        if (elements) for (const [key, value] of elements)this.set(key, value);
    }
    clear() {
        this.map.clear();
        this.inverse.clear();
    }
    set(key, value) {
        this.map.set(key, value);
        this.inverse.set(value, key);
        return this;
    }
    get(key) {
        return this.map.get(key);
    }
    getKey(value) {
        return this.inverse.get(value);
    }
    delete(key) {
        const value = this.map.get(key);
        if (value !== undefined) {
            this.map.delete(key);
            this.inverse.delete(value);
            return true;
        }
        return false;
    }
}



class $656f388a6eb9a1c1$export$6821cb2333c50d6b {
    constructor(services){
        this.nameProvider = services.references.NameProvider;
        this.descriptions = services.workspace.AstNodeDescriptionProvider;
    }
    async collectExportedSymbols(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        return this.collectExportedSymbolsForNode(document.parseResult.value, document, undefined, cancelToken);
    }
    /**
     * Creates {@link AstNodeDescription AstNodeDescriptions} for the given {@link AstNode parentNode} and its children.
     * The list of children to be considered is determined by the function parameter {@link children}.
     * By default only the direct children of {@link parentNode} are visited, nested nodes are not exported.
     *
     * @param parentNode AST node to be exported, i.e., of which an {@link AstNodeDescription} shall be added to the returned list.
     * @param document The document containing the AST node to be exported.
     * @param children A function called with {@link parentNode} as single argument and returning an {@link Iterable} supplying the children to be visited, which must be directly or transitively contained in {@link parentNode}.
     * @param cancelToken Indicates when to cancel the current operation.
     * @throws `OperationCancelled` if a user action occurs during execution.
     * @returns A list of {@link AstNodeDescription AstNodeDescriptions} to be published to index.
     */ async collectExportedSymbolsForNode(parentNode, document, children = (0, $de130ae470c6cbfb$export$99c402bba993fa31), cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const exports = [];
        this.addExportedSymbol(parentNode, exports, document);
        for (const node of children(parentNode)){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            this.addExportedSymbol(node, exports, document);
        }
        return exports;
    }
    /**
     * Adds a single node to the list of exports if it has a name. Override this method to change how
     * symbols are exported, e.g. by modifying their exported name.
     */ addExportedSymbol(node, exports, document) {
        const name = this.nameProvider.getName(node);
        if (name) exports.push(this.descriptions.createDescription(node, name, document));
    }
    // --- local symbols gathering ---
    async collectLocalSymbols(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const rootNode = document.parseResult.value;
        const symbols = new (0, $9c40ddedabc72f65$export$c43b025112e292e2)();
        // Here we navigate the full AST - local scopes shall be available in the whole document
        for (const node of (0, $de130ae470c6cbfb$export$b4b3af85716f6615)(rootNode)){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            this.addLocalSymbol(node, document, symbols);
        }
        return symbols;
    }
    /**
     * Adds a single node to the local symbols of its containing document if it has a name.
     * The default implementation makes the node visible in the subtree of its container if it does have a container.
     * Override this method to change this, e.g. by increasing the visibility to a higher level in the AST.
     */ addLocalSymbol(node, document, symbols) {
        const container = node.$container;
        if (container) {
            const name = this.nameProvider.getName(node);
            if (name) symbols.add(container, this.descriptions.createDescription(node, name, document));
        }
    }
}


/******************************************************************************
 * Copyright 2021-2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ /******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

class $e5b073777f2edfb6$export$3e1090b2fe6b3b72 {
    constructor(elements, outerScope, options){
        this.elements = elements;
        this.outerScope = outerScope;
        this.caseInsensitive = options?.caseInsensitive ?? false;
        this.concatOuterScope = options?.concatOuterScope ?? true;
    }
    getAllElements() {
        if (this.outerScope) return this.elements.concat(this.outerScope.getAllElements());
        else return this.elements;
    }
    getElement(name) {
        const lowerCaseName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.caseInsensitive ? this.elements.find((e)=>e.name.toLowerCase() === lowerCaseName) : this.elements.find((e)=>e.name === name);
        if (local) return local;
        if (this.outerScope) return this.outerScope.getElement(name);
        return undefined;
    }
    getElements(name) {
        const lowerCaseName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.caseInsensitive ? this.elements.filter((e)=>e.name.toLowerCase() === lowerCaseName) : this.elements.filter((e)=>e.name === name);
        if ((this.concatOuterScope || local.isEmpty()) && this.outerScope) return local.concat(this.outerScope.getElements(name));
        else return local;
    }
}
class $e5b073777f2edfb6$export$7aa236b11c062951 {
    constructor(elements, outerScope, options){
        this.elements = new Map();
        this.caseInsensitive = options?.caseInsensitive ?? false;
        this.concatOuterScope = options?.concatOuterScope ?? true;
        for (const element of elements){
            const name = this.caseInsensitive ? element.name.toLowerCase() : element.name;
            this.elements.set(name, element);
        }
        this.outerScope = outerScope;
    }
    getElement(name) {
        const localName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.elements.get(localName);
        if (local) return local;
        if (this.outerScope) return this.outerScope.getElement(name);
        return undefined;
    }
    getElements(name) {
        const localName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.elements.get(localName);
        const arr = local ? [
            local
        ] : [];
        if ((this.concatOuterScope || arr.length === 0) && this.outerScope) return (0, $1feb7546a8c17818$export$4938110305e6185f)(arr).concat(this.outerScope.getElements(name));
        else return (0, $1feb7546a8c17818$export$4938110305e6185f)(arr);
    }
    getAllElements() {
        let elementStream = (0, $1feb7546a8c17818$export$4938110305e6185f)(this.elements.values());
        if (this.outerScope) elementStream = elementStream.concat(this.outerScope.getAllElements());
        return elementStream;
    }
}
class $e5b073777f2edfb6$export$c1009e21a6615070 {
    constructor(elements, outerScope, options){
        this.elements = new (0, $9c40ddedabc72f65$export$c43b025112e292e2)();
        this.caseInsensitive = options?.caseInsensitive ?? false;
        this.concatOuterScope = options?.concatOuterScope ?? true;
        for (const element of elements){
            const name = this.caseInsensitive ? element.name.toLowerCase() : element.name;
            this.elements.add(name, element);
        }
        this.outerScope = outerScope;
    }
    getElement(name) {
        const localName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.elements.get(localName)[0];
        if (local) return local;
        if (this.outerScope) return this.outerScope.getElement(name);
        return undefined;
    }
    getElements(name) {
        const localName = this.caseInsensitive ? name.toLowerCase() : name;
        const local = this.elements.get(localName);
        if ((this.concatOuterScope || local.length === 0) && this.outerScope) return (0, $1feb7546a8c17818$export$4938110305e6185f)(local).concat(this.outerScope.getElements(name));
        else return (0, $1feb7546a8c17818$export$4938110305e6185f)(local);
    }
    getAllElements() {
        let elementStream = (0, $1feb7546a8c17818$export$4938110305e6185f)(this.elements.values());
        if (this.outerScope) elementStream = elementStream.concat(this.outerScope.getAllElements());
        return elementStream;
    }
}
const $e5b073777f2edfb6$export$c4f40b2a09feb62e = {
    getElement () {
        return undefined;
    },
    getElements () {
        return 0, $1feb7546a8c17818$export$7160cecf0710cccd;
    },
    getAllElements () {
        return 0, $1feb7546a8c17818$export$7160cecf0710cccd;
    }
};




/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ class $d5c638f1e4023415$export$da2d809075efb18a {
    constructor(){
        this.toDispose = [];
        this.isDisposed = false;
    }
    onDispose(disposable) {
        this.toDispose.push(disposable);
    }
    dispose() {
        this.throwIfDisposed();
        this.clear();
        this.isDisposed = true;
        this.toDispose.forEach((disposable)=>disposable.dispose());
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error('This cache has already been disposed');
    }
}
class $d5c638f1e4023415$export$de40364712978bcb extends $d5c638f1e4023415$export$da2d809075efb18a {
    constructor(){
        super(...arguments);
        this.cache = new Map();
    }
    has(key) {
        this.throwIfDisposed();
        return this.cache.has(key);
    }
    set(key, value) {
        this.throwIfDisposed();
        this.cache.set(key, value);
    }
    get(key, provider) {
        this.throwIfDisposed();
        if (this.cache.has(key)) return this.cache.get(key);
        else if (provider) {
            const value = provider();
            this.cache.set(key, value);
            return value;
        } else return undefined;
    }
    delete(key) {
        this.throwIfDisposed();
        return this.cache.delete(key);
    }
    clear() {
        this.throwIfDisposed();
        this.cache.clear();
    }
}
class $d5c638f1e4023415$export$e910ddfc8c19083 extends $d5c638f1e4023415$export$da2d809075efb18a {
    constructor(converter){
        super();
        this.cache = new Map();
        this.converter = converter ?? ((value)=>value);
    }
    has(contextKey, key) {
        this.throwIfDisposed();
        return this.cacheForContext(contextKey).has(key);
    }
    set(contextKey, key, value) {
        this.throwIfDisposed();
        this.cacheForContext(contextKey).set(key, value);
    }
    get(contextKey, key, provider) {
        this.throwIfDisposed();
        const contextCache = this.cacheForContext(contextKey);
        if (contextCache.has(key)) return contextCache.get(key);
        else if (provider) {
            const value = provider();
            contextCache.set(key, value);
            return value;
        } else return undefined;
    }
    delete(contextKey, key) {
        this.throwIfDisposed();
        return this.cacheForContext(contextKey).delete(key);
    }
    clear(contextKey) {
        this.throwIfDisposed();
        if (contextKey) {
            const mapKey = this.converter(contextKey);
            this.cache.delete(mapKey);
        } else this.cache.clear();
    }
    cacheForContext(contextKey) {
        const mapKey = this.converter(contextKey);
        let documentCache = this.cache.get(mapKey);
        if (!documentCache) {
            documentCache = new Map();
            this.cache.set(mapKey, documentCache);
        }
        return documentCache;
    }
}
class $d5c638f1e4023415$export$4277a86801a0904 extends $d5c638f1e4023415$export$e910ddfc8c19083 {
    /**
     * Creates a new document cache.
     *
     * @param sharedServices Service container instance to hook into document lifecycle events.
     * @param state Optional document state on which the cache should evict.
     * If not provided, the cache will evict on `DocumentBuilder#onUpdate`.
     * *Deleted* documents are considered in both cases.
     *
     * Providing a state here will use `DocumentBuilder#onDocumentPhase` instead,
     * which triggers on all documents that have been affected by this change, assuming that the
     * state is `DocumentState.Linked` or a later state.
     */ constructor(sharedServices, state){
        super((uri)=>uri.toString());
        if (state) {
            this.toDispose.push(sharedServices.workspace.DocumentBuilder.onDocumentPhase(state, (document)=>{
                this.clear(document.uri.toString());
            }));
            this.toDispose.push(sharedServices.workspace.DocumentBuilder.onUpdate((_changed, deleted)=>{
                for (const uri of deleted)this.clear(uri);
            }));
        } else this.toDispose.push(sharedServices.workspace.DocumentBuilder.onUpdate((changed, deleted)=>{
            const allUris = changed.concat(deleted); // react on both changed and deleted documents
            for (const uri of allUris)this.clear(uri);
        }));
    }
}
class $d5c638f1e4023415$export$8d6ba3561ddc8e91 extends $d5c638f1e4023415$export$de40364712978bcb {
    /**
     * Creates a new workspace cache.
     *
     * @param sharedServices Service container instance to hook into document lifecycle events.
     * @param state Optional document state on which the cache should evict.
     * If not provided, the cache will evict on `DocumentBuilder#onUpdate`.
     * *Deleted* documents are considered in both cases.
     */ constructor(sharedServices, state){
        super();
        if (state) {
            this.toDispose.push(sharedServices.workspace.DocumentBuilder.onBuildPhase(state, ()=>{
                this.clear();
            }));
            this.toDispose.push(sharedServices.workspace.DocumentBuilder.onUpdate((_changed, deleted)=>{
                if (deleted.length > 0) this.clear();
            }));
        } else this.toDispose.push(sharedServices.workspace.DocumentBuilder.onUpdate(()=>{
            this.clear();
        }));
    }
}


class $6ae4237029067986$export$49a7480ed4da4397 {
    constructor(services){
        this.reflection = services.shared.AstReflection;
        this.nameProvider = services.references.NameProvider;
        this.descriptions = services.workspace.AstNodeDescriptionProvider;
        this.indexManager = services.shared.workspace.IndexManager;
        this.globalScopeCache = new (0, $d5c638f1e4023415$export$8d6ba3561ddc8e91)(services.shared);
    }
    getScope(context) {
        const scopes = [];
        const referenceType = this.reflection.getReferenceType(context);
        const localSymbols = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(context.container).localSymbols;
        if (localSymbols) {
            let currentNode = context.container;
            do {
                if (localSymbols.has(currentNode)) scopes.push(localSymbols.getStream(currentNode).filter((desc)=>this.reflection.isSubtype(desc.type, referenceType)));
                currentNode = currentNode.$container;
            }while (currentNode);
        }
        let result = this.getGlobalScope(referenceType, context);
        for(let i = scopes.length - 1; i >= 0; i--)result = this.createScope(scopes[i], result);
        return result;
    }
    /**
     * Create a scope for the given collection of AST node descriptions.
     */ createScope(elements, outerScope, options) {
        return new (0, $e5b073777f2edfb6$export$3e1090b2fe6b3b72)((0, $1feb7546a8c17818$export$4938110305e6185f)(elements), outerScope, options);
    }
    /**
     * Create a scope for the given collection of AST nodes, which need to be transformed into respective
     * descriptions first. This is done using the `NameProvider` and `AstNodeDescriptionProvider` services.
     */ createScopeForNodes(elements, outerScope, options) {
        const s = (0, $1feb7546a8c17818$export$4938110305e6185f)(elements).map((e)=>{
            const name = this.nameProvider.getName(e);
            if (name) return this.descriptions.createDescription(e, name);
            return undefined;
        }).nonNullable();
        return new (0, $e5b073777f2edfb6$export$3e1090b2fe6b3b72)(s, outerScope, options);
    }
    /**
     * Create a global scope filtered for the given reference type.
     */ getGlobalScope(referenceType, _context) {
        return this.globalScopeCache.get(referenceType, ()=>new (0, $e5b073777f2edfb6$export$c1009e21a6615070)(this.indexManager.allElements(referenceType)));
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 



function $b3c995646a777b80$export$cb6ca660088b8d64(node) {
    return typeof node.$comment === 'string';
}
function $b3c995646a777b80$var$isIntermediateReference(obj) {
    return typeof obj === 'object' && !!obj && ('$ref' in obj || '$refs' in obj || '$error' in obj);
}
class $b3c995646a777b80$export$6c161a533d76d64a {
    constructor(services){
        /** The set of AstNode properties to be ignored by the serializer. */ this.ignoreProperties = new Set([
            '$container',
            '$containerProperty',
            '$containerIndex',
            '$document',
            '$cstNode'
        ]);
        this.langiumDocuments = services.shared.workspace.LangiumDocuments;
        this.astNodeLocator = services.workspace.AstNodeLocator;
        this.nameProvider = services.references.NameProvider;
        this.commentProvider = services.documentation.CommentProvider;
    }
    serialize(node, options) {
        const serializeOptions = options ?? {};
        const specificReplacer = options?.replacer;
        const defaultReplacer = (key, value)=>this.replacer(key, value, serializeOptions);
        const replacer = specificReplacer ? (key, value)=>specificReplacer(key, value, defaultReplacer) : defaultReplacer;
        try {
            this.currentDocument = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(node);
            return JSON.stringify(node, replacer, options?.space);
        } finally{
            this.currentDocument = undefined;
        }
    }
    deserialize(content, options) {
        const deserializeOptions = options ?? {};
        const root = JSON.parse(content);
        this.linkNode(root, root, deserializeOptions);
        return root;
    }
    replacer(key, value, { refText: refText, sourceText: sourceText, textRegions: textRegions, comments: comments, uriConverter: uriConverter }) {
        if (this.ignoreProperties.has(key)) return undefined;
        else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(value)) {
            const refValue = value.ref;
            const $refText = refText ? value.$refText : undefined;
            if (refValue) {
                const targetDocument = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(refValue);
                let targetUri = '';
                if (this.currentDocument && this.currentDocument !== targetDocument) {
                    if (uriConverter) targetUri = uriConverter(targetDocument.uri, refValue);
                    else targetUri = targetDocument.uri.toString();
                }
                const targetPath = this.astNodeLocator.getAstNodePath(refValue);
                return {
                    $ref: `${targetUri}#${targetPath}`,
                    $refText: $refText
                };
            } else return {
                $error: value.error?.message ?? 'Could not resolve reference',
                $refText: $refText
            };
        } else if ((0, $09c22474b334b427$export$c99833078476c909)(value)) {
            const $refText = refText ? value.$refText : undefined;
            const $refs = [];
            for (const item of value.items){
                const refValue = item.ref;
                const targetDocument = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(item.ref);
                let targetUri = '';
                if (this.currentDocument && this.currentDocument !== targetDocument) {
                    if (uriConverter) targetUri = uriConverter(targetDocument.uri, refValue);
                    else targetUri = targetDocument.uri.toString();
                }
                const targetPath = this.astNodeLocator.getAstNodePath(refValue);
                $refs.push(`${targetUri}#${targetPath}`);
            }
            return {
                $refs: $refs,
                $refText: $refText
            };
        } else if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) {
            let astNode = undefined;
            if (textRegions) {
                astNode = this.addAstNodeRegionWithAssignmentsTo({
                    ...value
                });
                if ((!key || value.$document) && astNode?.$textRegion) // The document URI is added to the root node of the resulting JSON tree
                astNode.$textRegion.documentURI = this.currentDocument?.uri.toString();
            }
            if (sourceText && !key) {
                astNode ?? (astNode = {
                    ...value
                });
                astNode.$sourceText = value.$cstNode?.text;
            }
            if (comments) {
                astNode ?? (astNode = {
                    ...value
                });
                const comment = this.commentProvider.getComment(value);
                if (comment) astNode.$comment = comment.replace(/\r/g, '');
            }
            return astNode ?? value;
        } else return value;
    }
    addAstNodeRegionWithAssignmentsTo(node) {
        const createDocumentSegment = (cstNode)=>({
                offset: cstNode.offset,
                end: cstNode.end,
                length: cstNode.length,
                range: cstNode.range
            });
        if (node.$cstNode) {
            const textRegion = node.$textRegion = createDocumentSegment(node.$cstNode);
            const assignments = textRegion.assignments = {};
            Object.keys(node).filter((key)=>!key.startsWith('$')).forEach((key)=>{
                const propertyAssignments = (0, $624e994b941222bd$export$b6014cab792295bd)(node.$cstNode, key).map(createDocumentSegment);
                if (propertyAssignments.length !== 0) assignments[key] = propertyAssignments;
            });
            return node;
        }
        return undefined;
    }
    linkNode(node, root, options, container, containerProperty, containerIndex) {
        for (const [propertyName, item] of Object.entries(node)){
            if (Array.isArray(item)) for(let index = 0; index < item.length; index++){
                const element = item[index];
                if ($b3c995646a777b80$var$isIntermediateReference(element)) item[index] = this.reviveReference(node, propertyName, root, element, options);
                else if ((0, $09c22474b334b427$export$dd586f2688797f92)(element)) this.linkNode(element, root, options, node, propertyName, index);
            }
            else if ($b3c995646a777b80$var$isIntermediateReference(item)) node[propertyName] = this.reviveReference(node, propertyName, root, item, options);
            else if ((0, $09c22474b334b427$export$dd586f2688797f92)(item)) this.linkNode(item, root, options, node, propertyName);
        }
        const mutable = node;
        mutable.$container = container;
        mutable.$containerProperty = containerProperty;
        mutable.$containerIndex = containerIndex;
    }
    reviveReference(container, property, root, reference, options) {
        let refText = reference.$refText;
        let error = reference.$error;
        let ref;
        if (reference.$ref) {
            const refNode = this.getRefNode(root, reference.$ref, options.uriConverter);
            if ((0, $09c22474b334b427$export$dd586f2688797f92)(refNode)) {
                if (!refText) refText = this.nameProvider.getName(refNode);
                return {
                    $refText: refText ?? '',
                    ref: refNode
                };
            } else error = refNode;
        } else if (reference.$refs) {
            const refs = [];
            for (const refUri of reference.$refs){
                const refNode = this.getRefNode(root, refUri, options.uriConverter);
                if ((0, $09c22474b334b427$export$dd586f2688797f92)(refNode)) refs.push({
                    ref: refNode
                });
            }
            if (refs.length === 0) {
                ref = {
                    $refText: refText ?? '',
                    items: refs
                };
                error ?? (error = 'Could not resolve multi-reference');
            } else return {
                $refText: refText ?? '',
                items: refs
            };
        }
        if (error) {
            ref ?? (ref = {
                $refText: refText ?? '',
                ref: undefined
            });
            ref.error = {
                info: {
                    container: container,
                    property: property,
                    reference: ref
                },
                message: error
            };
            return ref;
        } else return undefined;
    }
    getRefNode(root, uri, uriConverter) {
        try {
            const fragmentIndex = uri.indexOf('#');
            if (fragmentIndex === 0) {
                const node = this.astNodeLocator.getAstNode(root, uri.substring(1));
                if (!node) return 'Could not resolve path: ' + uri;
                return node;
            }
            if (fragmentIndex < 0) {
                const documentUri = uriConverter ? uriConverter(uri) : (0, $3a1a3bfcc859a329$exports.URI).parse(uri);
                const document = this.langiumDocuments.getDocument(documentUri);
                if (!document) return 'Could not find document for URI: ' + uri;
                return document.parseResult.value;
            }
            const documentUri = uriConverter ? uriConverter(uri.substring(0, fragmentIndex)) : (0, $3a1a3bfcc859a329$exports.URI).parse(uri.substring(0, fragmentIndex));
            const document = this.langiumDocuments.getDocument(documentUri);
            if (!document) return 'Could not find document for URI: ' + uri;
            if (fragmentIndex === uri.length - 1) return document.parseResult.value;
            const node = this.astNodeLocator.getAstNode(document.parseResult.value, uri.substring(fragmentIndex + 1));
            if (!node) return 'Could not resolve URI: ' + uri;
            return node;
        } catch (err) {
            return String(err);
        }
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
class $a101d7777e543b9c$export$17a7e66d43732508 {
    /**
     * @deprecated Since 3.1.0. Use the new `fileExtensionMap` (or `languageIdMap`) property instead.
     */ get map() {
        return this.fileExtensionMap;
    }
    constructor(services){
        this.languageIdMap = new Map();
        this.fileExtensionMap = new Map();
        this.fileNameMap = new Map();
        this.textDocuments = services?.workspace.TextDocuments;
    }
    register(language) {
        const data = language.LanguageMetaData;
        for (const ext of data.fileExtensions){
            if (this.fileExtensionMap.has(ext)) console.warn(`The file extension ${ext} is used by multiple languages. It is now assigned to '${data.languageId}'.`);
            this.fileExtensionMap.set(ext, language);
        }
        if (data.fileNames) for (const name of data.fileNames){
            if (this.fileNameMap.has(name)) console.warn(`The file name ${name} is used by multiple languages. It is now assigned to '${data.languageId}'.`);
            this.fileNameMap.set(name, language);
        }
        this.languageIdMap.set(data.languageId, language);
    }
    getServices(uri) {
        if (this.languageIdMap.size === 0) throw new Error('The service registry is empty. Use `register` to register the services of a language.');
        const languageId = this.textDocuments?.get(uri)?.languageId;
        if (languageId !== undefined) {
            const services = this.languageIdMap.get(languageId);
            if (services) return services;
        }
        const ext = (0, $c3a2ae12d89e8820$export$c96870febfa75a76).extname(uri);
        const name = (0, $c3a2ae12d89e8820$export$c96870febfa75a76).basename(uri);
        const services = this.fileNameMap.get(name) ?? this.fileExtensionMap.get(ext);
        if (!services) {
            if (languageId) throw new Error(`The service registry contains no services for the extension '${ext}' for language '${languageId}'.`);
            else throw new Error(`The service registry contains no services for the extension '${ext}'.`);
        }
        return services;
    }
    hasServices(uri) {
        try {
            this.getServices(uri);
            return true;
        } catch  {
            return false;
        }
    }
    get all() {
        return Array.from(this.languageIdMap.values());
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 




/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 



function $122aedc676522a5a$export$97d57a366f400a9(code) {
    return {
        code: code
    };
}
var $122aedc676522a5a$export$2cd67429cf01d10b;
(function(ValidationCategory) {
    ValidationCategory.defaults = [
        'fast',
        'slow',
        'built-in'
    ];
    /**
     * @deprecated since 4.2 Use `ValidationCategory.defaults` instead,
     * since "all" does not include user-defined, custom validation categories.
     */ ValidationCategory.all = ValidationCategory.defaults;
})($122aedc676522a5a$export$2cd67429cf01d10b || ($122aedc676522a5a$export$2cd67429cf01d10b = {}));
class $122aedc676522a5a$export$74bb79b1ec263dfd {
    constructor(services){
        this.entries = new (0, $9c40ddedabc72f65$export$c43b025112e292e2)();
        this.knownCategories = new Set($122aedc676522a5a$export$2cd67429cf01d10b.defaults);
        this.entriesBefore = [];
        this.entriesAfter = [];
        this.reflection = services.shared.AstReflection;
    }
    /**
     * Register a set of validation checks. Each value in the record can be either a single validation check (i.e. a function)
     * or an array of validation checks.
     *
     * @param checksRecord Set of validation checks to register.
     * @param thisObj Optional object to be used as `this` when calling the validation check functions.
     * @param category Optional category for the validation checks (defaults to `'fast'`).
     */ register(checksRecord, thisObj = this, category = 'fast') {
        if (category === 'built-in') throw new Error("The 'built-in' category is reserved for lexer, parser, and linker errors.");
        this.knownCategories.add(category); // remember custom/user-defined categories
        for (const [type, ch] of Object.entries(checksRecord)){
            const callbacks = ch;
            if (Array.isArray(callbacks)) for (const check of callbacks){
                const entry = {
                    check: this.wrapValidationException(check, thisObj),
                    category: category
                };
                this.addEntry(type, entry);
            }
            else if (typeof callbacks === 'function') {
                const entry = {
                    check: this.wrapValidationException(callbacks, thisObj),
                    category: category
                };
                this.addEntry(type, entry);
            } else (0, $71d485f045ec2841$export$f2525c1d596f8d46)(callbacks);
        }
    }
    wrapValidationException(check, thisObj) {
        return async (node, accept, cancelToken)=>{
            await this.handleException(()=>check.call(thisObj, node, accept, cancelToken), 'An error occurred during validation', accept, node);
        };
    }
    async handleException(functionality, messageContext, accept, node) {
        try {
            await functionality();
        } catch (err) {
            if ((0, $4fb404a672a62c84$export$5b2d4ab85306fab5)(err)) throw err;
            console.error(`${messageContext}:`, err);
            if (err instanceof Error && err.stack) console.error(err.stack);
            const messageDetails = err instanceof Error ? err.message : String(err);
            accept('error', `${messageContext}: ${messageDetails}`, {
                node: node
            });
        }
    }
    addEntry(type, entry) {
        if (type === 'AstNode') {
            this.entries.add('AstNode', entry);
            return;
        }
        for (const subtype of this.reflection.getAllSubTypes(type))this.entries.add(subtype, entry);
    }
    getChecks(type, categories) {
        let checks = (0, $1feb7546a8c17818$export$4938110305e6185f)(this.entries.get(type)).concat(this.entries.get('AstNode'));
        if (categories) checks = checks.filter((entry)=>categories.includes(entry.category));
        return checks.map((entry)=>entry.check);
    }
    /**
     * Register logic which will be executed once before validating all the nodes of an AST/Langium document.
     * This helps to prepare or initialize some information which are required or reusable for the following checks on the AstNodes.
     *
     * As an example, for validating unique fully-qualified names of nodes in the AST,
     * here the map for mapping names to nodes could be established.
     * During the usual checks on the nodes, they are put into this map with their name.
     *
     * Note that this approach makes validations stateful, which is relevant e.g. when cancelling the validation.
     * Therefore it is recommended to clear stored information
     * _before_ validating an AST to validate each AST unaffected from other ASTs
     * AND _after_ validating the AST to free memory by information which are no longer used.
     *
     * @param checkBefore a set-up function which will be called once before actually validating an AST
     * @param thisObj Optional object to be used as `this` when calling the validation check functions.
     */ registerBeforeDocument(checkBefore, thisObj = this) {
        this.entriesBefore.push(this.wrapPreparationException(checkBefore, 'An error occurred during set-up of the validation', thisObj));
    }
    /**
     * Register logic which will be executed once after validating all the nodes of an AST/Langium document.
     * This helps to finally evaluate information which are collected during the checks on the AstNodes.
     *
     * As an example, for validating unique fully-qualified names of nodes in the AST,
     * here the map with all the collected nodes and their names is checked
     * and validation hints are created for all nodes with the same name.
     *
     * Note that this approach makes validations stateful, which is relevant e.g. when cancelling the validation.
     * Therefore it is recommended to clear stored information
     * _before_ validating an AST to validate each AST unaffected from other ASTs
     * AND _after_ validating the AST to free memory by information which are no longer used.
     *
     * @param checkBefore a set-up function which will be called once before actually validating an AST
     * @param thisObj Optional object to be used as `this` when calling the validation check functions.
     */ registerAfterDocument(checkAfter, thisObj = this) {
        this.entriesAfter.push(this.wrapPreparationException(checkAfter, 'An error occurred during tear-down of the validation', thisObj));
    }
    wrapPreparationException(check, messageContext, thisObj) {
        return async (rootNode, accept, categories, cancelToken)=>{
            await this.handleException(()=>check.call(thisObj, rootNode, accept, categories, cancelToken), messageContext, accept, rootNode);
        };
    }
    get checksBefore() {
        return this.entriesBefore;
    }
    get checksAfter() {
        return this.entriesAfter;
    }
    getAllValidationCategories(_document) {
        return this.knownCategories;
    }
}


const $10a976939bbc6c50$export$85f521e87e2a51cf = Object.freeze({
    validateNode: true,
    validateChildren: true
});
class $10a976939bbc6c50$export$26c8dfd81f255a91 {
    constructor(services){
        this.validationRegistry = services.validation.ValidationRegistry;
        this.metadata = services.LanguageMetaData;
        this.profiler = services.shared.profilers.LangiumProfiler;
        this.languageId = services.LanguageMetaData.languageId;
    }
    async validateDocument(document, options = {}, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const parseResult = document.parseResult;
        const diagnostics = [];
        await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
        if (!options.categories || options.categories.includes('built-in')) {
            this.processLexingErrors(parseResult, diagnostics, options);
            if (options.stopAfterLexingErrors && diagnostics.some((d)=>d.data?.code === $10a976939bbc6c50$export$7d47fbcff74879c.LexingError)) return diagnostics;
            this.processParsingErrors(parseResult, diagnostics, options);
            if (options.stopAfterParsingErrors && diagnostics.some((d)=>d.data?.code === $10a976939bbc6c50$export$7d47fbcff74879c.ParsingError)) return diagnostics;
            this.processLinkingErrors(document, diagnostics, options);
            if (options.stopAfterLinkingErrors && diagnostics.some((d)=>d.data?.code === $10a976939bbc6c50$export$7d47fbcff74879c.LinkingError)) return diagnostics;
        }
        // Process custom validations
        try {
            diagnostics.push(...await this.validateAst(parseResult.value, options, cancelToken));
        } catch (err) {
            if ((0, $4fb404a672a62c84$export$5b2d4ab85306fab5)(err)) throw err;
            console.error('An error occurred during validation:', err);
        }
        await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
        return diagnostics;
    }
    processLexingErrors(parseResult, diagnostics, _options) {
        const lexerDiagnostics = [
            ...parseResult.lexerErrors,
            ...parseResult.lexerReport?.diagnostics ?? []
        ];
        for (const lexerDiagnostic of lexerDiagnostics){
            const severity = lexerDiagnostic.severity ?? 'error';
            const diagnostic = {
                severity: $10a976939bbc6c50$export$60423a612b9e2f10(severity),
                range: {
                    start: {
                        line: lexerDiagnostic.line - 1,
                        character: lexerDiagnostic.column - 1
                    },
                    end: {
                        line: lexerDiagnostic.line - 1,
                        character: lexerDiagnostic.column + lexerDiagnostic.length - 1
                    }
                },
                message: lexerDiagnostic.message,
                data: $10a976939bbc6c50$export$7e704b86437cd056(severity),
                source: this.getSource()
            };
            diagnostics.push(diagnostic);
        }
    }
    processParsingErrors(parseResult, diagnostics, _options) {
        for (const parserError of parseResult.parserErrors){
            let range = undefined;
            // We can run into the chevrotain error recovery here
            // The token contained in the parser error might be automatically inserted
            // In this case every position value will be invalid (`NaN` or `-1`)
            if (!(0, $f87d6e075cbbfde9$export$b271295f38c7b1c6)(parserError.token)) // Some special parser error types contain a `previousToken`
            // We can simply append our diagnostic to that token
            {
                if ('previousToken' in parserError) {
                    const token = parserError.previousToken;
                    if ((0, $f87d6e075cbbfde9$export$b271295f38c7b1c6)(token)) {
                        const position = {
                            line: token.endLine - 1,
                            character: token.endColumn
                        };
                        range = {
                            start: position,
                            end: position
                        };
                    } else {
                        // No valid prev token. Might be empty document or containing only hidden tokens.
                        // Point to document start
                        const position = {
                            line: 0,
                            character: 0
                        };
                        range = {
                            start: position,
                            end: position
                        };
                    }
                }
            } else range = (0, $f87d6e075cbbfde9$export$412827f3965fb32)(parserError.token);
            if (range) {
                const diagnostic = {
                    severity: $10a976939bbc6c50$export$60423a612b9e2f10('error'),
                    range: range,
                    message: parserError.message,
                    data: (0, $122aedc676522a5a$export$97d57a366f400a9)($10a976939bbc6c50$export$7d47fbcff74879c.ParsingError),
                    source: this.getSource()
                };
                diagnostics.push(diagnostic);
            }
        }
    }
    processLinkingErrors(document, diagnostics, _options) {
        for (const reference of document.references){
            const linkingError = reference.error;
            if (linkingError) {
                const info = {
                    node: linkingError.info.container,
                    range: reference.$refNode?.range,
                    property: linkingError.info.property,
                    index: linkingError.info.index,
                    data: {
                        code: $10a976939bbc6c50$export$7d47fbcff74879c.LinkingError,
                        containerType: linkingError.info.container.$type,
                        property: linkingError.info.property,
                        refText: linkingError.info.reference.$refText
                    }
                };
                diagnostics.push(this.toDiagnostic('error', linkingError.message, info));
            }
        }
    }
    async validateAst(rootNode, options, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const validationItems = [];
        const acceptor = (severity, message, info)=>{
            validationItems.push(this.toDiagnostic(severity, message, info));
        };
        await this.validateAstBefore(rootNode, options, acceptor, cancelToken);
        await this.validateAstNodes(rootNode, options, acceptor, cancelToken);
        await this.validateAstAfter(rootNode, options, acceptor, cancelToken);
        return validationItems;
    }
    async validateAstBefore(rootNode, options, acceptor, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const checksBefore = this.validationRegistry.checksBefore;
        for (const checkBefore of checksBefore){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            await checkBefore(rootNode, acceptor, options.categories ?? [], cancelToken);
        }
    }
    async validateAstNodes(rootNode, options, acceptor, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        if (this.profiler?.isActive('validating')) {
            const task = this.profiler.createTask('validating', this.languageId);
            task.start();
            try {
                const nodes = (0, $de130ae470c6cbfb$export$b7350f614170899e)(rootNode).iterator();
                for (const node of nodes){
                    task.startSubTask(node.$type);
                    const nodeOptions = this.validateSingleNodeOptions(node, options);
                    if (nodeOptions.validateNode) try {
                        const checks = this.validationRegistry.getChecks(node.$type, options.categories);
                        for (const check of checks)await check(node, acceptor, cancelToken);
                    } finally{
                        task.stopSubTask(node.$type);
                    }
                    if (!nodeOptions.validateChildren) nodes.prune();
                }
            } finally{
                task.stop();
            }
        } else {
            const nodes = (0, $de130ae470c6cbfb$export$b7350f614170899e)(rootNode).iterator();
            for (const node of nodes){
                await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
                const nodeOptions = this.validateSingleNodeOptions(node, options);
                if (nodeOptions.validateNode) {
                    const checks = this.validationRegistry.getChecks(node.$type, options.categories);
                    for (const check of checks)await check(node, acceptor, cancelToken);
                }
                if (!nodeOptions.validateChildren) nodes.prune();
            }
        }
    }
    validateSingleNodeOptions(_node, _options) {
        return $10a976939bbc6c50$export$85f521e87e2a51cf;
    }
    async validateAstAfter(rootNode, options, acceptor, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const checksAfter = this.validationRegistry.checksAfter;
        for (const checkAfter of checksAfter){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            await checkAfter(rootNode, acceptor, options.categories ?? [], cancelToken);
        }
    }
    toDiagnostic(severity, message, info) {
        return {
            message: message,
            range: $10a976939bbc6c50$export$6e26cfa49397bcc2(info),
            severity: $10a976939bbc6c50$export$60423a612b9e2f10(severity),
            code: info.code,
            codeDescription: info.codeDescription,
            tags: info.tags,
            relatedInformation: info.relatedInformation,
            data: info.data,
            source: this.getSource()
        };
    }
    getSource() {
        return this.metadata.languageId;
    }
}
function $10a976939bbc6c50$export$6e26cfa49397bcc2(info) {
    if (info.range) return info.range;
    let cstNode;
    if (typeof info.property === 'string') cstNode = (0, $624e994b941222bd$export$cb1742ae4f1e059d)(info.node.$cstNode, info.property, info.index);
    else if (typeof info.keyword === 'string') cstNode = (0, $624e994b941222bd$export$3c69baddbefd5ba4)(info.node.$cstNode, info.keyword, info.index);
    cstNode ?? (cstNode = info.node.$cstNode);
    if (!cstNode) return {
        start: {
            line: 0,
            character: 0
        },
        end: {
            line: 0,
            character: 0
        }
    };
    return cstNode.range;
}
function $10a976939bbc6c50$export$60423a612b9e2f10(severity) {
    switch(severity){
        case 'error':
            return 1;
        case 'warning':
            return 2;
        case 'info':
            return 3;
        case 'hint':
            return 4;
        default:
            throw new Error('Invalid diagnostic severity: ' + severity);
    }
}
function $10a976939bbc6c50$export$7e704b86437cd056(severity) {
    switch(severity){
        case 'error':
            return (0, $122aedc676522a5a$export$97d57a366f400a9)($10a976939bbc6c50$export$7d47fbcff74879c.LexingError);
        case 'warning':
            return (0, $122aedc676522a5a$export$97d57a366f400a9)($10a976939bbc6c50$export$7d47fbcff74879c.LexingWarning);
        case 'info':
            return (0, $122aedc676522a5a$export$97d57a366f400a9)($10a976939bbc6c50$export$7d47fbcff74879c.LexingInfo);
        case 'hint':
            return (0, $122aedc676522a5a$export$97d57a366f400a9)($10a976939bbc6c50$export$7d47fbcff74879c.LexingHint);
        default:
            throw new Error('Invalid diagnostic severity: ' + severity);
    }
}
var $10a976939bbc6c50$export$7d47fbcff74879c;
(function(DocumentValidator) {
    DocumentValidator.LexingError = 'lexing-error';
    DocumentValidator.LexingWarning = 'lexing-warning';
    DocumentValidator.LexingInfo = 'lexing-info';
    DocumentValidator.LexingHint = 'lexing-hint';
    DocumentValidator.ParsingError = 'parsing-error';
    DocumentValidator.LinkingError = 'linking-error';
})($10a976939bbc6c50$export$7d47fbcff74879c || ($10a976939bbc6c50$export$7d47fbcff74879c = {}));



/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 





class $20dfb38d03ca0518$export$d8f430237f85d6fe {
    constructor(services){
        this.astNodeLocator = services.workspace.AstNodeLocator;
        this.nameProvider = services.references.NameProvider;
    }
    createDescription(node, name, document) {
        const doc = document ?? (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(node);
        name ?? (name = this.nameProvider.getName(node));
        const path = this.astNodeLocator.getAstNodePath(node);
        if (!name) throw new Error(`Node at path ${path} has no name.`);
        let nameNodeSegment;
        const nameSegmentGetter = ()=>nameNodeSegment ?? (nameNodeSegment = (0, $f87d6e075cbbfde9$export$c9a2c6a6b5629cf4)(this.nameProvider.getNameNode(node) ?? node.$cstNode));
        return {
            node: node,
            name: name,
            get nameSegment () {
                return nameSegmentGetter();
            },
            selectionSegment: (0, $f87d6e075cbbfde9$export$c9a2c6a6b5629cf4)(node.$cstNode),
            type: node.$type,
            documentUri: doc.uri,
            path: path
        };
    }
}
class $20dfb38d03ca0518$export$dfc8922e6bc4afce {
    constructor(services){
        this.nodeLocator = services.workspace.AstNodeLocator;
    }
    async createDescriptions(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const descr = [];
        const rootNode = document.parseResult.value;
        for (const astNode of (0, $de130ae470c6cbfb$export$b7350f614170899e)(rootNode)){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            (0, $de130ae470c6cbfb$export$a724fcaa837c6cb2)(astNode).forEach((refInfo)=>{
                if (!refInfo.reference.error) descr.push(...this.createInfoDescriptions(refInfo));
            });
        }
        return descr;
    }
    createInfoDescriptions(refInfo) {
        const reference = refInfo.reference;
        if (reference.error || !reference.$refNode) return [];
        let items = [];
        if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(reference) && reference.$nodeDescription) items = [
            reference.$nodeDescription
        ];
        else if ((0, $09c22474b334b427$export$c99833078476c909)(reference)) items = reference.items.map((e)=>e.$nodeDescription).filter((e)=>e !== undefined);
        const sourceUri = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(refInfo.container).uri;
        const sourcePath = this.nodeLocator.getAstNodePath(refInfo.container);
        const descriptions = [];
        const segment = (0, $f87d6e075cbbfde9$export$c9a2c6a6b5629cf4)(reference.$refNode);
        for (const item of items)descriptions.push({
            sourceUri: sourceUri,
            sourcePath: sourcePath,
            targetUri: item.documentUri,
            targetPath: item.path,
            segment: segment,
            local: (0, $c3a2ae12d89e8820$export$c96870febfa75a76).equals(item.documentUri, sourceUri)
        });
        return descriptions;
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ class $2bc65b9f5e083cd0$export$f89e112f1e9e8018 {
    constructor(){
        this.segmentSeparator = '/';
        this.indexSeparator = '@';
    }
    getAstNodePath(node) {
        if (node.$container) {
            const containerPath = this.getAstNodePath(node.$container);
            const newSegment = this.getPathSegment(node);
            const nodePath = containerPath + this.segmentSeparator + newSegment;
            return nodePath;
        }
        return '';
    }
    getPathSegment({ $containerProperty: $containerProperty, $containerIndex: $containerIndex }) {
        if (!$containerProperty) throw new Error("Missing '$containerProperty' in AST node.");
        if ($containerIndex !== undefined) return $containerProperty + this.indexSeparator + $containerIndex;
        return $containerProperty;
    }
    getAstNode(node, path) {
        const segments = path.split(this.segmentSeparator);
        return segments.reduce((previousValue, currentValue)=>{
            if (!previousValue || currentValue.length === 0) return previousValue;
            const propertyIndex = currentValue.indexOf(this.indexSeparator);
            if (propertyIndex > 0) {
                const property = currentValue.substring(0, propertyIndex);
                const arrayIndex = parseInt(currentValue.substring(propertyIndex + 1));
                const array = previousValue[property];
                return array?.[arrayIndex];
            }
            return previousValue[currentValue];
        }, node);
    }
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

class $a6decb20d3606417$export$2c9bab6ec0183664 {
    constructor(services){
        this._ready = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        this.onConfigurationSectionUpdateEmitter = new (0, $284dfc6cfc7f5287$exports.Emitter)();
        this.settings = {};
        this.workspaceConfig = false;
        this.serviceRegistry = services.ServiceRegistry;
    }
    get ready() {
        return this._ready.promise;
    }
    initialize(params) {
        this.workspaceConfig = params.capabilities.workspace?.configuration ?? false;
    }
    async initialized(params) {
        if (this.workspaceConfig) {
            if (params.register) {
                // params.register(...) is a function to be provided by the calling language server for the sake of
                //  decoupling this implementation from the concrete LSP implementations, specifically the LSP Connection
                const languages = this.serviceRegistry.all;
                params.register({
                    // Listen to configuration changes for all languages
                    section: languages.map((lang)=>this.toSectionName(lang.LanguageMetaData.languageId))
                });
            }
            if (params.fetchConfiguration) {
                // params.fetchConfiguration(...) is a function to be provided by the calling language server for the sake of
                //  decoupling this implementation from the concrete LSP implementations, specifically the LSP Connection
                const configToUpdate = this.serviceRegistry.all.map((lang)=>({
                        // Fetch the configuration changes for all languages
                        section: this.toSectionName(lang.LanguageMetaData.languageId)
                    }));
                // get workspace configurations (default scope URI)
                const configs = await params.fetchConfiguration(configToUpdate);
                configToUpdate.forEach((conf, idx)=>{
                    this.updateSectionConfiguration(conf.section, configs[idx]);
                });
            }
        }
        this._ready.resolve();
    }
    /**
     *  Updates the cached configurations using the `change` notification parameters.
     *
     * @param change The parameters of a change configuration notification.
     * `settings` property of the change object could be expressed as `Record<string, Record<string, any>>`
     */ updateConfiguration(change) {
        if (typeof change.settings !== 'object' || change.settings === null) return;
        Object.entries(change.settings).forEach(([section, configuration])=>{
            this.updateSectionConfiguration(section, configuration);
            this.onConfigurationSectionUpdateEmitter.fire({
                section: section,
                configuration: configuration
            });
        });
    }
    updateSectionConfiguration(section, configuration) {
        this.settings[section] = configuration;
    }
    /**
    * Returns a configuration value stored for the given language.
    *
    * @param language The language id
    * @param configuration Configuration name
    */ async getConfiguration(language, configuration) {
        await this.ready;
        const sectionName = this.toSectionName(language);
        if (this.settings[sectionName]) return this.settings[sectionName][configuration];
    }
    toSectionName(languageId) {
        return `${languageId}`;
    }
    get onConfigurationSectionUpdate() {
        return this.onConfigurationSectionUpdateEmitter.event;
    }
}


/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ var $47e1fb7c1f0e9546$export$252720412a173de;
(function(Disposable) {
    function create(callback) {
        return {
            dispose: async ()=>await callback()
        };
    }
    Disposable.create = create;
})($47e1fb7c1f0e9546$export$252720412a173de || ($47e1fb7c1f0e9546$export$252720412a173de = {}));







class $5b49ac48d62003c4$export$c5b3e0d04e5036b6 {
    constructor(services){
        this.updateBuildOptions = {
            // Default: run only the built-in validation checks and those in the _fast_ category (includes those without category)
            validation: {
                categories: [
                    'built-in',
                    'fast'
                ]
            }
        };
        this.updateListeners = [];
        this.buildPhaseListeners = new (0, $9c40ddedabc72f65$export$c43b025112e292e2)();
        this.documentPhaseListeners = new (0, $9c40ddedabc72f65$export$c43b025112e292e2)();
        this.buildState = new Map();
        this.documentBuildWaiters = new Map();
        this.currentState = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed;
        this.langiumDocuments = services.workspace.LangiumDocuments;
        this.langiumDocumentFactory = services.workspace.LangiumDocumentFactory;
        this.textDocuments = services.workspace.TextDocuments;
        this.indexManager = services.workspace.IndexManager;
        this.fileSystemProvider = services.workspace.FileSystemProvider;
        this.workspaceManager = ()=>services.workspace.WorkspaceManager;
        this.serviceRegistry = services.ServiceRegistry;
    }
    async build(documents, options = {}, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        for (const document of documents){
            const key = document.uri.toString();
            if (document.state === (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Validated) {
                if (typeof options.validation === 'boolean' && options.validation) // Force re-running all validation checks
                this.resetToState(document, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedReferences);
                else if (typeof options.validation === 'object') {
                    // Validation with explicit options was requested for a document that has already been partly validated.
                    // In this case, we need to execute only the missing validation categories.
                    const categories = this.findMissingValidationCategories(document, options);
                    if (categories.length > 0) {
                        // Validate this document, since some of the requested validation categories are not executed yet.
                        //  In all other cases/else-branches, the document is not build at all.
                        this.buildState.set(key, {
                            completed: false,
                            options: {
                                validation: {
                                    categories: categories
                                }
                            },
                            result: this.buildState.get(key)?.result
                        });
                        // Reset the state, but keep the existing validation markers of the already completed validation categories.
                        document.state = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedReferences;
                    }
                }
            } else // Default: forget any previous build options
            this.buildState.delete(key);
        }
        this.currentState = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed;
        await this.emitUpdate(documents.map((e)=>e.uri), []);
        await this.buildDocuments(documents, options, cancelToken);
    }
    async update(changed, deleted, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        this.currentState = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed;
        // Remove all metadata of documents that are reported as deleted
        const deletedUris = [];
        for (const deletedUri of deleted){
            // Since the deleted URI might point to a directory, we delete all documents within
            const deletedDocs = this.langiumDocuments.deleteDocuments(deletedUri);
            for (const doc of deletedDocs){
                deletedUris.push(doc.uri);
                this.cleanUpDeleted(doc);
            }
        }
        // Since the changed URI might point to a directory, we need to check all (nested) documents in that directory
        const changedUris = (await Promise.all(changed.map((uri)=>this.findChangedUris(uri)))).flat();
        // Set the state of all changed documents to `Changed` so they are completely rebuilt
        for (const changedUri of changedUris){
            let changedDocument = this.langiumDocuments.getDocument(changedUri);
            if (changedDocument === undefined) {
                // We create an unparsed, invalid document.
                // This will be parsed as soon as we reach the first document builder phase.
                // This allows to cancel the parsing process later in case we need it.
                changedDocument = this.langiumDocumentFactory.fromModel({
                    $type: 'INVALID'
                }, changedUri);
                changedDocument.state = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed; // required, since `langiumDocumentFactory.fromModel` marks the new document as `DocumentState.Parsed`
                this.langiumDocuments.addDocument(changedDocument);
            }
            this.resetToState(changedDocument, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed);
        }
        // Set the state of all documents that should be relinked to `ComputedScopes` (if not already lower)
        const allChangedUris = (0, $1feb7546a8c17818$export$4938110305e6185f)(changedUris).concat(deletedUris).map((uri)=>uri.toString()).toSet();
        this.langiumDocuments.all.filter((doc)=>!allChangedUris.has(doc.uri.toString()) && this.shouldRelink(doc, allChangedUris)).forEach((doc)=>this.resetToState(doc, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).ComputedScopes));
        // Notify listeners of the update
        await this.emitUpdate(changedUris, deletedUris);
        // Only allow interrupting the execution after all state changes are done
        await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
        // Collect and sort all documents that we should rebuild
        const rebuildDocuments = this.sortDocuments(this.langiumDocuments.all.filter((doc)=>// This includes those that were reported as changed and those that we selected for relinking
            doc.state < (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Validated || !this.buildState.get(doc.uri.toString())?.completed || this.resultsAreIncomplete(doc, this.updateBuildOptions)).toArray());
        await this.buildDocuments(rebuildDocuments, this.updateBuildOptions, cancelToken);
    }
    resultsAreIncomplete(document, options) {
        return this.findMissingValidationCategories(document, options).length >= 1;
    }
    findMissingValidationCategories(document, options) {
        const state = this.buildState.get(document.uri.toString());
        const allCategories = this.serviceRegistry.getServices(document.uri).validation.ValidationRegistry.getAllValidationCategories(document);
        const executedCategories = state?.result?.validationChecks ? new Set(state?.result?.validationChecks) : state?.completed ? allCategories : new Set();
        const requestedCategories = options === undefined || options.validation === true ? allCategories : typeof options.validation === 'object' ? options.validation.categories ?? allCategories : [];
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(requestedCategories).filter((requested)=>!executedCategories.has(requested)).toArray();
    }
    async findChangedUris(changed) {
        // Most common case is that the document/textDocument at the specified URI has changed
        const document = this.langiumDocuments.getDocument(changed) ?? this.textDocuments?.get(changed);
        if (document) return [
            changed
        ];
        // If the document doesn't exist yet, we need to check what kind of file has changed
        try {
            const stat = await this.fileSystemProvider.stat(changed);
            if (stat.isDirectory) {
                // If a directory has changed, we need to check all documents in that directory
                const uris = await this.workspaceManager().searchFolder(changed);
                return uris;
            } else if (this.workspaceManager().shouldIncludeEntry(stat)) // Return the changed URI if it's a file that we can handle
            return [
                changed
            ];
        } catch  {
        // If we can't determine the file type, we discard the change
        }
        return [];
    }
    async emitUpdate(changed, deleted) {
        await Promise.all(this.updateListeners.map((listener)=>listener(changed, deleted)));
    }
    /**
     * Sort the given documents by priority. By default, documents with an open text document are prioritized.
     * This is useful to ensure that visible documents show their diagnostics before all other documents.
     *
     * This improves the responsiveness in large workspaces as users usually don't care about diagnostics
     * in files that are currently not opened in the editor.
     */ sortDocuments(documents) {
        let left = 0;
        let right = documents.length - 1;
        while(left < right){
            while(left < documents.length && this.hasTextDocument(documents[left]))left++;
            while(right >= 0 && !this.hasTextDocument(documents[right]))right--;
            if (left < right) [documents[left], documents[right]] = [
                documents[right],
                documents[left]
            ];
        }
        return documents;
    }
    hasTextDocument(doc) {
        return Boolean(this.textDocuments?.get(doc.uri));
    }
    /**
     * Check whether the given document should be relinked after changes were found in the given URIs.
     */ shouldRelink(document, changedUris) {
        // Relink documents with linking errors -- maybe those references can be resolved now
        if (document.references.some((ref)=>ref.error !== undefined)) return true;
        // Check whether the document is affected by any of the changed URIs
        return this.indexManager.isAffected(document, changedUris);
    }
    onUpdate(callback) {
        this.updateListeners.push(callback);
        return (0, $47e1fb7c1f0e9546$export$252720412a173de).create(()=>{
            const index = this.updateListeners.indexOf(callback);
            if (index >= 0) this.updateListeners.splice(index, 1);
        });
    }
    resetToState(document, state) {
        switch(state){
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed:
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Parsed:
                this.indexManager.removeContent(document.uri);
            // Fall through
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedContent:
                document.localSymbols = undefined;
            // Fall through
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).ComputedScopes:
                {
                    const linker = this.serviceRegistry.getServices(document.uri).references.Linker;
                    linker.unlink(document);
                // Fall through
                }
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Linked:
                this.indexManager.removeReferences(document.uri);
            // Fall through
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedReferences:
                document.diagnostics = undefined;
                this.buildState.delete(document.uri.toString());
            // Fall through
            case (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Validated:
        }
        if (document.state > state) document.state = state;
    }
    cleanUpDeleted(document) {
        this.buildState.delete(document.uri.toString());
        this.indexManager.remove(document.uri);
        // Since this method `cleanUpDeleted` is not available from outside, the following line is not necessary, since the state is already set before.
        //  This line does not hurt and makes the code to be in sync with `resetToState`.
        //  If `cleanUpDeleted` is called in custom document builders at some more places, this line becomes necessary.
        document.state = (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Changed;
    }
    /**
     * Build the given documents by stepping through all build phases. If a document's state indicates
     * that a certain build phase is already done, the phase is skipped for that document.
     *
     * @param documents The documents to build.
     * @param options the {@link BuildOptions} to use.
     * @param cancelToken A cancellation token that can be used to cancel the build.
     * @returns A promise that resolves when the build is done.
     */ async buildDocuments(documents, options, cancelToken) {
        this.prepareBuild(documents, options);
        // 0. Parse content
        await this.runCancelable(documents, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Parsed, cancelToken, (doc)=>this.langiumDocumentFactory.update(doc, cancelToken));
        // 1. Index content: collect the documents' symbols being accessible by other documents
        await this.runCancelable(documents, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedContent, cancelToken, (doc)=>this.indexManager.updateContent(doc, cancelToken));
        // 2. Local symbols: collect each documents' symbols being accessible within the document (only)
        await this.runCancelable(documents, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).ComputedScopes, cancelToken, async (doc)=>{
            const scopeComputation = this.serviceRegistry.getServices(doc.uri).references.ScopeComputation;
            doc.localSymbols = await scopeComputation.collectLocalSymbols(doc, cancelToken);
        });
        // 3. Linking
        const toBeLinked = documents.filter((doc)=>this.shouldLink(doc));
        await this.runCancelable(toBeLinked, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Linked, cancelToken, (doc)=>{
            const linker = this.serviceRegistry.getServices(doc.uri).references.Linker;
            return linker.link(doc, cancelToken);
        });
        // 4. Index references
        await this.runCancelable(toBeLinked, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).IndexedReferences, cancelToken, (doc)=>this.indexManager.updateReferences(doc, cancelToken));
        // 5. Validation
        const toBeValidated = documents.filter((doc)=>{
            if (this.shouldValidate(doc)) return true; // the build state is marked as completed after finishing the validation for the current document
            else {
                this.markAsCompleted(doc); // since the validation is skipped for this document, it is already completed now
                return false;
            }
        });
        await this.runCancelable(toBeValidated, (0, $4ec1768ef727cb18$export$4c6f7616f18c0be).Validated, cancelToken, async (doc)=>{
            await this.validate(doc, cancelToken);
            this.markAsCompleted(doc);
        });
    }
    markAsCompleted(document) {
        const state = this.buildState.get(document.uri.toString());
        if (state) state.completed = true;
    }
    /**
     * Runs prior to beginning the build process to update the {@link DocumentBuildState} for each document
     *
     * @param documents collection of documents to be built
     * @param options the {@link BuildOptions} to use
     */ prepareBuild(documents, options) {
        for (const doc of documents){
            const key = doc.uri.toString();
            const state = this.buildState.get(key);
            if (!state // If the document has no previous build state, we set it.
             || state.completed // If it has one, but it's already marked as completed, we overwrite it.
            ) this.buildState.set(key, {
                completed: false,
                options: options,
                result: state?.result
            });
        }
    }
    /**
     * Runs a cancelable operation on a set of documents to bring them to a specified {@link DocumentState}.
     *
     * @param documents The array of documents to process.
     * @param targetState The target {@link DocumentState} to bring the documents to.
     * @param cancelToken A token that can be used to cancel the operation.
     * @param callback A function to be called for each document.
     * @returns A promise that resolves when all documents have been processed or the operation is canceled.
     * @throws Will throw `OperationCancelled` if the operation is canceled via a `CancellationToken`.
     */ async runCancelable(documents, targetState, cancelToken, callback) {
        for (const document of documents)if (document.state < targetState) {
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            await callback(document);
            document.state = targetState;
            await this.notifyDocumentPhase(document, targetState, cancelToken);
        }
        // Do not use `filtered` here, as that will miss documents that have previously reached the current target state.
        // For example, this happens in case the cancellation triggers between the processing of two documents
        // or files that were picked up during the workspace initialization.
        const targetStateDocs = documents.filter((doc)=>doc.state === targetState);
        await this.notifyBuildPhase(targetStateDocs, targetState, cancelToken);
        this.currentState = targetState;
    }
    onBuildPhase(targetState, callback) {
        this.buildPhaseListeners.add(targetState, callback);
        return (0, $47e1fb7c1f0e9546$export$252720412a173de).create(()=>{
            this.buildPhaseListeners.delete(targetState, callback);
        });
    }
    onDocumentPhase(targetState, callback) {
        this.documentPhaseListeners.add(targetState, callback);
        return (0, $47e1fb7c1f0e9546$export$252720412a173de).create(()=>{
            this.documentPhaseListeners.delete(targetState, callback);
        });
    }
    waitUntil(state, uriOrToken, cancelToken) {
        let uri = undefined;
        if (uriOrToken && 'path' in uriOrToken) uri = uriOrToken;
        else cancelToken = uriOrToken;
        cancelToken ?? (cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None);
        if (uri) return this.awaitDocumentState(state, uri, cancelToken);
        else return this.awaitBuilderState(state, cancelToken);
    }
    awaitDocumentState(state, uri, cancelToken) {
        const document = this.langiumDocuments.getDocument(uri);
        if (!document) return Promise.reject(new (0, $284dfc6cfc7f5287$exports.ResponseError)((0, $284dfc6cfc7f5287$exports.LSPErrorCodes).ServerCancelled, `No document found for URI: ${uri.toString()}`));
        else if (document.state >= state) return Promise.resolve(uri);
        else if (cancelToken.isCancellationRequested) return Promise.reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
        else if (this.currentState >= state && state > document.state) // this would imply that the document has been excluded from linking or validation, for example;
        // this should never occur, the LS need to make sure that the affected document is properly built,
        //  alternatively, the build state requirement need to be relaxed.
        return Promise.reject(new (0, $284dfc6cfc7f5287$exports.ResponseError)((0, $284dfc6cfc7f5287$exports.LSPErrorCodes).RequestFailed, `Document state of ${uri.toString()} is ${(0, $4ec1768ef727cb18$export$4c6f7616f18c0be)[document.state]}, requiring ${(0, $4ec1768ef727cb18$export$4c6f7616f18c0be)[state]}, but workspace state is already ${(0, $4ec1768ef727cb18$export$4c6f7616f18c0be)[this.currentState]}. Returning undefined.`));
        return new Promise((resolve, reject)=>{
            const buildDisposable = this.onDocumentPhase(state, (doc)=>{
                if ((0, $c3a2ae12d89e8820$export$c96870febfa75a76).equals(doc.uri, uri)) {
                    buildDisposable.dispose();
                    cancelDisposable.dispose();
                    resolve(doc.uri);
                }
            });
            const cancelDisposable = cancelToken.onCancellationRequested(()=>{
                buildDisposable.dispose();
                cancelDisposable.dispose();
                reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
            });
        });
    }
    awaitBuilderState(state, cancelToken) {
        if (this.currentState >= state) return Promise.resolve();
        else if (cancelToken.isCancellationRequested) return Promise.reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
        return new Promise((resolve, reject)=>{
            const buildDisposable = this.onBuildPhase(state, ()=>{
                buildDisposable.dispose();
                cancelDisposable.dispose();
                resolve();
            });
            const cancelDisposable = cancelToken.onCancellationRequested(()=>{
                buildDisposable.dispose();
                cancelDisposable.dispose();
                reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
            });
        });
    }
    async notifyDocumentPhase(document, state, cancelToken) {
        const listeners = this.documentPhaseListeners.get(state);
        const listenersCopy = listeners.slice();
        for (const listener of listenersCopy)try {
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            await listener(document, cancelToken);
        } catch (err) {
            // Ignore cancellation errors
            // We want to finish the listeners before throwing
            if (!(0, $4fb404a672a62c84$export$5b2d4ab85306fab5)(err)) throw err;
        }
    }
    async notifyBuildPhase(documents, state, cancelToken) {
        if (documents.length === 0) // Don't notify when no document has been processed
        return;
        const listeners = this.buildPhaseListeners.get(state);
        const listenersCopy = listeners.slice();
        for (const listener of listenersCopy){
            await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
            await listener(documents, cancelToken);
        }
    }
    /**
     * Determine whether the given document should be linked during a build. The default
     * implementation checks the `eagerLinking` property of the build options. If it's set to `true`
     * or `undefined`, the document is included in the linking phase. This also affects the
     * references indexing phase, which depends on eager linking.
     */ shouldLink(document) {
        return this.getBuildOptions(document).eagerLinking ?? true;
    }
    /**
     * Determine whether the given document should be validated during a build. The default
     * implementation checks the `validation` property of the build options. If it's set to `true`
     * or a `ValidationOptions` object, the document is included in the validation phase.
     */ shouldValidate(document) {
        return Boolean(this.getBuildOptions(document).validation);
    }
    /**
     * Run validation checks on the given document and store the resulting diagnostics in the document.
     * If the document already contains diagnostics, the new ones are added to the list.
     */ async validate(document, cancelToken) {
        const validator = this.serviceRegistry.getServices(document.uri).validation.DocumentValidator;
        const options = this.getBuildOptions(document);
        const validationOptions = typeof options.validation === 'object' ? {
            ...options.validation
        } : {};
        validationOptions.categories = this.findMissingValidationCategories(document, options); // execute only not-yet-executed categories
        const diagnostics = await validator.validateDocument(document, validationOptions, cancelToken);
        if (document.diagnostics) document.diagnostics.push(...diagnostics); // keep diagnostics of previously executed categories
        else document.diagnostics = diagnostics;
        // Store information about the executed validation in the build state
        const state = this.buildState.get(document.uri.toString());
        if (state) {
            state.result ?? (state.result = {});
            if (state.result.validationChecks) state.result.validationChecks = (0, $1feb7546a8c17818$export$4938110305e6185f)(state.result.validationChecks).concat(validationOptions.categories).distinct().toArray();
            else state.result.validationChecks = [
                ...validationOptions.categories
            ];
        }
    }
    getBuildOptions(document) {
        return this.buildState.get(document.uri.toString())?.options ?? {};
    }
}



/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 




class $0110b9418025e830$export$a50279bedae990c3 {
    constructor(services){
        /**
         * The symbol index stores all `AstNodeDescription` items exported by a document.
         * The key used in this map is the string representation of the specific document URI.
         */ this.symbolIndex = new Map();
        /**
         * This is a cache for the `allElements()` method.
         * It caches the descriptions from `symbolIndex` grouped by types.
         */ this.symbolByTypeIndex = new (0, $d5c638f1e4023415$export$e910ddfc8c19083)();
        /**
         * This index keeps track of all `ReferenceDescription` items exported by a document.
         * This is used to compute which elements are affected by a document change
         * and for finding references to an AST node.
         */ this.referenceIndex = new Map();
        this.documents = services.workspace.LangiumDocuments;
        this.serviceRegistry = services.ServiceRegistry;
        this.astReflection = services.AstReflection;
    }
    findAllReferences(targetNode, astNodePath) {
        const targetDocUri = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(targetNode).uri;
        const result = [];
        this.referenceIndex.forEach((docRefs)=>{
            docRefs.forEach((refDescr)=>{
                if ((0, $c3a2ae12d89e8820$export$c96870febfa75a76).equals(refDescr.targetUri, targetDocUri) && refDescr.targetPath === astNodePath) result.push(refDescr);
            });
        });
        return (0, $1feb7546a8c17818$export$4938110305e6185f)(result);
    }
    allElements(nodeType, uris) {
        let documentUris = (0, $1feb7546a8c17818$export$4938110305e6185f)(this.symbolIndex.keys());
        if (uris) documentUris = documentUris.filter((uri)=>!uris || uris.has(uri));
        return documentUris.map((uri)=>this.getFileDescriptions(uri, nodeType)).flat();
    }
    getFileDescriptions(uri, nodeType) {
        if (!nodeType) return this.symbolIndex.get(uri) ?? [];
        const descriptions = this.symbolByTypeIndex.get(uri, nodeType, ()=>{
            const allFileDescriptions = this.symbolIndex.get(uri) ?? [];
            return allFileDescriptions.filter((e)=>this.astReflection.isSubtype(e.type, nodeType));
        });
        return descriptions;
    }
    remove(uri) {
        this.removeContent(uri);
        this.removeReferences(uri);
    }
    removeContent(uri) {
        const uriString = uri.toString();
        this.symbolIndex.delete(uriString);
        this.symbolByTypeIndex.clear(uriString);
    }
    removeReferences(uri) {
        const uriString = uri.toString();
        this.referenceIndex.delete(uriString);
    }
    async updateContent(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const services = this.serviceRegistry.getServices(document.uri);
        const exports = await services.references.ScopeComputation.collectExportedSymbols(document, cancelToken);
        const uri = document.uri.toString();
        this.symbolIndex.set(uri, exports);
        this.symbolByTypeIndex.clear(uri);
    }
    async updateReferences(document, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const services = this.serviceRegistry.getServices(document.uri);
        const indexData = await services.workspace.ReferenceDescriptionProvider.createDescriptions(document, cancelToken);
        this.referenceIndex.set(document.uri.toString(), indexData);
    }
    isAffected(document, changedUris) {
        const references = this.referenceIndex.get(document.uri.toString());
        if (!references) return false;
        return references.some((ref)=>!ref.local && changedUris.has(ref.targetUri.toString()));
    }
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 



class $446d327cd6412534$export$cca55013f2a76810 {
    constructor(services){
        this.initialBuildOptions = {};
        this._ready = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        this.serviceRegistry = services.ServiceRegistry;
        this.langiumDocuments = services.workspace.LangiumDocuments;
        this.documentBuilder = services.workspace.DocumentBuilder;
        this.fileSystemProvider = services.workspace.FileSystemProvider;
        this.mutex = services.workspace.WorkspaceLock;
    }
    get ready() {
        return this._ready.promise;
    }
    get workspaceFolders() {
        return this.folders;
    }
    initialize(params) {
        this.folders = params.workspaceFolders ?? undefined;
    }
    initialized(_params) {
        // Initialize the workspace even if there are no workspace folders
        // We still want to load additional documents (language library or similar) during initialization
        return this.mutex.write((token)=>this.initializeWorkspace(this.folders ?? [], token));
    }
    async initializeWorkspace(folders, cancelToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const documents = await this.performStartup(folders);
        // Only after creating all documents do we check whether we need to cancel the initialization
        // The document builder will later pick up on all unprocessed documents
        await (0, $4fb404a672a62c84$export$bdfe86f6b3074c59)(cancelToken);
        await this.documentBuilder.build(documents, this.initialBuildOptions, cancelToken);
    }
    /**
     * Performs the uninterruptable startup sequence of the workspace manager.
     * This methods loads all documents in the workspace and other documents and returns them.
     */ async performStartup(folders) {
        const documents = [];
        const collector = (document)=>{
            documents.push(document);
            if (!this.langiumDocuments.hasDocument(document.uri)) this.langiumDocuments.addDocument(document);
        };
        // Even though we don't await the initialization of the workspace manager,
        // we can still assume that all library documents and file documents are loaded by the time we start building documents.
        // The mutex prevents anything from performing a workspace build until we check the cancellation token
        await this.loadAdditionalDocuments(folders, collector);
        const uris = [];
        await Promise.all(folders.map((wf)=>this.getRootFolder(wf)).map(async (entry)=>this.traverseFolder(entry, uris)));
        const uniqueUris = (0, $1feb7546a8c17818$export$4938110305e6185f)(uris)// Ensure that we only create one document per URI/file
        .distinct((uri)=>uri.toString())// Also ensure that the documents don't already exist
        .filter((uri)=>!this.langiumDocuments.hasDocument(uri));
        await this.loadWorkspaceDocuments(uniqueUris, collector);
        this._ready.resolve();
        return documents;
    }
    async loadWorkspaceDocuments(uris, collector) {
        await Promise.all(uris.map(async (uri)=>{
            const document = await this.langiumDocuments.getOrCreateDocument(uri);
            collector(document);
        }));
    }
    /**
     * Load all additional documents that shall be visible in the context of the given workspace
     * folders and add them to the collector. This can be used to include built-in libraries of
     * your language, which can be either loaded from provided files or constructed in memory.
     */ loadAdditionalDocuments(_folders, _collector) {
        return Promise.resolve();
    }
    /**
     * Determine the root folder of the source documents in the given workspace folder.
     * The default implementation returns the URI of the workspace folder, but you can override
     * this to return a subfolder like `src` instead.
     */ getRootFolder(workspaceFolder) {
        return (0, $3a1a3bfcc859a329$exports.URI).parse(workspaceFolder.uri);
    }
    /**
     * Traverse the file system folder identified by the given URI and its subfolders. All
     * contained files that match the file extensions are added to the `uris` array.
     */ async traverseFolder(folderPath, uris) {
        try {
            const content = await this.fileSystemProvider.readDirectory(folderPath);
            await Promise.all(content.map(async (entry)=>{
                if (this.shouldIncludeEntry(entry)) {
                    if (entry.isDirectory) await this.traverseFolder(entry.uri, uris);
                    else if (entry.isFile) uris.push(entry.uri);
                }
            }));
        } catch (e) {
            console.error('Failure to read directory content of ' + folderPath.toString(true), e);
        }
    }
    async searchFolder(uri) {
        const uris = [];
        await this.traverseFolder(uri, uris);
        return uris;
    }
    /**
     * Determine whether the given folder entry shall be included while indexing the workspace.
     */ shouldIncludeEntry(entry) {
        const name = (0, $c3a2ae12d89e8820$export$c96870febfa75a76).basename(entry.uri);
        if (name.startsWith('.')) return false;
        if (entry.isDirectory) return name !== 'node_modules' && name !== 'out';
        else if (entry.isFile) return this.serviceRegistry.hasServices(entry.uri);
        return false;
    }
}


/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
class $6204b5d2fabba386$export$a52adb64236636f9 {
    buildUnexpectedCharactersMessage(fullText, startOffset, length, line, column) {
        return (0, $5d51f81a4b917e73$export$cc067353be7648a1).buildUnexpectedCharactersMessage(fullText, startOffset, length, line, column);
    }
    buildUnableToPopLexerModeMessage(token) {
        return (0, $5d51f81a4b917e73$export$cc067353be7648a1).buildUnableToPopLexerModeMessage(token);
    }
}
const $6204b5d2fabba386$export$ce0418428e719b7f = {
    mode: 'full'
};
class $6204b5d2fabba386$export$98868b256b874b9b {
    constructor(services){
        this.errorMessageProvider = services.parser.LexerErrorMessageProvider;
        this.tokenBuilder = services.parser.TokenBuilder;
        const tokens = this.tokenBuilder.buildTokens(services.Grammar, {
            caseInsensitive: services.LanguageMetaData.caseInsensitive
        });
        this.tokenTypes = this.toTokenTypeDictionary(tokens);
        const lexerTokens = $6204b5d2fabba386$export$e2cc90b809b48400(tokens) ? Object.values(tokens) : tokens;
        const production = services.LanguageMetaData.mode === 'production';
        this.chevrotainLexer = new (0, $5d51f81a4b917e73$export$6168dc8908a6c652)(lexerTokens, {
            positionTracking: 'full',
            skipValidations: production,
            errorMessageProvider: this.errorMessageProvider
        });
    }
    get definition() {
        return this.tokenTypes;
    }
    tokenize(text, _options = $6204b5d2fabba386$export$ce0418428e719b7f) {
        const chevrotainResult = this.chevrotainLexer.tokenize(text);
        return {
            tokens: chevrotainResult.tokens,
            errors: chevrotainResult.errors,
            hidden: chevrotainResult.groups.hidden ?? [],
            report: this.tokenBuilder.flushLexingReport?.(text)
        };
    }
    toTokenTypeDictionary(buildTokens) {
        if ($6204b5d2fabba386$export$e2cc90b809b48400(buildTokens)) return buildTokens;
        const tokens = $6204b5d2fabba386$export$ca0e00777bdfe08f(buildTokens) ? Object.values(buildTokens.modes).flat() : buildTokens;
        const res = {};
        tokens.forEach((token)=>res[token.name] = token);
        return res;
    }
}
function $6204b5d2fabba386$export$ab1e5e9cca4c39ce(tokenVocabulary) {
    return Array.isArray(tokenVocabulary) && (tokenVocabulary.length === 0 || 'name' in tokenVocabulary[0]);
}
function $6204b5d2fabba386$export$ca0e00777bdfe08f(tokenVocabulary) {
    return tokenVocabulary && 'modes' in tokenVocabulary && 'defaultMode' in tokenVocabulary;
}
function $6204b5d2fabba386$export$e2cc90b809b48400(tokenVocabulary) {
    return !$6204b5d2fabba386$export$ab1e5e9cca4c39ce(tokenVocabulary) && !$6204b5d2fabba386$export$ca0e00777bdfe08f(tokenVocabulary);
}


/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 
var $bDmGd = parcelRequire("bDmGd");


function $ac320a7b66e79f5e$export$bf390bbdbaa3844f(node, start, options) {
    let opts;
    let position;
    if (typeof node === 'string') {
        position = start;
        opts = options;
    } else {
        position = node.range.start;
        opts = start;
    }
    if (!position) position = (0, $bDmGd.Position).create(0, 0);
    const lines = $ac320a7b66e79f5e$var$getLines(node);
    const normalizedOptions = $ac320a7b66e79f5e$var$normalizeOptions(opts);
    const tokens = $ac320a7b66e79f5e$var$tokenize({
        lines: lines,
        position: position,
        options: normalizedOptions
    });
    return $ac320a7b66e79f5e$var$parseJSDocComment({
        index: 0,
        tokens: tokens,
        position: position
    });
}
function $ac320a7b66e79f5e$export$747a6966af0d33f0(node, options) {
    const normalizedOptions = $ac320a7b66e79f5e$var$normalizeOptions(options);
    const lines = $ac320a7b66e79f5e$var$getLines(node);
    if (lines.length === 0) return false;
    const first = lines[0];
    const last = lines[lines.length - 1];
    const firstRegex = normalizedOptions.start;
    const lastRegex = normalizedOptions.end;
    return Boolean(firstRegex?.exec(first)) && Boolean(lastRegex?.exec(last));
}
function $ac320a7b66e79f5e$var$getLines(node) {
    let content = '';
    if (typeof node === 'string') content = node;
    else content = node.text;
    const lines = content.split((0, $f53f8e965a7efa80$export$5d8e12a48f5d751a));
    return lines;
}
const $ac320a7b66e79f5e$var$tagRegex = /\s*(@([\p{L}][\p{L}\p{N}]*)?)/uy;
const $ac320a7b66e79f5e$var$inlineTagRegex = /\{(@[\p{L}][\p{L}\p{N}]*)(\s*)([^\r\n}]+)?\}/gu;
function $ac320a7b66e79f5e$var$tokenize(context) {
    const tokens = [];
    let currentLine = context.position.line;
    let currentCharacter = context.position.character;
    for(let i = 0; i < context.lines.length; i++){
        const first = i === 0;
        const last = i === context.lines.length - 1;
        let line = context.lines[i];
        let index = 0;
        if (first && context.options.start) {
            const match = context.options.start?.exec(line);
            if (match) index = match.index + match[0].length;
        } else {
            const match = context.options.line?.exec(line);
            if (match) index = match.index + match[0].length;
        }
        if (last) {
            const match = context.options.end?.exec(line);
            if (match) line = line.substring(0, match.index);
        }
        line = line.substring(0, $ac320a7b66e79f5e$var$lastCharacter(line));
        const whitespaceEnd = $ac320a7b66e79f5e$var$skipWhitespace(line, index);
        if (whitespaceEnd >= line.length) // Only create a break token when we already have previous tokens
        {
            if (tokens.length > 0) {
                const position = (0, $bDmGd.Position).create(currentLine, currentCharacter);
                tokens.push({
                    type: 'break',
                    content: '',
                    range: (0, $bDmGd.Range).create(position, position)
                });
            }
        } else {
            $ac320a7b66e79f5e$var$tagRegex.lastIndex = index;
            const tagMatch = $ac320a7b66e79f5e$var$tagRegex.exec(line);
            if (tagMatch) {
                const fullMatch = tagMatch[0];
                const value = tagMatch[1];
                const start = (0, $bDmGd.Position).create(currentLine, currentCharacter + index);
                const end = (0, $bDmGd.Position).create(currentLine, currentCharacter + index + fullMatch.length);
                tokens.push({
                    type: 'tag',
                    content: value,
                    range: (0, $bDmGd.Range).create(start, end)
                });
                index += fullMatch.length;
                index = $ac320a7b66e79f5e$var$skipWhitespace(line, index);
            }
            if (index < line.length) {
                const rest = line.substring(index);
                const inlineTagMatches = Array.from(rest.matchAll($ac320a7b66e79f5e$var$inlineTagRegex));
                tokens.push(...$ac320a7b66e79f5e$var$buildInlineTokens(inlineTagMatches, rest, currentLine, currentCharacter + index));
            }
        }
        currentLine++;
        currentCharacter = 0;
    }
    // Remove last break token if there is one
    if (tokens.length > 0 && tokens[tokens.length - 1].type === 'break') return tokens.slice(0, -1);
    return tokens;
}
function $ac320a7b66e79f5e$var$buildInlineTokens(tags, line, lineIndex, characterIndex) {
    const tokens = [];
    if (tags.length === 0) {
        const start = (0, $bDmGd.Position).create(lineIndex, characterIndex);
        const end = (0, $bDmGd.Position).create(lineIndex, characterIndex + line.length);
        tokens.push({
            type: 'text',
            content: line,
            range: (0, $bDmGd.Range).create(start, end)
        });
    } else {
        let lastIndex = 0;
        for (const match of tags){
            const matchIndex = match.index;
            const startContent = line.substring(lastIndex, matchIndex);
            if (startContent.length > 0) tokens.push({
                type: 'text',
                content: line.substring(lastIndex, matchIndex),
                range: (0, $bDmGd.Range).create((0, $bDmGd.Position).create(lineIndex, lastIndex + characterIndex), (0, $bDmGd.Position).create(lineIndex, matchIndex + characterIndex))
            });
            let offset = startContent.length + 1;
            const tagName = match[1];
            tokens.push({
                type: 'inline-tag',
                content: tagName,
                range: (0, $bDmGd.Range).create((0, $bDmGd.Position).create(lineIndex, lastIndex + offset + characterIndex), (0, $bDmGd.Position).create(lineIndex, lastIndex + offset + tagName.length + characterIndex))
            });
            offset += tagName.length;
            if (match.length === 4) {
                offset += match[2].length;
                const value = match[3];
                tokens.push({
                    type: 'text',
                    content: value,
                    range: (0, $bDmGd.Range).create((0, $bDmGd.Position).create(lineIndex, lastIndex + offset + characterIndex), (0, $bDmGd.Position).create(lineIndex, lastIndex + offset + value.length + characterIndex))
                });
            } else tokens.push({
                type: 'text',
                content: '',
                range: (0, $bDmGd.Range).create((0, $bDmGd.Position).create(lineIndex, lastIndex + offset + characterIndex), (0, $bDmGd.Position).create(lineIndex, lastIndex + offset + characterIndex))
            });
            lastIndex = matchIndex + match[0].length;
        }
        const endContent = line.substring(lastIndex);
        if (endContent.length > 0) tokens.push({
            type: 'text',
            content: endContent,
            range: (0, $bDmGd.Range).create((0, $bDmGd.Position).create(lineIndex, lastIndex + characterIndex), (0, $bDmGd.Position).create(lineIndex, lastIndex + characterIndex + endContent.length))
        });
    }
    return tokens;
}
const $ac320a7b66e79f5e$var$nonWhitespaceRegex = /\S/;
const $ac320a7b66e79f5e$var$whitespaceEndRegex = /\s*$/;
function $ac320a7b66e79f5e$var$skipWhitespace(line, index) {
    const match = line.substring(index).match($ac320a7b66e79f5e$var$nonWhitespaceRegex);
    if (match) return index + match.index;
    else return line.length;
}
function $ac320a7b66e79f5e$var$lastCharacter(line) {
    const match = line.match($ac320a7b66e79f5e$var$whitespaceEndRegex);
    if (match && typeof match.index === 'number') return match.index;
    return undefined;
}
// Parsing
function $ac320a7b66e79f5e$var$parseJSDocComment(context) {
    const startPosition = (0, $bDmGd.Position).create(context.position.line, context.position.character);
    if (context.tokens.length === 0) return new $ac320a7b66e79f5e$var$JSDocCommentImpl([], (0, $bDmGd.Range).create(startPosition, startPosition));
    const elements = [];
    while(context.index < context.tokens.length){
        const element = $ac320a7b66e79f5e$var$parseJSDocElement(context, elements[elements.length - 1]);
        if (element) elements.push(element);
    }
    const start = elements[0]?.range.start ?? startPosition;
    const end = elements[elements.length - 1]?.range.end ?? startPosition;
    return new $ac320a7b66e79f5e$var$JSDocCommentImpl(elements, (0, $bDmGd.Range).create(start, end));
}
function $ac320a7b66e79f5e$var$parseJSDocElement(context, last) {
    const next = context.tokens[context.index];
    if (next.type === 'tag') return $ac320a7b66e79f5e$var$parseJSDocTag(context, false);
    else if (next.type === 'text' || next.type === 'inline-tag') return $ac320a7b66e79f5e$var$parseJSDocText(context);
    else {
        $ac320a7b66e79f5e$var$appendEmptyLine(next, last);
        context.index++;
        return undefined;
    }
}
function $ac320a7b66e79f5e$var$appendEmptyLine(token, element) {
    if (element) {
        const line = new $ac320a7b66e79f5e$var$JSDocLineImpl('', token.range);
        if ('inlines' in element) element.inlines.push(line);
        else element.content.inlines.push(line);
    }
}
function $ac320a7b66e79f5e$var$parseJSDocText(context) {
    let token = context.tokens[context.index];
    const firstToken = token;
    let lastToken = token;
    const lines = [];
    while(token && token.type !== 'break' && token.type !== 'tag'){
        lines.push($ac320a7b66e79f5e$var$parseJSDocInline(context));
        lastToken = token;
        token = context.tokens[context.index];
    }
    return new $ac320a7b66e79f5e$var$JSDocTextImpl(lines, (0, $bDmGd.Range).create(firstToken.range.start, lastToken.range.end));
}
function $ac320a7b66e79f5e$var$parseJSDocInline(context) {
    const token = context.tokens[context.index];
    if (token.type === 'inline-tag') return $ac320a7b66e79f5e$var$parseJSDocTag(context, true);
    else return $ac320a7b66e79f5e$var$parseJSDocLine(context);
}
function $ac320a7b66e79f5e$var$parseJSDocTag(context, inline) {
    const tagToken = context.tokens[context.index++];
    const name = tagToken.content.substring(1);
    const nextToken = context.tokens[context.index];
    if (nextToken?.type === 'text') {
        if (inline) {
            const docLine = $ac320a7b66e79f5e$var$parseJSDocLine(context);
            return new $ac320a7b66e79f5e$var$JSDocTagImpl(name, new $ac320a7b66e79f5e$var$JSDocTextImpl([
                docLine
            ], docLine.range), inline, (0, $bDmGd.Range).create(tagToken.range.start, docLine.range.end));
        } else {
            const textDoc = $ac320a7b66e79f5e$var$parseJSDocText(context);
            return new $ac320a7b66e79f5e$var$JSDocTagImpl(name, textDoc, inline, (0, $bDmGd.Range).create(tagToken.range.start, textDoc.range.end));
        }
    } else {
        const range = tagToken.range;
        return new $ac320a7b66e79f5e$var$JSDocTagImpl(name, new $ac320a7b66e79f5e$var$JSDocTextImpl([], range), inline, range);
    }
}
function $ac320a7b66e79f5e$var$parseJSDocLine(context) {
    const token = context.tokens[context.index++];
    return new $ac320a7b66e79f5e$var$JSDocLineImpl(token.content, token.range);
}
function $ac320a7b66e79f5e$var$normalizeOptions(options) {
    if (!options) return $ac320a7b66e79f5e$var$normalizeOptions({
        start: '/**',
        end: '*/',
        line: '*'
    });
    const { start: start, end: end, line: line } = options;
    return {
        start: $ac320a7b66e79f5e$var$normalizeOption(start, true),
        end: $ac320a7b66e79f5e$var$normalizeOption(end, false),
        line: $ac320a7b66e79f5e$var$normalizeOption(line, true)
    };
}
function $ac320a7b66e79f5e$var$normalizeOption(option, start) {
    if (typeof option === 'string' || typeof option === 'object') {
        const escaped = typeof option === 'string' ? (0, $f53f8e965a7efa80$export$7c57da42ce8e346f)(option) : option.source;
        if (start) return new RegExp(`^\\s*${escaped}`);
        else return new RegExp(`\\s*${escaped}\\s*$`);
    } else return option;
}
class $ac320a7b66e79f5e$var$JSDocCommentImpl {
    constructor(elements, range){
        this.elements = elements;
        this.range = range;
    }
    getTag(name) {
        return this.getAllTags().find((e)=>e.name === name);
    }
    getTags(name) {
        return this.getAllTags().filter((e)=>e.name === name);
    }
    getAllTags() {
        return this.elements.filter((e)=>'name' in e);
    }
    toString() {
        let value = '';
        for (const element of this.elements)if (value.length === 0) value = element.toString();
        else {
            const text = element.toString();
            value += $ac320a7b66e79f5e$var$fillNewlines(value) + text;
        }
        return value.trim();
    }
    toMarkdown(options) {
        let value = '';
        for (const element of this.elements)if (value.length === 0) value = element.toMarkdown(options);
        else {
            const text = element.toMarkdown(options);
            value += $ac320a7b66e79f5e$var$fillNewlines(value) + text;
        }
        return value.trim();
    }
}
class $ac320a7b66e79f5e$var$JSDocTagImpl {
    constructor(name, content, inline, range){
        this.name = name;
        this.content = content;
        this.inline = inline;
        this.range = range;
    }
    toString() {
        let text = `@${this.name}`;
        const content = this.content.toString();
        if (this.content.inlines.length === 1) text = `${text} ${content}`;
        else if (this.content.inlines.length > 1) text = `${text}\n${content}`;
        if (this.inline) // Inline tags are surrounded by curly braces
        return `{${text}}`;
        else return text;
    }
    toMarkdown(options) {
        return options?.renderTag?.(this) ?? this.toMarkdownDefault(options);
    }
    toMarkdownDefault(options) {
        const content = this.content.toMarkdown(options);
        if (this.inline) {
            const rendered = $ac320a7b66e79f5e$var$renderInlineTag(this.name, content, options ?? {});
            if (typeof rendered === 'string') return rendered;
        }
        let marker = '';
        if (options?.tag === 'italic' || options?.tag === undefined) marker = '*';
        else if (options?.tag === 'bold') marker = '**';
        else if (options?.tag === 'bold-italic') marker = '***';
        let text = `${marker}@${this.name}${marker}`;
        if (this.content.inlines.length === 1) text = `${text} \u{2014} ${content}`;
        else if (this.content.inlines.length > 1) text = `${text}\n${content}`;
        if (this.inline) // Inline tags are surrounded by curly braces
        return `{${text}}`;
        else return text;
    }
}
function $ac320a7b66e79f5e$var$renderInlineTag(tag, content, options) {
    if (tag === 'linkplain' || tag === 'linkcode' || tag === 'link') {
        const index = content.indexOf(' ');
        let display = content;
        if (index > 0) {
            const displayStart = $ac320a7b66e79f5e$var$skipWhitespace(content, index);
            display = content.substring(displayStart);
            content = content.substring(0, index);
        }
        if (tag === 'linkcode' || tag === 'link' && options.link === 'code') // Surround the display value in a markdown inline code block
        display = `\`${display}\``;
        const renderedLink = options.renderLink?.(content, display) ?? $ac320a7b66e79f5e$var$renderLinkDefault(content, display);
        return renderedLink;
    }
    return undefined;
}
function $ac320a7b66e79f5e$var$renderLinkDefault(content, display) {
    try {
        (0, $3a1a3bfcc859a329$exports.URI).parse(content, true);
        return `[${display}](${content})`;
    } catch  {
        return content;
    }
}
class $ac320a7b66e79f5e$var$JSDocTextImpl {
    constructor(lines, range){
        this.inlines = lines;
        this.range = range;
    }
    toString() {
        let text = '';
        for(let i = 0; i < this.inlines.length; i++){
            const inline = this.inlines[i];
            const next = this.inlines[i + 1];
            text += inline.toString();
            if (next && next.range.start.line > inline.range.start.line) text += '\n';
        }
        return text;
    }
    toMarkdown(options) {
        let text = '';
        for(let i = 0; i < this.inlines.length; i++){
            const inline = this.inlines[i];
            const next = this.inlines[i + 1];
            text += inline.toMarkdown(options);
            if (next && next.range.start.line > inline.range.start.line) text += '\n';
        }
        return text;
    }
}
class $ac320a7b66e79f5e$var$JSDocLineImpl {
    constructor(text, range){
        this.text = text;
        this.range = range;
    }
    toString() {
        return this.text;
    }
    toMarkdown() {
        return this.text;
    }
}
function $ac320a7b66e79f5e$var$fillNewlines(text) {
    if (text.endsWith('\n')) return '\n';
    else return '\n\n';
}


class $8b8885be21941dbf$export$f934c1221cae9c1f {
    constructor(services){
        this.indexManager = services.shared.workspace.IndexManager;
        this.commentProvider = services.documentation.CommentProvider;
    }
    getDocumentation(node) {
        const comment = this.commentProvider.getComment(node);
        if (comment && (0, $ac320a7b66e79f5e$export$747a6966af0d33f0)(comment)) {
            const parsedJSDoc = (0, $ac320a7b66e79f5e$export$bf390bbdbaa3844f)(comment);
            return parsedJSDoc.toMarkdown({
                renderLink: (link, display)=>{
                    return this.documentationLinkRenderer(node, link, display);
                },
                renderTag: (tag)=>{
                    return this.documentationTagRenderer(node, tag);
                }
            });
        }
        return undefined;
    }
    documentationLinkRenderer(node, name, display) {
        const description = this.findNameInLocalSymbols(node, name) ?? this.findNameInGlobalScope(node, name);
        if (description && description.nameSegment) {
            const line = description.nameSegment.range.start.line + 1;
            const character = description.nameSegment.range.start.character + 1;
            const uri = description.documentUri.with({
                fragment: `L${line},${character}`
            });
            return `[${display}](${uri.toString()})`;
        } else return undefined;
    }
    documentationTagRenderer(_node, _tag) {
        // Fall back to the default tag rendering
        return undefined;
    }
    findNameInLocalSymbols(node, name) {
        const document = (0, $de130ae470c6cbfb$export$f65ca476c09acec0)(node);
        const precomputed = document.localSymbols;
        if (!precomputed) return undefined;
        let currentNode = node;
        do {
            const allDescriptions = precomputed.getStream(currentNode);
            const description = allDescriptions.find((e)=>e.name === name);
            if (description) return description;
            currentNode = currentNode.$container;
        }while (currentNode);
        return undefined;
    }
    findNameInGlobalScope(node, name) {
        const description = this.indexManager.allElements().find((e)=>e.name === name);
        return description;
    }
}


/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

class $1310cb609d953209$export$374ab76be50d48ee {
    constructor(services){
        this.grammarConfig = ()=>services.parser.GrammarConfig;
    }
    getComment(node) {
        if ((0, $b3c995646a777b80$export$cb6ca660088b8d64)(node)) return node.$comment;
        return (0, $f87d6e075cbbfde9$export$bfcbdf586d163108)(node.$cstNode, this.grammarConfig().multilineCommentRules)?.text;
    }
}



/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

class $3ac07e425547b140$export$55f8d7a77e82290e {
    constructor(services){
        this.syncParser = services.parser.LangiumParser;
    }
    parse(text, _cancelToken) {
        return Promise.resolve(this.syncParser.parse(text));
    }
}
class $3ac07e425547b140$export$29d10d1ba881e15a {
    constructor(services){
        /**
         * The thread count determines how many threads are used to parse files in parallel.
         * The default value is 8. Decreasing this value increases startup performance, but decreases parallel parsing performance.
         */ this.threadCount = 8;
        /**
         * The termination delay determines how long the parser waits for a thread to finish after a cancellation request.
         * The default value is 200(ms).
         */ this.terminationDelay = 200;
        this.workerPool = [];
        this.queue = [];
        this.hydrator = services.serializer.Hydrator;
    }
    initializeWorkers() {
        while(this.workerPool.length < this.threadCount){
            const worker = this.createWorker();
            worker.onReady(()=>{
                if (this.queue.length > 0) {
                    const deferred = this.queue.shift();
                    if (deferred) {
                        worker.lock();
                        deferred.resolve(worker);
                    }
                }
            });
            this.workerPool.push(worker);
        }
    }
    async parse(text, cancelToken) {
        const worker = await this.acquireParserWorker(cancelToken);
        const deferred = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        let timeout;
        // If the cancellation token is requested, we wait for a certain time before terminating the worker.
        // Since the cancellation token lives longer than the parsing process, we need to dispose the event listener.
        // Otherwise, we might accidentally terminate the worker after the parsing process has finished.
        const cancellation = cancelToken.onCancellationRequested(()=>{
            timeout = setTimeout(()=>{
                this.terminateWorker(worker);
            }, this.terminationDelay);
        });
        worker.parse(text).then((result)=>{
            const hydrated = this.hydrator.hydrate(result);
            deferred.resolve(hydrated);
        }).catch((err)=>{
            deferred.reject(err);
        }).finally(()=>{
            cancellation.dispose();
            clearTimeout(timeout);
        });
        return deferred.promise;
    }
    terminateWorker(worker) {
        worker.terminate();
        const index = this.workerPool.indexOf(worker);
        if (index >= 0) this.workerPool.splice(index, 1);
    }
    async acquireParserWorker(cancelToken) {
        this.initializeWorkers();
        for (const worker of this.workerPool)if (worker.ready) {
            worker.lock();
            return worker;
        }
        const deferred = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        cancelToken.onCancellationRequested(()=>{
            const index = this.queue.indexOf(deferred);
            if (index >= 0) this.queue.splice(index, 1);
            deferred.reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
        });
        this.queue.push(deferred);
        return deferred.promise;
    }
}
class $3ac07e425547b140$export$df86ae820bd06a9f {
    get ready() {
        return this._ready;
    }
    get onReady() {
        return this.onReadyEmitter.event;
    }
    constructor(sendMessage, onMessage, onError, terminate){
        this.onReadyEmitter = new (0, $284dfc6cfc7f5287$exports.Emitter)();
        this.deferred = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        this._ready = true;
        this._parsing = false;
        this.sendMessage = sendMessage;
        this._terminate = terminate;
        onMessage((result)=>{
            const parseResult = result;
            this.deferred.resolve(parseResult);
            this.unlock();
        });
        onError((error)=>{
            this.deferred.reject(error);
            this.unlock();
        });
    }
    terminate() {
        this.deferred.reject((0, $4fb404a672a62c84$export$e8984aef454a5fd3));
        this._terminate();
    }
    lock() {
        this._ready = false;
    }
    unlock() {
        this._parsing = false;
        this._ready = true;
        this.onReadyEmitter.fire();
    }
    parse(text) {
        if (this._parsing) throw new Error('Parser worker is busy');
        this._parsing = true;
        this.deferred = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        this.sendMessage(text);
        return this.deferred.promise;
    }
}


/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 

var $9c405a67d29fc845$export$d718b0eb0bb0f66d;
(function(ReadPriority) {
    /**
     * The read action is queued up and executed once all write actions have finished.
     */ ReadPriority[ReadPriority["Normal"] = 0] = "Normal";
    /**
     * The read action is executed immediately, even while a write action is running.
     */ ReadPriority[ReadPriority["Immediate"] = 1] = "Immediate";
})($9c405a67d29fc845$export$d718b0eb0bb0f66d || ($9c405a67d29fc845$export$d718b0eb0bb0f66d = {}));
class $9c405a67d29fc845$export$e0e2afee989eeda {
    constructor(){
        this.previousTokenSource = new (0, $284dfc6cfc7f5287$exports.CancellationTokenSource)();
        this.writeQueue = [];
        this.readQueue = [];
        this.immediateReads = [];
        this.done = true;
    }
    write(action) {
        this.cancelWrite();
        const tokenSource = (0, $4fb404a672a62c84$export$77c8be3ce67874ab)();
        this.previousTokenSource = tokenSource;
        return this.enqueue(this.writeQueue, action, tokenSource.token);
    }
    read(action, priority = $9c405a67d29fc845$export$d718b0eb0bb0f66d.Normal) {
        if (priority === $9c405a67d29fc845$export$d718b0eb0bb0f66d.Immediate) {
            // Immediate reads bypass the queue and run concurrently to any active write.
            // The caller is responsible for having awaited the workspace/document state it needs.
            // They are still tracked so that new write actions don't start while they are in progress.
            const promise = Promise.resolve().then(()=>action());
            this.immediateReads.push(promise);
            const remove = ()=>{
                this.immediateReads.splice(this.immediateReads.indexOf(promise), 1);
            };
            promise.then(remove, remove);
            return promise;
        }
        return this.enqueue(this.readQueue, action);
    }
    enqueue(queue, action, cancellationToken = (0, $284dfc6cfc7f5287$exports.CancellationToken).None) {
        const deferred = new (0, $4fb404a672a62c84$export$85f6557964517f1a)();
        const entry = {
            action: action,
            deferred: deferred,
            cancellationToken: cancellationToken
        };
        queue.push(entry);
        this.performNextOperation();
        return deferred.promise;
    }
    async performNextOperation() {
        if (!this.done) return;
        const entries = [];
        if (this.writeQueue.length > 0) {
            // Just perform the next write action
            entries.push(this.writeQueue.shift());
            // A write action would modify the state that running immediate reads operate on,
            // so wait until all of them have finished before starting the write
            this.done = false;
            while(this.immediateReads.length > 0)await Promise.allSettled(this.immediateReads.slice());
        } else if (this.readQueue.length > 0) {
            // Empty the read queue and perform all actions in parallel
            entries.push(...this.readQueue.splice(0, this.readQueue.length));
            this.done = false;
        } else return;
        await Promise.all(entries.map(async ({ action: action, deferred: deferred, cancellationToken: cancellationToken })=>{
            try {
                // Move the execution of the action to the next event loop tick via `Promise.resolve()`
                const result = await Promise.resolve().then(()=>action(cancellationToken));
                deferred.resolve(result);
            } catch (err) {
                if ((0, $4fb404a672a62c84$export$5b2d4ab85306fab5)(err)) // If the operation was cancelled, we don't want to reject the promise
                deferred.resolve(undefined);
                else deferred.reject(err);
            }
        }));
        this.done = true;
        this.performNextOperation();
    }
    cancelWrite() {
        this.previousTokenSource.cancel();
    }
}


/******************************************************************************
 * Copyright 2024 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 





class $200ea8b7ac5e68dc$export$34ae75b8039a34b0 {
    constructor(services){
        this.grammarElementIdMap = new (0, $9c40ddedabc72f65$export$f742ea9eee1a8cf2)();
        this.tokenTypeIdMap = new (0, $9c40ddedabc72f65$export$f742ea9eee1a8cf2)();
        /** Used to assemble the CST during hydration; `CstNodeBuilder` is not a service, so we keep a local instance. */ this.cstNodeBuilder = new (0, $1b748ce23177adfe$export$f81d3ebae79e61c1)();
        this.grammar = services.Grammar;
        this.lexer = services.parser.Lexer;
        this.linker = services.references.Linker;
    }
    dehydrate(result) {
        return {
            lexerErrors: result.lexerErrors,
            lexerReport: result.lexerReport ? this.dehydrateLexerReport(result.lexerReport) : undefined,
            // We need to create shallow copies of the errors
            // The original errors inherit from the `Error` class, which is not transferable across worker threads
            parserErrors: result.parserErrors.map((e)=>({
                    ...e,
                    message: e.message
                })),
            value: this.dehydrateAstNode(result.value, this.createDehyrationContext(result.value))
        };
    }
    dehydrateLexerReport(lexerReport) {
        // By default, lexer reports are serializable
        return lexerReport;
    }
    createDehyrationContext(node) {
        const astNodes = new Map();
        const cstNodes = new Map();
        for (const astNode of (0, $de130ae470c6cbfb$export$b7350f614170899e)(node))astNodes.set(astNode, {});
        if (node.$cstNode) for (const cstNode of (0, $f87d6e075cbbfde9$export$e6e798b3ac4e876c)(node.$cstNode))cstNodes.set(cstNode, {});
        return {
            astNodes: astNodes,
            cstNodes: cstNodes
        };
    }
    dehydrateAstNode(node, context) {
        const obj = context.astNodes.get(node);
        obj.$type = node.$type;
        obj.$containerIndex = node.$containerIndex;
        obj.$containerProperty = node.$containerProperty;
        if (node.$cstNode !== undefined) obj.$cstNode = this.dehydrateCstNode(node.$cstNode, context);
        for (const [name, value] of Object.entries(node)){
            if (name.startsWith('$')) continue;
            if (Array.isArray(value)) {
                const arr = [];
                obj[name] = arr;
                for (const item of value){
                    if ((0, $09c22474b334b427$export$dd586f2688797f92)(item)) arr.push(this.dehydrateAstNode(item, context));
                    else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(item)) arr.push(this.dehydrateReference(item, context));
                    else arr.push(item);
                }
            } else if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) obj[name] = this.dehydrateAstNode(value, context);
            else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(value)) obj[name] = this.dehydrateReference(value, context);
            else if (value !== undefined) obj[name] = value;
        }
        return obj;
    }
    dehydrateReference(reference, context) {
        const obj = {};
        obj.$refText = reference.$refText;
        if (reference.$refNode) obj.$refNode = context.cstNodes.get(reference.$refNode);
        return obj;
    }
    dehydrateCstNode(node, context) {
        const cstNode = context.cstNodes.get(node);
        if ((0, $09c22474b334b427$export$95ae76a9457c0b7d)(node)) cstNode.fullText = node.fullText;
        else // Note: This returns undefined for hidden nodes (i.e. comments)
        cstNode.grammarSource = this.getGrammarElementId(node.grammarSource);
        cstNode.hidden = node.hidden;
        if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(node)) cstNode.content = node.content.map((child)=>this.dehydrateCstNode(child, context));
        else if ((0, $09c22474b334b427$export$e82a11db49cb0b82)(node)) {
            cstNode.tokenType = node.tokenType.name;
            cstNode.offset = node.offset;
            cstNode.length = node.length;
            const { start: start, end: end } = node.range;
            cstNode.startLine = start.line;
            cstNode.startColumn = start.character;
            cstNode.endLine = end.line;
            cstNode.endColumn = end.character;
        }
        return cstNode;
    }
    hydrate(result) {
        const node = result.value;
        const context = this.createHydrationContext(node);
        if ('$cstNode' in node) this.hydrateCstNode(node.$cstNode, context);
        return {
            lexerErrors: result.lexerErrors,
            lexerReport: result.lexerReport,
            parserErrors: result.parserErrors,
            value: this.hydrateAstNode(node, context)
        };
    }
    createHydrationContext(node) {
        const astNodes = new Map();
        const cstNodes = new Map();
        for (const astNode of (0, $de130ae470c6cbfb$export$b7350f614170899e)(node))astNodes.set(astNode, {});
        if (node.$cstNode) for (const cstNode of (0, $f87d6e075cbbfde9$export$e6e798b3ac4e876c)(node.$cstNode)){
            let cst;
            if ('fullText' in cstNode) cst = new (0, $1b748ce23177adfe$export$1e34a4735acab9e2)(cstNode.fullText);
            else if ('content' in cstNode) cst = new (0, $1b748ce23177adfe$export$458d45a1bda00db9)();
            else if ('tokenType' in cstNode) cst = this.hydrateCstLeafNode(cstNode);
            if (cst) cstNodes.set(cstNode, cst);
        }
        return {
            astNodes: astNodes,
            cstNodes: cstNodes,
            linkedCstNodes: new Set()
        };
    }
    hydrateAstNode(node, context) {
        const astNode = context.astNodes.get(node);
        astNode.$type = node.$type;
        astNode.$containerIndex = node.$containerIndex;
        astNode.$containerProperty = node.$containerProperty;
        if (node.$cstNode) {
            const cstNode = context.cstNodes.get(node.$cstNode);
            astNode.$cstNode = cstNode;
            // Store the AST backlink only on the directly associated CST node;
            // all other CST nodes resolve their AST node via the container hierarchy
            if (cstNode && !context.linkedCstNodes.has(cstNode)) {
                context.linkedCstNodes.add(cstNode);
                cstNode.astNode = astNode;
            }
        }
        for (const [name, value] of Object.entries(node)){
            if (name.startsWith('$')) continue;
            if (Array.isArray(value)) {
                const arr = [];
                astNode[name] = arr;
                for (const item of value){
                    if ((0, $09c22474b334b427$export$dd586f2688797f92)(item)) arr.push(this.setParent(this.hydrateAstNode(item, context), astNode));
                    else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(item)) arr.push(this.hydrateReference(item, astNode, name, context));
                    else arr.push(item);
                }
            } else if ((0, $09c22474b334b427$export$dd586f2688797f92)(value)) astNode[name] = this.setParent(this.hydrateAstNode(value, context), astNode);
            else if ((0, $09c22474b334b427$export$fa99cac1c0883c47)(value)) astNode[name] = this.hydrateReference(value, astNode, name, context);
            else if (value !== undefined) astNode[name] = value;
        }
        return astNode;
    }
    setParent(node, parent) {
        node.$container = parent;
        return node;
    }
    hydrateReference(reference, node, name, context) {
        return this.linker.buildReference(node, name, context.cstNodes.get(reference.$refNode), reference.$refText);
    }
    hydrateCstNode(cstNode, context, num = 0) {
        const cstNodeObj = context.cstNodes.get(cstNode);
        if (typeof cstNode.grammarSource === 'number') cstNodeObj.grammarSource = this.getGrammarElement(cstNode.grammarSource);
        if ((0, $09c22474b334b427$export$e4d2208aa188ebc5)(cstNodeObj)) {
            const children = [];
            for (const child of cstNode.content)children.push(this.hydrateCstNode(child, context, num++));
            this.cstNodeBuilder.appendChildren(cstNodeObj, children);
        }
        return cstNodeObj;
    }
    hydrateCstLeafNode(cstNode) {
        const tokenType = this.getTokenType(cstNode.tokenType);
        return new (0, $1b748ce23177adfe$export$eefe9a70fe4fb05c)(cstNode.offset, cstNode.length, cstNode.startLine, cstNode.startColumn, cstNode.endLine, cstNode.endColumn, tokenType, cstNode.hidden);
    }
    getTokenType(name) {
        return this.lexer.definition[name];
    }
    getGrammarElementId(node) {
        if (!node) return undefined;
        if (this.grammarElementIdMap.size === 0) this.createGrammarElementIdMap();
        return this.grammarElementIdMap.get(node);
    }
    getGrammarElement(id) {
        if (this.grammarElementIdMap.size === 0) this.createGrammarElementIdMap();
        const element = this.grammarElementIdMap.getKey(id);
        return element;
    }
    createGrammarElementIdMap() {
        let id = 0;
        for (const element of (0, $de130ae470c6cbfb$export$b7350f614170899e)(this.grammar))if ((0, $c70992891bcf3a02$export$14d6559204778623)(element)) this.grammarElementIdMap.set(element, id++);
    }
}


function $fc354df782e6db4f$export$eab5a4b5adef815d(context) {
    return {
        documentation: {
            CommentProvider: (services)=>new (0, $1310cb609d953209$export$374ab76be50d48ee)(services),
            DocumentationProvider: (services)=>new (0, $8b8885be21941dbf$export$f934c1221cae9c1f)(services)
        },
        parser: {
            AsyncParser: (services)=>new (0, $3ac07e425547b140$export$55f8d7a77e82290e)(services),
            GrammarConfig: (services)=>(0, $0427dfdfd0423955$export$66eccfaecec6301f)(services),
            LangiumParser: (services)=>(0, $0c6afc7ef5407be8$export$c34ae3a42210eed7)(services),
            CompletionParser: (services)=>(0, $69fd5d94279834e5$export$fb4437d6aec944c8)(services),
            ValueConverter: ()=>new (0, $ee0cf949ec60f893$export$f6596dabd45df11d)(),
            TokenBuilder: ()=>new (0, $e140e1b69a73e38f$export$a4968393d41e1883)(),
            Lexer: (services)=>new (0, $6204b5d2fabba386$export$98868b256b874b9b)(services),
            ParserErrorMessageProvider: ()=>new (0, $494eff091ec87f44$export$fa69d68414d554e3)(),
            LexerErrorMessageProvider: ()=>new (0, $6204b5d2fabba386$export$a52adb64236636f9)()
        },
        workspace: {
            AstNodeLocator: ()=>new (0, $2bc65b9f5e083cd0$export$f89e112f1e9e8018)(),
            AstNodeDescriptionProvider: (services)=>new (0, $20dfb38d03ca0518$export$d8f430237f85d6fe)(services),
            ReferenceDescriptionProvider: (services)=>new (0, $20dfb38d03ca0518$export$dfc8922e6bc4afce)(services)
        },
        references: {
            Linker: (services)=>new (0, $42c9a3b317638daf$export$4467b657ef20e7b9)(services),
            NameProvider: ()=>new (0, $8868c78697bc048f$export$d89d3fb260d53b12)(),
            ScopeProvider: (services)=>new (0, $6ae4237029067986$export$49a7480ed4da4397)(services),
            ScopeComputation: (services)=>new (0, $656f388a6eb9a1c1$export$6821cb2333c50d6b)(services),
            References: (services)=>new (0, $a03c43c8ab5ae2e3$export$3be536c561c2c1d7)(services)
        },
        serializer: {
            Hydrator: (services)=>new (0, $200ea8b7ac5e68dc$export$34ae75b8039a34b0)(services),
            JsonSerializer: (services)=>new (0, $b3c995646a777b80$export$6c161a533d76d64a)(services)
        },
        validation: {
            DocumentValidator: (services)=>new (0, $10a976939bbc6c50$export$26c8dfd81f255a91)(services),
            ValidationRegistry: (services)=>new (0, $122aedc676522a5a$export$74bb79b1ec263dfd)(services)
        },
        shared: ()=>context.shared
    };
}
function $fc354df782e6db4f$export$dbab074a2a0a86aa(context) {
    return {
        ServiceRegistry: (services)=>new (0, $a101d7777e543b9c$export$17a7e66d43732508)(services),
        workspace: {
            LangiumDocuments: (services)=>new (0, $4ec1768ef727cb18$export$33b27a5eb36b3f5e)(services),
            LangiumDocumentFactory: (services)=>new (0, $4ec1768ef727cb18$export$8e75912b72ec32a3)(services),
            DocumentBuilder: (services)=>new (0, $5b49ac48d62003c4$export$c5b3e0d04e5036b6)(services),
            IndexManager: (services)=>new (0, $0110b9418025e830$export$a50279bedae990c3)(services),
            WorkspaceManager: (services)=>new (0, $446d327cd6412534$export$cca55013f2a76810)(services),
            FileSystemProvider: (services)=>context.fileSystemProvider(services),
            WorkspaceLock: ()=>new (0, $9c405a67d29fc845$export$e0e2afee989eeda)(),
            ConfigurationProvider: (services)=>new (0, $a6decb20d3606417$export$2c9bab6ec0183664)(services)
        },
        profilers: {}
    };
}

/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ class $7cd4e8ed43f36490$export$289ee8ab1775bdc0 {
    stat(_uri) {
        throw new Error('No file system is available.');
    }
    statSync(_uri) {
        throw new Error('No file system is available.');
    }
    async exists() {
        return false;
    }
    existsSync() {
        return false;
    }
    readBinary() {
        throw new Error('No file system is available.');
    }
    readBinarySync() {
        throw new Error('No file system is available.');
    }
    readFile() {
        throw new Error('No file system is available.');
    }
    readFileSync() {
        throw new Error('No file system is available.');
    }
    async readDirectory() {
        return [];
    }
    readDirectorySync() {
        return [];
    }
}
const $7cd4e8ed43f36490$export$9849fb42e1532cce = {
    fileSystemProvider: ()=>new $7cd4e8ed43f36490$export$289ee8ab1775bdc0()
};

/******************************************************************************
 * Copyright 2021 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ var $84e57a48b9f5649b$export$c3a9d7ff17e4f3ed;
(function(Module) {
    /**
     * Merges two dependency injection modules into a new (third) one that is returned.
     * At that `m1` and `m2` stay unchanged. Therefore, `m1` is deep-copied first,
     * and m2 is merged onto the copy afterwards.
     *
     * Note that the leaf values of `m1` and `m2`, i.e. the service constructor functions,
     * cannot be copied generically, since they are functions. They are shared by the source and merged modules.
     *
     * @returns the merged module being a deep copy of `m1` with `m2` merged onto it.
     */ Module.merge = (m1, m2)=>$84e57a48b9f5649b$var$_merge($84e57a48b9f5649b$var$_merge({}, m1), m2);
})($84e57a48b9f5649b$export$c3a9d7ff17e4f3ed || ($84e57a48b9f5649b$export$c3a9d7ff17e4f3ed = {}));
function $84e57a48b9f5649b$export$a976684a0efeb93f(module1, module2, module3, module4, module5, module6, module7, module8, module9) {
    const module = [
        module1,
        module2,
        module3,
        module4,
        module5,
        module6,
        module7,
        module8,
        module9
    ].reduce($84e57a48b9f5649b$var$_merge, {});
    return $84e57a48b9f5649b$var$_inject(module);
}
const $84e57a48b9f5649b$var$isProxy = Symbol('isProxy');
function $84e57a48b9f5649b$export$5550c71412c16477(item) {
    if (item && item[$84e57a48b9f5649b$var$isProxy]) for (const value of Object.values(item))$84e57a48b9f5649b$export$5550c71412c16477(value);
    return item;
}
/**
 * Helper function that returns an injector by creating a proxy.
 * Invariant: injector is of type I. If injector is undefined, then T = I.
 */ function $84e57a48b9f5649b$var$_inject(module, injector) {
    const proxy = new Proxy({}, {
        deleteProperty: ()=>false,
        set: ()=>{
            throw new Error('Cannot set property on injected service container');
        },
        get: (obj, prop)=>{
            if (prop === $84e57a48b9f5649b$var$isProxy) return true;
            else return $84e57a48b9f5649b$var$_resolve(obj, prop, module, injector || proxy);
        },
        getOwnPropertyDescriptor: (obj, prop)=>($84e57a48b9f5649b$var$_resolve(obj, prop, module, injector || proxy), Object.getOwnPropertyDescriptor(obj, prop)),
        has: (_, prop)=>prop in module,
        ownKeys: ()=>[
                ...Object.getOwnPropertyNames(module)
            ] // used by for..in
    });
    return proxy;
}
/**
 * Internally used to tag a requested dependency, directly before calling the factory.
 * This allows us to find cycles during instance creation.
 */ const $84e57a48b9f5649b$var$__requested__ = Symbol();
/**
 * Returns the value `obj[prop]`. If the value does not exist, yet, it is resolved from
 * the module description. The result of service factories is cached. Groups are
 * recursively proxied.
 *
 * @param obj an object holding all group proxies and services
 * @param prop the key of a value within obj
 * @param module an object containing groups and service factories
 * @param injector the first level proxy that provides access to all values
 * @returns the requested value `obj[prop]`
 * @throws Error if a dependency cycle is detected
 */ function $84e57a48b9f5649b$var$_resolve(obj, prop, module, injector) {
    if (prop in obj) {
        if (obj[prop] instanceof Error) throw new Error('Construction failure. Please make sure that your dependencies are constructable. Cause: ' + obj[prop]);
        if (obj[prop] === $84e57a48b9f5649b$var$__requested__) throw new Error('Cycle detected. Please make "' + String(prop) + '" lazy. Visit https://langium.org/docs/reference/configuration-services/#resolving-cyclic-dependencies');
        return obj[prop];
    } else if (prop in module) {
        const value = module[prop];
        obj[prop] = $84e57a48b9f5649b$var$__requested__;
        try {
            obj[prop] = typeof value === 'function' ? value(injector) : $84e57a48b9f5649b$var$_inject(value, injector);
        } catch (error) {
            obj[prop] = error instanceof Error ? error : undefined;
            throw error;
        }
        return obj[prop];
    } else return undefined;
}
/**
 * Performs a deep-merge of two modules by writing source entries into the target module.
 *
 * @param target the module which is written
 * @param source the module which is read
 * @returns the target module
 */ function $84e57a48b9f5649b$var$_merge(target, source) {
    if (source) for (const [key, sourceValue] of Object.entries(source)){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (sourceValue !== undefined && sourceValue !== null) {
            if (typeof sourceValue === 'object') {
                const targetValue = target[key];
                if (typeof targetValue === 'object' && targetValue !== null) // in case both values are real (non-null) objects merge them recursively
                target[key] = $84e57a48b9f5649b$var$_merge(targetValue, sourceValue);
                else // in case 'target[key]' is not a non-null object
                //  we overwrite any existing value with a deep copy of 'sourceValue'
                //  by recursively calling this function with a new 'target' object to be populated
                //  that is assigned to 'target[key]' afterwards
                target[key] = $84e57a48b9f5649b$var$_merge({}, sourceValue);
            } else // in case 'sourceValue' is defined and assigned (non-null) but not an object
            //  we assume it to be a service constructor function according to the Module<I> type definition
            target[key] = sourceValue;
        }
    }
    return target;
}


/******************************************************************************
 * This file was generated by langium-cli 4.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/ 
/******************************************************************************
 * This file was generated by langium-cli 4.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/ /******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/ 




const $a22053c66aed19af$var$minimalGrammarModule = {
    Grammar: ()=>undefined,
    LanguageMetaData: ()=>({
            caseInsensitive: false,
            fileExtensions: [
                '.langium'
            ],
            languageId: 'langium'
        })
};
const $a22053c66aed19af$var$minimalSharedGrammarModule = {
    AstReflection: ()=>new $c70992891bcf3a02$export$3376ecb8b6225174()
};
function $a22053c66aed19af$var$createMinimalGrammarServices() {
    const shared = (0, $84e57a48b9f5649b$export$a976684a0efeb93f)((0, $fc354df782e6db4f$export$dbab074a2a0a86aa)((0, $7cd4e8ed43f36490$export$9849fb42e1532cce)), $a22053c66aed19af$var$minimalSharedGrammarModule);
    const grammar = (0, $84e57a48b9f5649b$export$a976684a0efeb93f)((0, $fc354df782e6db4f$export$eab5a4b5adef815d)({
        shared: shared
    }), $a22053c66aed19af$var$minimalGrammarModule);
    shared.ServiceRegistry.register(grammar);
    return grammar;
}
function $a22053c66aed19af$export$51803e2fc86a0231(json) {
    const services = $a22053c66aed19af$var$createMinimalGrammarServices();
    const astNode = services.serializer.JsonSerializer.deserialize(json);
    services.shared.workspace.LangiumDocumentFactory.fromModel(astNode, (0, $3a1a3bfcc859a329$exports.URI).parse(`memory:/${astNode.name ?? 'grammar'}.langium`));
    return astNode;
}


let $7e30a8f1a02a080a$var$loadedSpdGrammar;
const $7e30a8f1a02a080a$export$53fc7070ec131a87 = ()=>$7e30a8f1a02a080a$var$loadedSpdGrammar ?? ($7e30a8f1a02a080a$var$loadedSpdGrammar = (0, $a22053c66aed19af$export$51803e2fc86a0231)(`{
  "$type": "Grammar",
  "isDeclared": true,
  "name": "Spd",
  "rules": [
    {
      "$type": "ParserRule",
      "entry": true,
      "name": "Model",
      "definition": {
        "$type": "Assignment",
        "feature": "statements",
        "operator": "+=",
        "terminal": {
          "$type": "RuleCall",
          "rule": {
            "$ref": "#/rules@1"
          },
          "arguments": []
        },
        "cardinality": "*"
      },
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "Statement",
      "definition": {
        "$type": "Alternatives",
        "elements": [
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@2"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@13"
            },
            "arguments": []
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "CommandStatement",
      "definition": {
        "$type": "Alternatives",
        "elements": [
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@4"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@5"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@6"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@7"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@8"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@9"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@10"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@11"
            },
            "arguments": []
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@12"
            },
            "arguments": []
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "Block",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@15"
            },
            "arguments": []
          },
          {
            "$type": "Assignment",
            "feature": "statements",
            "operator": "+=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@1"
              },
              "arguments": []
            },
            "cardinality": "+"
          },
          {
            "$type": "RuleCall",
            "rule": {
              "$ref": "#/rules@16"
            },
            "arguments": []
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "IfStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":if"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "WhileStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":while"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "DoWhileStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":dowhile"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "CallStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":call"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "SwitchStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":switch"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "CaseStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":case"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "ElseStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":else"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "TerminalStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":terminal"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "CommentStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Keyword",
            "value": ":comment"
          },
          {
            "$type": "Assignment",
            "feature": "arg",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@14"
              },
              "arguments": []
            },
            "cardinality": "?"
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "ProcessStatement",
      "definition": {
        "$type": "Group",
        "elements": [
          {
            "$type": "Assignment",
            "feature": "content",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@18"
              },
              "arguments": []
            }
          },
          {
            "$type": "Assignment",
            "feature": "block",
            "operator": "=",
            "terminal": {
              "$type": "RuleCall",
              "rule": {
                "$ref": "#/rules@3"
              },
              "arguments": []
            },
            "cardinality": "?"
          }
        ]
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "ParserRule",
      "name": "Argument",
      "dataType": "string",
      "definition": {
        "$type": "RuleCall",
        "rule": {
          "$ref": "#/rules@18"
        },
        "arguments": []
      },
      "entry": false,
      "fragment": false,
      "parameters": []
    },
    {
      "$type": "TerminalRule",
      "name": "INDENT",
      "definition": {
        "$type": "CharacterRange",
        "left": {
          "$type": "Keyword",
          "value": "synthetic:indent"
        },
        "parenthesized": false
      },
      "fragment": false,
      "hidden": false
    },
    {
      "$type": "TerminalRule",
      "name": "DEDENT",
      "definition": {
        "$type": "CharacterRange",
        "left": {
          "$type": "Keyword",
          "value": "synthetic:dedent"
        },
        "parenthesized": false
      },
      "fragment": false,
      "hidden": false
    },
    {
      "$type": "TerminalRule",
      "hidden": true,
      "name": "LINE_COMMENT",
      "definition": {
        "$type": "RegexToken",
        "regex": "/#[^\\\\n\\\\r]*/",
        "parenthesized": false
      },
      "fragment": false
    },
    {
      "$type": "TerminalRule",
      "name": "Content",
      "definition": {
        "$type": "RegexToken",
        "regex": "/[^\\\\t:\\\\n\\\\r](?:[^\\\\n\\\\r]*(?<!\\\\\\\\)@[ \\\\t]*\\\\r?\\\\n[ \\\\t]*|#[^\\\\n\\\\r]*\\\\r?\\\\n[ \\\\t]*)*[^\\\\n\\\\r]*/",
        "parenthesized": false
      },
      "fragment": false,
      "hidden": false
    },
    {
      "$type": "TerminalRule",
      "hidden": true,
      "name": "WS",
      "definition": {
        "$type": "RegexToken",
        "regex": "/[ \\\\t]+/",
        "parenthesized": false
      },
      "fragment": false
    },
    {
      "$type": "TerminalRule",
      "hidden": true,
      "name": "NEWLINE",
      "definition": {
        "$type": "RegexToken",
        "regex": "/\\\\r?\\\\n/",
        "parenthesized": false
      },
      "fragment": false
    }
  ],
  "imports": [],
  "interfaces": [],
  "types": []
}`));


const $53e69b8cdb0b81cb$export$512b26eccbcec636 = {
    languageId: 'spd',
    fileExtensions: [
        '.spd'
    ],
    caseInsensitive: false,
    mode: 'development'
};
const $53e69b8cdb0b81cb$export$2873d779685c2d3e = {
    AstReflection: ()=>new (0, $9b23bf1934cbb958$export$f3faa6c632e65501)()
};
const $53e69b8cdb0b81cb$export$9d18a89cdb210602 = {
    Grammar: ()=>(0, $7e30a8f1a02a080a$export$53fc7070ec131a87)(),
    LanguageMetaData: ()=>$53e69b8cdb0b81cb$export$512b26eccbcec636,
    parser: {}
};



class $80b8b7672e70f105$export$3e9e271c0c03159d extends (0, $6204b5d2fabba386$export$98868b256b874b9b) {
    tokenize(text, options) {
        const result = super.tokenize(text, options);
        const newTokens = [];
        let currentDepth = 0;
        const indentType = this.definition.INDENT;
        const dedentType = this.definition.DEDENT;
        const lines = text.split(/\r?\n/);
        let lastLine = 0;
        for (const token of result.tokens){
            if (token.startLine && token.startLine > lastLine) {
                const lineIndex = token.startLine - 1;
                const lineStr = lines[lineIndex] || "";
                let tabNum = 0;
                for(let i = 0; i < lineStr.length; ++i){
                    if (lineStr.charAt(i) === "\t") tabNum++;
                    else break;
                }
                // Now, adjust depth
                if (tabNum > currentDepth) {
                    for(let i = 0; i < tabNum - currentDepth; i++)newTokens.push({
                        image: "",
                        startOffset: token.startOffset,
                        startLine: token.startLine,
                        startColumn: token.startColumn,
                        endOffset: token.startOffset,
                        endLine: token.startLine,
                        endColumn: token.startColumn,
                        tokenTypeIdx: indentType.tokenTypeIdx ?? 0,
                        tokenType: indentType
                    });
                    currentDepth = tabNum;
                } else if (tabNum < currentDepth) {
                    for(let i = 0; i < currentDepth - tabNum; i++)newTokens.push({
                        image: "",
                        startOffset: token.startOffset,
                        startLine: token.startLine,
                        startColumn: token.startColumn,
                        endOffset: token.startOffset,
                        endLine: token.startLine,
                        endColumn: token.startColumn,
                        tokenTypeIdx: dedentType.tokenTypeIdx ?? 0,
                        tokenType: dedentType
                    });
                    currentDepth = tabNum;
                }
            }
            newTokens.push(token);
            if (token.endLine && token.endLine > lastLine) lastLine = token.endLine;
            else if (token.startLine && token.startLine > lastLine) lastLine = token.startLine;
        }
        if (currentDepth > 0) {
            const lastToken = result.tokens[result.tokens.length - 1];
            for(let i = 0; i < currentDepth; i++)newTokens.push({
                image: "",
                startOffset: lastToken ? lastToken.endOffset ?? 0 : text.length,
                startLine: lastToken ? lastToken.endLine ?? 1 : 1,
                startColumn: lastToken ? lastToken.endColumn ?? 1 : 1,
                endOffset: lastToken ? lastToken.endOffset ?? 0 : text.length,
                endLine: lastToken ? lastToken.endLine ?? 1 : 1,
                endColumn: lastToken ? lastToken.endColumn ?? 1 : 1,
                tokenTypeIdx: dedentType.tokenTypeIdx ?? 0,
                tokenType: dedentType
            });
        }
        result.tokens = newTokens;
        return result;
    }
}


function $d833f4f86363406c$export$91465513ecbf9a35() {
    const shared = (0, $84e57a48b9f5649b$export$a976684a0efeb93f)((0, $fc354df782e6db4f$export$dbab074a2a0a86aa)((0, $7cd4e8ed43f36490$export$9849fb42e1532cce)), (0, $53e69b8cdb0b81cb$export$2873d779685c2d3e));
    const Spd = (0, $84e57a48b9f5649b$export$a976684a0efeb93f)((0, $fc354df782e6db4f$export$eab5a4b5adef815d)({
        shared: shared
    }), (0, $53e69b8cdb0b81cb$export$9d18a89cdb210602), {
        parser: {
            Lexer: (services)=>new (0, $80b8b7672e70f105$export$3e9e271c0c03159d)(services)
        }
    });
    shared.ServiceRegistry.register(Spd);
    return {
        shared: shared,
        Spd: Spd
    };
}
const $d833f4f86363406c$export$af3eb6fad56069d6 = $d833f4f86363406c$export$91465513ecbf9a35().Spd;


class $00c9095dc018a9e7$export$f9c837a54db411d extends Error {
    lineNo;
    lineStr;
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$f9c837a54db411d.prototype);
    }
}
class $00c9095dc018a9e7$export$eaf10ed6e5991cf8 extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306F\u5F15\u6570\u304C\u5FC5\u8981\u3067\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$eaf10ed6e5991cf8.prototype);
    }
}
class $00c9095dc018a9e7$export$1d21b533e0dc3eed extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u3053\u306E\u30B3\u30DE\u30F3\u30C9\u306B\u5F15\u6570\u306F\u4E0D\u8981\u3067\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$1d21b533e0dc3eed.prototype);
    }
}
class $00c9095dc018a9e7$export$d0be8b16a0056b4a extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u30A4\u30F3\u30C7\u30F3\u30C8\u306E\u6570\u304C\u4E0D\u6B63\u3067\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$d0be8b16a0056b4a.prototype);
    }
}
class $00c9095dc018a9e7$export$1e06c21ce32643dc extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u672A\u77E5\u306E\u30B3\u30DE\u30F3\u30C9\u3067\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$1e06c21ce32643dc.prototype);
    }
}
class $00c9095dc018a9e7$export$91a4fa3e8e7c8586 extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u4E0D\u9069\u5207\u306Aelse\u3067\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$91a4fa3e8e7c8586.prototype);
    }
}
class $00c9095dc018a9e7$export$773fc764960da4ba extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u4E0D\u9069\u5207\u306Acase\u304C\u73FE\u308C\u307E\u3057\u305F");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$773fc764960da4ba.prototype);
    }
}
class $00c9095dc018a9e7$export$a235ab136f3fda43 extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u65E2\u306B\u540C\u540D\u306ECase\u304C\u5B58\u5728\u3057\u307E\u3059");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$a235ab136f3fda43.prototype);
    }
}
class $00c9095dc018a9e7$export$ecfc75b1ea638281 extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(message){
        super(`\u{5185}\u{90E8}\u{30A8}\u{30E9}\u{30FC}:${message}`);
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$ecfc75b1ea638281.prototype);
    }
}
class $00c9095dc018a9e7$export$aeae85cd74b5f02 extends $00c9095dc018a9e7$export$f9c837a54db411d {
    constructor(){
        super("\u4E88\u671F\u3057\u306A\u3044IO\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F");
        Object.setPrototypeOf(this, $00c9095dc018a9e7$export$aeae85cd74b5f02.prototype);
    }
}
const $00c9095dc018a9e7$var$DummyParseErrorReceiver = ()=>{
    return false;
};
function $00c9095dc018a9e7$var$cleanText(rawText, isCommand) {
    if (!rawText) return "";
    if (isCommand) rawText = rawText.trim();
    const lines = rawText.split(/\r?\n/);
    const newLines = [];
    for(let i = 0; i < lines.length; i++){
        let l = lines[i];
        l = l.replace(/^\t+/, "");
        if (l.trim().startsWith("#")) continue;
        if (l.endsWith("@") && !l.endsWith("\\@")) l = l.substring(0, l.length - 1);
        newLines.push(l);
    }
    let text = newLines.join("\n");
    text = text.replace(/(?<!\\)@/g, "\n");
    text = text.replace(/\\@/g, "@");
    return text;
}
function $00c9095dc018a9e7$var$processStatement(stmt, srcLines, exr, errorLines) {
    try {
        if (stmt.$cstNode && errorLines.has(stmt.$cstNode.range.start.line + 1)) return null;
        let arg = "";
        if ("arg" in stmt && typeof stmt.arg === "string") arg = $00c9095dc018a9e7$var$cleanText(stmt.arg, true);
        if ((0, $9b23bf1934cbb958$export$2a0f7e1d90aa4674)(stmt)) {
            const content = $00c9095dc018a9e7$var$cleanText(stmt.content ?? "", false);
            if (content.trim() === "") return null;
            return {
                type: "process",
                text: content,
                childNode: $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines)
            };
        } else if ((0, $9b23bf1934cbb958$export$9b7dc97183f0dd51)(stmt)) {
            if ((0, $9b23bf1934cbb958$export$383a1cf0ba5823b2)(stmt)) {
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "call",
                    text: arg,
                    childNode: $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines)
                };
            } else if ((0, $9b23bf1934cbb958$export$985cf53721f25650)(stmt)) {
                if (stmt.block && stmt.block.statements.length > 0) throw new $00c9095dc018a9e7$export$d0be8b16a0056b4a();
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "terminal",
                    text: arg
                };
            } else if ((0, $9b23bf1934cbb958$export$fa509cabd5955637)(stmt)) {
                if (stmt.block && stmt.block.statements.length > 0) throw new $00c9095dc018a9e7$export$d0be8b16a0056b4a();
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "comment",
                    text: arg
                };
            } else if ((0, $9b23bf1934cbb958$export$c91f7d902b010e81)(stmt)) {
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "loop",
                    isWhile: true,
                    text: arg,
                    childNode: $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines)
                };
            } else if ((0, $9b23bf1934cbb958$export$3f395735debea0f3)(stmt)) {
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "loop",
                    isWhile: false,
                    text: arg,
                    childNode: $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines)
                };
            } else if ((0, $9b23bf1934cbb958$export$5d8d1c90f5b3b487)(stmt)) {
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                return {
                    type: "if",
                    text: arg,
                    trueNode: $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines),
                    falseNode: null
                };
            } else if ((0, $9b23bf1934cbb958$export$ec10f450bfbc36e1)(stmt)) {
                if (stmt.block && stmt.block.statements.length > 0) throw new $00c9095dc018a9e7$export$d0be8b16a0056b4a();
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                const cases = new Map();
                // cases are handled at block level, not inside switch block
                return {
                    type: "switch",
                    text: arg,
                    cases: cases
                };
            } else if ((0, $9b23bf1934cbb958$export$b0e67572cf2555f7)(stmt)) throw new $00c9095dc018a9e7$export$773fc764960da4ba();
            else if ((0, $9b23bf1934cbb958$export$d05303fa73d3cd50)(stmt)) throw new $00c9095dc018a9e7$export$91a4fa3e8e7c8586();
        }
        throw new $00c9095dc018a9e7$export$1e06c21ce32643dc();
    } catch (ex) {
        if (ex instanceof $00c9095dc018a9e7$export$f9c837a54db411d && ex.lineNo === undefined) {
            if (stmt.$cstNode) {
                ex.lineNo = stmt.$cstNode.range.start.line + 1; // Langium range line is 0-based
                ex.lineStr = srcLines[ex.lineNo - 1] ?? "";
            }
        }
        throw ex;
    }
}
function $00c9095dc018a9e7$var$processBlock(statements, srcLines, exr, errorLines) {
    if (!statements || statements.length === 0) return null;
    const nodeList = [];
    for(let i = 0; i < statements.length; i++){
        const stmt = statements[i];
        try {
            if (stmt.$cstNode && errorLines.has(stmt.$cstNode.range.start.line + 1)) continue;
            if ((0, $9b23bf1934cbb958$export$d05303fa73d3cd50)(stmt)) {
                if (nodeList.length === 0) throw new $00c9095dc018a9e7$export$91a4fa3e8e7c8586();
                const lastNode = nodeList[nodeList.length - 1];
                if (lastNode.type !== "if") throw new $00c9095dc018a9e7$export$91a4fa3e8e7c8586();
                if (lastNode.falseNode !== null) throw new $00c9095dc018a9e7$export$91a4fa3e8e7c8586();
                const _arg = "";
                if (stmt.$cstNode) {
                    const lineStr = srcLines[stmt.$cstNode.range.start.line] ?? "";
                    const idx = lineStr.indexOf(":else");
                    if (idx !== -1) {
                        const afterElse = lineStr.substring(idx + 5).trim();
                        if (afterElse.length > 0 && !afterElse.startsWith("#")) throw new $00c9095dc018a9e7$export$1d21b533e0dc3eed();
                    }
                }
                lastNode.falseNode = $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines);
            } else if ((0, $9b23bf1934cbb958$export$b0e67572cf2555f7)(stmt)) {
                if (nodeList.length === 0) throw new $00c9095dc018a9e7$export$773fc764960da4ba();
                const lastNode = nodeList[nodeList.length - 1];
                if (lastNode.type !== "switch") throw new $00c9095dc018a9e7$export$773fc764960da4ba();
                let arg = "";
                if ("arg" in stmt && typeof stmt.arg === "string") arg = $00c9095dc018a9e7$var$cleanText(stmt.arg, true);
                if (!arg) throw new $00c9095dc018a9e7$export$eaf10ed6e5991cf8();
                if (lastNode.cases.has(arg)) throw new $00c9095dc018a9e7$export$a235ab136f3fda43();
                lastNode.cases.set(arg, $00c9095dc018a9e7$var$processBlock(stmt.block?.statements ?? [], srcLines, exr, errorLines));
            } else {
                const node = $00c9095dc018a9e7$var$processStatement(stmt, srcLines, exr, errorLines);
                if (node) nodeList.push(node);
            }
        } catch (ex) {
            if (ex instanceof $00c9095dc018a9e7$export$f9c837a54db411d) {
                if (ex.lineNo === undefined) {
                    if (stmt.$cstNode) {
                        ex.lineNo = stmt.$cstNode.range.start.line + 1;
                        ex.lineStr = srcLines[ex.lineNo - 1] ?? "";
                    } else {
                        ex.lineNo = 1;
                        ex.lineStr = srcLines[0] ?? "";
                    }
                }
                if (exr(ex.lineStr ?? "", ex.lineNo - 1, ex)) {
                    errorLines.add(ex.lineNo);
                    continue; // ignore error and continue
                }
                throw ex;
            }
            throw ex;
        }
    }
    if (nodeList.length === 0) return null;
    if (nodeList.length === 1) return nodeList[0];
    return {
        type: "nodeList",
        children: nodeList
    };
}
const $00c9095dc018a9e7$export$98e6a39c04603d36 = (src, exr = $00c9095dc018a9e7$var$DummyParseErrorReceiver)=>{
    const srcLines = src.split(/\r?\n/);
    try {
        const parseResult = (0, $d833f4f86363406c$export$af3eb6fad56069d6).parser.LangiumParser.parse(src);
        const errorLines = new Set();
        if (parseResult.lexerErrors.length > 0 || parseResult.parserErrors.length > 0) {
            const errors = [
                ...parseResult.lexerErrors,
                ...parseResult.parserErrors
            ];
            for (const err of errors){
                let lineNo = 1;
                const errObj = err;
                if (errObj.line) lineNo = errObj.line;
                else if (errObj.token) lineNo = errObj.token.startLine || 1;
                const lineStr = srcLines[lineNo - 1] ?? "";
                const msg = err.message || "";
                const tokenName = errObj.token?.tokenType?.name || "";
                const isIndentError = msg.includes("INDENT") || msg.includes("DEDENT") || msg.includes("IllegalIndent") || msg.includes("synthetic:indent") || msg.includes("synthetic:dedent") || msg.includes("Unexpected token: INDENT") || msg.includes("Unexpected token: DEDENT") || msg.includes("Expecting token of type") && (msg.includes("indent") || msg.includes("dedent")) || tokenName === "INDENT" || tokenName === "DEDENT";
                const parseErr = isIndentError ? new $00c9095dc018a9e7$export$d0be8b16a0056b4a() : new $00c9095dc018a9e7$export$1e06c21ce32643dc();
                parseErr.lineNo = lineNo;
                parseErr.lineStr = lineStr;
                if (!exr(lineStr, lineNo - 1, parseErr)) throw parseErr;
                errorLines.add(lineNo);
            }
        }
        const model = parseResult.value;
        if (model?.$type !== "Model") return null;
        const statements = model.statements;
        const blockResult = $00c9095dc018a9e7$var$processBlock(statements, srcLines, exr, errorLines);
        if (!blockResult) return null;
        if (blockResult.type !== "nodeList") return {
            type: "nodeList",
            children: [
                blockResult
            ]
        };
        return blockResult;
    } catch (ex) {
        if (ex instanceof $00c9095dc018a9e7$export$f9c837a54db411d) {
            if (ex.lineNo === undefined) {
                ex.lineNo = 1;
                ex.lineStr = srcLines[0] ?? "";
            }
            if (exr(ex.lineStr ?? "", ex.lineNo - 1, ex)) return null;
            throw ex;
        }
        throw ex;
    }
};
const $00c9095dc018a9e7$export$8f49e4af10703ce3 = {
    parse: $00c9095dc018a9e7$export$98e6a39c04603d36
};


var $8a139cfa01cef008$exports = {};
var $8a139cfa01cef008$var$eaw = {};
$8a139cfa01cef008$exports = $8a139cfa01cef008$var$eaw;
$8a139cfa01cef008$var$eaw.eastAsianWidth = function(character) {
    var x = character.charCodeAt(0);
    var y = character.length === 2 ? character.charCodeAt(1) : 0;
    var codePoint = x;
    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
        x &= 0x3FF;
        y &= 0x3FF;
        codePoint = x << 10 | y;
        codePoint += 0x10000;
    }
    if (0x3000 === codePoint || 0xFF01 <= codePoint && codePoint <= 0xFF60 || 0xFFE0 <= codePoint && codePoint <= 0xFFE6) return 'F';
    if (0x20A9 === codePoint || 0xFF61 <= codePoint && codePoint <= 0xFFBE || 0xFFC2 <= codePoint && codePoint <= 0xFFC7 || 0xFFCA <= codePoint && codePoint <= 0xFFCF || 0xFFD2 <= codePoint && codePoint <= 0xFFD7 || 0xFFDA <= codePoint && codePoint <= 0xFFDC || 0xFFE8 <= codePoint && codePoint <= 0xFFEE) return 'H';
    if (0x1100 <= codePoint && codePoint <= 0x115F || 0x11A3 <= codePoint && codePoint <= 0x11A7 || 0x11FA <= codePoint && codePoint <= 0x11FF || 0x2329 <= codePoint && codePoint <= 0x232A || 0x2E80 <= codePoint && codePoint <= 0x2E99 || 0x2E9B <= codePoint && codePoint <= 0x2EF3 || 0x2F00 <= codePoint && codePoint <= 0x2FD5 || 0x2FF0 <= codePoint && codePoint <= 0x2FFB || 0x3001 <= codePoint && codePoint <= 0x303E || 0x3041 <= codePoint && codePoint <= 0x3096 || 0x3099 <= codePoint && codePoint <= 0x30FF || 0x3105 <= codePoint && codePoint <= 0x312D || 0x3131 <= codePoint && codePoint <= 0x318E || 0x3190 <= codePoint && codePoint <= 0x31BA || 0x31C0 <= codePoint && codePoint <= 0x31E3 || 0x31F0 <= codePoint && codePoint <= 0x321E || 0x3220 <= codePoint && codePoint <= 0x3247 || 0x3250 <= codePoint && codePoint <= 0x32FE || 0x3300 <= codePoint && codePoint <= 0x4DBF || 0x4E00 <= codePoint && codePoint <= 0xA48C || 0xA490 <= codePoint && codePoint <= 0xA4C6 || 0xA960 <= codePoint && codePoint <= 0xA97C || 0xAC00 <= codePoint && codePoint <= 0xD7A3 || 0xD7B0 <= codePoint && codePoint <= 0xD7C6 || 0xD7CB <= codePoint && codePoint <= 0xD7FB || 0xF900 <= codePoint && codePoint <= 0xFAFF || 0xFE10 <= codePoint && codePoint <= 0xFE19 || 0xFE30 <= codePoint && codePoint <= 0xFE52 || 0xFE54 <= codePoint && codePoint <= 0xFE66 || 0xFE68 <= codePoint && codePoint <= 0xFE6B || 0x1B000 <= codePoint && codePoint <= 0x1B001 || 0x1F200 <= codePoint && codePoint <= 0x1F202 || 0x1F210 <= codePoint && codePoint <= 0x1F23A || 0x1F240 <= codePoint && codePoint <= 0x1F248 || 0x1F250 <= codePoint && codePoint <= 0x1F251 || 0x20000 <= codePoint && codePoint <= 0x2F73F || 0x2B740 <= codePoint && codePoint <= 0x2FFFD || 0x30000 <= codePoint && codePoint <= 0x3FFFD) return 'W';
    if (0x0020 <= codePoint && codePoint <= 0x007E || 0x00A2 <= codePoint && codePoint <= 0x00A3 || 0x00A5 <= codePoint && codePoint <= 0x00A6 || 0x00AC === codePoint || 0x00AF === codePoint || 0x27E6 <= codePoint && codePoint <= 0x27ED || 0x2985 <= codePoint && codePoint <= 0x2986) return 'Na';
    if (0x00A1 === codePoint || 0x00A4 === codePoint || 0x00A7 <= codePoint && codePoint <= 0x00A8 || 0x00AA === codePoint || 0x00AD <= codePoint && codePoint <= 0x00AE || 0x00B0 <= codePoint && codePoint <= 0x00B4 || 0x00B6 <= codePoint && codePoint <= 0x00BA || 0x00BC <= codePoint && codePoint <= 0x00BF || 0x00C6 === codePoint || 0x00D0 === codePoint || 0x00D7 <= codePoint && codePoint <= 0x00D8 || 0x00DE <= codePoint && codePoint <= 0x00E1 || 0x00E6 === codePoint || 0x00E8 <= codePoint && codePoint <= 0x00EA || 0x00EC <= codePoint && codePoint <= 0x00ED || 0x00F0 === codePoint || 0x00F2 <= codePoint && codePoint <= 0x00F3 || 0x00F7 <= codePoint && codePoint <= 0x00FA || 0x00FC === codePoint || 0x00FE === codePoint || 0x0101 === codePoint || 0x0111 === codePoint || 0x0113 === codePoint || 0x011B === codePoint || 0x0126 <= codePoint && codePoint <= 0x0127 || 0x012B === codePoint || 0x0131 <= codePoint && codePoint <= 0x0133 || 0x0138 === codePoint || 0x013F <= codePoint && codePoint <= 0x0142 || 0x0144 === codePoint || 0x0148 <= codePoint && codePoint <= 0x014B || 0x014D === codePoint || 0x0152 <= codePoint && codePoint <= 0x0153 || 0x0166 <= codePoint && codePoint <= 0x0167 || 0x016B === codePoint || 0x01CE === codePoint || 0x01D0 === codePoint || 0x01D2 === codePoint || 0x01D4 === codePoint || 0x01D6 === codePoint || 0x01D8 === codePoint || 0x01DA === codePoint || 0x01DC === codePoint || 0x0251 === codePoint || 0x0261 === codePoint || 0x02C4 === codePoint || 0x02C7 === codePoint || 0x02C9 <= codePoint && codePoint <= 0x02CB || 0x02CD === codePoint || 0x02D0 === codePoint || 0x02D8 <= codePoint && codePoint <= 0x02DB || 0x02DD === codePoint || 0x02DF === codePoint || 0x0300 <= codePoint && codePoint <= 0x036F || 0x0391 <= codePoint && codePoint <= 0x03A1 || 0x03A3 <= codePoint && codePoint <= 0x03A9 || 0x03B1 <= codePoint && codePoint <= 0x03C1 || 0x03C3 <= codePoint && codePoint <= 0x03C9 || 0x0401 === codePoint || 0x0410 <= codePoint && codePoint <= 0x044F || 0x0451 === codePoint || 0x2010 === codePoint || 0x2013 <= codePoint && codePoint <= 0x2016 || 0x2018 <= codePoint && codePoint <= 0x2019 || 0x201C <= codePoint && codePoint <= 0x201D || 0x2020 <= codePoint && codePoint <= 0x2022 || 0x2024 <= codePoint && codePoint <= 0x2027 || 0x2030 === codePoint || 0x2032 <= codePoint && codePoint <= 0x2033 || 0x2035 === codePoint || 0x203B === codePoint || 0x203E === codePoint || 0x2074 === codePoint || 0x207F === codePoint || 0x2081 <= codePoint && codePoint <= 0x2084 || 0x20AC === codePoint || 0x2103 === codePoint || 0x2105 === codePoint || 0x2109 === codePoint || 0x2113 === codePoint || 0x2116 === codePoint || 0x2121 <= codePoint && codePoint <= 0x2122 || 0x2126 === codePoint || 0x212B === codePoint || 0x2153 <= codePoint && codePoint <= 0x2154 || 0x215B <= codePoint && codePoint <= 0x215E || 0x2160 <= codePoint && codePoint <= 0x216B || 0x2170 <= codePoint && codePoint <= 0x2179 || 0x2189 === codePoint || 0x2190 <= codePoint && codePoint <= 0x2199 || 0x21B8 <= codePoint && codePoint <= 0x21B9 || 0x21D2 === codePoint || 0x21D4 === codePoint || 0x21E7 === codePoint || 0x2200 === codePoint || 0x2202 <= codePoint && codePoint <= 0x2203 || 0x2207 <= codePoint && codePoint <= 0x2208 || 0x220B === codePoint || 0x220F === codePoint || 0x2211 === codePoint || 0x2215 === codePoint || 0x221A === codePoint || 0x221D <= codePoint && codePoint <= 0x2220 || 0x2223 === codePoint || 0x2225 === codePoint || 0x2227 <= codePoint && codePoint <= 0x222C || 0x222E === codePoint || 0x2234 <= codePoint && codePoint <= 0x2237 || 0x223C <= codePoint && codePoint <= 0x223D || 0x2248 === codePoint || 0x224C === codePoint || 0x2252 === codePoint || 0x2260 <= codePoint && codePoint <= 0x2261 || 0x2264 <= codePoint && codePoint <= 0x2267 || 0x226A <= codePoint && codePoint <= 0x226B || 0x226E <= codePoint && codePoint <= 0x226F || 0x2282 <= codePoint && codePoint <= 0x2283 || 0x2286 <= codePoint && codePoint <= 0x2287 || 0x2295 === codePoint || 0x2299 === codePoint || 0x22A5 === codePoint || 0x22BF === codePoint || 0x2312 === codePoint || 0x2460 <= codePoint && codePoint <= 0x24E9 || 0x24EB <= codePoint && codePoint <= 0x254B || 0x2550 <= codePoint && codePoint <= 0x2573 || 0x2580 <= codePoint && codePoint <= 0x258F || 0x2592 <= codePoint && codePoint <= 0x2595 || 0x25A0 <= codePoint && codePoint <= 0x25A1 || 0x25A3 <= codePoint && codePoint <= 0x25A9 || 0x25B2 <= codePoint && codePoint <= 0x25B3 || 0x25B6 <= codePoint && codePoint <= 0x25B7 || 0x25BC <= codePoint && codePoint <= 0x25BD || 0x25C0 <= codePoint && codePoint <= 0x25C1 || 0x25C6 <= codePoint && codePoint <= 0x25C8 || 0x25CB === codePoint || 0x25CE <= codePoint && codePoint <= 0x25D1 || 0x25E2 <= codePoint && codePoint <= 0x25E5 || 0x25EF === codePoint || 0x2605 <= codePoint && codePoint <= 0x2606 || 0x2609 === codePoint || 0x260E <= codePoint && codePoint <= 0x260F || 0x2614 <= codePoint && codePoint <= 0x2615 || 0x261C === codePoint || 0x261E === codePoint || 0x2640 === codePoint || 0x2642 === codePoint || 0x2660 <= codePoint && codePoint <= 0x2661 || 0x2663 <= codePoint && codePoint <= 0x2665 || 0x2667 <= codePoint && codePoint <= 0x266A || 0x266C <= codePoint && codePoint <= 0x266D || 0x266F === codePoint || 0x269E <= codePoint && codePoint <= 0x269F || 0x26BE <= codePoint && codePoint <= 0x26BF || 0x26C4 <= codePoint && codePoint <= 0x26CD || 0x26CF <= codePoint && codePoint <= 0x26E1 || 0x26E3 === codePoint || 0x26E8 <= codePoint && codePoint <= 0x26FF || 0x273D === codePoint || 0x2757 === codePoint || 0x2776 <= codePoint && codePoint <= 0x277F || 0x2B55 <= codePoint && codePoint <= 0x2B59 || 0x3248 <= codePoint && codePoint <= 0x324F || 0xE000 <= codePoint && codePoint <= 0xF8FF || 0xFE00 <= codePoint && codePoint <= 0xFE0F || 0xFFFD === codePoint || 0x1F100 <= codePoint && codePoint <= 0x1F10A || 0x1F110 <= codePoint && codePoint <= 0x1F12D || 0x1F130 <= codePoint && codePoint <= 0x1F169 || 0x1F170 <= codePoint && codePoint <= 0x1F19A || 0xE0100 <= codePoint && codePoint <= 0xE01EF || 0xF0000 <= codePoint && codePoint <= 0xFFFFD || 0x100000 <= codePoint && codePoint <= 0x10FFFD) return 'A';
    return 'N';
};
$8a139cfa01cef008$var$eaw.characterLength = function(character) {
    var code = this.eastAsianWidth(character);
    if (code === 'F' || code === 'W' || code === 'A') return 2;
    else return 1;
};
// Split a string considering surrogate-pairs.
function $8a139cfa01cef008$var$stringToArray(string) {
    return string.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || [];
}
$8a139cfa01cef008$var$eaw.length = function(string) {
    var characters = $8a139cfa01cef008$var$stringToArray(string);
    var len = 0;
    for(var i = 0; i < characters.length; i++)len = len + this.characterLength(characters[i]);
    return len;
};
$8a139cfa01cef008$var$eaw.slice = function(text, start, end) {
    var textLen = $8a139cfa01cef008$var$eaw.length(text);
    start = start === undefined || start === null ? 0 : start;
    end = end === undefined || start === null ? 1 : end;
    if (start < 0) start = textLen + start;
    if (end < 0) end = textLen + end;
    var result = '';
    var eawLen = 0;
    var chars = $8a139cfa01cef008$var$stringToArray(text);
    for(var i = 0; i < chars.length; i++){
        var char = chars[i];
        var charLen = $8a139cfa01cef008$var$eaw.length(char);
        if (eawLen >= start - (charLen === 2 ? 1 : 0)) {
            if (eawLen + charLen <= end) result += char;
            else break;
        }
        eawLen += charLen;
    }
    return result;
};


var $a95d59889df6cf5b$exports = {};
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
/**
 * C1 Unicode control character reference replacements (code points 128–159).
 * Index i gives the replacement for code point 128+i; 0 means "no replacement".
 */ const $9fd64e2a597499ae$var$c1 = [
    8364,
    0,
    8218,
    402,
    8222,
    8230,
    8224,
    8225,
    710,
    8240,
    352,
    8249,
    338,
    0,
    381,
    0,
    0,
    8216,
    8217,
    8220,
    8221,
    8226,
    8211,
    8212,
    732,
    8482,
    353,
    8250,
    339,
    0,
    382,
    376
];
/**
 * True for NUL, UTF-16 surrogates, and values past U+10FFFF.
 * @param codePoint Unicode code point to check.
 */ function $9fd64e2a597499ae$var$isInvalidCodePoint(codePoint) {
    return codePoint === 0 || codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff;
}
function $9fd64e2a597499ae$export$b978ab756102108a(codePoint) {
    if ($9fd64e2a597499ae$var$isInvalidCodePoint(codePoint)) return 0xfffd;
    if (codePoint >= 128 && codePoint <= 159) return $9fd64e2a597499ae$var$c1[codePoint - 128] || codePoint;
    return codePoint;
}
function $9fd64e2a597499ae$export$87faf5ae118ef8c5(codePoint) {
    return $9fd64e2a597499ae$var$isInvalidCodePoint(codePoint) ? 0xfffd : codePoint;
}
function $9fd64e2a597499ae$export$8967df39235cf1b1(codePoint) {
    return codePoint - 1 >>> 0 < 0x7f || codePoint - 0xa0 >>> 0 < 0xd760 ? String.fromCharCode(codePoint) : String.fromCodePoint($9fd64e2a597499ae$export$b978ab756102108a(codePoint));
}


// Generated using scripts/write-decode-map.ts
/*
 * Inverse of the encoder's SAFE alphabet (0x21..0x7E minus 0x22, 0x24, 0x5C),
 * precomputed once at module load. Entries for excluded chars stay 0 but
 * are never read.
 */ const $fde567e0f53e756a$var$BASE91_INVERSE = /* #__PURE__ */ (()=>{
    const table = new Uint8Array(127);
    let code = 0;
    for(let char = 0x21; char <= 0x7e; char++)if (char !== 0x22 && char !== 0x24 && char !== 0x5c) table[char] = code++;
    return table;
})();
function $fde567e0f53e756a$export$cdfe8f8480190230(input, resultLength, atomCount, dict1AtomCount, ngramCount, dictSize) {
    const base = 91;
    const inputLength = input.length;
    // For 2-char codes, slot = char1 * base - twoCharBias + char2.
    const twoCharBias = dictSize * (base - 1);
    let pos = 0;
    /** Read one slot code at `pos` and return its slot index, advancing pos. */ const readSlotCode = ()=>{
        const c1 = $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
        return c1 < dictSize ? c1 : c1 * base - twoCharBias + $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
    };
    const dict2AtomCount = atomCount - dict1AtomCount;
    const slotCount = atomCount + ngramCount;
    /*
     * Per-slot contents: atoms (always a single value) live directly in
     * `single`; ngram slots hold -1 there and expand to
     * `pool[start[slot] .. start[slot] + length[slot])`.
     */ const single = new Int32Array(slotCount);
    single.fill(-1, dict1AtomCount, dictSize);
    single.fill(-1, dictSize + dict2AtomCount, slotCount);
    const start = new Int32Array(slotCount);
    const length = new Int32Array(slotCount);
    /**
     * Decode `count` ascending uint16 values from a delta+RLE stream into
     * `single[off..off+count)`.
     *
     *   code < 89   → delta = code
     *   code == 89  → run-length: next char encodes runLength-2; emit `runLength` consecutive +1 values
     *   code == 90, next < 90  → escape: delta = 89 + next * BASE + after-next
     *   code == 90, next == 90 → double-escape: extra char for very large deltas
     * @param count
     * @param off
     */ function decodeDelta(count, off) {
        let previous = 0;
        let slot = off;
        const end = off + count;
        while(slot < end){
            const code = $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
            if (code < 89) {
                previous += code;
                single[slot++] = previous;
            } else if (code === 89) {
                let runLength = $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)] + 2;
                while(runLength--)single[slot++] = ++previous;
            } else {
                const next = $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
                previous += 89 + // eslint-disable-next-line unicorn/prefer-minimal-ternary -- branches read a different number of side-effecting input bytes
                (next < 90 ? next * base + $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)] : $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)] * 8281 + $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)] * base + $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)]);
                single[slot++] = previous;
            }
        }
    }
    // Streams 1 & 2: atoms decoded into their slot ranges.
    decodeDelta(dict1AtomCount, 0);
    decodeDelta(dict2AtomCount, dictSize);
    /*
     * Streams 3 & 4 are read in two passes: first collect every ngram's two
     * references and derive its expanded length (each ref resolves to an earlier
     * slot, so lengths are already known), which sizes the shared pool.
     * Pool ranges are handed out in decode order, so the second pass fills
     * the pool contiguously with a single write cursor.
     */ const references = new Int32Array(ngramCount * 2);
    let poolSize = 0;
    let ngramIndex = 0;
    /**
     * Read `count` ngram entries (each = 2 slot-code references) for the slots
     * starting at `startSlot`, recording references and assigning pool ranges.
     * @param count
     * @param startSlot
     */ function readNgramReferences(count, startSlot) {
        for(let index = 0; index < count; index++){
            const slot = startSlot + index;
            const a = readSlotCode();
            const b = readSlotCode();
            references[ngramIndex * 2] = a;
            references[ngramIndex * 2 + 1] = b;
            ngramIndex += 1;
            start[slot] = poolSize;
            const entryLength = (single[a] < 0 ? length[a] : 1) + (single[b] < 0 ? length[b] : 1);
            length[slot] = entryLength;
            poolSize += entryLength;
        }
    }
    readNgramReferences(ngramCount - dictSize + dict1AtomCount, dictSize + dict2AtomCount);
    readNgramReferences(dictSize - dict1AtomCount, dict1AtomCount);
    // Second pass: concatenate each ngram's two halves into the pool.
    const pool = new Uint16Array(poolSize);
    let write = 0;
    for(let index = 0; index < ngramIndex; index++)for(let half = 0; half < 2; half++){
        const source = references[index * 2 + half];
        const value = single[source];
        if (value < 0) {
            let read = start[source];
            const readEnd = read + length[source];
            while(read < readEnd)pool[write++] = pool[read++];
        } else pool[write++] = value;
    }
    // Stream 5: data. Each code expands to its slot's stored values.
    const out = new Uint16Array(resultLength);
    let outIndex = 0;
    while(pos < inputLength){
        let slot = $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
        if (slot >= dictSize) slot = slot * base - twoCharBias + $fde567e0f53e756a$var$BASE91_INVERSE[input.charCodeAt(pos++)];
        const value = single[slot];
        if (value < 0) {
            let read = start[slot];
            const readEnd = read + length[slot];
            while(read < readEnd)out[outIndex++] = pool[read++];
        } else out[outIndex++] = value;
    }
    return out;
}


const $cc62f38eaffeb4b6$export$b6a4accd5ee85f69 = /* #__PURE__ */ (0, $fde567e0f53e756a$export$cdfe8f8480190230)("!}.&u%}'&}*'~!6*)%&,~!J~!J~%L~y<~!R,~~%Lu~~#GD~~#|)1#%}^%}2%+#.##%##%}&%##%'#%##&%#%#'%#&#%#&#'#%%#&#%##%#)%''%&%#%#'%#%%#%%}%%%#%#&(23#%%#&-%0%('1#(##%#'##+%'*.:1}#%#6-+(%'%%#%%%}#L'2351&('%}&/N'(0(/*-%(%%}#'+&T%7.2}#&%&#%#36/5##%&%%#&#%%#))2%%##%&&'0~!#*+&'%1~!%).'3q?&%'1~!.##%6(~!+%%%(Gw'rT~!E#<nA%#jZ~!H%(~!42##~!*31&~!G%U~#)5~#`3~!J~!Z~%]~%Y~%C~!q~!u~#kz~%#~!6'~!D~!U~!?~#T~!c%~!G#'~%7|~!G~!J~!G&~#pb~(Df}#%}*&}#%##%##%##&#-}&'#'&%#.++}%mI,#,@&(}*%}*'%&##&#%##%}&0}#.},U},%}+%}&%}#%##&}B%(}(%}+%)})%##%#&}&%##%&}<%}>%#%&}*%}(%}9%}/%})%}*%}*%}?&}&%}3%}&*#%})%#%#)}#&#-#+*%E%%'%'#%}#*V##&##I}#&&##%&%#&&Qf%%))w/0+&%#(#.%-''''++++7}>%4'',##1,#%#&%##&#'##&#*#9)%&%}#*}%,#+P(%A&%#'&##wSD',9E00#y#@}(+}&%&>~!#~!X}#*}(&&}(&}(,%}%&#+&}#&}I%#%}%)#(},'%#*}4%%#%}(''}#/##(##),%-##%%)#&}(.}&%#&}%%}*&#%},&&}&%}#%*'#%})%}D&}&%}-&}6&#&}-,%}#%})-(~+`~,=?~I9'9%~!,#%})%})%}@%}?%}(~!?~#<~#pP~#BG~#=1#%K+~#?#~%;)~#A~#mF1~#A'~'X%'~#lR~#N~'N~#r~#m#-~#i'?%#'%~#B%##%,%#~#_%#0%~#]732~,w~2+#:&#%&'0%&>%}#>##F+)#%&&#(+_}4&}-%}(&}@&}O7Fdf0@+/v4}&WU##&/0#&'('B#%}.%}'+#%}#%%&#&%#%##+#&#)#6#'#.},%}c%},%#%##%&#&%#&~#>'*-.%##%##%}#%%}%'~#)D1}#%*&~#_%%'(~#S2%'.}#~#=##*'*-%}&'%'##&&~'E%.#&~#M4}%%##&'%#~#O1##%&#'+~#<B%##%%'%+~#;#@%}#&%#&&%#(~#H1}'%'##&&~#?A}&'~#D#%32}'&&&&~#[}'(#%}'~#;C})&}%%#%~#=&%,3}%'(#%%~#^'#&&)#%'~#Y%-~#d-%'~#^%%&#&&&}#~#b~2t*&'~&(~&@~0%~e~3}%*''0})&}+~!9##-}#%-hD*)1fC#%/&/fB#40~!+#)*4~!+~!K'&:~!/*7~!.#~!H~!L':~%x&~!H#~!*~%1~!I#~!+A~#p'~!F~~#-#~,,(~.Z~!V~%;'B'mq-W~!N~%I%#&&#&}#%},%%}'%}+X#%}#&}(%}'%}<%}#%}%%'}'%}:~![)9@~%>~#UA%-%##&~!C%~!-.9:~!1~!-^2/:a~!y,D*J#-5)/4~%23,~#G~!L1~!0X3`~!2+~!!0-~&E~!W~!o,>Y&]~%cZx_&~#O*9#A#'#+I'%#)~!0B*-5A+-((F&*M#)(-7-5+'-3a5Vi~!Y~!?+[)%3),ERHm~!+:D,VG.+)?fB%%*(%)'(#&80%1'8`K8?`+'Z#&O&'H5#*9)A%%5&3))0%39+.*7#()&&*=4@**L)<'_&*+..;(#*+)./&0#3)%')-8(4ixD(&.}%,('aI:,)%,k2231T)I'#/-W7,/'Q#.'Y24+h')37</31&83##&0#),H(?'&?/1##%#&&#%''-%&&&#(&''&#.-'%#%%(,')*'&#&#'##%(%(#%('#&##%%%%('%#%#%%#%#&%##h>w+v<ayvyvcg.uuhKr}g/v|g>u9i[~>g5uI~=RvdwEg;v/g;uk!!TTSx]@RT!U!#!@VBRUU!'UTe-d0c`e&gSdicedFcrdTaqb.kYcAohdYd@a3e+d}dMdtd.aJ#bqcK`dle/e.e'dwdPdodddjbEb}ogd^ofdpduc6j?l%d{drdqc)d7bacOdQ%T#Y)X.sR[yH>6Vyv3[xwLu>vo'!*.[yBacahoj>6Rew3[xqdZa#!a&#^(X-[yG>6Vyu3[xvg3sEr|g.u/Ri9db0T#^(Xa)!-[y;>6Vylg4wKs{JwNZt3@3r=c4Z([xlg;wKt!cpq's@v7A'*a(a+!-a#[y<3Dt?3Dt'>6Vym3[xmg9rxsNJwLZt4~?r?db1T#`-!(Xa,!0[yS>6Vz%NuQs.g4wKtnJwNZtS@3r>c4Z([y%g;wKtrdga8!a(!#&T*Y-Xa#!a0<or[yc3Dtq>6Vz43[y3JwNZtf@3s!Ju}!%Dti:pm3c_%X#tjB5pkd6q!r]u?voC'*-a.a2!0a&a+[yI3DtI3Ds~3DtH>6Vyw3[xx;:s#~<5pKJwNZtE@3r~d`a)!a2T#a.(!+U.X1[yT3Dt`3Dtv>6Vz&3[y&g9rxwzcxstPu.<rAJwLZtT~?r@dZa%!a.&^*Za(/Reu[ya>6Vz23[y1g3sEr}wkg{NuQRg{ci(U#5@b`~,cg#U(2WnH5wugcRh7dX#T(Y,a'Ta!!a,[yZ<]mj>6Vz,3[y+Pv#5ReZKu+=,%!H}7ABwkaS?Rh:BcW(X#<]mrj:ubv/ARekdg%!(!a.*Ta(Y.X1!#sP>Rl*Dt6[y>>6Vyo3Wf*jOvuumvuRgRJuq*!:9<B@bX~3jVv&v@s@5Re[d/rQt{uAvo&a&a*)a2!,0Wf!3Dt0=Bs'>6Re}3[xy~<5s%JwJZt1~Gs)c;&!#2sJkNuXvzq7rxu,Re8dka4!a8(aEZ+a@Y.X1Xa)[yd=Bs(3DtP>6Vz53[y4cX#X&Re:avRe9~<5s&JwJZtQ~Gs*i^rzvdRg+Jv{%!2sbB@bX}kdga,!Za?&^*T1/!a'Dt+[y6>6Vyf3Wf%g/u;s4hGu6?Rh-JvZ,!c%#&RoX54Rivj7uyvf8RgTKvZB%*!2sGh<vu5Rgq<=C::9bb~#dZ#T&Ta6Y.X*Dt>[y93Wf)coZ(T,6VyifluvRgC@95@B@bX~/hFu34cC#T,k/unq8w8Q5RkUklwQuzunq8w8Q5Rk8d/rJu?v8w9)-&!a0a;a&aIWejg3sEr/h1s<DtDJvyZqY5aws3Jvy!&Wei~Hr1:au5@Bag>23E~5c:Z&bX};kKv?w&unuVu5Rjc;>bs)#~@:Rh.=ay<a]C;b`}Vd6s/t{uAvoaxa()!a,a7%-a#a2Dt,[yF2Wo[>6Vyt3[xuNuPRi&NuPwpi#RoWh?vf8Ri%Jv]!%Ri:KvxD!.'2WeAjZu`q9rxu,Re7woeAg-unLq(qA_/*2Wg_g3u5q^9:4E}/jTrxrzv=Wkkd~0UX#^^Xa-a1a5T&a=U1a'*aEa]!a*aPaA-adok[y54Rn>;:p3~Dp5g9rpsFNvZqjg3uJp4~<5p0Pw;5qlJwNZt*@3p1Pw:5p/Ou!5p2JvG'!6Vye=<qnJvh_[xhg3v,Rh3kOwOw-sDuev/Re^dha[a%!%!a+#Ta7)-5TaCaO!aka!a)sf[yb2>Rl!9ARiq5E}Qg=ucRkBE|oJrJ_@Wk~@Wk{JrJ_@Wk|@WkyJrJ_@Wk}@WkzJvO_[y2g-vMRmiKuYC!)&>Ri;>Ri<@3RkNc](X#@9Rk=g5vuRmhKvDB!+'=]meg3u4Rmgd)#Y'Vz3CARmfd`a+!%T'!+#Ta1Ta6TaM-sTDt9[yA9sYd'%Y#s[[xpj:ueunaXRgEjRq,v-vuqdd2'`#6Rev<32@5>:2<E}5xIo9a*X#Y(;5RePJvD_g>vyRgNj8w)v8<wggs:RgXiZt|vjx,hSq3ah!-(~@:Ro/Ou!5RhWj^v(pyw8unRhUdx-UY#^Ua.a3a70!)%UX1TaDa)'omRiRRhE[y:3Dsz=Br,>6Vyj3[xkg6ruwjcqsrPw;5r*Ku]D'Zt-@3r(~?r.i[vwv]dU1a--U#`a4(g/vsRhPOu!5RhLj:rmu9Wo!~@:wdh@g/vsRiTjXuvvNr}:RhBj^v(pyw8unRn]dz1UYa'a+^Y(!aETZalaRY.Ta?a4[yDJw1!#qLsW>6Vyrfzq-pLflpwRe|Js>%!Dt@3Dt&Jvy_[xs~HrnjMuwpsw'RecKu+D#'!t<~Grl~?rjg5u-x,gwp{ah!-(~@:Rg~Ou!5Rh'jXuvvNr}:Rh#cW#X/c;&!#2sLi[v7u7RgpJv)(!iLrxu,Re6j7v@s@5Se[e7d`aW!Za(a`T.a#!a3!&aDa-!9)Dt_=6s+3[x~~DR|h~DS6avhGun5RkZj3w)v-]mkKunB!&*]kb97R|i<ARk<c:Z(6Vy}Juh'!wziMRoS:F|vkLuauJv5vtvQRh1d='T+Y#VyO~DR|jcF#T'7R|g97R|kJv3'!ay<Rj,Jvh&!:ReXcsa6*a+#a#_aIRf9aLRf?c,Z&Rf5Rf7c.Z&Rf;Rf>cQ#%T'p-Rf8Rf=ct#%'(*!,p,Rf4p+Rf6Rf:Rf<d~'Ua%U*^UYa(!a,-!#a4YaTalaEX0a8a<Weo3Dt/3Dsx=Br93Wen~Dr;~<5p<JwNZt2@3p=Pw:5p;Ou!5r3c7&!#:p>3Ds}KvGB)_6Vyk2sM=<r7x'eovA(!hFu1ARf}cV#X&@r5j6rvwQa^Rf3c=Za'wkghJv__g;unRggA53B9=b^}%j6uduo5Jq;!(hIv%2Re`Ou4ARe_e%a#^^^Xa&!a*a2!&a6YaP!*ad!#a:aE/5Rn?[y@>6Vyp;:pE~DrY~<5pBJwNZt8@3pCh=rt3rWPw:5pAJup_[xoNuPpF9c!#'45pD5ARn)d8#X'X*3@rU72s]h>v<<sSjJpqvewOJq/(!hNw'5ReBk0s2u3w/w'5ReE5@Jq.!a+JQ!&WeU23d(#Y&RjG5]jBk!u7w&u0udARjEe#+^^^Ub#!a2/a`Z(agT1!a-a;|@TaG!aS[yV=Re~fow'RguNuPRe?bz#'>RoUWeL>:Cbb|?JwPZtVg6ruRmzJvD'!6Vz(g/vmRh~Jvy_[y(g9voRgyx*cy(#2>Ri2B9b]~9kIw9u7rluJu3Rg]dI#a%UY'@=p%CAx.gQZ&RhwwygtRm{x5g_Z'+ABqR9Woa=Bp&dV#^*Xa'!&@o{g4v]Rk;Jv{!%Rk[wkkiA5RkiwwfUB=x,fUuqC&*!>RfTg8v0RfV~ARfSd;rJsAuAv9wR'ae+/aO!a@aza/a#[yQ@Wg!2Wemg3sEr0JvB_g>uvReWg2v+Re=KupB_+[y!2AbY~-~Hr2AJwD!(h<~El>h<~El?Kun@+_:9b`}Kg-v/Ri3g;vtwyk_9]k_d=&T#*U.6qh@Ab`|K9:H|CJv[!&3Dtex'fDwC%!Rf[9WlMd[(^X,!a%Z06Vz!@WgBg=v~Rgvg,QRe@awd,#Y+jTv|Q~EfWj]uNr|~FRfXdy#Y&^Ua%!aO.!(a)Ua;=!a@aKap!a-,a!Ta]a[rSa]p?[y82sK=Bq~;:p:~<5p8Pw:5p7d'#Y'Wf(;RnRi[u4w&RgJJvG'!6Vyh=<r#ijuuv/sIKuYD'ZtG@3p9~Gr&d2#`(g<vtRgFj`u5w&rqpxRf2CJuY!+:wfnTOu!5Rg}jNs1ucv&RfwJvA!&3@q|BDcC#T,k/unq8w8Q5RkTklwQuzunq8w8Q5Rk9dga#!a'!a=#a0!:+Tb*b@aO.a4!aba8aFJv^}?!VyR~Dr<g;u%Rn.~<5p[x'e`wNZtR@3p]Pw:5pZhNvjBp.woe_g5u-r4JwF!%DtO3:ooc7&!#:p^3DtpLuGw(!+%)Dtk6Vz#2sd=<r8d'#Y([y#<x3gJt`w@!)%}MRiowzikRij=]ilxAf3,U(#B2Rf#g0v-Rm[ck{`U#]giKv3>)!&6Ri154s,KuGB_%@r68r:dJ|t`#X(9<E|u2@H|rx3gJu?w'!+'1Nu7Reg4=H~+9<wxgY95Rm]xLggZ-`(X}U2:Ri4h<uOawRmsJv__5@bb{jbV~3dka#a'a]!,#a+U=a>b6a3b%!/aKa/)!arwve^VyJ;:pR~DpTg3uJpS~<5pOPw;5qmPw:5pNOu!5pQJvG'!6Vyx=<qoJvA!{~Jup!%@qk7Rn/KvyD!}''[xz;>wkh'?Rh,x8gyt`w5D!&),(SgyccRgztJ@3pPB5p#d'(Y#<]mmifubw&RgoJvE&!82s^JvF&!8Rf,ADb]~;x=h'rNu]vK!,%'*0RnORh)4Rh*AqQg-vaRnNg;wHwkh'ba~4cE#Ta*x3gctyw@'!+%RnFRnD<4Rn@hFvK5RnCxWg[#`&a0Ua()`1Rm75Rg[c]%X#qi8Rg^NvdRj>BwzgZauwji7Rm6A4wgg]d1#&(*,.0a#Rm;Rm<Rm=Rm>Rm?Rm@RmARmBe%#^^^Xaea?aC/b+(,!a+a#!a/!>a&Ta<aKbD!2wphBRnk[yPw}hE|.=Br-3Dtm>6Vy~g6urRf.x,hPrNav!%'RnqRo%Ro#Nu;q[Pw;5r+JwNZtM@3r)d'#Y'Weh;xChL#`&RnmRnoKu}>%(!Rne~Bs-;2wjcussJv+'!aYSO}6@B<5?ba~8LrNvj!.%*ROwungw~ng~:9;Ri^>wtnig;wHRnixDh@|(UZ.x1h@|)!#:2<H|*xHn]#-UX'3Ro)z=iT}6ARns=Bwsn_wpnaRncw]aR(#UXa&Ua*a/=]iPd'#Y&Ro'WnXf{QRm2hNvj]nZd`'T~&1`{|`#9b]{}c:'!#Wl{>@=be}]?cl{{U#:5Abb}Jds#^YaF!a*b4a#a3aPa>&Tb!bH!*a_!Eau?/a&RjY<]gj>6Vz*;:pe~DrZg,QRj1JwNZtX@wihspcJvZ&!VyX9WmOJu|!|N2WmHJvh&!]ht~Bpbcn&T(!#RmQ<s7Nu;padH#X'`+WmJ@>RmKCARhnKup=!)&Wf+:RhqNuPpf9c!#'45pd5AwghpARn(Ls@w!%,)!RmP@Wfe<E|IJva!&WmNg8vsRmLd`*.`#Y'Xa!axRn*]hrA8Rhug5s@rXg8u!RmMd8#X'X*3@rV72smdI*#UY&RmICARho~GsgxVgd)Ta'U-Y&Xa!T#RnEWnA@Wffg1uDRi0hFvK5RnBxGnG&#`%owp)@wsf+bX}Ze-*1!a*^^^Ua|!#a.aq&Ya2!a>.a6!a:aO`aJDtL[y`@Wg#>6Vz12@wzoYRoZNuPRi!NuPRhzg=ucRi,@=b`{Yg=ucRi-ACJvB!&Sh[ebSh]ebi`wUuFRm4Jw2_[y0JvB!.<Ju(!&SoG}6Shd}6<Ju(!&SoH}6She}6Kur@._g5vHRieJvx!{L2G{Kx6gd'T#?Rh82Wi5cZ#X(g1w)Rm5dW-Y(Ta#!a)!#aYa=wnfE=su2>>bU{0j9udv:<svj8uQv-7RgHdE%#^'sq9sp=>Bb_{TJv`!&g/r|snj6v(us5d,#Y(56H}[978H}]Jw5!&g1rushJvB!+j;v{u5?zDhd}6}bj;v{u5?zDhe}6}ce*#`(^^^a[aea!=!a6a*aoXb1a.!aAbL!b>,b'aL!aV@Wf|2Wlg3[y/JwNZt^@3piPw:5pgJunZou3@rsJva&!Vy_g<v~Rm#JvG'!6Vz0=<r{Ju{%!:pj@WfsiXuJu3Rm:JvZ&!WfA~Bph@c4Z&Dtwax5rubx(#:awRk1@d,#Y&RfjRfid1#,Y(@Wfp2Wlrg5s@ryKu[@!,'=]ig9wlk?Rk>g5u-rqJvy'!@9RkQcH(T#=>Ri~@<wkj(Wj(KuZB*!&<7rw@9RkRcH(T#=>Ri}@<wkj)Wj)dg(Ta2Xa9X#`-!a*CARhg@@=I}d9x;c~#X%so=<sj>2@@=aybb}XjWv0Q~EfEj3vLv;<d,#Y(56H}`978H}_dgaPaFa'a/!#a3Y0a_a;a|!1(a7-[yE3[xt;:pJNvZrrg3uJrvJwNZt=@3pIh=rt3rxPw:5pGOu!5rpJvG'!6Vys=<rz@c4Z&Dt(ax5rtJvZ!&~BpH@wsfNg-vaRlNci*U#=<wei<F}a5@Jq.!a*JQ!%@qZ23d(#Y&RjH5]jCk!u7w&u0udARjFd/prq=tyvpaEa(a:.!a1aZ(@@=I}:9wpd%=<sX55w_h}@@=I{t=ay<aU@@=I}T=ay<2@@=I})?C9:9au@9Cb]}DP~=x-fAZ(2Wl1=ay<aU@@=I}>5@d##Y+jTv|vV~EfFj]uNpn~FRfGdgaK!Z2&!a8a-Tb({E!acTbM*!a(DtY[yYd'%Y#sl[y*hHvh>Re5x2c{Z}.j4uCvcawRiMd+#X+_x&d!},<5RkX;2Hzw@x,gavfB-!{CcF&T#Roe;RodwWbBg5urRgaKvHC*_6Vz+<4opieuew&Rmq@d]&Y)X,T#X0Rh}<BqP=4qS9:ReMg/ujReNJw0!/<Jui%!bd{kawwnemRelAxUa?a3#*.&UX(Ya+a/RhvRnQ<o}9Wmtd-#Y&RgSRmw9;Rmxay=Rmyg-vaRmuxEhSrNu,v-voC!%(aR.a(a7+1Ro1>Ro5CE{A9b]{@;5x#eO{:g;urRi+KrNA!%(Ro3>Ro79;Ri_Ku@>{;&!x%gX|{KunA_+g5QRj/g3u5Rj#g>uERj%wio/xRhS&!,!#^1U}wba{8>>@=be}qC@:D5ba{7Ku+A&!}x?ba}t>>@=be}se(aA^^^Uat!b0#{pa+awUazbGa#aLb9bgaWac'a5TbS=Br!d1#`%scp_Jvl!#rT>Re0JvX&!VyN=H{Fcm#U&:pY=ReaJv2&!]h0=]nUJvG'!6Vy|=<r%JrM_=]h2@Wlud'#)U'Wf'b]{i=]h/Jvh!&~BpWg=v]RnMx+ny#'Nu;pVwjnu=]nwxJnx,T#`&Reqwjnt=]nvieu9vrRjLLuYwP(#+!th@wih5pX~Gr'g5v/Rh4KunA'!-CARnP@wwiN:Rm_9x'cvw>!|l=<saKvAA!0&3@q}>w^e1bp#&Re2Re3BDx7gH#T|f5H|eKuZ>!%(:qNAH{]Jv6!+3B2B9=b^{X<5<B92:E{ZLvhwA(a;a%!igQuyRmad+#Y}m@3Rh5d8#X'X*:AqUAHzmaxwbh<aXRnVcF}RT#Nw&cj#U(BWnug/vsRntdka)(a3+.Zb7aYYan1!bVa@Xa}[y^@b[{G=H{+hFu73Rj&Pv#5ReQcK%T#sig1v{Rj'Ku+D#'!t]~Grm~?rkKuMB!01d5#`'Vy.ta3Dtu~Hroc8#'{^45s85AwZbP&!#Rn!wghxWn#KvEA!)&2RlA2RlBx:h|#(T,=]j09Wobz>x]z/@awRoTd+#Y(az]hFhCrm4d,#Y+jTv|Q~EfMj]uNr|~FRfOdCa!Xa9_X#@<plJvf!%b`{(9;Rgwc;.!#2x7cw#T|UDb]|T5Ju={(!=@E{&Jv)&!Ab`{'awJvf!~*>>@=be{#KuY>!+&4Ezyi[ugv&RjIdea+T)#UXa&T-T&a!Rh9auRmW=]kLg5vuRn+g3u4Rn-Ow6ARn,hHus5xNk?#UX(U~)/g8v0RkD~AwkkF?Ri.OuNBwkkA?Ri/d|a2`a*^UYa.!aBTZaTa'Xa;!(!2!-a#b2[yC>6Vyq3[xr2Wi?g1rusVh%s?DtF~<5rbJs;%!DtBfswKtCj[uvuSsEu3RgVx3o:u+wN'*Zt;@3rd~Grh~?rfg8w)Lq)qE&-a%!>bI|`jWv0vV~EfCjTv|vV~Ef@j]uNpn~FRfBcK#T']gWNu7x,k7q4ai(0!hHv8<RhmkMu9vrsBuev/RhlCJvB!,g<v{wchh~@:Rhji[vrv{wchi~@:RhkdS&a5UY#Ta!RgPwwiI5BwciI~@:Rh`x'iJvj'!5]iJPu8Bwch]~@:Rhach)U#h3rp]gLh@t|Ax,hTq3ah!-(~@:Ro0Ou!5RhXj^v(pyw8unRhVd|)`,^UYas!a?/a2Z'a^Ta{Tb7Ta(a#!a,Wf&9sZ3DtAadamov=Bqt3[xig8vsRm~>waiL2b`{QJv*_Ouv2qgj<v]v2BqfdR'X*X#Y-@3qr~Gqv~?p6hHv-]glPup5Lq+q?_%*b_{qF{n9b^{rOu4ARhpKvCD!+&~Bqp:5Dbb}nwoiKl&unuTuBv]v+ueunaXRf0=Jvh!0nKufu8v1w&w7q%w&uHrz:Rgnj5w,uxDJq/(!hNw'5ReCk0s2u3w/w'5ReFd>Za&!*UaA=<wkgsRnSJv^!%Refifw3vyRgOKu_B'!,<]gkiiu:w&Rh<=C@a^<B57@2F{[<B5@aW:=3away9A5aW=<B=C@a^<B57@2F{Ie-#`(^^^bCara.b8aza6!/bZ,!adTbnTbOb+aFaS!aAT9@Wf~2Wli3Dtl2@d,#Y&RfnRfmJwJZtN~GqyJva&!VyMg<v~Rm%iXuJu3Rm9Jv[_=]ih9wlkDRkCd1#`(@Wg>2Wls3cH#T(@<Rj*=>Ri|b~'#23s9h<~El.d'#Y&Dtxi^rzvdRl#d*#U%(o|B2s`hJwSaxRmDKv4B&!1:Rmdd5#`'Vx}to~Hq{x'f1v3(!BA5ba|bJv_&!Wfug1v]ReIdO+U/Y#&G}-8wze=Rh{g1v]ReHg/uQRf/by#)ibQwERl/cH#T(@<Rj+=>Ri{cNu+vlax-!(#a0qa9<Rii2;;bU{H;x<i=&X#Rk`<4wwi=C9H~8xAI(Y#<azRi@45wXI<B9;5bb~7dL(X#Xa(+!aL6Vy{g5QqOau:5au2@ay547EzbxOcU(UX-T#Ta#:Cbb|A?wjh/b_|SOw6ARgtihr}u7Rhy<d1#T)X1@@=I|~=ay<2@@=aybb}Sj3vLv;<d,#Y(56H}A978H}@dGpvs@uAu`vcw9*!aFa+ai%(b!aXa8.a?a[ozWey=sU2@G}Nch&U#Rf_WexKu+D#'!t:~Gr`~?r^j]uNr|~FRg*j^psurwJt|RmcKv)@&!)7Rkv~Br[@wxfO:Rl3co#U'6Rezj_q#vIuavjRltwzeyh@vr5JqD0!>aY?C9:9au@9Cb]}9cl#U*5;5<H||jbuus1ucv&Rfvg1v~d/pppzqFr^a--a~!aMat1(hFv;Wiz@@=Izoj5uuv-7Rix~Cw`fk2WlVcZ#X,k)u3vWs@u2]ktg;wEx'fBq(_2Wg/jTv|vV~EfoJv]!15x'hzqG!(P~EfU~CRl_j6v(us5x4i-#T(2WmZ?C2F|d>Kq<aj1!*jTqIsBv=Wl`~Cw`fi2WlWj`v0u*~>RlR=c>Z,k#u3vWs@u2]kr<c1Z+jTqIsBv=Wla~Cw`fm2WlXdmb3!a{(arZa`bkTa%TbQTa-a9+c'!aM!/[yL=Bqug.w'RifhFvyDRj.g>vgwyk^9]k^Jv3_@WfbAARkhJw2_[x|JvB_wkoIRoKwkoJRoLd'(Y#<]gm=<9<H|yd'%_X#skDtb3awwqkgNulRkgdB#^',9:p'hJwSaxRmEBwVb8@4=H|qLu+w50&!)@3qs~?pU>Awwn;;Rn=c:Z'ARn<=<qwKvC@!/&~BqqJv6!&]eVb^z^xRge'/a%+^`#Sge}6<4Rn3=]n0Pw2>Rn8Jw0!&>Rn:>Rn6cY#a7+!a&=<wkaNw~h3z_c5Z{=wjh#=]nLKv^D!&)Vyz=bW|swYb<WetcG#T(2wxa@qVx@gD#Y&b^|V5JwG&!5bb|pg/w&RgD@x=kHs=uAvn!a%%/'+RmSRh694Ro`g-vaRmRhHv-]mlxCcS#`&ba~.5cD#Ta)P~=d,#Y(56H{>978H{Dd_#{2^Y%_+qbbb{6g3sERhsbU{?dfa.,`a(Xa<!aiX#(55RiG54RiHcI#T'WiU3RiVNvdwtfcRlKNvdd,#Y&RlHRlExQgf.1*^T'X#Sgf}6Wn4=]hfPrk>Rn7Jw0!&>Rn5>Rn9Lunw?&a2!,5<oq@@wqfdRlJj5Q~=d,#Y(~ARfcOuN]fdDKw;ay(}i!547E}j?cI#T(@5bV}iCbV}hdv(^^Tb?a40,b##Tbo!a*bR!a<b|a/!aKai!aU[yK=]o^g:v>ReGJwPZtK<7Rh+h<~El,Pv#5ReR@awwxjCg,ulRjDJv6&!]j!z?aQeeg>w=Sh<eeJw;!&axEzOg,Qosc!#*:wkeJ]eJ>x'h-u(!%Ro.w~h.zPdNZ(X,Ya![x{;9ReY;wkgxRiF:x?ap#Y&RmUg<s2Rkod]+UY0TZ'!a&A9sw<=bczLNvuw{gqzNhJwSaxRmCKuLay!#&s_Rf-55b^{uJvZa!!c%#(55Ri654wmiu5RiuawLu,vp!+}^%b_}Y9;wkgxba}o>A9:=b^}zKuh=a''!3awRk3c*'!#aHRk6c+Z&Rk5Rk4Jv)&!awRjSawd9*`#0?C2@EzMj8u<uJ5RmbjQrquJu3x,k>uq@_+=ayb^|W~ARkEOuN]k@7dhzV^X/X&a-#zRzSb`zXcJzTT#2WkVKvDBzW!%FzY9;5bbzWjQrquJu3Jw3%!b`zU=ayb^zQd:#X(T-a!6Vyywxh}=b]{Jg=u1RiAdGp~qHtzv!w(wA+a+a;<!aJaYai'anasb(=azRmV:Cbb{MLq2vb!%')RjuRjrRjtRjqx3jnqCw3!%')Rk(Rk+Rk&Rk)Lq2vb!%')Rj{RjxRjzRjwLq2vb!%')RjsRjpRjfRjex3jcqCw3!%')Rk'Rk*RjkRjl9<CbbzfOu4ARhxLq2vb!%')RjyRjvRjhRjgx=joq*uKvb!%')+-Rk.Rk%Rj~Rk-Rk#Rj}x=jdq*uKvb!%')+-Rk,Rk!Rj|RjmRjjRjidAq&qKs@uAv8Aa.'*-a@a&0!aM@a5[y73Dsy3Ds|3Dt):wxgI2sHJwJZt.~Gqxwsf0ikrzt}Rl0Jvy_[xj~HqzKv_A|D!&WfP8axRoVcf,U#k(v]v+ueunaXRf1Ju}'!g8u#Ri=jQw!sCunLprq>!,')~<5qeGzq9F{W=c##%s5au:5aU3CBE|;d4#X(D!a&6Vygx(b;#(=]ed?C2F{N<capoq2r[a&!aPa9,'Pw;5s:@@=I|,55w_h|@@=IzcP~=x'fCqB_2Wl2>aU@@=I|1OuNBc1Z+jTqIsBv=Wlc~Cw`fl2WlZ~AcTa%!Z+jTqIsBv=Wlb~Cw`fh2WlYk+uNqJsBv=WlSg,u3dca3#UXaMYa)TaB-=cM|7T#<bI}l5@B932:aV2G{BOuNBJq:|M!5Ezt=<B=C@a^<B57@2F{v>cB{/T#=ay<bI{3Jv6!a.6BKq0ah&+!5E}HP~Ef{978BaU@@=Iza<7d#.Y#978BaU@@=IzH~AJq0!(@@=IzG978BaU@@=IzFe,aU*Y&^^^bvJb,b:bFad!a,c2Ta>aL.bo6!a#CbTa'T#Re{2Wlh2@G{yg6t~Ro_NvdRfticuRQRllJv3&!x&c|zs@Jw3!%RflwpfkRlpKuL;%(!Re<@G|C2GzdhIvuBwgjAg-u0RjAKQB%!(GzZ@G|5NuuRl7d='T+Y#Vy[g<v~Rm!==G|>JvA!)@wma=]m1ifuaw&RmnLs@vT'!|/+[y,g:v>ReTJw1!#qX=x!eC{bLu+wT&)ZtZauq_~Graci&U#F|89:r_Lupvq!.)&2RlG8RfaC=x!eF{_h?rpWlmd&'!#X|&]k::xJey#`'T|+<E|&2@H|%dE#(^,g;u.RiEg6vjRiC9xCkA{O|zY#g=ucRmXKs0@!&*@G|m@awRknJuh!,3d(}gY}eJvj!%Rm):Jw3!%Rm+Rm-Ls0w(&!a(a#@b[|6cZ#X'7RkxWgAOu4ARn'dH'U#Y*Vz-Wm'CARm}d]*#a%^a*T'aK!a<9bV{PC=p*Jw4!&SgxcbB5r]idw(wBRmF7xFkt#&`(Rm/Rm8E|!JuY_9:Rl5=wrgr2:bbxd@xXfB(a*#T+!.X0X1Ta/a'T&RlDRfL>RlyARl9b[z[>RfZ:RlL:RfRwlg/ARl;9;RlxKv,A/!%7s69<74=BA5ba{-8Bde#`a<XaKYa1,a'P~=wxfB2bZ}}?C972@@=I}r8@55B9;5bb}G978B2@@=aybb}3j3vLv;<Jw3&!>Rfk=ayb^}4~Ad1#`*@@=aybb{w2@>==<bbz]dx+UY#^UaF!a9!bB'Ya1.!ajXa#%olRhD[y=3Dt#Ov5BrHKuMB%!(Rf^Wep~HrJwkiQjKr|~FRg)Ku+D#'!t5~GrF~?rDdV)UY,Z/_7RkuG{<~BrBg,rlsO:235B@bX}|d?a1!#`(6Vyn5@d##Y+jTv|vV~EfIj]uNpn~FRfH7Lq2vb1!a9-978BaU@@=Iz9978BbU}#~AJq0!(@@=Iz8978BaU@@=Iz7~AJQ|}!978BbU}!JvkaK!AdUa21-U#`a+(g/vsRn~Ou!5RPj:rmu9WhOjXuvvNr}:RhAj^v(pyw8unRn[kPr}p|u7vwv]RiSBd;pppzq@qHQa?(b.!a.a`@.|xa(hFv;Wiyj5uuv-7Riw~Cw`fg2WlU978BbU|wOuNBJqG!(P~EfD~CRlQcZ#X,k)u3vWs@u2]ksg;wEx'f@q1_2Wg.j]uNpn~FRfqJv]!15x'h{qG!(@@=IzK~CRl^j6v(us5x4i,#T(2WmY?C2F{1>Kq<aj1!*jTqIsBv=Wld~Cw`fj2Wl[j`v0u*~>RlT=c>Z,k#u3vWs@u2]kq<c1Z+jTqIsBv=Wle~Cw`fn2Wl]dn1#c(a(b^a2!b/bAT(bj!aDa7bu,a_a{c0!2T0g:v>ReD2@G{42@G{5~DpM~<5rc=Bx6i>{RT#RnI@zCx]y]z:2Jv[!zr5Awyk]9]k]dD(Y+X#6Vz.g=wKtgwhaCwgmTWj2Lu,w%_+/[y-B;b^xeg3u3Rj-2@bX{*KrJ<!+'@Wg(g?QRlC@Jv`!%b[zIwsfII}8JQ_@w|kW|=Jv(%!AqcOuNBJvEzh!bYzjLs@wP#(0!oy@>RkdJwMZtc3Dtd@BcG#T'9bWxg2@2Fznd*#Y+;2x'c}w<zizixNgwa#Z'U+!/!a'!a+w~g~z6wcn{Rn}wcnzRn|5Rh%=]nJg5vuRmvNvdRlvcprJu}w*az*a#!%.a.'Bot9qT]kj@Wg'ay2Gzv@Jv`!%b[zEwsfHI}1;ck#Ux`<Cbbx_Lu+w!a&0*!wko*wwo,So,}6Juqxf!E}PigQuyRm`d3(`#8>Rn%:A5B;bZ~%KvhCa!a2!x>k7#Uxb@b{#xaRk7Jw0!)>wwhlShl}6>wwhmShm}6CJvB!.x'hhvj{!!5Bwkhhbaz}x'hivjz~!5Bwkhibaz|xEhTrNu,v-vpD!a%&/)a3a.,%Ro2t[CE{)@3re9b]{%wjo09:rgc:Z&Ro6=<riifuaw&RmoKrNA!%(Ro4>Ro89;Ri`dSaL'UYzxZb)7Rka3xRhT&!,!#^1U}vbaz{>>@=be}yC@:D5bazzKu+A&!}{?ba}y>>@=be}wxBh[t`u~vJvr!%a!a()a,a0a4RoC=]o;Ju(!%RoGRhdwjh`=]oAg>w#Ro?g5vuRo=NvdRl|Ku]C.!&;RoEJvB!%RoORoMBx'h[v+_?w~h`}~5?w~hd~!xKh]oiptu-utv.vp!#%&a30a@a'a+(a/aOp(o~p!RoDJu(!%RoHRhewjha=]oBNvdRl}g>w#Ro@g5vuRo>c[#X']o<CauRoRAd-#Y':RkpauRoQKu]C.!&;RoFJvB!%RoNRoPBx'h]v+_?w~ha}t5?w~he}ue!/UbhYacXaW^Tc&a;b:a-c/#b&aja1(!cL+!bKbt!bmcRc9aIc?8[yW3Dtt94Rg`Jv}!&SiRMzBhEebShEMNuPRe>x7gL#TzuwjirRipc<Z&>on;>z=h-MSh.Mwqczx'a7vj&!>Re4@=ResJt__NuPRi*NuPRi)j]uNr|~FRfzKrJ>_+@Wfy@Wf]2WocKrJ<!+'@Wg%g/QRl@@Jv`!&awRl<wsfFIzgLu(w*!.*&ShBMwvhIRhI9;RhNx1hK'!#Sn]Mx1hK~0!#:2<H~7cNu+w7D*'1ZtW>Rn1~?rOc:Z&Rn2=<rQ<7wjh&=BSnLMc]#X(6Vz)w[b=a!U#9wzgMc3#&(RgMRitRis<x,gKt`ax!&+SioM=BSilMc3#&(RgKRinRimKurB,!&SiQMzBhDebShDM6BJQ!(P~Efx978B2@@=I}WLrJw!!,a*&@G}O@9wkibRid@@x'fKwC!&SlDMSfLMjUv~Q~EfKKv3@a+!(hFv-]mpx/hYZ(C5RiWz<o/MwkhY?So/M@x,gbvfB*&!SgEM:SoeeehFu3:Rgbda(,^TZa)X/7Sg[eb:2RgI~BrMC@wgkc:wwkcRerx3h(uUvK!&*,SnOM4Sh*MArRg;wHRh(x=h;rJvPwI!a4',a'0@Wg&=BSh/Mg>w=Rh=g3w*wwgGRgGcW(X#;Sg}M2Gzk@Jv`!&awRl=wsfGIz`dKZ*T'Y-:RhR7RhQg5u-p`j6v(us5d,#Y+~Awkia?RicOuNBwkibba}Ld6p~tyu_vbAa'a+!a/'a3aEa8a!>Sh,ebJv{!&Sh@ebSaReb9;SgwebNuPRi(NvdRl)NuPRi'hHu^<Rm^Jvv_@Wl(g;u1Si/ebKu'B&!*Sh?eb@Wl'z@aPeb95Si.ebcpputyvjB)!,&a+0a%ShAMWeK@G}C@WfJ9;RhMwvhH9w{ia}ix,hJvRA1(!zAn[MRhHx1hJ~*!#hFv(BSn[MBJQ!(@@=I~'978B2@@=I}2db.Ua<'X}+T#a0XaG2G}E;wkg|wuh!Rh!x,hZu,@)!&So0MVy)C5RiXACJvB!&5RiY5RiZg8w)cG}*T#2@bU}=KsA>(!a.3wkhZba~(x,h^u(A!&(SoCMRhb5Bz=h[eb?w~hb~6x,h_u(A!&(SoDMRhc5Bz=h]eb?w~hc~6e)aA1T#T,^^^c-bMb&blcPaP(a/!0!bA=b5c@a(!bfbrc#2afwmhARnjwchORnp2Wlf3DtsNvdRl-2@wpa<]m0bx(#:awRk2@Jw3!%RfhwpfgRlnKQB%!(G{V@G|'NuuRl6d='T+Y#VyUg<v~Rl~==G|<Jv+'!aYShC}6@B<5?ba~8@Jw3'!g2QRljhLrpWlOd+#Y'g.w'rIg>w*wgj@g-u0Rj@Lu+wT&)ZtUauq]~GrGci&U#F|39:rELrNvj!.%*RhCwunfw~nf~:9;Ri]>wtnhg;wHRnhx3hDs@v~!/+'@Wfr@9RkSNu&Rlo=@<5GzoKs0@_+@Wl+@awRkmJuh!-3d(}pY#qWJvj!%Rm(:Jw3!%Rm,Rm*de&!1U-U#`)Re;@G|.@9Ri82@wjfvRlq=@<5GzpLvOvr!).&2RlF8Rf`C=x!eE{.Jw3_g2QRlkhLrpWlPde(!#U{s,UXa*Ta'[y'g:v>ReS;x0PZ&RnlRnn~HrKJw1}f!=x!eB|2w]aP(#Xa&a*Ta.Ua2a7=]iOd'#Y&Ro&WnWg;u.RiDg6vjRiBNvdRlzhNvj]nYJuW_2Wm3x)kFze{9d])!a.!,Y01!#&aC!a3RndC=ox~BrC@2b^{pg,rlse7x'ksuq!%Rm.E{xidw(wBRmGx9o+)X#wwo-So-}69:Rl4@xSf@a#XZ'X)X,Ta(/ARl8b[xc>RfY:RlI:RfQwlg.ARl:9;Rlwdn'#^XafaQa1X1TaHTa)@b[{zcZ#X'7RkwWg@Ou4ARn&x)kG#{,g7u/RkGdH'U#Y*Vz'Wm&CARm|bx#(A]gUbUzJj9Q~=d,#Y(56H}l978H{U7d,0#U*2>ABb_xZ978BbU{e~AJQ{g!978BbU{hxMh?ad{oUYZ.x1h?{l!#:2<H{mx3n[t{vl!,&a%3Ro(z=iS}6ARnr=Bwsn^wvn`Rnbd`*T}B0!#^X'BG{c9b]{a>>@=be}F?JvS!&BG{d7BG}(Bde#`a1X,Ya@!a'P~=wxf@2bZ}I56B2@@=aybb}08@55B9;5bb}<j3vLv;<Jw3&!>Rfg=ayb^}&OuNBKuLA!)a!P~=x#fD{f2@>==<bbzl?C972@@=Ix^d6rSu,v7w*C(0a)a6#B+a%!sQ[y?3Dt%3[xn~<5rLOu!5p@Ku+D#'!t7~GrP~?rNKvlaya7'!h+v-5qMg=t|cd,U#5AAaa5Abb{S@52B5@a[@52B5Gx[iXueu;d<#`a(!/549C;ag>23ExY5@Dah89b^~689Jv)!~2b[~1Lv'w(%*!a#bX|aPrmawRe]keu7uhv-q6rxu,q`xTo]/a5aU!bNaDXbi!b-!ao!b<bwA!#5@B932:aV2G|:d-)Y#hJrL>RhG<7@C5<H|_=Cau:5aj5@B932:bJ|ng>vIbs)#?C2F|9jPv0w.vISh-MKvUaz(.!9ABbb|[5;5<H|Eg>unwfh;9:4E|YjQsBt|vjx'hYq3!(?C2F|J:2<BaY?C2F|GOu!5x,g|p{ah!-(?C2F|c9:4E|OjXuvvNr}:Rh&i[w*t|cd+U#jJvsu)vsSn~Mkfrmu9p}u7vwv]So!McW#Xa!ax5@A5aY:5;5<H|>kJv~vYrquJu3x4ib#T)2@SmZM?C2F|Bj:rmu9@xPhI(a*a#U#`a3-5Abb|L~@:RhK9:4E|0@52B5G|#C::aY?C2F|-:2<BaY?C2F|.5Jvk!a)javYrquJu3x4ia#T)2@SmYM?C2F|HAxPhH(!a#U#`a*-5Abb|4~@:RhJ9:4E|R@52B5G|F:2<BaY?C2F|Sc^#Xa2j=Qq5CJvB!-g<v{z;hhM?C2F|Zi[vrv{z;hiM?C2F|XKsA>!a)-g<v{z;h[eb?C2F|]i[vrv{z;h]eb?C2F|^iZu.vix,hZq3ah!.(?C2F|QOu!5ShXM:2<BaY?C2F|P", 13494, 2713, 49, 25, 61);


// Generated using scripts/write-decode-map.ts
/** Packed XML decode trie data. */ const $28adead722c34a77$export$298b118b5a906d9f = /* #__PURE__ */ new Uint16Array([
    512,
    26465,
    29036,
    7,
    0,
    2,
    4,
    116,
    24638,
    116,
    24636,
    8693,
    29807,
    24610,
    621,
    1,
    0,
    0,
    3,
    112,
    24614,
    111,
    115,
    24615
]);


/**
 * Bit flags & masks for the binary trie encoding used for entity decoding.
 *
 * The trie is a flat `Uint16Array`. Every node starts with one header word:
 *
 *   15..14 VALUE_LENGTH   Number of words the value occupies, +1.
 *                         0 = no value; 1 = value inline in bits 12..0;
 *                         2/3 = value in the 1/2 words after the header.
 *   13     FLAG13         If VALUE_LENGTH > 0: semicolon required ("strict"
 *                         entity; `;` is never stored as a branch).
 *                         If VALUE_LENGTH == 0: this node is a compact run.
 *   12..7  BRANCH_LENGTH  Number of branches (or run length for runs).
 *   6..0   JUMP_TABLE     Jump-table offset / single-branch char / first
 *                         run char (see below).
 *
 * Branch data follows the header and any value words. Its shape is selected
 * by (JUMP_TABLE, BRANCH_LENGTH) in the header:
 *
 *   Single branch  JUMP_TABLE = the only child's char, BRANCH_LENGTH = 0.
 *                  No branch words; the child node follows immediately.
 *   Jump table     JUMP_TABLE = first covered char (> 0), BRANCH_LENGTH =
 *                  table length. One word per covered char: 0 = no branch,
 *                  otherwise the child's offset from the END of the table,
 *                  +1 (so 0 stays the no-branch sentinel).
 *   Dictionary     JUMP_TABLE = 0, BRANCH_LENGTH = number of branches.
 *                  ceil(n/2) words of sorted keys packed two per word
 *                  (low byte first), then n pointer words storing the
 *                  child's offset from the END of the branch data.
 *   Compact run    VALUE_LENGTH = 0, FLAG13 set. BRANCH_LENGTH = run
 *                  length (3..63), JUMP_TABLE = first char; remaining run
 *                  chars packed two per word after the header. The target
 *                  node follows the packed words immediately.
 *
 * Pointers are end-relative (rather than relative to the pointer's own
 * position) because that makes the common "child encoded right after the
 * branch data" case a small constant, which compresses far better. Offsets
 * to already-encoded (shared) nodes wrap via uint16 modulo arithmetic; the
 * decoder masks navigation results with `& 0xff_ff` to match.
 */ var $accd6522a02453e7$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["FLAG13"] = 8192] = "FLAG13";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 8064] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
    /** Bits 12..0: the inline value of a VALUE_LENGTH = 1 header word. */ BinTrieFlags[BinTrieFlags["VALUE_MASK"] = 8191] = "VALUE_MASK";
})($accd6522a02453e7$export$6a4325c613e0faec || ($accd6522a02453e7$export$6a4325c613e0faec = {}));


var $d7032f3974c45172$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["AMP"] = 38] = "AMP";
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
})($d7032f3974c45172$var$CharCodes || ($d7032f3974c45172$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $d7032f3974c45172$var$TO_LOWER_BIT = 32;
/*
 * `parseNumericEntity` packs its two results into one 32-bit integer:
 * `(consumed << CONSUMED_SHIFT) | codePoint`. The 21-bit code point field
 * fits any valid Unicode value (max 0x10FFFF, clamped before packing); the
 * consumed count excludes `&` and gets the remaining 11 bits. Extract it
 * with `>>>` so the topmost bit isn't treated as a sign.
 *
 * Plain consts rather than a `const enum`: with `isolatedModules`, enum
 * member reads compile to runtime property loads.
 */ const $d7032f3974c45172$var$CONSUMED_SHIFT = 21;
const $d7032f3974c45172$var$CODE_POINT_MASK = 0x1fffff;
/**
 * Reserved consumed field for counts of at least 2047 characters after `&`.
 * The true count is in `longNumericConsumed`.
 */ const $d7032f3974c45172$var$CONSUMED_OVERFLOW = 0x7ff;
/**
 * Side channel for numeric entities of at least 2048 characters including
 * `&`. Set by `parseNumericEntity` when its consumed count reaches the
 * reserved value `CONSUMED_OVERFLOW`; callers read the true count from here.
 * A module-level slot avoids a tuple allocation on the hot path.
 */ let $d7032f3974c45172$var$longNumericConsumed = 0;
/**
 * Extract the consumed count from a `parseNumericEntity` packed result,
 * recovering the true length from `longNumericConsumed` when the packed
 * field contains the sentinel. Read it before the next `parseNumericEntity`
 * call, which may overwrite the side channel. This helper owns that protocol.
 * @param packed Packed result of `parseNumericEntity`.
 */ function $d7032f3974c45172$var$unpackConsumed(packed) {
    const consumed = packed >>> $d7032f3974c45172$var$CONSUMED_SHIFT;
    return consumed === $d7032f3974c45172$var$CONSUMED_OVERFLOW ? $d7032f3974c45172$var$longNumericConsumed : consumed;
}
/**
 * Unsigned subtraction trick: (code - lo) >>> 0 wraps negatives to large
 * values, so a single `<=` covers the entire [lo..hi] range check.
 * @param code Code point to check.
 */ function $d7032f3974c45172$var$isNumber(code) {
    return code - $d7032f3974c45172$var$CharCodes.ZERO >>> 0 <= 9;
}
function $d7032f3974c45172$var$isHexadecimalCharacter(code) {
    return (code | $d7032f3974c45172$var$TO_LOWER_BIT) - $d7032f3974c45172$var$CharCodes.LOWER_A >>> 0 <= 5; // F - a
}
function $d7032f3974c45172$var$isAlpha(code) {
    return (code | $d7032f3974c45172$var$TO_LOWER_BIT) - $d7032f3974c45172$var$CharCodes.LOWER_A >>> 0 <= 25; // Z - a
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 * @param code Code point to check.
 */ function $d7032f3974c45172$var$isEntityInAttributeInvalidEnd(code) {
    return code === $d7032f3974c45172$var$CharCodes.EQUALS || $d7032f3974c45172$var$isAlpha(code) || $d7032f3974c45172$var$isNumber(code);
}
var $d7032f3974c45172$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($d7032f3974c45172$var$EntityDecoderState || ($d7032f3974c45172$var$EntityDecoderState = {}));
var $d7032f3974c45172$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($d7032f3974c45172$export$8c8f129ce60f53c || ($d7032f3974c45172$export$8c8f129ce60f53c = {}));
class $d7032f3974c45172$export$15263a93ff7ec8ba {
    decodeTree;
    emitCodePoint;
    errors;
    /** The current state of the decoder. */ state = $d7032f3974c45172$var$EntityDecoderState.EntityStart;
    /** Characters that were consumed while parsing an entity. */ consumed = 1;
    /**
     * The result of the entity.
     *
     * For named entities: the trie index of the best legacy match so far
     * (0 = none). For numeric entities: the accumulated code point.
     */ result = 0;
    /** The current index in the decode tree. */ treeIndex = 0;
    /**
     * Characters consumed since the last recorded legacy match, plus one.
     * Invariant at the top of the `stateNamedEntity` loop: `excess` equals
     * the number of unrecorded consumed characters + 1.
     */ // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive (read via destructuring)
    excess = 1;
    /** The mode in which the decoder is operating. */ decodeMode = $d7032f3974c45172$export$8c8f129ce60f53c.Strict;
    /** The number of characters that have been consumed in the current run. */ // biome-ignore lint/correctness/noUnusedPrivateClassMembers: False positive
    runConsumed = 0;
    constructor(/** The predefined HTML or XML decode tree. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For named entities that decode to multiple code points, this will
     * be called multiple times, with the second codepoint, and the same
     * `consumed` value.
     * @param codepoint The decoded codepoint.
     * @param consumed The number of characters consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
    }
    /**
     * Resets the instance to make it reusable.
     * @param decodeMode Entity decoding mode to use.
     */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $d7032f3974c45172$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
        this.runConsumed = 0;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the non-streaming `decodeWithTrie`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $d7032f3974c45172$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $d7032f3974c45172$var$CharCodes.NUM) {
                    this.state = $d7032f3974c45172$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $d7032f3974c45172$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $d7032f3974c45172$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $d7032f3974c45172$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $d7032f3974c45172$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            default:
                // NamedEntity — the only remaining state.
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ // eslint-disable-next-line unicorn/consistent-class-member-order
    stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $d7032f3974c45172$var$TO_LOWER_BIT) === $d7032f3974c45172$var$CharCodes.LOWER_X) {
            this.state = $d7032f3974c45172$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $d7032f3974c45172$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML
     * spec. Digit parsing matches the hex loop in `parseNumericEntity`.
     * The accumulated value is preserved for numeric validation callbacks.
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const inputLength = input.length;
        // Local accumulators; flushed before any exit (see stateNamedEntity).
        let { result: result } = this;
        let { consumed: consumed } = this;
        while(offset < inputLength){
            const char = input.charCodeAt(offset);
            if ($d7032f3974c45172$var$isNumber(char) || $d7032f3974c45172$var$isHexadecimalCharacter(char)) {
                // Convert hex digit to value (0-15); 'a'/'A' -> 10.
                const digit = char <= $d7032f3974c45172$var$CharCodes.NINE ? char - $d7032f3974c45172$var$CharCodes.ZERO : (char | $d7032f3974c45172$var$TO_LOWER_BIT) - $d7032f3974c45172$var$CharCodes.LOWER_A + 10;
                result = result * 16 + digit;
                consumed += 1;
                offset += 1;
            } else {
                this.result = result;
                this.consumed = consumed;
                return this.emitNumericEntity(char, 3);
            }
        }
        this.result = result;
        this.consumed = consumed;
        return -1; // Incomplete entity
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML
     * spec. Digit parsing matches the decimal loop in `parseNumericEntity`.
     * The accumulated value is preserved for numeric validation callbacks.
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const inputLength = input.length;
        // Local accumulators; flushed before any exit (see stateNamedEntity).
        let { result: result } = this;
        let { consumed: consumed } = this;
        while(offset < inputLength){
            const digit = input.charCodeAt(offset) - $d7032f3974c45172$var$CharCodes.ZERO;
            if (digit >>> 0 > 9) {
                this.result = result;
                this.consumed = consumed;
                return this.emitNumericEntity(digit + $d7032f3974c45172$var$CharCodes.ZERO, 2);
            }
            result = result * 10 + digit;
            consumed += 1;
            offset += 1;
        }
        this.result = result;
        this.consumed = consumed;
        return -1; // Incomplete entity
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            this.errors?.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $d7032f3974c45172$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $d7032f3974c45172$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((this.decodeTree === (0, $28adead722c34a77$export$298b118b5a906d9f) ? (0, $9fd64e2a597499ae$export$87faf5ae118ef8c5) : (0, $9fd64e2a597499ae$export$b978ab756102108a))(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $d7032f3974c45172$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Flush locally-tracked walk state back to the fields, then emit the
     * recorded legacy match or reject (cold path — at most once per
     * entity). Called after failed navigation (leaf node, branch miss, or
     * compact-run mismatch). In attribute mode, reject if no legacy was
     * recorded at the current node, if we descended past it, or if the
     * pending input character is an invalid attribute terminator.
     * @param consumed Locally-tracked consumed count.
     * @param excess Locally-tracked excess count.
     * @param char Pending input character (may be the mismatching char).
     * @param valueLength Value length at the current trie node.
     */ flushAndEmitLegacyOrReject(consumed, excess, char, valueLength) {
        this.consumed = consumed;
        this.excess = excess;
        return this.result === 0 || this.decodeMode === $d7032f3974c45172$export$8c8f129ce60f53c.Attribute && (valueLength === 0 || excess > 1 || $d7032f3974c45172$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        const inputLength = input.length;
        const isStrict = this.decodeMode === $d7032f3974c45172$export$8c8f129ce60f53c.Strict;
        /*
         * Local copies of the resumable walk state avoid per-character
         * field writes. They are flushed back to the fields
         * on every exit (chunk end, and before any emit helper that reads
         * them). `this.result` is only written at the (rare) record points,
         * so it stays a direct field write.
         *
         * Legacy-match recording happens in two idempotent places: at the
         * loop top when sitting on a value node, and in the chunk-end
         * epilogue (so `end()` sees matches that land exactly on a chunk
         * boundary). Recording applies `consumed += excess - 1; excess = 1`,
         * which is a no-op when repeated — the loop-top invariant is
         * `excess` = unrecorded consumed characters + 1.
         */ let { treeIndex: treeIndex } = this;
        let { excess: excess } = this;
        let { consumed: consumed } = this;
        let current = decodeTree[treeIndex];
        while(offset < inputLength){
            /*
             * Descend through value-less jump-table nodes (including the
             * single-branch encoding) inline, mirroring `decodeWithTrie`:
             * this avoids a `determineBranch` call per level for the
             * dominant node shape — including the root on the first write.
             */ while((current & ((0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_LENGTH | (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13)) === 0 && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE) !== 0){
                const char = input.charCodeAt(offset);
                const jumpOffset = current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE;
                const branchCount = (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7;
                if (branchCount === 0) {
                    // Single branch encoded inline in the jump offset bits.
                    if (char !== jumpOffset) return this.flushAndEmitLegacyOrReject(consumed, excess, char, 0);
                    treeIndex += 1;
                } else {
                    const slot = char - jumpOffset;
                    if (slot >>> 0 >= branchCount) return this.flushAndEmitLegacyOrReject(consumed, excess, char, 0);
                    const stored = decodeTree[treeIndex + 1 + slot];
                    if (stored === 0) return this.flushAndEmitLegacyOrReject(consumed, excess, char, 0);
                    // End-relative: branch data ends at treeIndex+1+branchCount.
                    treeIndex = treeIndex + branchCount + stored & 0xffff;
                }
                current = decodeTree[treeIndex];
                offset += 1;
                excess += 1;
                /*
                 * `charCodeAt` past the end returns NaN, which would alias
                 * to slot 0 after `>>> 0` — bail out explicitly.
                 */ // eslint-disable-next-line unicorn/no-break-in-nested-loop
                if (offset >= inputLength) break;
            }
            if (offset >= inputLength) break;
            // Handle compact runs (resumable across chunks).
            if ((current & ((0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_LENGTH | (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13)) === (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) {
                const runLength = (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7; /* 3..63 */ 
                let { runConsumed: runConsumed } = this;
                // If we are starting a run, check the first char.
                if (runConsumed === 0) {
                    const char = input.charCodeAt(offset);
                    if (char !== (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE)) return this.flushAndEmitLegacyOrReject(consumed, excess, char, 0);
                    offset += 1;
                    excess += 1;
                    runConsumed = 1;
                }
                // Check remaining characters in the run (packed two per uint16 word).
                while(runConsumed < runLength){
                    if (offset >= inputLength) {
                        this.treeIndex = treeIndex;
                        this.excess = excess;
                        this.consumed = consumed;
                        this.runConsumed = runConsumed;
                        return -1;
                    }
                    const charIndexInPacked = runConsumed - 1;
                    const packedWord = decodeTree[treeIndex + 1 + (charIndexInPacked >> 1)];
                    const expectedChar = packedWord >> ((charIndexInPacked & 1) << 3) & 0xff;
                    const char = input.charCodeAt(offset);
                    if (char !== expectedChar) {
                        this.runConsumed = 0;
                        return this.flushAndEmitLegacyOrReject(consumed, excess, char, 0);
                    }
                    offset += 1;
                    excess += 1;
                    runConsumed += 1;
                }
                this.runConsumed = 0;
                treeIndex += 1 + (runLength >> 1);
                current = decodeTree[treeIndex];
                continue;
            }
            // Header plus out-of-line value words; 0 means no value.
            const valueLength = current >>> 14;
            const char = input.charCodeAt(offset);
            if (valueLength !== 0) {
                // Record a legacy match (FLAG13 clear = semicolon optional).
                if (!isStrict && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) === 0) {
                    this.result = treeIndex;
                    consumed += excess - 1;
                    excess = 1;
                }
                /*
                 * Implicit semicolon handling: emit immediately. Covers both
                 * strict (FLAG13 set) and legacy entities — neither stores
                 * an explicit `;` branch in the trie.
                 */ if (char === $d7032f3974c45172$var$CharCodes.SEMI) return this.emitNamedEntityData(treeIndex, valueLength, consumed + excess);
                /*
                 * `valueLength === 1` packs the codepoint into the header
                 * word's low 13 bits, where branch metadata also lives. Skip
                 * the branch lookup on leaves so those value bits aren't
                 * reinterpreted as branch offsets.
                 */ if (valueLength === 1) return this.flushAndEmitLegacyOrReject(consumed, excess, char, valueLength);
            }
            // Value-bearing or dictionary node: dispatch through determineBranch.
            const next = $d7032f3974c45172$export$44c08d99945e6276(decodeTree, current, treeIndex + (valueLength || 1), char);
            if (next < 0) return this.flushAndEmitLegacyOrReject(consumed, excess, char, valueLength);
            treeIndex = next;
            current = decodeTree[treeIndex];
            offset += 1;
            excess += 1;
        }
        /*
         * Chunk exhausted. Record a legacy match we may be sitting on, so a
         * subsequent `end()` emits it, then persist the walk state.
         */ if (!isStrict && current >>> 14 !== 0 && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) === 0) {
            this.result = treeIndex;
            consumed += excess - 1;
            excess = 1;
        }
        this.treeIndex = treeIndex;
        this.excess = excess;
        this.consumed = consumed;
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = decodeTree[result] >>> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        this.errors?.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     * @param result The index of the entity in the decode tree.
     * @param valueLength Encoded value length (header plus any value words).
     * @param consumed The number of characters consumed.
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & (0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_MASK : decodeTree[result + 1], consumed);
        if (valueLength === 3) // Emit the second UTF-16 code unit.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     * @returns The number of characters consumed.
     */ end() {
        switch(this.state){
            case $d7032f3974c45172$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $d7032f3974c45172$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $d7032f3974c45172$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $d7032f3974c45172$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $d7032f3974c45172$var$EntityDecoderState.NumericStart:
                this.errors?.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            default:
                // EntityStart or unknown — return 0.
                return 0;
        }
    }
}
function $d7032f3974c45172$export$44c08d99945e6276(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7;
    const jumpOffset = current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE;
    // Case 1: Single branch or jump table (jumpOffset encodes the first/only char code).
    if (jumpOffset) {
        if (branchCount === 0) // Single branch encoded inline in the jump offset bits.
        return char === jumpOffset ? nodeIndex : -1;
        /*
         * Jump table: branchCount consecutive slots starting at jumpOffset.
         * Unsigned comparison handles both < 0 and >= branchCount in one check.
         */ const slot = char - jumpOffset;
        if (slot >>> 0 >= branchCount) return -1;
        const stored = decodeTree[nodeIndex + slot];
        /*
         * 0 = empty slot (no branch); otherwise the child's offset from the
         * end of the branch array, +1 (end-relative pointers compress
         * better). `& 0xff_ff` mirrors the encoder's uint16 wrap for
         * backreferences to already-encoded nodes.
         */ return stored === 0 ? -1 : nodeIndex + branchCount + stored - 1 & 0xffff;
    }
    /*
     * Case 2: Packed dictionary. Linear scan — over 90% of dict nodes have
     * <= 4 branches in the HTML trie, where the constant-factor savings
     * dominate over binary search's asymptotic edge.
     */ if (branchCount === 0) return -1;
    const packedKeySlots = branchCount + 1 >> 1;
    const branchEnd = nodeIndex + packedKeySlots + branchCount;
    for(let index = 0; index < branchCount; index++){
        const packed = decodeTree[nodeIndex + (index >> 1)];
        const key = packed >> ((index & 1) << 3) & 0xff;
        if (key === char) {
            const pointerIndex = nodeIndex + packedKeySlots + index;
            // Pointers are relative to the end of the branch data.
            return branchEnd + decodeTree[pointerIndex] & 0xffff;
        }
        // Keys are sorted; if we've passed `char`, no match is possible.
        if (key > char) return -1;
    }
    return -1;
}
/**
 * Read the decoded value from a trie node.
 * @param decodeTree The trie.
 * @param nodeIndex The index of the node.
 * @param valueLength The length of the value (1, 2, or 3).
 * @returns The decoded string.
 */ function $d7032f3974c45172$var$readTrieValue(decodeTree, nodeIndex, valueLength) {
    if (valueLength === 1) return String.fromCharCode(decodeTree[nodeIndex] & (0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_MASK);
    if (valueLength === 2) return String.fromCharCode(decodeTree[nodeIndex + 1]);
    return String.fromCharCode(decodeTree[nodeIndex + 1], decodeTree[nodeIndex + 2]);
}
/**
 * Parse a numeric entity (`&#DDD;` or `&#xHHH;`).
 *
 * Encodes the result as `(consumed << CONSUMED_SHIFT) | codepoint` (see
 * the packing comment at the top of the file; overlong entities spill
 * their length into `longNumericConsumed`). Returns 0 when no digits were
 * found.
 *
 * This is the sync counterpart of the streaming
 * `EntityDecoder#stateNumericDecimal` / `#stateNumericHex`. Digit parsing
 * matches those methods; only this packed result needs a value clamp.
 * @param input       The input string.
 * @param numberStart Index of the `#` character.
 * @param inputLength Cached `input.length`.
 */ function $d7032f3974c45172$var$parseNumericEntity(input, numberStart, inputLength) {
    let offset = numberStart + 1; // Skip "#"
    let cp = 0;
    let digitStart = offset;
    /*
     * Separate decimal and hexadecimal loops: each multiplies by a constant
     * and runs a single digit test, instead of a per-character base check.
     */ if (offset < inputLength && (input.charCodeAt(offset) | $d7032f3974c45172$var$TO_LOWER_BIT) === $d7032f3974c45172$var$CharCodes.LOWER_X) {
        offset += 1;
        digitStart = offset;
        while(offset < inputLength){
            const char = input.charCodeAt(offset);
            if ($d7032f3974c45172$var$isNumber(char)) cp = cp * 16 + (char - $d7032f3974c45172$var$CharCodes.ZERO);
            else if ($d7032f3974c45172$var$isHexadecimalCharacter(char)) cp = cp * 16 + ((char | $d7032f3974c45172$var$TO_LOWER_BIT) - $d7032f3974c45172$var$CharCodes.LOWER_A + 10);
            else break;
            offset += 1;
        }
    } else while(offset < inputLength){
        const digit = input.charCodeAt(offset) - $d7032f3974c45172$var$CharCodes.ZERO;
        if (digit >>> 0 > 9) break;
        cp = cp * 10 + digit;
        offset += 1;
    }
    if (offset === digitStart) return 0;
    // Include the semicolon in consumed when present.
    if (offset < inputLength && input.charCodeAt(offset) === $d7032f3974c45172$var$CharCodes.SEMI) offset += 1;
    /*
     * Clamp out-of-range values to 0x110000 so they fit the 21-bit field
     * and decode to U+FFFD. Lengths at or above CONSUMED_OVERFLOW use the
     * side channel described with the packing constants.
     */ if (cp > 0x10ffff) cp = 0x110000;
    let consumed = offset - numberStart;
    if (consumed >= $d7032f3974c45172$var$CONSUMED_OVERFLOW) {
        // eslint-disable-next-line unicorn/no-top-level-assignment-in-function -- deliberate side channel, see `longNumericConsumed`
        $d7032f3974c45172$var$longNumericConsumed = consumed;
        consumed = $d7032f3974c45172$var$CONSUMED_OVERFLOW;
    }
    return consumed << $d7032f3974c45172$var$CONSUMED_SHIFT | cp;
}
/**
 * Decode all entities in `input` using the HTML trie.
 *
 * Hard-wired to `htmlDecodeTree`: the inline root navigation below assumes
 * the HTML root's jump-table shape, so this must not be generalized to
 * other tries (the XML trie's dictionary root would silently match no
 * entities — `decodeXML` has its own hand-coded fast path instead).
 * @param input      The string to decode.
 * @param isStrict Only match semicolon-terminated entities.
 * @param isAttribute Whether to apply attribute-specific parsing rules (disallowing certain non-semicolon terminators).
 * @returns The decoded string.
 */ function $d7032f3974c45172$var$decodeWithTrie(input, isStrict, isAttribute) {
    const decodeTree = (0, $cc62f38eaffeb4b6$export$b6a4accd5ee85f69);
    // Fast path: no entities at all — return input without any allocation.
    let offset = input.indexOf("&");
    if (offset < 0) return input;
    const inputLength = input.length;
    /*
     * `chunkStart` marks the start of the next pending slice. Rejected
     * entities don't advance it, so consecutive rejections are stitched
     * into a single `slice` once a real match (or end of input) is hit.
     */ let chunkStart = 0;
    let result = "";
    /*
     * Root navigation fields, hoisted out of the per-entity loop. The HTML
     * root is a multi-branch jump-table covering [A-Za-z]; see the inline
     * first-iteration comment below.
     */ const root = decodeTree[0];
    const rootJumpOffset = root & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE;
    const rootBranchCount = (root & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7;
    do {
        const entityStart = offset + 1;
        // Quick check: entity names must start with [A-Za-z], numeric with #.
        const firstChar = input.charCodeAt(entityStart);
        let consumed;
        let value;
        if (firstChar === $d7032f3974c45172$var$CharCodes.NUM) {
            const packed = $d7032f3974c45172$var$parseNumericEntity(input, entityStart, inputLength);
            consumed = $d7032f3974c45172$var$unpackConsumed(packed);
            // In strict mode, require semicolon termination.
            if (isStrict && consumed > 0 && input.charCodeAt(entityStart + consumed - 1) !== $d7032f3974c45172$var$CharCodes.SEMI) consumed = 0;
            value = consumed === 0 ? "" : (0, $9fd64e2a597499ae$export$8967df39235cf1b1)(packed & $d7032f3974c45172$var$CODE_POINT_MASK);
        } else if ($d7032f3974c45172$var$isAlpha(firstChar)) {
            consumed = 0;
            value = "";
            /*
             * The generator guarantees a jump-table root. Consume the first
             * character directly, then walk from its child.
             */ const rootSlotIndex = firstChar - rootJumpOffset;
            let nodeIndex;
            if (rootSlotIndex >>> 0 < rootBranchCount) {
                const stored = decodeTree[1 + rootSlotIndex];
                nodeIndex = stored === 0 ? -1 : rootBranchCount + stored & 0xffff;
            } else nodeIndex = -1;
            /*
             * Best legacy (no-semicolon) match so far, as trie coordinates.
             * Deferring `readTrieValue` to the end avoids allocating a
             * string for matches that longer matches supersede.
             */ let bestNodeIndex = 0;
            let bestValueLength = 0;
            let current = nodeIndex < 0 ? 0 : decodeTree[nodeIndex];
            let index = entityStart + 1;
            /*
             * Walk the trie from the root child. The `trie` label lets the
             * inner descent and compact-run loops abandon the entity (and
             * fall through to the legacy/reject handling) directly.
             */ trie: while(index < inputLength){
                /*
                 * Inline value-less jump tables and single branches. A miss
                 * falls through to the recorded legacy match or rejection.
                 */ while(// Value-less, non-run node with a nonzero jump offset.
                (current & ((0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_LENGTH | (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13)) === 0 && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE) !== 0){
                    const jumpOffset = current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE;
                    const branchCount = (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7;
                    if (branchCount === 0) {
                        // Single branch encoded inline in the jump offset bits.
                        if (input.charCodeAt(index) !== jumpOffset) break trie;
                        nodeIndex += 1;
                    } else {
                        const slot = input.charCodeAt(index) - jumpOffset;
                        if (slot >>> 0 >= branchCount) break trie;
                        const stored = decodeTree[nodeIndex + 1 + slot];
                        if (stored === 0) break trie;
                        // End-relative: branch data ends at nodeIndex+1+branchCount.
                        nodeIndex = nodeIndex + branchCount + stored & 0xffff;
                    }
                    current = decodeTree[nodeIndex];
                    index += 1;
                    /*
                     * `charCodeAt` past the end returns NaN, which would
                     * alias to slot 0 after `>>> 0` — bail out explicitly.
                     */ if (index >= inputLength) break trie;
                }
                // FLAG13 without a value marks a compact run.
                if ((current & ((0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_LENGTH | (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13)) === (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) {
                    const runLength = (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).BRANCH_LENGTH) >> 7;
                    // Check first char (stored in JUMP_TABLE bits).
                    if (input.charCodeAt(index) !== (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).JUMP_TABLE)) break;
                    index += 1;
                    // Check remaining characters (packed two per uint16 word).
                    const remaining = runLength - 1;
                    let wordIndex = nodeIndex + 1;
                    let charIndexInPacked = 0;
                    /*
                     * Process pairs: read one packed word, compare low byte then high byte.
                     * No explicit bounds check needed — charCodeAt returns NaN for OOB,
                     * which never equals an integer, so the mismatch break fires naturally.
                     */ for(; charIndexInPacked + 1 < remaining; charIndexInPacked += 2){
                        const packed = decodeTree[wordIndex];
                        if (input.charCodeAt(index) !== (packed & 0xff)) break trie;
                        index += 1;
                        if (input.charCodeAt(index) !== (packed >> 8 & 0xff)) break trie;
                        index += 1;
                        wordIndex += 1;
                    }
                    // Handle odd trailing char.
                    if (charIndexInPacked < remaining) {
                        if (input.charCodeAt(index) !== (decodeTree[wordIndex] & 0xff)) break;
                        index += 1;
                    }
                    nodeIndex += 1 + (runLength >> 1);
                    current = decodeTree[nodeIndex];
                    continue;
                }
                // Header plus out-of-line value words; 0 means no value.
                const valueLength = current >>> 14;
                const char = input.charCodeAt(index);
                /*
                 * Check current node for a value before navigating.
                 * This handles both: (a) values reached via compact runs on the
                 * previous iteration, and (b) values at regular branch targets.
                 */ if (valueLength !== 0) {
                    // If char is `;`, emit immediately.
                    if (char === $d7032f3974c45172$var$CharCodes.SEMI) {
                        consumed = index - entityStart + 1;
                        // Inline leaves carry the value in the low 13 bits.
                        value = valueLength === 1 ? String.fromCharCode(current & (0, $accd6522a02453e7$export$6a4325c613e0faec).VALUE_MASK) : $d7032f3974c45172$var$readTrieValue(decodeTree, nodeIndex, valueLength);
                        break;
                    }
                    // Record non-terminated (legacy) match (FLAG13 clear = semicolon optional).
                    if (!isStrict && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) === 0) {
                        consumed = index - entityStart;
                        bestNodeIndex = nodeIndex;
                        bestValueLength = valueLength;
                    }
                    /*
                     * A valueLength of 1 means the value is packed inline in the header
                     * word — these are always leaf nodes with no branches, so we can
                     * stop walking the trie.
                     */ // eslint-disable-next-line unicorn/no-break-in-nested-loop
                    if (valueLength === 1) break;
                }
                // Navigate to the next node (valueLength || 1: skip past value words, minimum 1 for header).
                const next = $d7032f3974c45172$export$44c08d99945e6276(decodeTree, current, nodeIndex + (valueLength || 1), char);
                // eslint-disable-next-line unicorn/no-break-in-nested-loop
                if (next < 0) break;
                nodeIndex = next;
                current = decodeTree[nodeIndex];
                index += 1;
            }
            /*
             * Post-loop: if the semicolon path didn't set value,
             * check for a final legacy match. The last navigation may
             * have landed on a legacy node whose value hasn't been
             * recorded yet (loop exited before the top-of-loop check
             * could run).
             */ if (value === "") {
                const finalVL = current >>> 14;
                if (finalVL !== 0 && !isStrict && (current & (0, $accd6522a02453e7$export$6a4325c613e0faec).FLAG13) === 0) {
                    consumed = index - entityStart;
                    bestNodeIndex = nodeIndex;
                    bestValueLength = finalVL;
                }
                if (consumed > 0) value = $d7032f3974c45172$var$readTrieValue(decodeTree, bestNodeIndex, bestValueLength);
            }
        } else {
            consumed = 0;
            value = "";
        }
        /*
         * The attribute end-char rule (HTML spec §13.2.5.73) only applies to
         * unterminated *named* references.  Semicolon-terminated entities and
         * numeric entities are always accepted, matching EntityDecoder behavior.
         *
         * When `attribute` is false (the common case), short-circuit skips all
         * the unterminated-named checks entirely.
         */ if (consumed === 0 || isAttribute && firstChar !== $d7032f3974c45172$var$CharCodes.NUM && input.charCodeAt(entityStart + consumed - 1) !== $d7032f3974c45172$var$CharCodes.SEMI && entityStart + consumed < inputLength && $d7032f3974c45172$var$isEntityInAttributeInvalidEnd(input.charCodeAt(entityStart + consumed))) // Rejected: leave `&` in the pending chunk, scan past it.
        offset = entityStart;
        else {
            if (chunkStart < offset) result += input.slice(chunkStart, offset);
            result += value;
            offset = chunkStart = entityStart + consumed;
        }
        /*
         * Adjacent entities (`&x;&y;`) are common in entity-dense input;
         * checking the single character at `offset` first skips the
         * `indexOf` call (and its per-call overhead) for that case.
         */ if (input.charCodeAt(offset) !== $d7032f3974c45172$var$CharCodes.AMP) offset = input.indexOf("&", offset);
    }while (offset >= 0);
    return result + input.slice(chunkStart);
}
function $d7032f3974c45172$export$f045cb747ce77a19(htmlString, mode = $d7032f3974c45172$export$8c8f129ce60f53c.Legacy) {
    return $d7032f3974c45172$var$decodeWithTrie(htmlString, mode === $d7032f3974c45172$export$8c8f129ce60f53c.Strict, mode === $d7032f3974c45172$export$8c8f129ce60f53c.Attribute);
}
function $d7032f3974c45172$export$49f5e8089adb006a(htmlAttribute) {
    return $d7032f3974c45172$var$decodeWithTrie(htmlAttribute, false, true);
}
function $d7032f3974c45172$export$da52f4371b3f37de(htmlString) {
    return $d7032f3974c45172$var$decodeWithTrie(htmlString, true, false);
}
function $d7032f3974c45172$export$88e3b9643a8bd06e(xmlString) {
    let offset = xmlString.indexOf("&");
    if (offset < 0) return xmlString;
    let lastIndex = 0;
    let result = "";
    do {
        const start = offset + 1;
        let consumed = 0;
        let value = "";
        const c1 = xmlString.charCodeAt(start);
        if (c1 === $d7032f3974c45172$var$CharCodes.NUM) {
            const packed = $d7032f3974c45172$var$parseNumericEntity(xmlString, start, xmlString.length);
            consumed = $d7032f3974c45172$var$unpackConsumed(packed);
            // XML is always strict — require semicolon.
            if (consumed === 0 || xmlString.charCodeAt(start + consumed - 1) !== $d7032f3974c45172$var$CharCodes.SEMI) consumed = 0;
            else {
                const codePoint = packed & $d7032f3974c45172$var$CODE_POINT_MASK;
                // Nonzero BMP values below the surrogate range need no replacement.
                value = codePoint - 1 >>> 0 < 0xd7ff ? String.fromCharCode(codePoint) : String.fromCodePoint((0, $9fd64e2a597499ae$export$87faf5ae118ef8c5)(codePoint));
            }
        } else /* eslint-disable unicorn/no-break-in-nested-loop -- Keep XML name dispatch inline with the decode loop. */ switch(c1){
            // &lt; / &gt;
            case 0x6c:
            case 0x67:
                if (xmlString.charCodeAt(start + 1) === 0x74 && xmlString.charCodeAt(start + 2) === $d7032f3974c45172$var$CharCodes.SEMI) {
                    consumed = 3;
                    value = c1 === 0x6c ? "<" : ">";
                }
                break;
            // &amp; / &apos;
            case 0x61:
                {
                    const c2 = xmlString.charCodeAt(start + 1);
                    if (c2 === 0x6d && xmlString.charCodeAt(start + 2) === 0x70 && xmlString.charCodeAt(start + 3) === $d7032f3974c45172$var$CharCodes.SEMI) {
                        consumed = 4;
                        value = "&";
                    } else if (c2 === 0x70 && xmlString.charCodeAt(start + 2) === 0x6f && xmlString.charCodeAt(start + 3) === 0x73 && xmlString.charCodeAt(start + 4) === $d7032f3974c45172$var$CharCodes.SEMI) {
                        consumed = 5;
                        value = "'";
                    }
                    break;
                }
            // &quot;
            case 0x71:
                if (xmlString.charCodeAt(start + 1) === 0x75 && xmlString.charCodeAt(start + 2) === 0x6f && xmlString.charCodeAt(start + 3) === 0x74 && xmlString.charCodeAt(start + 4) === $d7032f3974c45172$var$CharCodes.SEMI) {
                    consumed = 5;
                    value = '"';
                }
                break;
        }
        if (consumed > 0) {
            if (lastIndex < offset) result += xmlString.slice(lastIndex, offset);
            result += value;
            offset = lastIndex = start + consumed;
        } else offset = start;
        /*
         * Adjacent entities (`&x;&y;`) are common in entity-dense input;
         * checking the single character at `lastIndex` first skips the
         * `indexOf` call (and its per-call overhead) for that case.
         */ offset = xmlString.charCodeAt(offset) === $d7032f3974c45172$var$CharCodes.AMP ? offset : xmlString.indexOf("&", offset);
    }while (offset >= 0);
    return result + xmlString.slice(lastIndex);
}


var $9fcef3ab38f9bbe4$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($9fcef3ab38f9bbe4$var$CharCodes || ($9fcef3ab38f9bbe4$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $9fcef3ab38f9bbe4$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["DeclarationSequence"] = 20] = "DeclarationSequence";
    State[State["InSpecialComment"] = 21] = "InSpecialComment";
    State[State["InCommentLike"] = 22] = "InCommentLike";
    // Special tags
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["InPlainText"] = 25] = "InPlainText";
    State[State["InEntity"] = 26] = "InEntity";
})($9fcef3ab38f9bbe4$var$State || ($9fcef3ab38f9bbe4$var$State = {}));
function $9fcef3ab38f9bbe4$var$isWhitespace(c) {
    return c === $9fcef3ab38f9bbe4$var$CharCodes.Space || c === $9fcef3ab38f9bbe4$var$CharCodes.NewLine || c === $9fcef3ab38f9bbe4$var$CharCodes.Tab || c === $9fcef3ab38f9bbe4$var$CharCodes.FormFeed || c === $9fcef3ab38f9bbe4$var$CharCodes.CarriageReturn;
}
function $9fcef3ab38f9bbe4$var$isEndOfTagSection(c) {
    return c === $9fcef3ab38f9bbe4$var$CharCodes.Slash || c === $9fcef3ab38f9bbe4$var$CharCodes.Gt || $9fcef3ab38f9bbe4$var$isWhitespace(c);
}
function $9fcef3ab38f9bbe4$var$isASCIIAlpha(c) {
    return c >= $9fcef3ab38f9bbe4$var$CharCodes.LowerA && c <= $9fcef3ab38f9bbe4$var$CharCodes.LowerZ || c >= $9fcef3ab38f9bbe4$var$CharCodes.UpperA && c <= $9fcef3ab38f9bbe4$var$CharCodes.UpperZ;
}
var $9fcef3ab38f9bbe4$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($9fcef3ab38f9bbe4$export$cbf5509cea2ad22 || ($9fcef3ab38f9bbe4$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $9fcef3ab38f9bbe4$var$Sequences = {
    Empty: new Uint8Array(0),
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x21,
        0x3e
    ]),
    Doctype: new Uint8Array([
        0x64,
        0x6f,
        0x63,
        0x74,
        0x79,
        0x70,
        0x65
    ]),
    IframeEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x69,
        0x66,
        0x72,
        0x61,
        0x6d,
        0x65
    ]),
    NoembedEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x6e,
        0x6f,
        0x65,
        0x6d,
        0x62,
        0x65,
        0x64
    ]),
    NoframesEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x6e,
        0x6f,
        0x66,
        0x72,
        0x61,
        0x6d,
        0x65,
        0x73
    ]),
    Plaintext: new Uint8Array([
        0x3c,
        0x2f,
        0x70,
        0x6c,
        0x61,
        0x69,
        0x6e,
        0x74,
        0x65,
        0x78,
        0x74
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ]),
    TextareaEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x65,
        0x78,
        0x74,
        0x61,
        0x72,
        0x65,
        0x61
    ]),
    XmpEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x78,
        0x6d,
        0x70
    ])
};
/**
 * Maps the first lowercase character of an HTML tag name to the sequence
 * used for special-tag detection.  All sequences share a common layout
 * where index 2 is the first tag-name character, so matching always
 * continues from offset 3.
 */ const $9fcef3ab38f9bbe4$var$specialStartSequences = new Map([
    [
        $9fcef3ab38f9bbe4$var$Sequences.IframeEnd[2],
        $9fcef3ab38f9bbe4$var$Sequences.IframeEnd
    ],
    [
        $9fcef3ab38f9bbe4$var$Sequences.NoembedEnd[2],
        $9fcef3ab38f9bbe4$var$Sequences.NoembedEnd
    ],
    [
        $9fcef3ab38f9bbe4$var$Sequences.Plaintext[2],
        $9fcef3ab38f9bbe4$var$Sequences.Plaintext
    ],
    [
        $9fcef3ab38f9bbe4$var$Sequences.ScriptEnd[2],
        $9fcef3ab38f9bbe4$var$Sequences.ScriptEnd
    ],
    [
        $9fcef3ab38f9bbe4$var$Sequences.TitleEnd[2],
        $9fcef3ab38f9bbe4$var$Sequences.TitleEnd
    ],
    [
        $9fcef3ab38f9bbe4$var$Sequences.XmpEnd[2],
        $9fcef3ab38f9bbe4$var$Sequences.XmpEnd
    ]
]);
class $9fcef3ab38f9bbe4$export$2e2bcd8739ae039 {
    cbs;
    /** The current state the tokenizer is in. */ state = $9fcef3ab38f9bbe4$var$State.Text;
    /** The read buffer. */ buffer = "";
    /** The beginning of the section that is currently being read. */ sectionStart = 0;
    /** The index within the buffer that we are currently looking at. */ index = 0;
    /** The start of the last entity. */ entityStart = 0;
    /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ baseState = $9fcef3ab38f9bbe4$var$State.Text;
    /** For special parsing behavior inside of script and style tags. */ isSpecial = false;
    /** Indicates whether the tokenizer has been paused. */ running = true;
    /** The offset of the current buffer. */ offset = 0;
    xmlMode;
    decodeEntities;
    recognizeSelfClosing;
    entityDecoder;
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true, recognizeSelfClosing: recognizeSelfClosing = xmlMode }, cbs){
        this.cbs = cbs;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.recognizeSelfClosing = recognizeSelfClosing;
        this.entityDecoder = new (0, $d7032f3974c45172$export$15263a93ff7ec8ba)(xmlMode ? (0, $28adead722c34a77$export$298b118b5a906d9f) : (0, $cc62f38eaffeb4b6$export$b6a4accd5ee85f69), (cp, consumed)=>this.emitCodePoint(cp, consumed));
    }
    reset() {
        this.state = $9fcef3ab38f9bbe4$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $9fcef3ab38f9bbe4$var$State.Text;
        this.isSpecial = false;
        this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Empty;
        this.sequenceIndex = 0;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    stateText(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $9fcef3ab38f9bbe4$var$CharCodes.Amp) this.startEntity();
    }
    currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Empty;
    sequenceIndex = 0;
    enterTagBody() {
        if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.Plaintext) {
            this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Empty;
            this.state = $9fcef3ab38f9bbe4$var$State.InPlainText;
        } else if (this.isSpecial) {
            this.state = $9fcef3ab38f9bbe4$var$State.InSpecialTag;
            this.sequenceIndex = 0;
        } else this.state = $9fcef3ab38f9bbe4$var$State.Text;
    }
    /**
     * Match the opening tag name against an HTML text-only tag sequence.
     *
     * Some tags share an initial prefix (`script`/`style`, `title`/`textarea`,
     * `noembed`/`noframes`), so we may switch to an alternate sequence at the
     * first distinguishing byte.  On a successful full match we fall back to
     * the normal tag-name state; a later `>` will enter raw-text, RCDATA, or
     * plaintext mode based on `currentSequence` / `isSpecial`.
     * @param c Current character code point.
     */ stateSpecialStartSequence(c) {
        const lower = c | 0x20;
        // Still matching — check for an alternate sequence at branch points.
        if (this.sequenceIndex < this.currentSequence.length) {
            if (lower === this.currentSequence[this.sequenceIndex]) {
                this.sequenceIndex++;
                return;
            }
            if (this.sequenceIndex === 3) {
                if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.ScriptEnd && lower === $9fcef3ab38f9bbe4$var$Sequences.StyleEnd[3]) {
                    this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.StyleEnd;
                    this.sequenceIndex = 4;
                    return;
                }
                if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.TitleEnd && lower === $9fcef3ab38f9bbe4$var$Sequences.TextareaEnd[3]) {
                    this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.TextareaEnd;
                    this.sequenceIndex = 4;
                    return;
                }
            } else if (this.sequenceIndex === 4 && this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.NoembedEnd && lower === $9fcef3ab38f9bbe4$var$Sequences.NoframesEnd[4]) {
                this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.NoframesEnd;
                this.sequenceIndex = 5;
                return;
            }
        } else if ($9fcef3ab38f9bbe4$var$isEndOfTagSection(c)) {
            // Full match on a valid tag boundary — keep the sequence.
            this.sequenceIndex = 0;
            this.state = $9fcef3ab38f9bbe4$var$State.InTagName;
            this.stateInTagName(c);
            return;
        }
        // No match — abandon special-tag detection.
        this.isSpecial = false;
        this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Empty;
        this.sequenceIndex = 0;
        this.state = $9fcef3ab38f9bbe4$var$State.InTagName;
        this.stateInTagName(c);
    }
    stateCDATASequence(c) {
        if (c === $9fcef3ab38f9bbe4$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $9fcef3ab38f9bbe4$var$Sequences.Cdata.length) {
                this.state = $9fcef3ab38f9bbe4$var$State.InCommentLike;
                this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            if (this.xmlMode) {
                this.state = $9fcef3ab38f9bbe4$var$State.InDeclaration;
                this.stateInDeclaration(c); // Reconsume the character
            } else {
                this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
                this.stateInSpecialComment(c); // Reconsume the character
            }
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     * @param c Current character code point.
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Emit a comment token and return to the text state.
     * @param offset Number of characters in the end sequence that have already been matched.
     */ emitComment(offset) {
        this.cbs.oncomment(this.sectionStart, this.index, offset);
        this.sequenceIndex = 0;
        this.sectionStart = this.index + 1;
        this.state = $9fcef3ab38f9bbe4$var$State.Text;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     * @param c Current character code point.
     */ stateInCommentLike(c) {
        if (!this.xmlMode && this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.CommentEnd && this.sequenceIndex <= 1 && /*
             * We're still at the very start of the comment: the only
             * characters consumed since `<!--` are the dashes that
             * advanced sequenceIndex (0 for `<!-->`, 1 for `<!--->`).
             */ this.index === this.sectionStart + this.sequenceIndex && c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) // Abruptly closed empty HTML comment.
        this.emitComment(this.sequenceIndex);
        else if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.CommentEnd && this.sequenceIndex === 2 && c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) // `!` is optional here, so the same sequence also accepts `-->`.
        this.emitComment(2);
        else if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.CommentEnd && this.sequenceIndex === this.currentSequence.length - 1 && c !== $9fcef3ab38f9bbe4$var$CharCodes.Gt) this.sequenceIndex = Number(c === $9fcef3ab38f9bbe4$var$CharCodes.Dash);
        else if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 3);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $9fcef3ab38f9bbe4$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     * @param c Current character code point.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$9fcef3ab38f9bbe4$var$isEndOfTagSection(c) : $9fcef3ab38f9bbe4$var$isASCIIAlpha(c);
    }
    /**
     * Scan raw-text / RCDATA content for the matching end tag.
     *
     * For RCDATA tags (`<title>`, `<textarea>`) entities are decoded inline.
     * For raw-text tags (`<script>`, `<style>`, etc.) we fast-forward to `<`.
     * @param c Current character code point.
     */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if ($9fcef3ab38f9bbe4$var$isEndOfTagSection(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.TitleEnd || this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.TextareaEnd) // RCDATA tags have to parse entities while still looking for their end tag.
            {
                if (this.decodeEntities && c === $9fcef3ab38f9bbe4$var$CharCodes.Amp) this.startEntity();
            } else if (this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Lt)) // Outside of RCDATA tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $9fcef3ab38f9bbe4$var$CharCodes.Lt);
    }
    stateBeforeTagName(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.ExclamationMark) {
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Questionmark) {
            if (this.xmlMode) {
                this.state = $9fcef3ab38f9bbe4$var$State.InProcessingInstruction;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            } else {
                this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
                this.sectionStart = this.index;
            }
        } else if (this.isTagStartChar(c)) {
            this.sectionStart = this.index;
            const special = this.xmlMode || this.cbs.isInForeignContext?.() ? undefined : $9fcef3ab38f9bbe4$var$specialStartSequences.get(c | 0x20);
            if (special === undefined) this.state = $9fcef3ab38f9bbe4$var$State.InTagName;
            else {
                this.isSpecial = true;
                this.currentSequence = special;
                this.sequenceIndex = 3;
                this.state = $9fcef3ab38f9bbe4$var$State.SpecialStartSequence;
            }
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Slash) this.state = $9fcef3ab38f9bbe4$var$State.BeforeClosingTagName;
        else {
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($9fcef3ab38f9bbe4$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($9fcef3ab38f9bbe4$var$isWhitespace(c)) {
            if (this.xmlMode) ;
            else {
                this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
                this.sectionStart = this.index;
            }
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            if (!this.xmlMode) this.sectionStart = this.index + 1;
        } else {
            this.state = this.isTagStartChar(c) ? $9fcef3ab38f9bbe4$var$State.InClosingTagName : $9fcef3ab38f9bbe4$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if ($9fcef3ab38f9bbe4$var$isEndOfTagSection(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $9fcef3ab38f9bbe4$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt || this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Gt)) {
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            this.enterTagBody();
            this.sectionStart = this.index + 1;
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Slash) this.state = $9fcef3ab38f9bbe4$var$State.InSelfClosingTag;
        else if (!$9fcef3ab38f9bbe4$var$isWhitespace(c)) {
            this.state = $9fcef3ab38f9bbe4$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    /**
     * Handle `/` before `>` in an opening tag.
     *
     * In HTML mode, text-only tags ignore the self-closing flag and still enter
     * their raw-text/RCDATA/plaintext state unless self-closing tags are being
     * recognized. In XML mode, or for ordinary tags, the tokenizer returns to
     * regular text parsing after emitting the self-closing callback.
     * @param c Current character code point.
     */ stateInSelfClosingTag(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.sectionStart = this.index + 1;
            if (!this.recognizeSelfClosing) {
                this.enterTagBody();
                return;
            }
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
            this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Empty;
        } else if (!$9fcef3ab38f9bbe4$var$isWhitespace(c)) {
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Eq || $9fcef3ab38f9bbe4$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = this.index;
            this.state = $9fcef3ab38f9bbe4$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Eq) this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeValue;
        else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Slash || c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.onattribend($9fcef3ab38f9bbe4$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.sectionStart = -1;
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$9fcef3ab38f9bbe4$var$isWhitespace(c)) {
            this.cbs.onattribend($9fcef3ab38f9bbe4$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.state = $9fcef3ab38f9bbe4$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.DoubleQuote) {
            this.state = $9fcef3ab38f9bbe4$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.SingleQuote) {
            this.state = $9fcef3ab38f9bbe4$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$9fcef3ab38f9bbe4$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $9fcef3ab38f9bbe4$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $9fcef3ab38f9bbe4$var$CharCodes.DoubleQuote ? $9fcef3ab38f9bbe4$export$cbf5509cea2ad22.Double : $9fcef3ab38f9bbe4$export$cbf5509cea2ad22.Single, this.index + 1);
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $9fcef3ab38f9bbe4$var$CharCodes.Amp) this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $9fcef3ab38f9bbe4$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $9fcef3ab38f9bbe4$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($9fcef3ab38f9bbe4$var$isWhitespace(c) || c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($9fcef3ab38f9bbe4$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $9fcef3ab38f9bbe4$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $9fcef3ab38f9bbe4$var$CharCodes.Amp) this.startEntity();
    }
    /**
     * Distinguish between CDATA, declarations, HTML comments, and HTML bogus
     * comments after `<!`.
     *
     * In HTML mode, only real comments and doctypes stay on declaration paths;
     * everything else becomes a bogus comment terminated by the next `>`.
     * @param c Current character code point.
     */ stateBeforeDeclaration(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.OpeningSquareBracket) {
            this.state = $9fcef3ab38f9bbe4$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else if (this.xmlMode) this.state = c === $9fcef3ab38f9bbe4$var$CharCodes.Dash ? $9fcef3ab38f9bbe4$var$State.BeforeComment : $9fcef3ab38f9bbe4$var$State.InDeclaration;
        else if ((c | 0x20) === $9fcef3ab38f9bbe4$var$Sequences.Doctype[0]) {
            this.state = $9fcef3ab38f9bbe4$var$State.DeclarationSequence;
            this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.Doctype;
            this.sequenceIndex = 1;
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        } else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Dash) this.state = $9fcef3ab38f9bbe4$var$State.BeforeComment;
        else this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
    }
    /**
     * Continue matching `doctype` after `<!d`.
     *
     * A full `doctype` match stays on the declaration path; any other name falls
     * back to an HTML bogus comment, which matches browser behavior for
     * non-doctype `<!...>` constructs.
     * @param c Current character code point.
     */ stateDeclarationSequence(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            this.state = $9fcef3ab38f9bbe4$var$State.InDeclaration;
            this.stateInDeclaration(c);
        } else if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        } else this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
    }
    stateInDeclaration(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt || this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    /**
     * XML processing instructions (`<?...?>`).
     *
     * In HTML mode `<?` is routed to `InSpecialComment` instead, so this
     * state is only reachable in XML mode.
     * @param c Current character code point.
     */ stateInProcessingInstruction(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Questionmark) // Remember that we just consumed `?`, so the next `>` closes the PI.
        this.sequenceIndex = 1;
        else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt && this.sequenceIndex === 1) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index - 1);
            this.sequenceIndex = 0;
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        } else // Keep scanning for the next `?`, which can start a closing `?>`.
        this.sequenceIndex = Number(this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Questionmark));
    }
    stateBeforeComment(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Dash) {
            this.state = $9fcef3ab38f9bbe4$var$State.InCommentLike;
            this.currentSequence = $9fcef3ab38f9bbe4$var$Sequences.CommentEnd;
            this.sequenceIndex = 0;
            this.sectionStart = this.index + 1;
        } else if (this.xmlMode) this.state = $9fcef3ab38f9bbe4$var$State.InDeclaration;
        else if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        } else this.state = $9fcef3ab38f9bbe4$var$State.InSpecialComment;
    }
    stateInSpecialComment(c) {
        if (c === $9fcef3ab38f9bbe4$var$CharCodes.Gt || this.fastForwardTo($9fcef3ab38f9bbe4$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $9fcef3ab38f9bbe4$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = $9fcef3ab38f9bbe4$var$State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode ? (0, $d7032f3974c45172$export$8c8f129ce60f53c).Strict : this.baseState === $9fcef3ab38f9bbe4$var$State.Text || this.baseState === $9fcef3ab38f9bbe4$var$State.InSpecialTag ? (0, $d7032f3974c45172$export$8c8f129ce60f53c).Legacy : (0, $d7032f3974c45172$export$8c8f129ce60f53c).Attribute);
    }
    stateInEntity() {
        const indexInBuffer = this.index - this.offset;
        const length = this.entityDecoder.write(this.buffer, indexInBuffer);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) this.index -= 1;
        } else {
            if (indexInBuffer < this.buffer.length && this.buffer.charCodeAt(indexInBuffer) === $9fcef3ab38f9bbe4$var$CharCodes.Amp) {
                this.state = this.baseState;
                this.index -= 1;
                return;
            }
            // Mark buffer as consumed.
            this.index = this.offset + this.buffer.length - 1;
        }
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $9fcef3ab38f9bbe4$var$State.Text || this.state === $9fcef3ab38f9bbe4$var$State.InPlainText || this.state === $9fcef3ab38f9bbe4$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $9fcef3ab38f9bbe4$var$State.InAttributeValueDq || this.state === $9fcef3ab38f9bbe4$var$State.InAttributeValueSq || this.state === $9fcef3ab38f9bbe4$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $9fcef3ab38f9bbe4$var$State.Text:
                    this.stateText(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InPlainText:
                    // Skip to end of buffer; cleanup() emits the text.
                    this.index = this.buffer.length + this.offset - 1;
                    break;
                case $9fcef3ab38f9bbe4$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.DeclarationSequence:
                    this.stateDeclarationSequence(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $9fcef3ab38f9bbe4$var$State.InEntity:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $9fcef3ab38f9bbe4$var$State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    handleTrailingCommentLikeData(endIndex) {
        if (this.state !== $9fcef3ab38f9bbe4$var$State.InCommentLike) return false;
        if (this.currentSequence === $9fcef3ab38f9bbe4$var$Sequences.CdataEnd) {
            if (this.xmlMode) {
                if (this.sectionStart < endIndex) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            } else {
                /* In HTML mode, unclosed CDATA is a bogus comment. */ const cdataStart = this.sectionStart - $9fcef3ab38f9bbe4$var$Sequences.Cdata.length - 1;
                this.cbs.oncomment(cdataStart, endIndex, 0);
            }
        } else {
            const offset = this.xmlMode ? 0 : Math.min(this.sequenceIndex, $9fcef3ab38f9bbe4$var$Sequences.CommentEnd.length - 1);
            this.cbs.oncomment(this.sectionStart, endIndex, offset);
        }
        return true;
    }
    handleTrailingMarkupDeclaration(endIndex) {
        if (this.xmlMode) switch(this.state){
            case $9fcef3ab38f9bbe4$var$State.InSpecialComment:
            case $9fcef3ab38f9bbe4$var$State.BeforeComment:
            case $9fcef3ab38f9bbe4$var$State.CDATASequence:
            case $9fcef3ab38f9bbe4$var$State.DeclarationSequence:
            case $9fcef3ab38f9bbe4$var$State.InDeclaration:
                this.cbs.ontext(this.sectionStart, endIndex);
                return true;
            default:
                return false;
        }
        switch(this.state){
            case $9fcef3ab38f9bbe4$var$State.BeforeDeclaration:
            case $9fcef3ab38f9bbe4$var$State.InSpecialComment:
            case $9fcef3ab38f9bbe4$var$State.BeforeComment:
            case $9fcef3ab38f9bbe4$var$State.CDATASequence:
                this.cbs.oncomment(this.sectionStart, endIndex, 0);
                return true;
            case $9fcef3ab38f9bbe4$var$State.DeclarationSequence:
                if (this.sequenceIndex !== $9fcef3ab38f9bbe4$var$Sequences.Doctype.length) this.cbs.oncomment(this.sectionStart, endIndex, 0);
                return true;
            case $9fcef3ab38f9bbe4$var$State.InDeclaration:
                return true;
            default:
                return false;
        }
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.handleTrailingCommentLikeData(endIndex) || this.handleTrailingMarkupDeclaration(endIndex)) return;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) return;
        switch(this.state){
            case $9fcef3ab38f9bbe4$var$State.InTagName:
            case $9fcef3ab38f9bbe4$var$State.BeforeAttributeName:
            case $9fcef3ab38f9bbe4$var$State.BeforeAttributeValue:
            case $9fcef3ab38f9bbe4$var$State.AfterAttributeName:
            case $9fcef3ab38f9bbe4$var$State.InAttributeName:
            case $9fcef3ab38f9bbe4$var$State.InAttributeValueSq:
            case $9fcef3ab38f9bbe4$var$State.InAttributeValueDq:
            case $9fcef3ab38f9bbe4$var$State.InAttributeValueNq:
            case $9fcef3ab38f9bbe4$var$State.InClosingTagName:
                break;
            default:
                this.cbs.ontext(this.sectionStart, endIndex);
        }
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== $9fcef3ab38f9bbe4$var$State.Text && this.baseState !== $9fcef3ab38f9bbe4$var$State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        } else {
            if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
}


const { fromCodePoint: $e568cd9e4c5fb384$var$fromCodePoint } = String;
const $e568cd9e4c5fb384$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $e568cd9e4c5fb384$var$pTag = new Set([
    "p"
]);
const $e568cd9e4c5fb384$var$headingTags = new Set([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p"
]);
const $e568cd9e4c5fb384$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $e568cd9e4c5fb384$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $e568cd9e4c5fb384$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $e568cd9e4c5fb384$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "a",
        new Set([
            "a"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "h1",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "h2",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "h3",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "h4",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "h5",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "h6",
        $e568cd9e4c5fb384$var$headingTags
    ],
    [
        "select",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "input",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "output",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "button",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "datalist",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "textarea",
        $e568cd9e4c5fb384$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $e568cd9e4c5fb384$var$ddtTags
    ],
    [
        "dt",
        $e568cd9e4c5fb384$var$ddtTags
    ],
    [
        "address",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "article",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "aside",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "blockquote",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "details",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "div",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "dl",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "fieldset",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "figcaption",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "figure",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "footer",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "form",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "header",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "hr",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "main",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "nav",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "ol",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "pre",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "section",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "table",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "ul",
        $e568cd9e4c5fb384$var$pTag
    ],
    [
        "rt",
        $e568cd9e4c5fb384$var$rtpTags
    ],
    [
        "rp",
        $e568cd9e4c5fb384$var$rtpTags
    ],
    [
        "tbody",
        $e568cd9e4c5fb384$var$tableSectionTags
    ],
    [
        "tfoot",
        $e568cd9e4c5fb384$var$tableSectionTags
    ]
]);
const $e568cd9e4c5fb384$var$DOCUMENT_TYPE = "doctype";
const $e568cd9e4c5fb384$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $e568cd9e4c5fb384$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
/**
 * Elements that can be used to integrate HTML content within foreign namespaces (e.g., SVG or MathML).
 *
 * Entries must use the SVG-adjusted casing (e.g. "foreignObject" not
 * "foreignobject") since they are compared against adjusted tag names.
 */ const $e568cd9e4c5fb384$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $e568cd9e4c5fb384$var$svgTagNameAdjustments = new Map([
    [
        "altglyph",
        "altGlyph"
    ],
    [
        "altglyphdef",
        "altGlyphDef"
    ],
    [
        "altglyphitem",
        "altGlyphItem"
    ],
    [
        "animatecolor",
        "animateColor"
    ],
    [
        "animatemotion",
        "animateMotion"
    ],
    [
        "animatetransform",
        "animateTransform"
    ],
    [
        "clippath",
        "clipPath"
    ],
    [
        "feblend",
        "feBlend"
    ],
    [
        "fecolormatrix",
        "feColorMatrix"
    ],
    [
        "fecomponenttransfer",
        "feComponentTransfer"
    ],
    [
        "fecomposite",
        "feComposite"
    ],
    [
        "feconvolvematrix",
        "feConvolveMatrix"
    ],
    [
        "fediffuselighting",
        "feDiffuseLighting"
    ],
    [
        "fedisplacementmap",
        "feDisplacementMap"
    ],
    [
        "fedistantlight",
        "feDistantLight"
    ],
    [
        "fedropshadow",
        "feDropShadow"
    ],
    [
        "feflood",
        "feFlood"
    ],
    [
        "fefunca",
        "feFuncA"
    ],
    [
        "fefuncb",
        "feFuncB"
    ],
    [
        "fefuncg",
        "feFuncG"
    ],
    [
        "fefuncr",
        "feFuncR"
    ],
    [
        "fegaussianblur",
        "feGaussianBlur"
    ],
    [
        "feimage",
        "feImage"
    ],
    [
        "femerge",
        "feMerge"
    ],
    [
        "femergenode",
        "feMergeNode"
    ],
    [
        "femorphology",
        "feMorphology"
    ],
    [
        "feoffset",
        "feOffset"
    ],
    [
        "fepointlight",
        "fePointLight"
    ],
    [
        "fespecularlighting",
        "feSpecularLighting"
    ],
    [
        "fespotlight",
        "feSpotLight"
    ],
    [
        "fetile",
        "feTile"
    ],
    [
        "feturbulence",
        "feTurbulence"
    ],
    [
        "foreignobject",
        "foreignObject"
    ],
    [
        "glyphref",
        "glyphRef"
    ],
    [
        "lineargradient",
        "linearGradient"
    ],
    [
        "radialgradient",
        "radialGradient"
    ],
    [
        "textpath",
        "textPath"
    ]
]);
var $e568cd9e4c5fb384$var$ForeignContext;
(function(ForeignContext) {
    ForeignContext[ForeignContext["None"] = 0] = "None";
    ForeignContext[ForeignContext["Svg"] = 1] = "Svg";
    ForeignContext[ForeignContext["MathML"] = 2] = "MathML";
})($e568cd9e4c5fb384$var$ForeignContext || ($e568cd9e4c5fb384$var$ForeignContext = {}));
const $e568cd9e4c5fb384$var$reNameEnd = /\s|\//;
class $e568cd9e4c5fb384$export$7acfa6ed01010e37 {
    options;
    /** The start index of the last event. */ startIndex = 0;
    /** The end index of the last event. */ endIndex = 0;
    /**
     * Store the start index of the current open tag,
     * so we can update the start index for attributes.
     */ openTagStart = 0;
    tagname = "";
    attribname = "";
    attribvalue = "";
    attribs = null;
    stack = [];
    foreignContext;
    cbs;
    lowerCaseTagNames;
    lowerCaseAttributeNames;
    recognizeSelfClosing;
    /** We are parsing HTML. Inverse of the `xmlMode` option. */ htmlMode;
    tokenizer;
    buffers = [];
    bufferOffset = 0;
    /** The index of the last written buffer. Used when resuming after a `pause()`. */ writeIndex = 0;
    /** Indicates whether the parser has finished running / `.end` has been called. */ ended = false;
    constructor(cbs, options = {}){
        this.options = options;
        this.cbs = cbs ?? {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = options.lowerCaseTags ?? this.htmlMode;
        this.lowerCaseAttributeNames = options.lowerCaseAttributeNames ?? this.htmlMode;
        this.recognizeSelfClosing = options.recognizeSelfClosing ?? !this.htmlMode;
        this.tokenizer = new (options.Tokenizer ?? (0, $9fcef3ab38f9bbe4$export$2e2bcd8739ae039))(this.options, this);
        this.foreignContext = [
            $e568cd9e4c5fb384$var$ForeignContext.None
        ];
        this.cbs.onparserinit?.(this);
    }
    // Tokenizer event handlers
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ ontext(start, endIndex) {
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        this.cbs.ontext?.(data);
        this.startIndex = endIndex;
    }
    /**
     * @param cp Current Unicode code point.
     * @param endIndex End index for the current parser event.
     * @internal
     */ ontextentity(cp, endIndex) {
        this.endIndex = endIndex - 1;
        this.cbs.ontext?.($e568cd9e4c5fb384$var$fromCodePoint(cp));
        this.startIndex = endIndex;
    }
    /** @internal */ isInForeignContext() {
        return this.foreignContext[0] !== $e568cd9e4c5fb384$var$ForeignContext.None;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     * @param name Name of the pseudo selector.
     */ isVoidElement(name) {
        return this.htmlMode && $e568cd9e4c5fb384$var$voidElements.has(name);
    }
    /**
     * Read a tag name from the buffer.
     *
     * When `lowerCaseTagNames` is enabled (the default in HTML mode), the name
     * is lowercased and may be adjusted for SVG casing or the `image` → `img`
     * alias.
     * @param start Start index of the tag name in the buffer.
     * @param endIndex End index of the tag name in the buffer.
     */ readTagName(start, endIndex) {
        const name = this.lowerCaseTagNames ? this.getSlice(start, endIndex).toLowerCase() : this.getSlice(start, endIndex);
        if (!(this.lowerCaseTagNames && this.htmlMode)) return name;
        if (this.foreignContext[0] === $e568cd9e4c5fb384$var$ForeignContext.Svg) return $e568cd9e4c5fb384$var$svgTagNameAdjustments.get(name) ?? name;
        /*
         * Closing tags for SVG elements inside HTML integration points
         * (e.g. </foreignObject> while inside its own content) need case
         * adjustment so the name matches what was pushed to the stack.
         * `foreignContext.length > 1` means a foreign ancestor exists —
         * the base [None] entry plus at least one pushed context.
         */ if (this.foreignContext.length > 1) {
            const adjusted = $e568cd9e4c5fb384$var$svgTagNameAdjustments.get(name);
            if (adjusted !== undefined && this.stack.includes(adjusted)) return adjusted;
        }
        if (!this.isInForeignContext()) return name === "image" ? "img" : name;
        return name;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        this.emitOpenTag(this.readTagName(start, endIndex));
    }
    emitOpenTag(name) {
        this.openTagStart = this.startIndex;
        this.tagname = name;
        /*
         * The spec ignores a second <form> when one is already open.
         * Setting tagname to "" suppresses all downstream effects: attribs
         * stays null so endOpenTag is a no-op, and closeCurrentTag can't
         * match "" on the stack.
         */ if (this.htmlMode && name === "form" && this.stack.includes("form")) {
            this.tagname = "";
            return;
        }
        const impliesClose = this.htmlMode && $e568cd9e4c5fb384$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0]))this.popElement(true);
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if (name === "svg") this.foreignContext.unshift($e568cd9e4c5fb384$var$ForeignContext.Svg);
                else if (name === "math") this.foreignContext.unshift($e568cd9e4c5fb384$var$ForeignContext.MathML);
                else if ($e568cd9e4c5fb384$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift($e568cd9e4c5fb384$var$ForeignContext.None);
            }
        }
        this.cbs.onopentagname?.(name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            this.cbs.onopentag?.(this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /**
     * @param endIndex End index for the current parser event.
     * @internal
     */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onclosetag(start, endIndex) {
        this.endIndex = endIndex;
        const name = this.readTagName(start, endIndex);
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) {
                for(let index = 0; index < pos; index++)this.popElement(true);
                this.popElement(false);
            } else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            this.cbs.onopentagname?.("br");
            this.cbs.onopentag?.("br", {}, true);
            this.cbs.onclosetag?.("br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /**
     * @param endIndex End index for the current parser event.
     * @internal
     */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.recognizeSelfClosing || this.isInForeignContext()) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    /**
     * Pop the top element off the stack, emit a close event, and maintain
     * the foreign context stack.
     * @param implied Whether this close is implied (not from an explicit end tag).
     */ popElement(implied) {
        // biome-ignore lint/style/noNonNullAssertion: The element is guaranteed to exist.
        const element = this.stack.shift();
        if (this.htmlMode && ($e568cd9e4c5fb384$var$foreignContextElements.has(element) || $e568cd9e4c5fb384$var$htmlIntegrationElements.has(element))) this.foreignContext.shift();
        this.cbs.onclosetag?.(element, implied);
    }
    closeCurrentTag(isOpenImplied) {
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) this.popElement(!isOpenImplied);
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /**
     * @param cp Current Unicode code point.
     * @internal
     */ onattribentity(cp) {
        this.attribvalue += $e568cd9e4c5fb384$var$fromCodePoint(cp);
    }
    /**
     * @param quote Quote type used for the current attribute.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onattribend(quote, endIndex) {
        this.endIndex = endIndex;
        this.cbs.onattribute?.(this.attribname, this.attribvalue, quote === (0, $9fcef3ab38f9bbe4$export$cbf5509cea2ad22).Double ? '"' : quote === (0, $9fcef3ab38f9bbe4$export$cbf5509cea2ad22).Single ? "'" : quote === (0, $9fcef3ab38f9bbe4$export$cbf5509cea2ad22).NoValue ? undefined : null);
        if (this.attribs && !Object.hasOwn(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($e568cd9e4c5fb384$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            /*
             * In HTML mode, ondeclaration is only reached for DOCTYPE
             * (the tokenizer routes everything else to bogus comments).
             */ const name = this.htmlMode ? this.lowerCaseTagNames ? $e568cd9e4c5fb384$var$DOCUMENT_TYPE : value.slice(0, $e568cd9e4c5fb384$var$DOCUMENT_TYPE.length) : this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @internal
     */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @param offset Offset applied when computing parser indices.
     * @internal
     */ oncomment(start, endIndex, offset) {
        this.endIndex = endIndex;
        this.cbs.oncomment?.(this.getSlice(start, endIndex - offset));
        this.cbs.oncommentend?.();
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /**
     * @param start Start index for the current parser event.
     * @param endIndex End index for the current parser event.
     * @param offset Offset applied when computing parser indices.
     * @internal
     */ oncdata(start, endIndex, offset) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            this.cbs.oncdatastart?.();
            this.cbs.ontext?.(value);
            this.cbs.oncdataend?.();
        } else if (this.isInForeignContext()) this.cbs.ontext?.(value);
        else {
            this.cbs.oncomment?.(`[CDATA[${value}]]`);
            this.cbs.oncommentend?.();
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
        }
        this.cbs.onend?.();
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        this.cbs.onreset?.();
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        this.cbs.onparserinit?.(this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift($e568cd9e4c5fb384$var$ForeignContext.None);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        if (start === end) return "";
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     * @param chunk Chunk to parse.
     */ write(chunk) {
        if (this.ended) {
            this.cbs.onerror?.(new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        if (this.ended) {
            this.cbs.onerror?.(new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
}


/** Types of elements found in htmlparser2's DOM */ var $96358bb576046356$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($96358bb576046356$export$b992dc138d950e31 || ($96358bb576046356$export$b992dc138d950e31 = {}));
function $96358bb576046356$export$3bf645f08efe3292(element) {
    return element.type === $96358bb576046356$export$b992dc138d950e31.Tag || element.type === $96358bb576046356$export$b992dc138d950e31.Script || element.type === $96358bb576046356$export$b992dc138d950e31.Style;
}
const $96358bb576046356$export$be92b6f5f03c0fe9 = $96358bb576046356$export$b992dc138d950e31.Root;
const $96358bb576046356$export$5f1af8db9871e1d6 = $96358bb576046356$export$b992dc138d950e31.Text;
const $96358bb576046356$export$befdefbdce210f91 = $96358bb576046356$export$b992dc138d950e31.Directive;
const $96358bb576046356$export$4d299b491347818a = $96358bb576046356$export$b992dc138d950e31.Comment;
const $96358bb576046356$export$2f8b47a141e57afc = $96358bb576046356$export$b992dc138d950e31.Script;
const $96358bb576046356$export$d9e45bc13d335801 = $96358bb576046356$export$b992dc138d950e31.Style;
const $96358bb576046356$export$3288d34c523a1192 = $96358bb576046356$export$b992dc138d950e31.Tag;
const $96358bb576046356$export$1f8b8f7e5c763232 = $96358bb576046356$export$b992dc138d950e31.CDATA;
const $96358bb576046356$export$31b44af36ff2c60f = $96358bb576046356$export$b992dc138d950e31.Doctype;



class $057756af47669739$export$85c928794f8d04d4 {
    /** Parent of the node */ parent = null;
    /** Previous sibling */ prev = null;
    /** Next sibling */ next = null;
    /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ startIndex = null;
    /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ endIndex = null;
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(previous) {
        this.prev = previous;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $057756af47669739$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $057756af47669739$export$c3569d91cd44d357 extends $057756af47669739$export$85c928794f8d04d4 {
    data;
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $057756af47669739$export$5f1af8db9871e1d6 extends $057756af47669739$export$c3569d91cd44d357 {
    type = (0, $96358bb576046356$export$b992dc138d950e31).Text;
    get nodeType() {
        return 3;
    }
}
class $057756af47669739$export$4d299b491347818a extends $057756af47669739$export$c3569d91cd44d357 {
    type = (0, $96358bb576046356$export$b992dc138d950e31).Comment;
    get nodeType() {
        return 8;
    }
}
class $057756af47669739$export$9269dce19ee35e96 extends $057756af47669739$export$c3569d91cd44d357 {
    type = (0, $96358bb576046356$export$b992dc138d950e31).Directive;
    name;
    constructor(name, data){
        super(data);
        this.name = name;
    }
    get nodeType() {
        return 1;
    }
    /** If this is a doctype, the document type name (parse5 only). */ "x-name";
    /** If this is a doctype, the document type public identifier (parse5 only). */ "x-publicId";
    /** If this is a doctype, the document type system identifier (parse5 only). */ "x-systemId";
}
class $057756af47669739$export$62be934f90997196 extends $057756af47669739$export$85c928794f8d04d4 {
    children;
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        return this.children[0] ?? null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $057756af47669739$export$1f8b8f7e5c763232 extends $057756af47669739$export$62be934f90997196 {
    type = (0, $96358bb576046356$export$b992dc138d950e31).CDATA;
    get nodeType() {
        return 4;
    }
}
class $057756af47669739$export$b34a105447964f9f extends $057756af47669739$export$62be934f90997196 {
    type = (0, $96358bb576046356$export$b992dc138d950e31).Root;
    get nodeType() {
        return 9;
    }
}
class $057756af47669739$export$db77ccec0bb4ccac extends $057756af47669739$export$62be934f90997196 {
    name;
    attribs;
    type;
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     * @param type Node type used for the new node instance.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $96358bb576046356$export$b992dc138d950e31).Script : name === "style" ? (0, $96358bb576046356$export$b992dc138d950e31).Style : (0, $96358bb576046356$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>({
                name: name,
                value: this.attribs[name],
                namespace: this["x-attribsNamespace"]?.[name],
                prefix: this["x-attribsPrefix"]?.[name]
            }));
    }
    /** Element namespace (parse5 only). */ namespace;
    /** Element attribute namespaces (parse5 only). */ "x-attribsNamespace";
    /** Element attribute namespace-related prefixes (parse5 only). */ "x-attribsPrefix";
}
function $057756af47669739$export$3bf645f08efe3292(node) {
    return (0, $96358bb576046356$export$3bf645f08efe3292)(node);
}
function $057756af47669739$export$c2d65aed98d39b56(node) {
    return node.type === (0, $96358bb576046356$export$b992dc138d950e31).CDATA;
}
function $057756af47669739$export$1879817ac5c922b7(node) {
    return node.type === (0, $96358bb576046356$export$b992dc138d950e31).Text;
}
function $057756af47669739$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $96358bb576046356$export$b992dc138d950e31).Comment;
}
function $057756af47669739$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $96358bb576046356$export$b992dc138d950e31).Directive;
}
function $057756af47669739$export$62858bae88b53fd0(node) {
    return node.type === (0, $96358bb576046356$export$b992dc138d950e31).Root;
}
function $057756af47669739$export$bd5ff50f0e53d41c(node) {
    return Object.hasOwn(node, "children");
}
function $057756af47669739$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($057756af47669739$export$1879817ac5c922b7(node)) result = new $057756af47669739$export$5f1af8db9871e1d6(node.data);
    else if ($057756af47669739$export$3ab01370f5e64ac8(node)) result = new $057756af47669739$export$4d299b491347818a(node.data);
    else if ($057756af47669739$export$3bf645f08efe3292(node)) {
        const children = recursive ? $057756af47669739$var$cloneChildren(node.children) : [];
        const clone = new $057756af47669739$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        for (const child of children)child.parent = clone;
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($057756af47669739$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $057756af47669739$var$cloneChildren(node.children) : [];
        const clone = new $057756af47669739$export$1f8b8f7e5c763232(children);
        for (const child of children)child.parent = clone;
        result = clone;
    } else if ($057756af47669739$export$62858bae88b53fd0(node)) {
        const children = recursive ? $057756af47669739$var$cloneChildren(node.children) : [];
        const clone = new $057756af47669739$export$b34a105447964f9f(children);
        for (const child of children)child.parent = clone;
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($057756af47669739$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $057756af47669739$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
/**
 * Clone a list of child nodes.
 * @param childs The child nodes to clone.
 * @returns A list of cloned child nodes.
 */ function $057756af47669739$var$cloneChildren(childs) {
    const children = childs.map((child)=>$057756af47669739$export$ae8e35ea29ddac22(child, true));
    for(let index = 1; index < children.length; index++){
        children[index].prev = children[index - 1];
        children[index - 1].next = children[index];
    }
    return children;
}


// Default options
const $ca901c1589412cd1$var$defaultOptions = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $ca901c1589412cd1$export$ff8ccbac9225de62 {
    /** The elements of the DOM */ dom = [];
    /** The root element for the DOM */ root = new (0, $057756af47669739$export$b34a105447964f9f)(this.dom);
    /** Called once parsing has completed. */ callback;
    /** Settings for the handler. */ options;
    /** Callback whenever a tag is closed. */ elementCB;
    /** Indicated whether parsing has been completed. */ done = false;
    /** Stack of open tags. */ tagStack = [
        this.root
    ];
    /** A data node that is still being written to. */ lastNode = null;
    /** Reference to the parser instance. Used for location information. */ parser = null;
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $ca901c1589412cd1$var$defaultOptions;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback ?? null;
        this.options = options ?? $ca901c1589412cd1$var$defaultOptions;
        this.elementCB = elementCB ?? null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $057756af47669739$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const element = this.tagStack.pop();
        if (this.options.withEndIndices && this.parser) element.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(element);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $96358bb576046356$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $057756af47669739$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $96358bb576046356$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices && this.parser) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $057756af47669739$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $96358bb576046356$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $057756af47669739$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $057756af47669739$export$5f1af8db9871e1d6)("");
        const node = new (0, $057756af47669739$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $057756af47669739$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices && this.parser) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices && this.parser) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $ca901c1589412cd1$export$2e2bcd8739ae039 = $ca901c1589412cd1$export$ff8ccbac9225de62;






function $88ebf36645767532$export$3dea766d36a8935f(test, node, recurse = true, limit = Number.POSITIVE_INFINITY) {
    return $88ebf36645767532$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $88ebf36645767532$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const element = nodeStack[0][indexStack[0]++];
        if (test(element)) {
            result.push(element);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $057756af47669739$export$bd5ff50f0e53d41c)(element) && element.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(element.children);
        }
    }
}
function $88ebf36645767532$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for (const node of searchedNodes){
        if ((0, $057756af47669739$export$3bf645f08efe3292)(node) && test(node)) return node;
        if (recurse && (0, $057756af47669739$export$bd5ff50f0e53d41c)(node) && node.children.length > 0) {
            const found = $88ebf36645767532$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $88ebf36645767532$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $057756af47669739$export$3bf645f08efe3292)(node) && test(node) || (0, $057756af47669739$export$bd5ff50f0e53d41c)(node) && $88ebf36645767532$export$9d99dce58ac4a31b(test, node.children));
}
function $88ebf36645767532$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const element = nodeStack[0][indexStack[0]++];
        if ((0, $057756af47669739$export$3bf645f08efe3292)(element) && test(element)) result.push(element);
        if ((0, $057756af47669739$export$bd5ff50f0e53d41c)(element) && element.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(element.children);
        }
    }
}


/**
 * A map of functions to check nodes against.
 */ const $2c05bb40cf30e065$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (element)=>(0, $057756af47669739$export$3bf645f08efe3292)(element) && name(element.name);
        if (name === "*") return 0, $057756af47669739$export$3bf645f08efe3292;
        return (element)=>(0, $057756af47669739$export$3bf645f08efe3292)(element) && element.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (element)=>type(element.type);
        return (element)=>element.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (element)=>(0, $057756af47669739$export$1879817ac5c922b7)(element) && data(element.data);
        return (element)=>(0, $057756af47669739$export$1879817ac5c922b7)(element) && element.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $2c05bb40cf30e065$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (element)=>(0, $057756af47669739$export$3bf645f08efe3292)(element) && value(element.attribs[attrib]);
    return (element)=>(0, $057756af47669739$export$3bf645f08efe3292)(element) && element.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $2c05bb40cf30e065$var$combineFuncs(a, b) {
    return (element)=>a(element) || b(element);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $2c05bb40cf30e065$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.hasOwn($2c05bb40cf30e065$var$Checks, key) ? $2c05bb40cf30e065$var$Checks[key](value) : $2c05bb40cf30e065$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($2c05bb40cf30e065$var$combineFuncs);
}
function $2c05bb40cf30e065$export$7b31db6b5a0b2f32(options, node) {
    const test = $2c05bb40cf30e065$var$compileTest(options);
    return test ? test(node) : true;
}
function $2c05bb40cf30e065$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Number.POSITIVE_INFINITY) {
    const test = $2c05bb40cf30e065$var$compileTest(options);
    return test ? (0, $88ebf36645767532$export$3dea766d36a8935f)(test, nodes, recurse, limit) : [];
}
function $2c05bb40cf30e065$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $88ebf36645767532$export$a541876d5d7daf90)($2c05bb40cf30e065$var$getAttribCheck("id", id), nodes, recurse);
}
function $2c05bb40cf30e065$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Number.POSITIVE_INFINITY) {
    return (0, $88ebf36645767532$export$3dea766d36a8935f)($2c05bb40cf30e065$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $2c05bb40cf30e065$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Number.POSITIVE_INFINITY) {
    return (0, $88ebf36645767532$export$3dea766d36a8935f)($2c05bb40cf30e065$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $2c05bb40cf30e065$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Number.POSITIVE_INFINITY) {
    return (0, $88ebf36645767532$export$3dea766d36a8935f)($2c05bb40cf30e065$var$Checks["tag_type"](type), nodes, recurse, limit);
}




/**
 * Get the named reference for an XML special character or U+00A0.
 * @param char Code unit matched by one of the escape regexes.
 */ function $83515478df2b4ed4$var$getEscape(char) {
    return char === 34 ? "&quot;" : char === 38 ? "&amp;" : char === 39 ? "&apos;" : char === 60 ? "&lt;" : char === 62 ? "&gt;" : "&nbsp;";
}
const $83515478df2b4ed4$export$e02688b8085d016b = (input, index)=>input.codePointAt(index);
const $83515478df2b4ed4$export$7f1fd439cded3de1 = 0x500000c4; // 32..63 -> 34 ("),38 (&),39 ('),60 (<),62 (>)
const $83515478df2b4ed4$export$19d407bfdd0b8a57 = /["&'<>\u0080-\uFFFF]/g;
/**
 * Whether `code` (a UTF-16 code unit) is escaped by {@link encodeXML}: a
 * non-ASCII unit, or one of the five XML specials flagged in
 * `XML_BITSET_VALUE` (which is only meaningful for code units 32-63).
 * @param code Code unit to test.
 */ function $83515478df2b4ed4$var$isXmlEscapable(code) {
    return code >= 0x80 || code >= 32 && code < 64 && ($83515478df2b4ed4$export$7f1fd439cded3de1 >>> code & 1) === 1;
}
function $83515478df2b4ed4$export$18855ec5be97da16(input) {
    const { length: length } = input;
    let out;
    let last = 0;
    let index = 0;
    while(index < length){
        const char = input.charCodeAt(index);
        /*
         * Find the next character to escape: scan a short window inline
         * (escapable characters cluster in markup-heavy input), then fall
         * back to the regex, which skips clean spans in native code.
         */ if (!$83515478df2b4ed4$var$isXmlEscapable(char)) {
            const bound = Math.min(index + 32, length);
            let next = index + 1;
            while(next < bound && !$83515478df2b4ed4$var$isXmlEscapable(input.charCodeAt(next)))next++;
            if (next < bound) {
                index = next;
                continue;
            }
            if (next >= length) break;
            $83515478df2b4ed4$export$19d407bfdd0b8a57.lastIndex = next;
            if (!$83515478df2b4ed4$export$19d407bfdd0b8a57.test(input)) break;
            index = $83515478df2b4ed4$export$19d407bfdd0b8a57.lastIndex - 1;
            continue;
        }
        if (out === undefined) out = input.substring(0, index);
        else if (last !== index) out += input.substring(last, index);
        if (char < 64) {
            // Known replacement
            out += $83515478df2b4ed4$var$getEscape(char);
            last = index += 1;
            continue;
        }
        // Non-ASCII: encode as numeric entity (handle surrogate pair)
        const cp = input.codePointAt(index);
        out += `&#x${cp.toString(16)};`;
        if (cp !== char) index++; // Skip trailing surrogate
        last = index += 1;
    }
    if (out === undefined) return input;
    if (last < length) out += input.substr(last);
    return out;
}
const $83515478df2b4ed4$export$4e7f196112fea3c5 = $83515478df2b4ed4$export$18855ec5be97da16;
/**
 * Escape `data` using `re`, mapping each matched character to its entity.
 * Every match is one UTF-16 code unit, so its index is `lastIndex - 1`.
 * @param re Global regex matching exactly the characters to escape
 *   (`"`, `&`, `'`, `<`, `>`, `\u00A0` at most).
 * @param data String to escape.
 */ function $83515478df2b4ed4$var$escapeWithRegex(re, data) {
    re.lastIndex = 0;
    if (!re.test(data)) return data;
    let out = "";
    let last = 0;
    do {
        const index = re.lastIndex - 1;
        if (last !== index) out += data.substring(last, index);
        const char = data.charCodeAt(index);
        out += $83515478df2b4ed4$var$getEscape(char);
        last = index + 1;
    }while (re.test(data));
    return out + data.substring(last);
}
const $83515478df2b4ed4$var$xmlEscapeRegex = /["&'<>]/g;
function $83515478df2b4ed4$export$9e081872deefdcb0(data) {
    return $83515478df2b4ed4$var$escapeWithRegex($83515478df2b4ed4$var$xmlEscapeRegex, data);
}
const $83515478df2b4ed4$var$attributeEscapeRegex = /["&\u{A0}]/gu;
function $83515478df2b4ed4$export$30330f3d5eb70e11(data) {
    return $83515478df2b4ed4$var$escapeWithRegex($83515478df2b4ed4$var$attributeEscapeRegex, data);
}
const $83515478df2b4ed4$var$textEscapeRegex = /[&<>\u{A0}]/gu;
function $83515478df2b4ed4$export$96e6fc3a139b2555(data) {
    return $83515478df2b4ed4$var$escapeWithRegex($83515478df2b4ed4$var$textEscapeRegex, data);
}


// Generated using scripts/write-encode-map.ts
var $3f16c4113f35328a$export$2e2bcd8739ae039 = "9Tab;NewLine;22excl;quot;num;dollar;percnt;amp;apos;lpar;rpar;ast;plus;comma;1period;sol;10colon;semi;lt;{8402nvlt;}equals;{8421bne;}gt;{8402nvgt;}quest;commat;26lbrack;bsol;rbrack;Hat;lowbar;DiacriticalGrave;5{106fjlig;}20lbrace;verbar;rbrace;34nbsp;iexcl;cent;pound;curren;yen;brvbar;sect;die;copy;ordf;laquo;not;shy;circledR;macr;deg;PlusMinus;sup2;sup3;acute;micro;para;centerdot;cedil;sup1;ordm;raquo;frac14;frac12;frac34;iquest;Agrave;Aacute;Acirc;Atilde;Auml;angst;AElig;Ccedil;Egrave;Eacute;Ecirc;Euml;Igrave;Iacute;Icirc;Iuml;ETH;Ntilde;Ograve;Oacute;Ocirc;Otilde;Ouml;times;Oslash;Ugrave;Uacute;Ucirc;Uuml;Yacute;THORN;szlig;agrave;aacute;acirc;atilde;auml;aring;aelig;ccedil;egrave;eacute;ecirc;euml;igrave;iacute;icirc;iuml;eth;ntilde;ograve;oacute;ocirc;otilde;ouml;div;oslash;ugrave;uacute;ucirc;uuml;yacute;thorn;yuml;Amacr;amacr;Abreve;abreve;Aogon;aogon;Cacute;cacute;Ccirc;ccirc;Cdot;cdot;Ccaron;ccaron;Dcaron;dcaron;Dstrok;dstrok;Emacr;emacr;2Edot;edot;Eogon;eogon;Ecaron;ecaron;Gcirc;gcirc;Gbreve;gbreve;Gdot;gdot;Gcedil;1Hcirc;hcirc;Hstrok;hstrok;Itilde;itilde;Imacr;imacr;2Iogon;iogon;Idot;imath;IJlig;ijlig;Jcirc;jcirc;Kcedil;kcedil;kgreen;Lacute;lacute;Lcedil;lcedil;Lcaron;lcaron;Lmidot;lmidot;Lstrok;lstrok;Nacute;nacute;Ncedil;ncedil;Ncaron;ncaron;napos;ENG;eng;Omacr;omacr;2Odblac;odblac;OElig;oelig;Racute;racute;Rcedil;rcedil;Rcaron;rcaron;Sacute;sacute;Scirc;scirc;Scedil;scedil;Scaron;scaron;Tcedil;tcedil;Tcaron;tcaron;Tstrok;tstrok;Utilde;utilde;Umacr;umacr;Ubreve;ubreve;Uring;uring;Udblac;udblac;Uogon;uogon;Wcirc;wcirc;Ycirc;ycirc;Yuml;Zacute;zacute;Zdot;zdot;Zcaron;zcaron;19fnof;34imped;63gacute;65jmath;142circ;caron;16breve;DiacriticalDot;ring;ogon;DiacriticalTilde;dblac;51DownBreve;127Alpha;Beta;Gamma;Delta;Epsilon;Zeta;Eta;Theta;Iota;Kappa;Lambda;Mu;Nu;Xi;Omicron;Pi;Rho;1Sigma;Tau;Upsilon;Phi;Chi;Psi;ohm;7alpha;beta;gamma;delta;epsi;zeta;eta;theta;iota;kappa;lambda;mu;nu;xi;omicron;pi;rho;sigmaf;sigma;tau;upsi;phi;chi;psi;omega;7thetasym;Upsi;2phiv;piv;5Gammad;digamma;18kappav;rhov;3epsiv;backepsilon;10IOcy;DJcy;GJcy;Jukcy;DScy;Iukcy;YIcy;Jsercy;LJcy;NJcy;TSHcy;KJcy;1Ubrcy;DZcy;Acy;Bcy;Vcy;Gcy;Dcy;IEcy;ZHcy;Zcy;Icy;Jcy;Kcy;Lcy;Mcy;Ncy;Ocy;Pcy;Rcy;Scy;Tcy;Ucy;Fcy;KHcy;TScy;CHcy;SHcy;SHCHcy;HARDcy;Ycy;SOFTcy;Ecy;YUcy;YAcy;acy;bcy;vcy;gcy;dcy;iecy;zhcy;zcy;icy;jcy;kcy;lcy;mcy;ncy;ocy;pcy;rcy;scy;tcy;ucy;fcy;khcy;tscy;chcy;shcy;shchcy;hardcy;ycy;softcy;ecy;yucy;yacy;1iocy;djcy;gjcy;jukcy;dscy;iukcy;yicy;jsercy;ljcy;njcy;tshcy;kjcy;1ubrcy;dzcy;7074ensp;emsp;emsp13;emsp14;1numsp;puncsp;ThinSpace;hairsp;NegativeMediumSpace;zwnj;zwj;lrm;rlm;dash;2ndash;mdash;horbar;Verbar;1lsquo;CloseCurlyQuote;lsquor;1ldquo;CloseCurlyDoubleQuote;bdquo;1dagger;Dagger;bull;2nldr;hellip;9permil;pertenk;prime;Prime;tprime;backprime;3lsaquo;rsaquo;3oline;2caret;1hybull;frasl;10bsemi;7qprime;7MediumSpace;{8202ThickSpace;}NoBreak;af;InvisibleTimes;ic;72euro;46tdot;DotDot;37complexes;2incare;4gscr;hamilt;Hfr;Hopf;planckh;hbar;imagline;Ifr;lagran;ell;1naturals;numero;copysr;weierp;Popf;Qopf;realine;real;reals;rx;3trade;1integers;2mho;zeetrf;iiota;2bernou;Cayleys;1escr;Escr;Fouriertrf;1Mellintrf;order;alefsym;beth;gimel;daleth;12CapitalDifferentialD;dd;ee;ii;10frac13;frac23;frac15;frac25;frac35;frac45;frac16;frac56;frac18;frac38;frac58;frac78;49larr;ShortUpArrow;rarr;darr;harr;updownarrow;nwarr;nearr;LowerRightArrow;LowerLeftArrow;nlarr;nrarr;1rarrw;{824nrarrw;}Larr;Uarr;Rarr;Darr;larrtl;rarrtl;LeftTeeArrow;mapstoup;map;DownTeeArrow;1hookleftarrow;hookrightarrow;larrlp;looparrowright;harrw;nharr;1lsh;rsh;ldsh;rdsh;1crarr;cularr;curarr;2circlearrowleft;circlearrowright;leftharpoonup;DownLeftVector;RightUpVector;LeftUpVector;rharu;DownRightVector;dharr;dharl;RightArrowLeftArrow;udarr;LeftArrowRightArrow;leftleftarrows;upuparrows;rightrightarrows;ddarr;leftrightharpoons;Equilibrium;nlArr;nhArr;nrArr;DoubleLeftArrow;DoubleUpArrow;DoubleRightArrow;dArr;DoubleLeftRightArrow;DoubleUpDownArrow;nwArr;neArr;seArr;swArr;lAarr;rAarr;1zigrarr;6larrb;rarrb;15DownArrowUpArrow;7loarr;roarr;hoarr;forall;comp;part;{824npart;}exist;nexist;empty;1Del;Element;NotElement;1ni;notni;2prod;coprod;sum;minus;MinusPlus;dotplus;1Backslash;lowast;compfn;1radic;2prop;infin;angrt;ang;{8402nang;}angmsd;angsph;mid;nmid;DoubleVerticalBar;NotDoubleVerticalBar;and;or;cap;{65024caps;}cup;{65024cups;}int;Int;iiint;conint;Conint;Cconint;cwint;ClockwiseContourIntegral;awconint;there4;becaus;ratio;Colon;dotminus;1mDDot;homtht;sim;{8402nvsim;}backsim;{817race;}ac;{819acE;}acd;VerticalTilde;NotTilde;eqsim;{824nesim;}sime;NotTildeEqual;cong;simne;ncong;ap;nap;ape;apid;{824napid;}backcong;asympeq;{8402nvap;}bump;{824nbump;}bumpe;{824nbumpe;}doteq;{824nedot;}doteqdot;efDot;erDot;Assign;ecolon;ecir;circeq;1wedgeq;veeeq;1triangleq;2equest;ne;Congruent;{8421bnequiv;}nequiv;1le;{8402nvle;}ge;{8402nvge;}lE;{824nlE;}gE;{824ngE;}lnE;{65024lvertneqq;}gnE;{65024gvertneqq;}ll;{824nLtv;7577nLt;}gg;{824nGtv;7577nGt;}between;NotCupCap;nless;ngt;nle;nge;lesssim;GreaterTilde;nlsim;ngsim;LessGreater;gl;NotLessGreater;NotGreaterLess;pr;sc;prcue;sccue;PrecedesTilde;scsim;{824NotSucceedsTilde;}NotPrecedes;NotSucceeds;sub;{8402NotSubset;}sup;{8402NotSuperset;}nsub;nsup;sube;supe;NotSubsetEqual;NotSupersetEqual;subne;{65024varsubsetneq;}supne;{65024varsupsetneq;}1cupdot;UnionPlus;sqsub;{824NotSquareSubset;}sqsup;{824NotSquareSuperset;}sqsube;sqsupe;sqcap;{65024sqcaps;}sqcup;{65024sqcups;}CirclePlus;CircleMinus;CircleTimes;osol;CircleDot;circledcirc;circledast;1circleddash;boxplus;boxminus;boxtimes;dotsquare;RightTee;dashv;DownTee;bot;1models;DoubleRightTee;Vdash;Vvdash;VDash;nvdash;nvDash;nVdash;nVDash;prurel;1LeftTriangle;RightTriangle;LeftTriangleEqual;{8402nvltrie;}RightTriangleEqual;{8402nvrtrie;}origof;imof;multimap;hercon;intcal;veebar;1barvee;angrtvb;lrtri;bigwedge;bigvee;bigcap;bigcup;diam;sdot;sstarf;divideontimes;bowtie;ltimes;rtimes;leftthreetimes;rightthreetimes;backsimeq;curlyvee;curlywedge;Sub;Sup;Cap;Cup;fork;epar;lessdot;gtdot;Ll;{824nLl;}Gg;{824nGg;}leg;{65024lesg;}gel;{65024gesl;}2cuepr;cuesc;NotPrecedesSlantEqual;NotSucceedsSlantEqual;NotSquareSubsetEqual;NotSquareSupersetEqual;2lnsim;gnsim;precnsim;scnsim;nltri;NotRightTriangle;nltrie;NotRightTriangleEqual;vellip;ctdot;utdot;dtdot;disin;isinsv;isins;isindot;{824notindot;}notinvc;notinvb;1isinE;{824notinE;}nisd;xnis;nis;notnivc;notnivb;6barwed;Barwed;1lceil;rceil;LeftFloor;rfloor;drcrop;dlcrop;urcrop;ulcrop;bnot;1profline;profsurf;1telrec;target;5ulcorn;urcorn;dlcorn;drcorn;2frown;smile;9cylcty;profalar;7topbot;6ovbar;1solbar;60angzarr;51lmoustache;rmoustache;2OverBracket;bbrk;bbrktbrk;37OverParenthesis;UnderParenthesis;OverBrace;UnderBrace;2trpezium;4elinters;59blank;164circledS;55boxh;1boxv;9boxdr;3boxdl;3boxur;3boxul;3boxvr;7boxvl;7boxhd;7boxhu;7boxvh;19boxH;boxV;boxdR;boxDr;boxDR;boxdL;boxDl;boxDL;boxuR;boxUr;boxUR;boxuL;boxUl;boxUL;boxvR;boxVr;boxVR;boxvL;boxVl;boxVL;boxHd;boxhD;boxHD;boxHu;boxhU;boxHU;boxvH;boxVh;boxVH;19uhblk;3lhblk;3block;8blk14;blk12;blk34;13square;8blacksquare;EmptyVerySmallSquare;1rect;marker;2fltns;1bigtriangleup;blacktriangle;triangle;2blacktriangleright;rtri;3bigtriangledown;blacktriangledown;dtri;2blacktriangleleft;ltri;6loz;cir;32tridot;2bigcirc;8ultri;urtri;lltri;EmptySmallSquare;FilledSmallSquare;8bigstar;star;7phone;49female;1male;29spades;2clubs;1hearts;diamondsuit;3sung;2flat;natural;sharp;163check;3cross;8malt;21sext;33VerticalSeparator;25lbbrk;rbbrk;84bsolhsub;suphsol;28LeftDoubleBracket;RightDoubleBracket;lang;rang;Lang;Rang;loang;roang;7longleftarrow;longrightarrow;longleftrightarrow;DoubleLongLeftArrow;DoubleLongRightArrow;DoubleLongLeftRightArrow;1longmapsto;2dzigrarr;258nvlArr;nvrArr;nvHarr;Map;6lbarr;bkarow;lBarr;dbkarow;drbkarow;DDotrahd;UpArrowBar;DownArrowBar;2Rarrtl;2latail;ratail;lAtail;rAtail;larrfs;rarrfs;larrbfs;rarrbfs;2nwarhk;nearhk;hksearow;hkswarow;nwnear;nesear;seswar;swnwar;8rarrc;{824nrarrc;}1cudarrr;ldca;rdca;cudarrl;larrpl;2curarrm;cularrp;7rarrpl;2harrcir;Uarrocir;lurdshar;ldrushar;2LeftRightVector;RightUpDownVector;DownLeftRightVector;LeftUpDownVector;LeftVectorBar;RightVectorBar;RightUpVectorBar;RightDownVectorBar;DownLeftVectorBar;DownRightVectorBar;LeftUpVectorBar;LeftDownVectorBar;LeftTeeVector;RightTeeVector;RightUpTeeVector;RightDownTeeVector;DownLeftTeeVector;DownRightTeeVector;LeftUpTeeVector;LeftDownTeeVector;lHar;uHar;rHar;dHar;luruhar;ldrdhar;ruluhar;rdldhar;lharul;llhard;rharul;lrhard;udhar;duhar;RoundImplies;erarr;simrarr;larrsim;rarrsim;rarrap;ltlarr;1gtrarr;subrarr;1suplarr;lfisht;rfisht;ufisht;dfisht;5lopar;ropar;4lbrke;rbrke;lbrkslu;rbrksld;lbrksld;rbrkslu;langd;rangd;lparlt;rpargt;gtlPar;ltrPar;3vzigzag;1vangrt;angrtvbd;6ange;range;dwangle;uwangle;angmsdaa;angmsdab;angmsdac;angmsdad;angmsdae;angmsdaf;angmsdag;angmsdah;bemptyv;demptyv;cemptyv;raemptyv;laemptyv;ohbar;omid;opar;1operp;1olcross;odsold;1olcir;ofcir;olt;ogt;cirscir;cirE;solb;bsolb;3boxbox;3trisb;rtriltri;LeftTriangleBar;{824NotLeftTriangleBar;}RightTriangleBar;{824NotRightTriangleBar;}11iinfin;infintie;nvinfin;4eparsl;smeparsl;eqvparsl;5blacklozenge;8RuleDelayed;1dsol;9bigodot;bigoplus;bigotimes;1biguplus;1bigsqcup;5iiiint;fpartint;2cirfnint;awint;rppolint;scpolint;npolint;pointint;quatint;intlarhk;10pluscir;plusacir;simplus;plusdu;plussim;plustwo;1mcomma;minusdu;2loplus;roplus;Cross;timesd;timesbar;1smashp;lotimes;rotimes;otimesas;Otimes;odiv;triplus;triminus;tritime;intprod;2amalg;capdot;1ncup;ncap;capand;cupor;cupcap;capcup;cupbrcap;capbrcup;cupcup;capcap;ccups;ccaps;2ccupssm;2And;Or;andand;oror;orslope;andslope;1andv;orv;andd;ord;1wedbar;6sdote;3simdot;2congdot;{824ncongdot;}easter;apacir;apE;{824napE;}eplus;pluse;Esim;Colone;Equal;1ddotseq;equivDD;ltcir;gtcir;ltquest;gtquest;leqslant;{824nleqslant;}geqslant;{824ngeqslant;}lesdot;gesdot;lesdoto;gesdoto;lesdotor;gesdotol;lap;gap;lne;gne;lnap;gnap;lEg;gEl;lsime;gsime;lsimg;gsiml;lgE;glE;lesges;gesles;els;egs;elsdot;egsdot;el;eg;2siml;simg;simlE;simgE;LessLess;{824NotNestedLessLess;}GreaterGreater;{824NotNestedGreaterGreater;}1glj;gla;ltcc;gtcc;lescc;gescc;smt;lat;smte;{65024smtes;}late;{65024lates;}bumpE;PrecedesEqual;{824NotPrecedesEqual;}sce;{824NotSucceedsEqual;}2prE;scE;precneqq;scnE;prap;scap;precnapprox;scnap;Pr;Sc;subdot;supdot;subplus;supplus;submult;supmult;subedot;supedot;subE;{824nsubE;}supE;{824nsupE;}subsim;supsim;2subnE;{65024varsubsetneqq;}supnE;{65024varsupsetneqq;}2csub;csup;csube;csupe;subsup;supsub;subsub;supsup;suphsub;supdsub;forkv;topfork;mlcp;8Dashv;1Vdashl;Barv;vBar;vBarv;1Vbar;Not;bNot;rnmid;cirmid;midcir;topcir;nhpar;parsim;9parsl;{8421nparsl;}53250fflig;filig;fllig;ffilig;ffllig;55703Ascr;1Cscr;Dscr;2Gscr;2Jscr;Kscr;2Nscr;Oscr;Pscr;Qscr;1Sscr;Tscr;Uscr;Vscr;Wscr;Xscr;Yscr;Zscr;ascr;bscr;cscr;dscr;1fscr;1hscr;iscr;jscr;kscr;lscr;mscr;nscr;1pscr;qscr;rscr;sscr;tscr;uscr;vscr;wscr;xscr;yscr;zscr;52Afr;Bfr;1Dfr;Efr;Ffr;Gfr;2Jfr;Kfr;Lfr;Mfr;Nfr;Ofr;Pfr;Qfr;1Sfr;Tfr;Ufr;Vfr;Wfr;Xfr;Yfr;1afr;bfr;cfr;dfr;efr;ffr;gfr;hfr;ifr;jfr;kfr;lfr;mfr;nfr;ofr;pfr;qfr;rfr;sfr;tfr;ufr;vfr;wfr;xfr;yfr;zfr;Aopf;Bopf;1Dopf;Eopf;Fopf;Gopf;1Iopf;Jopf;Kopf;Lopf;Mopf;1Oopf;3Sopf;Topf;Uopf;Vopf;Wopf;Xopf;Yopf;1aopf;bopf;copf;dopf;eopf;fopf;gopf;hopf;iopf;jopf;kopf;lopf;mopf;nopf;oopf;popf;qopf;ropf;sopf;topf;uopf;vopf;wopf;xopf;yopf;zopf;";


/**
 * Flat lookup table for ASCII entity values (code points 0–127).
 *
 * Built once at startup from the full trie.  For ASCII characters that need
 * encoding, a direct `asciiEntities[charCode]` array index is much faster
 * than `Map.get(charCode)` because it avoids hashing and bucket lookup.
 *
 * A few ASCII characters also start multi-code-point entities
 * (e.g. `<` + U+20D2 → `&nvlt;`).  For those, the table holds the branch
 * node itself (children plus the single-char value), so the ASCII path
 * never consults `htmlTrie`.
 */ const $1abbb14f55c58211$var$asciiEntities = /* #__PURE__ */ Array.from({
    length: 128
}, ()=>null);
const $1abbb14f55c58211$var$htmlTrie = (()=>{
    /**
     * Parse a compact encode trie string into a Map keyed by code point.
     *
     * The serialized format (produced by `scripts/write-encode-map.ts`) stores
     * entries in ascending code-point order with delta encoding:
     *
     *   [gap]name;[{children}]
     *
     * - `gap` is a base-10 integer giving `currentKey - previousKey - 1`.
     *   The very first entry stores the absolute key.  A gap of 0 is omitted.
     * - `name;` is the entity name (without `&` prefix) terminated by `;`.
     *   Because gaps use only digits `[0-9]` and entity names always start with
     *   a letter `[A-Za-z]`, no additional delimiter is needed.
     * - `{…}` is an optional children block using the same scheme recursively.
     *   Children represent the second code unit of multi-character entities
     *   (e.g. `<` + U+20D2 → `&nvlt;`).
     */ const trie = new Map();
    const data = (0, $3f16c4113f35328a$export$2e2bcd8739ae039);
    let cursor = 0;
    let lastKey = -1;
    function readGap() {
        let value = 0;
        let ch;
        while((ch = data.charCodeAt(cursor)) >= 48 /* '0' */  && ch <= 57 /* '9' */ ){
            value = value * 10 + ch - 48;
            cursor++;
        }
        return value;
    }
    function readEntity() {
        const semi = data.indexOf(";", cursor);
        const entity = `&${data.substring(cursor, semi)};`;
        cursor = semi + 1;
        return entity;
    }
    const astralEntries = [];
    while(cursor < data.length){
        lastKey += readGap() + 1;
        const entityValue = data.charCodeAt(cursor) === 123 /* '{' */  ? null : readEntity();
        if (data.charCodeAt(cursor) === 123 /* '{' */ ) {
            cursor++; // Skip '{'
            const next = new Map();
            let childKey = -1;
            while(data.charCodeAt(cursor) !== 125 /* '}' */ ){
                childKey += readGap() + 1;
                next.set(childKey, readEntity());
            }
            const branch = {
                value: entityValue,
                next: next
            };
            trie.set(lastKey, branch);
            cursor++; // Skip '}'
            // ASCII fast path holds the branch node itself (children + value).
            if (lastKey < 0x80) $1abbb14f55c58211$var$asciiEntities[lastKey] = branch;
        } else if (lastKey < 0x80) $1abbb14f55c58211$var$asciiEntities[lastKey] = entityValue;
        else if (lastKey > 0xffff) astralEntries.push([
            lastKey,
            entityValue
        ]);
        else trie.set(lastKey, entityValue);
    }
    /*
     * Batch-insert astral entries as surrogate-pair trie nodes.
     * Entries are sorted by code point, so same-high-surrogate groups
     * are contiguous — no intermediate grouping Map needed.
     */ let astralIndex = 0;
    while(astralIndex < astralEntries.length){
        const hi = 0xd800 | astralEntries[astralIndex][0] - 0x10000 >> 10;
        const children = [];
        while(astralIndex < astralEntries.length && (0xd800 | astralEntries[astralIndex][0] - 0x10000 >> 10) === hi){
            const lo = 0xdc00 | astralEntries[astralIndex][0] - 0x10000 & 0x3ff;
            children.push([
                lo,
                astralEntries[astralIndex][1]
            ]);
            astralIndex++;
        }
        trie.set(hi, {
            value: null,
            next: new Map(children)
        });
    }
    return trie;
})();
/**
 * Bitset covering ASCII code points 0–127.  Each of the four 32-bit words
 * covers a 32-code-point range.  A set bit means "this character needs
 * encoding" when used with `encodeHTML`.
 */ const $1abbb14f55c58211$var$HTML_BITSET = /* #__PURE__ */ new Uint32Array([
    0x1600,
    0xfc00fffe,
    0xf8000001,
    0x38000001
]);
const $1abbb14f55c58211$var$XML_BITSET = /* #__PURE__ */ new Uint32Array([
    0,
    (0, $83515478df2b4ed4$export$7f1fd439cded3de1),
    0,
    0
]);
/*
 * Regex equivalent of `HTML_BITSET` (plus all non-ASCII code units, lone
 * surrogates included — no `u` flag). Must stay in sync with the bitset:
 * the scan uses the regex to find candidates and the bitset to re-check
 * adjacent characters. The XML equivalent is `xmlEncodeRegex`, shared with
 * `escape.ts`.
 */ // eslint-disable-next-line unicorn/prefer-unicode-code-point-escapes -- the `\u{...}` form requires the `u` flag, which we deliberately omit so lone surrogates match by code unit
const $1abbb14f55c58211$var$HTML_ENCODE_RE = /[\t\n\f!-/:-@[-`{-}\u0080-\uFFFF]/g;
const $1abbb14f55c58211$var$numericReference = (cp)=>`&#x${cp.toString(16)};`;
function $1abbb14f55c58211$export$f9d6449b9af28dc1(input) {
    return $1abbb14f55c58211$var$encodeHTMLTrieRe($1abbb14f55c58211$var$HTML_BITSET, $1abbb14f55c58211$var$HTML_ENCODE_RE, input);
}
function $1abbb14f55c58211$export$e6e86c76506f1190(input) {
    return $1abbb14f55c58211$var$encodeHTMLTrieRe($1abbb14f55c58211$var$XML_BITSET, (0, $83515478df2b4ed4$export$19d407bfdd0b8a57), input);
}
/**
 * Whether `code` (a UTF-16 code unit) must be encoded: any non-ASCII unit, or
 * an ASCII unit flagged in `bitset`.
 * @param bitset Bitset of ASCII characters to encode.
 * @param code Code unit to test.
 */ function $1abbb14f55c58211$var$isEncodable(bitset, code) {
    return code >= 0x80 || (bitset[code >>> 5] >>> code & 1) === 1;
}
const $1abbb14f55c58211$export$5b5514974877e801 = 16;
const $1abbb14f55c58211$var$LONG_GAP_THRESHOLD = 8;
function $1abbb14f55c58211$var$encodeHTMLTrieRe(bitset, re, input) {
    const { length: length } = input;
    let out;
    let last = 0; // Start of the next untouched slice.
    let index = 0;
    let wasLongGap = false; // The previous gap was long; skip the inline scan.
    while(index < length){
        let char = input.charCodeAt(index);
        /*
         * Find the next encodable character (one matching `bitset`, or any
         * non-ASCII unit). Gaps between entities in dense text are only a
         * few characters, so scan a short window inline first; the regex —
         * which matches exactly the same characters and skips clean spans
         * in native code — runs for longer gaps. Gap lengths cluster, so
         * after a window-exhausting gap the window is skipped until a gap
         * shorter than LONG_GAP_THRESHOLD reappears. Once located, the
         * character is captured in `char` and control falls through to the
         * encode logic below instead of re-testing it on the next loop
         * iteration.
         */ if (!$1abbb14f55c58211$var$isEncodable(bitset, char)) {
            const gapStart = index;
            let next = index + 1;
            let wasFound = false;
            if (!wasLongGap) {
                const bound = Math.min(index + $1abbb14f55c58211$export$5b5514974877e801, length);
                while(next < bound && !$1abbb14f55c58211$var$isEncodable(bitset, char = input.charCodeAt(next)))next++;
                if (next < bound) {
                    // `char` already holds the encodable unit at `next`.
                    index = next;
                    wasFound = true;
                } else if (next >= length) break;
            }
            if (!wasFound) {
                /*
                 * Every match is a single code unit, so `test` pins it at
                 * `lastIndex - 1` without allocating a match object.
                 */ re.lastIndex = next;
                if (!re.test(input)) break;
                index = re.lastIndex - 1;
                /*
                 * Reaching the regex from the inline scan means the gap
                 * exhausted the window, so it is long by definition; once
                 * in long-gap mode, stay until a gap shorter than the
                 * threshold appears.
                 */ wasLongGap = !wasLongGap || index - gapStart >= $1abbb14f55c58211$var$LONG_GAP_THRESHOLD;
                char = input.charCodeAt(index);
            }
        }
        // Lazy-init: copy the prefix before the first character that needs encoding.
        if (out == null) out = input.substring(0, index);
        else if (last !== index) out += input.substring(last, index);
        if (char < 0x80) {
            const node = $1abbb14f55c58211$var$asciiEntities[char];
            if (typeof node === "object" && node !== null) {
                // Multi-code-point entity first (e.g. < + U+20D2 → &nvlt;).
                if (index + 1 < length) {
                    const value = node.next.get(input.charCodeAt(index + 1));
                    if (value != null) {
                        out += value;
                        last = index += 2;
                        continue;
                    }
                }
                out += node.value ?? $1abbb14f55c58211$var$numericReference(char);
            } else out += node ?? $1abbb14f55c58211$var$numericReference(char);
        } else {
            // Non-ASCII: full trie lookup with multi-char entity support.
            let node = $1abbb14f55c58211$var$htmlTrie.get(char);
            if (typeof node === "object") {
                if (index + 1 < length) {
                    const value = node.next.get(input.charCodeAt(index + 1));
                    if (value != null) {
                        out += value;
                        last = index += 2;
                        continue;
                    }
                }
                node = node.value;
            }
            if (node == null) {
                // No named entity exists; emit a hexadecimal numeric reference.
                const cp = input.codePointAt(index);
                out += $1abbb14f55c58211$var$numericReference(cp);
                // Astral code points consume two UTF-16 code units.
                if (cp !== char) index++;
            } else out += node;
        }
        last = index += 1;
    }
    // If nothing needed encoding, return the original string (avoids allocation).
    if (out == null) return input;
    if (last < length) out += input.substr(last);
    return out;
}



var $3f24d79fc1acff48$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($3f24d79fc1acff48$export$b8c86583d9718b50 || ($3f24d79fc1acff48$export$b8c86583d9718b50 = {}));
var $3f24d79fc1acff48$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($3f24d79fc1acff48$export$1851b20d614eb756 || ($3f24d79fc1acff48$export$1851b20d614eb756 = {}));
function $3f24d79fc1acff48$export$2f872c0f2117be69(input, options = $3f24d79fc1acff48$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $3f24d79fc1acff48$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $d7032f3974c45172$export$f045cb747ce77a19)(input, mode);
    }
    return (0, $d7032f3974c45172$export$88e3b9643a8bd06e)(input);
}
function $3f24d79fc1acff48$export$c564cdbbe6da493(input, options = $3f24d79fc1acff48$export$b8c86583d9718b50.XML) {
    const { mode: mode = $3f24d79fc1acff48$export$1851b20d614eb756.Extensive, level: level = $3f24d79fc1acff48$export$b8c86583d9718b50.XML } = typeof options === "number" ? {
        level: options
    } : options;
    switch(mode){
        case $3f24d79fc1acff48$export$1851b20d614eb756.UTF8:
            return (0, $83515478df2b4ed4$export$9e081872deefdcb0)(input);
        case $3f24d79fc1acff48$export$1851b20d614eb756.Attribute:
            return (0, $83515478df2b4ed4$export$30330f3d5eb70e11)(input);
        case $3f24d79fc1acff48$export$1851b20d614eb756.Text:
            return (0, $83515478df2b4ed4$export$96e6fc3a139b2555)(input);
        case $3f24d79fc1acff48$export$1851b20d614eb756.ASCII:
            return (level === $3f24d79fc1acff48$export$b8c86583d9718b50.HTML ? (0, $1abbb14f55c58211$export$e6e86c76506f1190) : (0, $83515478df2b4ed4$export$18855ec5be97da16))(input);
        // biome-ignore lint/complexity/noUselessSwitchCase: we get an error for the switch not being exhaustive
        case $3f24d79fc1acff48$export$1851b20d614eb756.Extensive:
        default:
            return (level === $3f24d79fc1acff48$export$b8c86583d9718b50.HTML ? (0, $1abbb14f55c58211$export$f9d6449b9af28dc1) : (0, $83515478df2b4ed4$export$18855ec5be97da16))(input);
    }
}


/**
 * Mixed-case SVG and MathML element names recognized in foreign content.
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */ const $7ac172e348b55fd9$export$82b917442d249e05 = new Map("altGlyph altGlyphDef altGlyphItem animateColor animateMotion animateTransform clipPath feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feDropShadow feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence foreignObject glyphRef linearGradient radialGradient textPath".split(" ").map((name)=>[
        name.toLowerCase(),
        name
    ]));
const $7ac172e348b55fd9$export$b4cfbfd90280b005 = new Map("definitionURL attributeName attributeType baseFrequency baseProfile calcMode clipPathUnits diffuseConstant edgeMode filterUnits glyphRef gradientTransform gradientUnits kernelMatrix kernelUnitLength keyPoints keySplines keyTimes lengthAdjust limitingConeAngle markerHeight markerUnits markerWidth maskContentUnits maskUnits numOctaves pathLength patternContentUnits patternTransform patternUnits pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits refX refY repeatCount repeatDur requiredExtensions requiredFeatures specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles surfaceScale systemLanguage tableValues targetX targetY textLength viewBox viewTarget xChannelSelector yChannelSelector zoomAndPan".split(" ").map((name)=>[
        name.toLowerCase(),
        name
    ]));


// ── Constants ────────────────────────────────────────────────────────
/** Elements whose text content is never entity-encoded. */ const $975cb0c9db0d97ec$var$unencodedElements = new Set("style script xmp iframe noembed noframes plaintext noscript".split(" "));
/** HTML void elements — they cannot have children. */ const $975cb0c9db0d97ec$var$voidElements = new Set("area base basefont br col command embed frame hr img input isindex keygen link meta param source track wbr".split(" "));
/** Elements that switch the parser into foreign (XML-like) mode. */ const $975cb0c9db0d97ec$var$foreignElements = new Set([
    "svg",
    "math"
]);
/**
 * Foreign-mode integration points: children of these elements are parsed
 * as HTML again, not as foreign content.
 */ const $975cb0c9db0d97ec$var$foreignModeIntegrationPoints = new Set("mi mo mn ms mtext annotation-xml foreignObject desc title".split(" "));
function $975cb0c9db0d97ec$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    /*
     * `xmlMode` is threaded as a separate argument through the internal
     * functions so that foreign-mode transitions (svg/mathml ↔ html) can
     * adjust it without copying the options object on every element.
     */ const xmlMode = options.xmlMode ?? false;
    let output = "";
    // eslint-disable-next-line unicorn/no-for-loop
    for(let index = 0; index < nodes.length; index++)output += $975cb0c9db0d97ec$var$renderNode(nodes[index], options, xmlMode);
    return output;
}
var $975cb0c9db0d97ec$export$2e2bcd8739ae039 = $975cb0c9db0d97ec$export$b3890eb0ae9dca99;
// ── Internal rendering ───────────────────────────────────────────────
/**
 * Render an array of child nodes (skips the single-node wrapping in `render`).
 * @param children The child nodes to render.
 * @param options The serialization options.
 * @param xmlMode The XML mode to use.
 */ function $975cb0c9db0d97ec$var$renderChildren(children, options, xmlMode) {
    let output = "";
    // eslint-disable-next-line unicorn/no-for-loop
    for(let index = 0; index < children.length; index++)output += $975cb0c9db0d97ec$var$renderNode(children[index], options, xmlMode);
    return output;
}
function $975cb0c9db0d97ec$var$renderNode(node, options, xmlMode) {
    switch(node.type){
        case $96358bb576046356$export$be92b6f5f03c0fe9:
            return $975cb0c9db0d97ec$var$renderChildren(node.children, options, xmlMode);
        case $96358bb576046356$export$befdefbdce210f91:
            return `<${node.data}>`;
        case $96358bb576046356$export$4d299b491347818a:
            return `<!--${node.data}-->`;
        case $96358bb576046356$export$1f8b8f7e5c763232:
            return `<![CDATA[${node.children[0].data}]]>`;
        case $96358bb576046356$export$2f8b47a141e57afc:
        case $96358bb576046356$export$d9e45bc13d335801:
        case $96358bb576046356$export$3288d34c523a1192:
            return $975cb0c9db0d97ec$var$renderTag(node, options, xmlMode);
        case $96358bb576046356$export$5f1af8db9871e1d6:
            {
                const element = node;
                const data = element.data || "";
                /*
             * Skip encoding when entities weren't decoded on input, or when
             * inside a raw-text element (script, style, etc.) in HTML mode.
             */ if ((options.encodeEntities ?? options.decodeEntities) !== false && !(!xmlMode && element.parent && $975cb0c9db0d97ec$var$unencodedElements.has(element.parent.name))) // `xmlMode: "foreign"` is truthy
                return xmlMode || options.encodeEntities !== "utf8" ? (0, $83515478df2b4ed4$export$18855ec5be97da16)(data) : (0, $83515478df2b4ed4$export$96e6fc3a139b2555)(data);
                return data;
            }
    }
}
function $975cb0c9db0d97ec$var$renderTag(element, options, xmlMode) {
    if (xmlMode === "foreign") {
        // Correct lowercase element names back to their canonical mixed-case form
        element.name = (0, $7ac172e348b55fd9$export$82b917442d249e05).get(element.name) ?? element.name;
        // Integration points exit foreign mode: their children are HTML
        if (element.parent && $975cb0c9db0d97ec$var$foreignModeIntegrationPoints.has(element.parent.name)) xmlMode = false;
    }
    if (!xmlMode && $975cb0c9db0d97ec$var$foreignElements.has(element.name)) xmlMode = "foreign";
    const { name: name, children: children } = element;
    // Cache the void-element check — used for both self-closing and closing-tag logic
    const isVoid = !xmlMode && $975cb0c9db0d97ec$var$voidElements.has(name);
    let tag = `<${name}${$975cb0c9db0d97ec$var$formatAttributes(element.attribs, options, xmlMode)}`;
    if (children.length === 0 && (xmlMode ? options.selfClosingTags !== false : options.selfClosingTags && isVoid)) // XML: `<br/>`, HTML: `<br />`
    tag += xmlMode ? "/>" : " />";
    else {
        tag += ">";
        if (children.length > 0) tag += $975cb0c9db0d97ec$var$renderChildren(children, options, xmlMode);
        if (!isVoid) tag += `</${name}>`;
    }
    return tag;
}
// ── Attribute formatting ─────────────────────────────────────────────
function $975cb0c9db0d97ec$var$replaceQuotes(value) {
    return value.replaceAll('"', "&quot;");
}
/**
 * Serialize an element's attribute map to a string.
 *
 * Returns a string with a leading space before each attribute, or an
 * empty string if there are no attributes. This convention lets the
 * caller unconditionally concatenate the result onto the tag name.
 * @param attributes
 * @param options
 * @param xmlMode
 */ function $975cb0c9db0d97ec$var$formatAttributes(attributes, options, xmlMode) {
    if (!attributes) return "";
    /*
     * Pick the right encoder:
     *  - Encoding disabled → only escape double-quotes (for valid attributes)
     *  - XML / non-utf8    → full numeric entity encoding (encodeXML)
     *  - HTML + utf8       → minimal escaping (escapeAttribute)
     */ const encode = (options.encodeEntities ?? options.decodeEntities) === false ? $975cb0c9db0d97ec$var$replaceQuotes : xmlMode || options.encodeEntities !== "utf8" ? (0, $83515478df2b4ed4$export$18855ec5be97da16) : (0, $83515478df2b4ed4$export$30330f3d5eb70e11);
    const isForeign = xmlMode === "foreign";
    const showEmpty = !!(options.emptyAttrs ?? xmlMode);
    let result = "";
    for(const key in attributes){
        if (!Object.hasOwn(attributes, key)) continue;
        const value = attributes[key];
        const k = isForeign ? (0, $7ac172e348b55fd9$export$b4cfbfd90280b005).get(key) ?? key : key;
        result += !showEmpty && (value == null || value === "") ? ` ${k}` : ` ${k}="${encode(value == null ? "" : String(value))}"`;
    }
    return result;
}




function $8e79a4aa438e001f$export$39484b727cc2f324(node, options) {
    return (0, $975cb0c9db0d97ec$export$2e2bcd8739ae039)(node, options);
}
function $8e79a4aa438e001f$export$7ed15b4d2218408(node, options) {
    return (0, $057756af47669739$export$bd5ff50f0e53d41c)(node) ? node.children.map((node)=>$8e79a4aa438e001f$export$39484b727cc2f324(node, options)).join("") : "";
}
function $8e79a4aa438e001f$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($8e79a4aa438e001f$export$c72d34660a162238).join("");
    if ((0, $057756af47669739$export$3bf645f08efe3292)(node)) return node.name === "br" ? "\n" : $8e79a4aa438e001f$export$c72d34660a162238(node.children);
    if ((0, $057756af47669739$export$c2d65aed98d39b56)(node)) return $8e79a4aa438e001f$export$c72d34660a162238(node.children);
    if ((0, $057756af47669739$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $8e79a4aa438e001f$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($8e79a4aa438e001f$export$e0e0794250e9118f).join("");
    if ((0, $057756af47669739$export$bd5ff50f0e53d41c)(node) && !(0, $057756af47669739$export$3ab01370f5e64ac8)(node)) return $8e79a4aa438e001f$export$e0e0794250e9118f(node.children);
    if ((0, $057756af47669739$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $8e79a4aa438e001f$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($8e79a4aa438e001f$export$5864bc2a45f1eb81).join("");
    if ((0, $057756af47669739$export$bd5ff50f0e53d41c)(node) && (node.type === (0, $96358bb576046356$export$b992dc138d950e31).Tag || (0, $057756af47669739$export$c2d65aed98d39b56)(node))) return $8e79a4aa438e001f$export$5864bc2a45f1eb81(node.children);
    if ((0, $057756af47669739$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}


function $44a192c9a389cff7$export$ad32138c9e09ad4(document) {
    const feedRoot = $44a192c9a389cff7$var$getOneElement($44a192c9a389cff7$var$isValidFeed, document);
    return feedRoot ? feedRoot.name === "feed" ? $44a192c9a389cff7$var$getAtomFeed(feedRoot) : $44a192c9a389cff7$var$getRssFeed(feedRoot) : null;
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $44a192c9a389cff7$var$getAtomFeed(feedRoot) {
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $2c05bb40cf30e065$export$af941c3c7c3b40f5)("entry", childs).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $44a192c9a389cff7$var$getMediaElements(children)
            };
            $44a192c9a389cff7$var$addConditionally(entry, "id", "id", children);
            $44a192c9a389cff7$var$addConditionally(entry, "title", "title", children);
            const href = $44a192c9a389cff7$var$getOneElement("link", children)?.attribs["href"];
            if (href) entry.link = href;
            const description = $44a192c9a389cff7$var$fetch("summary", children) || $44a192c9a389cff7$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $44a192c9a389cff7$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $44a192c9a389cff7$var$addConditionally(feed, "id", "id", childs);
    $44a192c9a389cff7$var$addConditionally(feed, "title", "title", childs);
    const href = $44a192c9a389cff7$var$getOneElement("link", childs)?.attribs["href"];
    if (href) feed.link = href;
    $44a192c9a389cff7$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $44a192c9a389cff7$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $44a192c9a389cff7$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $44a192c9a389cff7$var$getRssFeed(feedRoot) {
    const childs = $44a192c9a389cff7$var$getOneElement("channel", feedRoot.children)?.children ?? [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $2c05bb40cf30e065$export$af941c3c7c3b40f5)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $44a192c9a389cff7$var$getMediaElements(children)
            };
            $44a192c9a389cff7$var$addConditionally(entry, "id", "guid", children);
            $44a192c9a389cff7$var$addConditionally(entry, "title", "title", children);
            $44a192c9a389cff7$var$addConditionally(entry, "link", "link", children);
            $44a192c9a389cff7$var$addConditionally(entry, "description", "description", children);
            const pubDate = $44a192c9a389cff7$var$fetch("pubDate", children) || $44a192c9a389cff7$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $44a192c9a389cff7$var$addConditionally(feed, "title", "title", childs);
    $44a192c9a389cff7$var$addConditionally(feed, "link", "link", childs);
    $44a192c9a389cff7$var$addConditionally(feed, "description", "description", childs);
    const updated = $44a192c9a389cff7$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $44a192c9a389cff7$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $44a192c9a389cff7$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $44a192c9a389cff7$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $44a192c9a389cff7$var$getMediaElements(where) {
    return (0, $2c05bb40cf30e065$export$af941c3c7c3b40f5)("media:content", where).map((element)=>{
        const { attribs: attribs } = element;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $44a192c9a389cff7$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $44a192c9a389cff7$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = Number.parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $44a192c9a389cff7$var$getOneElement(tagName, node) {
    return (0, $2c05bb40cf30e065$export$af941c3c7c3b40f5)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $44a192c9a389cff7$var$fetch(tagName, where, recurse = false) {
    return (0, $8e79a4aa438e001f$export$e0e0794250e9118f)((0, $2c05bb40cf30e065$export$af941c3c7c3b40f5)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param object Object to be extended.
 * @param property Property name.
 * @param tagName Tag name that contains the conditionally added property.
 * @param where Element to search for the property.
 * @param recurse Whether to recurse into child nodes.
 */ function $44a192c9a389cff7$var$addConditionally(object, property, tagName, where, recurse = false) {
    const value = $44a192c9a389cff7$var$fetch(tagName, where, recurse);
    if (value) object[property] = value;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $44a192c9a389cff7$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}


function $7a7ced587b5cd129$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $ca901c1589412cd1$export$ff8ccbac9225de62)(undefined, options);
    new (0, $e568cd9e4c5fb384$export$7acfa6ed01010e37)(handler, options).end(data);
    return handler.root;
}
function $7a7ced587b5cd129$export$d6f7114fde618113(callback, options, elementCallback) {
    const handler = new (0, $ca901c1589412cd1$export$ff8ccbac9225de62)((error)=>callback(error, handler.root), options, elementCallback);
    return new (0, $e568cd9e4c5fb384$export$7acfa6ed01010e37)(handler, options);
}
const $7a7ced587b5cd129$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $7a7ced587b5cd129$export$5267abf679cd576b(feed, options = $7a7ced587b5cd129$var$parseFeedDefaultOptions) {
    return (0, $44a192c9a389cff7$export$ad32138c9e09ad4)($7a7ced587b5cd129$export$b6a9369736b19f4d(feed, options).children);
}


var $c4d425048e4a6a16$exports = {};
'use strict';
$c4d425048e4a6a16$exports = (string)=>{
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};


/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $25a286262bc85461$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $25a286262bc85461$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($25a286262bc85461$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($25a286262bc85461$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}


var $a95d59889df6cf5b$require$isPlainObject = $25a286262bc85461$export$53b83ca8eaab0383;
var $060bc73db7a92eda$exports = {};
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if ($060bc73db7a92eda$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $060bc73db7a92eda$exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})($060bc73db7a92eda$exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === "\u0020" || // space
            c === "\u0009" || // horizontal tab
            c === "\u000A" || // new line
            c === "\u000C" || // form feed
            c === "\u000D"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "\u0028") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});


var $3e8fd19c657ae5f6$exports = {};
'use strict';
var $a78ea87fe43177f4$exports = {};
'use strict';
var $9c7747aa3f740b69$exports = {};
'use strict';
var $2e921bc74e628e3a$exports = {};
'use strict';
var $2ef5582d2243b2db$exports = {};
'use strict';
var $8b986f4ac1a8e843$exports = {};
'use strict';
var $8ea6b01be1e47493$exports = {};
var $8ea6b01be1e47493$var$x = String;
var $8ea6b01be1e47493$var$create = function() {
    return {
        isColorSupported: false,
        reset: $8ea6b01be1e47493$var$x,
        bold: $8ea6b01be1e47493$var$x,
        dim: $8ea6b01be1e47493$var$x,
        italic: $8ea6b01be1e47493$var$x,
        underline: $8ea6b01be1e47493$var$x,
        inverse: $8ea6b01be1e47493$var$x,
        hidden: $8ea6b01be1e47493$var$x,
        strikethrough: $8ea6b01be1e47493$var$x,
        black: $8ea6b01be1e47493$var$x,
        red: $8ea6b01be1e47493$var$x,
        green: $8ea6b01be1e47493$var$x,
        yellow: $8ea6b01be1e47493$var$x,
        blue: $8ea6b01be1e47493$var$x,
        magenta: $8ea6b01be1e47493$var$x,
        cyan: $8ea6b01be1e47493$var$x,
        white: $8ea6b01be1e47493$var$x,
        gray: $8ea6b01be1e47493$var$x,
        bgBlack: $8ea6b01be1e47493$var$x,
        bgRed: $8ea6b01be1e47493$var$x,
        bgGreen: $8ea6b01be1e47493$var$x,
        bgYellow: $8ea6b01be1e47493$var$x,
        bgBlue: $8ea6b01be1e47493$var$x,
        bgMagenta: $8ea6b01be1e47493$var$x,
        bgCyan: $8ea6b01be1e47493$var$x,
        bgWhite: $8ea6b01be1e47493$var$x,
        blackBright: $8ea6b01be1e47493$var$x,
        redBright: $8ea6b01be1e47493$var$x,
        greenBright: $8ea6b01be1e47493$var$x,
        yellowBright: $8ea6b01be1e47493$var$x,
        blueBright: $8ea6b01be1e47493$var$x,
        magentaBright: $8ea6b01be1e47493$var$x,
        cyanBright: $8ea6b01be1e47493$var$x,
        whiteBright: $8ea6b01be1e47493$var$x,
        bgBlackBright: $8ea6b01be1e47493$var$x,
        bgRedBright: $8ea6b01be1e47493$var$x,
        bgGreenBright: $8ea6b01be1e47493$var$x,
        bgYellowBright: $8ea6b01be1e47493$var$x,
        bgBlueBright: $8ea6b01be1e47493$var$x,
        bgMagentaBright: $8ea6b01be1e47493$var$x,
        bgCyanBright: $8ea6b01be1e47493$var$x,
        bgWhiteBright: $8ea6b01be1e47493$var$x
    };
};
$8ea6b01be1e47493$exports = $8ea6b01be1e47493$var$create();
$8ea6b01be1e47493$exports.createColors = $8ea6b01be1e47493$var$create;


var $5d37787af79cd1f2$exports = {};
"use strict";


class $8b986f4ac1a8e843$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = 'CssSyntaxError';
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
            if (typeof line === 'number') {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $8b986f4ac1a8e843$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ': ' : '';
        this.message += this.file ? this.file : '<css input>';
        if (typeof this.line !== 'undefined') this.message += ':' + this.line + ':' + this.column;
        this.message += ': ' + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return '';
        let css = this.source;
        if (color == null) color = $8ea6b01be1e47493$exports.isColorSupported;
        let aside = (text)=>text;
        let mark = (text)=>text;
        let highlight = (text)=>text;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $8ea6b01be1e47493$exports.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
            if ($5d37787af79cd1f2$exports) highlight = (text)=>$5d37787af79cd1f2$exports(text);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
            if (number === this.line) {
                if (line.length > 160) {
                    let padding = 20;
                    let subLineStart = Math.max(0, this.column - padding);
                    let subLineEnd = Math.max(this.column + padding, this.endColumn + padding);
                    let subLine = line.slice(subLineStart, subLineEnd);
                    let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, Math.min(this.column - 1, padding - 1)).replace(/[^\t]/g, ' ');
                    return mark('>') + aside(gutter) + highlight(subLine) + '\n ' + spacing + mark('^');
                }
                let spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
                return mark('>') + aside(gutter) + highlight(line) + '\n ' + spacing + mark('^');
            }
            return ' ' + aside(gutter) + highlight(line);
        }).join('\n');
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = '\n\n' + code + '\n';
        return this.name + ': ' + this.message + code;
    }
}
$8b986f4ac1a8e843$exports = $8b986f4ac1a8e843$var$CssSyntaxError;
$8b986f4ac1a8e843$var$CssSyntaxError.default = $8b986f4ac1a8e843$var$CssSyntaxError;


var $b1ec762d173acf42$exports = {};
'use strict';
// Characters that end an at-rule name, mirroring RE_AT_END in the tokenizer.
// Params starting with anything else need a space to stay separate tokens.
const $b1ec762d173acf42$var$AT_NAME_END = /[\t\n\f\r "#'()/;[\\\]{}]/;
const $b1ec762d173acf42$var$DEFAULT_RAW = {
    after: '\n',
    beforeClose: '\n',
    beforeComment: '\n',
    beforeDecl: '\n',
    beforeOpen: ' ',
    beforeRule: '\n',
    colon: ': ',
    commentLeft: ' ',
    commentRight: ' ',
    emptyBody: '',
    indent: '    ',
    semicolon: false
};
function $b1ec762d173acf42$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
function $b1ec762d173acf42$var$atruleStart(str, node) {
    let name = '@' + node.name;
    let params = node.params ? str.rawValue(node, 'params') : '';
    let afterName = node.raws.afterName;
    if (typeof afterName === 'undefined') afterName = params ? ' ' : '';
    else if (afterName === '' && params && !$b1ec762d173acf42$var$AT_NAME_END.test(params[0])) afterName = ' ';
    return name + afterName + params;
}
// `*--x` is not a custom property: the parser checks the first token, and the
// `*`/`_` hack prefix moves from `prop` into `before` only after that. A free
// semicolon in front of the declaration also ends up in `before`.
function $b1ec762d173acf42$var$isCustomProperty(node) {
    if (!node.prop.startsWith('--')) return false;
    let before = node.raws.before;
    return typeof before === 'undefined' || !/[^\s;]$/.test(before);
}
function $b1ec762d173acf42$var$pushBody(str, stack, node) {
    let nodes = node.nodes;
    let last = nodes.length - 1;
    while(last > 0){
        if (nodes[last].type !== 'comment') break;
        last -= 1;
    }
    let semicolon = str.raw(node, 'semicolon');
    let isDocument = node.type === 'document';
    for(let i = nodes.length - 1; i >= 0; i--){
        let child = nodes[i];
        let childSemicolon = last !== i || semicolon;
        // A childless at-rule or a custom property declaration that still has
        // following siblings must be terminated. Without the semicolon those
        // trailing comments are folded into the at-rule's prelude or the custom
        // property's value and disappear when the output is re-parsed.
        if (!childSemicolon && i < nodes.length - 1 && (child.type === 'atrule' && !child.nodes || child.type === 'decl' && $b1ec762d173acf42$var$isCustomProperty(child))) childSemicolon = true;
        stack.push({
            document: isDocument,
            node: child,
            semicolon: childSemicolon
        });
    }
}
function $b1ec762d173acf42$var$pushBlock(str, stack, node, start) {
    let between = str.raw(node, 'between', 'beforeOpen');
    str.builder(start + between + '{', node, 'start');
    let hasNodes = node.nodes && node.nodes.length;
    let close = ()=>{
        let after = hasNodes ? str.raw(node, 'after') : str.raw(node, 'after', 'emptyBody');
        if (after) str.builder(after);
        str.builder('}', node, 'end');
        if (node.type === 'rule' && node.raws.ownSemicolon) str.builder(node.raws.ownSemicolon, node, 'end');
    };
    if (hasNodes) {
        stack.push(close);
        $b1ec762d173acf42$var$pushBody(str, stack, node);
    } else close();
}
class $b1ec762d173acf42$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let start = $b1ec762d173acf42$var$atruleStart(this, node);
        if (node.nodes) this.block(node, start);
        else {
            let end = (node.raws.between || '') + (semicolon ? ';' : '');
            this.builder(start + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === 'decl') value = this.raw(node, null, 'beforeDecl');
        else if (node.type === 'comment') value = this.raw(node, null, 'beforeComment');
        else if (detect === 'before') value = this.raw(node, null, 'beforeRule');
        else value = this.raw(node, null, 'beforeClose');
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== 'root'){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes('\n')) {
            let indent = this.raw(node, null, 'indent');
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, 'between', 'beforeOpen');
        this.builder(start + between + '{', node, 'start');
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, 'after');
        } else after = this.raw(node, 'after', 'emptyBody');
        if (after) this.builder(after);
        this.builder('}', node, 'end');
    }
    body(node) {
        // Rules and at-rules are expanded into an explicit stack instead of
        // recursive `stringify()` calls to survive deeply nested trees.
        // If a subclass changes the traversal methods, its children go
        // through `stringify()` to keep the override in charge.
        let proto = $b1ec762d173acf42$var$Stringifier.prototype;
        let expandable = [
            'atrule',
            'block',
            'body',
            'rule',
            'stringify'
        ].every((method)=>this[method] === proto[method]);
        let stack = [];
        $b1ec762d173acf42$var$pushBody(this, stack, node);
        while(stack.length > 0){
            let entry = stack.pop();
            if (typeof entry === 'function') {
                entry();
                continue;
            }
            let child = entry.node;
            let before = this.raw(child, 'before');
            if (before) this.builder(before);
            if (expandable && child.type === 'rule') $b1ec762d173acf42$var$pushBlock(this, stack, child, this.rawValue(child, 'selector'));
            else if (expandable && child.type === 'atrule' && child.nodes) $b1ec762d173acf42$var$pushBlock(this, stack, child, $b1ec762d173acf42$var$atruleStart(this, child));
            else this.stringify(child, entry.semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, 'left', 'commentLeft');
        let right = this.raw(node, 'right', 'commentRight');
        this.builder('/*' + left + node.text + right + '*/', node);
    }
    decl(node, semicolon) {
        let raws = node.raws;
        let between = this.raw(node, 'between', 'colon');
        let string = node.prop + between + this.rawValue(node, 'value');
        if (node.important) string += raws.important || ' !important';
        if (semicolon) string += ';';
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== 'undefined') return value;
        }
        let parent = node.parent;
        if (detect === 'before') {
            // Hack for first rule in CSS
            if (!parent || parent.type === 'root' && parent.first === node) return '';
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === 'document') return '';
        }
        // Floating child without parent
        if (!parent) return $b1ec762d173acf42$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        let cache = root.rawCache || (root.rawCache = {});
        if (typeof cache[detect] !== 'undefined') return cache[detect];
        if (detect === 'before' || detect === 'after') return this.beforeAfter(node, detect);
        else {
            let method = 'raw' + $b1ec762d173acf42$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== 'undefined') return false;
            });
        }
        if (typeof value === 'undefined') value = $b1ec762d173acf42$var$DEFAULT_RAW[detect];
        cache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== 'undefined') {
                    value = i.raws.after;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeDecl');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== 'undefined') {
                value = i.raws.before;
                if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                return false;
            }
        });
        if (typeof value === 'undefined') value = this.raw(node, null, 'beforeRule');
        else if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== 'decl') {
                value = i.raws.between;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== 'undefined') {
                    value = i.raws.before;
                    if (value.includes('\n')) value = value.replace(/[^\n]+$/, '');
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, '');
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== 'undefined') {
                value = i.raws.between.replace(/[^\s:]/g, '');
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== 'undefined') {
                    let parts = i.raws.before.split('\n');
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, '');
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === 'decl') {
                value = i.raws.semicolon;
                if (typeof value !== 'undefined') return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        let inDocument = node.parent && node.parent.type === 'document';
        if (!inDocument && node.source && node.source.input.hasBOM) this.builder('\uFEFF', node, 'start');
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, 'selector'));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, 'end');
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error('Unknown AST node type ' + node.type + '. ' + 'Maybe you need to change PostCSS stringifier.');
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
$b1ec762d173acf42$exports = $b1ec762d173acf42$var$Stringifier;
$b1ec762d173acf42$var$Stringifier.default = $b1ec762d173acf42$var$Stringifier;


var $a0cdc5c7a7f85333$exports = {};
'use strict';

const $a0cdc5c7a7f85333$var$STYLE_TAG = /(<)(\/?style\b)/gi;
const $a0cdc5c7a7f85333$var$COMMENT_OPEN = /(<)(!--)/g;
function $a0cdc5c7a7f85333$var$escapeHTMLInCSS(str) {
    if (!str.includes('<')) return str;
    return str.replace($a0cdc5c7a7f85333$var$STYLE_TAG, '\\3c $2').replace($a0cdc5c7a7f85333$var$COMMENT_OPEN, '\\3c $2');
}
class $a0cdc5c7a7f85333$var$SafeStringifier extends $b1ec762d173acf42$exports {
    escapeHTML(node, print) {
        let builder = this.builder;
        let chunks, css;
        this.builder = (str, child, type)=>{
            if (chunks) {
                css += str;
                chunks.push(str, child, type);
            } else if (str.includes('<')) {
                // Dangerous sequences start with `<`, so everything before
                // the first `<` is safe to pass through. The rest is buffered
                // to escape it as a whole.
                css = str;
                chunks = [
                    str,
                    child,
                    type
                ];
            } else builder(str, child, type);
        };
        print();
        this.builder = builder;
        if (!chunks) return;
        let escaped = $a0cdc5c7a7f85333$var$escapeHTMLInCSS(css);
        if (escaped === css) // Keep the chunks to get a precise source map
        for(let i = 0; i < chunks.length; i += 3)builder(chunks[i], chunks[i + 1], chunks[i + 2]);
        else // Escaping happens only on a hack attempt, source map is not important.
        // Map only the node start: the end mapping expects the node’s last
        // char at the end of the string, which is wrong for Root raws.after.
        builder(escaped, node, 'start');
    }
    root(node) {
        if (node.parent && node.parent.type === 'document') {
            // Document raws around the Root hold markup and are kept as is since CSS in Document can be marked with <style>
            this.escapeHTML(node, ()=>this.body(node));
            if (node.raws.after) this.builder(node.raws.after);
        } else this.escapeHTML(node, ()=>super.root(node));
    }
}
function $a0cdc5c7a7f85333$var$stringify(node, builder) {
    let str = new $a0cdc5c7a7f85333$var$SafeStringifier(builder);
    // Root escapes its own output and keeps markup in Document raws
    if (node.type === 'root' || node.type === 'document') str.stringify(node);
    else str.escapeHTML(node, ()=>str.stringify(node));
}
$a0cdc5c7a7f85333$exports = $a0cdc5c7a7f85333$var$stringify;
$a0cdc5c7a7f85333$var$stringify.default = $a0cdc5c7a7f85333$var$stringify;


var $805ec064d50ece30$export$ae5e7911ce0728f9;
var $805ec064d50ece30$export$94fa0a6beb22f989;
'use strict';
$805ec064d50ece30$export$ae5e7911ce0728f9 = Symbol('isClean');
$805ec064d50ece30$export$94fa0a6beb22f989 = Symbol('my');


var $2ef5582d2243b2db$require$isClean = $805ec064d50ece30$export$ae5e7911ce0728f9;
var $2ef5582d2243b2db$require$my = $805ec064d50ece30$export$94fa0a6beb22f989;
function $2ef5582d2243b2db$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    // An explicit stack instead of recursive calls to survive deeply
    // nested trees. Each entry is [source, its clone, clone's parent].
    let stack = [
        [
            obj,
            cloned,
            parent
        ]
    ];
    while(stack.length > 0){
        let [source, target, targetParent] = stack.pop();
        for(let i in source){
            if (!Object.prototype.hasOwnProperty.call(source, i)) continue;
            if (i === 'proxyCache') continue;
            let value = source[i];
            let type = typeof value;
            if (i === 'parent' && type === 'object') {
                if (targetParent) target[i] = targetParent;
            } else if (i === 'source') target[i] = value;
            else if (Array.isArray(value)) {
                let children = [];
                target[i] = children;
                for (let j of value){
                    let childClone = new j.constructor();
                    children.push(childClone);
                    stack.push([
                        j,
                        childClone,
                        target
                    ]);
                }
            } else {
                if (type === 'object' && value !== null) {
                    let valueClone = new value.constructor();
                    stack.push([
                        value,
                        valueClone,
                        undefined
                    ]);
                    value = valueClone;
                }
                target[i] = value;
            }
        }
    }
    return cloned;
}
function $2ef5582d2243b2db$var$sourceOffset(inputCSS, position) {
    // Not all custom syntaxes support `offset` in `source.start` and `source.end`
    if (position && typeof position.offset !== 'undefined') return position.offset;
    let column = 1;
    let line = 1;
    let offset = 0;
    for(let i = 0; i < inputCSS.length; i++){
        if (line === position.line && column === position.column) {
            offset = i;
            break;
        }
        if (inputCSS[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
    }
    return offset;
}
class $2ef5582d2243b2db$var$Node {
    get proxyOf() {
        return this;
    }
    constructor(defaults = {}){
        this.raws = {};
        this[$2ef5582d2243b2db$require$isClean] = false;
        this[$2ef5582d2243b2db$require$my] = true;
        for (let name of Object.keys(defaults)){
            if (name === '__proto__') continue;
            if (name === 'nodes') {
                this.nodes = [];
                for (let node of defaults[name])// Clone only nodes that already belong to another tree, so passing a
                // freshly created (parent-less) node adopts that instance instead of
                // a copy and keeps the caller's reference usable. See #1987.
                if (typeof node.clone === 'function' && node.parent) this.append(node.clone());
                else this.append(node);
            } else this[name] = defaults[name];
        }
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $2ef5582d2243b2db$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $8b986f4ac1a8e843$exports(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (prop === 'root') return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'prop' || prop === 'value' || prop === 'name' || prop === 'params' || prop === 'important' || /* c8 ignore next */ prop === 'text') node.markDirty();
                return true;
            }
        };
    }
    /* c8 ignore next 3 */ markClean() {
        this[$2ef5582d2243b2db$require$isClean] = true;
    }
    markDirty() {
        if (this[$2ef5582d2243b2db$require$isClean]) {
            this[$2ef5582d2243b2db$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$2ef5582d2243b2db$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts = {}) {
        let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        let pos = {
            column: this.source.start.column,
            line: this.source.start.line,
            offset: $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.start)
        };
        if (opts.index) pos = this.positionInside(opts.index);
        else if (opts.word) {
            let stringRepresentation = inputString.slice($2ef5582d2243b2db$var$sourceOffset(inputString, this.source.start), $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.end));
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index);
        }
        return pos;
    }
    positionInside(index) {
        let column = this.source.start.column;
        let line = this.source.start.line;
        let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        let offset = $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.start);
        let end = offset + index;
        for(let i = offset; i < end; i++)if (inputString[i] === '\n') {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line,
            offset: end
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    rangeBy(opts = {}) {
        let inputString = 'document' in this.source.input ? this.source.input.document : this.source.input.css;
        let start = {
            column: this.source.start.column,
            line: this.source.start.line,
            offset: $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.start)
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line,
            offset: typeof this.source.end.offset === 'number' ? this.source.end.offset : // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
            // So, we add 1 to convert it to exclusive.
            $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.end) + 1
        } : {
            column: start.column + 1,
            line: start.line,
            offset: start.offset + 1
        };
        if (opts.word) {
            let stringRepresentation = inputString.slice($2ef5582d2243b2db$var$sourceOffset(inputString, this.source.start), $2ef5582d2243b2db$var$sourceOffset(inputString, this.source.end));
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index);
                end = this.positionInside(index + opts.word.length);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line,
                offset: $2ef5582d2243b2db$var$sourceOffset(inputString, opts.start)
            };
            else if (typeof opts.index === 'number') start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line,
                offset: $2ef5582d2243b2db$var$sourceOffset(inputString, opts.end)
            };
            else if (typeof opts.endIndex === 'number') end = this.positionInside(opts.endIndex);
            else if (typeof opts.index === 'number') end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line,
            offset: start.offset + 1
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $b1ec762d173acf42$exports();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== 'document')result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        // A worklist instead of recursive `toJSON()` calls to survive deeply
        // nested trees. Each entry converts one node and writes the result
        // into the already converted parent by [holder, key].
        let holderOfRoot = [];
        let queue = [
            [
                this,
                holderOfRoot,
                0
            ]
        ];
        for(let step = 0; step < queue.length; step++){
            let [node, holder, key] = queue[step];
            let fixed = {};
            holder[key] = fixed;
            for(let name in node){
                if (!Object.prototype.hasOwnProperty.call(node, name)) continue;
                if (name === 'parent' || name === 'proxyCache') continue;
                let value = node[name];
                if (Array.isArray(value)) {
                    let fixedArray = [];
                    fixed[name] = fixedArray;
                    for(let i = 0; i < value.length; i++){
                        let item = value[i];
                        if (typeof item === 'object' && item.toJSON) {
                            if (item.toJSON === $2ef5582d2243b2db$var$Node.prototype.toJSON) queue.push([
                                item,
                                fixedArray,
                                i
                            ]);
                            else fixedArray[i] = item.toJSON(null, inputs);
                        } else fixedArray[i] = item;
                    }
                } else if (typeof value === 'object' && value.toJSON) {
                    if (value.toJSON === $2ef5582d2243b2db$var$Node.prototype.toJSON) queue.push([
                        value,
                        fixed,
                        name
                    ]);
                    else fixed[name] = value.toJSON(null, inputs);
                } else if (name === 'source') {
                    if (value == null) continue;
                    let inputId = inputs.get(value.input);
                    if (inputId == null) {
                        inputId = inputs.size;
                        inputs.set(value.input, inputId);
                    }
                    fixed[name] = {
                        end: value.end,
                        inputId: inputId,
                        start: value.start
                    };
                } else fixed[name] = value;
            }
        }
        let fixed = holderOfRoot[0];
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $a0cdc5c7a7f85333$exports) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = '';
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts = {}) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
}
$2ef5582d2243b2db$exports = $2ef5582d2243b2db$var$Node;
$2ef5582d2243b2db$var$Node.default = $2ef5582d2243b2db$var$Node;


class $2e921bc74e628e3a$var$Comment extends $2ef5582d2243b2db$exports {
    constructor(defaults){
        super(defaults);
        this.type = 'comment';
    }
}
$2e921bc74e628e3a$exports = $2e921bc74e628e3a$var$Comment;
$2e921bc74e628e3a$var$Comment.default = $2e921bc74e628e3a$var$Comment;


var $22b80642d0efd425$exports = {};
'use strict';

class $22b80642d0efd425$var$Declaration extends $2ef5582d2243b2db$exports {
    get variable() {
        return this.prop.startsWith('--') || this.prop[0] === '$';
    }
    constructor(defaults){
        if (defaults && typeof defaults.value !== 'undefined' && typeof defaults.value !== 'string') defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = 'decl';
    }
}
$22b80642d0efd425$exports = $22b80642d0efd425$var$Declaration;
$22b80642d0efd425$var$Declaration.default = $22b80642d0efd425$var$Declaration;




var $9c7747aa3f740b69$require$isClean = $805ec064d50ece30$export$ae5e7911ce0728f9;
var $9c7747aa3f740b69$require$my = $805ec064d50ece30$export$94fa0a6beb22f989;
let $9c7747aa3f740b69$var$AtRule, $9c7747aa3f740b69$var$parse, $9c7747aa3f740b69$var$Root, $9c7747aa3f740b69$var$Rule;
function $9c7747aa3f740b69$var$cleanSource(nodes) {
    let stack = nodes.slice();
    while(stack.length > 0){
        let node = stack.pop();
        delete node.source;
        if (node.nodes) {
            node.nodes = node.nodes.slice();
            for (let i of node.nodes)stack.push(i);
        }
    }
    return nodes.slice();
}
function $9c7747aa3f740b69$var$markTreeDirty(node) {
    let stack = [
        node
    ];
    while(stack.length > 0){
        let next = stack.pop();
        next[$9c7747aa3f740b69$require$isClean] = false;
        if (next.proxyOf.nodes) for (let i of next.proxyOf.nodes)stack.push(i);
    }
}
class $9c7747aa3f740b69$var$Container extends $2ef5582d2243b2db$exports {
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        let stack = [
            this
        ];
        while(stack.length > 0){
            let node = stack.pop();
            if (node !== this && node.cleanRaws !== $9c7747aa3f740b69$var$Container.prototype.cleanRaws) {
                // Subclass with own logic; let it handle its subtree
                node.cleanRaws(keepBetween);
                continue;
            }
            $2ef5582d2243b2db$exports.prototype.cleanRaws.call(node, keepBetween);
            if (node.nodes) for (let child of node.nodes)stack.push(child);
        }
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === 'proxyOf') return node;
                else if (!node[prop]) return node[prop];
                else if (prop === 'each' || typeof prop === 'string' && prop.startsWith('walk')) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === 'function') return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === 'every' || prop === 'some') return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === 'root') return ()=>node.root().toProxy();
                else if (prop === 'nodes') return node.nodes.map((i)=>i.toProxy());
                else if (prop === 'first' || prop === 'last') return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === 'name' || prop === 'params' || prop === 'selector') node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === 'number') return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? 'prepend' : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === 'string') nodes = $9c7747aa3f740b69$var$cleanSource($9c7747aa3f740b69$var$parse(nodes).nodes);
        else if (typeof nodes === 'undefined') nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type === 'root' && this.type !== 'document') {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, 'ignore');
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === 'undefined') throw new Error('Value field is missed in node creation');
            else if (typeof nodes.value !== 'string') nodes.value = String(nodes.value);
            nodes = [
                new $22b80642d0efd425$exports(nodes)
            ];
        } else if (nodes.selector || nodes.selectors) nodes = [
            new $9c7747aa3f740b69$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $9c7747aa3f740b69$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $2e921bc74e628e3a$exports(nodes)
        ];
        else throw new Error('Unknown node type in node creation');
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$9c7747aa3f740b69$require$my]) $9c7747aa3f740b69$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$9c7747aa3f740b69$require$isClean]) $9c7747aa3f740b69$var$markTreeDirty(i);
            if (!i.raws) i.raws = {};
            if (typeof i.raws.before === 'undefined') {
                if (sample && typeof sample.raws.before !== 'undefined') i.raws.before = sample.raws.before.replace(/\S/g, '');
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, 'prepend').reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        if (!this.proxyOf.nodes) return undefined;
        // An explicit stack instead of recursive `each()` calls to survive
        // deeply nested trees. Each frame keeps a live `indexes` slot, so
        // insertion and removal during the walk behave like `each()`: the
        // slot stays at the current child until its subtree is finished.
        let stack = [
            {
                iterator: this.getIterator(),
                node: this.proxyOf
            }
        ];
        while(stack.length > 0){
            let { iterator: iterator, node: node } = stack[stack.length - 1];
            let index = node.indexes[iterator];
            if (index >= node.proxyOf.nodes.length) {
                delete node.indexes[iterator];
                stack.pop();
                let parent = stack[stack.length - 1];
                // Finish the parent’s step for the child subtree we just left
                if (parent) parent.node.indexes[parent.iterator] += 1;
                continue;
            }
            let child = node.proxyOf.nodes[index];
            let result;
            try {
                result = callback(child, index);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result === false) {
                for (let opened of stack)delete opened.node.indexes[opened.iterator];
                return false;
            }
            if (child.walk && child.proxyOf.nodes) stack.push({
                iterator: child.getIterator(),
                node: child
            });
            else node.indexes[iterator] += 1;
        }
        return undefined;
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === 'atrule') return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'atrule' && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'atrule' && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === 'comment') return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === 'decl') return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'decl' && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'decl' && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === 'rule') return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === 'rule' && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === 'rule' && child.selector === selector) return callback(child, i);
        });
    }
}
$9c7747aa3f740b69$var$Container.registerParse = (dependant)=>{
    $9c7747aa3f740b69$var$parse = dependant;
};
$9c7747aa3f740b69$var$Container.registerRule = (dependant)=>{
    $9c7747aa3f740b69$var$Rule = dependant;
};
$9c7747aa3f740b69$var$Container.registerAtRule = (dependant)=>{
    $9c7747aa3f740b69$var$AtRule = dependant;
};
$9c7747aa3f740b69$var$Container.registerRoot = (dependant)=>{
    $9c7747aa3f740b69$var$Root = dependant;
};
$9c7747aa3f740b69$exports = $9c7747aa3f740b69$var$Container;
$9c7747aa3f740b69$var$Container.default = $9c7747aa3f740b69$var$Container;
/* c8 ignore start */ $9c7747aa3f740b69$var$Container.rebuild = (node)=>{
    let stack = [
        node
    ];
    while(stack.length > 0){
        let next = stack.pop();
        if (next.type === 'atrule') Object.setPrototypeOf(next, $9c7747aa3f740b69$var$AtRule.prototype);
        else if (next.type === 'rule') Object.setPrototypeOf(next, $9c7747aa3f740b69$var$Rule.prototype);
        else if (next.type === 'decl') Object.setPrototypeOf(next, $22b80642d0efd425$exports.prototype);
        else if (next.type === 'comment') Object.setPrototypeOf(next, $2e921bc74e628e3a$exports.prototype);
        else if (next.type === 'root') Object.setPrototypeOf(next, $9c7747aa3f740b69$var$Root.prototype);
        next[$9c7747aa3f740b69$require$my] = true;
        if (next.nodes) for (let child of next.nodes)stack.push(child);
    }
} /* c8 ignore stop */ ;


class $a78ea87fe43177f4$var$AtRule extends $9c7747aa3f740b69$exports {
    constructor(defaults){
        super(defaults);
        this.type = 'atrule';
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
$a78ea87fe43177f4$exports = $a78ea87fe43177f4$var$AtRule;
$a78ea87fe43177f4$var$AtRule.default = $a78ea87fe43177f4$var$AtRule;
$9c7747aa3f740b69$exports.registerAtRule($a78ea87fe43177f4$var$AtRule);






var $87768caed9f1aad4$exports = {};
'use strict';

let $87768caed9f1aad4$var$LazyResult, $87768caed9f1aad4$var$Processor;
class $87768caed9f1aad4$var$Document extends $9c7747aa3f740b69$exports {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: 'document',
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $87768caed9f1aad4$var$LazyResult(new $87768caed9f1aad4$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$87768caed9f1aad4$var$Document.registerLazyResult = (dependant)=>{
    $87768caed9f1aad4$var$LazyResult = dependant;
};
$87768caed9f1aad4$var$Document.registerProcessor = (dependant)=>{
    $87768caed9f1aad4$var$Processor = dependant;
};
$87768caed9f1aad4$exports = $87768caed9f1aad4$var$Document;
$87768caed9f1aad4$var$Document.default = $87768caed9f1aad4$var$Document;


var $4cc8f496d0297ebf$exports = {};
'use strict';



var $59d77a69a0b8aad2$exports = {};
'use strict';
let $ee3e523b2726d590$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $ee3e523b2726d590$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ee3e523b2726d590$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i-- > 0)id += $ee3e523b2726d590$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $59d77a69a0b8aad2$require$nanoid = $ee3e523b2726d590$export$ac4959f4f1338dfc;

var $59d77a69a0b8aad2$require$isAbsolute = $5d37787af79cd1f2$exports.isAbsolute;
var $59d77a69a0b8aad2$require$resolve = $5d37787af79cd1f2$exports.resolve;

var $59d77a69a0b8aad2$require$SourceMapConsumer = $5d37787af79cd1f2$exports.SourceMapConsumer;
var $59d77a69a0b8aad2$require$SourceMapGenerator = $5d37787af79cd1f2$exports.SourceMapGenerator;

var $59d77a69a0b8aad2$require$fileURLToPath = $5d37787af79cd1f2$exports.fileURLToPath;
var $59d77a69a0b8aad2$require$pathToFileURL = $5d37787af79cd1f2$exports.pathToFileURL;

var $4a7af53cd3e5f045$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $802fd0de90cfa455$export$a143d493d941bafc;
var $802fd0de90cfa455$export$e4cf37d7f6fb9e0a;
var $802fd0de90cfa455$export$f99ded8fe4b79145;
var $802fd0de90cfa455$export$599f31c3813fae4d;
'use strict';
var $bf94c29cc99c1571$export$a48f0734ac7c2329;
var $bf94c29cc99c1571$export$d622b2ad8d90c771;
var $bf94c29cc99c1571$export$6100ba28696e12de;
'use strict';
$bf94c29cc99c1571$export$a48f0734ac7c2329 = $bf94c29cc99c1571$var$byteLength;
$bf94c29cc99c1571$export$d622b2ad8d90c771 = $bf94c29cc99c1571$var$toByteArray;
$bf94c29cc99c1571$export$6100ba28696e12de = $bf94c29cc99c1571$var$fromByteArray;
var $bf94c29cc99c1571$var$lookup = [];
var $bf94c29cc99c1571$var$revLookup = [];
var $bf94c29cc99c1571$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bf94c29cc99c1571$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bf94c29cc99c1571$var$i = 0, $bf94c29cc99c1571$var$len = $bf94c29cc99c1571$var$code.length; $bf94c29cc99c1571$var$i < $bf94c29cc99c1571$var$len; ++$bf94c29cc99c1571$var$i){
    $bf94c29cc99c1571$var$lookup[$bf94c29cc99c1571$var$i] = $bf94c29cc99c1571$var$code[$bf94c29cc99c1571$var$i];
    $bf94c29cc99c1571$var$revLookup[$bf94c29cc99c1571$var$code.charCodeAt($bf94c29cc99c1571$var$i)] = $bf94c29cc99c1571$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bf94c29cc99c1571$var$revLookup['-'.charCodeAt(0)] = 62;
$bf94c29cc99c1571$var$revLookup['_'.charCodeAt(0)] = 63;
function $bf94c29cc99c1571$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bf94c29cc99c1571$var$byteLength(b64) {
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bf94c29cc99c1571$var$toByteArray(b64) {
    var tmp;
    var lens = $bf94c29cc99c1571$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bf94c29cc99c1571$var$Arr($bf94c29cc99c1571$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 18 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 2 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i)] << 10 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bf94c29cc99c1571$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bf94c29cc99c1571$var$tripletToBase64(num) {
    return $bf94c29cc99c1571$var$lookup[num >> 18 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 12 & 0x3F] + $bf94c29cc99c1571$var$lookup[num >> 6 & 0x3F] + $bf94c29cc99c1571$var$lookup[num & 0x3F];
}
function $bf94c29cc99c1571$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bf94c29cc99c1571$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bf94c29cc99c1571$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bf94c29cc99c1571$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 2] + $bf94c29cc99c1571$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bf94c29cc99c1571$var$lookup[tmp >> 10] + $bf94c29cc99c1571$var$lookup[tmp >> 4 & 0x3F] + $bf94c29cc99c1571$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $32e74836fee794be$export$aafa59e2e03f2942;
var $32e74836fee794be$export$68d8715fc104d294;
$32e74836fee794be$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$32e74836fee794be$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $802fd0de90cfa455$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$802fd0de90cfa455$export$a143d493d941bafc = $802fd0de90cfa455$var$Buffer;
$802fd0de90cfa455$export$e4cf37d7f6fb9e0a = $802fd0de90cfa455$var$SlowBuffer;
$802fd0de90cfa455$export$f99ded8fe4b79145 = 50;
const $802fd0de90cfa455$var$K_MAX_LENGTH = 0x7fffffff;
$802fd0de90cfa455$export$599f31c3813fae4d = $802fd0de90cfa455$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT = $802fd0de90cfa455$var$typedArraySupport();
if (!$802fd0de90cfa455$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $802fd0de90cfa455$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($802fd0de90cfa455$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$802fd0de90cfa455$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $802fd0de90cfa455$var$createBuffer(length) {
    if (length > $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $802fd0de90cfa455$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $802fd0de90cfa455$var$allocUnsafe(arg);
    }
    return $802fd0de90cfa455$var$from(arg, encodingOrOffset, length);
}
$802fd0de90cfa455$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $802fd0de90cfa455$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $802fd0de90cfa455$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $802fd0de90cfa455$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($802fd0de90cfa455$var$isInstance(value, ArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, ArrayBuffer)) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($802fd0de90cfa455$var$isInstance(value, SharedArrayBuffer) || value && $802fd0de90cfa455$var$isInstance(value.buffer, SharedArrayBuffer))) return $802fd0de90cfa455$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $802fd0de90cfa455$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $802fd0de90cfa455$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $802fd0de90cfa455$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $802fd0de90cfa455$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $802fd0de90cfa455$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($802fd0de90cfa455$var$Buffer, Uint8Array);
function $802fd0de90cfa455$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $802fd0de90cfa455$var$alloc(size, fill, encoding) {
    $802fd0de90cfa455$var$assertSize(size);
    if (size <= 0) return $802fd0de90cfa455$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $802fd0de90cfa455$var$createBuffer(size).fill(fill, encoding) : $802fd0de90cfa455$var$createBuffer(size).fill(fill);
    return $802fd0de90cfa455$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $802fd0de90cfa455$var$Buffer.alloc = function(size, fill, encoding) {
    return $802fd0de90cfa455$var$alloc(size, fill, encoding);
};
function $802fd0de90cfa455$var$allocUnsafe(size) {
    $802fd0de90cfa455$var$assertSize(size);
    return $802fd0de90cfa455$var$createBuffer(size < 0 ? 0 : $802fd0de90cfa455$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $802fd0de90cfa455$var$Buffer.allocUnsafe = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $802fd0de90cfa455$var$Buffer.allocUnsafeSlow = function(size) {
    return $802fd0de90cfa455$var$allocUnsafe(size);
};
function $802fd0de90cfa455$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $802fd0de90cfa455$var$byteLength(string, encoding) | 0;
    let buf = $802fd0de90cfa455$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $802fd0de90cfa455$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $802fd0de90cfa455$var$checked(array.length) | 0;
    const buf = $802fd0de90cfa455$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $802fd0de90cfa455$var$fromArrayView(arrayView) {
    if ($802fd0de90cfa455$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $802fd0de90cfa455$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $802fd0de90cfa455$var$fromArrayLike(arrayView);
}
function $802fd0de90cfa455$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $802fd0de90cfa455$var$Buffer.prototype);
    return buf;
}
function $802fd0de90cfa455$var$fromObject(obj) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(obj)) {
        const len = $802fd0de90cfa455$var$checked(obj.length) | 0;
        const buf = $802fd0de90cfa455$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $802fd0de90cfa455$var$numberIsNaN(obj.length)) return $802fd0de90cfa455$var$createBuffer(0);
        return $802fd0de90cfa455$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $802fd0de90cfa455$var$fromArrayLike(obj.data);
}
function $802fd0de90cfa455$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $802fd0de90cfa455$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $802fd0de90cfa455$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $802fd0de90cfa455$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $802fd0de90cfa455$var$Buffer.alloc(+length);
}
$802fd0de90cfa455$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $802fd0de90cfa455$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$802fd0de90cfa455$var$Buffer.compare = function compare(a, b) {
    if ($802fd0de90cfa455$var$isInstance(a, Uint8Array)) a = $802fd0de90cfa455$var$Buffer.from(a, a.offset, a.byteLength);
    if ($802fd0de90cfa455$var$isInstance(b, Uint8Array)) b = $802fd0de90cfa455$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(a) || !$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$802fd0de90cfa455$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$802fd0de90cfa455$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $802fd0de90cfa455$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $802fd0de90cfa455$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($802fd0de90cfa455$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) buf = $802fd0de90cfa455$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $802fd0de90cfa455$var$byteLength(string, encoding) {
    if ($802fd0de90cfa455$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $802fd0de90cfa455$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $802fd0de90cfa455$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $802fd0de90cfa455$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$802fd0de90cfa455$var$Buffer.byteLength = $802fd0de90cfa455$var$byteLength;
function $802fd0de90cfa455$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Slice(this, start, end);
        case 'ascii':
            return $802fd0de90cfa455$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$latin1Slice(this, start, end);
        case 'base64':
            return $802fd0de90cfa455$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$802fd0de90cfa455$var$Buffer.prototype._isBuffer = true;
function $802fd0de90cfa455$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$802fd0de90cfa455$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$802fd0de90cfa455$var$swap(this, i, i + 1);
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $802fd0de90cfa455$var$swap(this, i, i + 3);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $802fd0de90cfa455$var$swap(this, i, i + 7);
        $802fd0de90cfa455$var$swap(this, i + 1, i + 6);
        $802fd0de90cfa455$var$swap(this, i + 2, i + 5);
        $802fd0de90cfa455$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$802fd0de90cfa455$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $802fd0de90cfa455$var$utf8Slice(this, 0, length);
    return $802fd0de90cfa455$var$slowToString.apply(this, arguments);
};
$802fd0de90cfa455$var$Buffer.prototype.toLocaleString = $802fd0de90cfa455$var$Buffer.prototype.toString;
$802fd0de90cfa455$var$Buffer.prototype.equals = function equals(b) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $802fd0de90cfa455$var$Buffer.compare(this, b) === 0;
};
$802fd0de90cfa455$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $802fd0de90cfa455$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($802fd0de90cfa455$var$customInspectSymbol) $802fd0de90cfa455$var$Buffer.prototype[$802fd0de90cfa455$var$customInspectSymbol] = $802fd0de90cfa455$var$Buffer.prototype.inspect;
$802fd0de90cfa455$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($802fd0de90cfa455$var$isInstance(target, Uint8Array)) target = $802fd0de90cfa455$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $802fd0de90cfa455$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($802fd0de90cfa455$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $802fd0de90cfa455$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($802fd0de90cfa455$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $802fd0de90cfa455$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $802fd0de90cfa455$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$802fd0de90cfa455$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$802fd0de90cfa455$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$802fd0de90cfa455$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $802fd0de90cfa455$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $802fd0de90cfa455$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($802fd0de90cfa455$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $802fd0de90cfa455$var$utf8Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $802fd0de90cfa455$var$asciiWrite(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$asciiToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$base64Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$base64ToBytes(string), buf, offset, length);
}
function $802fd0de90cfa455$var$ucs2Write(buf, string, offset, length) {
    return $802fd0de90cfa455$var$blitBuffer($802fd0de90cfa455$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$802fd0de90cfa455$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $802fd0de90cfa455$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $802fd0de90cfa455$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $802fd0de90cfa455$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $802fd0de90cfa455$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $802fd0de90cfa455$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$802fd0de90cfa455$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $802fd0de90cfa455$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bf94c29cc99c1571$export$6100ba28696e12de(buf);
    else return $bf94c29cc99c1571$export$6100ba28696e12de(buf.slice(start, end));
}
function $802fd0de90cfa455$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $802fd0de90cfa455$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $802fd0de90cfa455$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $802fd0de90cfa455$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $802fd0de90cfa455$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $802fd0de90cfa455$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $802fd0de90cfa455$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $802fd0de90cfa455$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $802fd0de90cfa455$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$802fd0de90cfa455$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $802fd0de90cfa455$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $802fd0de90cfa455$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$802fd0de90cfa455$var$Buffer.prototype.readUintLE = $802fd0de90cfa455$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUintBE = $802fd0de90cfa455$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint8 = $802fd0de90cfa455$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint16BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32LE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$802fd0de90cfa455$var$Buffer.prototype.readUint32BE = $802fd0de90cfa455$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$802fd0de90cfa455$var$Buffer.prototype.readBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$802fd0de90cfa455$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$802fd0de90cfa455$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$802fd0de90cfa455$var$Buffer.prototype.readBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $802fd0de90cfa455$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$802fd0de90cfa455$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 4, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$802fd0de90cfa455$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkOffset(offset, 8, this.length);
    return $32e74836fee794be$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $802fd0de90cfa455$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$802fd0de90cfa455$var$Buffer.prototype.writeUintLE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUintBE = $802fd0de90cfa455$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint8 = $802fd0de90cfa455$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint16BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32LE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeUint32BE = $802fd0de90cfa455$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $802fd0de90cfa455$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $802fd0de90cfa455$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigUInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $802fd0de90cfa455$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64LE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$802fd0de90cfa455$var$Buffer.prototype.writeBigInt64BE = $802fd0de90cfa455$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $802fd0de90cfa455$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $802fd0de90cfa455$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $32e74836fee794be$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$802fd0de90cfa455$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeFloat(this, value, offset, false, noAssert);
};
function $802fd0de90cfa455$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $802fd0de90cfa455$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $32e74836fee794be$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, true, noAssert);
};
$802fd0de90cfa455$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $802fd0de90cfa455$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$802fd0de90cfa455$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$802fd0de90cfa455$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$802fd0de90cfa455$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$802fd0de90cfa455$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $802fd0de90cfa455$var$Buffer.isBuffer(val) ? val : $802fd0de90cfa455$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $802fd0de90cfa455$var$errors = {};
function $802fd0de90cfa455$var$E(sym, getMessage, Base) {
    $802fd0de90cfa455$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$802fd0de90cfa455$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$802fd0de90cfa455$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$802fd0de90cfa455$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $802fd0de90cfa455$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $802fd0de90cfa455$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $802fd0de90cfa455$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength) {
    $802fd0de90cfa455$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $802fd0de90cfa455$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $802fd0de90cfa455$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $802fd0de90cfa455$var$checkBounds(buf, offset, byteLength);
}
function $802fd0de90cfa455$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $802fd0de90cfa455$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $802fd0de90cfa455$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $802fd0de90cfa455$var$validateNumber(value, type);
        throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $802fd0de90cfa455$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $802fd0de90cfa455$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $802fd0de90cfa455$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $802fd0de90cfa455$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($802fd0de90cfa455$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $802fd0de90cfa455$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $802fd0de90cfa455$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $802fd0de90cfa455$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $802fd0de90cfa455$var$base64ToBytes(str) {
    return $bf94c29cc99c1571$export$d622b2ad8d90c771($802fd0de90cfa455$var$base64clean(str));
}
function $802fd0de90cfa455$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $802fd0de90cfa455$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $802fd0de90cfa455$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $802fd0de90cfa455$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $802fd0de90cfa455$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $802fd0de90cfa455$var$BufferBigIntNotDefined : fn;
}
function $802fd0de90cfa455$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $4a7af53cd3e5f045$require$Buffer = $802fd0de90cfa455$export$a143d493d941bafc;
'use strict';

var $4a7af53cd3e5f045$require$existsSync = $5d37787af79cd1f2$exports.existsSync;
var $4a7af53cd3e5f045$require$readFileSync = $5d37787af79cd1f2$exports.readFileSync;
var $4a7af53cd3e5f045$require$realpathSync = $5d37787af79cd1f2$exports.realpathSync;

var $4a7af53cd3e5f045$require$dirname = $5d37787af79cd1f2$exports.dirname;
var $4a7af53cd3e5f045$require$isAbsolute = $5d37787af79cd1f2$exports.isAbsolute;
var $4a7af53cd3e5f045$require$join = $5d37787af79cd1f2$exports.join;
var $4a7af53cd3e5f045$require$relative = $5d37787af79cd1f2$exports.relative;
var $4a7af53cd3e5f045$require$sep = $5d37787af79cd1f2$exports.sep;

var $4a7af53cd3e5f045$require$SourceMapConsumer = $5d37787af79cd1f2$exports.SourceMapConsumer;
var $4a7af53cd3e5f045$require$SourceMapGenerator = $5d37787af79cd1f2$exports.SourceMapGenerator;
function $4a7af53cd3e5f045$var$realPath(path) {
    try {
        return $4a7af53cd3e5f045$require$realpathSync(path);
    } catch  {
        // Missing or dangling: keep the literal path. The existsSync() check below
        // still gates the read, and a path that does not exist cannot escape.
        return path;
    }
}
function $4a7af53cd3e5f045$var$fromBase64(str) {
    if ($4a7af53cd3e5f045$require$Buffer) return $4a7af53cd3e5f045$require$Buffer.from(str, 'base64').toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $4a7af53cd3e5f045$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        if (opts.unsafeMap) this.unsafeMap = true;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, 'data:');
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $4a7af53cd3e5f045$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $4a7af53cd3e5f045$require$SourceMapConsumer(this.json || this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        let uriMatch = text.match(charsetUri) || text.match(uri);
        if (uriMatch) return decodeURIComponent(text.substr(uriMatch[0].length));
        let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
        if (baseUriMatch) return $4a7af53cd3e5f045$var$fromBase64(text.substr(baseUriMatch[0].length));
        let encoding = text.slice(22);
        encoding = encoding.slice(0, encoding.indexOf(','));
        throw new Error('Unsupported source map encoding ' + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim();
    }
    isMap(map) {
        if (typeof map !== 'object') return false;
        return typeof map.mappings === 'string' || typeof map._mappings === 'string' || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/g);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf('*/', start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path, cssFile, trusted) {
        if (!trusted && !this.unsafeMap) {
            if (!/\.map$/i.test(path)) return undefined;
            if (!cssFile) return undefined;
            // Compare *resolved* paths: relative() is textual, so without this a
            // symlink at or below the CSS file's directory points the map outside it.
            let rel = $4a7af53cd3e5f045$require$relative($4a7af53cd3e5f045$var$realPath($4a7af53cd3e5f045$require$dirname(cssFile)), $4a7af53cd3e5f045$var$realPath(path));
            if (rel === '..' || rel.startsWith('..' + $4a7af53cd3e5f045$require$sep) || $4a7af53cd3e5f045$require$isAbsolute(rel)) return undefined;
        }
        this.root = $4a7af53cd3e5f045$require$dirname(path);
        if ($4a7af53cd3e5f045$require$existsSync(path)) {
            this.mapFile = path;
            return $4a7af53cd3e5f045$require$readFileSync(path, 'utf-8').toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === 'string') return prev;
            else if (typeof prev === 'function') {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath, file, true);
                    if (!map) throw new Error('Unable to load previous source map: ' + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $4a7af53cd3e5f045$require$SourceMapConsumer) return $4a7af53cd3e5f045$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $4a7af53cd3e5f045$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error('Unsupported previous source map format: ' + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $4a7af53cd3e5f045$require$join($4a7af53cd3e5f045$require$dirname(file), map);
            let unknown = this.loadFile(map, file, false);
            if (unknown) try {
                /* c8 ignore next 4 */ this.json = JSON.parse(unknown.replace(/^\)]}'[^\n]*\n/, ''));
            } catch  {
                return undefined;
            }
            return unknown;
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
$4a7af53cd3e5f045$exports = $4a7af53cd3e5f045$var$PreviousMap;
$4a7af53cd3e5f045$var$PreviousMap.default = $4a7af53cd3e5f045$var$PreviousMap;



let $59d77a69a0b8aad2$var$lineToIndexCache = Symbol('lineToIndexCache');
let $59d77a69a0b8aad2$var$sourceMapAvailable = Boolean($59d77a69a0b8aad2$require$SourceMapConsumer && $59d77a69a0b8aad2$require$SourceMapGenerator);
let $59d77a69a0b8aad2$var$pathAvailable = Boolean($59d77a69a0b8aad2$require$resolve && $59d77a69a0b8aad2$require$isAbsolute);
function $59d77a69a0b8aad2$var$getLineToIndex(input) {
    if (input[$59d77a69a0b8aad2$var$lineToIndexCache]) return input[$59d77a69a0b8aad2$var$lineToIndexCache];
    let lines = input.css.split('\n');
    let lineToIndex = new Array(lines.length);
    let prevIndex = 0;
    for(let i = 0, l = lines.length; i < l; i++){
        lineToIndex[i] = prevIndex;
        prevIndex += lines[i].length + 1;
    }
    input[$59d77a69a0b8aad2$var$lineToIndexCache] = lineToIndex;
    return lineToIndex;
}
class $59d77a69a0b8aad2$var$Input {
    get from() {
        return this.file || this.id;
    }
    constructor(css, opts = {}){
        if (css === null || typeof css === 'undefined' || typeof css === 'object' && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        this.document = this.css;
        if (opts.document) this.document = opts.document.toString();
        if (opts.from) {
            if (!$59d77a69a0b8aad2$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $59d77a69a0b8aad2$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $59d77a69a0b8aad2$require$resolve(opts.from);
        }
        if ($59d77a69a0b8aad2$var$pathAvailable && $59d77a69a0b8aad2$var$sourceMapAvailable) {
            let map = new $4a7af53cd3e5f045$exports(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = '<input css ' + $59d77a69a0b8aad2$require$nanoid(6) + '>';
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let endColumn, endLine, endOffset, offset, result;
        if (line && typeof line === 'object') {
            let start = line;
            let end = column;
            if (typeof start.offset === 'number') {
                offset = start.offset;
                let pos = this.fromOffset(offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
                offset = this.fromLineAndColumn(line, column);
            }
            if (typeof end.offset === 'number') {
                endOffset = end.offset;
                let pos = this.fromOffset(endOffset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
                endOffset = this.fromLineAndColumn(end.line, end.column);
            }
        } else if (!column) {
            offset = line;
            let pos = this.fromOffset(offset);
            line = pos.line;
            column = pos.col;
        } else offset = this.fromLineAndColumn(line, column);
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $8b986f4ac1a8e843$exports(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $8b986f4ac1a8e843$exports(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            endOffset: endOffset,
            line: line,
            offset: offset,
            source: this.css
        };
        if (this.file) {
            if ($59d77a69a0b8aad2$require$pathToFileURL) result.input.url = $59d77a69a0b8aad2$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    fromLineAndColumn(line, column) {
        let lineToIndex = $59d77a69a0b8aad2$var$getLineToIndex(this);
        let index = lineToIndex[line - 1];
        return index + column - 1;
    }
    fromOffset(offset) {
        let lineToIndex = $59d77a69a0b8aad2$var$getLineToIndex(this);
        let lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $59d77a69a0b8aad2$require$resolve(this.map.consumer().sourceRoot || this.map.root || '.', file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column - 1,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === 'number') {
            let toPosition = consumer.originalPositionFor({
                column: endColumn - 1,
                line: endLine
            });
            // The source map may not have a mapping that covers the end position
            // (`originalPositionFor()` then returns `null` for `line`/`column`
            // instead of omitting them). Treat that the same as not requesting
            // an end position at all, so `endLine`/`endColumn` stay a consistent
            // `undefined` pair instead of a mix of `null` and a bogus number.
            if (toPosition.source) to = toPosition;
        }
        let fromUrl;
        if ($59d77a69a0b8aad2$require$isAbsolute(from.source)) fromUrl = $59d77a69a0b8aad2$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $59d77a69a0b8aad2$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column + 1,
            endColumn: to && to.column + 1,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === 'file:') {
            if ($59d77a69a0b8aad2$require$fileURLToPath) result.file = $59d77a69a0b8aad2$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            'hasBOM',
            'css',
            'file',
            'id'
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
}
$59d77a69a0b8aad2$exports = $59d77a69a0b8aad2$var$Input;
$59d77a69a0b8aad2$var$Input.default = $59d77a69a0b8aad2$var$Input;
if ($5d37787af79cd1f2$exports && $5d37787af79cd1f2$exports.registerInput) $5d37787af79cd1f2$exports.registerInput($59d77a69a0b8aad2$var$Input);



var $8980ae1ba9ec4c00$exports = {};
'use strict';

let $8980ae1ba9ec4c00$var$LazyResult, $8980ae1ba9ec4c00$var$Processor;
class $8980ae1ba9ec4c00$var$Root extends $9c7747aa3f740b69$exports {
    constructor(defaults){
        super(defaults);
        this.type = 'root';
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let keepBefore = new Set();
        for (let node of Array.isArray(child) ? child : [
            child
        ])if (node && typeof node === 'object' && !node.parent && node.raws && typeof node.raws.before !== 'undefined') keepBefore.add(node.raws);
        let nodes = super.normalize(child);
        if (sample) {
            if (type === 'prepend') {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) {
                for (let node of nodes)if (!keepBefore.has(node.raws)) node.raws.before = sample.raws.before;
            }
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $8980ae1ba9ec4c00$var$LazyResult(new $8980ae1ba9ec4c00$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$8980ae1ba9ec4c00$var$Root.registerLazyResult = (dependant)=>{
    $8980ae1ba9ec4c00$var$LazyResult = dependant;
};
$8980ae1ba9ec4c00$var$Root.registerProcessor = (dependant)=>{
    $8980ae1ba9ec4c00$var$Processor = dependant;
};
$8980ae1ba9ec4c00$exports = $8980ae1ba9ec4c00$var$Root;
$8980ae1ba9ec4c00$var$Root.default = $8980ae1ba9ec4c00$var$Root;
$9c7747aa3f740b69$exports.registerRoot($8980ae1ba9ec4c00$var$Root);


var $022dabbf283c8d00$exports = {};
'use strict';

var $d1b044c6ccecfc04$exports = {};
'use strict';
let $d1b044c6ccecfc04$var$list = {
    comma (string) {
        return $d1b044c6ccecfc04$var$list.split(string, [
            ','
        ], true);
    },
    space (string) {
        let spaces = [
            ' ',
            '\n',
            '\t'
        ];
        return $d1b044c6ccecfc04$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        if (typeof string !== 'string') return [];
        let array = [];
        let current = '';
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = '';
        let escape = false;
        let inComment = false;
        for(let i = 0; i < string.length; i++){
            let letter = string[i];
            if (inComment) {
                current += letter;
                if (letter === '*' && string[i + 1] === '/') {
                    current += '/';
                    i += 1;
                    inComment = false;
                }
                continue;
            }
            if (escape) escape = false;
            else if (letter === '\\') escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === '/' && string[i + 1] === '*') {
                current += '/*';
                i += 1;
                inComment = true;
                continue;
            } else if (letter === '(') func += 1;
            else if (letter === ')') {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                let value = current.trim();
                if (last || value !== '') array.push(value);
                current = '';
                split = false;
            } else current += letter;
        }
        let value = current.trim();
        if (last || value !== '') array.push(value);
        return array;
    }
};
$d1b044c6ccecfc04$exports = $d1b044c6ccecfc04$var$list;
$d1b044c6ccecfc04$var$list.default = $d1b044c6ccecfc04$var$list;


class $022dabbf283c8d00$var$Rule extends $9c7747aa3f740b69$exports {
    get selectors() {
        return $d1b044c6ccecfc04$exports.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
        this.selector = values.join(sep);
    }
    constructor(defaults){
        super(defaults);
        this.type = 'rule';
        if (!this.nodes) this.nodes = [];
    }
}
$022dabbf283c8d00$exports = $022dabbf283c8d00$var$Rule;
$022dabbf283c8d00$var$Rule.default = $022dabbf283c8d00$var$Rule;
$9c7747aa3f740b69$exports.registerRule($022dabbf283c8d00$var$Rule);


function $4cc8f496d0297ebf$var$hydrateInputs(json, inputs) {
    if (!json.inputs) return inputs;
    return json.inputs.map((input)=>{
        let inputHydrated = {
            ...input,
            __proto__: $59d77a69a0b8aad2$exports.prototype
        };
        if (inputHydrated.map) inputHydrated.map = {
            ...inputHydrated.map,
            __proto__: $4a7af53cd3e5f045$exports.prototype
        };
        return inputHydrated;
    });
}
function $4cc8f496d0297ebf$var$constructNode(json, inputs, children) {
    let defaults = {
        ...json
    };
    delete defaults.inputs;
    delete defaults.nodes;
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    let node;
    if (defaults.type === 'root') node = new $8980ae1ba9ec4c00$exports(defaults);
    else if (defaults.type === 'decl') node = new $22b80642d0efd425$exports(defaults);
    else if (defaults.type === 'rule') node = new $022dabbf283c8d00$exports(defaults);
    else if (defaults.type === 'comment') node = new $2e921bc74e628e3a$exports(defaults);
    else if (defaults.type === 'atrule') node = new $a78ea87fe43177f4$exports(defaults);
    else throw new Error('Unknown node type: ' + json.type);
    // Rehydrated children are attached after construction. Passing them
    // through the container constructor would re-run insertion spacing
    // normalization and overwrite each child's own `raws.before`.
    if (children) {
        node.nodes = children;
        for (let child of children)child.parent = node;
    }
    return node;
}
function $4cc8f496d0297ebf$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$4cc8f496d0297ebf$var$fromJSON(n));
    // An explicit stack instead of recursive calls to survive deeply
    // nested trees. Children are rehydrated before their parent node
    // is constructed.
    let result;
    let stack = [
        {
            childIndex: 0,
            children: [],
            inputs: $4cc8f496d0297ebf$var$hydrateInputs(json, inputs),
            json: json
        }
    ];
    while(stack.length > 0){
        let frame = stack[stack.length - 1];
        let jsonNodes = frame.json.nodes;
        if (jsonNodes && frame.childIndex < jsonNodes.length) {
            let childJson = jsonNodes[frame.childIndex];
            frame.childIndex += 1;
            stack.push({
                childIndex: 0,
                children: [],
                inputs: $4cc8f496d0297ebf$var$hydrateInputs(childJson, frame.inputs),
                json: childJson
            });
            continue;
        }
        stack.pop();
        let node = $4cc8f496d0297ebf$var$constructNode(frame.json, frame.inputs, jsonNodes ? frame.children : undefined);
        if (stack.length > 0) stack[stack.length - 1].children.push(node);
        else result = node;
    }
    return result;
}
$4cc8f496d0297ebf$exports = $4cc8f496d0297ebf$var$fromJSON;
$4cc8f496d0297ebf$var$fromJSON.default = $4cc8f496d0297ebf$var$fromJSON;



var $a430195894949955$exports = {};
'use strict';


var $3ef6d51b5944036e$exports = {};

var $3ef6d51b5944036e$require$Buffer = $802fd0de90cfa455$export$a143d493d941bafc;
'use strict';

var $3ef6d51b5944036e$require$dirname = $5d37787af79cd1f2$exports.dirname;
var $3ef6d51b5944036e$require$relative = $5d37787af79cd1f2$exports.relative;
var $3ef6d51b5944036e$require$resolve = $5d37787af79cd1f2$exports.resolve;
var $3ef6d51b5944036e$require$sep = $5d37787af79cd1f2$exports.sep;

var $3ef6d51b5944036e$require$SourceMapConsumer = $5d37787af79cd1f2$exports.SourceMapConsumer;
var $3ef6d51b5944036e$require$SourceMapGenerator = $5d37787af79cd1f2$exports.SourceMapGenerator;

var $3ef6d51b5944036e$require$pathToFileURL = $5d37787af79cd1f2$exports.pathToFileURL;

let $3ef6d51b5944036e$var$sourceMapAvailable = Boolean($3ef6d51b5944036e$require$SourceMapConsumer && $3ef6d51b5944036e$require$SourceMapGenerator);
let $3ef6d51b5944036e$var$pathAvailable = Boolean($3ef6d51b5944036e$require$dirname && $3ef6d51b5944036e$require$resolve && $3ef6d51b5944036e$require$relative && $3ef6d51b5944036e$require$sep);
class $3ef6d51b5944036e$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = 'data:application/json;base64,' + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === 'string') content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === 'function') content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + '.map';
        let eol = '\n';
        if (this.css.includes('\r\n')) eol = '\r\n';
        this.css += eol + '/*# sourceMappingURL=' + content + ' */';
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $3ef6d51b5944036e$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $3ef6d51b5944036e$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== 'comment') continue;
                if (node.text.startsWith('# sourceMappingURL=')) this.root.removeChild(i);
            }
        } else if (this.css) {
            // Single forward pass. Removing every annotation from the whole
            // string separately would be O(n^2) on many annotations.
            let annotation = '/*# sourceMappingURL=';
            let css = '';
            let cursor = 0;
            let startIndex;
            while((startIndex = this.css.indexOf(annotation, cursor)) !== -1){
                let endIndex = this.css.indexOf('*/', startIndex + annotation.length);
                if (endIndex === -1) break;
                while(startIndex > cursor && this.css[startIndex - 1] === '\n')startIndex--;
                css += this.css.slice(cursor, startIndex);
                cursor = endIndex + 2;
            }
            if (cursor > 0) this.css = css + this.css.slice(cursor);
        }
    }
    generate() {
        this.clearAnnotation();
        if ($3ef6d51b5944036e$var$pathAvailable && $3ef6d51b5944036e$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = '';
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $3ef6d51b5944036e$require$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $3ef6d51b5944036e$require$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>'
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = '';
        this.map = new $3ef6d51b5944036e$require$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = '<no source>';
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ''
        };
        let last, lines;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== 'end') {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf('\n');
                column = str.length - last;
            } else column += str.length;
            if (node && type !== 'start') {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === 'decl' || node.type === 'atrule' && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== 'undefined') return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== 'undefined') return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== 'undefined' && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== 'undefined') return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== 'undefined') return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return 'to.css';
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $3ef6d51b5944036e$require$dirname(this.opts.to) : '.';
        if (typeof this.mapOpts.annotation === 'string') from = $3ef6d51b5944036e$require$dirname($3ef6d51b5944036e$require$resolve(from, this.mapOpts.annotation));
        let path = $3ef6d51b5944036e$require$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $59d77a69a0b8aad2$exports(this.originalCSS, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : '<no source>';
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($3ef6d51b5944036e$require$Buffer) return $3ef6d51b5944036e$require$Buffer.from(str).toString('base64');
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($3ef6d51b5944036e$require$pathToFileURL) {
            let fileURL = $3ef6d51b5944036e$require$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error('`map.absolute` option is not available in this PostCSS build');
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($3ef6d51b5944036e$require$sep === '\\') path = path.replace(/\\/g, '/');
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
}
$3ef6d51b5944036e$exports = $3ef6d51b5944036e$var$MapGenerator;


var $49d14f04666a0dc5$exports = {};
'use strict';


var $5b7e11c57b21202f$exports = {};
'use strict';





var $49d10d8c523fcce9$exports = {};
'use strict';
const $49d10d8c523fcce9$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $49d10d8c523fcce9$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $49d10d8c523fcce9$var$BACKSLASH = '\\'.charCodeAt(0);
const $49d10d8c523fcce9$var$SLASH = '/'.charCodeAt(0);
const $49d10d8c523fcce9$var$NEWLINE = '\n'.charCodeAt(0);
const $49d10d8c523fcce9$var$SPACE = ' '.charCodeAt(0);
const $49d10d8c523fcce9$var$FEED = '\f'.charCodeAt(0);
const $49d10d8c523fcce9$var$TAB = '\t'.charCodeAt(0);
const $49d10d8c523fcce9$var$CR = '\r'.charCodeAt(0);
const $49d10d8c523fcce9$var$OPEN_SQUARE = '['.charCodeAt(0);
const $49d10d8c523fcce9$var$CLOSE_SQUARE = ']'.charCodeAt(0);
const $49d10d8c523fcce9$var$OPEN_PARENTHESES = '('.charCodeAt(0);
const $49d10d8c523fcce9$var$CLOSE_PARENTHESES = ')'.charCodeAt(0);
const $49d10d8c523fcce9$var$OPEN_CURLY = '{'.charCodeAt(0);
const $49d10d8c523fcce9$var$CLOSE_CURLY = '}'.charCodeAt(0);
const $49d10d8c523fcce9$var$SEMICOLON = ';'.charCodeAt(0);
const $49d10d8c523fcce9$var$ASTERISK = '*'.charCodeAt(0);
const $49d10d8c523fcce9$var$COLON = ':'.charCodeAt(0);
const $49d10d8c523fcce9$var$AT = '@'.charCodeAt(0);
const $49d10d8c523fcce9$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $49d10d8c523fcce9$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $49d10d8c523fcce9$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $49d10d8c523fcce9$var$RE_HEX_ESCAPE = /[\da-f]/i;
$49d10d8c523fcce9$exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, content, escape, next, quote;
    let currentToken, escaped, escapePos, n, prev;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    let lastBadParen = -1;
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error('Unclosed ' + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $49d10d8c523fcce9$var$NEWLINE:
            case $49d10d8c523fcce9$var$SPACE:
            case $49d10d8c523fcce9$var$TAB:
            case $49d10d8c523fcce9$var$CR:
            case $49d10d8c523fcce9$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $49d10d8c523fcce9$var$SPACE || code === $49d10d8c523fcce9$var$NEWLINE || code === $49d10d8c523fcce9$var$TAB || code === $49d10d8c523fcce9$var$CR || code === $49d10d8c523fcce9$var$FEED);
                currentToken = [
                    'space',
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $49d10d8c523fcce9$var$OPEN_SQUARE:
            case $49d10d8c523fcce9$var$CLOSE_SQUARE:
            case $49d10d8c523fcce9$var$OPEN_CURLY:
            case $49d10d8c523fcce9$var$CLOSE_CURLY:
            case $49d10d8c523fcce9$var$COLON:
            case $49d10d8c523fcce9$var$SEMICOLON:
            case $49d10d8c523fcce9$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $49d10d8c523fcce9$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : '';
                n = css.charCodeAt(pos + 1);
                if (prev === 'url' && n !== $49d10d8c523fcce9$var$SINGLE_QUOTE && n !== $49d10d8c523fcce9$var$DOUBLE_QUOTE && n !== $49d10d8c523fcce9$var$SPACE && n !== $49d10d8c523fcce9$var$NEWLINE && n !== $49d10d8c523fcce9$var$TAB && n !== $49d10d8c523fcce9$var$FEED && n !== $49d10d8c523fcce9$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(')', next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed('bracket');
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $49d10d8c523fcce9$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        'brackets',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else if (pos <= lastBadParen) currentToken = [
                    '(',
                    '(',
                    pos
                ];
                else {
                    next = css.indexOf(')', pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $49d10d8c523fcce9$var$RE_BAD_BRACKET.test(content)) {
                        lastBadParen = next === -1 ? length : next;
                        currentToken = [
                            '(',
                            '(',
                            pos
                        ];
                    } else {
                        currentToken = [
                            'brackets',
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $49d10d8c523fcce9$var$SINGLE_QUOTE:
            case $49d10d8c523fcce9$var$DOUBLE_QUOTE:
                quote = code === $49d10d8c523fcce9$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed('string');
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $49d10d8c523fcce9$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    'string',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $49d10d8c523fcce9$var$AT:
                $49d10d8c523fcce9$var$RE_AT_END.lastIndex = pos + 1;
                $49d10d8c523fcce9$var$RE_AT_END.test(css);
                if ($49d10d8c523fcce9$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $49d10d8c523fcce9$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    'at-word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $49d10d8c523fcce9$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $49d10d8c523fcce9$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $49d10d8c523fcce9$var$SLASH && code !== $49d10d8c523fcce9$var$SPACE && code !== $49d10d8c523fcce9$var$NEWLINE && code !== $49d10d8c523fcce9$var$TAB && code !== $49d10d8c523fcce9$var$CR && code !== $49d10d8c523fcce9$var$FEED) {
                    next += 1;
                    if ($49d10d8c523fcce9$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($49d10d8c523fcce9$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $49d10d8c523fcce9$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    'word',
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $49d10d8c523fcce9$var$SLASH && css.charCodeAt(pos + 1) === $49d10d8c523fcce9$var$ASTERISK) {
                    next = css.indexOf('*/', pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed('comment');
                    }
                    currentToken = [
                        'comment',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $49d10d8c523fcce9$var$RE_WORD_END.lastIndex = pos + 1;
                    $49d10d8c523fcce9$var$RE_WORD_END.test(css);
                    if ($49d10d8c523fcce9$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $49d10d8c523fcce9$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        'word',
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};


const $5b7e11c57b21202f$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $5b7e11c57b21202f$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
function $5b7e11c57b21202f$var$tokensToString(tokens, from, to) {
    let result = '';
    for(let i = from; i < to; i++)result += tokens[i][1];
    return result;
}
class $5b7e11c57b21202f$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $8980ae1ba9ec4c00$exports();
        this.current = this.root;
        this.spaces = '';
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $a78ea87fe43177f4$exports();
        node.name = token[1].slice(1);
        if (node.name === '') this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === '(' || type === '[') brackets.push(type === '(' ? ')' : ']');
            else if (type === '{' && brackets.length > 0) brackets.push('}');
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ';') {
                    node.source.end = this.getPosition(token[2]);
                    node.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === '{') {
                    open = true;
                    break;
                } else if (type === '}') {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === 'space')prev = params[--shift];
                        if (prev) {
                            node.source.end = this.getPosition(prev[3] || prev[2]);
                            node.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, 'params', params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                this.spaces = node.raws.between;
                node.raws.between = '';
            }
        } else {
            node.raws.afterName = '';
            node.params = '';
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== 'space') {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid
        // property's value. Then we need to return the colon after that word
        // token. [3] is the "end" colon of that word. And because we need it
        // after that one we do +1 to get the next one.
        throw this.input.error('Missed semicolon', token[0] === 'word' ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let prev, token, type;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === '(') brackets += 1;
            if (type === ')') brackets -= 1;
            if (brackets === 0 && type === ':') {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === 'word' && prev[1] === 'progid') continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $2e921bc74e628e3a$exports();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (!text.trim()) {
            node.text = '';
            node.raws.left = text;
            node.raws.right = '';
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $49d10d8c523fcce9$exports(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $22b80642d0efd425$exports();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ';') {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $5b7e11c57b21202f$var$findLastWithPosition(tokens));
        node.source.end.offset++;
        let start = 0;
        while(tokens[start][0] !== 'word'){
            if (start === tokens.length - 1) this.unknownWord([
                tokens[start]
            ]);
            start++;
        }
        node.raws.before += $5b7e11c57b21202f$var$tokensToString(tokens, 0, start);
        node.source.start = this.getPosition(tokens[start][2]);
        let propStart = start;
        while(start < tokens.length){
            let type = tokens[start][0];
            if (type === ':' || type === 'space' || type === 'comment') break;
            start++;
        }
        node.prop = $5b7e11c57b21202f$var$tokensToString(tokens, propStart, start);
        let betweenStart = start;
        let token;
        while(start < tokens.length){
            token = tokens[start];
            start++;
            if (token[0] === ':') break;
            if (token[0] === 'word' && /\w/.test(token[1])) this.unknownWord([
                token
            ]);
        }
        node.raws.between = $5b7e11c57b21202f$var$tokensToString(tokens, betweenStart, start);
        if (node.prop[0] === '_' || node.prop[0] === '*') {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpacesStart = start;
        while(start < tokens.length){
            let next = tokens[start][0];
            if (next !== 'space' && next !== 'comment') break;
            start++;
        }
        let firstSpaces = tokens.slice(firstSpacesStart, start);
        tokens = tokens.slice(start);
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === '!important') {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== ' !important') node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === 'important') {
                let cache = tokens.slice(0);
                let str = '';
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().startsWith('!') && type !== 'space') break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().startsWith('!')) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== 'space' && token[0] !== 'comment') break;
        }
        let hasWord = tokens.some((i)=>i[0] !== 'space' && i[0] !== 'comment');
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join('');
            firstSpaces = [];
        }
        this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(':') && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error('Double colon', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $022dabbf283c8d00$exports();
        this.init(node, token[2]);
        node.selector = '';
        node.raws.between = '';
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.spaces = '';
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = '';
                // `ownSemicolon` also holds the spaces before the semicolon, but
                // the position above is the semicolon itself, so the node ends
                // right after it.
                prev.source.end = this.getPosition(token[2]);
                prev.source.end.offset++;
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = '';
        if (node.type !== 'comment') this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith('--');
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === '(' || type === '[') {
                if (!bracket) bracket = token;
                brackets.push(type === '(' ? ')' : ']');
            } else if (customProperty && colon && type === '{') {
                if (!bracket) bracket = token;
                brackets.push('}');
            } else if (brackets.length === 0) {
                if (type === ';') {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === '{') {
                    this.rule(tokens);
                    return;
                } else if (type === '}') {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ':') colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== 'space' && token !== 'comment') break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case 'space':
                    this.spaces += token[1];
                    break;
                case ';':
                    this.freeSemicolon(token);
                    break;
                case '}':
                    this.end(token);
                    break;
                case 'comment':
                    this.comment(token);
                    break;
                case 'at-word':
                    this.atrule(token);
                    break;
                case '{':
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = '';
        // Last character of `value`. Reading it from `value` would flatten
        // the string concatenation on every comment and make parsing O(n^2).
        let last = '';
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === 'space' && i === length - 1 && !customProperty) clean = false;
            else if (type === 'comment') {
                prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
                next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
                if (!$5b7e11c57b21202f$var$SAFE_COMMENT_NEIGHBOR[prev] && !$5b7e11c57b21202f$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (last === ',') clean = false;
                    else {
                        value += token[1];
                        last = token[1].slice(-1);
                    }
                } else clean = false;
            } else {
                value += token[1];
                last = token[1].slice(-1);
            }
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], '');
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $022dabbf283c8d00$exports();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, 'selector', tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = '';
        while(tokens.length){
            next = tokens[0][0];
            if (next !== 'space' && next !== 'comment') break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = '';
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== 'space') break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = '';
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error('Unclosed block', pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error('Unclosed bracket', {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error('Unexpected }', {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error('Unknown word ' + tokens[0][1], {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error('At-rule without name', {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
$5b7e11c57b21202f$exports = $5b7e11c57b21202f$var$Parser;


function $49d14f04666a0dc5$var$parse(css, opts) {
    let input = new $59d77a69a0b8aad2$exports(css, opts);
    let parser = new $5b7e11c57b21202f$exports(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
$49d14f04666a0dc5$exports = $49d14f04666a0dc5$var$parse;
$49d14f04666a0dc5$var$parse.default = $49d14f04666a0dc5$var$parse;
$9c7747aa3f740b69$exports.registerParse($49d14f04666a0dc5$var$parse);


var $7be1fb985c28fab1$exports = {};
'use strict';
var $28eabb141cb1b59c$exports = {};
'use strict';


var $28eabb141cb1b59c$require$my = $805ec064d50ece30$export$94fa0a6beb22f989;
class $28eabb141cb1b59c$var$Warning {
    constructor(text, opts = {}){
        this.type = 'warning';
        this.text = text;
        if (opts.node && opts.node.source) {
            if (!opts.node[$28eabb141cb1b59c$require$my]) // The node comes from another PostCSS copy in node_modules, so it does
            // not have this copy’s methods. Container#normalize() rebuilds such
            // nodes on insert, but a node passed straight to Result#warn() never
            // goes through it.
            $9c7747aa3f740b69$exports.rebuild(opts.node);
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ': ' + this.text;
        return this.text;
    }
}
$28eabb141cb1b59c$exports = $28eabb141cb1b59c$var$Warning;
$28eabb141cb1b59c$var$Warning.default = $28eabb141cb1b59c$var$Warning;


class $7be1fb985c28fab1$var$Result {
    get content() {
        return this.css;
    }
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = '';
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $28eabb141cb1b59c$exports(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === 'warning');
    }
}
$7be1fb985c28fab1$exports = $7be1fb985c28fab1$var$Result;
$7be1fb985c28fab1$var$Result.default = $7be1fb985c28fab1$var$Result;





var $a430195894949955$require$isClean = $805ec064d50ece30$export$ae5e7911ce0728f9;
var $a430195894949955$require$my = $805ec064d50ece30$export$94fa0a6beb22f989;
var $781efb7f055be5d5$exports = {};
/* eslint-disable no-console */ 'use strict';
let $781efb7f055be5d5$var$printed = {};
$781efb7f055be5d5$exports = function warnOnce(message) {
    if ($781efb7f055be5d5$var$printed[message]) return;
    $781efb7f055be5d5$var$printed[message] = true;
    if (typeof console !== 'undefined' && console.warn) console.warn(message);
};


const $a430195894949955$var$TYPE_TO_CLASS_NAME = {
    atrule: 'AtRule',
    comment: 'Comment',
    decl: 'Declaration',
    document: 'Document',
    root: 'Root',
    rule: 'Rule'
};
const $a430195894949955$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $a430195894949955$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $a430195894949955$var$CHILDREN = 0;
function $a430195894949955$var$isPromise(obj) {
    return typeof obj === 'object' && typeof obj.then === 'function';
}
function $a430195894949955$var$getEvents(node) {
    let key = false;
    let type = $a430195894949955$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === 'decl') key = node.prop.toLowerCase();
    else if (node.type === 'atrule') key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + '-' + key,
        $a430195894949955$var$CHILDREN,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (key) return [
        type,
        type + '-' + key,
        type + 'Exit',
        type + 'Exit-' + key
    ];
    else if (node.append) return [
        type,
        $a430195894949955$var$CHILDREN,
        type + 'Exit'
    ];
    else return [
        type,
        type + 'Exit'
    ];
}
function $a430195894949955$var$toStack(node) {
    let events;
    if (node.type === 'document') events = [
        'Document',
        $a430195894949955$var$CHILDREN,
        'DocumentExit'
    ];
    else if (node.type === 'root') events = [
        'Root',
        $a430195894949955$var$CHILDREN,
        'RootExit'
    ];
    else events = $a430195894949955$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $a430195894949955$var$cleanMarks(node) {
    let stack = [
        node
    ];
    while(stack.length > 0){
        let next = stack.pop();
        next[$a430195894949955$require$isClean] = false;
        if (next.nodes) for (let i of next.nodes)stack.push(i);
    }
    return node;
}
let $a430195894949955$var$postcss = {};
class $a430195894949955$var$LazyResult {
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return 'LazyResult';
    }
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) root = $a430195894949955$var$cleanMarks(css);
        else if (css instanceof $a430195894949955$var$LazyResult || css instanceof $7be1fb985c28fab1$exports) {
            root = $a430195894949955$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === 'undefined') opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $49d14f04666a0dc5$exports;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$a430195894949955$require$my]) /* c8 ignore next 2 */ $9c7747aa3f740b69$exports.rebuild(root);
        }
        this.result = new $7be1fb985c28fab1$exports(processor, root, opts);
        this.helpers = {
            ...$a430195894949955$var$postcss,
            postcss: $a430195894949955$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === 'object' && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error('Use process(css).then(cb) to work with async plugins');
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === 'CssSyntaxError' && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === 'object') for(let event in plugin){
                if (!$a430195894949955$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$a430195894949955$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === 'object') {
                        for(let filter in plugin[event])if (filter === '*') add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === 'function') add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($a430195894949955$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a430195894949955$require$isClean]){
                root[$a430195894949955$require$isClean] = true;
                let stack = [
                    $a430195894949955$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($a430195894949955$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === 'document') {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === 'object' && plugin.Once) {
                if (this.result.root.type === 'document') {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($a430195894949955$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === 'function') return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $a0cdc5c7a7f85333$exports;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let rootSource = this.result.root.source;
        if (opts.map === undefined && !(rootSource && rootSource.input && rootSource.input.map)) {
            let result = '';
            str(this.result.root, (i)=>{
                result += i;
            });
            this.result.css = result;
            return this.result;
        }
        let map = new $3ef6d51b5944036e$exports(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($a430195894949955$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a430195894949955$require$isClean]){
                root[$a430195894949955$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === 'document') for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== 'root' && node.type !== 'document' && !node.parent) return true;
            if ($a430195894949955$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            // Advance past the child we just finished visiting. Like
            // `Container#each`, the index is incremented only after a child has
            // been fully processed, so a node inserted right after the current
            // child is not skipped by the `existIndex < index` adjustment in
            // `Container#insertAfter()` (which would fire exit events too early).
            if (visit.descending) {
                visit.descending = false;
                node.indexes[iterator] += 1;
            }
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                if (!child[$a430195894949955$require$isClean]) {
                    child[$a430195894949955$require$isClean] = true;
                    visit.descending = true;
                    stack.push($a430195894949955$var$toStack(child));
                    return;
                }
                node.indexes[iterator] += 1;
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $a430195894949955$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$a430195894949955$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        // An explicit stack like in async `visitTick()` to survive deeply
        // nested trees. Unlike `visitTick()`, nodes are marked clean only
        // on entering, so a node dirtied by its own visitors is revisited
        // on the next pass.
        node[$a430195894949955$require$isClean] = true;
        let stack = [
            {
                eventIndex: 0,
                events: $a430195894949955$var$getEvents(node),
                iterator: 0,
                node: node
            }
        ];
        while(stack.length > 0){
            let visit = stack[stack.length - 1];
            let visitNode = visit.node;
            if (visit.iterator !== 0) {
                let iterator = visit.iterator;
                // Advance past the child we just finished visiting. Like
                // `Container#each`, the index is incremented only after a child has
                // been fully processed. Incrementing before (as this loop used to)
                // makes a node inserted right after the current child get skipped by
                // the `existIndex < index` adjustment in `Container#insertAfter()`,
                // which fires exit events before those new siblings are visited.
                if (visit.descending) {
                    visit.descending = false;
                    visitNode.indexes[iterator] += 1;
                }
                let child;
                let descended = false;
                while(child = visitNode.nodes[visitNode.indexes[iterator]]){
                    if (!child[$a430195894949955$require$isClean]) {
                        child[$a430195894949955$require$isClean] = true;
                        visit.descending = true;
                        stack.push({
                            eventIndex: 0,
                            events: $a430195894949955$var$getEvents(child),
                            iterator: 0,
                            node: child
                        });
                        descended = true;
                        break;
                    }
                    visitNode.indexes[iterator] += 1;
                }
                if (descended) continue;
                visit.iterator = 0;
                delete visitNode.indexes[iterator];
            }
            if (visit.eventIndex < visit.events.length) {
                let event = visit.events[visit.eventIndex];
                visit.eventIndex += 1;
                if (event === $a430195894949955$var$CHILDREN) {
                    if (visitNode.nodes && visitNode.nodes.length) visit.iterator = visitNode.getIterator();
                } else {
                    let visitors = this.listeners[event];
                    if (visitors) {
                        if (this.visitSync(visitors, visitNode.toProxy())) stack.pop();
                    }
                }
                continue;
            }
            stack.pop();
        }
    }
    warnings() {
        return this.sync().warnings();
    }
}
$a430195894949955$var$LazyResult.registerPostcss = (dependant)=>{
    $a430195894949955$var$postcss = dependant;
};
$a430195894949955$exports = $a430195894949955$var$LazyResult;
$a430195894949955$var$LazyResult.default = $a430195894949955$var$LazyResult;
$8980ae1ba9ec4c00$exports.registerLazyResult($a430195894949955$var$LazyResult);
$87768caed9f1aad4$exports.registerLazyResult($a430195894949955$var$LazyResult);





var $2ed6ea766e20131c$exports = {};
'use strict';


var $77ff663d24919b4e$exports = {};
'use strict';





class $77ff663d24919b4e$var$NoWorkResult {
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $49d14f04666a0dc5$exports;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return 'NoWorkResult';
    }
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let str = $a0cdc5c7a7f85333$exports;
        this.result = new $7be1fb985c28fab1$exports(this._processor, undefined, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, 'root', {
            get () {
                return self.root;
            }
        });
        let map = new $3ef6d51b5944036e$exports(str, undefined, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
}
$77ff663d24919b4e$exports = $77ff663d24919b4e$var$NoWorkResult;
$77ff663d24919b4e$var$NoWorkResult.default = $77ff663d24919b4e$var$NoWorkResult;



class $2ed6ea766e20131c$var$Processor {
    constructor(plugins = []){
        this.version = '8.5.30';
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === 'object' && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === 'object' && i.postcssPlugin) normalized.push(i);
            else if (typeof i === 'function') normalized.push(i);
            else if (typeof i === 'object' && (i.parse || i.stringify)) ;
            else throw new Error(i + ' is not a PostCSS plugin');
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $77ff663d24919b4e$exports(this, css, opts);
        else return new $a430195894949955$exports(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
$2ed6ea766e20131c$exports = $2ed6ea766e20131c$var$Processor;
$2ed6ea766e20131c$var$Processor.default = $2ed6ea766e20131c$var$Processor;
$8980ae1ba9ec4c00$exports.registerProcessor($2ed6ea766e20131c$var$Processor);
$87768caed9f1aad4$exports.registerProcessor($2ed6ea766e20131c$var$Processor);







function $3e8fd19c657ae5f6$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $2ed6ea766e20131c$exports(plugins);
}
$3e8fd19c657ae5f6$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ': postcss.plugin was deprecated. Migration guide:\n' + 'https://evilmartians.com/chronicles/postcss-8-plugin-migration');
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $2ed6ea766e20131c$exports().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, 'postcss', {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $3e8fd19c657ae5f6$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$3e8fd19c657ae5f6$var$postcss.stringify = $a0cdc5c7a7f85333$exports;
$3e8fd19c657ae5f6$var$postcss.parse = $49d14f04666a0dc5$exports;
$3e8fd19c657ae5f6$var$postcss.fromJSON = $4cc8f496d0297ebf$exports;
$3e8fd19c657ae5f6$var$postcss.list = $d1b044c6ccecfc04$exports;
$3e8fd19c657ae5f6$var$postcss.comment = (defaults)=>new $2e921bc74e628e3a$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.atRule = (defaults)=>new $a78ea87fe43177f4$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.decl = (defaults)=>new $22b80642d0efd425$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.rule = (defaults)=>new $022dabbf283c8d00$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.root = (defaults)=>new $8980ae1ba9ec4c00$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.document = (defaults)=>new $87768caed9f1aad4$exports(defaults);
$3e8fd19c657ae5f6$var$postcss.CssSyntaxError = $8b986f4ac1a8e843$exports;
$3e8fd19c657ae5f6$var$postcss.Declaration = $22b80642d0efd425$exports;
$3e8fd19c657ae5f6$var$postcss.Container = $9c7747aa3f740b69$exports;
$3e8fd19c657ae5f6$var$postcss.Processor = $2ed6ea766e20131c$exports;
$3e8fd19c657ae5f6$var$postcss.Document = $87768caed9f1aad4$exports;
$3e8fd19c657ae5f6$var$postcss.Comment = $2e921bc74e628e3a$exports;
$3e8fd19c657ae5f6$var$postcss.Warning = $28eabb141cb1b59c$exports;
$3e8fd19c657ae5f6$var$postcss.AtRule = $a78ea87fe43177f4$exports;
$3e8fd19c657ae5f6$var$postcss.Result = $7be1fb985c28fab1$exports;
$3e8fd19c657ae5f6$var$postcss.Input = $59d77a69a0b8aad2$exports;
$3e8fd19c657ae5f6$var$postcss.Rule = $022dabbf283c8d00$exports;
$3e8fd19c657ae5f6$var$postcss.Root = $8980ae1ba9ec4c00$exports;
$3e8fd19c657ae5f6$var$postcss.Node = $2ef5582d2243b2db$exports;
$a430195894949955$exports.registerPostcss($3e8fd19c657ae5f6$var$postcss);
$3e8fd19c657ae5f6$exports = $3e8fd19c657ae5f6$var$postcss;
$3e8fd19c657ae5f6$var$postcss.default = $3e8fd19c657ae5f6$var$postcss;


var $a95d59889df6cf5b$require$postcssParse = $3e8fd19c657ae5f6$exports.parse;
var $dbd9d38dc4b54e0d$exports = {};
var $ac909277c03a2df9$exports = {};
!function(t, e) {
    $ac909277c03a2df9$exports = e();
}($ac909277c03a2df9$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


// Strip characters browsers ignore inside URLs (control chars and
// embedded HTML comments) that are commonly used to sneak XSS
// payloads past simple scheme checks.
function $dbd9d38dc4b54e0d$var$cleanHref(href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    // eslint-disable-next-line no-control-regex
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    while(true){
        const firstIndex = href.indexOf('<!--');
        if (firstIndex === -1) break;
        const lastIndex = href.indexOf('-->', firstIndex + 4);
        if (lastIndex === -1) break;
        href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
    }
    return href;
}
// Returns true if `href` should be rejected as unsafe. Used to block
// `javascript:`, `data:` and other dangerous schemes both when
// validating URL fields and when sanitizing HTML attribute values.
//
// `options.allowedSchemes` is an array of permitted URL schemes
// (defaults to the schemes long permitted by `launder().url`).
// `options.allowProtocolRelative` controls whether protocol-relative
// URLs (e.g. `//example.com`) are permitted. Defaults to true.
function $dbd9d38dc4b54e0d$var$naughtyHref(href, options) {
    options = options || {};
    const allowedSchemes = options.allowedSchemes || [
        'http',
        'https',
        'ftp',
        'mailto',
        'tel',
        'sms'
    ];
    const allowProtocolRelative = options.allowProtocolRelative !== false;
    if (typeof href !== 'string') return false;
    href = $dbd9d38dc4b54e0d$var$cleanHref(href);
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    // Allow more characters after the first so we don't get faked
    // out by certain schemes browsers accept
    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!matches) {
        // Protocol-relative URL starting with any combination of '/' and '\'
        if (href.match(/^[/\\]{2}/)) return !allowProtocolRelative;
        // No scheme
        return false;
    }
    const scheme = matches[1].toLowerCase();
    return allowedSchemes.indexOf(scheme) === -1;
}
$dbd9d38dc4b54e0d$exports = function(options) {
    const self = {};
    self.options = options || {};
    self.filterTag = self.options.filterTag || function(tag) {
        tag = tag.trim();
        return tag.toLowerCase();
    };
    self.string = function(s, def) {
        if (typeof s !== 'string') {
            if (typeof s === 'number' || typeof s === 'boolean') s += '';
            else s = '';
        }
        s = s.trim();
        if (def !== undefined) {
            if (s === '') s = def;
        }
        return s;
    };
    self.strings = function(strings) {
        if (!Array.isArray(strings)) return [];
        return strings.map(function(s) {
            return self.string(s);
        });
    };
    self.integer = function(i, def, min, max) {
        if (def === undefined) def = 0;
        if (typeof i === 'number') i = Math.floor(i);
        else try {
            i = parseInt(i, 10);
            if (isNaN(i)) i = def;
        } catch (e) {
            i = def;
        }
        if (typeof min === 'number' && i < min) i = min;
        if (typeof max === 'number' && i > max) i = max;
        return i;
    };
    self.padInteger = function(i, places) {
        let s = i + '';
        while(s.length < places)s = '0' + s;
        return s;
    };
    self.float = function(i, def, min, max) {
        if (def === undefined) def = 0;
        if (!(typeof i === 'number')) try {
            i = parseFloat(i, 10);
            if (isNaN(i)) i = def;
        } catch (e) {
            i = def;
        }
        if (typeof min === 'number' && i < min) i = min;
        if (typeof max === 'number' && i > max) i = max;
        return i;
    };
    self.naughtyHref = $dbd9d38dc4b54e0d$var$naughtyHref;
    self.url = function(s, def, httpsFix) {
        s = self.string(s, def);
        // Allow the default to be undefined, null, false, etc.
        if (s === def) return s;
        // Strip characters browsers ignore that are commonly used to
        // smuggle dangerous schemes past validation.
        s = $dbd9d38dc4b54e0d$var$cleanHref(s);
        // Reject naughty URLs (e.g. `javascript:`, `data:`) before fixUrl
        // runs. Otherwise fixUrl could mask such schemes by prepending
        // `https://` to anything containing a `.`, turning
        // `javascript:alert(document.domain)` into a syntactically odd
        // but accepted `https://...` URL.
        if ($dbd9d38dc4b54e0d$var$naughtyHref(s)) return def;
        s = fixUrl(s);
        if (s === null) return def;
        return s;
        function fixUrl(href) {
            if (href.match(/^(((https?|ftp):\/\/)|((mailto|tel|sms):)|#|([^/.]+)?\/|[^/.]+$)/)) // All good - no change required
            return href;
            else if (href.match(/^[^/.]+\.[^/.]+/)) {
                // Smells like a domain name. Educated guess: they left off http://
                const protocol = httpsFix ? 'https://' : 'http://';
                return protocol + href;
            } else return null;
        }
    };
    self.select = function(s, choices, def) {
        s = self.string(s);
        if (!choices || !choices.length) return def;
        let choice;
        if (typeof choices[0] === 'object') {
            choice = choices.find(function(choice) {
                if (choice.value === null || choice.value === undefined) // Don't crash on invalid choices
                return false;
                return choice.value.toString() === s;
            });
            if (choice != null) return choice.value;
            return def;
        }
        choice = choices.find(function(choice) {
            if (choice === null || choice === undefined) // Don't crash on invalid choices
            return false;
            return choice.toString() === s;
        });
        if (choice !== undefined) return choice;
        return def;
    };
    self.boolean = function(b, def) {
        if (b === true) return true;
        if (b === false) return false;
        b = self.string(b, def);
        if (b === def) {
            if (b === undefined) return false;
            return b;
        }
        b = b.toLowerCase().charAt(0);
        if (b === '' || b === 'n' || b === '0' || b === 'f') return false;
        if (b === 't' || b === 'y' || b === '1') return true;
        return false;
    };
    // Given an `options` object in which options[name] is a string
    // set to '0', '1', or 'any', this method adds mongodb criteria
    // to the `criteria` object.
    //
    // '0' or false means "the property must be false or absent," '1' or true
    // means "the property must be true," and 'any' or null means "we don't care
    // what the property is."
    //
    // See `booleanOrNull` for additional synonyms accepted for the
    // three possible values.
    //
    // An empty string is considered equivalent to '0'.
    //
    // This is not the same as apos.sanitizeBoolean which is concerned only with
    // true or false and does not address "any."
    //
    // `def` defaults to `any`.
    //
    // This method is most often used with REST API parameters and forms.
    self.addBooleanFilterToCriteria = function(options, name, criteria, def) {
        // if any or null, we aren't changing criteria
        if (def === undefined) def = null;
        // allow object or boolean
        let value = typeof options === 'object' && options !== null ? options[name] : options;
        value = value === undefined ? def : value;
        value = self.booleanOrNull(value);
        if (value === null) ;
        else if (!value) // Must be absent or false. Hooray for $ne
        criteria[name] = {
            $ne: true
        };
        else // Must be true
        criteria[name] = true;
    };
    // This method is used for tristate filters, i.e. "published,"
    // "unpublished", and "show me both".
    //
    // Accepts `true`, `false`, or `null` and returns them exactly
    // as such; if the parameter is none of those or their synonyms
    // below, returns `def`.
    //
    // Also accepts the strings `'yes'` (or starting with y), `'no'` (or
    // starting with n), `'true'` (or starting with t), `'false'`
    // (or starting with f), `'1'`, `'0'` and the strings `'any'` and
    // `'null'`. The string `'null'` must be an exact match, anything
    // else starting with `n` is taken as `no` (false).
    //
    // These various synonyms are useful for string input, such as from
    // a user friendly query string.
    self.booleanOrNull = function(b, def) {
        if (b === true) return b;
        if (b === false) return b;
        if (b === null) return b;
        b = self.string(b, def);
        if (b === def) {
            if (def === undefined) return null;
            return b;
        }
        // String 'null' must match as a full string to disambiguate from string 'n' for 'no'
        if (b === 'null') return null;
        b = b.toLowerCase().charAt(0);
        if (b === '' || b === 'n' || b === '0' || b === 'f') return false;
        if (b === 't' || b === 'y' || b === '1') return true;
        if (b === 'a') return null;
        return def;
    };
    // Accept a user-entered string in YYYY-MM-DD, MM/DD, MM/DD/YY, or MM/DD/YYYY format
    // (tolerates missing leading zeroes on MM and DD). Also accepts a Date object.
    // Returns YYYY-MM-DD.
    //
    // The current year is assumed when MM/DD is used. If there is no explicit default
    // any unparseable date is returned as today's date.
    //
    // If the default is explicitly `null` (not `undefined`) then `null` is returned for
    // any unparseable date.
    //
    // The `now` argument can be passed for performance if you prefer to call
    // `new Date()` just once before many calls to this method and pass that single
    // value to all of them.
    self.date = function(date, def, now) {
        let components;
        function returnDefault() {
            if (def === undefined) def = $ac909277c03a2df9$exports().format('YYYY-MM-DD');
            return def;
        }
        if (typeof date === 'string') {
            if (date.match(/\//)) {
                components = date.split('/');
                if (components.length === 2) // Convert mm/dd to yyyy-mm-dd
                return (now || new Date()).getFullYear() + '-' + self.padInteger(components[0], 2) + '-' + self.padInteger(components[1], 2);
                else if (components.length === 3) {
                    // Convert mm/dd/yy to mm/dd/yyyy
                    if (components[2] < 100) {
                        // Add the current century. If the result is more than
                        // 50 years in the future, assume they meant the
                        // previous century. Thus in 2015, we find that
                        // we get the intuitive result for both 1/1/75,
                        // 1/1/99 and 1/1/25. It's a nasty habit among
                        // us imprecise humans. -Tom
                        const d = now || new Date();
                        const nowYear = d.getFullYear() % 100;
                        const nowCentury = d.getFullYear() - nowYear;
                        let theirYear = parseInt(components[2]) + nowCentury;
                        if (theirYear - d.getFullYear() > 50) theirYear -= 100;
                        components[2] = theirYear;
                    }
                    // Convert mm/dd/yyyy to yyyy-mm-dd
                    return self.padInteger(components[2], 4) + '-' + self.padInteger(components[0], 2) + '-' + self.padInteger(components[1], 2);
                } else return returnDefault();
            } else if (date.match(/-/)) {
                components = date.split('-');
                if (components.length === 2) // Convert mm-dd to yyyy-mm-dd
                return (now || new Date()).getFullYear() + '-' + self.padInteger(components[0], 2) + '-' + self.padInteger(components[1], 2);
                else if (components.length === 3) // Convert yyyy-mm-dd (with questionable padding) to yyyy-mm-dd
                return self.padInteger(components[0], 4) + '-' + self.padInteger(components[1], 2) + '-' + self.padInteger(components[2], 2);
                else return returnDefault();
            }
        }
        try {
            if (date === null) return returnDefault();
            date = now || new Date(date);
            if (isNaN(date.getTime())) return returnDefault();
            return date.getFullYear() + '-' + self.padInteger(date.getMonth() + 1, 2) + '-' + self.padInteger(date.getDate(), 2);
        } catch (e) {
            return returnDefault();
        }
    };
    // This is likely not relevent to you unless you're using Apostrophe
    // Given a date object, return a date string in Apostrophe's preferred sortable,
    // comparable, JSON-able format, which is YYYY-MM-DD. If `date` is undefined
    // the current date is used.
    self.formatDate = function(date) {
        return $ac909277c03a2df9$exports(date).format('YYYY-MM-DD');
    };
    // Accepts a user-entered string in 12-hour or 24-hour time and returns a string
    // in 24-hour time. This method is tolerant of syntax such as `4pm`; minutes and
    // seconds are optional.
    //
    // If `def` is not set the default is the current time.
    self.time = function(time, def) {
        time = self.string(time).toLowerCase();
        time = time.trim();
        const components = time.match(/^(\d+)([:|.](\d+))?([:|.](\d+))?\s*(am|pm|AM|PM|a|p|A|M)?$/);
        if (components) {
            let hours = parseInt(components[1], 10);
            const minutes = components[3] !== undefined ? parseInt(components[3], 10) : 0;
            const seconds = components[5] !== undefined ? parseInt(components[5], 10) : 0;
            let ampm = components[6] ? components[6].toLowerCase() : components[6];
            ampm = ampm && ampm.charAt(0);
            if (hours === 12 && ampm === 'a') hours -= 12;
            else if (hours === 12 && ampm === 'p') ;
            else if (ampm === 'p') hours += 12;
            if (hours === 24 || hours === '24') hours = 0;
            return self.padInteger(hours, 2) + ':' + self.padInteger(minutes, 2) + ':' + self.padInteger(seconds, 2);
        } else {
            if (def !== undefined) return def;
            return $ac909277c03a2df9$exports().format('HH:mm');
        }
    };
    // This is likely not relevent to you unless you're using Apostrophe
    // Given a JavaScript Date object, return a time string in
    // Apostrophe's preferred sortable, comparable, JSON-able format:
    // 24-hour time, with seconds.
    //
    // If `date` is missing the current time is used.
    self.formatTime = function(date) {
        return $ac909277c03a2df9$exports(date).format('HH:mm:ss');
    };
    // Sanitize tags. Tags should be submitted as an array of strings,
    // or a comma-separated string.
    //
    // This method ensures the input is an array or string and, if
    // an array, that the elements of the array are strings.
    //
    // If a filterTag function is passed as an option when initializing
    // Launder, then all tags are passed through it (as individual
    // strings, one per call) and the return value is used instead. You
    // may also pass a filterTag when calling this function
    self.tags = function(tags, filter) {
        if (typeof tags === 'string') tags = tags.split(/,\s*/);
        if (!Array.isArray(tags)) return [];
        const strings = tags.map((tag)=>self.string(tag));
        const rewritten = strings.map(filter || self.filterTag);
        const filtered = rewritten.filter((tag)=>tag.length > 0);
        return filtered;
    };
    // Sanitize an id. IDs must consist solely of upper and lower case
    // letters, numbers, and digits unless options.idRegExp is set.
    self.idRegExp = self.options.idRegExp || /^[A-Za-z0-9_]+$/;
    self.id = function(s, def) {
        const id = self.string(s, def);
        if (id === def) return id;
        if (!id.match(self.idRegExp)) return def;
        return id;
    };
    // Sanitize an array of IDs. IDs must consist solely of upper and lower case
    // letters and numbers, digits, and underscores. Any elements that are not
    // IDs are omitted from the final array.
    self.ids = function(ids) {
        if (!Array.isArray(ids)) return [];
        const result = ids.filter(function(id) {
            return self.id(id) !== undefined;
        });
        return result;
    };
    return self;
};
// Expose `naughtyHref` statically so callers (notably sanitize-html)
// can use it without instantiating a launder.
$dbd9d38dc4b54e0d$exports.naughtyHref = $dbd9d38dc4b54e0d$var$naughtyHref;


var $a95d59889df6cf5b$require$launderNaughtyHref = $dbd9d38dc4b54e0d$exports.naughtyHref;
// Tags that can conceivably represent stand-alone media.
const $a95d59889df6cf5b$var$mediaTags = [
    'img',
    'audio',
    'video',
    'picture',
    'svg',
    'object',
    'map',
    'iframe',
    'embed'
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $a95d59889df6cf5b$var$vulnerableTags = [
    'script',
    'style'
];
// SVG SMIL animation elements. These do not carry a URL themselves: they
// retarget an attribute of another element, naming it with `attributeName`
// and supplying the new value(s) in `values`, `from`, `to` and `by`.
const $a95d59889df6cf5b$var$svgAnimationTags = [
    'animate',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'set'
];
// Attribute names that always name a URL sink, whatever
// `allowedSchemesAppliedToAttributes` has been narrowed to. A namespace prefix
// is ignored when matching, so `xlink:href` and any other prefixed spelling of
// `href` are covered.
const $a95d59889df6cf5b$var$alwaysUrlAttributes = [
    'href'
];
// Our own diagnostics. A console-shaped `logger` option takes them instead of
// the console; missing methods fall back to it.
const $a95d59889df6cf5b$var$severities = [
    'debug',
    'info',
    'warn',
    'error'
];
function $a95d59889df6cf5b$var$loggerFor(options) {
    const source = options && options.logger || console;
    const logger = {};
    for (const severity of $a95d59889df6cf5b$var$severities)logger[severity] = typeof source[severity] === 'function' ? (...args)=>source[severity](...args) : (...args)=>console[severity](...args);
    return logger;
}
function $a95d59889df6cf5b$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $a95d59889df6cf5b$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Combine the tag-specific and wildcard lists of allowed classes
function $a95d59889df6cf5b$var$mergeClasses(specific, wildcard) {
    if (!Array.isArray(specific) || !Array.isArray(wildcard)) return wildcard;
    return specific.concat(wildcard);
}
// Combine the tag-specific and wildcard allowed styles, concatenating the
// lists of regular expressions for properties that appear in both. The result
// has no prototype, so a property named `__proto__` is just another property
function $a95d59889df6cf5b$var$mergeStyles(specific, wildcard) {
    const merged = Object.create(null);
    for (const rules of [
        specific,
        wildcard
    ])for (const prop of Object.keys(rules))merged[prop] = $a95d59889df6cf5b$var$has(merged, prop) ? merged[prop].concat(rules[prop]) : rules[prop];
    return merged;
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $a95d59889df6cf5b$var$filter(a, cb) {
    const n = [];
    $a95d59889df6cf5b$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $a95d59889df6cf5b$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($a95d59889df6cf5b$var$has(obj, key)) return false;
    }
    return true;
}
function $a95d59889df6cf5b$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error('URL missing');
        return part.url + (part.w ? ` ${part.w}w` : '') + (part.h ? ` ${part.h}h` : '') + (part.d ? ` ${part.d}x` : '');
    }).join(', ');
}
$a95d59889df6cf5b$exports = $a95d59889df6cf5b$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $a95d59889df6cf5b$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// How many discarded <iframe> elements can be nested while their fallback
// markup is still re-sanitized as HTML (see the `ontext` handler). Deeper
// fallback is escaped as text, so that crafted input cannot recurse without
// bound or re-parse the remainder of the input once per iframe
// (GHSA-c9rx-x947-fp3h).
const $a95d59889df6cf5b$var$MAX_IFRAME_FALLBACK_DEPTH = 8;
// `_fallback` is internal: it is set when re-sanitizing the fallback markup
// of a discarded <iframe>, to carry the current nesting depth into the
// recursive call.
function $a95d59889df6cf5b$var$sanitizeHtml(html, options, _fallback) {
    if (html == null) return '';
    const baseDepth = _fallback && _fallback.depth || 0;
    const iframeFallbackDepth = _fallback && _fallback.iframeFallbackDepth || 0;
    if (typeof html === 'number') html = html.toString();
    let result = '';
    // Used for hot swapping the result variable with an empty string
    // in order to "capture" the text written to it.
    let tempResult = '';
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ''; // Node inner text
        this.openingTagLength = 0;
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $a95d59889df6cf5b$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $a95d59889df6cf5b$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $a95d59889df6cf5b$var$htmlParserDefaults, options.parser);
    const logger = $a95d59889df6cf5b$var$loggerFor(options);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $a95d59889df6cf5b$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) logger.warn(`Your \`allowedTags\` option includes \`${tag}\`, which is inherently ` + 'vulnerable to XSS attacks. Please remove it from `allowedTags`, or, ' + 'to disable this warning, add the `allowVulnerableTags` option and ' + 'ensure you are accounting for this risk.');
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    // `xmp` is included because htmlparser2 treats it as a raw-text element,
    // so markup inside is parsed as text on input but would otherwise be
    // re-emitted unescaped via the `ontext` branch below, allowing XSS bypass
    // when `xmp` is disallowed (which is the default).
    const nonTextTagsArray = options.nonTextTags || [
        'script',
        'style',
        'textarea',
        'option',
        'xmp'
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $a95d59889df6cf5b$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($c4d425048e4a6a16$exports(obj).replace(/\\\*/g, '.*'));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $a95d59889df6cf5b$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$a95d59889df6cf5b$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push('class');
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            const globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === 'string' && obj.indexOf('*') >= 0) globRegex.push($c4d425048e4a6a16$exports(obj).replace(/\\\*/g, '.*'));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
        }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $a95d59889df6cf5b$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === 'function') transFun = transform;
        else if (typeof transform === 'string') transFun = $a95d59889df6cf5b$var$sanitizeHtml.simpleTransform(transform);
        if (tag === '*') transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    // Browsers (with scripting enabled) parse <noscript> content as raw text up
    // to the first `</noscript`, but htmlparser2 parses it as markup, so an end
    // tag for an ancestor can make htmlparser2 close the <noscript> implicitly
    // much earlier. `rawTextEnd` is the source offset where the browser ends the
    // <noscript> being discarded, and `skipRawText` is set while htmlparser2 has
    // already closed it but the browser has not, so that we keep discarding
    // until we reach that offset (GHSA-x3q4-9hxx-gx8m).
    let rawTextEnd;
    let skipRawText;
    let addedText = false;
    initializeState();
    const parser = new $e568cd9e4c5fb384$export$7acfa6ed01010e37({
        onopentag: function(name, attribs) {
            if (options.onOpenTag) options.onOpenTag(name, attribs);
            updateRawTextRegion();
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === 'html') initializeState();
            if (skipRawText) return;
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($a95d59889df6cf5b$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || animatesUrlAttribute(name, attribs) || options.disallowedTagsMode === 'recursiveEscape' && !$a95d59889df6cf5b$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                        if (frame.tag.toLowerCase() === 'noscript') rawTextEnd = findRawTextEnd('noscript', parser.endIndex + 1);
                    }
                }
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    // We want the contents but not this tag
                    if (frame.innerText && !hasText) {
                        const escaped = escapeHtml(frame.innerText);
                        if (options.textFilter) result += options.textFilter(escaped, name);
                        else result += escaped;
                        addedText = true;
                    }
                    return;
                }
                tempResult = result;
                result = '';
            }
            result += '<' + name;
            if (name === 'script') {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = '';
            }
            const isBeingEscaped = skip && (options.disallowedTagsMode === 'escape' || options.disallowedTagsMode === 'recursiveEscape');
            const shouldPreserveEscapedAttributes = isBeingEscaped && options.preserveEscapedAttributes;
            if (shouldPreserveEscapedAttributes) $a95d59889df6cf5b$var$each(attribs, function(value, a) {
                result += ' ' + a + '="' + escapeHtml(value || '', true) + '"';
            });
            else if (!allowedAttributesMap || $a95d59889df6cf5b$var$has(allowedAttributesMap, name) || allowedAttributesMap['*']) $a95d59889df6cf5b$var$each(attribs, function(value, a) {
                if (!$a95d59889df6cf5b$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, check if the attribute is
                // in the allowedEmptyAttributes array.
                // If it is not in the allowedEmptyAttributes array,
                // and it is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === '' && !options.allowedEmptyAttributes.includes(a) && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $a95d59889df6cf5b$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 || $a95d59889df6cf5b$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($a95d59889df6cf5b$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = '';
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(' ');
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === '') newValue = s;
                                else newValue += ' ' + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    // `<meta http-equiv="refresh" content="0;url=...">` navigates to a
                    // URL embedded in `content`, so scheme check that URL too
                    // (GHSA-cv27-6wvh-8x7j). Other meta `content` values are left alone.
                    if (name === 'meta' && a.toLowerCase() === 'content' && isRefresh(attribs) && naughtyRefresh(value)) {
                        delete frame.attribs[a];
                        return;
                    }
                    if (name === 'script' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === 'iframe' && a === 'src') {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $a95d59889df6cf5b$var$has(options, 'allowIframeRelativeUrls') ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'srcset' || a === 'imagesrcset') try {
                        let parsed = $060bc73db7a92eda$exports(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref(name, value.url)) value.evil = true;
                        });
                        parsed = $a95d59889df6cf5b$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $a95d59889df6cf5b$var$stringifySrcset($a95d59889df6cf5b$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === 'class') {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap['*'];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesRegex = allowedClassesRegexMap['*'];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $a95d59889df6cf5b$var$mergeClasses(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === 'style') {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $a95d59889df6cf5b$require$postcssParse(name + ' {' + value + '}', {
                                map: false
                            });
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== 'undefined') logger.warn(`Failed to parse "${name} {${value}}". If you are ` + 'running this in a browser, we recommend disabling ' + 'style parsing with the parseStyleAttributes option, ' + 'since it only works in a node environment due to a ' + 'postcss dependency. More info: ' + 'https://github.com/apostrophecms/sanitize-html/issues/547');
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
                    }
                    result += ' ' + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                    else if (options.allowedEmptyAttributes.includes(a)) result += '=""';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += ' />';
            else {
                result += '>';
                if (frame.innerText && !hasText) {
                    const escaped = escapeHtml(frame.innerText);
                    if (options.textFilter) result += options.textFilter(escaped, name);
                    else result += escaped;
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
            frame.openingTagLength = result.length - frame.tagPosition;
        },
        ontext: function(text) {
            updateRawTextRegion();
            if (skipText || skipRawText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === 'completelyDiscard' && !tagAllowed(tag)) text = '';
            else if (tag && tagAllowed(tag) && (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && (tag === 'script' || tag === 'style')) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else if (tag && tagAllowed(tag) && (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && (tag === 'textarea' || tag === 'xmp')) {
                // <textarea> and <xmp> hold text that must not be re-emitted verbatim:
                // if a raw `<` survives into the output it can reopen a tag when the
                // result is re-parsed by a browser, smuggling non-allowlisted markup
                // through the allowlist (mutation-XSS, GHSA-jxwj-j7wr-gfrw — e.g. the
                // `</textarea/>` solidus mis-close). We therefore ALWAYS escape this
                // content rather than passing it through. Escaping unconditionally also
                // closes the related SVG/MathML foreign-content bypass (where the HTML5
                // parser treats <textarea>/<xmp> as ordinary foreign elements and a
                // browser re-parses their contents as live markup, e.g.
                // `<svg><textarea><img src=x onerror=alert(1)></textarea></svg>`): since
                // we never re-emit raw text for these tags, no namespace check is
                // needed. The two tags need different escaping because htmlparser2
                // tokenizes them differently:
                if (tag === 'xmp') // <xmp> is a raw-text (CDATA) element: entities are NOT decoded, so
                // its content reaches us as raw source that is already entity-encoded.
                // Escape only the angle brackets so a literal `<` cannot reopen a tag,
                // while leaving `&` untouched to avoid double-encoding entities that
                // are already encoded in the source.
                result += text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                else // <textarea> is an RCDATA element: htmlparser2 (>= 11) decodes
                // entities inside it, so its content reaches us as plain decoded text.
                // It must therefore be fully escaped like any other text — escaping
                // `&` as well as `<`/`>` — so entities round-trip faithfully (no
                // double-encoding, see the CVE-2026-40186 regression tests) and no
                // `<` can reopen a tag.
                result += escapeHtml(text, false);
            } else if (// htmlparser2 treats <iframe> as a raw-text element, so markup inside
            // (including after an unclosed <iframe>) arrives as a single text node.
            // When the iframe is discarded, re-sanitize that fallback markup as HTML
            // instead of escaping it as plain text (issue #5550).
            // The nested call continues from the current depth so that
            // `nestingLimit` applies to the whole output.
            tag === 'iframe' && !tagAllowed(tag) && options.disallowedTagsMode === 'discard' && iframeFallbackDepth < $a95d59889df6cf5b$var$MAX_IFRAME_FALLBACK_DEPTH) result += $a95d59889df6cf5b$var$sanitizeHtml(text, options, {
                depth: depth,
                iframeFallbackDepth: iframeFallbackDepth + 1
            });
            else if (!addedText) {
                const escaped = escapeHtml(text, false);
                if (options.textFilter) result += options.textFilter(escaped, tag);
                else result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (options.onCloseTag) options.onCloseTag(name, isImplied);
            updateRawTextRegion();
            if (skipRawText) {
                // Still inside the browser's raw text: only close elements that were
                // opened before the discarded region, so the output stays balanced.
                const lastFrame = stack[stack.length - 1];
                if (!lastFrame || lastFrame.tag !== name) return;
            } else if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) {
                    skipText = false;
                    if (rawTextEnd !== null) // htmlparser2 closed the element implicitly (e.g. an ancestor's
                    // end tag) before the browser would. Close its frame below, but
                    // keep discarding up to the browser's end tag.
                    skipRawText = true;
                } else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === 'html' : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = '';
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter) {
                const filterResult = options.exclusiveFilter(frame);
                if (filterResult === 'excludeTag') {
                    if (skip) {
                        // no longer escaping the tag since it's not added at all
                        result = tempResult;
                        tempResult = '';
                    }
                    // remove the opening tag from the result
                    result = result.substring(0, frame.tagPosition) + result.substring(frame.tagPosition + frame.openingTagLength);
                    return;
                } else if (filterResult) {
                    result = result.substring(0, frame.tagPosition);
                    return;
                }
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                'escape',
                'recursiveEscape'
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = '';
                }
                return;
            }
            result += '</' + name + '>';
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = '';
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    if (options.disallowedTagsMode === 'escape' || options.disallowedTagsMode === 'recursiveEscape') {
        const lastParsedIndex = parser.endIndex;
        if (lastParsedIndex != null && lastParsedIndex >= 0 && lastParsedIndex < html.length) {
            const unparsed = html.substring(lastParsedIndex);
            result += escapeHtml(unparsed);
        } else if ((lastParsedIndex == null || lastParsedIndex < 0) && html.length > 0 && result === '') result = escapeHtml(html);
    }
    return result;
    function initializeState() {
        result = '';
        depth = baseDepth;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
        rawTextEnd = null;
        skipRawText = false;
    }
    // Leave the raw text region once the parser reaches the offset where the
    // browser ends it.
    function updateRawTextRegion() {
        if (rawTextEnd !== null && parser.startIndex >= rawTextEnd) {
            rawTextEnd = null;
            skipRawText = false;
        }
    }
    // Offset of the end tag that ends a raw text element in a browser: the
    // first case-insensitive `</name` followed by HTML whitespace, `/` or `>`.
    // With no such end tag the element runs to the end of the input.
    function findRawTextEnd(tagName, from) {
        const re = new RegExp('</' + tagName + '[\\t\\n\\f\\r />]', 'ig');
        re.lastIndex = from;
        const match = re.exec(html);
        return match ? match.index : Infinity;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== 'string') s = s + '';
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            if (quote) s = s.replace(/"/g, '&quot;');
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
        if (quote) s = s.replace(/"/g, '&quot;');
        return s;
    }
    function naughtyHref(name, href) {
        // Resolve the per-tag scheme allowlist if one is configured for
        // this tag, otherwise fall back to the global allowedSchemes.
        const allowedSchemes = $a95d59889df6cf5b$var$has(options.allowedSchemesByTag, name) ? options.allowedSchemesByTag[name] : options.allowedSchemes || [];
        return $a95d59889df6cf5b$require$launderNaughtyHref(href, {
            allowedSchemes: allowedSchemes,
            allowProtocolRelative: options.allowProtocolRelative
        });
    }
    function isRefresh(attribs) {
        return Object.keys(attribs).some(function(a) {
            return a.toLowerCase() === 'http-equiv' && String(attribs[a]).trim().toLowerCase() === 'refresh';
        });
    }
    // True if the `content` of a `<meta http-equiv="refresh">` must be dropped:
    // its destination URL fails the scheme policy, or it cannot be parsed as a
    // refresh at all (a browser would ignore it then, so nothing is lost).
    // Extracts the URL the way the HTML standard's "shared declarative refresh
    // steps" do, so that spelling, separator, quoting and case variations of
    // `url=`, or no `url=` at all, all yield the URL a browser would navigate to.
    function naughtyRefresh(content) {
        const input = String(content);
        const isWhitespace = function(c) {
            return c === ' ' || c === '\t' || c === '\n' || c === '\f' || c === '\r';
        };
        let position = 0;
        const skipWhitespace = function() {
            while(position < input.length && isWhitespace(input[position]))position++;
        };
        const lowerAt = function(i) {
            return (input[i] || '').toLowerCase();
        };
        skipWhitespace();
        const timeStart = position;
        while(position < input.length && /[0-9.]/.test(input[position]))position++;
        if (position === timeStart) return true;
        if (position < input.length) {
            const c = input[position];
            if (c !== ';' && c !== ',' && !isWhitespace(c)) return true;
            skipWhitespace();
            if (input[position] === ';' || input[position] === ',') position++;
            skipWhitespace();
        }
        if (position >= input.length) // No URL: refreshes the current document
        return false;
        let url = input.slice(position);
        let quoted = true;
        if (lowerAt(position) === 'u') {
            quoted = false;
            if (lowerAt(position + 1) === 'r' && lowerAt(position + 2) === 'l') {
                position += 3;
                skipWhitespace();
                if (input[position] === '=') {
                    position++;
                    skipWhitespace();
                    quoted = true;
                }
            }
        }
        if (quoted) {
            const quote = input[position];
            if (quote === '"' || quote === '\'') position++;
            url = input.slice(position);
            if (quote === '"' || quote === '\'') {
                const end = url.indexOf(quote);
                if (end !== -1) url = url.slice(0, end);
            }
        }
        return naughtyHref('meta', url);
    }
    // True if this is an SVG SMIL animation element that animates a URL-bearing
    // attribute, e.g. `<animate attributeName="href" values="#safe;javascript:...">`.
    //
    // Such an element carries no URL of its own: the browser copies the animation
    // values into the target attribute *after* sanitization, so a `javascript:`
    // destination reaches a live link sink without ever being scheme checked.
    // `values` compounds this, because it is a semicolon-separated LIST of
    // destinations: checking it as one flat URL only validates its first entry, so
    // a leading `#safe` fragment carries the rest of the list past the policy.
    //
    // Re-checking each entry of each value attribute would leave the safety of the
    // output resting on our imitation of SMIL list parsing, so we reject the
    // animation on the strength of its target instead. Animations of attributes
    // that are not URL sinks, such as `fill` or `opacity`, are unaffected.
    function animatesUrlAttribute(name, attribs) {
        // In an XML serialization a prefixed name such as `svg:animate` is the same
        // element as `animate`, so match on the local name (GHSA-374f-7chj-9948).
        if ($a95d59889df6cf5b$var$svgAnimationTags.indexOf(localPart(name)) === -1) return false;
        const schemeCheckedAttributes = options.allowedSchemesAppliedToAttributes || [];
        return Object.keys(attribs || {}).some(function(attributeName) {
            if (localPart(attributeName) !== 'attributename') return false;
            const target = (attribs[attributeName] || '').trim().toLowerCase();
            // The target may be namespace prefixed (`xlink:href`). Which prefixes are
            // in scope depends on the document, so consider the local name too.
            const localName = target.slice(target.lastIndexOf(':') + 1);
            return $a95d59889df6cf5b$var$alwaysUrlAttributes.indexOf(localName) !== -1 || schemeCheckedAttributes.indexOf(target) !== -1 || schemeCheckedAttributes.indexOf(localName) !== -1;
        });
    }
    // Lowercased name with any namespace prefix removed.
    function localPart(name) {
        const lower = name.toLowerCase();
        return lower.slice(lower.lastIndexOf(':') + 1);
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
        if (value.startsWith('relative:')) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error('relative: exploit attempt');
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = 'relative://relative-site';
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] -
   * Each object contains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color),
   * value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles['*']) selectedRule = $a95d59889df6cf5b$var$mergeStyles(allowedStyles[astRules.selector], allowedStyles['*']);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example:
   * "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`);
            return extractedAttributes;
        }, []).join(';');
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList - List of declarations
    * which pass the allowlist.
    * @param  {object} attributeObject - Object representing the current css property.
    * @property {string} attributeObject.type - Typically 'declaration'.
    * @property {string} attributeObject.prop - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value - The corresponding value to
    * the css property, i.e 'red'.
    * @return {function} - When used in Array.reduce,
    * will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($a95d59889df6cf5b$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(' ');
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $a95d59889df6cf5b$var$htmlParserDefaults = {
    decodeEntities: true
};
$a95d59889df6cf5b$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        'address',
        'article',
        'aside',
        'footer',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'hgroup',
        'main',
        'nav',
        'section',
        // Text content
        'blockquote',
        'dd',
        'div',
        'dl',
        'dt',
        'figcaption',
        'figure',
        'hr',
        'li',
        'menu',
        'ol',
        'p',
        'pre',
        'ul',
        // Inline text semantics
        'a',
        'abbr',
        'b',
        'bdi',
        'bdo',
        'br',
        'cite',
        'code',
        'data',
        'dfn',
        'em',
        'i',
        'kbd',
        'mark',
        'q',
        'rb',
        'rp',
        'rt',
        'rtc',
        'ruby',
        's',
        'samp',
        'small',
        'span',
        'strong',
        'sub',
        'sup',
        'time',
        'u',
        'var',
        'wbr',
        // Table content
        'caption',
        'col',
        'colgroup',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'tr'
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        'abbr',
        'accept',
        'accept-charset',
        'accesskey',
        'action',
        'allow',
        'alt',
        'as',
        'autocapitalize',
        'autocomplete',
        'blocking',
        'charset',
        'cite',
        'class',
        'color',
        'cols',
        'colspan',
        'content',
        'contenteditable',
        'coords',
        'crossorigin',
        'data',
        'datetime',
        'decoding',
        'dir',
        'dirname',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'fetchpriority',
        'for',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formtarget',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'http-equiv',
        'id',
        'imagesizes',
        'imagesrcset',
        'inputmode',
        'integrity',
        'is',
        'itemid',
        'itemprop',
        'itemref',
        'itemtype',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'name',
        'nonce',
        'optimum',
        'pattern',
        'ping',
        'placeholder',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'referrerpolicy',
        'rel',
        'rows',
        'rowspan',
        'sandbox',
        'scope',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'spellcheck',
        'src',
        'srcdoc',
        'srclang',
        'srcset',
        'start',
        'step',
        'style',
        'tabindex',
        'target',
        'title',
        'translate',
        'type',
        'usemap',
        'value',
        'width',
        'wrap',
        // Event handlers
        'onauxclick',
        'onafterprint',
        'onbeforematch',
        'onbeforeprint',
        'onbeforeunload',
        'onbeforetoggle',
        'onblur',
        'oncancel',
        'oncanplay',
        'oncanplaythrough',
        'onchange',
        'onclick',
        'onclose',
        'oncontextlost',
        'oncontextmenu',
        'oncontextrestored',
        'oncopy',
        'oncuechange',
        'oncut',
        'ondblclick',
        'ondrag',
        'ondragend',
        'ondragenter',
        'ondragleave',
        'ondragover',
        'ondragstart',
        'ondrop',
        'ondurationchange',
        'onemptied',
        'onended',
        'onerror',
        'onfocus',
        'onformdata',
        'onhashchange',
        'oninput',
        'oninvalid',
        'onkeydown',
        'onkeypress',
        'onkeyup',
        'onlanguagechange',
        'onload',
        'onloadeddata',
        'onloadedmetadata',
        'onloadstart',
        'onmessage',
        'onmessageerror',
        'onmousedown',
        'onmouseenter',
        'onmouseleave',
        'onmousemove',
        'onmouseout',
        'onmouseover',
        'onmouseup',
        'onoffline',
        'ononline',
        'onpagehide',
        'onpageshow',
        'onpaste',
        'onpause',
        'onplay',
        'onplaying',
        'onpopstate',
        'onprogress',
        'onratechange',
        'onreset',
        'onresize',
        'onrejectionhandled',
        'onscroll',
        'onscrollend',
        'onsecuritypolicyviolation',
        'onseeked',
        'onseeking',
        'onselect',
        'onslotchange',
        'onstalled',
        'onstorage',
        'onsubmit',
        'onsuspend',
        'ontimeupdate',
        'ontoggle',
        'onunhandledrejection',
        'onunload',
        'onvolumechange',
        'onwaiting',
        'onwheel'
    ],
    disallowedTagsMode: 'discard',
    allowedAttributes: {
        a: [
            'href',
            'name',
            'target'
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            'src',
            'srcset',
            'alt',
            'title',
            'width',
            'height',
            'loading'
        ]
    },
    allowedEmptyAttributes: [
        'alt'
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        'img',
        'br',
        'hr',
        'area',
        'base',
        'basefont',
        'input',
        'link',
        'meta',
        'col'
    ],
    // URL schemes we permit
    allowedSchemes: [
        'http',
        'https',
        'ftp',
        'mailto',
        'tel'
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        'href',
        'src',
        'cite',
        'action',
        'formaction',
        'data',
        'xlink:href',
        'poster',
        'background',
        'ping',
        'longdesc',
        'usemap',
        'codebase',
        'classid',
        'archive',
        'profile',
        'manifest',
        'itemid',
        'dynsrc',
        'lowsrc'
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true,
    preserveEscapedAttributes: false
};
$a95d59889df6cf5b$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};


// デフォルトの描画オプション
const $87e6ec714089ec43$var$defaultRenderOptions = {
    fontSize: 14,
    fontFamily: "monospace",
    margin: {
        top: 20,
        right: 20,
        bottom: 20,
        left: 20
    },
    boxPadding: {
        top: 10,
        right: 10,
        bottom: 10,
        left: 10
    },
    branchePadding: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    strokeWidth: 1,
    strokeColor: "#000000",
    backgroundColor: "#ffffff",
    baseBackgroundColor: null,
    textColor: "#000000",
    lineHeight: 1.2,
    doubleLineWidth: 5,
    switchNodeCaseWidth: 20,
    connectorWidth: 2,
    nodeListSpace: 10,
    childNodeOffsetWidth: 20,
    listRenderType: "Original"
};
function $87e6ec714089ec43$export$b3890eb0ae9dca99(node, options) {
    const mergedOptions = {
        ...$87e6ec714089ec43$var$defaultRenderOptions,
        ...options
    };
    const safeOptions = {
        ...mergedOptions,
        strokeColor: $87e6ec714089ec43$var$escapeXmlAttribute($87e6ec714089ec43$var$sanitizeSvgColor(mergedOptions.strokeColor)),
        backgroundColor: $87e6ec714089ec43$var$escapeXmlAttribute($87e6ec714089ec43$var$sanitizeSvgColor(mergedOptions.backgroundColor)),
        strokeWidth: Number.isFinite(Number(mergedOptions.strokeWidth)) ? Math.max(0, Number(mergedOptions.strokeWidth)) : $87e6ec714089ec43$var$defaultRenderOptions.strokeWidth
    };
    if (!node) return "";
    const fragment = $87e6ec714089ec43$var$renderNode(node, safeOptions);
    const svgWidth = fragment.width + safeOptions.margin.left + safeOptions.margin.right;
    const svgHeight = fragment.height + safeOptions.margin.top + safeOptions.margin.bottom;
    let svg = `<svg `;
    svg += `width="${svgWidth.toFixed(1)}" height="${svgHeight.toFixed(1)}" `;
    svg += `viewBox="0 0 ${svgWidth.toFixed(1)} ${svgHeight.toFixed(1)}" `;
    svg += `xmlns="http://www.w3.org/2000/svg">`;
    if (mergedOptions.title) svg += `<title>${$87e6ec714089ec43$var$escapeXmlAttribute(mergedOptions.title)}</title>`;
    const baseFillColor = $87e6ec714089ec43$var$sanitizeSvgColor(mergedOptions.baseBackgroundColor);
    svg += `<rect x="0" y="0" `;
    svg += `width="${svgWidth.toFixed(1)}" height="${svgHeight.toFixed(1)}" `;
    svg += `fill="${$87e6ec714089ec43$var$escapeXmlAttribute(baseFillColor)}"/>`;
    svg += $87e6ec714089ec43$var$renderTransformTranslateSvg(safeOptions.margin.left, safeOptions.margin.top, fragment.svg);
    svg += `</svg>`;
    const sanitizedSvg = (0, (/*@__PURE__*/$parcel$interopDefault($a95d59889df6cf5b$exports)))(svg, {
        allowedTags: [
            "svg",
            "title",
            "g",
            "rect",
            "path",
            "line",
            "polyline",
            "polygon",
            "ellipse",
            "circle",
            "text",
            "tspan",
            "defs",
            "marker"
        ],
        allowedAttributes: {
            svg: [
                "xmlns",
                "width",
                "height",
                "viewBox"
            ],
            g: [
                "transform",
                "stroke",
                "stroke-width",
                "fill",
                "class"
            ],
            rect: [
                "x",
                "y",
                "width",
                "height",
                "rx",
                "ry",
                "stroke",
                "stroke-width",
                "fill"
            ],
            path: [
                "d",
                "stroke",
                "stroke-width",
                "fill",
                "marker-end",
                "marker-start"
            ],
            line: [
                "x1",
                "y1",
                "x2",
                "y2",
                "stroke",
                "stroke-width"
            ],
            polyline: [
                "points",
                "stroke",
                "stroke-width",
                "fill"
            ],
            polygon: [
                "points",
                "stroke",
                "stroke-width",
                "fill"
            ],
            ellipse: [
                "cx",
                "cy",
                "rx",
                "ry",
                "stroke",
                "stroke-width",
                "fill"
            ],
            circle: [
                "cx",
                "cy",
                "r",
                "stroke",
                "stroke-width",
                "fill"
            ],
            text: [
                "x",
                "y",
                "dx",
                "dy",
                "font-size",
                "font-family",
                "text-anchor",
                "dominant-baseline",
                "fill"
            ],
            tspan: [
                "x",
                "y",
                "dx",
                "dy"
            ],
            defs: [],
            marker: [
                "id",
                "viewBox",
                "refX",
                "refY",
                "markerWidth",
                "markerHeight",
                "orient"
            ]
        },
        allowedSchemes: [
            "http",
            "https"
        ],
        selfClosing: [
            "rect",
            "path",
            "line",
            "polyline",
            "polygon",
            "ellipse",
            "circle"
        ],
        parser: {
            lowerCaseTags: false,
            lowerCaseAttributeNames: false
        }
    });
    return sanitizedSvg.replace(/ \/>/g, "/>");
}
function $87e6ec714089ec43$var$escapeXmlAttribute(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $87e6ec714089ec43$var$sanitizeSvgColor(color) {
    if (color == null) return "none";
    const value = color.trim();
    if (value === "none") return "none";
    const isHex = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);
    const isNamedColor = /^[a-zA-Z]+$/.test(value);
    const isRgb = /^rgb\(\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*,\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*,\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*\)$/.test(value);
    const isRgba = /^rgba\(\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*,\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*,\s*(?:\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\s*,\s*(?:0|0?\.\d+|1(?:\.0+)?)\s*\)$/.test(value);
    return isHex || isNamedColor || isRgb || isRgba ? value : "none";
}
/**
 * ASTのノード種別に応じて、対応する描画関数を呼び出す
 */ function $87e6ec714089ec43$var$renderNode(node, options) {
    switch(node.type){
        case "process":
            return $87e6ec714089ec43$var$renderProcessFragment(node, options);
        case "terminal":
            return $87e6ec714089ec43$var$renderTerminalFragment(node, options);
        case "nodeList":
            return $87e6ec714089ec43$var$renderListFragment(node, options);
        case "call":
            return $87e6ec714089ec43$var$renderCallFragment(node, options);
        case "loop":
            return $87e6ec714089ec43$var$renderLoopFragment(node, options);
        case "if":
            return $87e6ec714089ec43$var$renderIfFragment(node, options);
        case "switch":
            return $87e6ec714089ec43$var$renderSwitchFragment(node, options);
        case "comment":
            return $87e6ec714089ec43$var$renderCommentFragment(node, options);
        // 他のノードタイプは後で追加
        default:
            return {
                svg: "",
                width: 0,
                height: 0,
                type: "Unknown"
            }; // 未実装のノードタイプ
    }
}
/**
 * 箱型ノードの描画処理
 */ function $87e6ec714089ec43$var$renderBoxFragment(node, options) {
    const textMetrics = $87e6ec714089ec43$var$measureTextSvg(node.text, options);
    let contentWidth = textMetrics.width;
    let contentHeight = textMetrics.height;
    let textOffsetX = options.boxPadding.left;
    let textOffsetY = 0;
    let svg = ``;
    if (node.borderType === "Box") {
        // 四角形のボックス
        contentWidth += options.boxPadding.left + options.boxPadding.right;
        contentHeight += options.boxPadding.top + options.boxPadding.bottom;
        textOffsetY += options.boxPadding.top;
        const fillColor = options.backgroundColor ?? "none";
        const safeStrokeColor = $87e6ec714089ec43$var$escapeXmlAttribute(options.strokeColor);
        const safeFillColor = $87e6ec714089ec43$var$escapeXmlAttribute(fillColor);
        svg += `<rect x="0" y="0" width="${contentWidth.toFixed(1)}" height="${contentHeight.toFixed(1)}" `;
        svg += `stroke="${safeStrokeColor}" stroke-width="${options.strokeWidth.toFixed(1)}" `;
        svg += `fill="${safeFillColor}"/>`;
    } else if (node.borderType === "WRound") {
        // 丸みを帯びた四角形
        contentHeight += options.boxPadding.top + options.boxPadding.bottom;
        textOffsetY += options.boxPadding.top;
        const radius = contentHeight / 2; // 高さの半分を丸みの半径とする
        contentWidth += contentHeight;
        textOffsetX = radius;
        const fillColor = options.backgroundColor ?? "none";
        const safeStrokeColor = $87e6ec714089ec43$var$escapeXmlAttribute(options.strokeColor);
        const safeFillColor = $87e6ec714089ec43$var$escapeXmlAttribute(fillColor);
        svg += `<rect x="0" y="0" width="${contentWidth.toFixed(1)}" height="${contentHeight.toFixed(1)}" `;
        svg += `rx="${radius.toFixed(1)}" ry="${radius.toFixed(1)}" `;
        svg += `stroke="${safeStrokeColor}" stroke-width="${options.strokeWidth.toFixed(1)}" `;
        svg += `fill="${safeFillColor}"/>`;
    } else // ボーダーなし
    contentWidth += options.boxPadding.left + options.boxPadding.right;
    if (node.drawLeftBar) // 左側二重線
    svg += $87e6ec714089ec43$var$renderLineSvg(options.doubleLineWidth, 0, options.doubleLineWidth, contentHeight, options);
    if (node.drawRightBar) // 右側二重線
    svg += $87e6ec714089ec43$var$renderLineSvg(contentWidth - options.doubleLineWidth, 0, contentWidth - options.doubleLineWidth, contentHeight, options);
    svg += $87e6ec714089ec43$var$renderTextSvg(node.text, textOffsetX, textOffsetY, options);
    let childFragment = null;
    if (node.childNode) {
        childFragment = $87e6ec714089ec43$var$renderNode(node.childNode, options);
        svg += $87e6ec714089ec43$var$renderTransformTranslateSvg(options.childNodeOffsetWidth + contentWidth, 0, childFragment.svg);
        svg += $87e6ec714089ec43$var$renderLineSvg(contentWidth, 0, options.childNodeOffsetWidth + contentWidth, 0, options);
    }
    const totalWidth = parseFloat((contentWidth + (childFragment ? childFragment.width + options.childNodeOffsetWidth : 0)).toFixed(1));
    const totalHeight = parseFloat(Math.max(contentHeight, childFragment ? childFragment.height : 0).toFixed(1));
    return {
        svg: svg,
        width: totalWidth,
        height: totalHeight,
        type: node.type
    };
}
/**
 * コメントノードの描画
 */ function $87e6ec714089ec43$var$renderCommentFragment(node, options) {
    const boxNode = {
        type: "Comment",
        text: `(${node.text})`,
        childNode: null,
        borderType: "None",
        drawLeftBar: false,
        drawRightBar: false
    };
    return $87e6ec714089ec43$var$renderBoxFragment(boxNode, options);
}
/**
 * ループノードの描画
 */ function $87e6ec714089ec43$var$renderLoopFragment(node, options) {
    const boxNode = {
        type: "Loop",
        text: node.text,
        childNode: node.childNode,
        borderType: "Box",
        drawLeftBar: node.isWhile,
        drawRightBar: !node.isWhile
    };
    return $87e6ec714089ec43$var$renderBoxFragment(boxNode, options);
}
/**
 * 呼び出しノードの描画
 */ function $87e6ec714089ec43$var$renderCallFragment(node, options) {
    const boxNode = {
        type: "Call",
        text: node.text,
        childNode: node.childNode,
        borderType: "Box",
        drawLeftBar: true,
        drawRightBar: true
    };
    return $87e6ec714089ec43$var$renderBoxFragment(boxNode, options);
}
/**
 * 処理ノードの描画
 */ function $87e6ec714089ec43$var$renderProcessFragment(node, options) {
    const boxNode = {
        type: "Process",
        text: node.text,
        childNode: node.childNode,
        borderType: "Box",
        drawLeftBar: false,
        drawRightBar: false
    };
    return $87e6ec714089ec43$var$renderBoxFragment(boxNode, options);
}
/**
 * 端子ノードの描画
 */ function $87e6ec714089ec43$var$renderTerminalFragment(node, options) {
    const boxNode = {
        type: "Terminal",
        text: node.text,
        childNode: null,
        borderType: "WRound",
        drawLeftBar: false,
        drawRightBar: false
    };
    return $87e6ec714089ec43$var$renderBoxFragment(boxNode, options);
}
// == Branchノードの描画関数群 ===
function $87e6ec714089ec43$var$measureTextSvgForBranche(text, options) {
    const textMetrics = $87e6ec714089ec43$var$measureTextSvg(text, options);
    return {
        width: textMetrics.width + options.branchePadding.left + options.branchePadding.right,
        height: textMetrics.height + options.branchePadding.top + options.branchePadding.bottom
    };
}
function $87e6ec714089ec43$var$renderTextSvgForBranche(text, posX, posY, options) {
    return $87e6ec714089ec43$var$renderTextSvg(text, posX + options.branchePadding.left, posY + options.branchePadding.top, options);
}
/**
 * 分岐ノードの描画
 */ function $87e6ec714089ec43$var$renderBrancheFragment(node, options) {
    // ケースの数が2未満の場合はダミーを追加する
    if (node.branches.length < 2) while(node.branches.length < 2)node.branches.push({
        label: "",
        node: null
    });
    let svg = "";
    const conditionSize = $87e6ec714089ec43$var$measureTextSvgForBranche(node.text, options);
    const minHeight = conditionSize.height;
    const x = 0;
    const y = 0;
    // labelw　<- ラベルの最大幅
    // h <- ラベルと、サブビューの合計値
    // subview <- サブビューの最大幅
    let labelw = 0;
    let subvieww = 0;
    let h = 0;
    let count = 0;
    let lastdy = 0;
    let lastldy = 0;
    const brancheFragments = [];
    const ymap = new Map();
    for (const [index, branche] of node.branches.entries()){
        const label = branche.label;
        const labelSize = $87e6ec714089ec43$var$measureTextSvgForBranche(label, options);
        const brancheFragment = branche.node ? $87e6ec714089ec43$var$renderNode(branche.node, options) : null;
        // サブビューがない場合はサイズ = 0
        const subViewSize = brancheFragment ? {
            width: brancheFragment.width,
            height: brancheFragment.height
        } : {
            width: 0,
            height: 0
        };
        if (count !== node.branches.length - 1) subViewSize.height += options.nodeListSpace;
        brancheFragments.push({
            label: label,
            fragment: brancheFragment
        });
        // ラベルの最大幅を更新
        if (labelw < labelSize.width) labelw = labelSize.width;
        // サブビューの最大幅を更新
        if (subvieww < subViewSize.width) subvieww = subViewSize.width;
        // ラベルに合わせて高さを更新
        let uply, bottomly;
        if (count === 0) {
            uply = 0;
            bottomly = labelSize.height;
        } else if (count === node.branches.length - 1) {
            uply = labelSize.height;
            bottomly = 0;
        } else {
            uply = parseFloat((labelSize.height / 2).toFixed(1));
            bottomly = uply;
        }
        if (lastdy < uply) lastdy = parseFloat((lastdy + uply - lastdy).toFixed(1));
        // ラベルが縦長い場合に調整
        const minldy = parseFloat((lastldy > uply ? lastldy * 2 : uply * 2).toFixed(1));
        lastldy = bottomly;
        if (minldy > lastdy) lastdy = minldy;
        // 高さを更新
        h = parseFloat((h + lastdy).toFixed(1));
        ymap.set(index, h);
        // tmp <- 高さ追記分
        if (bottomly > subViewSize.height) lastdy = bottomly;
        else lastdy = subViewSize.height;
        if (lastdy < minHeight && count < node.branches.length - 1) lastdy = minHeight;
        count += 1;
    }
    h = parseFloat((h + lastdy).toFixed(1));
    // 描画
    /**
   * A-----B1
   * |    /
   * |   C2
   * |    \
   * |     B2
   * |    /
   * |   C3
   * |    \
   * E-----B3
   */ let first = true;
    let addChildLineWidth = false;
    const poly = [];
    let lasty = 0;
    const boxRight = parseFloat((x + conditionSize.width + labelw + options.switchNodeCaseWidth).toFixed(1));
    poly.push({
        x: x,
        y: y
    }); // Pos:A
    for (const [index, brancheFragment] of brancheFragments.entries()){
        const lh_temp = ymap.get(index);
        const lh = lh_temp ? lh_temp : 0;
        const ly = parseFloat((y + lh).toFixed(1));
        if (brancheFragment.fragment !== null) {
            // brancheFragment.fragment の描画
            svg += $87e6ec714089ec43$var$renderTransformTranslateSvg(parseFloat((boxRight + options.childNodeOffsetWidth).toFixed(1)), ly, brancheFragment.fragment.svg);
            // 小要素への line の描画
            svg += $87e6ec714089ec43$var$renderLineSvg(boxRight, ly, parseFloat((boxRight + options.childNodeOffsetWidth).toFixed(1)), ly, options);
            // 小要素への line の分、最後に返す幅を増やす
            addChildLineWidth = true;
        }
        if (!first) // Pos:C
        poly.push({
            x: parseFloat((boxRight - options.switchNodeCaseWidth).toFixed(1)),
            y: parseFloat(((lasty + ly) / 2).toFixed(1))
        });
        poly.push({
            x: boxRight,
            y: ly
        }); // Pos:B
        first = false;
        lasty = ly;
    }
    poly.push({
        x: x,
        y: parseFloat(lasty.toFixed(1))
    }); // Pos:E
    const polyPoints = poly.map((p)=>`${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");
    // polyの描画
    const fillColor = options.backgroundColor ?? "none";
    svg += `<polygon points="${polyPoints}" `;
    svg += `stroke="${options.strokeColor}" `;
    svg += `stroke-width="${options.strokeWidth.toFixed(1)}" `;
    svg += `fill="${fillColor}"/>`;
    for (const [index, brancheFragment] of brancheFragments.entries()){
        const label = brancheFragment.label;
        const lh_temp = ymap.get(index);
        const lh = lh_temp ? lh_temp : 0;
        let ly = parseFloat((y + lh).toFixed(1));
        const ls = $87e6ec714089ec43$var$measureTextSvgForBranche(label, options);
        if (index >= node.branches.length - 1) ly = parseFloat((ly - ls.height).toFixed(1));
        else if (index > 0) ly = parseFloat((ly - ls.height / 2).toFixed(1));
        // label の描画
        svg += $87e6ec714089ec43$var$renderTextSvgForBranche(label, parseFloat((x + conditionSize.width + labelw - ls.width).toFixed(1)), ly, options);
    }
    // node.text の描画
    svg += $87e6ec714089ec43$var$renderTextSvgForBranche(node.text, parseFloat(x.toFixed(1)), parseFloat((lasty / 2 - conditionSize.height / 2).toFixed(1)), options);
    return {
        svg: svg,
        width: parseFloat((boxRight + subvieww + (addChildLineWidth ? options.childNodeOffsetWidth : 0)).toFixed(1)),
        height: parseFloat(h.toFixed(1)),
        type: node.type
    };
}
/**
 * SWITCH分岐ノードの描画
 */ function $87e6ec714089ec43$var$renderSwitchFragment(node, options) {
    const switchBrancheNode = {
        text: node.text,
        type: "Switch",
        branches: []
    };
    for (const [label, caseNode] of node.cases.entries())switchBrancheNode.branches.push({
        label: label.toString(),
        node: caseNode
    });
    return $87e6ec714089ec43$var$renderBrancheFragment(switchBrancheNode, options);
}
/**
 * IF分岐ノードの描画
 */ function $87e6ec714089ec43$var$renderIfFragment(node, options) {
    const ifBrancheNode = {
        text: node.text,
        type: "If",
        branches: []
    };
    if (node.trueNode) ifBrancheNode.branches.push({
        label: "",
        node: node.trueNode
    });
    else ifBrancheNode.branches.push({
        label: "",
        node: null
    });
    if (node.falseNode) ifBrancheNode.branches.push({
        label: "",
        node: node.falseNode
    });
    else ifBrancheNode.branches.push({
        label: "",
        node: null
    });
    return $87e6ec714089ec43$var$renderBrancheFragment(ifBrancheNode, options);
}
// == ノード間の接続線の描画関数群 ===
/**
 * 連結ノード（NodeListNode）の描画
 */ function $87e6ec714089ec43$var$renderListFragment(node, options) {
    if (options.listRenderType === "TerminalOffset") return $87e6ec714089ec43$var$renderListFragmentTerminalOffset(node, options);
    else return $87e6ec714089ec43$var$renderListFragmentOriginal(node, options);
}
function $87e6ec714089ec43$var$renderListFragmentOriginal(node, options) {
    let totalHeight = 0;
    let maxWidth = 0;
    let currentY = 0;
    let childrenSvg = "";
    const childFragments = [];
    // 子ノードを再帰的に描画し、サイズとSVGを収集
    for (const child of node.children){
        const childFragment = $87e6ec714089ec43$var$renderNode(child, options);
        childFragments.push(childFragment);
        totalHeight = parseFloat((totalHeight + childFragment.height).toFixed(1));
        maxWidth = parseFloat(Math.max(maxWidth, childFragment.width).toFixed(1));
    }
    // 子ノードのSVGを配置し、接続線を描画
    for(let i = 0; i < childFragments.length; i++){
        const childFragment = childFragments[i];
        // const xOffset = (maxWidth - childFragment.width) / 2; // 中央揃え
        childrenSvg += $87e6ec714089ec43$var$renderTransformTranslateSvg(0, currentY, childFragment.svg);
        // 接続線を描画 (最後のノード以外)
        if (i < childFragments.length - 1) {
            let startY = 0;
            let endY = 0;
            if (childFragment.type === "Terminal") startY = parseFloat((currentY + childFragment.height / 2).toFixed(1));
            else startY = parseFloat(currentY.toFixed(1));
            if (childFragments[i + 1].type === "Terminal") endY = parseFloat((currentY + childFragment.height + options.nodeListSpace + childFragments[i + 1].height / 2).toFixed(1));
            else endY = parseFloat((currentY + childFragment.height + options.nodeListSpace + childFragments[i + 1].height).toFixed(1));
            childrenSvg += $87e6ec714089ec43$var$renderLineSvg(0, startY, 0, endY, options);
            totalHeight = parseFloat((totalHeight + options.nodeListSpace).toFixed(1));
        }
        currentY = parseFloat((currentY + childFragment.height + options.nodeListSpace).toFixed(1));
    }
    return {
        svg: childrenSvg,
        width: maxWidth,
        height: totalHeight,
        type: "NodeList"
    };
}
function $87e6ec714089ec43$var$renderListFragmentTerminalOffset(node, options) {
    let totalHeight = 0;
    let maxWidth = 0;
    let offsetX = 0;
    let topAddWidth = 0;
    let bottomAddWidth = 0;
    let currentY = 0;
    let childrenSvg = "";
    const childFragments = [];
    // 子ノードを再帰的に描画し、サイズとSVGを収集
    for (const child of node.children){
        const childFragment = $87e6ec714089ec43$var$renderNode(child, options);
        childFragments.push(childFragment);
        totalHeight = parseFloat((totalHeight + childFragment.height).toFixed(1));
        maxWidth = parseFloat(Math.max(maxWidth, childFragment.width).toFixed(1));
    }
    const topChildFragment = childFragments[0];
    if (topChildFragment.type === "Terminal") {
        const topWidth = topChildFragment.width;
        offsetX = parseFloat((topWidth / 2).toFixed(1));
    }
    const bottomChildFragment = childFragments[childFragments.length - 1];
    if (bottomChildFragment.type === "Terminal") {
        const bottomWidth = bottomChildFragment.width;
        const bottomOffset = parseFloat((bottomWidth / 2).toFixed(1));
        if (bottomOffset > offsetX) {
            topAddWidth = parseFloat((bottomOffset - offsetX).toFixed(1));
            offsetX = bottomOffset;
        } else bottomAddWidth = parseFloat((offsetX - bottomOffset).toFixed(1));
    }
    // 子ノードのSVGを配置し、接続線を描画
    for(let i = 0; i < childFragments.length; i++){
        const childFragment = childFragments[i];
        // const xOffset = (maxWidth - childFragment.width) / 2; // 中央揃え
        if (i === 0) {
            let topOffsetX = offsetX;
            if (topChildFragment.type === "Terminal") topOffsetX = topAddWidth;
            childrenSvg += $87e6ec714089ec43$var$renderTransformTranslateSvg(topOffsetX, currentY, childFragment.svg);
        } else if (i === childFragments.length - 1) {
            let bottomOffsetX = offsetX;
            if (bottomChildFragment.type === "Terminal") bottomOffsetX = bottomAddWidth;
            childrenSvg += $87e6ec714089ec43$var$renderTransformTranslateSvg(bottomOffsetX, currentY, childFragment.svg);
        } else childrenSvg += $87e6ec714089ec43$var$renderTransformTranslateSvg(offsetX, currentY, childFragment.svg);
        // 接続線を描画 (最後のノード以外)
        if (i < childFragments.length - 1) {
            let startY = 0;
            let endY = 0;
            if (childFragment.type === "Terminal") {
                if (i === 0) startY = parseFloat((currentY + childFragment.height).toFixed(1));
                else startY = parseFloat((currentY + childFragment.height / 2).toFixed(1));
            } else startY = parseFloat(currentY.toFixed(1));
            if (childFragments[i + 1].type === "Terminal") {
                if (i + 1 === childFragments.length - 1) endY = parseFloat((currentY + childFragment.height + options.nodeListSpace).toFixed(1));
                else endY = parseFloat((currentY + childFragment.height + options.nodeListSpace + childFragments[i + 1].height / 2).toFixed(1));
            } else endY = parseFloat((currentY + childFragment.height + options.nodeListSpace + childFragments[i + 1].height).toFixed(1));
            childrenSvg += $87e6ec714089ec43$var$renderLineSvg(offsetX, startY, offsetX, endY, options);
            totalHeight = parseFloat((totalHeight + options.nodeListSpace).toFixed(1));
        }
        currentY = parseFloat((currentY + childFragment.height + options.nodeListSpace).toFixed(1));
    }
    return {
        svg: childrenSvg,
        width: parseFloat((maxWidth + offsetX).toFixed(1)),
        height: totalHeight,
        type: "NodeList"
    };
}
// == テキスト処理 ==
/**
 * テキストのサイズを概算するヘルパー関数。
 * 全角文字と半角文字を考慮してテキストの幅を計算します。
 */ function $87e6ec714089ec43$var$measureTextSvg(text, options) {
    const lines = text.split("\n");
    const maxWidth = Math.max(...lines.map((line)=>{
        let width = 0;
        width = (0, (/*@__PURE__*/$parcel$interopDefault($8a139cfa01cef008$exports))).length(line) * options.fontSize / 2;
        return width;
    }));
    const textHeight = lines.length * options.fontSize * options.lineHeight;
    return {
        width: maxWidth,
        height: textHeight
    };
}
/**
 * XML/SVGで安全に利用するためのエスケープ
 */ function $87e6ec714089ec43$var$escapeXml(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
/**
 * テキストをSVG形式で描画
 */ function $87e6ec714089ec43$var$renderTextSvg(text, posX, posY, options) {
    const lines = text.split("\n");
    let svg = "";
    lines.forEach((line, index)=>{
        const dy = index === 0 ? 0 : index * options.fontSize * options.lineHeight;
        svg += `<text `;
        svg += `x="${posX.toFixed(1)}" y="${(posY + options.fontSize).toFixed(1)}" dy="${dy.toFixed(1)}" `;
        svg += `font-family="${$87e6ec714089ec43$var$escapeXml(options.fontFamily)}" `;
        svg += `font-size="${options.fontSize}" `;
        svg += `fill="${$87e6ec714089ec43$var$escapeXml(options.textColor)}">${$87e6ec714089ec43$var$escapeXml(line)}</text>`;
    });
    return svg;
}
// == 描画支援 ==
/**
 * line描画支援
 */ function $87e6ec714089ec43$var$renderLineSvg(x1, y1, x2, y2, options) {
    const safeStrokeColor = $87e6ec714089ec43$var$escapeXmlAttribute($87e6ec714089ec43$var$sanitizeSvgColor(options.strokeColor));
    const numericStrokeWidth = typeof options.strokeWidth === "number" ? options.strokeWidth : Number(options.strokeWidth);
    const safeStrokeWidth = Number.isFinite(numericStrokeWidth) ? Math.max(0, numericStrokeWidth) : 0;
    return `<line
		x1="${x1.toFixed(1)}" y1="${y1.toFixed(1)}"
		x2="${x2.toFixed(1)}" y2="${y2.toFixed(1)}"
		stroke="${safeStrokeColor}"
		stroke-width="${safeStrokeWidth.toFixed(1)}"
	/>`;
}
/**
 * 描画位置オフセット支援
 */ function $87e6ec714089ec43$var$renderTransformTranslateSvg(x, y, childSvg) {
    return `<g transform="translate(${x.toFixed(1)}, ${y.toFixed(1)})">${childSvg}</g>`;
}


document.addEventListener("DOMContentLoaded", ()=>{
    const appVersion = document.getElementById("appVersion");
    if (appVersion) appVersion.textContent = (0, $560653e296c684a1$exports.version);
    const spdInput = document.getElementById("spdInput");
    const inputModeSpd = document.getElementById("inputModeSpd");
    const inputModeAst = document.getElementById("inputModeAst");
    const svgOutput = document.getElementById("svgOutput");
    const svgViewer = document.getElementById("svgViewer");
    const astOutput = document.getElementById("astOutput");
    const errorOutput = document.getElementById("errorOutput");
    const displayModeSvg = document.getElementById("displayModeSvg");
    const displayModeAst = document.getElementById("displayModeAst");
    const displayModeAstPretty = document.getElementById("displayModeAstPretty");
    const displayModeError = document.getElementById("displayModeError");
    const _displayModeErrorLabel = document.getElementById("displayModeErrorLabel");
    const zoomInButton = document.getElementById("zoomInButton");
    const zoomOutButton = document.getElementById("zoomOutButton");
    const resetZoomButton = document.getElementById("resetZoomButton");
    const zoomLevelInput = document.getElementById("zoomLevelInput");
    const fullscreenButton = document.getElementById("fullscreenButton");
    const checkerboardButton = document.getElementById("checkerboardButton");
    const checkerboardIcon = document.getElementById("checkerboardIcon");
    let zoomLevel = 1.0;
    let showCheckerboard = true;
    let lastSuccessfulDisplayMode = "svg";
    const updateViewerBackground = ()=>{
        if (showCheckerboard) {
            svgOutput.classList.add("show-checkerboard");
            svgOutput.style.backgroundColor = "";
            checkerboardButton.classList.add("active");
            checkerboardIcon.textContent = "grid_on";
        } else {
            svgOutput.classList.remove("show-checkerboard");
            svgOutput.style.backgroundColor = baseBackgroundColorInput.value;
            checkerboardButton.classList.remove("active");
            checkerboardIcon.textContent = "grid_off";
        }
    };
    checkerboardButton.addEventListener("click", ()=>{
        showCheckerboard = !showCheckerboard;
        updateViewerBackground();
    });
    const updateZoom = (newLevel)=>{
        if (newLevel !== undefined) // 10% から 500% の間にクリップ
        zoomLevel = Math.max(0.1, Math.min(newLevel, 5.0));
        const svgElement = svgOutput.querySelector("svg");
        if (svgElement) svgElement.style.transform = `scale(${zoomLevel})`;
        if (zoomLevelInput) zoomLevelInput.value = Math.round(zoomLevel * 100).toString();
    };
    zoomInButton.addEventListener("click", ()=>{
        updateZoom(zoomLevel + 0.1);
    });
    zoomOutButton.addEventListener("click", ()=>{
        updateZoom(zoomLevel - 0.1);
    });
    resetZoomButton.addEventListener("click", ()=>{
        updateZoom(1.0);
    });
    zoomLevelInput.addEventListener("change", ()=>{
        const value = parseInt(zoomLevelInput.value, 10);
        if (!Number.isNaN(value)) updateZoom(value / 100);
        else updateZoom(); // 無効な入力の場合は現在の値にリセット
    });
    zoomLevelInput.addEventListener("keydown", (event)=>{
        if (event.key === "Enter") zoomLevelInput.blur();
    });
    fullscreenButton.addEventListener("click", ()=>{
        if (!document.fullscreenElement) svgViewer.requestFullscreen().catch((err)=>{
            alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });
        else document.exitFullscreen();
    });
    const fileInput = document.getElementById("fileInput");
    const downloadButton = document.getElementById("downloadButton");
    const downloadAstButton = document.getElementById("downloadAstButton");
    const downloadSvgButton = document.getElementById("downloadSvgButton");
    const shareButton = document.getElementById("shareButton");
    // Render Options
    const fontSizeInput = document.getElementById("fontSizeInput");
    const fontFamilySelect = document.getElementById("fontFamilySelect");
    const fontFamilyCustomInput = document.getElementById("fontFamilyCustomInput");
    const customFontCheckbox = document.getElementById("customFontCheckbox");
    const baseBackgroundColorInput = document.getElementById("baseBackgroundColorInput");
    const transparentBackgroundCheckbox = document.getElementById("transparentBackgroundCheckbox");
    const backgroundColorInput = document.getElementById("backgroundColorInput");
    const transparentNodeBackgroundCheckbox = document.getElementById("transparentNodeBackgroundCheckbox");
    const textColorInput = document.getElementById("textColorInput");
    const listRenderTypeTerminalOffset = document.getElementById("listRenderTypeTerminalOffset");
    const applyOptionsButton = document.getElementById("applyOptionsButton");
    const convertAndRender = ()=>{
        const spdText = spdInput.value;
        const _isSvgMode = displayModeSvg.checked;
        const isAstPrettyMode = displayModeAstPretty.checked;
        // 現在の選択がErrorでない場合は、最後の成功したモードを更新
        if (!displayModeError.checked) {
            if (displayModeSvg.checked) lastSuccessfulDisplayMode = "svg";
            else if (displayModeAst.checked) lastSuccessfulDisplayMode = "ast";
            else if (displayModeAstPretty.checked) lastSuccessfulDisplayMode = "astPretty";
        }
        try {
            const ast = inputModeAst.checked ? (0, $a84dc0d9eb6de82c$export$20f9c480f308924b)(spdText) : (0, $00c9095dc018a9e7$export$98e6a39c04603d36)(spdText);
            if (!ast) throw new Error("Could not obtain AST.");
            // 成功時はラジオボタンを有効化し、Error表示を隠す
            displayModeSvg.disabled = false;
            displayModeAst.disabled = false;
            displayModeAstPretty.disabled = false;
            displayModeError.disabled = true;
            errorOutput.style.display = "none";
            // 最後の成功したモードに戻す（もしErrorモードだった場合）
            if (displayModeError.checked) {
                if (lastSuccessfulDisplayMode === "svg") displayModeSvg.checked = true;
                else if (lastSuccessfulDisplayMode === "ast") displayModeAst.checked = true;
                else if (lastSuccessfulDisplayMode === "astPretty") displayModeAstPretty.checked = true;
            }
            if (displayModeSvg.checked) {
                svgViewer.style.display = "flex";
                astOutput.style.display = "none";
                downloadSvgButton.style.display = "inline-flex";
                downloadAstButton.style.display = "none";
                const options = {
                    fontSize: parseInt(fontSizeInput.value, 10),
                    fontFamily: customFontCheckbox.checked ? fontFamilyCustomInput.value : fontFamilySelect.value,
                    baseBackgroundColor: transparentBackgroundCheckbox.checked ? null : baseBackgroundColorInput.value,
                    backgroundColor: transparentNodeBackgroundCheckbox.checked ? null : backgroundColorInput.value,
                    textColor: textColorInput.value,
                    listRenderType: listRenderTypeTerminalOffset.checked ? "TerminalOffset" : "Original"
                };
                const svgString = (0, $87e6ec714089ec43$export$b3890eb0ae9dca99)(ast, options);
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
                const svgElement = svgDoc.documentElement;
                svgOutput.textContent = "";
                if (svgElement && svgElement.tagName === "svg") {
                    svgOutput.appendChild(svgElement);
                    updateZoom();
                } else {
                    // Fallback for cases where parsing might fail (though renderSvg should return valid SVG)
                    svgOutput.innerHTML = svgString;
                    updateZoom();
                }
            } else {
                svgViewer.style.display = "none";
                astOutput.style.display = "block";
                astOutput.value = isAstPrettyMode ? (0, $a84dc0d9eb6de82c$export$ad632ceaa839ccf)(ast, 2) : (0, $a84dc0d9eb6de82c$export$ad632ceaa839ccf)(ast);
                downloadSvgButton.style.display = "none";
                downloadAstButton.style.display = "inline-flex";
            }
        } catch (error) {
            // エラー時はラジオボタンを無効化し、Error表示に切り替える
            displayModeSvg.disabled = true;
            displayModeAst.disabled = true;
            displayModeAstPretty.disabled = true;
            displayModeError.disabled = false;
            displayModeError.checked = true;
            const errorDiv = document.createElement("div");
            errorDiv.classList.add("error-message");
            svgOutput.textContent = "";
            astOutput.value = "";
            svgViewer.style.display = "none";
            astOutput.style.display = "none";
            errorOutput.style.display = "block";
            errorOutput.textContent = "";
            downloadSvgButton.style.display = "none";
            downloadAstButton.style.display = "none";
            if (error instanceof (0, $00c9095dc018a9e7$export$f9c837a54db411d)) {
                const msgPara = document.createElement("div");
                if (error.lineNo !== undefined && error.lineStr !== undefined) {
                    msgPara.textContent = `Error at line ${error.lineNo}: ${error.message}`;
                    errorDiv.appendChild(msgPara);
                    const lineCode = document.createElement("code");
                    lineCode.classList.add("error-line");
                    lineCode.textContent = error.lineStr;
                    errorDiv.appendChild(lineCode);
                } else {
                    msgPara.textContent = `Error: ${error.message}`;
                    errorDiv.appendChild(msgPara);
                }
                console.error("SPD conversion error:", error);
            } else if (error instanceof Error) {
                const msgPara = document.createElement("div");
                msgPara.textContent = `Error: ${error.message}`;
                errorDiv.appendChild(msgPara);
                console.error("SPD conversion error:", error);
            } else {
                errorDiv.textContent = "An unknown error occurred";
                console.error("An unknown error occurred:", error);
            }
            errorOutput.appendChild(errorDiv);
        }
    };
    customFontCheckbox.addEventListener("change", ()=>{
        if (customFontCheckbox.checked) {
            fontFamilySelect.style.display = "none";
            fontFamilyCustomInput.style.display = "inline-block";
        } else {
            fontFamilySelect.style.display = "inline-block";
            fontFamilyCustomInput.style.display = "none";
        }
        convertAndRender();
    });
    transparentBackgroundCheckbox.addEventListener("change", ()=>{
        baseBackgroundColorInput.disabled = transparentBackgroundCheckbox.checked;
    });
    transparentNodeBackgroundCheckbox.addEventListener("change", ()=>{
        backgroundColorInput.disabled = transparentNodeBackgroundCheckbox.checked;
    });
    spdInput.addEventListener("input", convertAndRender);
    inputModeSpd.addEventListener("change", convertAndRender);
    inputModeAst.addEventListener("change", convertAndRender);
    displayModeSvg.addEventListener("change", convertAndRender);
    displayModeAst.addEventListener("change", convertAndRender);
    displayModeAstPretty.addEventListener("change", convertAndRender);
    applyOptionsButton.addEventListener("click", convertAndRender);
    spdInput.addEventListener("keydown", (event)=>{
        if (event.key === "Tab") {
            event.preventDefault(); // デフォルトのTabキーの動作（フォーカス移動）をキャンセル
            const start = spdInput.selectionStart;
            const end = spdInput.selectionEnd;
            // タブ文字を挿入
            spdInput.value = spdInput.value.substring(0, start) + "	" + spdInput.value.substring(end);
            // カーソル位置をタブの直後に設定
            spdInput.selectionStart = spdInput.selectionEnd = start + 1;
            convertAndRender(); // タブ挿入後も変換を実行
        }
    });
    fileInput.addEventListener("change", (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e)=>{
                spdInput.value = e.target?.result;
                // .jsonファイルの場合は自動的に「ASTとしてインポート」をオンにする
                if (file.name.endsWith(".json")) inputModeAst.checked = true;
                else if (file.name.endsWith(".spd")) inputModeSpd.checked = true;
                convertAndRender(); // ファイル読み込み後も変換を実行
            };
            reader.readAsText(file);
        }
    });
    const getFileName = (message, defaultName)=>{
        try {
            return prompt(message, defaultName);
        } catch (error) {
            console.warn("prompt() is not supported, using default filename.", error);
            return defaultName;
        }
    };
    downloadButton.addEventListener("click", ()=>{
        const spdText = spdInput.value;
        const isAst = inputModeAst.checked;
        const defaultFileName = isAst ? "input_ast.json" : "edited_spd.spd";
        const fileNameInput = getFileName("\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u30D5\u30A1\u30A4\u30EB\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044:", defaultFileName);
        if (fileNameInput === null) // ユーザーがキャンセルした場合
        return;
        let fileName = fileNameInput;
        // 拡張子がない場合は適切に追加
        if (isAst) {
            if (!fileName.endsWith(".json")) fileName += ".json";
        } else if (!fileName.endsWith(".spd")) fileName += ".spd";
        const mimeType = isAst ? "application/json" : "text/plain";
        const blob = new Blob([
            spdText
        ], {
            type: mimeType
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // ユーザーが入力したファイル名を使用
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });
    downloadAstButton.addEventListener("click", ()=>{
        const spdText = spdInput.value;
        try {
            const ast = inputModeAst.checked ? (0, $a84dc0d9eb6de82c$export$20f9c480f308924b)(spdText) : (0, $00c9095dc018a9e7$export$98e6a39c04603d36)(spdText);
            if (!ast) {
                alert("AST\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
                return;
            }
            const isAstPrettyMode = displayModeAstPretty.checked;
            const astJson = isAstPrettyMode ? (0, $a84dc0d9eb6de82c$export$ad632ceaa839ccf)(ast, 2) : (0, $a84dc0d9eb6de82c$export$ad632ceaa839ccf)(ast);
            const fileNameInput = getFileName("\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308BAST\u30D5\u30A1\u30A4\u30EB\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044:", "ast.json");
            if (fileNameInput === null) return;
            let fileName = fileNameInput;
            if (!fileName.endsWith(".json")) fileName += ".json";
            const blob = new Blob([
                astJson
            ], {
                type: "application/json"
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            alert(`AST\u{306E}\u{751F}\u{6210}\u{306B}\u{5931}\u{6557}\u{3057}\u{307E}\u{3057}\u{305F}: ${error instanceof Error ? error.message : error}`);
        }
    });
    downloadSvgButton.addEventListener("click", ()=>{
        const svgString = svgOutput.innerHTML;
        if (!svgString) {
            alert("SVG\u304C\u751F\u6210\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002");
            return;
        }
        const fileNameInput = getFileName("\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308BSVG\u30D5\u30A1\u30A4\u30EB\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044:", "output.svg");
        if (fileNameInput === null) // ユーザーがキャンセルした場合
        return;
        let fileName = fileNameInput;
        // 拡張子がない場合は.svgを追加
        if (!fileName.endsWith(".svg")) fileName += ".svg";
        const blob = new Blob([
            svgString
        ], {
            type: "image/svg+xml"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });
    shareButton.addEventListener("click", ()=>{
        const spdText = spdInput.value;
        if (!spdText) {
            alert("SPD\u304C\u5165\u529B\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002");
            return;
        }
        try {
            // UTF-8文字列をBase64にエンコード
            const bytes = new TextEncoder().encode(spdText);
            const binString = Array.from(bytes, (byte)=>String.fromCodePoint(byte)).join("");
            const base64 = btoa(binString);
            const url = new URL(window.location.href);
            url.searchParams.set("spd", base64);
            if (inputModeAst.checked) url.searchParams.set("ast", "1");
            navigator.clipboard.writeText(url.toString()).then(()=>{
                alert("\u5171\u6709\u7528URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002");
            }).catch((err)=>{
                console.error("Failed to copy URL:", err);
                alert("URL\u306E\u30B3\u30D4\u30FC\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002");
            });
        } catch (error) {
            console.error("Failed to encode SPD:", error);
            alert("URL\u306E\u751F\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002");
        }
    });
    // 初期表示用のデータ取得
    const urlParams = new URLSearchParams(window.location.search);
    const spdParam = urlParams.get("spd");
    const astParam = urlParams.get("ast");
    if (spdParam) try {
        // Base64をデコード（UTF-8対応）
        const binString = atob(spdParam);
        const bytes = Uint8Array.from(binString, (m)=>m.codePointAt(0) ?? 0);
        spdInput.value = new TextDecoder().decode(bytes);
        if (astParam === "1") inputModeAst.checked = true;
    } catch (error) {
        console.error("Failed to decode SPD from URL parameter:", error);
        // デコードに失敗した場合はデフォルトを表示
        spdInput.value = $ec43e17e86053d7b$var$getDefaultSpd();
    }
    else spdInput.value = $ec43e17e86053d7b$var$getDefaultSpd();
    baseBackgroundColorInput.addEventListener("input", ()=>{
        updateViewerBackground();
    });
    convertAndRender(); // ページロード時に一度変換を実行
    updateViewerBackground(); // 初期背景設定
});
function $ec43e17e86053d7b$var$getDefaultSpd() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ee520df843a253e5$exports))).trim();
}


//# sourceMappingURL=web.93073fb5.js.map
